function declareControllerForMainAndAddressDiv() {
  var e = $("#content_wrapper");
  wcRenderContext.addRefreshAreaId(
    "contextForMainAndAddressDiv",
    "content_wrapper"
  );
  var t = wcRenderContext.getRenderContextProperties(
    "contextForMainAndAddressDiv"
  );
  e.refreshWidget({
    renderContextChangedHandler: function () {
      CheckoutHelperJS.showHideDivs(t.showArea, t.hideArea);
    },
  });
}

function declareTraditionalShipmentDetailsController() {
  var myWidgetObj = $("#WC_ShipmentDisplay_div_17");
  wcRenderContext.addRefreshAreaId(
    "traditionalShipmentDetailsContext",
    "WC_ShipmentDisplay_div_17"
  );
  var myRCProperties = wcRenderContext.getRenderContextProperties(
      "traditionalShipmentDetailsContext"
    ),
    events = $.extend(
      {},
      order_updated,
      {
        OrderShippingInfoUpdate: "OrderShippingInfoUpdate",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxAddUnboundPaymentInstructionToThisOrder:
          "AjaxAddUnboundPaymentInstructionToThisOrder",
      },
      {
        AjaxDeleteUnboundPaymentInstructionFromThisOrder:
          "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
      },
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      }
    );
  wcTopic.subscribe(events, function (e) {
    myWidgetObj.refreshWidget("refresh", myRCProperties),
      "OrderItemAddressShipMethodUpdate" != e.actionId &&
        (submitRequest(), cursor_wait());
  }),
    myWidgetObj.refreshWidget({
      renderContextChangedHandler: function () {
        wcRenderContext.testForChangedRC("traditionalShipmentDetailsContext", [
          "beginIndex",
        ]) && myWidgetObj.refreshWidget("refresh", myRCProperties);
      },
      postRefreshHandler: function () {
        resetRequest(),
          cursor_clear(),
          "true" == myRCProperties.initializeJS &&
            ($('input[id^="orderItem_"]').each(function (i, orderItem) {
              var initJS =
                "addReqListsJS" +
                orderItem.value +
                " = new AddToRequisitionListsJS(" +
                myRCProperties.storeId +
                "," +
                myRCProperties.catalogId +
                "," +
                myRCProperties.langId +
                ',"' +
                orderItem.value +
                'requisitionListContent","' +
                orderItem.value +
                'requisitionListSelect","' +
                orderItem.value +
                'createNewListMenu","' +
                orderItem.value +
                'listTypeMenu","' +
                orderItem.value +
                'newListNameInput","' +
                orderItem.value +
                'listType","' +
                orderItem.value +
                'productAdded","","AddToRequisitionListsJS' +
                orderItem.value +
                '");addReqListsJS' +
                orderItem.value +
                '.setCatEntryId("' +
                $(
                  "#catalogId_" +
                    orderItem.id.substring(orderItem.id.indexOf("_") + 1)
                ).val() +
                '");';
              eval(initJS);
            }),
            $('div[id^="shoppingListScript_"]').each(function (e, t) {
              $.globalEval(t.innerHTML);
            }));
      },
    });
}

function declareShippingAddressSelectBoxAreaController() {
  var e = $("#shippingAddressSelectBoxArea");
  wcRenderContext.addRefreshAreaId(
    "shippingAddressDropDownBoxContext",
    "shippingAddressSelectBoxArea"
  );
  var t = wcRenderContext.getRenderContextProperties(
      "shippingAddressDropDownBoxContext"
    ),
    r = $.extend(
      {},
      address_updated,
      {
        AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
      },
      {
        AddBillingAddressInCheckOut: "AddBillingAddressInCheckOut",
      }
    );
  wcTopic.subscribe(r, function (r) {
    r.actionId in address_updated
      ? (wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        }),
        (selectedAddressId = r.data.addressId),
        (t.addressId = selectedAddressId),
        0 != CheckoutHelperJS.orderItemIds.length &&
          CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(
            selectedAddressId[0]
          ),
        cursor_clear())
      : "AjaxUpdateOrderItemsAddressId" == r.actionId
      ? (e.refreshWidget("refresh", t), cursor_clear())
      : "AddBillingAddressInCheckOut" == r.actionId &&
        "ShippingAndBilling" == r.data.addBillingAddressInCheckOutAddressType &&
        document.getElementById("singleShipmentAddress") &&
        ((t.addressId = document.getElementById("singleShipmentAddress").value),
        e.refreshWidget("refresh", t),
        cursor_clear());
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        null != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "undefined" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          document
            .getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus())
            .focus(),
          declareShippingAddressDisplayAreaController();
      },
    });
}

function declareCurrentOrderTotalsAreaController() {
  var e = $("#WC_ShipmentDisplay_div_18");
  wcRenderContext.addRefreshAreaId(
    "currentOrder_Context",
    "WC_ShipmentDisplay_div_18"
  );
  var t = wcRenderContext.getRenderContextProperties("currentOrder_Context"),
    r = $.extend(
      {},
      order_updated,
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxUpdateOrderAfterAddressUpdate: "AjaxUpdateOrderAfterAddressUpdate",
      },
      {
        AjaxAddShippingAndBillingAddressForPersonDuringCheckout:
          "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
      },
      {
        AjaxPrepareOrderForPaymentSubmit: "AjaxPrepareOrderForPaymentSubmit",
      }
    );
  wcTopic.subscribe(r, function (r) {
    e.refreshWidget("refresh", t);
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        $("#discountDetailsSection").length &&
          $("#discountDetailsSection").css("display", "block"),
          $("#appliedPromotionCodes").length &&
            $("#appliedPromotionCodes").css("display", "block");
      },
    });
}

function declareSingleShipmentShipChargeController() {
  var e = $("#WC_SingleShipmentDisplay_ShipCharge_Area");
  wcRenderContext.addRefreshAreaId(
    "singleShipmentShipChargeContext",
    "WC_SingleShipmentDisplay_ShipCharge_Area"
  );
  var t = wcRenderContext.getRenderContextProperties(
    "singleShipmentShipChargeContext"
  );
  wcTopic.subscribe(["OrderItemAddressShipMethodUpdate"], function () {
    SBControllersDeclarationJS.shipChargeEnabled &&
      e.refreshWidget("refresh", t);
  }),
    e.refreshWidget({
      postRefreshHandler: function () {
        cursor_clear();
      },
    });
}

function declareBillingAddressSelectBoxAreaController(e) {
  ("object" == typeof e || "array" == typeof e) && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", e);
  var r = wcRenderContext.getRenderContextProperties(
    "billingAddressDropDownBoxContext"
  );
  wcTopic.subscribe(
    [
      "AddBillingAddressInCheckOut",
      "UpdateBillingAddressInCheckout",
      "AjaxUpdateAddressForPerson",
      "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
      "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    ],
    function (e) {
      var s = t.attr("objectId"),
        a = r["billingAddress" + s];
      "" == r["paymentTCId" + s]
        ? t.refreshWidget("updateUrl", r["billingURL" + s])
        : t.refreshWidget(
            "updateUrl",
            r["billingURL" + s] + "&paymentTCId=" + r["paymentTCId" + s]
          ),
        -1 == r["billingAddress" + s]
          ? ((a = e.data.addressId),
            t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              selectedAddressId: a,
              paymentMethodSelected: r["payment" + s],
            }),
            (r["billingAddress" + s] = a),
            s <= CheckoutPayments.numberOfPaymentMethods &&
              CheckoutPayments.updatePaymentObject(s, "billing_address_id"))
          : 0 == r["billingAddress" + s]
          ? t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              paymentMethodSelected: r["payment" + s],
            })
          : (document.getElementById("singleShipmentAddress") &&
              ((shippingAddressId = document.getElementById(
                "singleShipmentAddress"
              ).value),
              (billingAddressId = document.getElementById(
                "billing_address_id_" + s
              ).value),
              shippingAddressId == billingAddressId &&
                s <= CheckoutPayments.numberOfPaymentMethods &&
                "AjaxAddAddressForPerson" != e.data.originalServiceId &&
                (a = e.data.addressId)),
            t.refreshWidget("refresh", {
              paymentAreaNumber: s,
              selectedAddressId: a,
              paymentMethodSelected: r["payment" + s],
            }),
            s <= CheckoutPayments.numberOfPaymentMethods &&
              CheckoutPayments.updatePaymentObject(s, "billing_address_id"));
    }
  ),
    t.refreshWidget({
      renderContextChangedHandler: function () {
        var e = t.attr("objectId");
        if (
          wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
            "payment" + e,
          ]) ||
          wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
            "paymentTCId" + e,
          ])
        ) {
          "" == r["paymentTCId" + e]
            ? t.refreshWidget("updateUrl", r["billingURL" + e])
            : t.refreshWidget(
                "updateUrl",
                r["billingURL" + e] + "&paymentTCId=" + r["paymentTCId" + e]
              );
          var s = $("#billing_address_id_" + e).val();
          t.refreshWidget("refresh", {
            paymentAreaNumber: e,
            selectedAddressId: s,
            paymentMethodSelected: r["payment" + e],
          });
        }
      },
      postRefreshHandler: function () {
        var e = t.attr("objectId");
        CheckoutHelperJS.showHideEditBillingAddressLink(
          document.getElementsByName("billing_address_id")[e - 1],
          e
        ),
          cursor_clear();
        var r = CheckoutHelperJS.getLastAddressLinkIdToFocus();
        if (numAjaxRequests >= 0 && null != r && "undefined" != r && "" != r)
          if (null != document.getElementById(r))
            document.getElementById(r).focus();
          else {
            var s = r.split("_"),
              a = parseInt(s[s.length - 1]) + 1 + "";
            if (r.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
              var i = "WC_ShippingAddressSelectMultiple_link_2_" + a;
              null != document.getElementById(i) &&
                document.getElementById(i).focus();
            } else {
              var i = "WC_ShippingAddressSelectMultiple_link_3_" + a;
              null != document.getElementById(i) &&
                document.getElementById(i).focus();
            }
          }
        declareBillingAddressDisplayAreaController(
          "billingAddressDisplayArea_" + e
        );
      },
    });
}

function declareBillingAddressDisplayAreaController(e) {
  ("object" == typeof e || "array" == typeof e) && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", e);
  var r = wcRenderContext.getRenderContextProperties(
    "billingAddressDropDownBoxContext"
  );
  t.refreshWidget({
    renderContextChangedHandler: function () {
      var s = r.areaNumber,
        a = e;
      if (
        wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", [
          "billingAddress" + s,
        ]) &&
        a.charAt(a.length - 1) == s
      ) {
        var i = r["billingAddress" + s];
        t.refreshWidget("refresh", {
          addressId: i,
        });
      }
    },
    postRefreshHandler: function () {
      var e = r.areaNumber;
      CheckoutHelperJS.showHideEditBillingAddressLink(
        document.getElementsByName("billing_address_id")[e - 1],
        e
      ),
        cursor_clear();
    },
  });
}

function declareOrderTotalController() {
  var e = $("#orderTotalAmountArea");
  wcRenderContext.addRefreshAreaId("paymentContext", "orderTotalAmountArea");
  var t =
    (wcRenderContext.getRenderContextProperties("paymentContext"),
    $.extend(
      {},
      order_updated,
      {
        OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
      },
      {
        AjaxPrepareOrderForShipChargeUpdate:
          "AjaxPrepareOrderForShipChargeUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate:
          "OrderItemAddressShipInstructionsUpdate",
      },
      {
        OrderItemAddressShipInstructionsUpdate1:
          "OrderItemAddressShipInstructionsUpdate1",
      },
      {
        AjaxUpdateOrderAfterAddressUpdate: "AjaxUpdateOrderAfterAddressUpdate",
      },
      {
        AjaxDeleteOrderItemForShippingBillingPage:
          "AjaxDeleteOrderItemForShippingBillingPage",
      },
      {
        AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
      }
    ));
  wcTopic.subscribe(t, function () {
    cursor_wait(), CheckoutPayments.getTotalInJSON();
  }),
    e.refreshWidget({
      postRefreshHandler: function (e) {
        cursor_clear();
      },
    });
}

function declarePaymentAreaController(e) {
  "object" == typeof e && (e = e[0]);
  var t = $("#" + e);
  wcRenderContext.addRefreshAreaId("paymentContext", e);
  var r = wcRenderContext.getRenderContextProperties("paymentContext"),
    s = e[e.length - 1];
  t.refreshWidget({
    renderContextChangedHandler: function () {
      r.currentPaymentArea == s &&
        (wcRenderContext.testForChangedRC("paymentContext", ["payment" + s]) ||
          wcRenderContext.testForChangedRC("paymentContext", [
            "paymentTCId" + s,
          ]) ||
          (wcRenderContext.testForChangedRC("paymentContext", ["piAmount"]) &&
            supportPaymentTypePromotions)) &&
        ("empty" == r["payment" + s]
          ? (viewName = "EmptySnippetView")
          : (viewName = paymentSnippetsURLMap[r["payment" + s]]),
        t.refreshWidget("updateUrl", viewName + paymentAreaUrlParam),
        supportPaymentTypePromotions
          ? 1 != CheckoutPayments.numberOfPaymentMethods
            ? t.refreshWidget("refresh", r)
            : 1 == CheckoutPayments.numberOfPaymentMethods &&
              2 > s &&
              t.refreshWidget("refresh", r)
          : t.refreshWidget("refresh", r));
    },
    postRefreshHandler: function () {
      if (!supportPaymentTypePromotions) {
        var e = $("#OrderTotalAmount").val();
        CheckoutPayments.updateAmountFields(e);
      }
      var t = "paymentArea" + s;
      TealeafWCJS.rebind(t);
      wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext", {
        addressKey:
          document.getElementsByName("billing_address_id")[s - 1].value,
        areaNumber: s,
      }),
        cursor_clear();
    },
  });
}

function declareShippingAddressDisplayAreaController() {
  var e = $("#shippingAddressDisplayArea");
  wcRenderContext.addRefreshAreaId(
    "shippingAddressContext",
    "shippingAddressDisplayArea"
  );
  var t = wcRenderContext.getRenderContextProperties("shippingAddressContext");
  e.refreshWidget({
    renderContextChangedHandler: function () {
      if (
        wcRenderContext.testForChangedRC("shippingAddressContext", [
          "shippingAddress",
        ])
      ) {
        var r = t.shippingAddress;
        e.refreshWidget("refresh", {
          addressId: r,
        });
      }
      cursor_clear();
    },
  });
}

function declareEditShippingAdddressAreaController() {
  var e = $("#editShippingAddressArea1");
  wcRenderContext.addRefreshAreaId(
    "editShippingAddressContext",
    "editShippingAddressArea1"
  );
  var t = wcRenderContext.getRenderContextProperties(
      "editShippingAddressContext"
    ),
    r = $.extend({}, address_updated, {
      UpdateBillingAddressInCheckout: "UpdateBillingAddressInCheckout",
    });
  wcTopic.subscribe(r, function (e) {
    2 == shipmentTypeId &&
      (wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
        showArea: "mainContents",
        hideArea: "editAddressContents",
      }),
      (selectedAddressId = e.data.addressId),
      CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(
        selectedAddressId[0]
      ),
      cursor_clear());
  }),
    e.refreshWidget({
      renderContextChangedHandler: function () {
        if (
          wcRenderContext.testForChangedRC("editShippingAddressContext", [
            "shippingAddress",
          ])
        ) {
          var r = t.shippingAddress;
          t.shippingAddress = 0;
          var s = t.addressType;
          e.refreshWidget("refresh", {
            addressId: r,
            addressType: s,
          });
        }
      },
      postRefreshHandler: function () {
        cursor_clear(),
          AddressHelper.loadStatesUI(
            "shopcartAddressForm",
            "",
            "stateDiv",
            "state",
            !0
          ),
          TealeafWCJS.rebind("centered_single_column_form");
      },
    });
}

function declareMultipleShipmentOrderDetailsRefreshArea() {
  var e = "WC_MultipleShipmentDisplay_div_18",
    t = "multipleShipmentDetailsContext";
  wcRenderContext.checkIdDefined(t) ||
    wcRenderContext.declare(t, [], {
      shipmentDetailsArea: "update",
    });
  var r = wcRenderContext.getRenderContextProperties(t),
    s = $("#" + e);
  wcRenderContext.addRefreshAreaId(t, e);
  var a = $.extend({}, order_updated, {
    AjaxUpdateOrderItemsAddressId: "AjaxUpdateOrderItemsAddressId",
    AjaxDeleteOrderItemForShippingBillingPage:
      "AjaxDeleteOrderItemForShippingBillingPage",
    OrderItemAddressShipMethodUpdate: "OrderItemAddressShipMethodUpdate",
    AjaxPrepareOrderForShipChargeUpdate: "AjaxPrepareOrderForShipChargeUpdate",
    OrderItemAddressShipInstructionsUpdate:
      "OrderItemAddressShipInstructionsUpdate",
    OrderItemAddressShipInstructionsUpdate1:
      "OrderItemAddressShipInstructionsUpdate1",
    AjaxAddUnboundPaymentInstructionToThisOrder:
      "AjaxAddUnboundPaymentInstructionToThisOrder",
    AjaxDeleteUnboundPaymentInstructionFromThisOrder:
      "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    AddBillingAddressInCheckOut: "AddBillingAddressInCheckOut",
  });
  wcTopic.subscribe(a, function (e) {
    CheckoutHelperJS.RequestShippingDateAction ||
    ("AddBillingAddressInCheckOut" == e.actionId &&
      "Billing" == e.addBillingAddressInCheckOutAddressType)
      ? (CheckoutHelperJS.RequestShippingDateAction = !1)
      : (s.refreshWidget("refresh", r), submitRequest(), cursor_wait());
  });
  var i = function () {
      wcRenderContext.testForChangedRC(t, ["beginIndex"]) &&
        s.refreshWidget("refresh", r);
    },
    n = function () {
      if (
        (resetRequest(),
        cursor_clear(),
        "true" == r.initializeJS &&
          ($('input[id^="orderItem_"]').each(function (e, t) {
            $.globalEval($("#addToRequisitionListScript_" + t.value).html());
            var r = "addReqListsJS" + t.value;
            $.globalEval(
              "if(typeof " +
                r +
                ' !== "undefined") {' +
                r +
                '.setCatEntryId("' +
                document.getElementById(
                  "catalogId_" + t.id.substring(t.id.indexOf("_") + 1)
                ).value +
                '");}'
            );
          }),
          $('div[id^="shoppingListScript_"]').each(function (e, t) {
            $.globalEval($(t).html());
          })),
        numAjaxRequests >= 0 &&
          null != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "undefined" != CheckoutHelperJS.getLastAddressLinkIdToFocus() &&
          "" != CheckoutHelperJS.getLastAddressLinkIdToFocus())
      )
        if (
          null !=
          document.getElementById(
            CheckoutHelperJS.getLastAddressLinkIdToFocus()
          )
        )
          document
            .getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus())
            .focus();
        else {
          var e = CheckoutHelperJS.getLastAddressLinkIdToFocus(),
            t = e.split("_"),
            s = parseInt(t[t.length - 1]) + 1 + "";
          if (e.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
            var a = "WC_ShippingAddressSelectMultiple_link_2_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          } else {
            var a = "WC_ShippingAddressSelectMultiple_link_3_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          }
        }
      else if ("" != CheckoutHelperJS.getLastFocus() && tabPressed) {
        if (
          ((tabPressed = !1),
          null != document.getElementById(CheckoutHelperJS.getLastFocus()))
        )
          document.getElementById(CheckoutHelperJS.getLastFocus()).focus();
        else {
          var e = CheckoutHelperJS.getLastFocus(),
            t = e.split("_"),
            s = parseInt(t[t.length - 1]) + 1 + "";
          if (e.indexOf("WC_ShippingAddressSelectMultiple_link_2_") > -1) {
            var a = "WC_ShippingAddressSelectMultiple_link_2_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          } else {
            var a = "WC_ShippingAddressSelectMultiple_link_3_" + s;
            null != document.getElementById(a) &&
              document.getElementById(a).focus();
          }
        }
        CheckoutHelperJS.setLastFocus("");
      }
    };
  s.refreshWidget({
    renderContextChangedHandler: i,
    postRefreshHandler: n,
  });
}

function declareMultipleShipmentShipChargeRefreshArea() {
  var e = "multipleShipmentShipChargeContext",
    t = "WC_MultipleShipmentDisplay_ShipCharge_Area",
    r = $("#" + t);
  wcRenderContext.checkIdDefined(e) || wcRenderContext.declare(e, [], null);
  var s = wcRenderContext.getRenderContextProperties(e);
  wcRenderContext.addRefreshAreaId(e, t),
    wcTopic.subscribe(
      [
        "OrderItemAddressShipMethodUpdate",
        "AjaxDeleteOrderItemForShippingBillingPage",
      ],
      function (e) {
        SBControllersDeclarationJS.shipChargeEnabled &&
          ("OrderItemAddressShipMethodUpdate" == e.actionId &&
            r.refreshWidget("refresh", s),
          "AjaxDeleteOrderItemForShippingBillingPage" == e.actionId &&
            r.refreshWidget("refresh", s));
      }
    );
  var a = function () {
    cursor_clear();
  };
  r.refreshWidget({
    postRefreshHandler: a,
  });
}

function declareDOMEditShippingAdddressAreaController() {
  var e = "editShippingAddressContext",
    t = "editShippingAddressArea1",
    r = $("#" + t),
    s = wcRenderContext.getRenderContextProperties(e);
  wcRenderContext.addRefreshAreaId(e, t),
    wcTopic.subscribe(address_updated, function () {
      wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
        showArea: "mainContents",
        hideArea: "editAddressContents",
      }),
        cursor_clear();
    }),
    r.refreshWidget({
      renderContextChangedHandler: function () {
        if (wcRenderContext.testForChangedRC(e, ["shippingAddress"])) {
          var t = s.shippingAddress;
          s.shippingAddress = 0;
          var a = s.addressType;
          r.refreshWidget("refresh", {
            addressId: t,
            addressType: a,
          });
        }
      },
      postRefreshHandler: function () {
        cursor_clear();
      },
    });
}

function nullCartTotalCookie(e) {
  setCookie("WC_CartTotal_" + e, null, {
    expires: -1,
    path: "/",
    domain: cookieDomain,
  });
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s),
      i = t[r].substr(s + 1);
    if (
      ((a = a.replace(/^\s+|\s+$/g, "")),
      (i = i.replace(/^\s+|\s+$/g, "")),
      i == e)
    ) {
      setCookie(a, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      });
      break;
    }
  }
}

function initializeInactivityWarning() {
  "G" != storeUserType &&
    0 != inactivityTimeout &&
    document.cookie.indexOf("WC_USERACTIVITY_") > 0 &&
    (null != inactivityTimeoutTracker && clearTimeout(inactivityTimeoutTracker),
    (inactivityTimeoutTracker = setTimeout(
      showInactivityWarningDialog,
      inactivityTimeout - inactivityWarningDialogBuffer
    )));
}

function showInactivityWarningDialog() {
  $("#inactivityWarningPopup").data("wc-WCDialog").open(),
    null != dialogTimeoutTracker && clearTimeout(dialogTimeoutTracker),
    (dialogTimeoutTracker = setTimeout(
      hideInactivityWarningDialog,
      inactivityWarningDialogDisplayTimer
    ));
}

function hideInactivityWarningDialog() {
  $("#inactivityWarningPopup").hide();
}

function resetServerInactivity() {
  $.post({
    url: getAbsoluteURL() + "Ping",
    success: function (e, t, r) {
      e.success
        ? initializeInactivityWarning()
        : console.error("Ping service failed");
    },
    error: function (e, t, r) {
      console.error("Ping service failed");
    },
  });
}

function byId(e) {
  return document.getElementById(e);
}

function focusSetter() {
  $("#MiniCartFocusReceiver1").length
    ? $("#MiniCartFocusReceiver1").focus()
    : $("#MiniCartFocusReceiver2").focus();
}

function determineFocus(e) {
  e.shiftKey &&
    e.keyCode === KeyCodes.TAB &&
    (e.srcElement
      ? "MiniCartFocusReceiver1" == e.srcElement.id
        ? ($("#WC_MiniShopCartDisplay_link_5").focus(), Utils.stopEvent(e))
        : "MiniCartFocusReceiver2" == e.srcElement.id &&
          ($("#MiniCartFocusReceiver2").focus(), Utils.stopEvent(e))
      : "MiniCartFocusReceiver1" == e.target.id
      ? ($("#WC_MiniShopCartDisplay_link_5").focus(), Utils.stopEvent(e))
      : "MiniCartFocusReceiver2" == e.target.id &&
        ($("#MiniCartFocusReceiver2").focus(), Utils.stopEvent(e)));
}

function destroyDialog(e) {
  void 0 == e && (e = "quick_cart_container");
  var t = $("#" + e).data("wc-WCDialog");
  t && t.destroy(),
    void 0 != e && "quick_cart_container" == e
      ? (dropDownDlg = null)
      : (productAddedDropDownDlg = null);
}

function loadLink(e) {
  document.location.href = e;
}

function clearSearchField() {
  (searchText = $("#SimpleSearchForm_SearchTerm").val()),
    searchText == $("#searchTextHolder").html()
      ? $("#SimpleSearchForm_SearchTerm").val("")
      : (document.getElementById("SimpleSearchForm_SearchTerm").select(),
        showAutoSuggestIfResults(),
        (autoSuggestHover = !1));
}

function fillSearchField() {
  "" == $("#SimpleSearchForm_SearchTerm").val() &&
    ((document.getElementById("SimpleSearchForm_SearchTerm").className =
      "search_input gray_color"),
    $("#SimpleSearchForm_SearchTerm").val($("#searchTextHolder").html())),
    autoSuggestHover || showAutoSuggest(!1);
}

function showDropDownMenu() {
  $("#header_menu_dropdown").css("display", "block"),
    $("#outerCartContainer").css("display", "block");
}

function cursor_wait(e) {
  var t = !0;
  1 == e && Utils.isOpera() && (t = !1),
    t && ENV_SHOWLOADER && setTimeout("showProgressBar()", 500);
}

function showProgressBar() {
  requestSubmitted && displayProgressBar();
}

function displayProgressBar() {
  var e = $("#progress_bar_dialog").data("wc-WCDialog");
  if (e) {
    var t = $("#progress_bar");
    t.css("display", "block"),
      "" !== this.currentId
        ? e.option("position", {
            my: "left top",
            at: "right top",
            of: $("#" + this.currentId),
          })
        : (t.css("left", ""), t.css("top", ""), e.element.html(t)),
      e.open(),
      setTimeout("cursor_clear()", 18e5);
  }
}

function setCurrentId(e) {
  requestSubmitted || "" !== this.currentId || (this.currentId = e);
}

function trim(e) {
  word = e.toString();
  for (var t = 0, r = word.length - 1; " " == word.charAt(t); ) t++;
  for (; " " == word.charAt(r); ) r -= 1;
  return t > r ? word.substring(t, t) : word.substring(t, r + 1);
}

function cursor_clear() {
  //requestSubmitted = !1, wcTopic.publish("requestSubmittedChanged", requestSubmitted), showLoadingInternal(false, null);
  (requestSubmitted = !1),
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
  var e = $("#progress_bar_dialog").data("wc-WCDialog"),
    t = document.getElementById("progress_bar");
  null != e &&
    (null != t && $(t).css("display", "none"),
    e.close(),
    (this.currentId = ""));
}

function escapeXml(e, t) {
  return (
    t &&
      (e = e
        .replace(/&(?!(quot;|#34;|#034;|#x27;|#39;|#039;))/gm, "&amp;")
        .replace(/</gm, "&lt;")
        .replace(/>/gm, "&gt;")),
    (e = e.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;"))
  );
}

function submitRequest() {
  return requestSubmitted
    ? !1
    : ((requestSubmitted = !0),
      wcTopic.publish("requestSubmittedChanged", requestSubmitted),
      !0);
}

function resetRequest() {
  (requestSubmitted = !1),
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
}

function setPageLocation(e) {
  submitRequest() && (document.location.href = e);
}

function submitSpecifiedForm(e) {
  submitRequest() &&
    (console.debug("form.action == " + e.action), processAndSubmitForm(e));
}

function getLocation(e) {
  var t = e;
  t.match(/^[a-zA-Z]+:\/\//) || (t = "http://" + t);
  var r = document.createElement("a");
  return (r.href = t), r;
}

function getReturnUrl(e) {
  var t,
    r = this.getLocation(decodeURIComponent(e));
  (t = r.hostname === location.hostname ? e : "about:blank"),
    (location.href = t);
}

function matchUrlProtocol(e) {
  if (!stringStartsWith(e, "http")) return e;
  var t = document.location.href,
    r = t.lastIndexOf("s", 4),
    s = e,
    a = s.lastIndexOf("s", 4);
  return (
    -1 != r && -1 == a
      ? (s = s.substring(0, 4) + "s" + s.substring(4))
      : -1 == r && -1 != a && (s = s.substring(0, 4) + s.substring(5)),
    s
  );
}

function hideElementById(e) {
  $("#" + e).css("display", "none");
}

function showElementById(e) {
  if (
    e == "billingAddressCreateEditFormDiv_1" &&
    (window.mobilecheck() || window.tabletPortraitCheck())
  ) {
    $("#" + e).css("display", "flex");
  } else {
    $("#" + e).css("display", "block");
  }
}

function hideBackgroundImage(e) {
  $(e).css("backgroundImage", "none");
}

function showBackgroundImage(e) {
  $(e).css(
    "backgroundImage",
    "url(" +
      getImageDirectoryPath() +
      getStyleDirectoryPath() +
      "product_hover_background.png)"
  );
}

function checkIE8Browser() {
  Utils.get_IE_version() &&
    Utils.get_IE_version() <= 8 &&
    (correctBrowser = !0);
}

function ApprovalToolLink(e, t) {
  return (
    checkIE8Browser(),
    correctBrowser
      ? void (RFQwindow = window.open(t))
      : void MessageHelper.formErrorHandleClient(
          e,
          MessageHelper.messages.ERROR_INCORRECT_BROWSER
        )
  );
}

function updateViewAndBeginIndexForCurrencyChange() {
  $("#fastFinderResultControls").length &&
  "" != document.getElementById("fastFinderResultControls")
    ? (null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          document.FastFinderForm.pageView.value),
      null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          document.FastFinderForm.beginIndex.value))
    : $("#CategoryDisplay_Widget").length &&
      "" != document.getElementById("CategoryDisplay_Widget")
    ? ("" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.pageView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.pageView),
      "" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.beginIndex &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.beginIndex))
    : $("#Search_Result_Summary").length &&
      "" != document.getElementById("Search_Result_Summary")
    ? ("" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsPageNum))
    : $("#Search_Result_Summary2").length &&
      "" != document.getElementById("Search_Result_Summary2") &&
      ("" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.SetCurrencyPreferenceForm.pageView &&
        (document.SetCurrencyPreferenceForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.SetCurrencyPreferenceForm.beginIndex &&
        (document.SetCurrencyPreferenceForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsPageNum));
  try {
    (void 0 != window.top._ceaCollabDialog ||
      null != window.top._ceaCollabDialog) &&
      ($("#SetCurrencyPreferenceForm")[0].URL.value =
        $("#SetCurrencyPreferenceForm")[0].URL.value +
        "&coshopChangeCurrency=" +
        $("#currencySelection").find(":selected").text());
  } catch (e) {
    console.log(e);
  }
}

function updateViewAndBeginIndexForLanguageChange() {
  $("#fastFinderResultControls").length &&
  "" != document.getElementById("fastFinderResultControls")
    ? (null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          document.FastFinderForm.pageView.value),
      null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          document.FastFinderForm.beginIndex.value))
    : $("#CategoryDisplay_Widget").length &&
      "" != document.getElementById("CategoryDisplay_Widget")
    ? ("" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.pageView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.pageView),
      "" !==
        wcRenderContext.getRenderContextProperties("CategoryDisplay_Context")
          .properties.beginIndex &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "CategoryDisplay_Context"
          ).properties.beginIndex))
    : $("#Search_Result_Summary").length &&
      "" != document.getElementById("Search_Result_Summary")
    ? ("" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "catalogSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "catalogSearchResultDisplay_Context"
          ).properties.searchResultsPageNum))
    : $("#Search_Result_Summary2").length &&
      "" != document.getElementById("Search_Result_Summary2") &&
      ("" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsView &&
        null != document.LanguageSelectionForm.pageView &&
        (document.LanguageSelectionForm.pageView.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsView),
      "" !==
        wcRenderContext.getRenderContextProperties(
          "contentSearchResultDisplay_Context"
        ).properties.searchResultsPageNum &&
        null != document.LanguageSelectionForm.beginIndex &&
        (document.LanguageSelectionForm.beginIndex.value =
          wcRenderContext.getRenderContextProperties(
            "contentSearchResultDisplay_Context"
          ).properties.searchResultsPageNum));
  try {
    (void 0 != window.top._ceaCollabDialog ||
      null != window.top._ceaCollabDialog) &&
      $("#LanguageSelectionForm").attr(
        "action",
        $("#LanguageSelectionForm").attr("action") +
          "&langId=" +
          $("#languageSelection").find(":selected").text()
      );
  } catch (e) {
    console.log(e);
  }
}

function showHeaderLinksInTwoLines() {
  $("#header_links").length &&
    ($("#header_links").width() > 750 &&
      ($("#header_links1").css("display", "block"),
      $("#headerHomeLink").css("display", "none"),
      $("#headerShopCartLink").css("display", "none")),
    $("#header_links").css("visibility", "visible"));
}

function showLinksInOneLine() {
  $("#header_links").css("visibility", "visible");
}

function isNonNegativeInteger(e) {
  var t = new RegExp(/^\d*$/);
  return null != e && "" !== e && t.test(e);
}

function isPositiveInteger(e) {
  return isNonNegativeInteger(e) && 0 != e;
}

function closeAllDialogs() {
  $("[data-widget-type='wc.WCDialog']").each(function (e, t) {
    $(t).hide();
  });
}

function setWarningMessageCookie(e) {
  setCookie("signon_warning_cookie", e, {
    path: "/",
    domain: cookieDomain,
  });
}

function removeCookie(e) {
  setCookie(e, null, {
    expires: -1,
  });
}

function getCookie(e) {
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s);
    if (((a = a.replace(/^\s+|\s+$/g, "")), a == e))
      return decodeURIComponent(t[r].substr(s + 1));
  }
}

function deleteOnBehalfRoleCookie() {
  var e = getCookie("WC_OnBehalf_Role_" + WCParamJS.storeId);
  null != e &&
    setCookie("WC_OnBehalf_Role_" + WCParamJS.storeId, null, {
      expires: -1,
      path: "/",
      domain: cookieDomain,
    });
}

function getCookieName_BeginningWith(e) {
  for (var t = document.cookie.split(";"), r = 0; r < t.length; r++) {
    var s = t[r].indexOf("="),
      a = t[r].substr(0, s);
    if (((a = a.replace(/^\s+|\s+$/g, "")), stringStartsWith(a, e))) return a;
  }
}

function stringStartsWith(e, t) {
  return t.length > 0 && e.substring(0, t.length) === t;
}

function isStorePreview(e, t) {
  return e.indexOf(t) > -1;
}

function hideESpotInfoPopup(e, t) {
  if (null == t || "keypress" != t.type || t.keyCode === KeyCodes.ESCAPE) {
    var r = $("#" + e);
    r.length && r.data("wc-WCDialog").close();
  }
}

function showESpotInfoPopup(e, t) {
  if (
    (null == t || "keypress" != t.type || t.keyCode === KeyCodes.RETURN) &&
    parent.checkPopupAllowed()
  ) {
    var r = $("#" + e).data("wc-WCDialog");
    r &&
      (r.bringToFront(),
      r.bringToFront($(".ESpotInfo")),
      r.open(),
      r.reposition());
  }
}

function incrementNumAjaxRequest() {
  "undefined" != numAjaxRequests && numAjaxRequests++;
}

function decrementNumAjaxRequest() {
  "undefined" != numAjaxRequests && 0 != numAjaxRequests && numAjaxRequests--;
}

function updateParamObject(e, t, r, s, a) {
  if ((null == e && (e = []), null != e[t] && s))
    if ($.isArray(e[t])) null != a && "" !== a ? (e[t][a] = r) : e[t].push(r);
    else {
      var i = e[t];
      (e[t] = []), e[t].push(i), e[t].push(r);
    }
  else if (null != a && "" !== a && -1 != a) e[t + "_" + a] = r;
  else if (-1 == a) {
    for (var n = 1; null != e[t + "_" + n]; ) n++;
    e[t + "_" + n] = r;
  } else e[t] = r;
  return e;
}

function showSection(e) {
  $("#" + e).css("visibility", "visible");
}

function hideSection(e) {
  $("#" + e).css("visibility", "");
}

function shiftTabHideSection(e, t) {
  t.shiftKey && t.keyCode === KeyCodes.TAB && hideSection(e);
}

function tabHideSection(e, t, r) {
  t.shiftKey ||
    t.keyCode !== KeyCodes.TAB ||
    (null != r && $("#" + r).focus(), hideSection(e), Utils.stopEvent(t));
}

function saveShiftTabPress(e) {
  1 == e.shiftKey && e.keyCode === KeyCodes.TAB && (tabPressed = !0);
}

function saveTabPress(e) {
  0 == e.shiftKey && e.keyCode === KeyCodes.TAB && (tabPressed = !0);
}

function setFocus(e) {
  tabPressed && ((tabPressed = !1), document.getElementById(e).focus());
}

function increaseHeight(e, t) {
  var r = document.getElementById(e).offsetHeight;
  $("#" + e).css("height", r + t + "px");
}

function redirectToSignOn(e) {
  var t = "Header_GlobalLogin";
  setCookie("WC_RedirectToPage_" + WCParamJS.storeId, e, {
    path: "/",
    domain: cookieDomain,
  }),
    GlobalLoginJS.InitHTTPSecure(t);
}

function handlePopup(e, t) {
  currentPopup == t ? (document.location.href = e) : (currentPopup = t);
}

function isAndroid() {
  if (null == android && null != navigator && null != navigator.userAgent) {
    var e = navigator.userAgent.toLowerCase();
    android = e.indexOf("android") > -1;
  }
  return android;
}

function isIOS() {
  if (null == ios && null != navigator && null != navigator.userAgent) {
    var e = navigator.userAgent.toLowerCase();
    ios =
      e.indexOf("ipad") > -1 ||
      e.indexOf("mac") > -1 ||
      e.indexOf("iphone") > -1 ||
      e.indexOf("ipod") > -1;
  }
  return ios;
}

function outlineSpots() {
  $(document.body).addClass("editMode"),
    $(".carousel > .content").css("zIndex", "auto"),
    $(".ESpotInfo").css("display", "block"),
    $(".searchScore").css("display", "block"),
    $(".editManagedContent").css("display", "block"),
    $(
      ".genericESpot,.product,.searchResultSpot,.productDetail,.categorySpot"
    ).each(function (e, t) {
      if ($(t).hasClass("emptyESpot")) {
        var r = $(".ESpotInfo", t)[0].offsetWidth + 4,
          s = $(".ESpotInfo", t)[0].offsetHeight + 4;
        $(t).attr("_width", $(t).css("width")),
          $(t).attr("_height", $(t).css("height")),
          $(t).css({
            width: +r + "px",
            height: s + "px",
          });
      }
      $(".borderCaption").length
        ? $(t).prepend("<div class='borderCaption'></div>")
        : $(".borderCaption", t).css({
            display: "block",
          }),
        t.addEventListener
          ? (t.addEventListener(
              "mouseover",
              function (e) {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption").css("display", "none"),
                  $(".caption", this).first().css({
                    display: "block",
                  }),
                  e.stopPropagation());
              },
              !1
            ),
            t.addEventListener(
              "mouseout",
              function (e) {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption", this).css({
                    display: "none",
                  }),
                  e.stopPropagation());
              },
              !1
            ))
          : t.attachEvent &&
            ((t.onmouseover = (function (e) {
              return function () {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption").css("display", "none"),
                  $(".caption", e).first().css({
                    display: "block",
                  }),
                  (window.event.cancelBubble = !0));
              };
            })(t)),
            (t.onmouseleave = (function (e) {
              return function () {
                window.parent.frames[0].isSpotsShown() &&
                  ($(".caption", e).css({
                    display: "none",
                  }),
                  (window.event.cancelBubble = !0));
              };
            })(t)));
    });
}

function hideSpots() {
  $(document.body).removeClass("editMode"),
    $(".carousel > .content").css("zIndex", ""),
    $(".ESpotInfo").css("display", "none"),
    $(".caption").css("display", "none"),
    $(".searchScore").css("display", "none"),
    $(".editManagedContent").css("display", "none"),
    $(".borderCaption").css("display", "none"),
    $(".emptyESpot").each(function (e, t) {
      $(t).css({
        width: $(t).attr("_width") + "px",
      }),
        $(t).css({
          height: $(t).attr("_height") + "px",
        });
    });
}

function logout(e) {
  setDeleteCartCookie(),
    setCookie("WC_FIRST_SESSION_POPUP_" + storeDirectory, "false", {
      path: "/",
      domain: cookieDomain,
    }),
    (document.location.href = e);
}

function switchLanguageCurrency(e) {
  var t = document.location.href,
    r = "/" + $("#currentLanguageSEO").val() + "/";
  if (
    (-1 !== t.indexOf("SearchDisplay") ||
      -1 !== t.indexOf("CategoryDisplay")) &&
    -1 !== t.indexOf("#")
  ) {
    var s = t.split("#");
    t = s[0];
  }
  var a = t;
  if (
    -1 !== t.indexOf(r) &&
    document.getElementById(
      "langSEO" +
        document.getElementById("languageSelection").options[
          document.getElementById("languageSelection").selectedIndex
        ].value
    )
  ) {
    var i =
      "/" +
      document.getElementById(
        "langSEO" +
          document.getElementById("languageSelection").options[
            document.getElementById("languageSelection").selectedIndex
          ].value
      ).value +
      "/";
    a = t.replace(r, i);
  }
  if (-1 !== a.indexOf("&")) {
    var n = a.split("&");
    a = "";
    for (var o = 0; o < n.length; o++)
      -1 === n[o].indexOf("langId=")
        ? (a = "" === a ? n[o] : a + "&" + n[o])
        : n[o].indexOf("langId=") > 0 &&
          (0 == o
            ? (a = n[0].substring(0, n[0].indexOf("langId=")))
            : (a += "&"),
          (a =
            a +
            "langId=" +
            document.getElementById("languageSelection").options[
              document.getElementById("languageSelection").selectedIndex
            ].value));
  }
  (a = switchLanguageCurrencyFilter(a)),
    (document.forms[e].URL.value = a),
    (document.forms[e].languageSelectionHidden.value =
      document.getElementById("languageSelection").options[
        document.getElementById("languageSelection").selectedIndex
      ].value),
    $("#widget_language_and_currency_popup").data("wc-WCDialog").close(),
    "function" == typeof changeStoreViewLanguage &&
      changeStoreViewLanguage(document.forms[e].languageSelectionHidden.value),
    document.getElementById(e).submit();
}

function switchLanguageCurrencyFilter(e) {
  var t = [],
    r = [
      {
        key: "registerNew",
        value: "Y",
      },
    ];
  t.push({
    exclude: "UserRegistrationAdd",
    replace: "UserRegistrationForm",
    param: r,
  });
  for (var s = 0; s < t.length; s++)
    if (e.indexOf(t[s].exclude) > 0) {
      if (((e = e.replace(t[s].exclude, t[s].replace)), void 0 != t[s].param))
        for (var a = t[s].param, i = 0; i < a.length; i++)
          e = appendToURL(e, a[i].key, a[i].value, !1);
      break;
    }
  return e;
}

function isParameterExcluded(e, t) {
  try {
    if ("object" == typeof URLConfig)
      if ("object" == typeof URLConfig.excludedURLPatterns)
        for (var r in URLConfig.excludedURLPatterns) {
          var s = URLConfig.excludedURLPatterns[r],
            a = r;
          if (
            "object" == typeof s &&
            (s.urlPattern && (a = s.urlPattern),
            console.debug("URL pattern to match : " + a),
            (a = new RegExp(a)),
            e.match(a))
          ) {
            var i = s.excludedParameters;
            for (var n in i) if (parametername == n) return !0;
          }
        }
      else console.debug("The parameter " + t + " is not excluded");
    else console.debug("No URLConfig defined.");
  } catch (o) {
    console.debug("An error occured while trying to exclude " + o);
  }
  return !1;
}

function appendToURL(e, t, r, s) {
  s = null == s ? !1 : s;
  var a = new RegExp(t + "=[^&]+"),
    i = t + "=" + r;
  return (
    -1 !== e.indexOf(i) ||
      (!a.test(e) || s
        ? ((e += -1 === e.indexOf("?") ? "?" : "&"), (e += i))
        : (e = e.replace(a, i))),
    e
  );
}

function appendWcCommonRequestParameters(e, t) {
  if (((t = null == t ? !1 : t), "object" == typeof wcCommonRequestParameters))
    for (var r in wcCommonRequestParameters)
      isParameterExcluded(e, r) ||
        (e = appendToURL(e, r, wcCommonRequestParameters[r], t));
  return e;
}

function updateFormWithWcCommonRequestParameters(e, t) {
  if (((t = null == t ? !1 : t), "object" == typeof wcCommonRequestParameters))
    for (var r in wcCommonRequestParameters)
      if (
        void 0 !== e.action &&
        null !== e.action &&
        !isParameterExcluded(e.action, r)
      ) {
        var s = !1;
        $("input[name='" + r + "']", e).each(function (a, i) {
          i.value == wcCommonRequestParameters[r]
            ? (s = !0)
            : t || e.removeChild(i);
        }),
          s ||
            ("get" == e.method
              ? $("<input></input>", {
                  name: r,
                  type: "hidden",
                  value: wcCommonRequestParameters[r],
                }).appendTo(e)
              : (e.action = appendToURL(
                  e.action,
                  r,
                  wcCommonRequestParameters[r],
                  t
                )));
      }
}

function addAuthToken(e) {
  try {
    return (
      $("#csrf_authToken").length
        ? $("<input></input>", {
            name: "authToken",
            type: "hidden",
            value: $("#csrf_authToken").val(),
          }).appendTo(e)
        : console.debug("auth token is missing from the HTML DOM"),
      !0
    );
  } catch (t) {
    console.debug(
      "An error occured while trying to add authToken to the form..." + t
    );
  }
  return !1;
}

function processAndSubmitForm(e) {
  updateFormWithWcCommonRequestParameters(e), addAuthToken(e), e.submit();
}

function getCommonParametersQueryString() {
  return (
    "storeId=" +
    WCParamJS.storeId +
    "&langId=" +
    WCParamJS.langId +
    "&catalogId=" +
    WCParamJS.catalogId
  );
}

function getFinalViewURL(e) {
  var t = e.indexOf("finalView");
  if (-1 != t) {
    var r = e.indexOf("&", t);
    if (-1 == r) var s = e.substring(t + 10);
    else var s = e.substring(t + 10, r);
    var a = e.indexOf("?"),
      i = e.substring(a + 1, t);
    if (-1 == r) var n = "";
    else var n = e.substring(r);
    "&" == i.charAt(i.length - 1) && (i = i.substring(0, i.length - 1)),
      "&" == i.charAt(0) && (i = i.substring(1)),
      "&" == n.charAt(n.length - 1) && (n = n.substring(0, n.length - 1)),
      "&" == n.charAt(0) && (n = n.substring(1));
    var o = "";
    return (
      "" !== i
        ? ((o = s + "?" + i), "" !== n && (o = o + "&" + n))
        : (o = s + "?" + n),
      o
    );
  }
  return "";
}

function invokeItemAdd(e) {
  wcService.getServiceById("MyAcctAjaxAddOrderItem").url = e;
  var t = [];
  (t.PasswordRequestAuthenticated = "TRUE"),
    submitRequest() &&
      (cursor_wait(),
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
      wcService.invoke("MyAcctAjaxAddOrderItem", t));
}

function invokeOtherService(e) {
  wcService.getServiceById("MyAcctGenericService").url = e;
  var t = {
    PasswordRequestAuthenticated: "TRUE",
  };
  submitRequest() &&
    (cursor_wait(),
    setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
      expires: -1,
      path: "/",
      domain: cookieDomain,
    }),
    wcService.invoke("MyAcctGenericService", t));
}

function setCookie(e, t, r) {
  var s = function (e, t, r) {
    r || (r = {});
    var s = r.expires;
    if (s) {
      if ("number" == typeof s) {
        var a = new Date();
        a.setTime(a.getTime() + 24 * s * 60 * 60 * 1e3), (s = a);
      }
      s.toUTCString ? (r.expires = s.toUTCString()) : (r.expires = s);
    }
    t = encodeURIComponent(t);
    var i = e + "=" + t;
    for (var e in r) {
      i += "; " + e;
      var n = r[e];
      n !== !0 && (i += "=" + n);
    }
    document.cookie = i;
  };
  if (r) {
    var a = r;
    for (var i in a) a[i] || delete a[i];
    s(e, t, a);
  } else s(e, t);
}

function getBaseTextDir() {
  var e = getCookie(_BTD_PREFS);
  return e ? e : "";
}

function setBaseTextDir(e) {
  var t = getCookie(_BTD_PREFS);
  t != e && setCookie(_BTD_PREFS, e.toLowerCase());
}

function isRTLValue(e) {
  for (var t in e) {
    if (isBidiChar(e.charCodeAt(t))) return !0;
    if (isLatinChar(e.charCodeAt(t))) return !1;
  }
  return !1;
}

function isBidiChar(e) {
  return e >= 1488 && 1535 >= e
    ? !0
    : e >= 1536 && 1631 >= e
    ? !0
    : e >= 1642 && 1775 >= e
    ? !0
    : e >= 1786 && 2047 >= e
    ? !0
    : e >= 64285 && 65023 >= e
    ? !0
    : e >= 65136 && 65276 >= e
    ? !0
    : !1;
}

function isLatinChar(e) {
  return (e > 64 && 91 > e) || (e > 96 && 123 > e) ? !0 : !1;
}

function resolveBaseTextDir(e, t) {
  return "auto" == t ? (isRTLValue(e) ? "rtl" : "ltr") : t;
}

function handleTextDirection(e) {
  var t = getBaseTextDir();
  null != e &&
    "" !== t &&
    ["INPUT", "TEXTAREA"].indexOf(e.tagName) > -1 &&
    $(e).css("direction", resolveBaseTextDir(e.value, t));
}

function enforceTextDirectionOnPage() {
  var e = getBaseTextDir();
  "" !== e &&
    $(".bidiAware").each(function (t, r) {
      r.dir = $(r).css(
        "direction",
        resolveBaseTextDir(r.value || r.text || r.outerText || r.innerHTML, e)
      );
    });
}

function commonServiceFailureHandler(e) {
  e.errorMessage
    ? MessageHelper.displayErrorMessage(e.errorMessage)
    : e.errorMessageKey && MessageHelper.displayErrorMessage(e.errorMessageKey),
    cursor_clear();
}

function isChrome() {
  return (
    /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  );
}

function isSafari() {
  return (
    /Safari/.test(navigator.userAgent) &&
    /Apple Computer/.test(navigator.vendor)
  );
}

function successHandlerForURLChainingService(e) {
  if (
    (console.debug("Success Handler of AjaxCustomServiceForURLChaining", e),
    null != this.postRefreshHandlerParameters &&
      "" !== this.postRefreshHandlerParameters)
  ) {
    var t = "";
    (nextServiceURLObject = this.postRefreshHandlerParameters.splice(0, 1)[0]),
      console.debug("nextServiceURLObject ", nextServiceURLObject);
    if (
      null != nextServiceURLObject &&
      "undefined" != typeof nextServiceURLObject
    ) {
      var t = nextServiceURLObject.URL,
        r = nextServiceURLObject.requestType,
        s = nextServiceURLObject.requestParams;
      console.debug("nextServiceURL ", t),
        console.debug("requestType ", r),
        console.debug("requestParams ", s);
    }
    if ("" !== t)
      if ("GET" == r) {
        -1 === t.indexOf("?") &&
          (t = t + "?" + getCommonParametersQueryString());
        for (var a in s) t = t + "&" + a + "=" + s[a];
        document.location.href = t;
      } else {
        var i = getCustomServiceForURLChaining(
          t,
          this.postRefreshHandlerParameters
        );
        wcService.invoke(i.getParam("id"), s);
      }
    else
      console.debug(
        "End of URL chaining with AjaxCustomServiceForURLChaining service"
      );
  }
}

function getCustomServiceForURLChaining(e, t, r) {
  var s = wcService.getServiceById("AjaxCustomServiceForURLChaining");
  return (
    (null == s || void 0 == s) &&
      (console.debug("Start creating AjaxCustomServiceForURLChaining"),
      wcService.declare({
        id: "AjaxCustomServiceForURLChaining",
        actionId: "AjaxCustomServiceForURLChaining",
        url: "",
        formId: "",
        successHandler: successHandlerForURLChainingService,
        failureHandler: commonServiceFailureHandler,
      }),
      (s = wcService.getServiceById("AjaxCustomServiceForURLChaining"))),
    null != e &&
      "undefined" != e &&
      (stringStartsWith("url", "http")
        ? s.setUrl(e)
        : s.setUrl(getAbsoluteURL() + e)),
    null != t && "undefined" != t
      ? s.setParam("postRefreshHandlerParameters", t)
      : s.setParam("postRefreshHandlerParameters", null),
    null != r && "undefined" != r ? s.setFormId(r) : s.setFormId(null),
    console.debug("Return AjaxCustomServiceForURLChaining", s),
    s
  );
}

function declareDeptDropdownRefreshArea(e) {
  wcRenderContext.declare("departmentSubMenuContext", [e], {
    targetId: "",
  });
  var t = function () {
      $("#" + e).refreshWidget(
        "refresh",
        wcRenderContext.getRenderContextProperties("departmentSubMenuContext")
      );
    },
    r = function () {
      updateDepartmentsMenu(),
        activate(
          document.getElementById(
            wcRenderContext.getRenderContextProperties(
              "departmentSubMenuContext"
            ).targetId
          )
        ),
        cursor_clear();
    };
  $("#" + e).refreshWidget({
    renderContextChangedHandler: t,
    postRefreshHandler: r,
  });
}

function ShoppingListJS(
  storeParams,
  catEntryParams,
  shoppingListNames,
  jsObjectName
) {
  (this.storeParams = storeParams),
    (this.catEntryParams = catEntryParams),
    (this.catEntryParams.quantity = 1),
    (this.shoppingListNames = shoppingListNames),
    (this.addItemAfterCreate = !1),
    (this.jsObjectName = jsObjectName),
    (this.dropDownVisible = !1),
    (this.dropDownInFocus = !1),
    (this.dropDownOpen = !1),
    (this.exceptionFlag = !1),
    (this.mouseOnArrow = !1),
    (this.pageName = ""),
    (this.itemId = -1);
  var eventName = "";
  (this.nameToDelete = ""),
    (this.orderItemId = ""),
    (this.actionBeingPerformed = ""),
    "shoppingListJS" != jsObjectName &&
      ((this.pageName = jsObjectName.replace("shoppingListJS", "")),
      (eventName = this.pageName + "_")),
    (this.setCatEntryQuantity = function (e) {
      var e = $.parseJSON(e);
      if ($.isPlainObject(e)) {
        var t = this.catEntryParams.components[e.baseItemId];
        t.id != e.baseItemId && 0 != e.id && (t.id = e.id),
          (t.quantity = e.quantity);
      } else this.catEntryParams.quantity = e;
    }),
    (this.setCatEntryAttributes = function (e) {
      this.catEntryParams.attributes = $.parseJSON(e);
    }),
    (this.setItemId = function (e) {
      this.itemId = e;
    }),
    (this.hideDropDown = function () {
      var e = $("#" + this.pageName + "shoppingListDropDown");
      if (e) {
        $(e).css("display", "none"),
          $("#" + this.pageName + "addToShoppingListBtn .drop")
            .first()
            .focus(),
          (this.dropDownVisible = !1),
          (this.dropDownInFocus = !1),
          (this.dropDownOpen = !1);
        var t = $(".widget_quick_info_popup .content_right_border").first();
        void 0 != t && $(t).css("height", "auto");
      }
    }),
    (this.showDropDown = function () {
      if (0 == this.dropDownOpen) {
        var e = $(".widget_quick_info_popup .content_right_border").first(),
          t = ($(e).height(), "#" + this.pageName + "shoppingListDropDown");
        if (
          ($(t).css("display", ""),
          (this.dropDownVisible = !0),
          $(
            "#" + this.pageName + "shoppingListDropDown.dropdown_list div"
          ).removeClass("focused"),
          $("#quickInfoRefreshArea") && $("#QuickInfoshoppingListDropDown"))
        ) {
          $("#quickInfoRefreshArea").height(),
            $("QuickInfoshoppingListDropDown").height(),
            $(e).height();
        }
        this.dropDownOpen = !0;
      } else this.hideDropDown();
    }),
    (this.showPopup = function (e) {
      this.hideDropDown(), this.clearPopupText();
      var t = $("#" + this.pageName + e + "ShoppingListPopup").data(
          "wc-WCDialog"
        ),
        r = $("#" + this.pageName + "newListName");
      t.option("close_on_primary_click", !1),
        this.hideErrorMessage(),
        this.hideEditErrorMessage(),
        t
          ? (closeAllDialogs(),
            t.close(),
            setTimeout(function () {
              t.open(),
                "create" === e
                  ? $(r).focus()
                  : "edit" === e && $("#editListName").focus();
            }, 250))
          : console.debug(e + "ShoppingListPopup does not exist");
    }),
    (this.showSuccessDialog = function () {
      var e = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      e &&
        "" !== this.actionBeingPerformed &&
        ($("#" + this.pageName + "successMessageAreaText").html(
          Utils.getLocalizationMessage("LIST_CREATED")
        ),
        e.open(),
        (this.actionBeingPerformed = ""));
    }),
    (this.showMessageDialog = function (e) {
      var t = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      t &&
        ($("#" + this.pageName + "successMessageAreaText").html(e), t.open());
    }),
    (this.hideMessageDialog = function () {
      var e = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data(
        "wc-WCDialog"
      );
      e && e.close();
    }),
    (this.showErrorMessage = function (e) {
      document.getElementById(this.pageName + "shoppingListErrorMessageArea") &&
        document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ) &&
        ((document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ).innerHTML = e),
        (document.getElementById(
          this.pageName + "shoppingListErrorMessageArea"
        ).style.display = "block"));
    }),
    (this.hideErrorMessage = function () {
      document.getElementById(this.pageName + "shoppingListErrorMessageArea") &&
        document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ) &&
        ((document.getElementById(
          this.pageName + "shoppingListErrorMessageText"
        ).innerHTML = ""),
        (document.getElementById(
          this.pageName + "shoppingListErrorMessageArea"
        ).style.display = "none"));
    }),
    (this.showEditErrorMessage = function (e) {
      document.getElementById("editShoppingListErrorMessageArea") &&
        document.getElementById("editShoppingListErrorMessageText") &&
        ((document.getElementById(
          "editShoppingListErrorMessageText"
        ).innerHTML = e),
        (document.getElementById(
          "editShoppingListErrorMessageArea"
        ).style.display = "block"));
    }),
    (this.hideEditErrorMessage = function () {
      document.getElementById("editShoppingListErrorMessageArea") &&
        document.getElementById("editShoppingListErrorMessageText") &&
        ((document.getElementById(
          "editShoppingListErrorMessageText"
        ).innerHTML = ""),
        (document.getElementById(
          "editShoppingListErrorMessageArea"
        ).style.display = "none"));
    }),
    (this.create = function () {
      var e = trim($("#" + this.pageName + "newListName").val()),
        t = $("#" + this.pageName + "newListName").maxLength,
        r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
      if (this.empty(e))
        this.showErrorMessage(Utils.getLocalizationMessage("ERR_NAME_EMPTY"));
      else if (MessageHelper.isValidUTF8length(e, t))
        if (e == r)
          this.showErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_SHOPPING_LIST")
          );
        else if (this.isDuplicate(e))
          this.showErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_DUPLICATE")
          );
        else if (this.validateWishName(e)) {
          var s = this.setCommonParams();
          if (((s.name = e), !submitRequest())) return;
          cursor_wait(),
            wcService.invoke("ShoppingListServiceCreate", s),
            (this.actionBeingPerformed = "create");
        } else
          this.showErrorMessage(
            Utils.getLocalizationMessage("INVALID_NAME_SHOPPING_LIST")
          );
      else
        this.showErrorMessage(Utils.getLocalizationMessage("ERR_NAME_TOOLONG"));
    }),
    (this.createDefaultListAndAddItem = function (e, t, r) {
      if ((t && "" != t && (this.orderItemId = t), "-1" == e)) {
        var s = this.setCommonParams();
        if (
          ((s.name = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")),
          !submitRequest())
        )
          return;
        cursor_wait(),
          (this.addItemAfterCreate = !0),
          wcService.invoke("ShoppingListServiceCreate", s);
      } else
        t && "" != t ? this.addToListAndDelete(e, t, r) : this.addToList(e, r);
    }),
    (this.addToList = function (e, t) {
      this.hideDropDown();
      var r = this.setCommonParams();
      r.giftListId = e;
      var s = this.catEntryParams.id;
      if (
        "itembean" == this.catEntryParams.type.toLowerCase() ||
        "packagebean" == this.catEntryParams.type.toLowerCase() ||
        "preddynakitbean" == this.catEntryParams.type.toLowerCase() ||
        "dynamickitbean" == this.catEntryParams.type.toLowerCase()
      )
        updateParamObject(r, "catEntryId", this.catEntryParams.id, !1, -1),
          updateParamObject(
            r,
            "quantity",
            this.catEntryParams.quantity,
            !1,
            -1
          );
      else if ("bundlebean" == this.catEntryParams.type.toLowerCase()) {
        var a = !0;
        for (baseItemId in this.catEntryParams.components)
          if (
            this.catEntryParams.components[baseItemId].skus &&
            this.catEntryParams.components[baseItemId].skus.length > 1
          ) {
            var i = this.catEntryParams.components[baseItemId].resolved;
            if (null == i || "undefined" == i || 0 == i) {
              a = !1;
              break;
            }
          }
        if (!a)
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
          );
        for (baseItemId in this.catEntryParams.components)
          updateParamObject(
            r,
            "catEntryId",
            this.catEntryParams.components[baseItemId].id,
            !1,
            -1
          ),
            updateParamObject(
              r,
              "quantity",
              this.catEntryParams.components[baseItemId].quantity,
              !1,
              -1
            );
      } else {
        var n = this.itemId;
        if ((-1 == n && (n = this.resolveSKU()), -1 == n))
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
          );
        (s = n),
          updateParamObject(r, "catEntryId", n, !1, -1),
          updateParamObject(
            r,
            "quantity",
            this.catEntryParams.quantity,
            !1,
            -1
          );
      }
      "shoppingListJS" != this.jsObjectName && QuickInfoJS.close(),
        submitRequest() &&
          (cursor_wait(),
          ShoppingListDialogJS.setDialogParams(this.storeParams, {
            catEntryId: s,
            thumbnail: "imgPath",
            focusElement: t,
          }),
          wcService.invoke("ShoppingListServiceAddItem", r));
    }),
    (this.isDuplicate = function (e) {
      var e = this.escapeXml(e, !0);
      return 1 == this.shoppingListNames[e.toUpperCase()];
    }),
    (this.updateDefaultListId = function (e) {
      (this.shoppingListNames[
        Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")
      ] = 1),
        $("#" + this.pageName + "addToShoppingList") &&
          $("#" + this.pageName + "addToShoppingList").attr(
            "href",
            '"javascript:" + this.jsObjectName + ".createDefaultListAndAddItem(" + listId + ");"'
          );
    }),
    (this.updateShoppingList = function (e, t, r) {
      var s = this.escapeXml(t, !1);
      (this.shoppingListNames[s.toUpperCase()] = 1),
        !r ||
          ("edit" != r && "delete" != r) ||
          (this.shoppingListNames[this.nameToDelete.toUpperCase()] = -1);
      var a = $("#" + this.pageName + "ShoppingListDivider");
      if (a) {
        var i = "javascript: this.className = 'created_list';";
        if (-1 == this.pageName.indexOf("OI"))
          $("#" + this.pageName + "ShoppingListDivider").before(
            '<div role="menuitem" id="' +
              this.pageName +
              "ShoppingList_" +
              e +
              '" class="created_list" onfocus="javascript:' +
              jsObjectName +
              ".focusList('" +
              e +
              '\'); "  onblur="' +
              i +
              '" onclick="javascript:' +
              jsObjectName +
              ".addToList('" +
              e +
              '\');"><a role="menuitem" id="' +
              this.pageName +
              "ShoppingListLink_" +
              e +
              '" href="javascript:' +
              jsObjectName +
              ".addToList('" +
              e +
              '\');" onfocus="javascript:' +
              jsObjectName +
              ".focusListLink('" +
              e +
              "');\">" +
              t +
              "</a></div>"
          );
        else {
          var n = this.pageName.replace("OI", "");
          $("#" + this.pageName + "ShoppingListDivider").before(
            '<div role="menuitem" id="' +
              this.pageName +
              "ShoppingList_" +
              e +
              '" class="created_list" onfocus="javascript:' +
              jsObjectName +
              ".focusList('" +
              e +
              '\'); "  onblur="' +
              i +
              '" onclick="javascript:' +
              jsObjectName +
              ".addToListAndDelete('" +
              e +
              "','" +
              n +
              '\');"><a role="menuitem" id="' +
              this.pageName +
              "ShoppingListLink_" +
              e +
              '" href="javascript:' +
              jsObjectName +
              ".addToListAndDelete('" +
              e +
              "','" +
              n +
              '\');" onfocus="javascript:' +
              jsObjectName +
              ".focusListLink('" +
              e +
              "');\">" +
              t +
              "</a></div>"
          );
        }
      }
    }),
    (this.clearPopupText = function () {
      $("#" + this.pageName + "newListName").val("");
    }),
    (this.escapeXml = function (e, t) {
      return (
        t &&
          (e = e
            .replace(/&/gm, "&amp;")
            .replace(/</gm, "&lt;")
            .replace(/>/gm, "&gt;")),
        (e = e.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;"))
      );
    }),
    (this.resolveSKU = function () {
      if (1 == this.catEntryParams.skus.length)
        return this.catEntryParams.skus[0].id;
      for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
        var e = 0,
          t = 0;
        for (attribute in this.catEntryParams.skus[idx].attributes) {
          if (
            (t++,
            !this.catEntryParams.attributes ||
              this.catEntryParams.skus[idx].attributes[attribute] !=
                this.catEntryParams.attributes[attribute])
          )
            break;
          e++;
        }
        if (0 != e && e == t) return this.catEntryParams.skus[idx].id;
      }
      return -1;
    }),
    (this.setCommonParams = function () {
      var e = {};
      return (
        (e.storeId = this.storeParams.storeId),
        (e.catalogId = this.storeParams.catalogId),
        (e.langId = this.storeParams.langId),
        e
      );
    }),
    (this.empty = function (e) {
      return null == e || void 0 == e || "" == e;
    }),
    (this.redirectToSignOn = function () {
      var e = document.location.href,
        t = "Header_GlobalLogin";
      setCookie("WC_RedirectToPage_" + WCParamJS.storeId, e, {
        path: "/",
        domain: cookieDomain,
      }),
        GlobalLoginJS.InitHTTPSecure(t);
    }),
    (this.focusList = function (e) {
      this.focusListByElementId(this.pageName + "ShoppingList_" + e);
    }),
    (this.focusListByElementId = function (e) {
      $("#" + e).hasClass("focused") ||
        $("#" + e.replace("ShoppingList", "ShoppingListLink")).focus();
    }),
    (this.focusListLink = function (e) {
      $(
        "#" + this.pageName + "shoppingListDropDown.dropdown_list div"
      ).removeClass("focused"),
        $("#" + this.pageName + "ShoppingList_" + e).addClass("focused");
    }),
    (this.updateShoppingListAndAddItem = function (e) {
      e.listName == Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME")
        ? this.updateDefaultListId(e.listId)
        : this.updateShoppingList(e.listId, e.listName, e.action),
        this.addItemAfterCreate
          ? ((this.addItemAfterCreate = !1),
            "" != this.orderItemId
              ? this.addToListAndDelete(e.listId, this.orderItemId)
              : this.addToList(e.listId))
          : "add" == e.action && this.showSuccessDialog();
    }),
    (this.navigateDropDown = function (e) {
      var t = this;
      if (e.keyCode === KeyCodes.UP_ARROW) {
        Utils.stopEvent(e);
        var r = !1,
          s = $(
            "#" +
              t.pageName +
              "shoppingListDropDown.dropdown_list div.created_list"
          );
        s.each(function (e, a) {
          !r &&
            $(a).hasClass("focused") &&
            (0 == e
              ? t.focusListByElementId($(s).get(s.length - 1).id)
              : t.focusListByElementId($(s).get(e - 1).id),
            (r = !0));
        });
      } else if (e.keyCode === KeyCodes.DOWN_ARROW) {
        Utils.stopEvent(e);
        var r = !1,
          s = $(
            "#" +
              t.pageName +
              "shoppingListDropDown.dropdown_list div.created_list"
          );
        s.each(function (e, a) {
          !r &&
            $(a).hasClass("focused") &&
            (s.length - 1 == e
              ? t.focusListByElementId($(s).get(0).id)
              : t.focusListByElementId($(s).get(e + 1).id),
            (r = !0));
        });
      } else
        (e.keyCode === KeyCodes.ESCAPE || e.keyCode === KeyCodes.TAB) &&
          (Utils.stopEvent(e), this.hideDropDown());
    }),
    (this.hideIfNoFocus = function () {
      !this.dropDownVisible ||
        this.dropDownInFocus ||
        this.mouseOnArrow ||
        this.hideDropDown();
    }),
    (this.hasFocus = function (e) {
      $(document).on("contextmenu", function (e) {
        1 == e.which
          ? (this.dropDownInFocus = !0)
          : (this.dropDownInFocus = !1);
      });
    }),
    (this.edit = function () {
      var e = trim($("#editListName").val()),
        t = e.maxLength,
        r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
      if (this.empty(e))
        this.showEditErrorMessage(
          Utils.getLocalizationMessage("ERR_NAME_EMPTY")
        );
      else if (MessageHelper.isValidUTF8length(e, t))
        if (e == r)
          this.showEditErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_SHOPPING_LIST")
          );
        else if (this.isDuplicate(e))
          this.showEditErrorMessage(
            Utils.getLocalizationMessage("ERR_NAME_DUPLICATE")
          );
        else if (this.validateWishName(e)) {
          var s = this.setCommonParams();
          s.name = e;
          var a = $("#multipleWishlistController_select");
          if (
            (null != a &&
              "undefined" != a &&
              0 != a.value &&
              ((s.giftListId = $("#multipleWishlistController_select").val()),
              (this.nameToDelete = $(
                "#multipleWishlistController_select options:dropdown.selectedIndex"
              ).text())),
            $("#editShoppingListPopup").data("wc-WCDialog").close(),
            !submitRequest())
          )
            return;
          cursor_wait(), wcService.invoke("ShoppingListServiceUpdate", s);
        } else
          this.showErrorMessage(
            Utils.getLocalizationMessage("INVALID_NAME_SHOPPING_LIST")
          );
      else
        this.showEditErrorMessage(
          Utils.getLocalizationMessage("ERR_NAME_TOOLONG")
        );
    }),
    (this.deleteList = function () {
      var e = this.setCommonParams(),
        t = $("#multipleWishlistController_select");
      null != t &&
        "undefined" != t &&
        0 != t.value &&
        ((e.giftListId = $("#multipleWishlistController_select").val()),
        (this.nameToDelete = $(
          "#multipleWishlistController_select options:dropdown.selectedIndex"
        ).text())),
        $("#deleteShoppingListPopup").data("wc-WCDialog").close(),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("ShoppingListServiceDelete", e));
    }),
    (this.refreshLinkState = function () {
      var e = $("#multipleWishlistController_select")[0];
      if (null != e) {
        var t = $("#multipleWishlistController_select")[0].options[
            e.selectedIndex
          ].text,
          r = Utils.getLocalizationMessage("DEFAULT_WISH_LIST_NAME");
        t == r
          ? ($("#editDivider").css("display", "none"),
            $("#edit_popup_link").css("display", "none"),
            $("#deleteDivider").css("display", "none"),
            $("#delete_popup_link").css("display", "none"))
          : ($("#editDivider").css("display", "block"),
            $("#edit_popup_link").css("display", "block"),
            $("#deleteDivider").css("display", "block"),
            $("#delete_popup_link").css("display", "block"));
      }
    }),
    (this.addToListAndDelete = function (e, t, r) {
      (this.orderItemId = t),
        wcTopic.publish("modelChanged/AnalyticsConversionEvent"),
        this.hideDropDown();
      var s = this.setCommonParams();
      (s.giftListId = e),
        (s.catEntryId_1 = this.catEntryParams.id),
        (s.quantity_1 = 1),
        submitRequest() &&
          (cursor_wait(),
          ShoppingListDialogJS.setDialogParams(this.storeParams, {
            catEntryId: this.catEntryParams.id,
            name: this.catEntryParams.name,
            image: this.catEntryParams.image,
            thumbnail: "imgPath",
            focusElement: r,
          }),
          wcService.invoke("ShoppingListServiceAddItemAndRemoveFromCart", s));
    }),
    (this.deleteItemFromCart = function () {
      if ("" != this.orderItemId) {
        var e = this.orderItemId;
        (this.orderItemId = ""),
          "" != e && CheckoutHelperJS.deleteFromCart(e, !0);
      }
    }),
    (this.validateWishName = function (e) {
      var t = "~!@#$%^&*()+=[]{};:,<>?/|`";
      t += " '\"\\/";
      for (var r = 0; r < e.length; r++)
        if (t.indexOf(e.substring(r, r + 1)) >= 0) return !1;
      return !0;
    }),
    (this.setResolved = function (e, t) {
      this.catEntryParams.components[e].resolved = t;
    }),
    $(document.documentElement).on("mousedown", $.proxy("hideIfNoFocus", this));
  for (baseItemId in this.catEntryParams.components)
    wcTopic.subscribe(
      "DefiningAttributes_Resolved_" + baseItemId,
      function (catEntryId, productId) {
        eval(jsObjectName + ".setResolved('" + productId + "', true)");
      }
    ),
      wcTopic.subscribe(
        "DefiningAttributes_Changed_" + baseItemId,
        function (catEntryId, productId) {
          0 == catEntryId &&
            eval(jsObjectName + ".setResolved('" + productId + "', false)");
        }
      );
}
if (
  (("undefined" != typeof analyticsJS &&
    analyticsJS &&
    analyticsJS.topicNamespace) ||
    (analyticsJS = {
      storeId: 0,
      catalogId: 0,
      urlPath: null,
      miniShopCartTitle: "MiniShoppingCart",
      jsonPageView: "AnalyticsPageView",
      jsonProductView: "AnalyticsProductView",
      jsonElementView: "AnalyticsElementView",
      jsonShopcartView: "AnalyticsShopcartView",
      jsonAddCart: "AnalyticsShopcartView",
      jsonRegistrationView: "AnalyticsRegistrationView",
      jsonConversionEventView: "AnalyticsConversionEventView",
      topicNamespace: "/wc/analytics/",
      pageView: "pageview",
      productView: "productview",
      cartView: "cartview",
      addCart: "addcart",
      element: "element",
      registration: "registration",
      conversionEvent: "conversionevent",
      pageViewControl: !1,
      incTaxInUnitPriceForCart: "F",
      cartViewActionIdList: ["AjaxDeleteOrderItem", "AjaxUpdateOrderItem"],
      addCartActionIdList: ["AddOrderItem", "AjaxAddOrderItemWithShipingInfo"],
      wishlistPageIdList: [
        "AjaxInterestItemAdd",
        "InterestItemDelete",
        "AjaxRestWishListAddItem",
        "AjaxRestWishListRemoveItem",
        "ShoppingListServiceAddItem",
      ],
      conversionEventList: [
        "AjaxInterestItemAdd",
        "AjaxRestWishListAddItem",
        "AjaxInterestItemAddAndDeleteFromCart",
        "ShoppingListServiceAddItem",
        "AnalyticsConversionEvent",
      ],
      publishAnalyticsView: function (e, t, r) {
        var s = this,
          a = {
            url: getAbsoluteURL() + e,
            method: "GET",
            dataType: "json",
            data: $.extend(
              {
                storeId: s.storeId,
                catalogId: s.catalogId,
              },
              t
            ),
            error: function (e, t) {
              wcTopic.publish("ajaxRequestCompleted");
            },
            success: function (e, t) {
              r.call(s, e), wcTopic.publish("ajaxRequestCompleted");
            },
          };
        wcTopic.publish("ajaxRequestInitiated"), $.ajax(a);
      },
      publishTopic: function (e, t) {
        var r = this.makeTopic(e);
        wcTopic.publish(r, t);
      },
      publishPageView: function (e) {
        var t = this;
        this.publishAnalyticsView(t.jsonPageView, e, function (e) {
          t.publishTopic(t.pageView, e);
        });
      },
      publishConversionEventView: function (e) {
        var t = this;
        this.publishAnalyticsView(t.jsonConversionEventView, e, function (e) {
          t.publishTopic(t.conversionEvent, e);
        });
      },
      publishCartView: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonShopcartView,
          {
            storeId: e.storeId,
            incTaxInPrice: e.incTaxInUnitPriceForCart,
          },
          function (t) {
            e.publishTopic(e.cartView, t);
          }
        );
      },
      publishAddCart: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonAddCart,
          {
            storeId: e.storeId,
            incTaxInPrice: e.incTaxInUnitPriceForCart,
          },
          function (t) {
            e.publishTopic(e.addCart, t);
          }
        );
      },
      publishRegistrationView: function () {
        var e = this;
        this.publishAnalyticsView(
          e.jsonRegistrationView,
          {
            storeId: e.storeId,
          },
          function (t) {
            e.publishTopic(e.registration, t);
          }
        );
      },
      makeTopic: function (e) {
        return [this.topicNamespace, e].join("");
      },
      getMiniShopCartPageCategory: function () {
        return "MiniShoppingCart";
      },
      getMiniShopCartPageName: function () {
        return ["MiniShoppingCart: ", document.title].join("");
      },
      getMiniShopCartPageViewData: function (e) {
        var t = this.getMiniShopCartPageName(),
          r = this.getMiniShopCartPageCategory();
        return {
          pagename: t,
          category: r,
        };
      },
      publishMiniShopCartPageView: function (e) {
        var t = this;
        if (!t.pageViewControl) {
          t.lockPageView();
          var r = this.getMiniShopCartPageViewData(e);
          this.publishPageView(r);
        }
      },
      lockPageView: function () {
        (this.pageViewControl = !0),
          setTimeout("analyticsJS.pageViewControl = false;", 3e3);
      },
      registerMiniShopCartCartView: function () {
        var e = this;
        $(this.cartViewActionIdList).each(function (t, r) {
          wcTopic.subscribe("modelChanged/" + r, function () {
            e.publishCartView();
          });
        }),
          $(this.addCartActionIdList).each(function (t, r) {
            wcTopic.subscribe("modelChanged/" + r, function () {
              e.publishAddCart();
            });
          });
      },
      loadShopCartHandler: function (e) {
        var t = this;
        e === !0 && (t.incTaxInUnitPriceForCart = "T"),
          t.registerMiniShopCartCartView(),
          t.registerShopCartPaginationPageView(),
          t.registerShippingBillingAddressEditPageView();
      },
      loadShopCartPaginationHandler: function () {
        var e = this;
        e.registerShopCartPaginationPageView();
      },
      registerShopCartPaginationPageView: function () {
        var e = this;
        wcTopic.subscribe(
          "ShopCartPaginationDisplay_Context/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
            };
            e.publishPageView(t);
          }
        ),
          wcTopic.subscribe(
            "OrderItemPaginationDisplay_Context/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          ),
          wcTopic.subscribe(
            "traditionalShipmentDetailsContext/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          ),
          wcTopic.subscribe(
            "MSOrderItemPaginationDisplay_Context/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
              };
              e.publishPageView(t);
            }
          );
      },
      registerShippingBillingAddressEditPageView: function () {
        var e = this;
        wcTopic.subscribe(
          "editShippingAddressContext/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
              category: "Shipping and biling address",
            };
            e.publishPageView(t);
          }
        );
      },
      registerStoreLocatorPageViews: function () {
        var e = this;
        wcTopic.subscribe(
          "selectedStoreListContext/RenderContextChanged",
          function () {
            var t = {
              pagename: document.title,
              category: "Store locator",
            };
            e.publishPageView(t);
          }
        ),
          wcTopic.subscribe(
            "storeLocatorResultsContext/RenderContextChanged",
            function () {
              var t = {
                pagename: document.title,
                category: "Store locator",
              };
              e.publishPageView(t);
            }
          );
      },
      loadStoreLocatorPageViews: function () {
        var e = this;
        $(document).ready(function () {
          e.registerStoreLocatorPageViews();
        });
      },
      registerWishlistHandler: function () {
        var e = this,
          t =
            ("Personal Wishlist:" + document.title,
            {
              eventId: "AddToWishlist",
            });
        $(this.conversionEventList).each(function (r, s) {
          wcTopic.subscribe("modelChanged/" + s, function () {
            e.publishConversionEventView(t);
          });
        });
      },
      loadWishlistHandler: function () {
        var e = this;
        $(document).ready(function () {
          e.registerWishlistHandler();
        });
      },
      publishShopCartLoginTags: function () {
        var e = this;
        $(document).ready(function () {
          e.publishRegistrationView(), e.publishCartView();
        });
      },
      registerProductQuickInfoView: function () {
        var e = this;
        "undefined" != typeof QuickInfoJS &&
          Utils.aop_after(QuickInfoJS, "showDetails", function (t) {
            var r = t[0];
            e.publishAnalyticsView(
              e.jsonProductView,
              {
                productId: r,
                storeId: e.storeId,
              },
              function (t) {
                e.publishTopic(e.productView, t);
              }
            );
          });
      },
      loadProductQuickInfoHandler: function () {
        var e = this;
        $(document).ready(function () {
          e.registerProductQuickInfoView();
        });
      },
      loadPagingHandler: function () {
        var e = this;
        $(document).ready(function () {
          var t = {
              forward: "page forward",
              backward: "page backward",
            },
            r = [
              ["Common", "goBack", t.backward],
              ["Common", "goForard", t.forward],
              ["Common.HistoryTracker.prototype", "back", t.backward],
              ["Common.HistoryTracker.prototype", "forward", t.forward],
            ];
          $(r).each(function (t, r) {
            var s = Utils.getObject(r[0]),
              a = r[1],
              i = r[2];
            $(s).on(a, function () {
              e.publishPageView({
                pagename: document.title,
                category: i,
              });
            });
          });
        });
      },
      registerSearchResultPageView: function (
        resultInfoDivId,
        registerPageViewNow,
        advSearchFormDivId
      ) {
        var realSearch = !0,
          scope = this;
        if (registerPageViewNow && $("#" + resultInfoDivId).length) {
          var resultInfo = eval(
              "(" + $("#" + resultInfoDivId).html() + ")"
            ).searchResult,
            pageViewData = {
              pagename: document.title,
            };
          "" !== resultInfo.searchTerms &&
            ((pageViewData =
              "0" !== resultInfo.totalResultCount
                ? {
                    pagename:
                      "Search Successful:" + resultInfo.currentPageNumber,
                  }
                : {
                    pagename: "Search Unsuccessful",
                  }),
            resultInfo.searchTerms.length > 0 &&
              ((pageViewData.searchTerms = resultInfo.searchTerms),
              (pageViewData.searchCount = resultInfo.totalResultCount)),
            (pageViewData.category = "Search Results")),
            (pageViewData.attributes = resultInfo.attributes),
            scope.publishPageView(pageViewData);
        }
      },
      loadSearchResultHandler: function (e, t, r) {
        var s = this;
        wcTopic.subscribe("CMPageRefreshEvent", function () {
          s.registerSearchResultPageView(e, t, r);
        });
      },
      registerPaymentPageView: function (e) {
        var t = this;
        Utils.aop_after(e, "setNumberOfPaymentMethods", function (e) {
          var r = e[1];
          t.publishPageView({
            pagename: r.value,
            category: "payment method",
          }),
            (r = null);
        });
      },
      loadPaymentPageView: function (e) {
        var t = this;
        $(document).ready(function () {
          t.registerPaymentPageView(e);
        });
      },
    }),
  (categoryDisplayJS = {
    entitledItems: [],
    selectedProducts: {},
    selectedAttributes: {},
    errorMessages: {},
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    contextChanged: !1,
    isHistory: !1,
    merchandisingAssociationItems: [],
    baseCatalogEntryDetails: [],
    associationThumbnailIndex: 1,
    totalAssociationCount: 0,
    baseItemAddedToCart: !1,
    merchandisingProductAssociationAddToCart: !1,
    merchandisingProductAssociationForm: "",
    isParentBundleBean: !1,
    userType: "",
    moreInfoUrl: "",
    displayPrevAssociation: "",
    displayNextAssociation: "",
    defaultItemArray: [],
    currentPageType: "",
    currentCatalogEntryId: "",
    entitledItemJsonObject: null,
    isPopup: !1,
    displayPriceRange: !0,
    itemPriceJsonOject: [],
    allSwatchesArray: [],
    setCommonParameters: function (e, t, r, s) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.userType = s);
    },
    setEntitledItems: function (e) {
      this.entitledItems = e;
    },
    setSelectedAttribute: function (e, t) {
      console.debug(e + " : " + t),
        (this.selectedAttributes[e] = t),
        (this.moreInfoUrl = this.moreInfoUrl + "&" + e + "=" + t);
    },
    setSelectedAttributeJS: function (e, t) {
      console.debug(
        e.replace(/'/g, "&#039;") + " : " + t.replace(/'/g, "&#039;")
      ),
        (this.selectedAttributes[e.replace(/'/g, "&#039;")] = t.replace(
          /'/g,
          "&#039;"
        )),
        (this.moreInfoUrl =
          this.moreInfoUrl +
          "&" +
          e.replace(/'/g, "&#039;") +
          "=" +
          t.replace(/'/g, "&#039;"));
    },
    displayPriceServiceResponse: function (e, t) {
      (categoryDisplayJS.itemPriceJsonOject[
        e.catalogEntry.catalogEntryIdentifier.uniqueID
      ] = e),
        categoryDisplayJS.displayPrice(e.catalogEntry);
    },
    displayPrice: function (e) {
      var t,
        r = categoryDisplayJS.isPopup;
      if (
        (1 == r &&
          ($("#productPrice").html(e.offerPrice),
          $("#productName").html(e.description[0].name),
          $("#productSKUValue").html(
            e.catalogEntryIdentifier.externalIdentifier.partNumber
          )),
        0 == r)
      ) {
        var s = "";
        if (
          ((s =
            !e.listPriced || e.listPrice <= e.offerPrice
              ? "<span class='price bold'>" +
                MessageHelper.messages.PRICE +
                " </span><span class='price bold'>" +
                e.offerPrice +
                "</span>"
              : "<span class='price bold'>" +
                MessageHelper.messages.PRICE +
                " </span><span class='price listPrice bold'>" +
                e.listPrice +
                "</span><div class='price offerprice bold'>" +
                e.offerPrice +
                "</div>"),
          (s += "<br />"),
          1 == categoryDisplayJS.displayPriceRange)
        )
          for (var a in e.priceRange)
            "null" != e.priceRange[a].endingNumberOfUnits
              ? ((t = MessageHelper.messages.TieredPricingDisp),
                (t = t.replace("{0}", e.priceRange[a].startingNumberOfUnits)),
                (t = t.replace("{1}", e.priceRange[a].endingNumberOfUnits)),
                (t = t.replace("{2}", e.priceRange[a].localizedPrice)),
                (s = s + "<span class='price bold'>" + t + "</span>"))
              : ((t = MessageHelper.messages.TieredPricingDispLast),
                (t = t.replace("{0}", e.priceRange[a].startingNumberOfUnits)),
                (t = t.replace("{1}", e.priceRange[a].localizedPrice)),
                (s = s + "<span class='price bold'>" + t + "</span>")),
              (s += "<br />");
        $("#WC_CachedProductOnlyDisplay_div_4").html(s),
          $("#catalog_link").html(e.description[0].name);
      }
    },
    setSelectedAttributeOfProduct: function (e, t, r) {
      (selectedAttributesForProduct = {}),
        this.selectedProducts[e] &&
          (selectedAttributesForProduct = this.selectedProducts[e]),
        (selectedAttributesForProduct[t] = r),
        (this.selectedProducts[e] = selectedAttributesForProduct);
    },
    getCatalogEntryId: function () {
      var e = [];
      for (attribute in this.selectedAttributes)
        e.push(attribute + "_|_" + this.selectedAttributes[attribute]);
      return this.resolveSKU(e);
    },
    getImageForSKU: function () {
      var e = [];
      for (attribute in this.selectedAttributes)
        e.push(attribute + "_|_" + this.selectedAttributes[attribute]);
      return this.resolveImageForSKU(e);
    },
    getCatalogEntryIdforProduct: function (e) {
      var t = [];
      for (attribute in e) t.push(attribute + "_|_" + e[attribute]);
      return this.resolveSKU(t);
    },
    resolveSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].catentry_id,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName];
            n in s && i++;
          }
          if (a == i)
            return console.debug("CatEntryId:" + t + " for Attribute: " + e), t;
        }
      }
      return null;
    },
    resolveImageForSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].ItemImage,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName];
            n in s && i++;
          }
          if (a == i)
            return console.debug("ItemImage:" + t + " for Attribute: " + e), t;
        }
      }
      return null;
    },
    addToAllSwatchsArray: function (e, t, r) {
      if (!this.existInAllSwatchsArray(e, t)) {
        var s = [];
        (s[0] = e),
          (s[1] = t),
          (s[2] = r),
          (s[4] = document.getElementById("swatch_" + t).onclick),
          this.allSwatchesArray.push(s);
      }
    },
    existInAllSwatchsArray: function (e, t) {
      for (var r = 0; r < this.allSwatchesArray.length; r++) {
        var s = this.allSwatchesArray[r][0],
          a = this.allSwatchesArray[r][1];
        if (s == e && a == t) return !0;
      }
      return !1;
    },
    updateParamObject: function (e, t, r, s, a) {
      if ((null == e && (e = []), null != e[t] && s))
        if ($.isArray(e[t]))
          null != a && "" !== a ? (e[t][a] = r) : e[t].push(r);
        else {
          var i = e[t];
          (e[t] = []), e[t].push(i), e[t].push(r);
        }
      else if (null != a && "" !== a && -1 != a) e[t + "_" + a] = r;
      else if (-1 == a) {
        for (var n = 1; null != e[t + "_" + n]; ) n++;
        e[t + "_" + n] = r;
      } else e[t] = r;
      return e;
    },
    setDefaultItem: function (e, t) {
      this.defaultItemArray[e] = t;
    },
    getDefaultItem: function (e) {
      return this.defaultItemArray[e];
    },
    AddBundle2ShopCartAjax: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var t = [];
      (t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.orderId = "."),
        (t.calculateOrder = "0"),
        (t.inventoryValidation = "true");
      for (var r = e.numberOfProduct.value, s = 1; r >= s; s++) {
        var a = e["catEntryId_" + s].value;
        this.selectedProducts[a] &&
          (a = this.getCatalogEntryIdforProduct(this.selectedProducts[a]));
        var i = e["quantity_" + s].value;
        if (null == i || "" === i || 0 >= i)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        if (null == i || "" === i || null == a)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        this.updateParamObject(t, "catEntryId", a, !1, -1),
          this.updateParamObject(t, "quantity", i, !1, -1),
          (this.baseItemAddedToCart = !0);
        var n = document.getElementsByName(
          "contractSelectForm_contractId_" + a
        );
        if (null != n && "undefined" != n)
          for (j = 0; j < n.length; j++)
            if (n[j].checked) {
              e["contractId_" + s].value = n[j].value;
              break;
            }
        var o = e["contractId_" + s].value;
        null != o &&
          "" !== o &&
          this.updateParamObject(t, "contractId", o, !1, -1);
      }
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxAddOrderItem", t));
    },
    AddBundle2ShopCart: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      e.URL.value = "AjaxOrderItemDisplayView";
      for (var t = e.numberOfProduct.value, r = 1; t >= r; r++) {
        var s = e["catEntryId_" + r].value;
        if (this.selectedProducts[s]) {
          if (
            ((s = this.getCatalogEntryIdforProduct(this.selectedProducts[s])),
            null == s)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          e["catEntryId_" + r].value = s;
        }
        var a = e["quantity_" + r].value;
        if (null == a || "" === a || 0 >= a)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        var i = document.getElementsByName(
          "contractSelectForm_contractId_" + s
        );
        if (null != i && "undefined" != i)
          for (j = 0; j < i.length; j++)
            if (i[j].checked) {
              e["contractId_" + r].value = i[j].value;
              break;
            }
      }
      submitRequest() && processAndSubmitForm(e);
    },
    Add2ShopCart: function (entitledItemId, form, quantity, isPopup) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      if (null != catalogEntryId) {
        if (this.merchandisingProductAssociationAddToCart)
          return void this.AddAssociation2ShopCart(catalogEntryId, quantity);
        (form.catEntryId.value = catalogEntryId),
          (form.productId.value = catalogEntryId),
          this.AddItem2ShopCart(form, quantity),
          hidePopup("second_level_category_popup");
      } else
        1 == isPopup
          ? ($("#second_level_category_popup").css("zIndex", "1"),
            MessageHelper.formErrorHandleClient(
              "addToCartLink",
              MessageHelper.messages.ERR_RESOLVING_SKU
            ))
          : MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
    },
    AddItem2ShopCart: function (e, t) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.QUANTITY_INPUT_ERROR
        );
      e.quantity.value = t;
      var r = document.getElementsByName("contractSelectForm_contractId");
      if (null != r && "undefined" != r)
        for (i = 0; i < r.length; i++)
          if (r[i].checked) {
            e.contractId.value = r[i].value;
            break;
          }
      submitRequest() && processAndSubmitForm(e);
    },
    Add2ShopCartAjax: function (
      entitledItemId,
      quantity,
      isPopup,
      customParams
    ) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      null != catalogEntryId
        ? (this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams),
          (this.baseItemAddedToCart = !0),
          hidePopup("second_level_category_popup"))
        : 1 == isPopup
        ? ($("#second_level_category_popup").css("zIndex", "1"),
          MessageHelper.formErrorHandleClient(
            "addToCartLinkAjax",
            MessageHelper.messages.ERR_RESOLVING_SKU
          ))
        : (MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          ),
          (this.baseItemAddedToCart = !1));
    },
    setEntitledItemJsonObject: function (e) {
      this.entitledItemJsonObject = e;
    },
    getEntitledItemJsonObject: function () {
      return this.entitledItemJsonObject;
    },
    ReplaceItemAjax: function (entitledItemId, quantity) {
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(),
        removeOrderItemId = "",
        removeOrderItemId = replaceOrderItemId,
        typeId = document.getElementById("shipmentTypeId"),
        addressId = "",
        shipModeId = "";
      null != typeId &&
        "" !== typeId &&
        ("2" == typeId.value
          ? ((addressId = document.getElementById(
              "MS_ShipmentAddress_" + removeOrderItemId
            ).value),
            (shipModeId = document.getElementById(
              "MS_ShippingMode_" + removeOrderItemId
            ).value))
          : ((addressId = $("#addressId_all").val()),
            (shipModeId = $("#shipModeId_all").val()))),
        null != catalogEntryId
          ? "" !== removeOrderItemId &&
            this.ReplaceItemAjaxHelper(
              catalogEntryId,
              quantity,
              removeOrderItemId,
              addressId,
              shipModeId
            )
          : MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
    },
    ReplaceItemNonAjax: function (entitledItemId, quantity, form) {
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(),
        removeOrderItemId = "",
        removeOrderItemId = replaceOrderItemId;
      if (null != catalogEntryId)
        if ("" === removeOrderItemId);
        else {
          form.orderItemId.value = removeOrderItemId;
          var addressId, shipModeId;
          if (
            (0 == quantity && console.debug("An invalid quantity was selected"),
            null != form.shipmentTypeId && "" !== form.shipmenTypeId
              ? ("2" == form.shipmentTypeId.value
                  ? ((addressId = document.getElementById(
                      "MS_ShipmentAddress_" + removeOrderItemId
                    ).value),
                    (shipModeId = document.getElementById(
                      "MS_ShippingMode_" + removeOrderItemId
                    ).value))
                  : ((addressId = $("#addressId_all").val()),
                    (shipModeId = $("#shipModeId_all").val())),
                (form.URL.value =
                  "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId=" +
                  catalogEntryId +
                  "&quantity=" +
                  quantity +
                  "&addressId=" +
                  addressId +
                  "&shipModeId=" +
                  shipModeId +
                  "&URL=RESTOrderShipInfoUpdate?URL=" +
                  form.URL.value))
              : (form.URL.value =
                  "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId=" +
                  catalogEntryId +
                  "&quantity=" +
                  quantity +
                  "&URL=" +
                  form.URL.value),
            !submitRequest())
          )
            return;
          processAndSubmitForm(form);
        }
      else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    AddItem2ShopCartAjax: function (e, t, r) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId: ".",
      };
      (s.calculateOrder = "0"), (s.inventoryValidation = "true");
      var a = "AjaxAddOrderItem",
        i = "AjaxAddOrderItem_shopCart";
      if ($.isArray(e) && $.isArray(t))
        for (var n = 0; n < e.length; n++) {
          if (!isPositiveInteger(t[n]))
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.QUANTITY_INPUT_ERROR
            );
          (s["catEntryId_" + (n + 1)] = e[n]),
            (s["quantity_" + (n + 1)] = t[n]);
        }
      else {
        if (!isPositiveInteger(t))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        (s.catEntryId = e), (s.quantity = t);
      }
      if (null != r && "undefined" != r) {
        for (n in r) s[n] = r[n];
        "dynamicKit" == r.catalogEntryType &&
          ((a = "AjaxAddPreConfigurationToCart"),
          (i = "AjaxAddPreConfigurationToCart_shopCart"));
      }
      var o = document.getElementsByName("contractSelectForm_contractId");
      if (null != o && "undefined" != o)
        for (n = 0; n < o.length; n++)
          if (o[n].checked) {
            s.contractId = o[n].value;
            break;
          }
      submitRequest() &&
        (cursor_wait(),
        wcService.invoke(a, s),
        (this.baseItemAddedToCart = !0),
        document.getElementById("headerShopCartLink") &&
        "none" != document.getElementById("headerShopCartLink").style.display
          ? $("#headerShopCart").focus()
          : $("#headerShopCart1").focus());
    },
    ConfigureDynamicKit: function (e, t, r) {
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
      };
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.QUANTITY_INPUT_ERROR
        );
      var a = document.getElementsByName("contractSelectForm_contractId");
      if (null != a && "undefined" != a)
        for (n = 0; n < a.length; n++)
          if (a[n].checked) {
            s.contractId = a[n].value;
            break;
          }
      if (null != r && "undefined" != r) for (n in r) s[n] = r[n];
      if (submitRequest()) {
        cursor_wait();
        var i = "ConfigureView",
          n = 0;
        for (param in s) i += (0 == n++ ? "?" : "&") + param + "=" + s[param];
        document.location.href =
          getAbsoluteURL() + appendWcCommonRequestParameters(i);
      }
    },
    ReplaceItemAjaxHelper: function (e, t, r, s, a) {
      var i = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderItemId: r,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (i.calculationUsage = "-1,-2,-5,-6,-7")
        : (i.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var n = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (n.calculationUsage = "-1,-2,-5,-6,-7")
        : (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var o = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId:
          null != this.orderId &&
          "undefined" != this.orderId &&
          "" !== this.orderId
            ? this.orderId
            : ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (o.calculationUsage = "-1,-2,-5,-6,-7")
        : (o.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (o.allocate = "***"),
        (o.backorder = "***"),
        (o.remerge = "***"),
        (o.check = "*n");
      var d = !1;
      null != s &&
        "" !== s &&
        null != a &&
        "" !== a &&
        ((o.addressId = s), (o.shipModeId = a), (d = !0)),
        wcService.declare({
          id: "AjaxReplaceItem",
          actionId: "AjaxReplaceItem",
          url: "AjaxRESTOrderItemDelete",
          formId: "",
          successHandler: function (e) {
            d
              ? wcService.invoke("AjaxAddOrderItemTemp", n)
              : wcService.invoke("AjaxAddOrderItem", n);
          },
          failureHandler: function (e) {
            e.errorMessage
              ? MessageHelper.displayErrorMessage(e.errorMessage)
              : e.errorMessageKey &&
                MessageHelper.displayErrorMessage(e.errorMessageKey),
              cursor_clear();
          },
        }),
        wcService.declare({
          id: "AjaxAddOrderItemTemp",
          actionId: "AjaxAddOrderItemTemp",
          url: "AjaxRESTOrderItemAdd",
          formId: "",
          successHandler: function (e) {
            wcService.invoke("OrderItemAddressShipMethodUpdate", o);
          },
          failureHandler: function (e) {
            MessageHelper.displayErrorMessage(e.errorMessageKey);
          },
        }),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxReplaceItem", i));
    },
    AddBundle2WishList: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      for (var t = e.numberOfProduct.value, r = 1; t >= r; r++) {
        var s = e["catEntryId_" + r].value;
        if (this.selectedProducts[s]) {
          if (
            ((s = this.getCatalogEntryIdforProduct(this.selectedProducts[s])),
            null == s)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          e["catEntryId_" + r].value = s;
        }
      }
      (e.action = "InterestItemAdd"),
        (e.page.value = "customerlinkwishlist"),
        "G" == this.userType
          ? (e.URL.value = "InterestItemDisplay")
          : (e.URL.value = "AjaxLogonForm"),
        submitRequest() && processAndSubmitForm(e);
    },
    AddBundle2WishListAjax: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var t = [];
      (t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.updateable = 0),
        (t.orderId = ".");
      var r = [];
      r = e.catEntryIDS.value.toString().split(",");
      for (var s = 0; s < r.length; s++) {
        var a = document.getElementById("quantity_" + r[s]).value,
          i = r[s];
        if (
          (this.selectedProducts[r[s]] &&
            (i = this.getCatalogEntryIdforProduct(this.selectedProducts[r[s]])),
          (0 == a || null == a) && (a = 1),
          null == a || "" === a || null == i)
        )
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        this.updateParamObject(t, "catEntryId", i, !1, -1),
          this.updateParamObject(t, "quantity", a, !1, -1);
      }
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t));
    },
    Add2WishListAjaxByID: function (e) {
      if (null != e) {
        isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
        var t = {
          storeId: this.storeId,
          catalogId: this.catalogId,
          langId: this.langId,
          catEntryId: e,
          updateable: 0,
          URL: "SuccessfulAJAXRequest",
        };
        if (
          ($("#controllerURLWishlist").length &&
            $("#WishlistDisplay_Widget").refreshWidget(
              "updateUrl",
              $("#controllerURLWishlist").val()
            ),
          !submitRequest())
        )
          return;
        cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    Add2WishListAjax: function (entitledItemId) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      this.Add2WishListAjaxByID(catalogEntryId);
    },
    AddItem2WishListAjax: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var t = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        updateable: 0,
        URL: "SuccessfulAJAXRequest",
      };
      $("#controllerURLWishlist").length &&
        $("#WishlistDisplay_Widget").refreshWidget(
          "updateUrl",
          $("#controllerURLWishlist").val()
        ),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxInterestItemAdd", t));
    },
    Add2WishList: function (entitledItemId, form) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM");
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      this.Add2WishListByID(catalogEntryId, form);
    },
    Add2WishListByID: function (e, t) {
      if (
        (isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM"),
        null != e)
      ) {
        if (
          ((t.productId.value = e),
          (t.catEntryId.value = e),
          (t.action = "InterestItemAdd"),
          (t.page.value = "customerlinkwishlist"),
          "G" == this.userType
            ? (t.URL.value = "InterestItemDisplay")
            : (t.URL.value = "AjaxLogonForm"),
          (t.quantity.value = "1"),
          !submitRequest())
        )
          return;
        processAndSubmitForm(t);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU
        );
    },
    AddItem2WishList: function (e) {
      isAuthenticated || setWarningMessageCookie("WISHLIST_GUEST_ADDITEM"),
        (e.action = "InterestItemAdd"),
        (e.quantity.value = "1"),
        (e.page.value = "customerlinkwishlist"),
        "G" == this.userType
          ? (e.URL.value = "InterestItemDisplay")
          : (e.URL.value = "AjaxLogonForm"),
        submitRequest() && processAndSubmitForm(e);
    },
    initializeMerchandisingAssociation: function (thumbnailIndex) {
      var associationDisplay = document.getElementById(
          "marchandisingAssociationDisplay"
        ),
        totalPriceMsg = $("#totalPriceMsg").val(),
        baseCatEntryJSON = eval("(" + $("#baseCatEntryDetails").html() + ")");
      this.baseCatalogEntryDetails = baseCatEntryJSON;
      var basePrice = this.baseCatalogEntryDetails[0].baseCatEntry_Price;
      this.totalAssociationCount =
        this.baseCatalogEntryDetails[0].totalAssociations;
      var identifierJSON = "associatedCatEntries_" + thumbnailIndex,
        associationEntryJSON = eval("(" + $("#" + identifierJSON).html() + ")");
      this.merchandisingAssociationItems = associationEntryJSON;
      var totalPrice =
          parseFloat(basePrice) +
          parseFloat(this.merchandisingAssociationItems[0].catEntry_Price),
        dragType = "";
      "ProductBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "product")
        : "ItemBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "item")
        : "PackageBean" == this.merchandisingAssociationItems[0].catEntry_Type
        ? (dragType = "package")
        : "BundleBean" == this.merchandisingAssociationItems[0].catEntry_Type &&
          (dragType = "bundle");
      var widgetHTML = "";
      if ($("#addToCartLink").length) {
        var url =
          "AjaxOrderItemDisplayView?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId;
        widgetHTML =
          widgetHTML +
          "<form name='OrderItemAddForm_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' action='RESTOrderItemAdd' method='post' id='OrderItemAddForm_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'>\n<input type='hidden' name='storeId' value='" +
          this.storeId +
          "' id='OrderItemAddForm_storeId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='orderId' value='.' id='OrderItemAddForm_orderId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='catalogId' value='" +
          this.catalogId +
          "' id='OrderItemAddForm_orderId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='URL' value='" +
          url +
          "' id='OrderItemAddForm_url_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='errorViewName' value='InvalidInputErrorView' id='OrderItemAddForm_errorViewName_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='catEntryId' value='" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' id='OrderItemAddForm_catEntryId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' name='productId' value='" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' id='OrderItemAddForm_productId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='1' name='quantity' id='OrderItemAddForm_quantity_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='' name='page' id='OrderItemAddForm_page_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='-1,-2,-3,-4,-5,-6,-7' name='calculationUsage' id='OrderItemAddForm_calcUsage_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='0' name='updateable' id='OrderItemAddForm_updateable_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n<input type='hidden' value='' name='giftListId' id='OrderItemAddForm_giftListId_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'/>\n</form>\n";
      }
      (widgetHTML += "<div class='scroller' id='WC_CategoryDisplayJS_div_1'>"),
        this.totalAssociationCount > 1 &&
          (this.associationThumbnailIndex < this.totalAssociationCount &&
            (widgetHTML +=
              "      <a href='Javascript:categoryDisplayJS.showNextAssociation()'  id='WC_ProductAssociation_UpArrow_Link_1'>"),
          (widgetHTML =
            widgetHTML +
            "      <img src='" +
            this.baseCatalogEntryDetails[0].storeImage_Path +
            "i_up_arrow.png' alt='" +
            this.displayNextAssociation +
            "'/></a>")),
        (widgetHTML =
          widgetHTML +
          " <br /><div id='baseContent_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "'"),
        "true" == this.merchandisingAssociationItems[0].showProductQuickView
          ? (widgetHTML =
              widgetHTML +
              " onmouseover='showPopupButton(" +
              this.merchandisingAssociationItems[0].catEntry_Identifier +
              ");' onmouseout='hidePopupButton(" +
              this.merchandisingAssociationItems[0].catEntry_Identifier +
              ");'>")
          : (widgetHTML += " >"),
        (widgetHTML =
          widgetHTML +
          "  <a href='" +
          this.merchandisingAssociationItems[0].catEntry_ProductLink +
          "'  id='img" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' onfocus='showPopupButton(" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          ");'>"),
        (widgetHTML =
          widgetHTML +
          "     <img src='" +
          this.merchandisingAssociationItems[0].catEntry_Thumbnail +
          "' alt='" +
          this.merchandisingAssociationItems[0].catEntry_ShortDescription +
          "' class='img' width='70' height='70'/>  </a><br />"),
        "true" == this.merchandisingAssociationItems[0].showProductQuickView &&
          (widgetHTML =
            widgetHTML +
            " <div id='popupButton_" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            "' class='main_quickinfo_button'><span class='secondary_button' >\n<span class='button_container' >\n<span class='button_bg' >\n<span class='button_top'>\n<span class='button_bottom'>\n<a id='QuickInfoButton_" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            "' href='#' onclick='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; actionListImageAcct.showAddToCart=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; showPopup(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ",event,null,null,actionListImageAcct);' onkeypress='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; actionListImageAcct.showAddToCart=" +
            this.merchandisingAssociationItems[0].associationProductBuyable +
            "; showPopup(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ",event,null,null,actionListImageAcct);' onblur='hidePopupButton(" +
            this.merchandisingAssociationItems[0].catEntry_Identifier +
            ");' role='wairole:button' waistate:haspopup='true'>" +
            this.merchandisingAssociationItems[0].showProductQuickViewLable +
            "</a></span>\n</span>\n</span>\n</span>\n</span>\n</div>\n"),
        (widgetHTML += "</div>"),
        this.totalAssociationCount > 1 &&
          (this.associationThumbnailIndex > 1 &&
            (widgetHTML +=
              "      <a href='Javascript:categoryDisplayJS.showPreviousAssociation()'  id='WC_ProductAssociation_DownArrow_Link_1'>"),
          (widgetHTML =
            widgetHTML +
            "        <img src='" +
            this.baseCatalogEntryDetails[0].storeImage_Path +
            "i_down_arrow.png' alt='" +
            this.displayPrevAssociation +
            "'/></a>"));
      var comboText =
        this.baseCatalogEntryDetails[0].associatedProductsName.replace(
          /%0/,
          this.baseCatalogEntryDetails[0].baseCatEntry_Name
        );
      (comboText = comboText.replace(
        /%1/,
        this.merchandisingAssociationItems[0].catEntry_Name
      )),
        (widgetHTML =
          widgetHTML +
          "</div><div class='combo_text' id='WC_CategoryDisplayJS_div_2'>\n <h1 id='maHeader' class='status_msg'>" +
          comboText +
          "</h1>\n   <span id='maPrice' class='grey'>" +
          totalPriceMsg +
          Utils.formatCurrency(totalPrice.toFixed(2), {
            currency: this.baseCatalogEntryDetails[0].currency,
          }) +
          "</span>\n</div>\n"),
        (widgetHTML =
          widgetHTML +
          "<input type='hidden' id='compareImgPath_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_Thumbnail_compare +
          "'/><input type='hidden' id='compareProductDetailsPath_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_ProductLink +
          "'/><input type='hidden' id='compareImgDescription_" +
          this.merchandisingAssociationItems[0].catEntry_Identifier +
          "' value='" +
          this.merchandisingAssociationItems[0].catEntry_ShortDescription +
          "'/>"),
        (associationDisplay.innerHTML = null),
        (associationDisplay.innerHTML = widgetHTML),
        WCWidgetParser.parse(associationDisplay),
        WCWidgetParser.parseRefreshArea(associationDisplay);
    },
    showNextAssociation: function () {
      this.associationThumbnailIndex < this.totalAssociationCount &&
        ((this.associationThumbnailIndex = this.associationThumbnailIndex + 1),
        this.initializeMerchandisingAssociation(
          this.associationThumbnailIndex
        ));
    },
    showPreviousAssociation: function () {
      this.associationThumbnailIndex > 1 &&
        ((this.associationThumbnailIndex = this.associationThumbnailIndex - 1),
        this.initializeMerchandisingAssociation(
          this.associationThumbnailIndex
        ));
    },
    AddAssociation2ShopCartAjax: function (baseProductId, baseProductQuantity) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var identifierJSON =
          "associatedCatEntries_" + this.associationThumbnailIndex,
        associationEntryJSON = eval("(" + $("#" + identifierJSON).html() + ")");
      if (
        ((this.merchandisingAssociationItems = associationEntryJSON),
        (this.baseItemAddedToCart = !1),
        "ProductBean" == this.merchandisingAssociationItems[0].catEntry_Type)
      )
        this.Add2ShopCartAjax(baseProductId, baseProductQuantity),
          this.baseItemAddedToCart &&
            showPopup(
              this.merchandisingAssociationItems[0].catEntry_Identifier,
              function (e) {
                return e;
              },
              "marchandisingAssociationDisplay"
            );
      else if (
        ["ItemBean", "PackageBean", "BundleBean"].indexOf(
          this.merchandisingAssociationItems[0].catEntry_Type
        ) > -1
      ) {
        var entitledItemJSON = eval("(" + $("#" + baseProductId).html() + ")");
        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(),
          params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
          };
        if (((params.calculateOrder = "0"), null == catalogEntryId))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU
          );
        if (
          (this.updateParamObject(params, "catEntryId", catalogEntryId, !1, -1),
          this.updateParamObject(
            params,
            "quantity",
            baseProductQuantity,
            !1,
            -1
          ),
          "BundleBean" == this.merchandisingAssociationItems[0].catEntry_Type)
        ) {
          var form = document.getElementById(
              this.merchandisingAssociationItems[0].catEntry_BundleFormId
            ),
            catEntryArray = [];
          catEntryArray = form.catEntryIDS.value.toString().split(",");
          for (var i = 0; i < catEntryArray.length; i++) {
            var qty = document.getElementById(
                "quantity_" + catEntryArray[i]
              ).value,
              catEntryId = catEntryArray[i];
            if (
              (this.getDefaultItem(catEntryArray[i]) &&
                (catEntryId = this.getDefaultItem(catEntryArray[i])),
              (0 == qty || null == qty) && (qty = 1),
              null == qty || "" === qty || null == catEntryId)
            )
              return void MessageHelper.displayErrorMessage(
                MessageHelper.messages.ERR_RESOLVING_SKU
              );
            this.updateParamObject(params, "catEntryId", catEntryId, !1, -1),
              this.updateParamObject(params, "quantity", qty, !1, -1);
          }
        } else
          this.updateParamObject(
            params,
            "catEntryId",
            this.merchandisingAssociationItems[0].catEntry_Identifier,
            !1,
            -1
          ),
            this.updateParamObject(params, "quantity", 1, !1, -1);
        if (!submitRequest()) return;
        cursor_wait(), wcService.invoke("AjaxAddOrderItem", params);
      }
    },
    AddAssociation2ShopCart: function (e, t) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ADD2CART_BROWSE_ONLY_ERROR")
        );
      var r = this.merchandisingProductAssociationForm;
      if (
        ((this.merchandisingProductAssociationAddToCart = !1),
        this.isParentBundleBean)
      ) {
        var s = [];
        s = r.catEntryIDS.value.toString().split(",");
        for (var a = 1, i = 0; i < s.length; i++) {
          var n = document.getElementById("quantity_" + s[i]).value,
            o = s[i];
          if (
            (this.selectedProducts[s[i]] &&
              (o = this.getCatalogEntryIdforProduct(
                this.selectedProducts[s[i]]
              )),
            (0 == n || null == n) && (n = 1),
            null == n || "" === n || null == o)
          )
            return void MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERR_RESOLVING_SKU
            );
          var d = document.createElement("input");
          $(d).attr("id", "OrderItemAddForm_catEntryId_" + o),
            $(d).attr("type", "hidden"),
            $(d).attr("name", "catEntryId_" + a),
            $(d).attr("value", o),
            (a += 1),
            r.appendChild(d);
        }
        var l = document.createElement("input");
        $(l).attr("id", "OrderItemAddForm_catEntryId_" + e),
          $(l).attr("type", "hidden"),
          $(l).attr("name", "catEntryId_" + a),
          $(l).attr("value", e),
          r.appendChild(l);
        var c = document.createElement("input");
        $(c).attr("id", "OrderItemAddForm_quantity_" + e),
          $(c).attr("type", "hidden"),
          $(c).attr("name", "quantity_" + a),
          $(c).attr("value", t),
          r.appendChild(c),
          (r.URL.value = "AjaxOrderItemDisplayView"),
          (this.isParentBundleBean = !1);
      } else
        (r.catEntryId_2.value = e),
          (r.productId_2.value = e),
          (r.quantity_2.value = t);
      submitRequest() &&
        (processAndSubmitForm(r),
        (this.merchandisingProductAssociationForm = ""));
    },
    setOrderId: function (e) {
      this.orderId = e;
    },
    addToNewListFromProductDetail: function (
      entitledItemId,
      quantityElemId,
      currentPage
    ) {
      MessageHelper.hideAndClearMessage();
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId();
      return null == catalogEntryId
        ? (MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
          ),
          void (
            $("#second_level_category_popup").length &&
            hidePopup("second_level_category_popup")
          ))
        : void this.addItemToNewListFromProductDetail(
            catalogEntryId,
            quantityElemId,
            currentPage
          );
    },
    addItemToNewListFromProductDetail: function (e, t, r) {
      if ((MessageHelper.hideAndClearMessage(), null != e)) {
        var s = $("#" + t).val();
        if (null == s || "" === s || 0 >= s || !RequisitionList.isNumber(s))
          return (
            MessageHelper.displayErrorMessage(
              MessageHelper.messages.QUANTITY_INPUT_ERROR
            ),
            void (
              $("#second_level_category_popup").length &&
              hidePopup("second_level_category_popup")
            )
          );
        var a = "AjaxLogonForm?page=createrequisitionlist",
          i = document.createElement("form");
        $(i).attr("method", "POST");
        var n = document.createElement("input");
        $(n).attr("type", "hidden"),
          $(n).attr("value", r),
          $(n).attr("name", "previousPage"),
          i.appendChild(n),
          (i.action =
            a +
            "&catEntryId=" +
            e +
            "&quantity=" +
            s +
            "&storeId=" +
            this.storeId +
            "&catalogId=" +
            this.catalogId +
            "&langId=" +
            this.langId),
          document.body.appendChild(i),
          processAndSubmitForm(i);
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
        );
    },
    addBundleToNewListFromProductDetail: function (e, t) {
      for (
        var r = e.numberOfProduct.value,
          s = "AjaxLogonForm?page=createrequisitionlist",
          a = 1;
        r >= a;
        a++
      ) {
        var i = e["catEntryId_" + a].value;
        this.selectedProducts[i] &&
          (i = this.getCatalogEntryIdforProduct(this.selectedProducts[i]));
        var n = e["quantity_" + a].value;
        if (null == n || "" === n || 0 >= n || !RequisitionList.isNumber(n))
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.QUANTITY_INPUT_ERROR
          );
        if (null == i)
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERR_RESOLVING_SKU_REQ_LIST
          );
        s = s + "&catEntryId=" + i + "&quantity=" + n;
      }
      var o = document.createElement("input");
      $(o).attr("type", "hidden"),
        $(o).attr("value", t),
        $(o).attr("name", "previousPage"),
        e.appendChild(o),
        (s =
          s +
          "&numberOfProduct=" +
          e.numberOfProduct.value +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId),
        (e.action = s),
        processAndSubmitForm(e);
    },
    setCurrentPageType: function (e) {
      this.currentPageType = e;
    },
    setCurrentCatalogEntryId: function (e) {
      this.currentCatalogEntryId = e;
    },
    handleCategorySubscription: function (e) {
      var t = document.forms[e],
        r = {
          DM_ReqCmd: t.DM_ReqCmd.value,
          storeId: t.storeId.value,
          catalogId: t.catalogId.value,
          langId: t.langId.value,
          categoryId: t.categoryId.value,
        };
      submitRequest() &&
        (cursor_wait(), wcService.invoke("AjaxCategorySubscribe", r));
    },
  }),
  (compareProductJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    compareReturnName: "",
    returnUrl: "",
    cookieKeyPrefix: "CompareItems_",
    cookieDelimiter: ";",
    maxNumberProductsAllowedToCompare: 4,
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.compareReturnName = s),
        (this.returnUrl = decodeURIComponent(a));
    },
    clear: function () {
      MessageHelper.hideAndClearMessage();
      var e = this.cookieKeyPrefix + this.storeId;
      if (
        (setCookie(e, "", {
          path: "/",
          domain: cookieDomain,
        }),
        $.remove("#compareDropZoneImgDiv"),
        $("#compareDropZoneImg").length &&
          $("#compareDropZoneImg").css("display", "block"),
        $("#compareProductPage").length && $("#compareProductPage").val())
      ) {
        var t =
          "CompareProductsDisplay?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          this.compareReturnName +
          "&returnUrl=" +
          encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl));
        document.location.href = appendWcCommonRequestParameters(t);
      }
      MessageHelper.displayStatusMessage(
        MessageHelper.messages.COMPARE_ITEMS_CLEAR
      );
    },
    remove: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (null != r) {
        if ("" == $.trim(r))
          setCookie(t, null, {
            expires: -1,
          });
        else {
          var s = r.split(this.cookieDelimiter),
            a = "";
          for (index in s)
            s[index] != e &&
              (a = "" === a ? s[index] : a + this.cookieDelimiter + s[index]);
          setCookie(t, a, {
            path: "/",
            domain: cookieDomain,
          });
        }
        this.compareProducts();
      }
    },
    Add2CompareAjax: function (e, t, r, s) {
      MessageHelper.hideAndClearMessage(),
        $("#compareProductParentId_" + e).length &&
          void 0 != document.getElementById("compareProductParentId_" + e) &&
          (e = document.getElementById("compareProductParentId_" + e).value);
      var a = this.cookieKeyPrefix + this.storeId,
        i = getCookie(a);
      if (null != i && (-1 !== i.indexOf(e) || null == e))
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.COMPARE_ITEM_EXISTS
        );
      var n = 0;
      if (
        (null != i && "" !== i && (n = i.split(this.cookieDelimiter).length),
        n < parseInt(this.maxNumberProductsAllowedToCompare))
      ) {
        var o = "";
        if (
          ((o = null == i || "" === i ? e : i + this.cookieDelimiter + e),
          setCookie(a, o, {
            path: "/",
            domain: cookieDomain,
          }),
          0 == n &&
            ($("#compareDropZoneImg").css("display", "none"),
            $("#compareZone").after(
              "<div id='compareDropZoneImgDiv' style='width:100%'><table><tbody id='compareItemsTable'><tr id='compareRow'></tr></tbody></table></div>"
            )),
          $("#compareDropZoneImgDiv").length)
        ) {
          var d = (
            '<td id="compareCatentry' +
            e +
            '"><div id="compareCatentryContainer' +
            e +
            '"><div id="compare_img_' +
            e +
            '" class="compare_img"><a id="imgcatBrowseCompare_Item_' +
            e +
            '" href="' +
            r +
            '"><img height="40" width="40" border="0" alt="' +
            s +
            '" title="' +
            s +
            '" src="' +
            t +
            '"></img>\n</a></div><div id="compare_info_' +
            e +
            '" class="compare_info"><div id="compare_product_desc_' +
            e +
            '" class="compare_product_desc">' +
            s +
            "</div></div></div></td>"
          )
            .replace(/\"/g, "'")
            .replace(/\r|\n|\r\n|\n\r/g, "");
          $("#compareRow").after(d);
        }
        $("#compareProductPage").length &&
          "undefined" != document.getElementById("compareProductPage") &&
          $("#compareProductPage").val() &&
          this.compareProducts(),
          MessageHelper.displayStatusMessage(
            MessageHelper.messages.COMPAREZONE_ADDED
          );
      } else
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.COMPATE_MAX_ITEMS
        );
    },
    compareProducts: function () {
      var e =
          "CompareProductsDisplay?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          this.compareReturnName,
        t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (Utils.notNullOrWhiteSpace(r)) {
        var s = r.split(this.cookieDelimiter);
        for (index in s) e = e + "&catentryId=" + s[index];
      }
      (e =
        appendWcCommonRequestParameters(e) +
        "&returnUrl=" +
        encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl))),
        (document.location.href = getAbsoluteURL() + e);
    },
    init: function () {
      wcTopic.subscribe("/dnd/drop", function (e, t, r, s) {
        e != s && s.deleteSelectedNodes();
        var a = "",
          i = "",
          n = "",
          o = e.parent.id;
        if ("compareZone" == s.parent.id) {
          if (
            void 0 != getCookie("coShoppingDisableDnd") &&
            "true" == getCookie("coShoppingDisableDnd")
          )
            return void wcTopic.publish("/wc/collaboration/dndDisabled", []);
          var d = o.indexOf("_", 0);
          d >= 0 && (o = o.substring(d + 1)),
            $("#compareImgPath_" + o).length &&
              void 0 != document.getElementById("compareImgPath_" + o) &&
              (i = document.getElementById("compareImgPath_" + o).value),
            $("#compareProductDetailsPath_" + o).length &&
              void 0 !=
                document.getElementById("compareProductDetailsPath_" + o) &&
              (a = document.getElementById(
                "compareProductDetailsPath_" + o
              ).value),
            $("#compareImgDescription_" + o).length &&
              void 0 != document.getElementById("compareImgDescription_" + o) &&
              (n = document.getElementById("compareImgDescription_" + o).value),
            $("#compareProductParentId_" + o).length &&
              void 0 !=
                document.getElementById("compareProductParentId_" + o) &&
              (o = document.getElementById(
                "compareProductParentId_" + o
              ).value),
            compareProductJS.Add2CompareAjax(o, i, a, n);
        }
      });
      var e = this.cookieKeyPrefix + this.storeId;
      getCookie(e);
    },
  }),
  null == CheckoutPaymentsBis || "object" != typeof CheckoutPaymentsBis)
)
  var CheckoutPaymentsBis = new Object();
(CheckoutPaymentsBis = {
  errorMessages: {},
  numberOfPaymentMethods: 1,
  langId: "-1",
  storeId: "",
  catalogId: "",
  dirtyFlag: !1,
  jQlocale: "",
  maxNumberOfPaymentMethodsSupported: 3,
  paymentObjects: new Array(),
  paymentsToDelete: new Array(),
  paymentsToAdd: new Array(),
  paymentsToUpdate: new Array(),
  prevNumberOfPaymentMethods: 1,
  purchaseOrderNumber: "",
  paymentSpecificAddress: !1,
  quickCheckoutProfileForPaymentFlag: !1,
  currentPaymentMethodChanged: 1,
  setLocale: function (e) {
    this.jQlocale = e;
  },
  setQuickCheckoutProfileForPaymentFlag: function (e) {
    this.quickCheckoutProfileForPaymentFlag = e;
  },
  setErrorMessage: function (e, t) {
    this.errorMessages[e] = t;
  },
  setCommonParameters: function (e, t, r) {
    (this.langId = e), (this.storeId = t), (this.catalogId = r);
  },
  setNumPaymentIndicator: function (e) {
    var t = document.getElementById("paymentSection2");
    if ("block" == t.style.display)
      for (i = 1; i < e; i++) {
        var r = document.getElementById("paymentHeading" + i);
        r.style.display = "block";
      }
    else document.getElementById("paymentHeading1").style.display = "none";
  },
  setNumberOfPaymentMethods: function (e, t, r) {
    for (this.numberOfPaymentMethods = t.value, i = 1; i <= e; i++) {
      var s = document.getElementById(r + i);
      void 0 != s &&
        (i <= t.value
          ? (s.style.display = "block")
          : (s.style.display = "none"));
    }
    var a = document.getElementById("OrderTotalAmount").value;
    this.updateAmountFields(a), this.setNumPaymentIndicator(t.value);
  },
  clearPaymentFormData: function (e) {
    " " !== this.getValue(e, "cc_brand") && (e.cc_brand.value = " "),
      " " !== this.getValue(e, "cc_cvc") && (e.cc_cvc.value = " "),
      " " !== this.getValue(e, "account") && (e.account.value = " "),
      " " !== this.getValue(e, "payment_token") &&
        (e.payment_token.value = " "),
      " " !== this.getValue(e, "expire_month") && (e.expire_month.value = " "),
      " " !== this.getValue(e, "expire_year") && (e.expire_year.value = " "),
      " " !== this.getValue(e, "check_routing_number") &&
        (e.check_routing_number.value = " "),
      " " !== this.getValue(e, "checkingAccountNumber") &&
        (e.checkingAccountNumber.value = " "),
      " " !== this.getValue(e, "checkRoutingNumber") &&
        (e.checkRoutingNumber.value = " "),
      " " !== this.getValue(e, "numberOfInstallments") &&
        (e.numberOfInstallments.value = " ");
  },
  loadPaymentSnippet: function (e, t) {
    var r = document.forms["PaymentForm" + t];
    this.clearPaymentFormData(r);
    var s = e.value.split("_"),
      a = s[0],
      i = "";
    null != s[1] && (i = s[1]),
      this.paymentSpecificAddress &&
        ((wcRenderContext.getRenderContextProperties(
          "billingAddressDropDownBoxContext"
        )["payment" + t] = a),
        (wcRenderContext.getRenderContextProperties(
          "billingAddressDropDownBoxContext"
        )["paymentTCId" + t] = i),
        wcRenderContext.updateRenderContext(
          "billingAddressDropDownBoxContext"
        )),
      MessageHelper.hideAndClearMessage();
    for (var n = 0, o = 1; t > o; o++) {
      var d = document.forms["PaymentForm" + o];
      null == d.piAmount ||
        "" == d.piAmount.value ||
        isNaN(d.piAmount.value) ||
        (n = 1 * n + 1 * d.piAmount.value);
    }
    var l = "payment" + t,
      c = r.buyerOrgDN.value,
      u = r.orderId.value,
      m = r.piAmount.value,
      g = {};
    (g[l] = a),
      (g["paymentTCId" + t] = i),
      (g.currentPaymentArea = t),
      (g.payMethodId = a),
      (g.currentTotal = n),
      (g.paymentTCId = i),
      (g.buyerOrgDN = c),
      (g.orderId = u),
      (g.piAmount = m),
      wcRenderContext.updateRenderContext("paymentContext", g);
    var p = document.forms["PaymentForm" + t];
    if ("PayInStore" == a) {
      var h = document.getElementById("billingAddressSelectBoxArea_" + t);
      (h.style.display = "none"),
        p.billing_address_id && (p.billing_address_id.value = "");
    } else {
      var h = document.getElementById("billingAddressSelectBoxArea_" + t);
      (h.style.display = "block"),
        "" == p.billing_address_id && (p.billing_address_id.value = "-1");
    }
  },
  loadPaymentSnippetLocally: function (e, t) {
    var r = e.value.split("_"),
      s = r[0],
      a = "",
      i = "",
      n = "",
      o = document.forms["PaymentForm" + t];
    if (
      (null == o.piAmount ||
        "" == o.piAmount.value ||
        isNaN(o.piAmount.value) ||
        (i = o.piAmount.value),
      null == o.piAmount_display ||
        "" == o.piAmount_display.value ||
        isNaN(o.piAmount_display.value) ||
        (n = o.piAmount_display.value),
      null != r[1])
    ) {
      var d = r[1];
      a = $("#PIInfo_Div_" + s + "_" + t + "_" + d).html();
    } else a = $("#PIInfo_Div_" + s + "_" + t).html();
    var l = document.getElementById("paymentFormDiv" + t);
    l.html(a),
      "" != i && (o.piAmount.value = i),
      "" != n && (o.piAmount_display.value = n);
    var c = document.getElementById("OrderTotalAmount").value;
    this.updateAmountFields(c);
  },
  processCheckout: function (e, t) {
    if (
      (!CheckoutHelperJS.isSinglePageCheckout() ||
        this.validatePaymentTotals(e)) &&
      ((void 0 == t || null == t) && (t = !1),
      !CheckoutHelperJS.checkForDirtyFlag())
    ) {
      if ("1" == CheckoutHelperJS.getShipmentTypeId()) {
        if (null != document.getElementById("requestShippingDateCheckbox")) {
          var r = $("#requestedShippingDate");
          if (!r.ValidationTextbox("validationAndErrorHandler"))
            return void r.focus();
        }
      } else {
        var s = document.getElementById("totalNumberOfItems");
        if (null != s)
          for (var a = 0; a < s.value; a++) {
            var i = document.getElementById("orderItem_" + (a + 1));
            if (null != i) {
              var n = i.value,
                o = $("#MS_requestShippingDateCheckbox_" + n)[0];
              if (null != o) {
                var r = $("#MS_requestedShippingDate_" + n);
                if (!r.ValidationTextbox("validationAndErrorHandler"))
                  return void r.focus();
              }
            }
          }
      }
      if (null != document.getElementById("scheduleOrderInputSection")) {
        var d = document.getElementById("ScheduleOrderFrequency"),
          l = $("#ScheduleOrderStartDate"),
          c = document.getElementById("makeRecurringOrderMandatory");
        if (
          ("undefined" == d.value && null != l.val()) ||
          (c && "true" == c.value && "undefined" == d.value)
        )
          return void MessageHelper.formErrorHandleClient(
            d.id,
            MessageHelper.messages.SCHEDULE_ORDER_MISSING_FREQUENCY
          );
        if ("undefined" != d.value && null == l.val())
          return void MessageHelper.formErrorHandleClient(
            l[0].id,
            MessageHelper.messages.SCHEDULE_ORDER_MISSING_START_DATE
          );
        if (!CheckoutHelperJS.validateDate(l, "ScheduleOrderStartDate")) return;
      }
      var u = document.getElementById("numberOfPaymentMethods");
      if (u)
        for (var m = u.value, a = 1; m >= a; a++) {
          var g = document.forms[e + a];
          if ("select-one" == g.payMethodId.type)
            for (var p = 0; p < g.payMethodId.options.length; p++) {
              var h = g.payMethodId.options[p].value.split("_")[0];
              g.payMethodId.options[p].value = h;
            }
        }
      if (!t && !CheckoutHelperJS.isSinglePageCheckout()) {
        var I = [];
        if (
          ((I.storeId = this.storeId),
          (I.catalogId = this.catalogId),
          (I.langId = this.langId),
          (I.orderId = "."),
          !submitRequest())
        )
          return;
        return (
          cursor_wait(),
          void wcService.invoke("AjaxPrepareOrderBeforePaymentCapture", I)
        );
      }
      if (t) this.processPIAndCheckout(e, t);
      else {
        var I = [];
        if (
          ((I.storeId = this.storeId),
          (I.catalogId = this.catalogId),
          (I.langId = this.langId),
          !submitRequest())
        )
          return;
        cursor_wait(), wcService.invoke("AjaxPrepareOrderBeforeSubmit", I);
      }
    }
  },
  processPIAndCheckout: function (e, t) {
    if (
      (void 0 == t || null == t
        ? (t = !1)
        : ("true" == t || "false" == t) && (t = "true" === t),
      this.checkValidPaymentInstructions(e))
    ) {
      var r = document.forms[e + "1"];
      "Y" == this.getValue(r, "valueFromProfileOrder") &&
        (this.setQuickCheckoutProfileForPaymentFlag("true"),
        this.updatePaymentObject(1, "account"));
      for (
        var s = parseInt(this.maxNumberOfPaymentMethodsSupported), a = 1;
        s >= a;
        a++
      ) {
        var i = this.retrievePaymentObject(a);
        null != i &&
          (("delete" != i.action && "re-add" != i.action) ||
            "" == i.piId ||
            this.setPaymentsToDelete(a),
          ("add" == i.action || "re-add" == i.action) &&
            this.setPaymentsToAdd(a),
          "update" == i.action && "" != i.piId && this.setPaymentsToUpdate(a));
      }
      this.getPaymentsToDelete().length > 0
        ? this.deletePaymentInstructions()
        : this.getPaymentsToAdd().length > 0
        ? this.addPaymentInstructions()
        : this.getPaymentsToUpdate().length > 0
        ? this.updatePaymentInstructions()
        : (CheckoutPayments.setCommonParameters(
            SBServicesDeclarationJS.langId,
            SBServicesDeclarationJS.storeId,
            SBServicesDeclarationJS.catalogId
          ),
          CheckoutPayments.showSummaryPage(),
          cursor_clear()),
        CheckoutHelperJS.setFieldDirtyFlag(!1);
    }
  },
  showSummaryPage: function () {
    null != document.getElementById("scheduleOrderInputSection") &&
      CheckoutHelperJS.prepareOrderSchedule();
    var e = encodeURIComponent(this.purchaseOrderNumber),
      t = "";
    "1" == CheckoutHelperJS.getShipmentTypeId()
      ? ((t =
          "SingleShipmentOrderSummaryView?langId=" +
          this.langId +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&purchaseorder_id=" +
          e +
          "&quickCheckoutProfileForPayment=" +
          this.quickCheckoutProfileForPaymentFlag),
        (document.location.href = appendWcCommonRequestParameters(t)))
      : ((t =
          "MultipleShipmentOrderSummaryView?langId=" +
          this.langId +
          "&storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&purchaseorder_id=" +
          e +
          "&quickCheckoutProfileForPayment=" +
          this.quickCheckoutProfileForPaymentFlag),
        (document.location.href = appendWcCommonRequestParameters(t)));
  },
  showBillingPage: function () {
    document.location.href = appendWcCommonRequestParameters(
      "OrderBillingView?langId=" +
        this.langId +
        "&storeId=" +
        this.storeId +
        "&catalogId=" +
        this.catalogId +
        "&forceShipmentType=" +
        CheckoutHelperJS.getShipmentTypeId()
    );
  },
  populateProtocolData: function (e, t) {
    return (
      (t = this.updateParamObject(
        t,
        "storeId",
        this.getValue(e, "storeId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "payment_token",
        this.getValue(e, "payment_token"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "catalogId",
        this.getValue(e, "catalogId"),
        !0
      )),
      (t = this.updateParamObject(t, "langId", this.getValue(e, "langId"), !0)),
      (t = this.updateParamObject(
        t,
        "valueFromProfileOrder",
        this.getValue(e, "valueFromProfileOrder"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "valueFromPaymentTC",
        this.getValue(e, "valueFromPaymentTC"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "paymentTCId",
        this.getValue(e, "paymentTCId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "payMethodId",
        this.getValue(e, "payMethodId"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "piAmount",
        this.getValue(e, "piAmount"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "billing_address_id",
        this.getValue(e, "billing_address_id"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "cc_brand",
        this.getValue(e, "cc_brand"),
        !0
      )),
      (t = this.updateParamObject(t, "cc_cvc", this.getValue(e, "cc_cvc"), !0)),
      (t = this.updateParamObject(
        t,
        "account",
        this.getValue(e, "account"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "expire_month",
        this.getValue(e, "expire_month"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "expire_year",
        this.getValue(e, "expire_year"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "check_routing_number",
        this.getValue(e, "check_routing_number"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "checkingAccountNumber",
        this.getValue(e, "checkingAccountNumber"),
        !0
      )),
      (t = this.updateParamObject(
        t,
        "checkRoutingNumber",
        this.getValue(e, "checkRoutingNumber"),
        !0
      )),
      (t = this.updateParamObject(t, "requesttype", "ajax", !0)),
      e.authToken &&
        (t = this.updateParamObject(
          t,
          "authToken",
          this.getValue(e, "authToken"),
          !0
        )),
      t
    );
  },
  populateProtocolDataForGivenFields: function (e, t, r) {
    for (var s = 0; s < r.length; s++) {
      var a = r[s];
      t = this.updateParamObject(t, a, this.getValue(e, a), !0);
    }
    return (t = this.updateParamObject(t, "requesttype", "ajax", !0));
  },
  getSelected: function (e, t) {
    if (null != e[t]) {
      var r = e[t],
        s = r.selectedIndex;
      return -1 !== s ? r.options[s].text : "";
    }
    return "";
  },
  getValue: function (e, t) {
    return null != e[t] ? e[t].value : " ";
  },
  trim: function (e) {
    word = e.toString();
    for (var t = 0, r = word.length - 1; " " == word.charAt(t); ) t++;
    for (; " " == word.charAt(r); ) r -= 1;
    return t > r ? word.substring(t, t) : word.substring(t, r + 1);
  },
  isNumber: function (e) {
    for (var t = "0123456789", e = this.trim(e), r = 0; r < e.length; r++)
      if (-1 == t.indexOf(e.charAt(r))) return !1;
    return !0;
  },
  formatAmountDisplayForLocale: function (e) {
    var t = document.getElementById("piAmount_" + e),
      r = document.getElementById("piAmount_" + e + "_display");
    if ("ar-eg" == this.jQlocale)
      var s = Utils.formatNumber(t.value, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    else if (
      0 === this.jQlocale.indexOf("zh") ||
      0 === this.jQlocale.indexOf("ja") ||
      0 === this.jQlocale.indexOf("ko")
    )
      var s = Utils.formatNumber(t.value, {
        locale: this.jQlocale,
        maximumFractionDigits: 1,
      });
    else
      var s = Utils.formatNumber(t.value, {
        locale: this.jQlocale,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    (r.value != s || "ar-eg" == this.jQlocale) && (r.value = s);
  },
  validateAmount: function (e, t) {
    var r = document.forms[e + t];
    (r.piAmount_display.value = r.piAmount_display.value.replace(
      /^\s+|\s+$/g,
      ""
    )),
      (r.piAmount_display.value = r.piAmount_display.value.replace(
        /\xa0/g,
        ""
      ));
    var s = r.piAmount_display.value;
    if ("ar-eg" == this.jQlocale) {
      s = s.replace(",", "");
      var a = Utils.formatNumber(s, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      });
    } else var a = Utils.parseNumber(s);
    if (
      (a != r.piAmount.value && (r.piAmount.value = a),
      null != r.piAmount && "" == r.piAmount.value)
    )
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_NO_AMOUNT
        ),
        !1
      );
    if (null != r.piAmount && parseFloat(r.piAmount.value) < 0)
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_AMOUNT_LT_ZERO
        ),
        !1
      );
    if (null != r.piAmount && isNaN(r.piAmount.value))
      return (
        MessageHelper.formErrorHandleClient(
          r.piAmount_display,
          this.errorMessages.EDPPaymentMethods_AMOUNT_NAN
        ),
        !1
      );
    var i = {};
    return (
      (i["paymentAreaAmount" + t] = a),
      wcRenderContext.updateRenderContext("paymentContext", i),
      !0
    );
  },
  validatePaymentTotals: function (e) {
    for (
      var t = parseFloat(0),
        r = document.getElementById("OrderTotalAmount").value,
        s = 1;
      s <= this.numberOfPaymentMethods;
      s++
    ) {
      var a = document.forms[e + s];
      if (!this.validateAmount(e, s)) return !1;
      t += parseFloat(a.piAmount.value);
      var i = t.toFixed(2);
      t = parseFloat(i);
    }
    if (t == r) return !0;
    var n = document.getElementsByName("piAmount_display")[0];
    return r > t
      ? (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages.EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT
        ),
        !1)
      : t > r
      ? (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages
            .EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT
        ),
        !1)
      : (MessageHelper.formErrorHandleClient(
          n,
          this.errorMessages.EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM
        ),
        !1);
  },
  isBillingAddressValid: function (e) {
    for (var t = 1; t <= this.numberOfPaymentMethods; t++) {
      var r = document.forms[e + t],
        s = r.billing_address_isValid;
      if (s && "false" == s.value) return !1;
    }
    return !0;
  },
  checkValidPaymentInstructions: function (e) {
    for (var t = 1; t <= this.numberOfPaymentMethods; t++) {
      var r = document.forms[e + t],
        s = " ";
      null != r["mandatoryFields_" + t] &&
        (s = r["mandatoryFields_" + t].value);
      var a = document.forms.purchaseOrderNumberInfo;
      if (a) {
        if (
          ((this.purchaseOrderNumber = a.purchase_order_number.value),
          "true" == a.purchaseOrderNumberRequired.value &&
            "" == a.purchase_order_number.value)
        )
          return (
            MessageHelper.formErrorHandleClient(
              a.purchase_order_number,
              this.errorMessages.ERROR_PONumberEmpty
            ),
            !1
          );
        if (
          !MessageHelper.isValidUTF8length(a.purchase_order_number.value, 128)
        )
          return (
            MessageHelper.formErrorHandleClient(
              a.purchase_order_number,
              this.errorMessages.ERROR_PONumberTooLong
            ),
            !1
          );
      }
      if (
        "select-one" == r.payMethodId.type &&
        "empty" ==
          r.payMethodId.options[r.payMethodId.options.selectedIndex].value
      )
        return (
          MessageHelper.formErrorHandleClient(
            r.payMethodId,
            this.errorMessages.EDPPaymentMethods_NO_PAYMENT_SELECTED
          ),
          !1
        );
      if (
        (CheckoutHelperJS.isPaymentDataDirty(t) &&
          null != document.getElementById("account_" + t) &&
          (document.getElementById("account_" + t).value =
            document.getElementById("account1_" + t).value),
        null != document.getElementById("expire_month_" + t) ||
          null != document.getElementById("expire_year_" + t))
      ) {
        var i = new Date(
            r.curr_year.value,
            r.curr_month.value - 1,
            r.curr_date.value
          ),
          n = 1,
          o = 1;
        null != document.getElementById("expire_month_" + t) &&
          ((o =
            new Number(document.getElementById("expire_month_" + t).value) + 1),
          o > 13 && (o = 1));
        var d = 2e3;
        null != document.getElementById("expire_year_" + t) &&
          (d = new Date(
            document.getElementById("expire_year_" + t).value,
            o - 1,
            n
          ));
      }
      if (null != r.piAmount && parseFloat(r.piAmount.value) < 0)
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_AMOUNT_LT_ZERO
          ),
          !1
        );
      if (
        -1 != s.indexOf("account_" + t) &&
        null != document.getElementById("account_" + t) &&
        "" == document.getElementById("account_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_ACCOUNT_NUMBER
          ),
          !1
        );
      if (
        -1 != s.indexOf("expire_month_" + t) &&
        -1 != s.indexOf("expire_year_" + t) &&
        null != document.getElementById("expire_month_" + t) &&
        null != document.getElementById("expire_year_" + t) &&
        i >= d
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_INVALID_EXPIRY_DATE
          ),
          !1
        );
      if (null != r.piAmount && "" == r.piAmount.value)
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_NO_AMOUNT
          ),
          !1
        );
      if (null != r.piAmount && isNaN(r.piAmount.value))
        return (
          MessageHelper.formErrorHandleClient(
            r.piAmount_display,
            this.errorMessages.EDPPaymentMethods_AMOUNT_NAN
          ),
          !1
        );
      if (
        -1 != s.indexOf("check_routing_number_" + t) &&
        null != document.getElementById("check_routing_number_" + t) &&
        "" == document.getElementById("check_routing_number_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_ROUTING_NUMBER
          ),
          !1
        );
      if (
        -1 != s.indexOf("CheckAccount_" + t) &&
        null != document.getElementById("CheckAccount_" + t) &&
        "" == document.getElementById("CheckAccount_" + t).value
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_BANK_ACCOUNT_NO
          ),
          !1
        );
      if (
        -1 != s.indexOf("billing_address_id") &&
        null != r.billing_address_id &&
        ("" == r.billing_address_id.value || "-1" == r.billing_address_id.value)
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_NO_BILLING_ADDRESS
          ),
          !1
        );
      if (
        CheckoutHelperJS.isPaymentDataDirty(t) &&
        -1 != s.indexOf("cc_cvc_" + t) &&
        null != document.getElementById("cc_cvc_" + t) &&
        null != this.trim(document.getElementById("cc_cvc_" + t).value) &&
        "" != this.trim(document.getElementById("cc_cvc_" + t).value) &&
        !this.isNumber(document.getElementById("cc_cvc_" + t).value)
      )
        return (
          MessageHelper.displayErrorMessage(
            this.errorMessages.EDPPaymentMethods_CVV_NOT_NUMERIC
          ),
          !1
        );
    }
    return this.isBillingAddressValid(e)
      ? CheckoutHelperJS.isSinglePageCheckout() || this.validatePaymentTotals(e)
        ? !0
        : !1
      : (MessageHelper.displayErrorMessage(
          this.errorMessages.EDPPaymentMethods_BILLING_ADDRESS_INVALID
        ),
        !1);
  },
  updateExistingPiId: function (e, t) {
    if (null != e) {
      var r = document.forms[e + 1];
      r.existingPiId.value = t;
    }
  },
  updateParamObject: function (e, t, r, s, a) {
    if ((null == e && (e = []), null != e[t] && s))
      if ($.isArray(e[t])) null != a && "" != a ? (e[t][a] = r) : e[t].push(r);
      else {
        var i = e[t];
        (e[t] = []), e[t].push(i), e[t].push(r);
      }
    else if (null != a && "" != a && -1 != a) e[t + "_" + a] = r;
    else if (-1 == a) {
      for (var n = 1; null != e[t + "_" + n]; ) n++;
      e[t + "_" + n] = r;
    } else e[t] = r;
    return e;
  },
  saveBillingAddressDropDownBoxContextProperties: function (e, t) {
    for (var r = 1; 4 > r; r++) {
      var s = document.forms["PaymentForm" + r];
      if (s) {
        if (null != s.billing_address_id) {
          var a = s.billing_address_id.value;
          "create" == e && t == r && (a = "-1"),
            (wcRenderContext.getRenderContextProperties(
              "billingAddressDropDownBoxContext"
            )["billingAddress" + r] = a);
        }
      } else if (!(null == s && r > 1)) return;
    }
    if ("edit" == e) {
      var s = document.forms["PaymentForm" + t];
      if (s)
        for (var a = s.billing_address_id.value, r = 1; 4 > r; r++) {
          var i = document.forms["PaymentForm" + r];
          if (i) {
            var n = i.billing_address_id.value;
            n == a &&
              (wcRenderContext.getRenderContextProperties(
                "billingAddressDropDownBoxContext"
              )["billingAddress" + r] = "-1");
          }
        }
    }
  },
  createBillingAddress: function (e, t) {
    this.saveBillingAddressDropDownBoxContextProperties("create", e),
      CheckoutHelperJS.createAddress(-1, t);
  },
  displayBillingAddressDetails: function (e, t, r) {
    if (
      (-1 != e.value &&
        (document.getElementById("selectedAddressId_" + t).value = e.value),
      this.saveBillingAddressDropDownBoxContextProperties("create", "-1"),
      -1 != e.value)
    ) {
      wcRenderContext.updateRenderContext("billingAddressDropDownBoxContext", {
        addressKey: e.value,
        areaNumber: t,
      });
    }
  },
  getTotalInJSON: function (e, t, r) {
    var s = {};
    (s.operation = e),
      (s.piFormName = t),
      (s.skipOrderPrepare = r),
      (s.storeId = this.storeId),
      (s.catalogId = this.catalogId),
      (s.langId = this.langId);
    var a = appendWcCommonRequestParameters("orderTotalAsJSON");
    wcTopic.publish("ajaxRequestInitiated"),
      $.ajax({
        url: a,
        method: "POST",
        dataType: "json",
        data: s,
        context: this,
        success: CheckoutPayments.updateAmountFieldsWithTotalInJSON,
        error: function (e, t, r) {
          console.debug("error - inside CheckoutPayments.getTotalInJSON()"),
            console.debug(r),
            wcTopic.publish("ajaxRequestCompleted");
        },
      });
  },
  updateAmountFieldsWithTotalInJSON: function (e, t, r) {
    null != e &&
      void 0 != e &&
      CheckoutPayments.updateAmountFields(
        e.orderTotal,
        e.operation,
        e.piFormName,
        e.skipOrderPrepare
      ),
      wcTopic.publish("ajaxRequestCompleted");
  },
  updateAmountFields: function (e, t, r, s) {
    var a,
      i = 0;
    if (
      ((this.numberOfPaymentMethods = document.getElementById(
        "numberOfPaymentMethods"
      ).value),
      null != document.getElementById("OrderTotalAmount") &&
        (document.getElementById("OrderTotalAmount").value = e),
      1 == this.numberOfPaymentMethods)
    )
      return (
        (a = document.forms.PaymentForm1),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          ((a.piAmount.value = e),
          (a.piAmount_display.value = e),
          this.formatAmountDisplayForLocale("1"),
          null != this.retrievePaymentObject(1) &&
            this.updatePaymentObject(1, "piAmount")),
        void (void 0 != t && "OrderPrepare" == t
          ? this.processPIAndCheckout(r, s)
          : ((void 0 != t && "loadPaymentSnippet" == t) ||
              supportPaymentTypePromotions) &&
            this.currentPaymentMethodChanged &&
            (this.loadPaymentSnippet(
              document.getElementById(
                "payMethodId_" + this.currentPaymentMethodChanged
              ),
              this.currentPaymentMethodChanged
            ),
            this.updatePaymentObject(
              this.currentPaymentMethodChanged,
              "payMethodId"
            )))
      );
    for (var n = 1; n <= this.numberOfPaymentMethods; n++)
      (a = document.forms["PaymentForm" + n]),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          (i = 1 * i + 1 * a.piAmount.value);
    var o = e - i;
    if (((o = Math.round(100 * o) / 100), o > 0)) {
      var d = this.numberOfPaymentMethods;
      (a = document.forms["PaymentForm" + d]),
        null == a.piAmount ||
          "" == a.piAmount.value ||
          isNaN(a.piAmount.value) ||
          ((a.piAmount.value = parseFloat(a.piAmount.value) + parseFloat(o)),
          (a.piAmount_display.value = a.piAmount.value),
          this.formatAmountDisplayForLocale(d),
          null != this.retrievePaymentObject(d) &&
            this.updatePaymentObject(d, "piAmount"));
    } else {
      o = -1 * o;
      for (var l = this.numberOfPaymentMethods; l > 0; l--)
        if (
          ((a = document.forms["PaymentForm" + l]),
          null != a.piAmount &&
            "" != a.piAmount.value &&
            !isNaN(a.piAmount.value))
        ) {
          if (a.piAmount.value > o) {
            var c = a.piAmount.value - o;
            (a.piAmount.value = Math.round(100 * c) / 100),
              (a.piAmount_display.value = a.piAmount.value),
              this.formatAmountDisplayForLocale(l),
              null != this.retrievePaymentObject(l) &&
                this.updatePaymentObject(l, "piAmount"),
              (o = 0);
            break;
          }
          (o -= a.piAmount.value),
            (a.piAmount.value = 0),
            null != this.retrievePaymentObject(l) &&
              this.updatePaymentObject(l, "piAmount"),
            this.formatAmountDisplayForLocale(l);
        }
    }
    void 0 != t && "OrderPrepare" == t
      ? this.processPIAndCheckout(r, s)
      : void 0 != t &&
        "loadPaymentSnippet" == t &&
        this.currentPaymentMethodChanged &&
        (this.loadPaymentSnippet(
          document.getElementById(
            "payMethodId_" + this.currentPaymentMethodChanged
          ),
          this.currentPaymentMethodChanged
        ),
        this.updatePaymentObject(
          this.currentPaymentMethodChanged,
          "payMethodId"
        ));
  },
  removeCreditCardNumberAndCVV: function (e, t, r) {
    CheckoutHelperJS.isPaymentDataDirty(e) ||
      (t &&
        (null == document.forms["PaymentForm" + e].valueFromProfileOrder ||
          "Y" !=
            document.forms["PaymentForm" + e].valueFromProfileOrder.value) &&
        $("#account1_" + e).length &&
        $("#account1_" + e).val(""),
      r && $("#cc_cvc_" + e).length && $("#cc_cvc_" + e).val(""));
  },
  initializePaymentAreaDataDirtyFlags: function () {
    (CheckoutHelperJS.dataDirty[1] = !1),
      (CheckoutHelperJS.dataDirty[2] = !1),
      (CheckoutHelperJS.dataDirty[3] = !1);
  },
  initializeOverallPaymentObjects: function () {
    (this.prevNumberOfPaymentMethods = document.getElementById(
      "numberOfPaymentMethods"
    ).value),
      (this.numberOfPaymentMethods = parseInt(
        $("#numberOfPaymentMethods").val()
      ));
    for (
      var e = parseInt(this.maxNumberOfPaymentMethodsSupported), t = 1;
      e >= t;
      t++
    )
      this.initializePaymentObject(t);
    var r = document.forms.PaymentForm1.existingPiId.value,
      s = null;
    if (
      document.forms.PaymentForm1.unboundPiId &&
      ((s = document.forms.PaymentForm1.unboundPiId.value),
      null != s && "" != s)
    )
      var a = s.split(",");
    if (null != r && "" != r)
      for (var i = r.split(","), t = 0; t < i.length; t++) {
        var n = t + 1;
        if (
          ((this.retrievePaymentObject(n).piId = i[t]),
          (document.forms["PaymentForm" + n].piId.value = i[t]),
          n > this.numberOfPaymentMethods &&
            (this.retrievePaymentObject(n).action = "delete"),
          supportPaymentTypePromotions && null != s && "" != s)
        )
          for (var o = 0; o < a.length; o++)
            if (this.retrievePaymentObject(n).piId == a[o]) {
              this.retrievePaymentObject(n).action = "re-add";
              break;
            }
      }
    else this.retrievePaymentObject(1).action = "add";
    !supportPaymentTypePromotions ||
      ("Y" !=
        this.getValue(document.forms.PaymentForm1, "valueFromProfileOrder") &&
        "PayInStore" !=
          this.getValue(document.forms.PaymentForm1, "payMethodId")) ||
      (requestSubmitted
        ? (this.updatePaymentTypePromotionForProfileCheckoutHandler =
            wcTopic.subscribe("requestSubmittedChanged", function (e) {
              e ||
                (CheckoutPayments.updatePaymentTypePromotionForProfileCheckoutHandler.remove(),
                CheckoutPayments.updateUnboundPaymentToOrder());
            }))
        : this.updateUnboundPaymentToOrder());
  },
  initializePaymentObject: function (e) {
    var t = new Array();
    (t.piId = ""),
      (t.action = ""),
      (t.fields = new Array()),
      (t.options = ""),
      this.storePaymentObject(e, t);
  },
  storePaymentObject: function (e, t) {
    this.paymentObjects[e] = t;
  },
  retrievePaymentObject: function (e) {
    return this.paymentObjects[e];
  },
  updatePaymentObject: function (e, t) {
    var r = this.retrievePaymentObject(e);
    if (null != r) {
      if (
        (console.debug(t + " was changed."),
        "" == r.piId
          ? ((r.action = "add"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 'add'."
            ))
          : "piAmount" == t &&
            "add" != r.action &&
            "delete" != r.action &&
            "re-add" != r.action
          ? ((r.action = "update"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 'update'."
            ))
          : ((r.action = "re-add"),
            console.debug(
              "The action property in the payment object associated with payment area " +
                e +
                " was updated to 're-add'."
            )),
        "piAmount" == t)
      ) {
        for (var s = !1, a = 0; a < r.fields.length; a++)
          if (r.fields[a] == t) {
            s = !0;
            break;
          }
        s || r.fields.push(t);
      }
    } else
      console.debug(
        "CheckoutPayemnts.updatePaymentObject -- payment object not found."
      );
  },
  setPaymentsToDelete: function (e) {
    this.paymentsToDelete.push(e);
  },
  getPaymentsToDelete: function () {
    return this.paymentsToDelete;
  },
  setPaymentsToAdd: function (e) {
    this.paymentsToAdd.push(e);
  },
  getPaymentsToAdd: function () {
    return this.paymentsToAdd;
  },
  setPaymentsToUpdate: function (e) {
    this.paymentsToUpdate.push(e);
  },
  getPaymentsToUpdate: function () {
    return this.paymentsToUpdate;
  },
  deletePaymentInstructions: function () {
    var e = [];
    if (((e.piId = new Array()), this.getPaymentsToDelete().length > 0)) {
      var t = this.getPaymentsToDelete().pop();
      e.piId.push(document.forms["PaymentForm" + t].piId.value),
        (e.storeId = this.storeId),
        (e.catalogId = this.catalogId),
        (e.paymentAreaNumber = t),
        (e.langId = this.langId),
        null != document.forms.PaymentForm1.authToken &&
          (e.authToken = document.forms.PaymentForm1.authToken.value),
        (e.orderId = ".");
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxDeletePaymentInstructionFromThisOrder", e));
  },
  addPaymentInstructions: function () {
    var e = [];
    if (this.getPaymentsToAdd().length > 0) {
      var t = this.getPaymentsToAdd().pop(),
        r = document.forms["PaymentForm" + t];
      e = this.populateProtocolData(r, e);
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxAddPaymentInstructionToThisOrder", e));
  },
  updatePaymentInstructions: function () {
    var e = [];
    if (this.getPaymentsToUpdate().length > 0) {
      var t = this.getPaymentsToUpdate().pop(),
        r = document.forms["PaymentForm" + t],
        s = this.retrievePaymentObject(t);
      s.fields.push("storeId"),
        s.fields.push("catalogId"),
        s.fields.push("langId"),
        s.fields.push("piId"),
        s.fields.push("payMethodId"),
        s.fields.push("authToken"),
        s.fields.push("orderId"),
        (document.forms["PaymentForm" + t].paymentDataEditable.value = !1),
        s.fields.push("paymentDataEditable"),
        (e = this.populateProtocolDataForGivenFields(r, e, s.fields));
    }
    submitRequest() &&
      (cursor_wait(),
      wcService.invoke("AjaxUpdatePaymentInstructionInThisOrder", e));
  },
  reinitializePaymentObjects: function (e) {
    supportPaymentTypePromotions && this.updateUnboundPaymentToOrder();
    var t = parseInt(e.value),
      r = parseInt(this.prevNumberOfPaymentMethods),
      s = parseInt(this.maxNumberOfPaymentMethodsSupported);
    if (r > t)
      for (var a = t + 1; s >= a; a++) {
        var i = this.retrievePaymentObject(a);
        "" == i.piId
          ? (i.action = "")
          : ((i.action = "delete"),
            console.debug(
              "The action in the payment object associated with payment area " +
                a +
                " was updated to 'delete'."
            ));
      }
    else if (t > r)
      for (var a = r + 1; s >= a; a++) {
        var i = this.retrievePaymentObject(a);
        "" != i.piId
          ? a > t && s >= a
            ? ("delete" == i.action,
              console.debug(
                "The action in the payment object associated with payment area " +
                  a +
                  " was updated to 'delete'."
              ))
            : ("re-add" == i.action,
              console.debug(
                "The action in the payment object associated with payment area " +
                  a +
                  " was updated to 're-add'."
              ))
          : (this.initializePaymentObject(a),
            console.debug(
              "A new payment object was initialized to be associated with payment area " +
                a +
                "."
            ));
      }
    this.prevNumberOfPaymentMethods = t;
  },
  setPaymentFormPiId: function (e, t) {
    var r = document.forms["PaymentForm" + e];
    r && (r.piId.value = t);
  },
  updateUnboundPaymentToOrder: function (e) {
    this.currentPaymentMethodChanged = e;
    var t = document.forms.PaymentForm1,
      r = this.getValue(t, "piId");
    if (null != r && "" != r) {
      var s = [];
      if (
        ((s.storeId = this.storeId),
        (s.catalogId = this.catalogId),
        (s.langId = this.langId),
        (s.orderId = "."),
        (s.piId = ""),
        !submitRequest())
      )
        return;
      cursor_wait(),
        wcService.invoke("AjaxDeleteUnboundPaymentInstructionFromThisOrder", s);
    } else
      this.isSinglePaymentType()
        ? this.addNewUnboundPaymentInstruction()
        : e &&
          (this.loadPaymentSnippet(
            document.getElementById("payMethodId_" + e),
            e
          ),
          this.updatePaymentObject(e, "payMethodId"));
  },
  addNewUnboundPaymentInstruction: function () {
    var e = document.forms.PaymentForm1,
      t = [];
    if (
      ((t.storeId = this.storeId),
      (t.catalogId = this.catalogId),
      (t.langId = this.langId),
      null != document.forms.PaymentForm1.authToken &&
        (t.authToken = document.forms.PaymentForm1.authToken.value),
      (t.payMethodId = this.getValue(e, "payMethodId", !0)),
      (t.unbound = !0),
      "empty" != t.payMethodId && "" != t.payMethodId)
    ) {
      if (!submitRequest()) return;
      cursor_wait(),
        wcService.invoke("AjaxAddUnboundPaymentInstructionToThisOrder", t);
    }
  },
  isSinglePaymentType: function () {
    for (
      var e = document.forms.PaymentForm1,
        t = this.getValue(e, "payMethodId"),
        r = "empty" != t && "" != t,
        s = 2;
      r && s <= this.numberOfPaymentMethods;
      s++
    ) {
      var a = document.forms["PaymentForm" + s],
        i = this.getValue(a, "payMethodId");
      r = i == t;
    }
    return r;
  },
}),
  (PromotionChoiceOfFreeGiftsJS = {
    disableApplyButton: !1,
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    updateRewardChoices: function (e, t, r, s) {
      if (this.disableApplyButton) return !1;
      var a = [],
        i = [],
        n = [],
        o = 0;
      (a.storeId = this.storeId),
        (a.orderId = s),
        (a.rewardOptionId = r),
        CheckoutHelperJS.shoppingCartPage
          ? (a.calculationUsage = "-1,-2,-5,-6,-7")
          : (a.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      for (var d = 0; t > d; d++)
        document.getElementById("no_gifts").checked ||
          (document.getElementById("SelectFreeGift_" + (d + 1)).checked &&
            ((i[o] = document.getElementById(
              "CatalogEntryID_" + (d + 1)
            ).value),
            (n[o] = document.getElementById(
              "GiftItemQuantity_" + (d + 1)
            ).value),
            o++));
      (a.catEntryId = i),
        (a.quantity = n),
        submitRequest() &&
          (cursor_wait(),
          wcService.invoke("AjaxUpdateRewardOption", a),
          setTimeout($.proxy(this, "hidePopup", "free_gifts_popup"), 200),
          $("#free_gifts_popup").data("wc-WCDialog").close());
    },
    checkNumberOfAllowedItems: function (e) {
      var t = 1,
        r = 0;
      for (
        this.disableApplyButton = !1;
        document.getElementById("SelectFreeGift_" + t);

      )
        document.getElementById("SelectFreeGift_" + t).checked && r++, t++;
      if (r > e)
        null != document.getElementById("message") &&
          ((document.getElementById("message").className = "error"),
          (document.getElementById("message").innerHTML =
            MessageHelper.messages.PROMOTION_FREE_GIFTS_POPUP_ERROR_EXCEED_GIFT_QUANTITY)),
          (this.disableApplyButton = !0);
      else if (r > 0) {
        if (1 == r)
          var s =
            MessageHelper.messages
              .PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS_ONE;
        else {
          var s =
            MessageHelper.messages
              .PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS;
          s = s.replace(/%0/, r);
        }
        null != document.getElementById("message") &&
          ((document.getElementById("message").className = "status_message"),
          (document.getElementById("message").innerHTML = s));
      } else
        0 == r &&
          (null != document.getElementById("message") &&
            (document.getElementById("message").innerHTML = "&nbsp;"),
          (this.disableApplyButton = !0));
    },
    rewardChoicesEnabledStatus: function () {
      var e = 1;
      if (document.getElementById("no_gifts").checked)
        for (
          this.disableApplyButton = !1,
            null != document.getElementById("message") &&
              (document.getElementById("message").innerHTML = "&nbsp;");
          document.getElementById("SelectFreeGift_" + e);

        )
          (document.getElementById("SelectFreeGift_" + e).checked = !1),
            (document.getElementById("SelectFreeGift_" + e).disabled = !0),
            e++;
      else {
        for (; document.getElementById("SelectFreeGift_" + e); )
          (document.getElementById("SelectFreeGift_" + e).disabled = !1), e++;
        this.checkNumberOfAllowedItems(), this.checkFreeGiftsAvailability();
      }
    },
    showFreeGiftsDialog: function () {
      this.checkNumberOfAllowedItems(),
        $("#free_gifts_popup").data("wc-WCDialog").open(),
        this.checkFreeGiftsAvailability();
    },
    checkFreeGiftsAvailability: function () {
      for (
        var e = 1, t = 0;
        document.getElementById("OnlineAvailability_" + e);

      )
        "Available" !=
          document.getElementById("OnlineAvailability_" + e).value &&
        "Backorderable" !=
          document.getElementById("OnlineAvailability_" + e).value
          ? ((document.getElementById("SelectFreeGift_" + e).checked = !1),
            (document.getElementById("SelectFreeGift_" + e).disabled = !0))
          : t++,
          e++;
      0 == t && (this.disableApplyButton = !0);
    },
    hideFreeGiftsPopup: function (e, t) {
      if (null == t || "keypress" != t.type || t.keyCode == KeyCodes.ESCAPE) {
        var r = $("#" + e).data("wc-WCDialog");
        r && r.close();
      }
    },
  }),
  ("undefined" != typeof PunchoutJS &&
    PunchoutJS &&
    PunchoutJS.topicNamespace) ||
    (PunchoutJS = {
      divId: "",
      sameWindow: !0,
      displayPopup: function () {
        if (!$("#punchout_popup_container").length)
          return void console.debug(
            "PunchoutJS.displayPopup: element with Id punchout_popup_container was not found on the page."
          );
        $("#punchout_popup_container").show();
        var e = $("<div id='pageMask'/>").appendTo($("body"));
        $(e).css({
          position: "absolute",
          "z-index": 949,
          top: "0px",
          left: "0px",
          width: $("body").innerWidth() + "px",
          height: $("body").innerHeight() + "px",
          background: "#000",
          opacity: "0.40",
        }),
          setTimeout("$('#punchout_popup_close_icon').focus()", 1e3);
      },
      handleResponse: function (e) {
        var t = this.divId,
          r = this.sameWindow,
          s = document.getElementById(t),
          a = s.innerHTML.replace(/(^\s*)|(\s*$)/g, ""),
          i = a.toLowerCase();
        if (0 !== i.indexOf("<form") && 0 !== i.indexOf("&lt;form")) {
          0 !== i.indexOf("<a") && 0 !== i.indexOf("&lt;a")
            ? (s.innerHTML = '<a name="punchout_anchor" href="' + a + '" />')
            : (s.innerHTML = a);
          var n = s.childNodes[0];
          r
            ? (window.location = n.href)
            : ((n.target = "_blank"), window.open(n.href));
        } else {
          s.innerHTML = a;
          var o = s.childNodes[0];
          (o.name = "punchout_form"),
            r ? o.submit() : ((o.target = "_blank"), o.submit());
        }
      },
      pay: function (e, t, r, s, a) {
        (this.divId = s),
          (this.sameWindow = a),
          (params = []),
          (params.storeId = e),
          (params.orderId = t),
          (params.piId = r);
        var i = document.forms.punchoutPaymentRedirectForm_AuthTokenInfo,
          n = i.punchoutPaymentRedirect_authToken.value;
        (params.authToken = n),
          submitRequest() &&
            (cursor_wait(), wcService.invoke("AjaxPunchoutPay", params));
      },
      handleKeyPress: function (e) {
        e.keyCode !== KeyCodes.TAB &&
          e.keyCode !== KeyCodes.SHIFT &&
          location.reload();
      },
      focusElement: function (e) {
        $("#" + e).length ||
          console.debug(
            "PunchoutJS.focusElement: element with Id " +
              e +
              " was not found on the page."
          ),
          $("#" + e).focus();
      },
    }),
  (ShipmodeSelectionExtJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    BOPISEnabled: !1,
    orderItemId: "",
    isPickUpInStore: function () {
      var e = this.getShipTypeValue();
      return "pickUp" == e ? !0 : !1;
    },
    getShipTypeValue: function () {
      if (void 0 != document.BOPIS_FORM)
        for (var e = 0; e < document.BOPIS_FORM.shipType.length; e++)
          if (document.BOPIS_FORM.shipType[e].checked)
            return document.BOPIS_FORM.shipType[e].value;
    },
    getShipTypeValueFromCookieForOrder: function (e) {
      var t = getCookie("WC_shipTypeValueOrderId");
      if (t == e) {
        var r = getCookie("WC_shipTypeValue");
        return r;
      }
      return "";
    },
    setShipTypeValueToCookieForOrder: function (e, t) {
      var r = e;
      if (null != r && "undefined" != r && "" != r) {
        var s = getCookie("WC_shipTypeValueOrderId");
        s != t &&
          (setCookie("WC_shipTypeValueOrderId", null, {
            expires: -1,
          }),
          setCookie("WC_shipTypeValueOrderId", t, {
            path: "/",
            domain: cookieDomain,
          }));
        var a = this.getShipTypeValueFromCookieForOrder(t);
        r != a &&
          (setCookie("WC_shipTypeValue", null, {
            expires: -1,
          }),
          setCookie("WC_shipTypeValue", r, {
            path: "/",
            domain: cookieDomain,
          }));
      }
      "pickUp" == r
        ? document.getElementById("scheduling_options") &&
          ((document.getElementById("scheduling_options").style.display =
            "none"),
          setCookie("WC_recurringOrder_" + t, "false", {
            path: "/",
            domain: cookieDomain,
          }),
          document.getElementById("recurringOrder") &&
            (document.getElementById("recurringOrder").checked = !1),
          this.hideShowNonRecurringOrderMsg(t))
        : "shopOnline" == r &&
          document.getElementById("scheduling_options") &&
          ((document.getElementById("scheduling_options").style.display =
            "block"),
          this.hideShowNonRecurringOrderMsg(t));
    },
    displaySavedShipmentTypeForOrder: function (e) {
      var t = getCookie("WC_shipTypeValueOrderId");
      if (t != e)
        setCookie("WC_shipTypeValueOrderId", null, {
          expires: -1,
        }),
          setCookie("WC_shipTypeValue", null, {
            expires: -1,
          });
      else {
        var r = this.getShipTypeValueFromCookieForOrder(e);
        "pickUp" == r
          ? 0 == document.getElementById("shipTypePickUp").disabled
            ? ((document.getElementById("shipTypePickUp").checked = !0),
              document.getElementById("scheduling_options") &&
                ((document.getElementById("scheduling_options").style.display =
                  "none"),
                setCookie("WC_recurringOrder_" + e, "false", {
                  path: "/",
                  domain: cookieDomain,
                }),
                document.getElementById("recurringOrder") &&
                  (document.getElementById("recurringOrder").checked = !1)))
            : ((document.getElementById("shipTypeOnline").checked = !0),
              document.getElementById("scheduling_options") &&
                (document.getElementById("scheduling_options").style.display =
                  "block"),
              this.setShipTypeValueToCookieForOrder("shopOnline", e))
          : "shopOnline" == r &&
            ((document.getElementById("shipTypeOnline").checked = !0),
            document.getElementById("scheduling_options") &&
              (document.getElementById("scheduling_options").style.display =
                "block"));
      }
      this.hideShowNonRecurringOrderMsg(e, !0);
    },
    hideShowNonRecurringOrderMsg: function (e, t) {
      if (
        ((document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          document.getElementById("shipTypeOnline") &&
          document.getElementById("shipTypeOnline").checked) ||
        (document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          null == document.getElementById("shipTypeOnline"))
          ? setCookie("WC_recurringOrder_" + e, "true", {
              path: "/",
              domain: cookieDomain,
            })
          : setCookie("WC_recurringOrder_" + e, "false", {
              path: "/",
              domain: cookieDomain,
            }),
        document.getElementById("nonRecurringOrderItems") &&
          "" != document.getElementById("nonRecurringOrderItems").value)
      ) {
        if (
          document.getElementById("nonRecurringOrderItemsCount") &&
          document.getElementById("numOrderItemsInOrder")
        ) {
          var r = document.getElementById("numOrderItemsInOrder").value,
            s = document.getElementById("nonRecurringOrderItemsCount").value;
          if (r == s && document.getElementById("scheduling_options"))
            return (
              (document.getElementById("scheduling_options").style.display =
                "none"),
              setCookie("WC_recurringOrder_" + e, "false", {
                path: "/",
                domain: cookieDomain,
              }),
              void (
                document.getElementById("recurringOrder") &&
                (document.getElementById("recurringOrder").checked = !1)
              )
            );
        }
        for (
          var a = document.getElementById("nonRecurringOrderItems").value,
            i = a.split(","),
            n = 0;
          n < i.length;
          n++
        )
          document.getElementById("nonRecurringItem_" + i[n]) &&
            ((document.getElementById("recurringOrder") &&
              document.getElementById("recurringOrder").checked &&
              document.getElementById("shipTypeOnline") &&
              document.getElementById("shipTypeOnline").checked) ||
            (document.getElementById("recurringOrder") &&
              document.getElementById("recurringOrder").checked &&
              null == document.getElementById("shipTypeOnline"))
              ? (document.getElementById(
                  "nonRecurringItem_" + i[n]
                ).style.display = "block")
              : (document.getElementById(
                  "nonRecurringItem_" + i[n]
                ).style.display = "none"));
        ((document.getElementById("recurringOrder") &&
          document.getElementById("recurringOrder").checked &&
          document.getElementById("shipTypeOnline") &&
          document.getElementById("shipTypeOnline").checked &&
          !t) ||
          (document.getElementById("recurringOrder") &&
            document.getElementById("recurringOrder").checked &&
            null == document.getElementById("shipTypeOnline") &&
            !t)) &&
          MessageHelper.displayErrorMessage(
            MessageHelper.messages.RECURRINGORDER_ERROR
          );
      }
    },
    registeredUserContinue: function (e, t) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      if (submitRequest())
        if (this.isBOPISEnabled() && this.isPickUpInStore())
          document.location.href = appendWcCommonRequestParameters(t);
        else {
          var r =
              ("RESTOrderItemUpdate?remerge=***&check=*n&allocate=***&backorder=***&calculationUsage=-1,-2,-3,-4,-5,-6,-7&calculateOrder=1&orderItemId=" +
                this.orderItemId +
                "&errorViewName=AjaxOrderItemDisplayView&orderId=.&URL=",
              []),
            s = "AjaxRESTOrderItemUpdate",
            a = [];
          (a.remerge = "***"),
            (a.check = "*n"),
            (a.allocate = "***"),
            (a.backorder = "***"),
            (a.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
            (a.calculateOrder = "1"),
            (a.orderItemId = this.orderItemId),
            (a.orderId = "."),
            (a.storeId = this.storeId),
            r.push({
              URL: e,
              requestType: "GET",
              requestParams: {},
            });
          var i = getCustomServiceForURLChaining(s, r, null);
          i.invoke(a);
        }
    },
    guestShopperContinue: function (e, t) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      if (submitRequest()) {
        var r = [];
        if (this.isBOPISEnabled() && this.isPickUpInStore()) {
          var s = $("#existingPaymentInstructionId").val();
          if ("" != s) {
            for (var a = s.split(","), i = 1; i < a.length; i++)
              r.push({
                URL: "AjaxRESTOrderPIDelete",
                requestParams: {
                  piId: a[i],
                },
              });
            r.push({
              URL: t,
              requestType: "GET",
            });
            var n = [];
            n.piId = a[0];
            var o = getCustomServiceForURLChaining(
              "AjaxRESTOrderPIDelete",
              r,
              null
            );
            o.invoke(n);
          } else document.location.href = t;
        } else {
          var n = [];
          (n.remerge = "***"),
            (n.check = "*n"),
            (n.allocate = "***"),
            (n.backorder = "***"),
            (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
            (n.calculateOrder = "1"),
            (n.orderItemId = this.orderItemId),
            (n.orderId = "."),
            (n.storeId = this.storeId);
          var r = [];
          r.push({
            URL: e,
            requestType: "GET",
            requestParams: {
              guestChkout: "1",
            },
          });
          var o = getCustomServiceForURLChaining(
            "AjaxRESTOrderItemUpdate",
            r,
            null
          );
          o.invoke(n);
        }
      }
    },
    guestShopperLogon: function (e, t, r) {
      if (CheckoutHelperJS.getFieldDirtyFlag())
        return void MessageHelper.displayErrorMessage(
          MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
        );
      var s = "";
      (s = this.isBOPISEnabled() && this.isPickUpInStore() ? r : t),
        (document.AjaxLogon.URL.value = s),
        (document.location.href = e);
    },
    updateCartWithQuickCheckoutProfile: function (e) {
      if (this.isBOPISEnabled() && this.isPickUpInStore())
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.message_QUICK_CHKOUT_ERR
        );
      else {
        if (CheckoutHelperJS.getFieldDirtyFlag())
          return void MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERROR_UPDATE_FIRST_SHOPPING_CART
          );
        CheckoutHelperJS.setCommonParameters(
          this.langId,
          this.storeId,
          this.catalogId
        ),
          CheckoutHelperJS.updateCartWithQuickCheckoutProfile(e);
      }
    },
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setOrderItemId: function (e) {
      this.orderItemId = e;
    },
    setBOPISEnabled: function (e) {
      this.BOPISEnabled = e;
    },
    isBOPISEnabled: function () {
      return this.BOPISEnabled;
    },
    submitStoreSelectionForm: function (e) {
      var t = PhysicalStoreCookieJSStore.getPickUpStoreIdFromCookie();
      null != t && "" != t
        ? ((e.physicalStoreId.value = t), processAndSubmitForm(e))
        : null != document.getElementById("storeSelection_NextButton")
        ? MessageHelper.formErrorHandleClient(
            document.getElementById("storeSelection_NextButton"),
            MessageHelper.messages.message_NO_STORE
          )
        : MessageHelper.displayErrorMessage(
            MessageHelper.messages.message_NO_STORE
          );
    },
    submitAddressForm: function (e, t, r) {
      var s = document.forms[e];
      "" != t && AddressHelper.setStateDivName(t);
      var a = !1;
      $("#payInStorePaymentOption").is(":checked") && (a = !0);
      var i = [],
        n = [];
      if (r)
        var o = null,
          d = null;
      else if (AddressHelper.validateAddressForm(s))
        var o = $(s).attr("action"),
          d = s.id;
      var l = $("#existingPaymentInstructionId").val();
      if ("" != l) {
        var c = l.split(",");
        if (null == o) {
          var o = "AjaxRESTOrderPIDelete";
          n.piId = c[0];
        } else
          i.push({
            URL: "AjaxRESTOrderPIDelete",
            requestParams: {
              piId: c[0],
            },
          });
        for (var u = 1; u < c.length; u++)
          i.push({
            URL: "AjaxRESTOrderPIDelete",
            requestParams: {
              piId: c[u],
            },
          });
      }
      var m = [];
      (m.remerge = "***"),
        (m.check = "*n"),
        (m.allocate = "***"),
        (m.backorder = "***"),
        (m.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (m.calculateOrder = "1"),
        (m.orderItemId = this.orderItemId),
        (m.orderId = "."),
        (m.storeId = this.storeId),
        null == o
          ? ((o = "AjaxRESTOrderItemUpdate"), (n = m))
          : i.push({
              URL: "AjaxRESTOrderItemUpdate",
              requestParams: m,
            }),
        i.push({
          URL: "DOMOrderShippingBillingView",
          requestType: "GET",
          requestParams: {
            payInStore: a,
          },
        });
      var g = getCustomServiceForURLChaining(o, i, d);
      g.invoke(n);
    },
  }),
  (SBControllersDeclarationJS = {
    singlePageCheckout: !0,
    shipChargeEnabled: !1,
    setRefreshURL: function (e, t) {
      $("#" + e).attr("refreshurl", t);
    },
    setSinglePageCheckout: function (e) {
      this.singlePageCheckout = e;
    },
    isSinglePageCheckout: function () {
      return this.singlePageCheckout;
    },
    setShipChargeEnabled: function (e) {
      this.shipChargeEnabled = e;
    },
  }),
  (SBServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    singlePageCheckout: !0,
    orderPrepare: !1,
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setSinglePageCheckout: function (e) {
      this.singlePageCheckout = e;
    },
    isSinglePageCheckout: function () {
      return this.singlePageCheckout;
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAddAndDeleteFromCart",
    actionId: "AjaxInterestItemAddAndDeleteFromCart",
    url: "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), CheckoutHelperJS.deleteFromCart(e.orderItemId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipMethodUpdate",
    actionId: "OrderItemAddressShipMethodUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderShipChargeUpdate",
    actionId: "AjaxOrderShipChargeUpdate",
    url: "AjaxShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.orderId = "."),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        wcService.invoke("AjaxPrepareOrderForShipChargeUpdate", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForShipChargeUpdate",
    actionId: "AjaxPrepareOrderForShipChargeUpdate",
    url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipInstructionsUpdate",
    actionId: "OrderItemAddressShipInstructionsUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = [];
      if (
        ((t.orderId = "."),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        null != document.getElementById("shipInstructions"))
      ) {
        var r = document.getElementById("shipInstructions").value,
          s = document.getElementById("orderItem_1").value;
        (t.shipInstructions = r),
          (t.orderItemId = s),
          wcService.invoke("OrderItemAddressShipInstructionsUpdate1", t);
      } else MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipInstructionsUpdate1",
    actionId: "OrderItemAddressShipInstructionsUpdate1",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderItemAddressShipMethodUpdate1",
    actionId: "OrderItemAddressShipMethodUpdate1",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t = CheckoutHelperJS.storeId,
        r = CheckoutHelperJS.catalogId,
        s = CheckoutHelperJS.langId,
        a = e.orderId,
        i = document.getElementById("orderItem_1").value,
        n = document.getElementById("commonShipModeId").value;
      if (null != n && "undefined" != n) var o = n;
      else var o = document.getElementById("MS_ShippingMode_" + i).value;
      var d = [],
        l = "AjaxRESTOrderShipInfoUpdate",
        c = [];
      (c.remerge = "***"),
        (c.check = "*n"),
        (c.allocate = "***"),
        (c.backorder = "***"),
        (c.storeId = t),
        (c.catalogId = r),
        (c.langId = s),
        (c.orderId = a),
        (c.shipModeId = o),
        (c.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (c.calculateOrder = "1");
      var u = document.getElementById("purchase_order_number");
      if (u) {
        var m = u.value;
        null != m && "undefined" != m && "" != m && (c.purchaseorder_id = m);
      }
      (valueFromProfileOrderElement =
        document.getElementsByName("valueFromProfileOrder")[0] &&
        "Y" == valueFromProfileOrderElement.value) &&
        (c.quickCheckoutProfileForPayment = "true"),
        d.push({
          URL: "OrderShippingBillingView",
          requestType: "GET",
          requestParams: {},
        });
      var g = getCustomServiceForURLChaining(l, d, null);
      g.invoke(c);
    },
    failureHandler: function (e) {
      "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.ERROR_SWITCH_SINGLE_SHIPMENT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItemsAddressId",
    actionId: "AjaxUpdateOrderItemsAddressId",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        (CheckoutHelperJS.orderItemIds = []),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddBillingAddressInCheckOut",
    actionId: "AddBillingAddressInCheckOut",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        }),
        "" != this.formId &&
          document.getElementById(this.formId) &&
          (e.addBillingAddressInCheckOutAddressType = document.getElementById(
            this.formId
          ).addressType.value);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "UpdateBillingAddressInCheckout",
    actionId: "UpdateBillingAddressInCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        wcRenderContext.updateRenderContext("contextForMainAndAddressDiv", {
          showArea: "mainContents",
          hideArea: "editAddressContents",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderShippingInfoUpdate",
    actionId: "OrderShippingInfoUpdate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderBeforeSubmit",
    actionId: "AjaxPrepareOrderBeforeSubmit",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.getTotalInJSON("OrderPrepare", "PaymentForm", !1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderBeforePaymentCapture",
    actionId: "AjaxPrepareOrderBeforePaymentCapture",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      CheckoutPayments.setCommonParameters(
        SBServicesDeclarationJS.langId,
        SBServicesDeclarationJS.storeId,
        SBServicesDeclarationJS.catalogId
      ),
        CheckoutPayments.showBillingPage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetAddressIdOfOrderItems",
    actionId: "AjaxSetAddressIdOfOrderItems",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?orderId=" +
        (e.orderId ? e.orderId : ".") +
        "&langId=" +
        e.langId +
        "&storeId=" +
        e.storeId +
        "&catalogId=" +
        e.catalogId +
        "&showRegTag=T";
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetShipModeIdForOrder",
    actionId: "AjaxSetShipModeIdForOrder",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?langId=" +
        SBServicesDeclarationJS.langId +
        "&storeId=" +
        SBServicesDeclarationJS.storeId +
        "&catalogId=" +
        SBServicesDeclarationJS.catalogId;
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetRequestedShipDateForOrder",
    actionId: "AjaxSetRequestedShipDateForOrder",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingView?orderId=" +
        (e.orderId ? e.orderId : ".") +
        "&langId=" +
        SBServicesDeclarationJS.langId +
        "&storeId=" +
        SBServicesDeclarationJS.storeId +
        "&catalogId=" +
        SBServicesDeclarationJS.catalogId +
        "&showRegTag=T";
      document.location.href = appendWcCommonRequestParameters(t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        (document.getElementById(
          "OrderShippingBillingErrorArea"
        ).style.display = "block"),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    actionId: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      "" != this.formId &&
        (e.originalServiceId = document.getElementById(
          this.formId
        ).originalServiceId.value),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    actionId: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      "" != this.formId &&
        (e.originalServiceId = document.getElementById(
          this.formId
        ).originalServiceId.value),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeletePaymentInstructionFromThisOrder",
    actionId: "AjaxDeletePaymentInstructionFromThisOrder",
    url: "AjaxRESTOrderPIDelete",
    formId: "",
    successHandler: function (e) {
      var t = CheckoutPayments.retrievePaymentObject(e.paymentAreaNumber);
      if (
        ("undefined" != typeof t && (t.piId = ""),
        cursor_clear(),
        CheckoutPayments.getPaymentsToDelete().length < 1)
      )
        if ((cursor_clear(), CheckoutPayments.getPaymentsToAdd().length > 0))
          CheckoutPayments.addPaymentInstructions();
        else if (CheckoutPayments.getPaymentsToUpdate().length > 0)
          CheckoutPayments.updatePaymentInstructions();
        else {
          if (!submitRequest()) return;
          cursor_wait(),
            CheckoutPayments.setCommonParameters(
              SBServicesDeclarationJS.langId,
              SBServicesDeclarationJS.storeId,
              SBServicesDeclarationJS.catalogId
            ),
            CheckoutPayments.showSummaryPage(),
            cursor_clear();
        }
      else CheckoutPayments.deletePaymentInstructions();
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToDelete = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddPaymentInstructionToThisOrder",
    actionId: "AjaxAddPaymentInstructionToThisOrder",
    url: "AjaxRESTOrderPIAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
      if (CheckoutPayments.getPaymentsToAdd().length < 1) {
        if (CheckoutPayments.getPaymentsToUpdate().length > 0) {
          CheckoutPayments.updatePaymentInstructions();
        } else {
          if (!submitRequest()) {
            return;
          }

          //setCurrentId('singleOrderSummary');
          resetRequest();
          //showLoadingInternal(true,'shippingBillingPageNext');
          CheckoutHelperJS.checkoutOrder(
            CheckoutHelperJS.getSavedParameter("tempOrderId"),
            CheckoutHelperJS.getSavedParameter("tempUserType"),
            CheckoutHelperJS.getSavedParameter("tempEmailAddresses"),
            CheckoutHelperJS.getSavedParameter("tempIsQuote")
          );
        }
      } else {
        CheckoutPayments.addPaymentInstructions();
      }
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToAdd = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear(),
        supportPaymentTypePromotions &&
          1 == CheckoutPayments.numberOfPaymentMethods &&
          CheckoutPayments.addNewUnboundPaymentInstruction();
    },
  }),
  wcService.declare({
    id: "AjaxUpdatePaymentInstructionInThisOrder",
    actionId: "AjaxUpdatePaymentInstructionInThisOrder",
    url: "AjaxRESTOrderPIUpdate",
    formId: "",
    successHandler: function (e) {
      if ((cursor_clear(), CheckoutPayments.getPaymentsToUpdate().length < 1)) {
        if (!submitRequest()) return;
        cursor_wait(),
          CheckoutPayments.setCommonParameters(
            SBServicesDeclarationJS.langId,
            SBServicesDeclarationJS.storeId,
            SBServicesDeclarationJS.catalogId
          ),
          CheckoutPayments.showSummaryPage(),
          cursor_clear();
      } else CheckoutPayments.updatePaymentInstructions();
    },
    failureHandler: function (e) {
      (CheckoutPayments.paymentsToUpdate = new Array()),
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddUnboundPaymentInstructionToThisOrder",
    actionId: "AjaxAddUnboundPaymentInstructionToThisOrder",
    url: "AjaxRESTOrderPIAdd",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.setPaymentFormPiId(1, e.paymentInstruction[0].piId),
        (CheckoutPayments.paymentObjects[1].piId =
          e.paymentInstruction[0].piId),
        (CheckoutPayments.paymentObjects[1].action = "re-add");
      var t = [];
      (t.orderId = e.orderId),
        (t.storeId = CheckoutHelperJS.storeId),
        (t.catalogId = CheckoutHelperJS.catalogId),
        (t.langId = CheckoutHelperJS.langId),
        cursor_wait(),
        wcService.invoke("AjaxPrepareOrderForPaymentSubmit", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    actionId: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
    url: "AjaxRESTOrderPIDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
      for (var t = 1; t < CheckoutPayments.paymentObjects.length; t++)
        $("#account1_" + t).length &&
          (CheckoutPayments.removeCreditCardNumberAndCVV(t, !0, !0),
          CheckoutHelperJS.paymentDataDirty(t, !0)),
          CheckoutPayments.setPaymentFormPiId(t, ""),
          (CheckoutPayments.paymentObjects[t].piId = ""),
          t > CheckoutPayments.numberOfPaymentMethods
            ? (CheckoutPayments.paymentObjects[t].action = "")
            : (CheckoutPayments.paymentObjects[t].action = "add");
      if (CheckoutPayments.isSinglePaymentType())
        CheckoutPayments.addNewUnboundPaymentInstruction();
      else {
        var r = [];
        (r.orderId = e.orderId),
          (r.storeId = CheckoutHelperJS.storeId),
          (r.catalogId = CheckoutHelperJS.catalogId),
          (r.langId = CheckoutHelperJS.langId),
          cursor_wait(),
          wcService.invoke("AjaxPrepareOrderForPaymentSubmit", r);
      }
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForPaymentSubmit",
    actionId: "AjaxPrepareOrderForPaymentSubmit",
    url: "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        CheckoutPayments.getTotalInJSON(
          "loadPaymentSnippet",
          "PaymentForm",
          !0
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  flowEnabled.SideBySideIntegration &&
    ((CallCenterIntegrationJS = function () {
      (this.lookUpMode = "lookup"),
        (this.normalMode = "normal"),
        (this.setUpCookies = function (e) {
          var t = "WCC_Mode_" + WCParamJS.storeId;
          void 0 != e &&
            null != e &&
            (e.length > 0
              ? setCookie("WCC_Mode_" + WCParamJS.storeId, escapeXml(e, !0), {
                  path: "/",
                  domain: cookieDomain,
                })
              : removeCookie(t));
        }),
        (this.updateWCParamJS = function (e, t) {
          WCParamJS[e] = t;
        }),
        (this.consumeAddToCartEvent = function (e, t) {
          var r = getCookie("WCC_Mode_" + WCParamJS.storeId);
          return r == this.lookUpMode
            ? ((e.action = "Sending_Product"),
              $.extend(e, t),
              (e = JSON.stringify(e)),
              console.debug(e),
              window.parent.postMessage(e, WCParamJS.wcc_integration_origin),
              !0)
            : !1;
        }),
        (this.postActionMessage = function (e, t) {
          var r = getCookie("WCC_Mode_" + WCParamJS.storeId);
          return r == this.lookUpMode || r == this.normalMode
            ? ((e.action = t),
              (e = JSON.stringify(e)),
              window.parent.postMessage(e, WCParamJS.wcc_integration_origin),
              !0)
            : void 0;
        }),
        window.addEventListener("message", function (e) {
          if (e.origin != WCParamJS.wcc_integration_origin)
            return void console.warn(
              "Unexpected WCC Integration server - " + e.origin
            );
          try {
            console.debug(e.data);
            var t = JSON.parse(e.data);
            if (t.action && "Requesting_Cart_Details" === t.action) {
              var r = getCookie("WC_CartOrderId_" + WCParamJS.storeId),
                s = {};
              (s.storeId = WCParamJS.storeId),
                (s.action = "Sending_Cart"),
                (s.custId = WCParamJS.logonId),
                (s.orderId = r),
                e.source.postMessage(JSON.stringify(s), e.origin);
            } else t.action && "ADD_TO_EXTERNAL_CART_SUCCESS" === t.action ? cursor_clear() : t.action && "TERMINATE_ON_BEHALF_SESSION" === t.action ? "undefined" != typeof GlobalLoginShopOnBehalfJS && void 0 != GlobalLoginShopOnBehalfJS && null != GlobalLoginShopOnBehalfJS && GlobalLoginShopOnBehalfJS.restoreCSRSessionAndRedirect(t.redirectURL) : t.action && "SET_USER_IN_SESSION" === t.action && "undefined" != typeof registeredCustomersJS && void 0 != registeredCustomersJS && null != registeredCustomersJS && registeredCustomersJS.setUserInSession(t.userId, t.userName, t.redirectURL);
          } catch (a) {
            console.warn("Unexpected message: " + e.data);
          }
        });
    }),
    $(document).ready(function () {
      callCenterIntegrationJS = new CallCenterIntegrationJS();
    })),
  (shoppingActionsJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    userType: "",
    baseItemAddedToCart: !1,
    entitledItems: [],
    entitledItemJsonObject: null,
    selectedAttributesList: {},
    moreInfoUrl: "",
    isPopup: !1,
    displayPriceRange: !0,
    itemPriceJsonOject: [],
    allSwatchesArrayList: {},
    skuImageId: "",
    cookieKeyPrefix: "CompareItems_",
    cookieDelimiter: ";",
    maxNumberProductsAllowedToCompare: 4,
    minNumberProductsAllowedToCompare: 2,
    baseCatalogEntryId: 0,
    selectedProducts: {},
    productList: {},
    currencySymbol: "",
    compareReturnName: "",
    searchTerm: "",
    search01: "'",
    search02: '"',
    replaceStr01: /\\\'/g,
    replaceStr02: /\\\"/g,
    ampersandChar: /&/g,
    ampersandEntityName: "&amp;",
    productAddedList: {},
    setCompareReturnName: function (e) {
      this.compareReturnName = e;
    },
    setSearchTerm: function (e) {
      this.searchTerm = e;
    },
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.userType = s),
        (this.currencySymbol = a);
    },
    setEntitledItems: function (e) {
      this.entitledItems = e;
    },
    getCatalogEntryId: function (e) {
      var t = [],
        r = this.selectedAttributesList[e];
      for (attribute in r) t.push(attribute + "_|_" + r[attribute]);
      return this.resolveSKU(t);
    },
    getCatalogEntryIdforProduct: function (e) {
      var t = [];
      for (attribute in e) t.push(attribute + "_|_" + e[attribute]);
      return this.resolveSKU(t);
    },
    getEntitledItemJsonObject: function () {
      return this.entitledItemJsonObject;
    },
    resolveSKU: function (e) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var t = "",
        r = e.length;
      if (1 == this.entitledItems.length)
        return this.entitledItems[0].catentry_id;
      for (x in this.entitledItems) {
        var t = this.entitledItems[x].catentry_id,
          s = this.entitledItems[x].Attributes,
          a = 0;
        for (index in s) a++;
        if (0 == r && 0 == a) return t;
        if (0 != a && r >= a) {
          var i = 0;
          for (attributeName in e) {
            var n = e[attributeName],
              o = n.replace(this.search02, this.search01);
            (n in s || o in s) && i++;
          }
          if (a == i)
            return (
              console.debug("CatEntryId:" + t + " for Attribute: " + e),
              this.disableBuyButtonforUnbuyable(x),
              t
            );
        }
      }
      return null;
    },
    setSelectedAttribute: function (e, t, r, s, a) {
      console.debug(e + " : " + t);
      var i = this.selectedAttributesList[r];
      null == i && (i = {}),
        (t = t.replace(this.replaceStr01, this.search01)),
        (t = t.replace(this.replaceStr02, this.search02)),
        (t = t.replace(this.ampersandChar, this.ampersandEntityName)),
        (i[e] = t),
        (this.moreInfoUrl = this.moreInfoUrl + "&" + e + "=" + t),
        (this.selectedAttributesList[r] = i),
        this.changeProdImage(r, e, t, s, a);
    },
    setSelectedAttributeOfProduct: function (
      productId,
      selectedAttributeName,
      selectedAttributeValue,
      isSingleSKU
    ) {
      var selectedAttributesForProduct = null;
      (selectedAttributesForProduct = this.selectedProducts[productId]
        ? this.selectedProducts[productId]
        : {}),
        null != selectedAttributeName &&
          "" != selectedAttributeName &&
          (selectedAttributesForProduct[selectedAttributeName] =
            selectedAttributeValue),
        (this.selectedProducts[productId] = selectedAttributesForProduct);
      var entitledItemJSON = eval(
        "(" + $("#entitledItem_" + productId).html() + ")"
      );
      this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryIdforProduct(
        selectedAttributesForProduct
      );
      if (null == catalogEntryId) catalogEntryId = 0;
      else if (
        (this.changePrice("entitledItem_" + productId, !1, !0, productId),
        "undefined" != typeof MerchandisingAssociationJS &&
          null != MerchandisingAssociationJS.baseItemParams &&
          "BundleBean" == MerchandisingAssociationJS.baseItemParams.type)
      )
        for (
          idx = 0;
          idx < MerchandisingAssociationJS.baseItemParams.components.length;
          idx++
        )
          productId ==
            MerchandisingAssociationJS.baseItemParams.components[idx]
              .productId &&
            (MerchandisingAssociationJS.baseItemParams.components[idx].id =
              catalogEntryId);
      var productDetails = null;
      this.productList[productId]
        ? (productDetails = this.productList[productId])
        : ((productDetails = {}),
          (this.productList[productId] = productDetails),
          (productDetails.baseItemId = productId)),
        (productDetails.id = catalogEntryId),
        productDetails.quantity &&
          wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails)),
        isSingleSKU ||
          (0 != catalogEntryId
            ? wcTopic.publish(
                "DefiningAttributes_Resolved_" + productId,
                catalogEntryId,
                productId
              )
            : wcTopic.publish(
                "DefiningAttributes_Changed_" + productId,
                catalogEntryId,
                productId
              ));
    },
    Add2ShopCartAjax: function (
      entitledItemId,
      quantity,
      isPopup,
      customParams
    ) {
      var dialog = $("#quick_cart_container").data("wc-WCDialog");
      if ((dialog && dialog.close(), browseOnly))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var entitledItemJSON;
      (entitledItemJSON = $("#" + entitledItemId).length
        ? eval("(" + $("#" + entitledItemId).html() + ")")
        : this.getEntitledItemJsonObject()),
        this.setEntitledItems(entitledItemJSON);
      var catalogEntryId = this.getCatalogEntryId(entitledItemId);
      if (null != catalogEntryId) {
        var productId = entitledItemId.substring(
          entitledItemId.indexOf("_") + 1
        );
        this.AddItem2ShopCartAjax(
          catalogEntryId,
          quantity,
          customParams,
          productId
        ),
          (this.baseItemAddedToCart = !0);
      } else
        1 == isPopup
          ? ($("#second_level_category_popup").css("zIndex", "1"),
            MessageHelper.formErrorHandleClient(
              "addToCartLinkAjax",
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            ))
          : (MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            ),
            (this.baseItemAddedToCart = !1));
    },
    AddItem2ShopCartAjax: function (e, t, r, s) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var a = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        orderId: ".",
      };
      (a.inventoryValidation = "true"), (a.calculateOrder = "0");
      var i = "AddOrderItem";
      if (((this.productAddedList = {}), Array.isArray(e) && Array.isArray(t)))
        for (var n = 0; n < e.length; n++) {
          if (!isPositiveInteger(t[n]))
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
            );
          (a["catEntryId_" + (n + 1)] = e[n]),
            (a["quantity_" + (n + 1)] = t[n]);
        }
      else {
        if (!isPositiveInteger(t))
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
          );
        (a.catEntryId = e), (a.quantity = t);
        var o = {};
        for (attr in this.selectedAttributesList["entitledItem_" + s])
          o[attr] = this.selectedAttributesList["entitledItem_" + s][attr];
        void 0 == s
          ? this.saveAddedProductInfo(t, e, e, o)
          : this.saveAddedProductInfo(t, s, e, o);
      }
      if (null != r && "undefined" != r) {
        for (n in r) a[n] = r[n];
        "dynamicKit" == r.catalogEntryType && (i = "AddPreConfigurationToCart");
      }
      var d = document.getElementsByName("contractSelectForm_contractId");
      if (null != d && "undefined" != d)
        for (n = 0; n < d.length; n++)
          if (d[n].checked) {
            a.contractId = d[n].value;
            break;
          }
      submitRequest() &&
        (cursor_wait(),
        wcService.invoke(i, a),
        (this.baseItemAddedToCart = !0),
        document.getElementById("headerShopCartLink") &&
        "none" != document.getElementById("headerShopCartLink").style.display
          ? $("#headerShopCart").focus()
          : $("#headerShopCart1").focus());
    },
    AddBundle2ShopCartAjax: function () {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("ERROR_ADD2CART_BROWSE_ONLY")
        );
      var e = "AddOrderItem",
        t = {
          storeId: this.storeId,
          catalogId: this.catalogId,
          langId: this.langId,
          orderId: ".",
          inventoryValidation: "true",
          calculateOrder: "0",
        },
        r = 1;
      this.productAddedList = {};
      for (productId in this.productList) {
        var s = this.productList[productId],
          a = Utils.parseNumber(s.quantity);
        if (0 != a) {
          if (0 == s.id)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("ERR_RESOLVING_SKU")
            );
          if (isNaN(a) || 0 > a)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
            );
          (t["catEntryId_" + r] = s.id),
            (t["quantity_" + r++] = a),
            (this.baseItemAddedToCart = !0),
            this.saveAddedProductInfo(
              a,
              productId,
              s.id,
              this.selectedProducts[productId]
            );
        }
      }
      submitRequest() && (cursor_wait(), wcService.invoke(e, t));
    },
    resetProductAddedList: function () {
      shoppingActionsJS.productAddedList = {};
    },
    saveAddedProductInfo: function (e, t, r, s) {
      var a = "";
      $("#ProductInfoName_" + t).length
        ? (a = document.getElementById("ProductInfoName_" + t).value)
        : $("#ProductInfoName_" + r).length &&
          (a = document.getElementById("ProductInfoName_" + r).value);
      var i = "";
      $("#ProductInfoImage_" + t).length
        ? (i = document.getElementById("ProductInfoImage_" + t).value)
        : $("#ProductInfoImage_" + r).length &&
          (i = document.getElementById("ProductInfoImage_" + r).value);
      var n = "";
      $("#ProductInfoPrice_" + t).length
        ? (n = document.getElementById("ProductInfoPrice_" + t).value)
        : $("#ProductInfoPrice_" + r).length &&
          (n = document.getElementById("ProductInfoPrice_" + r).value);
      var o = [a, i, n, e, s];
      t != r ? (this.productAddedList[r] = o) : (this.productAddedList[t] = o),
        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },
    setSKUImageId: function (e) {
      this.skuImageId = e;
    },
    getImageForSKU: function (e, t) {
      var r = [],
        s = this.selectedAttributesList[e];
      for (attribute in s) r.push(attribute + "_|_" + s[attribute]);
      return this.resolveImageForSKU(r, t);
    },
    resolveImageForSKU: function (e, t) {
      console.debug("Resolving SKU >> " + e + ">>" + this.entitledItems);
      var r = "",
        s = e.length;
      for (x in this.entitledItems) {
        if (null != t) var r = this.entitledItems[x][t];
        else var r = this.entitledItems[x].ItemImage467;
        var a = this.entitledItems[x].Attributes,
          i = 0;
        for (index in a) i++;
        if (0 == s && 0 == i) return r;
        if (0 != i && s >= i) {
          var n = 0;
          for (attributeName in e) {
            var o = e[attributeName];
            o in a && n++;
          }
          if (i == n) {
            console.debug("ItemImage:" + r + " for Attribute: " + e),
              this.disableBuyButtonforUnbuyable(x);
            var d = [];
            return (
              d.push(r),
              d.push(this.entitledItems[x].ItemThumbnailImage),
              null != this.entitledItems[x].ItemAngleThumbnail &&
                void 0 != this.entitledItems[x].ItemAngleThumbnail &&
                (d.push(this.entitledItems[x].ItemAngleThumbnail),
                d.push(this.entitledItems[x].ItemAngleFullImage)),
              d
            );
          }
        }
      }
      return null;
    },
    disableBuyButtonforUnbuyable: function (e) {
      var t = this.entitledItems[e].buyable,
        r = document.getElementById(
          "listViewAdd2Cart_" + this.entitledItems[e].productId
        );
      null != t &&
        null != r &&
        ("false" == t
          ? (r.className += " add2CartButtonDisabled")
          : (r.className = r.className.replace(" add2CartButtonDisabled", "")));
    },
    changeViewImages: function (e, t) {
      var r = 0;
      for (x in e) {
        var s = r;
        r++,
          $("#WC_CachedProductOnlyDisplay_images_1_" + r).attr("src", e[x]),
          $("#WC_CachedProductOnlyDisplay_links_1_" + r).length &&
            $("#WC_CachedProductOnlyDisplay_links_1_" + r).attr(
              "href",
              "JavaScript:changeThumbNail('productAngleLi" +
                s +
                "','" +
                t[x] +
                "');"
            ),
          $("#productAngleLi" + s).length &&
            "selected" === $("#productAngleLi" + s).attr("className") &&
            changeThumbNail("productAngleLi" + s, t[x]);
      }
    },
    changeProdImage: function (
      entitledItemId,
      swatchAttrName,
      swatchAttrValue,
      skuImageId,
      imageField
    ) {
      $("#" + entitledItemId).length &&
        (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON);
      var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1),
        skuImage = null,
        imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
      if (
        (null != imageArr && (skuImage = imageArr[0]),
        void 0 != skuImageId && this.setSKUImageId(skuImageId),
        null != skuImage)
      ) {
        if ($("#" + this.skuImageId).length) {
          (document.getElementById(this.skuImageId).src = skuImage),
            $("#ProductInfoImage_" + productId).length &&
              (document.getElementById("ProductInfoImage_" + productId).value =
                skuImage);
          var itemAngleThumbnail = imageArr[2],
            itemAngleFullImage = imageArr[3];
          null != itemAngleThumbnail &&
            void 0 != itemAngleThumbnail &&
            shoppingActionsJS.changeViewImages(
              itemAngleThumbnail,
              itemAngleFullImage
            );
        }
      } else {
        var imageFound = !1;
        for (x in this.entitledItems) {
          var Attributes = this.entitledItems[x].Attributes;
          if (null != imageField)
            var itemImage = this.entitledItems[x][imageField];
          else var itemImage = this.entitledItems[x].ItemImage467;
          var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail,
            itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;
          for (y in Attributes) {
            var index = y.indexOf("_|_"),
              entitledSwatchName = y.substring(0, index),
              entitledSwatchValue = y.substring(index + 3);
            if (
              entitledSwatchName == swatchAttrName &&
              entitledSwatchValue == swatchAttrValue
            ) {
              $("#" + this.skuImageId).length &&
                ($("#" + this.skuImageId).attr("src", itemImage),
                null !=
                  document.getElementById("ProductInfoImage_" + productId) &&
                  (document.getElementById(
                    "ProductInfoImage_" + productId
                  ).value = itemImage)),
                null != itemAngleThumbnail &&
                  void 0 != itemAngleThumbnail &&
                  shoppingActionsJS.changeViewImages(
                    itemAngleThumbnail,
                    itemAngleFullImage
                  ),
                (imageFound = !0);
              break;
            }
          }
          if (imageFound) break;
        }
      }
    },
    updateSwatchListView: function () {
      for (
        var swatchArray = $("a[id^='swatch_array_']"), i = 0;
        i < swatchArray.length;
        i++
      ) {
        var swatchArrayElement = swatchArray[i];
        eval($(swatchArrayElement).attr("href"));
      }
      for (
        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']"), i = 0;
        i < swatchSkuImage.length;
        i++
      ) {
        var swatchSkuImageElement = swatchSkuImage[i];
        eval($(swatchSkuImageElement).attr("href"));
      }
      for (
        var swatchDefault = $("a[id^='swatch_selectDefault_']"), i = 0;
        i < swatchDefault.length;
        i++
      ) {
        var swatchDefaultElement = swatchDefault[i];
        eval($(swatchDefaultElement).attr("href"));
      }
    },
    selectSwatch: function (e, t, r, s, a, i, n) {
      if (!$("#swatch_" + r + "_" + t).hasClass("color_swatch_disabled")) {
        var o = this.selectedAttributesList[r];
        for (attribute in o) {
          if (attribute == e && o[attribute] != t) {
            var d = document.getElementById("swatch_" + r + "_" + o[attribute]);
            (d.className = "color_swatch"),
              (d.src = d.src.replace("_disabled.png", "_enabled.png")),
              (document.getElementById(
                "swatch_link_" + r + "_" + o[attribute]
              ).title = d.alt);
          }
          null !=
            document.getElementById("swatch_link_" + r + "_" + o[attribute]) &&
            document
              .getElementById("swatch_link_" + r + "_" + o[attribute])
              .setAttribute("aria-checked", "false");
        }
        this.makeSwatchSelection(e, t, r, s, a, i, n);
      }
    },
    makeSwatchSelection: function (e, t, r, s, a, i, n) {
      this.setSelectedAttribute(e, t, r, i, n),
        (document.getElementById("swatch_" + r + "_" + t).className =
          "color_swatch_selected"),
        document
          .getElementById("swatch_link_" + r + "_" + t)
          .setAttribute("aria-checked", "true"),
        (document.getElementById(
          "swatch_selection_label_" + r + "_" + e
        ).className = "header color_swatch_label"),
        "none" ==
          document.getElementById("swatch_selection_" + r + "_" + e).style
            .display &&
          (document.getElementById(
            "swatch_selection_" + r + "_" + e
          ).style.display = "inline"),
        null != a
          ? (document.getElementById(
              "swatch_selection_" + r + "_" + e
            ).innerHTML = a)
          : (document.getElementById(
              "swatch_selection_" + r + "_" + e
            ).innerHTML = t),
        this.updateSwatchImages(e, r, s, n);
    },
    addToAllSwatchsArray: function (e, t, r, s, a) {
      var i = this.allSwatchesArrayList[s];
      if ((null == i && (i = []), !this.existInAllSwatchsArray(e, t, i))) {
        var n = [];
        (n[0] = e),
          (n[1] = t),
          (n[2] = r),
          (n[4] = document.getElementById(
            "swatch_link_" + s + "_" + t
          ).onclick),
          (n[5] = null),
          (n[6] = a),
          i.push(n),
          (this.allSwatchesArrayList[s] = i);
      }
    },
    existInAllSwatchsArray: function (e, t, r) {
      for (var s = 0; s < r.length; s++) {
        var a = r[s][0],
          i = r[s][1];
        if (a == e && i == t) return !0;
      }
      return !1;
    },
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
      0 == this.entitledItems.length &&
        ($("#" + entitledItemId).length &&
          (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON));
      for (x in this.entitledItems) {
        var Attributes = this.entitledItems[x].Attributes;
        for (y in Attributes) {
          var index = y.indexOf("_|_"),
            swatchName = y.substring(0, index),
            swatchValue = y.substring(index + 3);
          this.makeSwatchSelection(
            swatchName,
            swatchValue,
            entitledItemId,
            doNotDisable,
            null,
            imageField
          );
        }
        break;
      }
    },
    updateSwatchImages: function (e, t, r, s) {
      for (
        var a = [],
          i = this.selectedAttributesList[t],
          n = i[e],
          o = this.allSwatchesArrayList[t],
          d = 0;
        d < o.length;
        d++
      ) {
        var l = o[d][0],
          c = o[d][1],
          u = o[d][2],
          m = (o[d][3], o[d][4]),
          g = o[d][6];
        if (l != r && l != e) {
          var p = [];
          (p[0] = l),
            (p[1] = c),
            (p[2] = u),
            (p[4] = m),
            (p[5] = !1),
            (p[6] = g),
            a.push(p);
        }
      }
      for (x in this.entitledItems) {
        var h = this.entitledItems[x].Attributes;
        for (y in h) {
          var I = y.indexOf("_|_"),
            f = y.substring(0, I),
            S = y.substring(I + 3);
          if (f == e && S == n)
            for (z in h) {
              var v = z.indexOf("_|_"),
                _ = z.substring(0, v),
                C = z.substring(v + 3);
              if (y != z)
                for (d in a) {
                  var A = a[d][0],
                    E = a[d][1];
                  _ == A && C == E && (a[d][5] = !0);
                }
            }
        }
      }
      var b = [];
      for (d in a) {
        var A = a[d][0],
          E = a[d][1],
          M = (a[d][2], a[d][3], a[d][4]),
          O = a[d][5];
        if (O) {
          if (
            "color_swatch_selected" !=
            document.getElementById("swatch_" + t + "_" + E).className
          ) {
            var R = document.getElementById("swatch_" + t + "_" + E);
            (R.className = "color_swatch"),
              (R.src = R.src.replace("_disabled.png", "_enabled.png")),
              (document.getElementById("swatch_link_" + t + "_" + E).title =
                R.alt);
          }
          document
            .getElementById("swatch_link_" + t + "_" + E)
            .setAttribute("aria-disabled", "false"),
            (document.getElementById("swatch_link_" + t + "_" + E).onclick = M);
        } else if (A != r) {
          var R = document.getElementById("swatch_" + t + "_" + E),
            P = document.getElementById("swatch_link_" + t + "_" + E);
          (R.className = "color_swatch_disabled"),
            (P.onclick = null),
            (R.src = R.src.replace("_enabled.png", "_disabled.png"));
          Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [R.alt]);
          document
            .getElementById("swatch_link_" + t + "_" + E)
            .setAttribute("aria-disabled", "true"),
            i[A] == E && b.push(a[d]);
        }
      }
      for (d in b) {
        var T = b[d][0],
          D = b[d][1];
        for (d in a) {
          var A = a[d][0],
            E = a[d][1],
            w = a[d][6],
            O = a[d][5];
          if (A == T && E != D && O) {
            this.makeSwatchSelection(A, E, t, r, w, s);
            break;
          }
        }
      }
    },
    changePrice: function (
      entitledItemId,
      isPopup,
      displayPriceRange,
      productId
    ) {
      (this.displayPriceRange = displayPriceRange), (this.isPopup = isPopup);
      var entitledItemJSON;
      entitledItemJSON =
        $("#" + entitledItemId).length && !this.isPopup
          ? eval("(" + $("#" + entitledItemId).html() + ")")
          : this.getEntitledItemJsonObject();
      var catalogEntryId = null;
      if (
        (this.setEntitledItems(entitledItemJSON),
        this.selectedProducts[productId])
      )
        var catalogEntryId = this.getCatalogEntryIdforProduct(
          this.selectedProducts[productId]
        );
      else var catalogEntryId = this.getCatalogEntryId(entitledItemId);
      if (null != catalogEntryId)
        if (
          null != this.itemPriceJsonOject[catalogEntryId] &&
          "undefined" != this.itemPriceJsonOject[catalogEntryId]
        )
          this.displayPrice(
            this.itemPriceJsonOject[catalogEntryId].catalogEntry,
            productId
          ),
            console.debug(
              "ShoppingActions.changePrice: using stored json object."
            );
        else {
          var parameters = {
            storeId: this.storeId,
            langId: this.langId,
            catalogId: this.catalogId,
            catalogEntryId: catalogEntryId,
            productId: productId,
          };
          wcService.declare({
            id: "getCatalogEntryDetailsSA",
            actionId: "getCatalogEntryDetailsSA",
            url:
              getAbsoluteURL() +
              appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
            formId: "",
            successHandler: function (e, t) {
              shoppingActionsJS.displayPriceServiceResponse(e, t);
            },
            failureHandler: function (e, t) {
              console.debug(
                "ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request."
              );
            },
          }),
            wcService.invoke("getCatalogEntryDetailsSA", parameters);
        }
      else
        console.debug(
          "ShoppingActions.changePrice: all attributes are not selected."
        );
    },
    displayPriceServiceResponse: function (e, t) {
      var r = t.productId;
      (shoppingActionsJS.itemPriceJsonOject[
        e.catalogEntry.catalogEntryIdentifier.uniqueID
      ] = e),
        shoppingActionsJS.displayPrice(e.catalogEntry, r);
    },
    displayPrice: function (e, t) {
      var r,
        s = shoppingActionsJS.isPopup;
      if (
        (1 == s &&
          ($("#productPrice").html(e.offerPrice),
          (document.getElementById("productName").innerHTML =
            e.description[0].name),
          (document.getElementById("productSKUValue").innerHTML =
            e.catalogEntryIdentifier.externalIdentifier.partNumber)),
        0 == s)
      ) {
        var a = "",
          i = Utils.parseNumber(e.listPrice),
          n = Utils.parseNumber(e.offerPrice);
        if (
          (this.setPriceInProductList(t, n),
          (a =
            !e.listPriced || n >= i
              ? "<span id='offerPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='price'>" +
                e.offerPrice +
                "</span>"
              : "<span id='listPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='old_price'>" +
                e.listPrice +
                "</span><span id='offerPrice_" +
                e.catalogEntryIdentifier.uniqueID +
                "' class='price'>" +
                e.offerPrice +
                "</span>"),
          (document.getElementById("price_display_" + t).innerHTML =
            a +
            "<input type='hidden' id='ProductInfoPrice_" +
            e.catalogEntryIdentifier.uniqueID +
            "' value='" +
            e.offerPrice +
            "'/>"),
          (a = ""),
          1 == shoppingActionsJS.displayPriceRange)
        )
          for (var o in e.priceRange)
            e.priceRange[o].endingNumberOfUnits ==
            e.priceRange[o].startingNumberOfUnits
              ? ((r = Utils.getLocalizationMessage("PQ_PRICE_X", {
                  0: e.priceRange[o].startingNumberOfUnits,
                })),
                (a = a + "<p>" + r))
              : "null" != e.priceRange[o].endingNumberOfUnits
              ? ((r = Utils.getLocalizationMessage("PQ_PRICE_X_TO_Y", {
                  0: e.priceRange[o].startingNumberOfUnits,
                  1: e.priceRange[o].endingNumberOfUnits,
                })),
                (a = a + "<p>" + r))
              : ((r = Utils.getLocalizationMessage("PQ_PRICE_X_OR_MORE", {
                  0: e.priceRange[o].startingNumberOfUnits,
                })),
                (a = a + "<p>" + r)),
              (a =
                a +
                " <span class='price'>" +
                e.priceRange[o].localizedPrice +
                "</span></p>");
        var d = document.getElementById("productLevelPriceRange_" + t),
          l = document.getElementById("itemLevelPriceRange_" + t);
        null != d && null == l
          ? (d.style.display = "")
          : "" != a && null != l
          ? ((a = Utils.getLocalizationMessage("PQ_PURCHASE") + a),
            (l.innerHTML = a),
            (l.style.display = ""),
            null != d && (d.style.display = "none"))
          : "" == a &&
            (null != l && (l.style.display = "none"),
            null != d && (d.style.display = ""));
        var c = $("#product_name_" + t + " > a");
        1 == c.length
          ? $(c[0]).html(e.description[0].name)
          : $("#product_name_" + t) &&
            $("#product_name_" + t).html(e.description[0].name),
          $("#widget_product_info_viewer > div[id^='PageHeading_']").length &&
            $("#widget_product_info_viewer > div[id^='PageHeading_']").each(
              function (t, r) {
                null != r.childNodes &&
                  3 == r.childNodes.length &&
                  (r.childNodes[1].innerHTML = e.description[0].name);
              }
            ),
          null != document.getElementById("ProductInfoName_" + t) &&
            (document.getElementById("ProductInfoName_" + t).value =
              e.description[0].name),
          document.getElementById("product_shortdescription_" + t) &&
            (document.getElementById(
              "product_shortdescription_" + t
            ).innerHTML = e.description[0].shortDescription),
          document.getElementById("product_SKU_" + t) &&
            (document.getElementById("product_SKU_" + t).innerHTML =
              Utils.getLocalizationMessage("SKU") +
              " " +
              e.catalogEntryIdentifier.externalIdentifier.partNumber);
      }
    },
    showWCDialogPopup: function (e) {
      var t = $("#" + e).data("wc-WCDialog");
      t
        ? (t.open(), $("#" + e).css("display", "block"))
        : console.debug(e + " does not exist");
    },
    notifyAttributeChange: function (e) {
      this.baseCatalogEntryId = e;
      this.selectedAttributesList["entitledItem_" + e];
      wcTopic.publish("DefiningAttributes_Resolved_" + e, e, -1);
    },
    notifyQuantityChange: function (e) {
      wcTopic.publish("Quantity_Changed", e);
    },
    initCompare: function (e) {
      if ("compare" == e || "catalogEntryList" == e) this.checkForCompare();
      else {
        var t = this.cookieKeyPrefix + this.storeId,
          r = "";
        setCookie(t, r, {
          path: "/",
          domain: cookieDomain,
        });
      }
    },
    changeCompareBox: function (e, t) {
      (box = document.getElementById(e)),
        (box.checked = !box.checked),
        this.addOrRemoveFromCompare(t, box.checked);
    },
    addOrRemoveFromCompare: function (e, t) {
      t ? this.addToCompare(e) : this.removeFromCompare(e);
    },
    addToCompare: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t);
      if (null != r && (-1 != r.indexOf(e) || null == e))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS")
        );
      var s = 0;
      if (
        (null != r && "" !== r && (s = r.split(this.cookieDelimiter).length),
        s < parseInt(this.maxNumberProductsAllowedToCompare))
      ) {
        var a = "";
        (a = null == r || "" === r ? e : r + this.cookieDelimiter + e),
          setCookie(t, a, {
            path: "/",
            domain: cookieDomain,
          }),
          shoppingActionsJS.checkForCompare();
      } else
        this.showWCDialogPopup("widget_product_comparison_popup"),
          (document.getElementById("comparebox_" + e).checked = !1),
          console.debug("You can only compare up to 4 products");
    },
    removeFromCompare: function (e) {
      var t = this.cookieKeyPrefix + this.storeId,
        r = getCookie(t),
        s = 0;
      if (null != r) {
        if ("" == r.trim())
          setCookie(t, null, {
            expires: -1,
          });
        else {
          var a = r.split(this.cookieDelimiter),
            i = "";
          for (index in a)
            a[index] != e &&
              (i = "" === i ? a[index] : i + this.cookieDelimiter + a[index]);
          setCookie(t, i, {
            path: "/",
            domain: cookieDomain,
          }),
            (s = i.split(this.cookieDelimiter).length);
        }
        shoppingActionsJS.checkForCompare();
      }
    },
    compareProducts: function (e, t) {
      var r = appendWcCommonRequestParameters(
        "CompareProductsDisplayView?storeId=" +
          this.storeId +
          "&catalogId=" +
          this.catalogId +
          "&langId=" +
          this.langId +
          "&compareReturnName=" +
          encodeURIComponent(this.compareReturnName) +
          "&searchTerm=" +
          this.searchTerm
      );
      "" != e.top_category && (r = r + "&top_category=" + e.top_category),
        "" != e.parent_category_rn &&
          (r = r + "&parent_category_rn=" + e.parent_category_rn),
        "" != e.categoryId && (r = r + "&categoryId=" + e.categoryId),
        void 0 != t && "" != t && (r = r + "&manufacturer=" + t);
      var s = this.cookieKeyPrefix + this.storeId,
        a = getCookie(s);
      null != a && "" != a.trim() && (r = r + "&catentryId=" + a);
      var i = appendWcCommonRequestParameters(location.href);
      -1 === i.indexOf("?")
        ? (i += "?fromPage=compare")
        : -1 === i.indexOf("fromPage=compare") && (i += "&fromPage=compare"),
        (r = r + "&returnUrl=" + encodeURIComponent(i)),
        (location.href = getAbsoluteURL() + r);
    },
    setProductQuantity: function (e, t, r, s) {
      var a = null;
      this.productList[t]
        ? (a = this.productList[t])
        : ((a = {}),
          (this.productList[t] = a),
          (a.baseItemId = t),
          "item" == e ? (a.id = t) : (a.id = 0)),
        (a.quantity = r),
        wcTopic.publish("Quantity_Changed", JSON.stringify(a)),
        (a.price = Utils.parseNumber(s));
    },
    quantityChanged: function (e, t) {
      if (this.productList[e]) {
        var r = this.productList[e];
        if (
          ((r.quantity = t.trim()),
          wcTopic.publish("Quantity_Changed", JSON.stringify(r)),
          null != MerchandisingAssociationJS &&
            null != MerchandisingAssociationJS.baseItemParams &&
            "BundleBean" == MerchandisingAssociationJS.baseItemParams.type)
        )
          for (
            idx = 0;
            idx < MerchandisingAssociationJS.baseItemParams.components.length;
            idx++
          )
            (e ==
              MerchandisingAssociationJS.baseItemParams.components[idx]
                .productId ||
              e ==
                MerchandisingAssociationJS.baseItemParams.components[idx].id) &&
              (MerchandisingAssociationJS.baseItemParams.components[
                idx
              ].quantity = r.quantity);
      }
    },
    setPriceInProductList: function (e, t) {
      var r = this.productList[e];
      r && (r.price = t);
    },
    selectBundleItemSwatch: function (e, t, r, s) {
      if (
        !$("#swatch_" + e + "_" + t + "_" + r).hasClass("color_swatch_disabled")
      ) {
        if ($("#entitledItem_" + e).length) {
          var a,
            i = t + "_" + r;
          a = JSON.stringify($("#entitledItem_" + e).html());
          var n = [];
          for (idx in a) {
            var o = !1,
              d = a[idx];
            for (attribute in d.Attributes)
              if (i == attribute) {
                o = !0;
                break;
              }
            if (o)
              for (attribute in d.Attributes) {
                var l = attribute.substring(0, attribute.lastIndexOf("_|_"));
                l != s && l != t && n.push(attribute);
              }
          }
          var c = [],
            u = [];
          for (idx in a) {
            var d = a[idx];
            for (attribute in d.Attributes) {
              var l = attribute.substring(0, attribute.lastIndexOf("_|_"));
              if (l != s && l != t) {
                var m = "swatch_" + e + "_" + attribute,
                  g = m.replace("swatch_", "swatch_link_");
                if (n.indexOf(attribute) > -1)
                  $("#" + m).hasClass("color_swatch_selected") ||
                    ((document.getElementById(m).className = "color_swatch"),
                    (document.getElementById(m).src = document
                      .getElementById(m)
                      .src.replace("_disabled.png", "_enabled.png")),
                    (document.getElementById(g).title =
                      document.getElementById(m).alt),
                    document
                      .getElementById(g)
                      .setAttribute("aria-disabled", "false"));
                else if (-1 === c.indexOf(attribute)) {
                  c.push(attribute),
                    $("#" + m).hasClass("color_swatch_selected") && u.push(m),
                    (document.getElementById(m).className =
                      "color_swatch_disabled"),
                    (document.getElementById(m).src = document
                      .getElementById(m)
                      .src.replace("_enabled.png", "_disabled.png"));
                  var p = document.getElementById(m).alt;
                  Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [p]);
                  $("#" + g).attr("aria-disabled", "true");
                }
              }
              null !=
                document.getElementById("swatch_link_" + e + "_" + attribute) &&
                document
                  .getElementById("swatch_link_" + e + "_" + attribute)
                  .setAttribute("aria-checked", "false");
            }
          }
          for (idx in u) {
            var h = u[idx],
              I = h.substring(0, h.lastIndexOf("_|_")),
              y = !1;
            $("[id^='" + I + "']").each(function (e, t, r) {
              if (!y && $(t).hasClass("color_swatch")) {
                var a = t.id.split("_");
                shoppingActionsJS.selectBundleItemSwatch(a[1], a[2], a[3], s),
                  shoppingActionsJS.setSelectedAttributeOfProduct(
                    a[1],
                    a[2],
                    a[3],
                    !1
                  ),
                  (y = !0);
              }
            });
          }
        }
        "none" == $("#swatch_selection_" + e + "_" + t).css("display") &&
          $("#swatch_selection_" + e + "_" + t).css("display", "inline"),
          $("#swatch_selection_" + e + "_" + t).html(r);
        var f = "swatch_" + e + "_" + t + "_",
          S = "swatch_link_" + e + "_" + t + "_";
        $("img[id^='" + f + "']").each(function (e, t, r) {
          $(t).hasClass("color_swatch_disabled")
            ? $(t).removeClass("color_swatch")
            : $(t).addClass("color_swatch"),
            $(t).removeClass("color_swatch_selected");
        }),
          $("#" + f + r).attr("className", "color_swatch_selected"),
          document.getElementById(S + r).setAttribute("aria-checked", "true"),
          this.setSelectedAttributeOfProduct(e, t, r, !1),
          this.changeBundleItemImage(e, t, r, "productThumbNailImage_" + e);
      }
    },
    changeBundleItemImage: function (
      catalogEntryId,
      swatchAttrName,
      swatchAttrValue,
      skuImageId
    ) {
      var entitledItemId = "entitledItem_" + catalogEntryId;
      $("#" + entitledItemId).length &&
        (entitledItemJSON = eval("(" + $("#" + entitledItemId).html() + ")")),
        this.setEntitledItems(entitledItemJSON);
      var skuImage = null,
        imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
      if (
        (null != imageArr && (skuImage = imageArr[1]),
        void 0 != skuImageId && this.setSKUImageId(skuImageId),
        null != skuImage)
      )
        null != $("#" + this.skuImageId) &&
          ((document.getElementById(this.skuImageId).src = skuImage),
          null !=
            document.getElementById("ProductInfoImage_" + catalogEntryId) &&
            (document.getElementById(
              "ProductInfoImage_" + catalogEntryId
            ).value = skuImage));
      else {
        var imageFound = !1;
        for (x in this.entitledItems) {
          var Attributes = this.entitledItems[x].Attributes,
            itemImage = this.entitledItems[x].ItemThumbnailImage;
          for (y in Attributes) {
            var index = y.indexOf("_|_"),
              entitledSwatchName = y.substring(0, index),
              entitledSwatchValue = y.substring(index + 3);
            if (
              entitledSwatchName == swatchAttrName &&
              entitledSwatchValue == swatchAttrValue
            ) {
              (document.getElementById(this.skuImageId).src = itemImage),
                null !=
                  document.getElementById(
                    "ProductInfoImage_" + catalogEntryId
                  ) &&
                  (document.getElementById(
                    "ProductInfoImage_" + catalogEntryId
                  ).value = itemImage),
                (imageFound = !0);
              break;
            }
          }
          if (imageFound) break;
        }
      }
    },
    getImageForBundleItem: function (e) {
      var t = [],
        r = this.selectedProducts[e];
      for (attribute in r) t.push(attribute + "_|_" + r[attribute]);
      return this.resolveImageForSKU(t);
    },
    checkForCompare: function () {
      var e = getCookie(
        shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId
      );
      e = e ? e.split(shoppingActionsJS.cookieDelimiter) : [];
      var t = $(".compareCheckboxLabels > label");
      $(".compare_target").each(function (r, s) {
        var a = $('input[type="checkbox"]', s)[0];
        a.checked = -1 !== e.indexOf(a.value);
        var i = a.checked ? (e.length > 1 ? 2 : 1) : 0;
        s.setAttribute("data-state", i.toString());
        var n = $('label[for="' + a.id + '"]', s)[0];
        $(n).html($(t[i]).html());
      });
    },
    replaceItemAjaxHelper: function (e, t, r, s, a, i) {
      var n = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        orderItemId: r,
        orderId: ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (n.calculationUsage = "-1,-2,-5,-6,-7")
        : (n.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var o = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        catEntryId: e,
        quantity: t,
        orderId: ".",
        calculateOrder: "1",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (o.calculationUsage = "-1,-2,-5,-6,-7")
        : (o.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var d = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        langId: WCParamJS.langId,
        orderId: ".",
      };
      CheckoutHelperJS.shoppingCartPage
        ? (d.calculationUsage = "-1,-2,-5,-6,-7")
        : (d.calculationUsage = "-1,-2,-3,-4,-5,-6,-7");
      var l = !1,
        c = !0;
      null != s && "" !== s && (d.addressId = s),
        null != a && "" !== a && (d.shipModeId = a),
        null != i && "" !== i && ((d.physicalStoreId = i), (c = !1)),
        null == d.shipModeId ||
          (null == d.addressId && null == d.physicalStoreId) ||
          (l = !0),
        c &&
          ((d.allocate = "***"),
          (d.backorder = "***"),
          (d.remerge = "***"),
          (d.check = "*n")),
        wcService.declare({
          id: "AjaxReplaceItem",
          actionId: "AjaxReplaceItem",
          url: "AjaxRESTOrderItemDelete",
          formId: "",
          successHandler: function (e) {
            l
              ? wcService.invoke("AjaxAddOrderItemTemp", o)
              : wcService.invoke("AjaxAddOrderItem", o);
          },
          failureHandler: function (e) {
            e.errorMessage
              ? MessageHelper.displayErrorMessage(e.errorMessage)
              : e.errorMessageKey &&
                MessageHelper.displayErrorMessage(e.errorMessageKey),
              cursor_clear();
          },
        }),
        wcService.declare({
          id: "AjaxAddOrderItemTemp",
          actionId: "AjaxAddOrderItemTemp",
          url: "AjaxRESTOrderItemAdd",
          formId: "",
          successHandler: function (e) {
            (d.orderItemId =
              null != e.orderItem && null != e.orderItem[0].orderItemId
                ? e.orderItem[0].orderItemId
                : e.orderItemId),
              MessageHelper.displayStatusMessage(
                MessageHelper.messages.SHOPCART_ADDED
              ),
              wcService.invoke("OrderItemAddressShipMethodUpdate", d);
          },
          failureHandler: function (e) {
            MessageHelper.displayErrorMessage(e.errorMessageKey);
          },
        }),
        submitRequest() &&
          (cursor_wait(), wcService.invoke("AjaxReplaceItem", n));
    },
    customizeDynamicKit: function (e, t, r) {
      var s = {
        storeId: this.storeId,
        catalogId: this.catalogId,
        langId: this.langId,
        catEntryId: e,
        quantity: t,
      };
      if (!isPositiveInteger(t))
        return void MessageHelper.displayErrorMessage(
          Utils.getLocalizationMessage("QUANTITY_INPUT_ERROR")
        );
      var a = document.getElementsByName("contractSelectForm_contractId");
      if (null != a && "undefined" != a)
        for (n = 0; n < a.length; n++)
          if (a[n].checked) {
            s.contractId = a[n].value;
            break;
          }
      if (null != r && "undefined" != r) for (n in r) s[n] = r[n];
      if (submitRequest()) {
        cursor_wait();
        var i = "ConfigureView",
          n = 0;
        for (param in s) i += (0 == n++ ? "?" : "&") + param + "=" + s[param];
        document.location.href =
          getAbsoluteURL() + appendWcCommonRequestParameters(i);
      }
    },
  }),
  wcTopic.subscribe(
    "ProductInfo_Reset",
    shoppingActionsJS.resetProductAddedList
  ),
  $(document).ready(function () {
    var e = Utils.get_IE_version();
    9 > e &&
      $(document).on(
        "click",
        '.compare_target > input[type="checkbox"]:click',
        function (e) {
          this.blur(), this.focus();
        }
      );
  }),
  (shoppingActionsServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "AddOrderItem",
    actionId: "AddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(), cursor_clear(), shoppingActionsJS)
      ) {
        var t = $('div[id^="attrValue_"]');
        if (null != $(".definingAttributes")[0])
          var t = $(".definingAttributes");
        else if (null != $(".product_sizes")[0]) var t = $(".product_sizes");
        else if (null != $(".product_info")[0]) var t = $(".product_info");
        for (var r = new Array(), s = 0; s < t.length; s++)
          for (
            var a = t[s].querySelectorAll(".dijitSelect"), i = 0;
            i < a.length;
            i++
          )
            r = r.concat(a[i]);
        for (var n = new Array(), s = 0; s < r.length; s++)
          n[s] = dijit.registry.byNode(r[s]);
        for (var o = !0, s = 0; s < n.length; s++)
          n[s].options.length > 2 && (o = !1);
        if (!o) {
          (shoppingActionsJS.selectedAttributes = new Object()),
            wcTopic.publish(
              "DefiningAttributes_Resolved_" +
                shoppingActionsJS.baseCatalogEntryId,
              shoppingActionsJS.baseCatalogEntryId,
              -1
            );
          for (var s = 0; s < n.length; s++) null != n[s] && (n[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(
          null != e.orderItem && null != e.orderItem[0].orderItemId
            ? e.orderItem[0].orderItemId
            : e.orderItemId
        ),
        wcTopic.publish("ProductAddedToCart");
    },
    failureHandler: function (e) {
      if (e.errorMessage)
        if ("_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey)
          MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          );
        else if ("_ERR_RETRIEVE_PRICE" == e.errorMessageKey) {
          var t = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {
            0: Utils.getLocalizationMessage("GENERICERR_CONTACT_US"),
          });
          MessageHelper.displayErrorMessage(t);
        } else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
          MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
        } else MessageHelper.displayErrorMessage(e.errorMessage);
      else
        e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
      e.errorCode && wcTopic.publish("OrderError", e), cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddPreConfigurationToCart",
    actionId: "AddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(), cursor_clear(), shoppingActionsJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          shoppingActionsJS.selectedAttributes = new Object();
          for (var s = 0; s < t.length; s++)
            null != t[s] && ((t[s].value = ""), t[s].onchange());
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(e.orderItem[0].orderItemId);
    },
    failureHandler: function (e) {
      if (e.errorMessage)
        if ("_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey)
          MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          );
        else if ("_ERR_RETRIEVE_PRICE" == e.errorMessageKey) {
          var t = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {
            0: Utils.getLocalizationMessage("GENERICERR_CONTACT_US"),
          });
          MessageHelper.displayErrorMessage(t);
        } else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
          MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
        } else MessageHelper.displayErrorMessage(e.errorMessage);
      else
        e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
      cursor_clear();
    },
  }),
  (CommonContextsJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setContextProperty: function (e, t, r) {
      wcRenderContext.getRenderContextProperties(e)[t] = r;
    },
  }),
  wcRenderContext.declare("multipleShipmentDetailsContext", [], {
    shipmentDetailsArea: "update",
  }),
  wcRenderContext.declare("singleShipmentShipChargeContext", [], null),
  wcRenderContext.declare("multipleShipmentShipChargeContext", [], null),
  wcRenderContext.declare("traditionalShipmentDetailsContext", [], {
    shipmentDetailsArea: "update",
  }),
  wcRenderContext.declare("currentOrder_Context", [], null),
  wcRenderContext.declare("editShippingAddressContext", [], {
    shippingAddress: "0",
    addressType: "ShippingAndBilling",
  }),
  wcRenderContext.declare("shippingAddressContext", [], {
    shippingAddress: "0",
  }),
  wcRenderContext.declare("billingAddressDropDownBoxContext", [], {
    billingAddress1: "0",
    billingAddress2: "0",
    billingAddress3: "0",
    billingURL1: "",
    billingURL2: "",
    billingURL3: "",
    areaNumber: "0",
    payment1: "",
    payment2: "",
    payment3: "",
    paymentTCId1: "",
    paymentTCId2: "",
    paymentTCId3: "",
  }),
  wcRenderContext.declare("paymentContext", [], {
    payment1: "empty",
    payment2: "empty",
    payment3: "empty",
    currentAreaNumber: "1",
    billingMode1: "none",
    billingMode2: "none",
    billingMode3: "none",
    currentTotal: "0",
  }),
  wcRenderContext.declare("contextForMainAndAddressDiv", [], {
    showArea: "0",
    hideArea: "0",
  }),
  wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {}),
  wcRenderContext.declare("CategoryDisplay_Context", [], {
    pageView: "",
    beginIndex: "",
  }),
  wcRenderContext.declare("SubCategoryDisplay_Context", [], null),
  wcRenderContext.declare("ShopCartPaginationDisplay_Context", [], {}),
  wcRenderContext.declare("PendingOrderPaginationDisplay_Context", [], {}),
  wcRenderContext.declare("PendingOrderDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("OrderItemPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("OrderDetailPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("MSOrderItemPaginationDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("CouponDisplay_Context", [], null),
  wcRenderContext.declare("PromotionFreeGifts_Context", [], {}),
  wcRenderContext.declare("ListOrdersDisplay_Context", [], {
    startNumber: "0",
  }),
  wcRenderContext.declare("ScheduledOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "Scheduled",
  }),
  wcRenderContext.declare("ProcessedOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "PreviouslyProcessed",
  }),
  wcRenderContext.declare("WaitingForApprovalOrdersStatusDisplay_Context", [], {
    beginIndex: "0",
    selectedTab: "WaitingForApproval",
  }),
  wcRenderContext.declare("BrowsingHistoryContext", [], {
    status: "init",
  }),
  wcRenderContext.declare("BrowsingHistoryDisplay_Context", [], {
    currentPage: "0",
    pageView: "",
  }),
  wcRenderContext.declare("CategorySubscriptionContext", [], null),
  wcRenderContext.declare("RecurringOrderDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("SubscriptionDisplay_Context", [], {
    beginIndex: "0",
  }),
  wcRenderContext.declare("RecentRecurringOrderDisplay_Context", [], {
    beginIndex: "0",
    isMyAccountMainPage: "true",
  }),
  wcRenderContext.declare("RecentSubscriptionDisplay_Context", [], {
    beginIndex: "0",
    isMyAccountMainPage: "true",
  }),
  wcRenderContext.declare("RecurringOrderChildOrdersDisplay_Context", [], {
    beginIndex: "0",
    orderId: "",
  }),
  wcRenderContext.declare("SubscriptionChildOrdersDisplay_Context", [], {
    beginIndex: "0",
    orderItemId: "",
    subscriptionName: "",
  }),
  wcRenderContext.declare("QuickInfoContext", ["quickInfoRefreshArea"], {}),
  wcRenderContext.declare("DiscountDetailsContext", [], null),
  wcRenderContext.declare("QuickInfoDiscountDetailsContext", [], {}),
  wcRenderContext.declare("DoubleContentAreaESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("ScrollableESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoriesESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("CategoryFeaturedProductsESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeHeroESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeLeftESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeRightTopESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("HomeRightBottomESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TallDoubleContentAreaESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoryHeroESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("TopCategoryTallDoubleESpot_Context", [], {
    emsName: "",
  }),
  wcRenderContext.declare("AttachmentPagination_Context", [], {
    beginIndex: "0",
  }),
  (CommonControllersDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    setRefreshURL: function (e, t) {
      $("#" + e).attr("refreshurl", t);
    },
    declareAccountCouponRefreshArea: function () {
      var e = $("#CouponDisplay_Widget");
      wcTopic.subscribe(
        ["AjaxCouponsAddRemove", "AjaxWalletItemProcessServiceDelete"],
        function () {
          e.refreshWidget("refresh");
        }
      ),
        e.refreshWidget();
    },
    declareShopCartDisplayRefreshArea: function () {
      var e = $("#ShopCartDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "ShopCartPaginationDisplay_Context"
        );
      wcTopic.subscribe(order_updated, function () {
        e.refreshWidget("refresh", t), submitRequest(), cursor_wait();
      });
      var r = function () {
        resetRequest(),
          null != typeof savedOrdersJS &&
            "undefined" != typeof savedOrdersJS &&
            savedOrdersJS.isCurrentOrderPage(!0),
          $("#discountDetailsSection").css("display", "block"),
          $("#appliedPromotionCodes").css("display", "block");
        var e = t.orderId;
        $("#currentOrderId").length &&
          (e = document.getElementById("currentOrderId").value),
          ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(e),
          $("#OrderFirstItemId").length &&
            (ShipmodeSelectionExtJS.orderItemId =
              document.getElementById("OrderFirstItemId").value),
          cursor_clear(),
          "function" == typeof showApplePayButtons && showApplePayButtons();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareShopCartPagingDisplayRefreshArea: function () {
      var e = $("#ShopCartPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "ShopCartPaginationDisplay_Context",
        "ShopCartPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
          "ShopCartPaginationDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "ShopCartPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
          var e = t.orderId;
          document.getElementById("currentOrderId") &&
            (e = document.getElementById("currentOrderId").value),
            ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(e),
            $('div[id^="shoppingListScript_"]').each(function (e, t) {
              $.globalEval($(t).html());
            }),
            $('input[id^="orderItem_"]').each(function (e, t) {
              null != $("addToRequisitionListScript_" + t.value) &&
                $.globalEval(
                  $("addToRequisitionListScript_" + t.value).innerHTML
                ),
                0 != $("addReqListsJS_" + t.value).length &&
                  $.globalEval(
                    "addReqListsJS" +
                      t.value +
                      '.setCatEntryId("' +
                      $("catalogId_" + t.id.substring(t.id.indexOf("_") + 1))
                        .value +
                      '");'
                  );
            });
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declarePromotionFreeGiftsDisplayRefreshArea: function () {
      var e = $("#PromotionFreeGiftsDisplay");
      wcRenderContext.addRefreshAreaId(
        "PromotionFreeGifts_Context",
        "PromotionFreeGiftsDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
          "PromotionFreeGifts_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        },
        s = function () {
          PromotionChoiceOfFreeGiftsJS.showFreeGiftsDialog();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareRecentRecurringOrderDisplayRefreshArea: function () {
      var e = $("#RecentRecurringOrderDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecentRecurringOrderDisplay_Context",
        "RecentRecurringOrderDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecentRecurringOrderDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
        cursor_clear();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareRecentSubscriptionDisplayRefreshArea: function () {
      var e = $("#RecentSubscriptionDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecentSubscriptionDisplay_Context",
        "RecentSubscriptionDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecentSubscriptionDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
        cursor_clear();
      };
      e.refreshWidget({
        postRefreshHandler: r,
      });
    },
    declareOrderItemPaginationDisplayRefreshArea: function (e) {
      ("object" == typeof e || "array" == typeof e) && (e = e[0]);
      var t = $("#" + e);
      wcRenderContext.addRefreshAreaId("OrderItemPaginationDisplay_Context", e);
      var r = wcRenderContext.getRenderContextProperties(
          "OrderItemPaginationDisplay_Context"
        ),
        s = function () {
          wcRenderContext.testForChangedRC(
            "OrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && t.refreshWidget("refresh", r);
        },
        a = function () {
          cursor_clear(),
            "true" == r.analytics &&
              wcTopic.publish(
                "order_contents_ProductRec",
                $("#orderPartNumbers").val()
              );
        };
      t.refreshWidget({
        renderContextChangedHandler: s,
        postRefreshHandler: a,
      });
    },
    declareRecurOrderDisplayRefreshArea: function () {
      var e = $("#RecurringOrderDisplay");
      wcRenderContext.addRefreshAreaId(
        "RecurringOrderDisplay_Context",
        "RecurringOrderDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "RecurringOrderDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
          wcRenderContext.testForChangedRC("RecurringOrderDisplay_Context", [
            "beginIndex",
          ]) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareRecurOrderChildOrdersRefreshArea: function () {
      var e = $("#RecurringOrderChildOrdersDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "RecurringOrderChildOrdersDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "RecurringOrderChildOrdersDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSubscriptionDisplayRefreshArea: function () {
      var e = $("#SubscriptionDisplay");
      wcRenderContext.addRefreshAreaId(
        "SubscriptionDisplay_Context",
        "SubscriptionDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "SubscriptionDisplay_Context"
      );
      wcTopic.subscribe("AjaxCancelSubscription", function () {
        e.refreshWidget("refresh", t);
      });
      var r = function () {
          wcRenderContext.testForChangedRC("SubscriptionDisplay_Context", [
            "beginIndex",
          ]) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSubscriptionChildOrdersRefreshArea: function () {
      var e = $("#SubscriptionChildOrdersDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "SubscriptionChildOrdersDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "SubscriptionChildOrdersDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareQuickInfoDetails: function () {
      var e = $("#quickInfoRefreshArea"),
        t = wcRenderContext.getRenderContextProperties("QuickInfoContext");
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          if ($("#catEntryParamsForJS").length)
            var e = $.parseJSON($("#catEntryParamsForJS").val());
          if ($("#QuickInfostoreParams").length) {
            var t = $("#QuickInfostoreParams").val(),
              r = $("#QuickInfoshoppingListNames").val();
            (shoppingListJSQuickInfo = new ShoppingListJS(
              $.parseJSON(t),
              e,
              $.parseJSON(r),
              "shoppingListJSQuickInfo"
            )),
              this.quickInfoEvenSubscribed ||
                ((this.quickInfoEvenSubscribed = !0),
                wcTopic.subscribe(
                  "DefiningAttributes_Resolved",
                  function (e, t) {
                    shoppingListJSQuickInfo.setItemId(e, t);
                  }
                ),
                wcTopic.subscribe("QuickInfo_attributesChanged", function (e) {
                  shoppingListJSQuickInfo.setCatEntryAttributes(e);
                }),
                wcTopic.subscribe("Quantity_Changed", function (e) {
                  shoppingListJSQuickInfo.setCatEntryQuantity(e);
                }),
                wcTopic.subscribe("ShoppingList_Changed", function (e) {
                  shoppingListJSQuickInfo.updateShoppingListAndAddItem(e);
                }),
                wcTopic.subscribe("ShoppingListItem_Added", function () {
                  shoppingListJSQuickInfo.deleteItemFromCart();
                }),
                $("#QuickInfoaddToShoppingListDropdown").on(
                  "mouseover",
                  function () {
                    shoppingListJSQuickInfo.mouseOnArrow = !0;
                  }
                ),
                $("#QuickInfoShoppingList_0").on("mouseover", function () {
                  (shoppingListJSQuickInfo.exceptionFlag = !0),
                    $("#QuickInfoShoppingListLink_0").focus();
                }));
            var s = e.id;
            null != s &&
              "" != s &&
              wcRenderContext.updateRenderContext(
                "QuickInfoDiscountDetailsContext",
                {
                  productId: e.id,
                }
              );
          }
          $("#catEntryParamsForJS").length &&
            (QuickInfoJS.catEntryParams = $.parseJSON(
              $("#catEntryParamsForJS").val()
            ));
          var a = $("#quickInfoPopup").data("wc-WCDialog");
          a
            ? (closeAllDialogs(),
              "" == QuickInfoJS.itemId
                ? (QuickInfoJS.setCatEntryQuantity(1),
                  QuickInfoJS.selectDefaultSwatch())
                : QuickInfoJS.selectCurrentAttributes(),
              a.open(),
              "undefined" != typeof TealeafWCJS &&
                TealeafWCJS.rebind("quickInfoPopup"))
            : console.debug("quickInfoPopup does not exist"),
            cursor_clear();
        },
      });
    },
    declareQuickInfoDiscountDetailsController: function () {
      var e = $("#quickInfoDiscountDetailsRefreshArea");
      wcRenderContext.addRefreshAreaId(
        "QuickInfoDiscountDetailsContext",
        "quickInfoDiscountDetailsRefreshArea"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "QuickInfoDiscountDetailsContext"
      );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          cursor_clear();
        },
      });
    },
    declareMSOrderItemPagingDisplayRefreshArea: function (e) {
      var t = "MSOrderItemPaginationDisplay_Context";
      "object" == typeof e && (e = e[0]);
      var r = $("#" + e);
      wcRenderContext.checkIdDefined(t) || wcRenderContext.declare(t, [], null);
      var s = wcRenderContext.getRenderContextProperties(t);
      wcRenderContext.addRefreshAreaId(t, e),
        (renderContextChangedHandler = function () {
          wcRenderContext.testForChangedRC(t, ["beginIndex"]) &&
            r.refreshWidget("refresh", s);
        }),
        (postRefreshHandler = function () {
          cursor_clear(),
            "true" == s.analytics &&
              wcTopic.publish(
                "order_contents_ProductRec",
                $("#orderPartNumbers").value
              );
        }),
        r.refreshWidget({
          renderContextChangedHandler: renderContextChangedHandler,
          postRefreshHandler: postRefreshHandler,
        });
    },
    declareSSFSOrderItemPaginationDisplayController: function () {
      var e = $("#OrderConfirmPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "OrderItemPaginationDisplay_Context",
        "OrderConfirmPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "OrderItemPaginationDisplay_Context"
      );
      e.refreshWidget({
        renderContextChangedHandler: function () {
          wcRenderContext.testForChangedRC(
            "OrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = document.getElementById("jsonOrderStr").innerHTML,
            r = t.beginIndex,
            s = t.pageSize;
          sterlingIntegrationJS.populateOrderLineInfoForSingleShipment(e, r, s),
            cursor_clear();
        },
      });
    },
    declareSSFSMSOrderItemPaginationDisplayController: function () {
      var e = $("#MSOrderDetailPagingDisplay");
      wcRenderContext.addRefreshAreaId(
        "MSOrderItemPaginationDisplay_Context",
        "MSOrderDetailPagingDisplay"
      );
      var t = wcRenderContext.getRenderContextProperties(
        "MSOrderItemPaginationDisplay_Context"
      );
      e.refreshWidget({
        renderContextChangedHandler: function () {
          wcRenderContext.testForChangedRC(
            "MSOrderItemPaginationDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = document.getElementById("jsonOrderStr").innerHTML,
            r = t.beginIndex,
            s = t.pageSize;
          sterlingIntegrationJS.populateOrderLineInfoForMultipleShipment(
            e,
            r,
            s
          ),
            cursor_clear();
        },
      });
    },
  }),
  wcService.declare({
    id: "AjaxAddPreConfigurationToCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        categoryDisplayJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          categoryDisplayJS.selectedAttributes = [];
          for (var s = 0; s < t.length; s++) null != t[s] && (t[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(e.orderItem[0].orderItemId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddPreConfigurationToCart_shopCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      var t = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
      document.location.href = t;
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var GeolocationJS = {
  showPosition: function (e) {
    void 0 !== e &&
      null != e &&
      storeLocatorJSStore.refreshResultsFromNearest(
        e.coords.latitude,
        e.coords.longitude
      );
  },
  locationError: function (e) {
    var t;
    switch (e.code) {
      case e.PERMISSION_DENIED:
        t = "LBS_ERROR_PERMISSION_DENIED";
        break;
      case e.POSITION_UNAVAILABLE:
        t = "LBS_ERROR_NO_USER_CURRENT_LOC";
        break;
      case e.TIMEOUT:
        t = "LBS_ERROR_TIMEOUT";
    }
    storeLocatorJSStore.refreshResultsWithLocationError(t);
  },
  launch: function () {
    navigator.geolocation &&
      navigator.geolocation.getCurrentPosition(
        GeolocationJS.showPosition,
        GeolocationJS.locationError,
        {
          timeout: 1e4,
          enableHighAccuracy: !0,
        }
      );
  },
};
("undefined" != typeof MessageHelper &&
  MessageHelper &&
  MessageHelper.topicNamespace) ||
  (MessageHelper = {
    messages: {},
    identifier: "",
    focusElement: "",
    getCurrentYear: function () {
      return new Date().getFullYear();
    },
    getCurrentMonth: function () {
      return new Date().getMonth() + 1;
    },
    getCurrentDay: function () {
      return new Date().getDate();
    },
    getRenderContextProperty: function (e, t) {
      if (
        (console.debug(
          "enter getRenderContextProperty with propertyName = " + t
        ),
        null == e)
      )
        return console.debug("context is null. Return null..."), null;
      var r = e.properties[t];
      return console.debug("the found property value is: " + r), r;
    },
    setMessage: function (e, t) {
      this.messages[e] = t;
    },
    setFocusElement: function (e) {
      this.focusElement = e;
    },
    showHideMessageArea: function (e) {
      cursor_clear(), (null == e || void 0 == e) && (e = 0);
      var t = $("#MessageArea");
      null !== $("#MessageArea_ACCE_Title") &&
        $("#MessageArea_ACCE_Title").css("display", "block"),
        $(t).fadeIn(200);
    },
    hideMessageArea: function () {
      cursor_clear();
      var e = "";
      "" !== this.focusElement &&
        null !== $("#" + this.focusElement) &&
        (e = $("#" + this.focusElement));
      var t = $("#MessageArea");
      null !== $("#MessageArea_ACCE_Title") &&
        $("#MessageArea_ACCE_Title").css("display", "none"),
        null != document.getElementById(e) && e.focus(),
        $(t).fadeOut(500),
        $("#ErrorMessageText").html(""),
        (this.focusElement = "");
    },
    displayErrorMessage: function (e, t, r) {
      if (
        ((null == t || void 0 == t) && (t = 0),
        (void 0 == r || null == r || 1 == r) &&
          null != this.messages.ERROR_MESSAGE_TYPE &&
          "undefined" != this.messages.ERROR_MESSAGE_TYPE)
      ) {
        var s = this.messages.ERROR_MESSAGE_TYPE;
        e = s + e;
      }
      this.setMessageAreaStyle("error_icon"),
        $("#ErrorMessageText").html(e),
        this.showHideMessageArea(t),
        $("#clickableErrorMessageImg").focus(),
        setTimeout(function () {
          null !== $("#ErrorMessageText") && $("#ErrorMessageText").focus();
        }, 1e3),
        "undefined" != typeof TealeafWCJS &&
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: "-1",
            message: e,
          });
    },
    setMessageAreaStyle: function (e) {
      $("#success_icon").css("display", "none"),
        $("#error_icon").css("display", "none"),
        null != $("#" + e) && $("#" + e).css("display", "inline");
    },
    displayStatusMessage: function (e, t) {
      (null == t || void 0 == t) && (t = 0),
        this.setMessageAreaStyle("success_icon"),
        $("#ErrorMessageText").html(e),
        this.showHideMessageArea(t),
        $("#clickableErrorMessageImg").focus(),
        setTimeout(function () {
          null !== $("#ErrorMessageText") && $("#ErrorMessageText").focus();
        }, 1e3);
    },
    hideAndClearMessage: function () {
      $("#ErrorMessageText").html(""), $("#MessageArea").css("display", "none");
    },
    adjustCoordinates: function (e) {
      if ("none" != $("#MessageArea").css("display")) {
        var t = $("#page"),
          r = $("#MessageArea");
        if (null != t && null != r) {
          var s = $(t).position(),
            a = $(t).width();
          (null == e || void 0 == e) && (e = 0),
            $(r).css({
              width: a + 20 + "px",
              left: s.left - 10 + "px",
              top: s.top + e + "px",
            });
        }
      }
    },
    formErrorHandle: function (e, t) {
      this.formErrorHandleClient(e.errorMessageParam, e.errorMessage);
    },
    formErrorHandleClient: function (e, t) {
      e.id && (e = e.id);
      var r = $("#" + e);
      if (null == t)
        return void console.debug(
          "formErrorHandleClient: The error message is null."
        );
      if (r) {
        if (Utils.has_ios())
          this.setMessageAreaStyle("error_icon"),
            $("#MessageArea").css("display", "block"),
            $("#ErrorMessageText").html(t),
            window.setTimeout(function () {
              window.scrollTo(0, 0);
            }, 0);
        else if (this.identifier != e + "_tooltip") {
          r.focus(), (this.identifier = e + "_tooltip");
          var s = document.createElement("span"),
            a = getImageDirectoryPath();
          if (
            (Utils.get_IE_version() < 7
              ? (s.innerHTML =
                  t +
                  "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" +
                  a +
                  "images/empty.gif'></iframe>")
              : (s.innerHTML = t),
            Utils.hasTouch())
          ) {
            var i = this;
            setTimeout(function () {
              var r = this;
              (this.tooltip = $(
                "<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" +
                  t +
                  "</div></div>"
              )),
                $("#" + e).after(this.tooltip),
                this.tooltip.position({
                  my: "center top",
                  at: "center bottom",
                  of: $("#" + e),
                }),
                $("#" + e).blur(function () {
                  r.tooltip && (r.tooltip.hide(), r.tooltip.remove()),
                    MessageHelper.clearCurrentIdentifier();
                });
            }, 1e3);
          } else {
            var i = this;
            (this.tooltip = $(
              "<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" +
                t +
                "</div></div>"
            )),
              $("#" + e).after(this.tooltip),
              this.tooltip.position({
                my: "center top",
                at: "center bottom",
                of: $("#" + e),
              }),
              $("#" + e).blur(function () {
                i.tooltip && (i.tooltip.hide(), i.tooltip.remove()),
                  MessageHelper.clearCurrentIdentifier();
              });
          }
        }
        "undefined" != typeof TealeafWCJS &&
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: r.id,
            message: t,
          });
      }
    },
    hideFormErrorHandle: function () {
      null != this.tooltip &&
        (this.tooltip.destroyRecursive(),
        (this.tooltip = null),
        this.clearCurrentIdentifier());
    },
    clearCurrentIdentifier: function () {
      this.identifier = "";
    },
    emptyFunc: function (e) {},
    containsDoubleByte: function (e) {
      for (var t = new String(e), r = 127, s = 0; s < t.length; s++)
        if (((chr = t.charCodeAt(s)), chr > r)) return !0;
      return !1;
    },
    isValidEmail: function (e) {
      return this.containsDoubleByte(e)
        ? !1
        : 0 == e.length
        ? !0
        : e.length < 5
        ? !1
        : e.indexOf(" ") > 0
        ? !1
        : e.indexOf("@") < 1
        ? !1
        : e.lastIndexOf(".") < e.indexOf("@") + 2
        ? !1
        : e.lastIndexOf(".") >= e.length - 2
        ? !1
        : !0;
    },
    isValidUTF8length: function (e, t) {
      return this.utf8StringByteLength(e) > t ? !1 : !0;
    },
    utf8StringByteLength: function (e) {
      if (null === e) return 0;
      var t = String(e),
        r = 127,
        s = 2047,
        a = t.length;
      for (i = 0; i < t.length; i++)
        (chr = t.charCodeAt(i)), chr > r && (a += 1), chr > s && (a += 1);
      return a;
    },
    IsNumeric: function (e, t) {
      if (t) var r = "0123456789.";
      else var r = "0123456789";
      var s,
        a = !0;
      for (i = 0; i < e.length && 1 == a; i++)
        (s = e.charAt(i)), -1 == r.indexOf(s) && (a = !1);
      return a;
    },
    IsValidPhone: function (e) {
      var t,
        r = "0123456789()-+ ",
        s = !0;
      for (i = 0; i < e.length && 1 == s; i++)
        (t = e.charAt(i)), -1 == r.indexOf(t) && (s = !1);
      return s;
    },
    showConfirmationDialog: function (e, t) {
      $("#confirmationPopupMessage").html(t);
      var r = $("#confirmationPopup").data("wc-WCDialog"),
        s = "click.MessageHelper";
      r.primary_button.one(s, function (t) {
        t.preventDefault(),
          r.secondary_button.off(s),
          wcTopic.publish(e, {
            action: "YES",
          });
      }),
        r.secondary_button.one(s, function (t) {
          t.preventDefault(),
            r.primary_button.off(s),
            wcTopic.publish(e, {
              action: "NO",
            });
        }),
        r.open();
    },
  }),
  (quickOrderJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    skuErrorMessage: "",
    qtyErrorMessage: "",
    numberOfItemsSupportedPerQuickOrder: "12",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.skuErrorMessage = s),
        (this.qtyErrorMessage = a);
    },
    addToOrderAjax: function (e) {
      if (browseOnly)
        return void MessageHelper.displayErrorMessage(
          storeNLS.ERROR_ADD2CART_BROWSE_ONLY
        );
      var t = [],
        r = document.forms[e];
      (t.storeId = r.storeId.value),
        (t.catalogId = r.catalogId.value),
        (t.langId = r.langId.value),
        (t.calculateOrder = "0");
      for (
        var s = 0, a = 1;
        a <= this.numberOfItemsSupportedPerQuickOrder;
        a++
      ) {
        var i = r["partNumber_" + a].id,
          n = r["quantity_" + a].id,
          o = trim(r["partNumber_" + a].value),
          d = trim(r["quantity_" + a].value);
        if ((null != o && "" != o) || (null != d && "" != d)) {
          if (null == o || "" == o)
            return void MessageHelper.formErrorHandleClient(
              i,
              this.skuErrorMessage
            );
          if (!isPositiveInteger(d))
            return void MessageHelper.formErrorHandleClient(
              n,
              this.qtyErrorMessage
            );
          (s += 1),
            (r["partNumber_" + a].value = o),
            (r["quantity_" + a].value = d),
            this.updateParamObject(
              t,
              "partNumber_" + s,
              r["partNumber_" + a].value
            ),
            this.updateParamObject(
              t,
              "quantity_" + s,
              r["quantity_" + a].value
            );
        }
      }
      if (s > 0) {
        if (!submitRequest()) return;
        cursor_wait(), wcService.invoke("QuickOrderAddOrderItem", t);
      }
    },
    updateParamObject: function (e, t, r, s) {
      if ((null == e && (e = []), null != s && "" !== s && -1 !== s))
        e[t + "_" + s] = r;
      else if (-1 === s) {
        for (var a = 1; null != e[t + "_" + a]; ) a++;
        e[t + "_" + a] = r;
      } else e[t] = r;
      return e;
    },
    clearForm: function (e) {
      for (var t = document.forms[e], r = 0; r < t.elements.length; r++)
        "text" == t.elements[r].type && (t.elements[r].value = "");
    },
  }),
  wcService.declare({
    id: "QuickOrderAddOrderItem",
    actionId: "AjaxAddOrderItem",
    url: "AjaxRESTOrderAddPreConfigurationToCart",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        quickOrderJS.clearForm("MQuickOrderForm");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  ("undefined" != typeof ResponsiveJS &&
    null != ResponsiveJS &&
    ResponsiveJS) ||
    (ResponsiveJS = {
      init: function () {
        $("#footerCustomerService").on(
          "click",
          $.proxy(ResponsiveJS._cSToggleAndShow, ResponsiveJS)
        ),
          $("#footerCorporateInfo").on(
            "click",
            $.proxy(ResponsiveJS._cIToggleAndShow, ResponsiveJS)
          ),
          $("#footerExplore").on(
            "click",
            $.proxy(ResponsiveJS._eToggleAndShow, ResponsiveJS)
          ),
          $("#footerFollowUs").on(
            "click",
            $.proxy(ResponsiveJS._FUToggleAndShow, ResponsiveJS)
          );
      },
      _cSToggleAndShow: function (e) {
        this.toggle($("#cSTog")), this.show($("#expandCS"));
      },
      _cIToggleAndShow: function (e) {
        this.toggle($("#cITog")), this.show($("#expandCI"));
      },
      _eToggleAndShow: function (e) {
        this.toggle($("#eTog")), this.show($("#expandE"));
      },
      _FUToggleAndShow: function (e) {
        this.toggle($("#fUTog")), this.show($("#expandFU"));
      },
      toggle: function (e) {
        var t = e;
        null != t &&
          ("-161px -1px" == t.style.backgroundPosition
            ? ((t.style.backgroundPosition = "-181px -1px"),
              (t.style.width = "12px"),
              (t.style.height = "6px"),
              (t.style.left = "6px"),
              (t.style.top = "14px"))
            : ((t.style.backgroundPosition = "-161px -1px"),
              (t.style.width = "6px"),
              (t.style.height = "12px"),
              (t.style.left = "10px"),
              (t.style.top = "10px")));
      },
      show: function (e) {
        (srcElement = e),
          null != srcElement &&
            ("block" == srcElement.style.display
              ? (close("searchDropdown"), (srcElement.style.display = "none"))
              : ($(".subDeptDropdown ").each(function (e, t) {
                  close(t.id);
                }),
                close("departmentsDropdown"),
                close("qLinkDropdown"),
                close("mobileSearchDropdown"),
                close("searchDropdown"),
                close("pageDropdown"),
                close("sortDropdown"),
                (srcElement.style.display = "block")));
      },
    }),
  (ServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAddAndDeleteFromCart",
    actionId: "AjaxInterestItemAddAndDeleteFromCart",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        resetRequest(),
        CheckoutHelperJS.deleteFromCart(e.orderItemId, !0),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddOrderItem",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
    formId: "",
    successHandler: function (e) {
      if (
        (MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_ADDED
        ),
        cursor_clear(),
        categoryDisplayJS)
      ) {
        for (
          var t = document.getElementsByName("attrValue"), r = !0, s = 0;
          s < t.length;
          s++
        )
          t[s].options.length > 1 && (r = !1);
        if (!r) {
          categoryDisplayJS.selectedAttributes = [];
          for (var s = 0; s < t.length; s++) null != t[s] && (t[s].value = "");
        }
      }
      null != typeof ShipmodeSelectionExtJS &&
        "undefined" != typeof ShipmodeSelectionExtJS &&
        ShipmodeSelectionExtJS.setOrderItemId(
          null != e.orderItem && null != e.orderItem[0].orderItemId
            ? e.orderItem[0].orderItemId
            : e.orderItemId
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddOrderItem_shopCart",
    actionId: "AjaxAddOrderItem",
    url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
    formId: "",
    successHandler: function (e) {
      document.location.href = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_CONTRACT_EXPIRED_GOTO_ORDER
            )
          : "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItem",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItemForShippingBillingPage",
    actionId: "AjaxDeleteOrderItemForShippingBillingPage",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItemFromCart",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxDeleteOrderItem1",
    actionId: "AjaxDeleteOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SHOPCART_REMOVEITEM
        ),
        CheckoutHelperJS.pendingOrderDetailsPage
          ? cursor_clear()
          : (setDeleteCartCookie(),
            CheckoutHelperJS.shoppingCartPage
              ? (document.location.href = appendWcCommonRequestParameters(
                  "AjaxOrderItemDisplayView?storeId=" +
                    ServicesDeclarationJS.storeId +
                    "&catalogId=" +
                    ServicesDeclarationJS.catalogId +
                    "&langId=" +
                    ServicesDeclarationJS.langId
                ))
              : (document.location.href = appendWcCommonRequestParameters(
                  "OrderShippingBillingView?storeId=" +
                    ServicesDeclarationJS.storeId +
                    "&catalogId=" +
                    ServicesDeclarationJS.catalogId +
                    "&langId=" +
                    ServicesDeclarationJS.langId +
                    "&orderId=" +
                    e.orderId
                )));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItem",
    actionId: "AjaxUpdateOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.hideFormErrorHandle(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE_QTY_UPDATE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderItem1",
    actionId: "AjaxUpdateOrderItem",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.pendingOrderDetailsPage
        ? cursor_clear()
        : CheckoutHelperJS.shoppingCartPage &&
          (document.location.href = appendWcCommonRequestParameters(
            "AjaxOrderItemDisplayView?storeId=" +
              ServicesDeclarationJS.storeId +
              "&catalogId=" +
              ServicesDeclarationJS.catalogId +
              "&langId=" +
              ServicesDeclarationJS.langId
          ));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "_ERR_RETRIEVE_PRICE" == e.errorMessageKey
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ERROR_RETRIEVE_PRICE_QTY_UPDATE
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderShippingInfo",
    actionId: "AjaxUpdateOrderShippingInfo",
    url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPrepareOrderForSubmit",
    actionId: "AjaxPrepareOrderForSubmit",
    url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.setOrderPrepared("true"),
        CheckoutHelperJS.checkoutOrder(
          CheckoutHelperJS.getSavedParameter("tempOrderId"),
          CheckoutHelperJS.getSavedParameter("tempUserType"),
          CheckoutHelperJS.getSavedParameter("tempEmailAddresses"),
          CheckoutHelperJS.getSavedParameter("tempIsQuote")
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSubmitOrder",
    actionId: "AjaxSubmitOrder",
    url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
    formId: "",
    successHandler: function (e) {
      nullCartTotalCookie(e.orderId);
      var t = CheckoutHelperJS.getShipmentTypeId();
      document.location.href = appendWcCommonRequestParameters(
        "OrderShippingBillingConfirmationView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId +
          "&orderId=" +
          e.orderId +
          "&shipmentTypeId=" +
          t
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSubmitQuote",
    actionId: "AjaxSubmitQuote",
    url: getAbsoluteURL() + "AjaxSubmitQuote",
    formId: "",
    successHandler: function (e) {
      var t =
        "OrderShippingBillingConfirmationView?storeId=" +
        ServicesDeclarationJS.storeId +
        "&catalogId=" +
        ServicesDeclarationJS.catalogId +
        "&langId=" +
        ServicesDeclarationJS.langId +
        "&orderId=" +
        CheckoutHelperJS.getOrderId() +
        "&shipmentTypeId=" +
        CheckoutHelperJS.getShipmentTypeId() +
        "&isQuote=true&quoteId=" +
        e.outOrderId;
      void 0 != e.outExternalQuoteId &&
        null != e.outExternalQuoteId &&
        (t += t + "&externalQuoteId=" + e.outExternalQuoteId),
        (document.location.href = appendWcCommonRequestParameters(t));
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxAddAddressForPerson",
    actionId: "AjaxAddAddressForPerson",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      AddressHelper.updateOrderAfterAddressUpdate(),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateAddressForPerson",
    actionId: "AjaxUpdateAddressForPerson",
    url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      AddressHelper.updateOrderAfterAddressUpdate(),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateOrderAfterAddressUpdate",
    actionId: "AjaxUpdateOrderAfterAddressUpdate",
    url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd",
    actionId: "AjaxInterestItemAdd",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        ),
        categoryDisplayJS && (categoryDisplayJS.selectedAttributes = []);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd_shopCart",
    actionId: "AjaxInterestItemAdd",
    url: getAbsoluteURL() + "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      document.location.href = appendWcCommonRequestParameters(
        "AjaxOrderItemDisplayView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId
      );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemDelete",
    actionId: "AjaxInterestItemDelete",
    url: getAbsoluteURL() + "AjaxInterestItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemListMessage",
    actionId: "AjaxInterestItemListMessage",
    url: getAbsoluteURL() + "AjaxInterestItemListMessage",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPromotionCodeManage",
    actionId: "AjaxPromotionCodeManage",
    url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPromotionCodeDelete",
    actionId: "AjaxPromotionCodeManage",
    url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCouponsAdd",
    actionId: "AjaxCouponsAddRemove",
    url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCouponsRemove",
    actionId: "AjaxCouponsAddRemove",
    url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.orderItemId = ""),
        (t.orderId = e.orderId),
        CheckoutHelperJS.shoppingCartPage
          ? (t.calculationUsage = "-1,-2,-5,-6,-7")
          : (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (t.calculateOrder = "1"),
        wcService.invoke("AjaxUpdateOrderItem", t);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage();
      var t = document.getElementById("orderIdToSchedule").value,
        r = e.orderId;
      nullCartTotalCookie(e.orderId);
      var s = CheckoutHelperJS.getShipmentTypeId(),
        a = "";
      null !=
        document.forms.purchaseOrderNumberInfo.purchase_order_number.value &&
        (a =
          document.forms.purchaseOrderNumberInfo.purchase_order_number.value);
      var i =
        "RESTOrderCancel?orderId=" +
        t +
        "&storeId=" +
        ServicesDeclarationJS.storeId +
        "&catalogId=" +
        ServicesDeclarationJS.catalogId +
        "&langId=" +
        ServicesDeclarationJS.langId +
        "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" +
        r +
        "%26originalOrderId%3D" +
        t +
        "%26shipmentTypeId%3D" +
        s +
        "%26purchaseOrderNumber%3D" +
        a;
      document.location.href = appendWcCommonRequestParameters(i);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), nullCartTotalCookie(e.orderId);
      var t = CheckoutHelperJS.getShipmentTypeId(),
        r =
          "OrderShippingBillingConfirmationView?storeId=" +
          ServicesDeclarationJS.storeId +
          "&catalogId=" +
          ServicesDeclarationJS.catalogId +
          "&langId=" +
          ServicesDeclarationJS.langId +
          "&orderId=" +
          e.orderId +
          "&shipmentTypeId=" +
          t;
      (document.location.href = appendWcCommonRequestParameters(r)),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCreate",
    actionId: "AjaxOrderCreate",
    url: getAbsoluteURL() + "AjaxOrderCreate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_CREATED
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CREATED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCancel",
    actionId: "AjaxSingleOrderCancel",
    url: getAbsoluteURL() + "AjaxRESTOrderCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDERS_CANCELLED
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CANCELLED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCancel",
    actionId: "AjaxOrderCancel",
    url: getAbsoluteURL() + "AjaxRESTOrderCancel",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.cancelSavedOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_CANCELLED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderSave",
    actionId: "AjaxOrderSave",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.saveOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SAVED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSetPendingOrder",
    actionId: "AjaxSetPendingOrder",
    url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_SET_CURRENT
        ),
        savedOrdersJS.determinePageForward("AjaxSetPendingOrder"),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode || "CMN1024E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SET_CURRENT
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxUpdatePendingOrder",
    actionId: "AjaxUpdatePendingOrder",
    url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
    formId: "",
    successHandler: function (e) {
      savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder"),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_SET_CURRENT
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCopy",
    actionId: "AjaxSingleOrderCopy",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.URL = ""),
        (t.updatePrices = "1"),
        (t.orderId = e.orderId),
        (t.calculationUsageId = "-1"),
        wcService.invoke("AjaxSingleOrderCalculate", t),
        MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCopy",
    actionId: "AjaxOrderCopy",
    url: getAbsoluteURL() + "AjaxOrderCopy",
    formId: "",
    successHandler: function (e) {
      var t = [];
      (t.storeId = ServicesDeclarationJS.storeId),
        (t.catalogId = ServicesDeclarationJS.catalogId),
        (t.langId = ServicesDeclarationJS.langId),
        (t.URL = ""),
        (t.updatePrices = "1"),
        (t.orderId = e.orderId),
        (t.calculationUsageId = "-1"),
        wcService.invoke("AjaxOrderCalculate", t),
        MessageHelper.hideAndClearMessage();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxSingleOrderCalculate",
    actionId: "AjaxSingleOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(MessageHelper.messages.ORDER_COPIED),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCurrentOrderCalculate",
    actionId: "AjaxCurrentOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.ORDER_SET_CURRENT
        ),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxOrderCalculate",
    actionId: "AjaxOrderCalculate",
    url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), savedOrdersJS.copyOrder(!1);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? "CMN0409E" == e.errorCode
          ? MessageHelper.displayErrorMessage(
              MessageHelper.messages.ORDER_NOT_COPIED
            )
          : MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxPunchoutPay",
    actionId: "AjaxPunchoutPay",
    url: "AjaxRESTOrderRePay",
    formId: "",
    successHandler: function (e) {
      PunchoutJS.handleResponse(e.orderId),
        MessageHelper.hideAndClearMessage(),
        cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCategorySubscribe",
    actionId: "AjaxCategorySubscribe",
    url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.SUBSCRIPTION_UPDATED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var order_updated = {
    AjaxAddOrderItem: "AjaxAddOrderItem",
    AjaxAddOrderItemWithShipingInfo: "AjaxAddOrderItemWithShipingInfo",
    AjaxDeleteOrderItem: "AjaxDeleteOrderItem",
    AjaxUpdateOrderItem: "AjaxUpdateOrderItem",
    AjaxUpdateOrderShippingInfo: "AjaxUpdateOrderShippingInfo",
    AjaxOrderCalculate: "AjaxOrderCalculate",
    AjaxLogoff: "AjaxLogoff",
    AjaxSetPendingOrder: "AjaxSetPendingOrder",
    AjaxUpdatePendingOrder: "AjaxUpdatePendingOrder",
    AjaxSingleOrderCancel: "AjaxSingleOrderCancel",
    AjaxUpdateRewardOption: "AjaxUpdateRewardOption",
  },
  address_updated = {
    AjaxDeleteAddressForPerson: "AjaxDeleteAddressForPerson",
    AjaxAddAddressForPerson: "AjaxAddAddressForPerson",
    AjaxUpdateAddressForPerson: "AjaxUpdateAddressForPerson",
    AjaxAddShippingAndBillingAddressForPersonDuringCheckout:
      "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
    AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout:
      "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
  },
  user_changed = {
    AjaxLogonService: "AjaxLogonService",
    AjaxLogoff: "AjaxLogoff",
  },
  wishlist_changed = {
    AjaxInterestItemAdd: "AjaxInterestItemAdd",
    AjaxInterestItemDelete: "AjaxInterestItemDelete",
    AjaxLogonService: "AjaxLogonService",
    AjaxLogoff: "AjaxLogoff",
  };
wcTopic.subscribe("ajaxRequestInitiated", incrementNumAjaxRequest),
  wcTopic.subscribe("ajaxRequestCompleted", decrementNumAjaxRequest),
  wcTopic.subscribe("ajaxRequestCompleted", initializeInactivityWarning),
  wcTopic.subscribe("OrderError", function (e) {
    "CMN4512I" == e.errorCode &&
      (setDeleteCartCookie(), loadMiniCart(null, null));
  });
var showDropdown = !1,
  dropDownDlg = null,
  productAddedDropDownDlg = null,
  originalMiniCartWidth = 0,
  isIE = document.all ? !0 : !1,
  correctBrowser = !1,
  requestSubmitted = !0,
  currentId = "",
  numAjaxRequests = 0,
  widgetsList = [],
  tabPressed = !1,
  currentPopup = "",
  android = null,
  ios = null,
  cookieDomain = "",
  _BTD_PREFS = "WC_Base_Text_Direction",
  detectedLocale = Utils.getLocale();
wcService.declare({
  id: "MyAcctAjaxAddOrderItem",
  actionId: "AjaxAddOrderItem",
  url: "",
  formId: "",
  successHandler: function (e) {
    MessageHelper.hideAndClearMessage(),
      MessageHelper.displayStatusMessage(
        Utils.getLocalizationMessage("SHOPCART_ADDED")
      ),
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
      cursor_clear();
  },
  failureHandler: function (e) {
    e.errorMessage
      ? "_ERR_NO_ELIGIBLE_TRADING" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER")
          )
        : MessageHelper.displayErrorMessage(e.errorMessage)
      : e.errorMessageKey &&
        MessageHelper.displayErrorMessage(e.errorMessageKey),
      cursor_clear();
  },
}),
  wcService.declare({
    id: "MyAcctGenericService",
    actionId: "",
    url: "",
    formId: "",
    successHandler: function (e) {
      setCookie("WC_nextURL_" + WCParamJS.storeId, null, {
        expires: -1,
        path: "/",
        domain: cookieDomain,
      }),
        MessageHelper.hideAndClearMessage(),
        (finalViewURL = getFinalViewURL(this.url)),
        "" !== finalViewURL
          ? (document.location.href = finalViewURL)
          : (MessageHelper.displayStatusMessage(
              Utils.getLocalizationMessage("MYACCOUNT_ACTION_PERFORMED")
            ),
            cursor_clear());
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  (PhysicalStoreCookieJSStore = {
    storeArray: null,
    arrayMaxSize: 5,
    getStoreIdsFromCookie: function () {
      var e = getCookie("WC_physicalStores");
      if (((this.storeArray = new Array()), null != e)) {
        var t = "",
          r = e,
          s = e.length,
          a = r.indexOf(",");
        if (a > 0) {
          for (; a >= 0; )
            (t = r.substring(0, a)),
              this.addToStoreArray(t),
              (r = r.substring(a + 1, s)),
              (s = r.length),
              (a = r.indexOf(","));
          (t = r), this.addToStoreArray(t);
        } else s > 0 && this.addToStoreArray(r);
      }
      return this.storeArray;
    },
    isAddOneStoreIdExceedMax: function () {
      var e = !1;
      return this.getNumStores() + 1 > this.arrayMaxSize && (e = !0), e;
    },
    setStoreIdsToCookie: function () {
      var e = "";
      for (i = 0; i < this.storeArray.length; i++)
        (e += this.storeArray[i]), i < this.storeArray.length - 1 && (e += ",");
      0 == e.length
        ? setCookie("WC_physicalStores", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          })
        : setCookie("WC_physicalStores", e, {
            path: "/",
            domain: cookieDomain,
          });
    },
    addToStoreArray: function (e) {
      for (
        null == this.storeArray && this.getStoreIdsFromCookie(), i = 0;
        i < this.storeArray.length;
        i++
      )
        if (this.storeArray[i] == e) return;
      this.storeArray.length < this.arrayMaxSize && this.storeArray.push(e);
    },
    addToCookie: function (e) {
      this.addToStoreArray(e), this.setStoreIdsToCookie();
    },
    removeFromStoreArray: function (e) {
      null == this.storeArray && this.getStoreIdsFromCookie();
      var t = -1;
      for (i = 0; i < this.storeArray.length; i++)
        this.storeArray[i] == e && ((t = i), (i = this.storeArray.length));
      this.storeArray.splice(t, 1);
    },
    removeFromCookie: function (e) {
      this.removeFromStoreArray(e), this.setStoreIdsToCookie();
    },
    clearStoreArray: function () {
      this.storeArray = new Array();
    },
    clearCookie: function () {
      this.clearStoreArray(), this.setStoreIdsToCookie();
    },
    getNumStores: function () {
      return (
        null == this.storeArray && this.getStoreIdsFromCookie(),
        this.storeArray.length
      );
    },
    getPickUpStoreIdFromCookie: function () {
      var e = getCookie("WC_pickUpStore");
      return e;
    },
    setPickUpStoreIdToCookie: function (e) {
      var t = e;
      if (null != t && "undefined" != t && "" != t) {
        var r = this.getPickUpStoreIdFromCookie();
        t != r &&
          (setCookie("WC_pickUpStore", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          }),
          setCookie("WC_pickUpStore", t, {
            path: "/",
            domain: cookieDomain,
          }));
      }
    },
    clearPickUpStoreIdFromCookie: function (e) {
      var t = e;
      if (null != t && "undefined" != t && "" != t) {
        var r = this.getPickUpStoreIdFromCookie();
        t == r &&
          setCookie("WC_pickUpStore", null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          });
      }
    },
    getValueFromCookie: function (e) {
      var t = getCookie(e);
      return t;
    },
    setValueToCookie: function (e, t) {
      var r = t;
      if (null != r && "undefined" != r && "" != r) {
        var s = this.getValueFromCookie(e);
        r != s &&
          (setCookie(e, null, {
            path: "/",
            expires: -1,
            domain: cookieDomain,
          }),
          setCookie(e, r, {
            path: "/",
            domain: cookieDomain,
          }));
      }
    },
    clearValueFromCookie: function (e) {
      var t = this.getValueFromCookie(e);
      null != t &&
        "undefined" != t &&
        setCookie(e, null, {
          path: "/",
          expires: -1,
          domain: cookieDomain,
        });
    },
  }),
  (storeLocatorJSStore = {
    initProvinceSelections: function () {
      var e = $("#selectCountry").prop("selectedIndex");
      if (e > -1) {
        var t = e,
          r = storeLocatorJSStore.getSavedCountrySelectionIndex();
        null != r &&
          r != e &&
          ((t = r), ($("#selectCountry")[0].options[t].selected = !0)),
          wcRenderContext.updateRenderContext("provinceSelectionsContext", {
            countryId: $("#selectCountry")[0].options[t].value,
          });
      }
    },
    refreshCities: function () {
      var e = $("#selectState").prop("selectedIndex");
      if (e > -1) {
        var t = e,
          r = storeLocatorJSStore.getSavedProvinceSelectionIndex();
        null != r &&
          r != e &&
          ((t = r), ($("#selectState")[0].options[t].selected = !0)),
          wcRenderContext.updateRenderContext("citySelectionsContext", {
            provinceId: $("#selectState")[0].options[t].value,
          });
      }
    },
    refreshSearchResults: function (e) {
      var t = $("#selectCity").selectedIndex;
      if (t > -1) {
        var r = t,
          s = storeLocatorJSStore.getSavedCitySelectionIndex();
        null != s &&
          s != t &&
          ((r = s),
          ($("#selectCountry")[0].options[r].value("selectCity").options[
            r
          ].selected = !0));
        var a = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stFind");
        null != a &&
          wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
            cityId: document
              .getElementById("selectCountry")
              .options[r].value("selectCity").options[r].value,
            fromPage: e,
          });
      }
    },
    addPhysicalStore: function (e, t) {
      if (1 == PhysicalStoreCookieJSStore.isAddOneStoreIdExceedMax())
        return null !=
          document.getElementById("addPhysicalStoreToCookieButton" + t)
          ? (MessageHelper.formErrorHandleClient(
              "addPhysicalStoreToCookieButton" + t,
              MessageHelper.messages.EXCEED_PHYSICAL_STORE_SIZE
            ),
            !1)
          : (MessageHelper.displayErrorMessage(
              MessageHelper.messages.EXCEED_PHYSICAL_STORE_SIZE
            ),
            !1);
      if (submitRequest())
        return (
          cursor_wait(),
          PhysicalStoreCookieJSStore.addToCookie(e),
          storeLocatorJSStore.showRemoveOption(e),
          !0
        );
    },
    removePhysicalStore: function (e) {
      PhysicalStoreCookieJSStore.removeFromCookie(e),
        PhysicalStoreCookieJSStore.clearPickUpStoreIdFromCookie(e),
        storeLocatorJSStore.showAddOption(e);
    },
    showRemoveOption: function (e) {
      var t = $("#addPhysicalStoreToCookieDisabled" + e),
        r = $("#addPhysicalStoreToCookie" + e);
      null != t && "undefined" != t && $(t).css("display", "block"),
        null != r && "undefined" != r && $(r).css("display", "none");
    },
    showAddOption: function (e) {
      var t = $("#addPhysicalStoreToCookieDisabled" + e),
        r = $("#addPhysicalStoreToCookie" + e);
      null != t && "undefined" != t && $(t).css("display", "none"),
        null != r && "undefined" != r && $(r).css("display", "block");
    },
    manageCookieFromCity: function () {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stFind", 1);
    },
    refreshResultsFromCity: function (e, t) {
      return e.selectCity.selectedIndex < 0
        ? void MessageHelper.formErrorHandleClient(
            e.selectCity.id,
            MessageHelper.messages.MISSING_CITY
          )
        : (storeLocatorJSStore.manageCookieFromCity(),
          void wcRenderContext.updateRenderContext(
            "storeLocatorResultsContext",
            {
              cityId: e.selectCity.options[e.selectCity.selectedIndex].value,
              fromPage: t,
              geoCodeLatitude: "",
              geoCodeLongitude: "",
              errorMsgKey: "",
            }
          ));
    },
    refreshResultsFromNearest: function (e, t) {
      PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCntry"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
          geoCodeLatitude: e,
          geoCodeLongitude: t,
          errorMsgKey: "",
        });
    },
    refreshResultsWithLocationError: function (e) {
      PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("storeLocatorResultsContext", {
          errorMsgKey: e,
        });
    },
    refreshStoreList: function (e) {
      wcRenderContext.updateRenderContext("selectedStoreListContext", {
        fromPage: e,
      });
    },
    removeFromStoreList: function (e, t) {
      var r = PhysicalStoreCookieJSStore.getNumStores();
      if (0 == r) this.refreshStoreList(e);
      else {
        var s = document.getElementById(t);
        s.remove();
      }
    },
    hideStoreList: function () {
      var e = $("#selectedStoreList"),
        t = $("#showStoreListHeader"),
        r = $("#hideStoreListHeader");
      null != e && "undefined" != e && $(e).css("display", "none"),
        null != t && "undefined" != t && $(t).css("display", "block"),
        null != r && "undefined" != r && $(r).css("display", "none");
    },
    showStoreList: function () {
      var e = $("#selectedStoreList"),
        t = $("#showStoreListHeader"),
        r = $("#hideStoreListHeader");
      null != e && "undefined" != e && $(e).css("display", "block"),
        null != t && "undefined" != t && $(t).css("display", "none"),
        null != r && "undefined" != r && $(r).css("display", "block");
    },
    changeCountrySelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stCntry", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("provinceSelectionsContext", {
          countryId: e,
        });
    },
    changeProvinceSelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stProv", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity"),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind"),
        wcRenderContext.updateRenderContext("citySelectionsContext", {
          provinceId: e,
        });
    },
    changeCitySelection: function (e) {
      PhysicalStoreCookieJSStore.setValueToCookie("WC_stCity", e),
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");
    },
    getSavedCountrySelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCntry");
      if (null != t) {
        var r = $("#selectCountry");
        if (null != r && "undefined" != r) {
          var s = r.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
    getSavedProvinceSelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stProv");
      if (null != t) {
        var r = $("#selectState");
        if (null != r && "undefined" != r) {
          var s = r.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
    getSavedCitySelectionIndex: function () {
      var e = null,
        t = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCity");
      if (null != t) {
        var r = $("#selectCity");
        if (null != r && "undefined" != r) {
          var s = r[0].options.length;
          for (i = 0; i < s; i++)
            t == r[0].options[i].value && ((e = i), (i = s));
        }
      }
      return e;
    },
  }),
  (StoreLocatorContextsJSStore = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.orderId = s),
        (this.fromPage = a);
    },
    setContextProperty: function (e, t, r) {
      wcRenderContext.getRenderContextProperties(e)[t] = r;
    },
  }),
  wcRenderContext.declare(
    "provinceSelectionsContext",
    ["provinceSelections"],
    ""
  ),
  wcRenderContext.declare("citySelectionsContext", ["citySelections"], ""),
  wcRenderContext.declare(
    "storeLocatorResultsContext",
    ["storeLocatorResults"],
    ""
  ),
  wcRenderContext.declare(
    "selectedStoreListContext",
    ["selectedStoreList"],
    ""
  ),
  (StoreLocatorControllersDeclarationJSStore = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        (this.catalogId = r),
        (this.orderId = s),
        (this.fromPage = a);
    },
    provinceSelectionsRefreshArea: function () {
      var e = $("#provinceSelections"),
        t = wcRenderContext.getRenderContextProperties(
          "provinceSelectionsContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          storeLocatorJSStore.refreshCities(), cursor_clear();
        },
      });
    },
    citySelectionsRefreshController: function () {
      var e = $("#citySelections"),
        t = wcRenderContext.getRenderContextProperties("citySelectionsContext");
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function (e) {
          storeLocatorJSStore.refreshSearchResults(
            StoreLocatorControllersDeclarationJSStore.fromPage
          ),
            cursor_clear();
        },
      });
    },
    storeLocatorResultsRefreshController: function () {
      var e = $("#storeLocatorResults"),
        t = wcRenderContext.getRenderContextProperties(
          "storeLocatorResultsContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = $("#bopis_table");
          null != e && "undefined" != e && e.focus();
          var t = $("#no_store_message");
          null != t && "undefined" != t && t.focus(), cursor_clear();
        },
      });
    },
    selectedStoreListRefreshController: function () {
      var e = $("#selectedStoreList"),
        t = wcRenderContext.getRenderContextProperties(
          "selectedStoreListContext"
        );
      e.refreshWidget({
        formId: "",
        renderContextChangedHandler: function () {
          cursor_wait(), e.refreshWidget("refresh", t);
        },
        postRefreshHandler: function () {
          var e = $("#bopis_table");
          null != e && "undefined" != e && e.focus(), cursor_clear();
        },
      });
    },
  }),
  (AddressBookFormJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    addressDeleted: "false",
    addressNew: "false",
    pageVar: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    getControllerActionHandler: function (e, t) {
      console.debug(
        "entering getControllerActionHandler(controller, handlerKey, actionName): " +
          t
      );
      var r = AddressBookFormJS[t + "s"][e];
      return r
        ? function (e, t, s) {
            r(e, t, s);
          }
        : function (e, t, r) {
            console.debug("empty handler. This is a no-op");
          };
    },
    addressFormAreaActions: {
      create: function (e, t, r) {
        t.refresh(r.renderContext.properties),
          (r.renderContext.properties.addressFormAreaState = "create");
      },
      edit: function (e, t, r) {
        console.debug("starting to getting editing area"),
          t.refresh(r.renderContext.properties),
          (r.renderContext.properties.addressFormAreaState = "edit");
      },
      clean: function (e, t, r) {
        t.setInnerHTML(""),
          (r.renderContext.properties.addressFormAreaState = "clean");
      },
      handleModelChange: function (e, t, r) {
        t.setInnerHTML(""),
          (r.renderContext.properties.addressFormAreaState = "clean");
      },
    },
    addressDisplayAreaActions: {
      reload: function (e, t, r) {
        console.debug("reloading " + t), t.refresh(r.renderContext.properties);
      },
      handleModelChange: function (e, t, r) {
        console.debug("reloading " + t), t.refresh(r.renderContext.properties);
      },
    },
    statesDisplayAreaActions: {
      countryUpdated: function (e, t, r) {
        console.debug("IN countryUpdated handler: message = " + e);
        var s = r.renderContext.properties.paramPrefix;
        t.widgetId.match(s)
          ? (console.debug(
              "matchin paramPrefix: " + s + " refreshing " + t.widgetId
            ),
            t.refresh(r.renderContext.properties))
          : console.debug("no maching paramPrefix " + s);
      },
    },
    toggleAddressDisplay: function (e, t, r) {
      console.debug("toggle address display");
      var s = e.options[e.selectedIndex].value;
      $("." + t).each(function (e, t) {
        var a = r + s;
        t.id == a && "MyBillingAddress" != s
          ? $(t).css("display", "block")
          : $(t).css("display", "none");
      });
    },
    populateTextFields: function (e, t, r) {
      if ("block" == document.getElementById("adding").style.display) {
        var s = document.getElementById("adding");
        hideElementById(s);
        var a = document.getElementById("normal");
        a.style.display = "block";
      }
      for (
        var i = e.options[e.selectedIndex].value, n = r.sbAddress, o = 0;
        o < n.length;
        o++
      )
        n[o].value == t[i].addressType && (n[o].checked = "checked");
      (r.nickName.value = t[i].nickName),
        (r.firstName.value = t[i].firstName),
        (r.lastName.value = t[i].lastName),
        (r.address1.value = t[i].address1),
        (r.address2.value = t[i].address2),
        (r.country.value = t[i].country),
        (r.zipCode.value = t[i].zipCode),
        (r.email1.value = t[i].email1),
        (r.phone1.value = t[i].phone1),
        (r.city.value = t[i].city),
        AddressHelper.loadStatesUI("AddressForm", "", "stateDiv", "state"),
        (r.state.value = t[i].state),
        r.middleName && (r.middleName.value = t[i].middleName),
        (document.getElementById("addr_title").innerHTML =
          "<h2 class='status_msg'>" + t[i].nickName + "</h2>");
    },
    populateTextFieldsOnLoad: function (e, t, r) {
      for (
        var s = e.options[e.selectedIndex].value, a = r.sbAddress, i = 0;
        i < a.length;
        i++
      )
        a[i].value == t[s].addressType && (a[i].checked = "checked");
      (r.nickName.value = t[s].nickName),
        (r.firstName.value = t[s].firstName),
        (r.lastName.value = t[s].lastName),
        (r.address1.value = t[s].address1),
        (r.address2.value = t[s].address2),
        (r.state.value = t[s].state),
        (r.country.value = t[s].country),
        (r.zipCode.value = t[s].zipCode),
        (r.email1.value = t[s].email1),
        (r.phone1.value = t[s].phone1),
        (r.city.value = t[s].city),
        r.middleName && (r.middleName.value = t[s].middleName),
        AddressHelper.loadStatesUI("AddressForm", "", "stateDiv", "state", !0),
        (document.getElementById("addr_title").innerHTML =
          "<h2 class='status_msg'>" + t[s].nickName + "</h2>");
    },
    clearTextFields: function (e) {
      (e.nickName.value = ""),
        (e.firstName.value = ""),
        (e.lastName.value = ""),
        (e.address1.value = ""),
        (e.address2.value = ""),
        (e.city.value = ""),
        (e.state.value = ""),
        (e.country.value = ""),
        (e.zipCode.value = ""),
        (e.email1.value = ""),
        (e.phone1.value = ""),
        e.middleName && (e.middleName.value = "");
    },
    showAdd: function () {
      var e = document.getElementById("normal");
      hideElementById(e);
      var t = document.getElementById("adding");
      t.style.display = "block";
    },
    copyBillingFormNew: function (e, t) {
      var r = document.forms[e],
        s = document.forms[t],
        a = document.getElementById("SameShippingAndBillingAddress");
      a.checked &&
        (hideElementById("shippingAddressCreateEditFormDiv_1"),
        (s.firstName.value = r.firstName.value),
        (s.lastName.value = r.lastName.value),
        (s.address1.value = r.address1.value),
        (s.address2.value = r.address2.value),
        (s.city.value = r.city.value),
        isIE
          ? (document.getElementById("stateDiv2").firstChild.value =
              document.getElementById("stateDiv1").firstChild.value)
          : (s.state.value = r.state.value),
        (s.zipCode.value = r.zipCode.value),
        (s.country.value = r.country.value),
        (s.phone1.value = r.phone1.value),
        (s.email1.value = r.email1.value),
        r.middleName && (s.middleName.value = r.middleName.value)),
        a.checked ||
          (showElementById("shippingAddressCreateEditFormDiv_1"),
          (s.firstName.value = ""),
          (s.lastName.value = ""),
          (s.address1.value = ""),
          (s.address2.value = ""),
          (s.city.value = ""),
          isIE
            ? (document.getElementById("stateDiv2").firstChild.value = "")
            : (s.state.value = ""),
          (s.zipCode.value = ""),
          (s.phone1.value = ""),
          (s.email1.value = ""),
          s.middleName && (s.middleName.value = ""));
    },
  }),
  (LogonForm = {
    SubmitAjaxLogin: function (e) {
      this.validateAjaxLogin(e) &&
        submitRequest() &&
        (setDeleteCartCookie(), e.submit());
    },
    validateAjaxLogin: function (e) {
      return (
        (reWhiteSpace = new RegExp(/^\s+$/)),
        (null != e.logonId && reWhiteSpace.test(e.logonId.value)) ||
        "" == e.logonId.value
          ? (MessageHelper.formErrorHandleClient(
              e.logonId.id,
              MessageHelper.messages.LOGON_REQUIRED_FIELD_ENTER
            ),
            !1)
          : (null != e.logonPassword &&
              reWhiteSpace.test(e.logonPassword.value)) ||
            "" == e.logonPassword.value
          ? (MessageHelper.formErrorHandleClient(
              e.logonPassword.id,
              MessageHelper.messages.PASSWORD_REQUIRED_FIELD_ENTER
            ),
            !1)
          : !0
      );
    },
    prepareSubmit: function (e) {
      if (
        "true" == CSRWCParamJS.env_shopOnBehalfSessionEstablished ||
        "true" == CSRWCParamJS.env_shopOnBehalfEnabled_CSR
      ) {
        var t = Math.random(),
          r = t.toString(36).slice(-7),
          s = Math.floor(9 * t + 1);
        (r += s),
          (null == $("#logonPassword").val() ||
            "" == $("#logonPassword").val()) &&
            $("<input>")
              .attr({
                type: "hidden",
                value: r,
                name: "logonPassword",
                id: "logonPassword",
              })
              .appendTo("form"),
          (null == $("#logonPasswordVerify").val() ||
            "" == $("#logonPasswordVerify").val()) &&
            $("<input>")
              .attr({
                type: "hidden",
                value: r,
                name: "logonPasswordVerify",
                id: "logonPasswordVerify",
              })
              .appendTo("form"),
          (null == $("#passwordExpired").val() ||
            "" == $("#passwordExpired").val()) &&
            $("#passwordExpired").val("1");
      }
      this.validatePrepareForm(e) /*&& submitRequest()*/ &&
        (setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {
          path: "/",
          domain: cookieDomain,
        }),
        "true" == CSRWCParamJS.env_shopOnBehalfEnabled_CSR ||
        ("true" == CSRWCParamJS.env_shopOnBehalfSessionEstablished &&
          null != e.userId &&
          null != e.userId.value)
          ? null != registeredCustomersJS &&
            registeredCustomersJS.createRegisteredUser(e.landingURL_CSR.value)
          : e.submit());
    },
    validatePrepareForm: function (e) {
      if (
        ((reWhiteSpace = new RegExp(/^\s+$/)),
        (null != e.logonId && reWhiteSpace.test(e.logonId.value)) ||
          "" == e.logonId.value)
      )
        return (
          MessageHelper.formErrorHandleClient(
            e.logonId.id,
            MessageHelper.messages.ERROR_LogonIdEmpty
          ),
          !1
        );
      if (
        "function" == typeof this.validateLoginId &&
        !this.validateLoginId(e.logonId)
      )
        return !1;
      if (null != e.ancestorOrgs) {
        if ("" == e.ancestorOrgs.value)
          return (
            MessageHelper.formErrorHandleClient(
              e.ancestorOrgs.id,
              MessageHelper.messages.ERROR_OrgNameEmpty
            ),
            !1
          );
        if ("Default Organization" == e.ancestorOrgs.value)
          return (
            MessageHelper.formErrorHandleClient(
              e.ancestorOrgs.id,
              MessageHelper.messages.ERROR_DefaultOrgRegistration
            ),
            !1
          );
      }
      return (null != e.logonPassword &&
        reWhiteSpace.test(e.logonPassword.value)) ||
        "" == e.logonPassword.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPassword.id,
            MessageHelper.messages.ERROR_PasswordEmpty
          ),
          !1)
        : (null != e.logonPasswordVerify &&
            reWhiteSpace.test(e.logonPasswordVerify.value)) ||
          "" == e.logonPasswordVerify.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPasswordVerify.id,
            MessageHelper.messages.ERROR_VerifyPasswordEmpty
          ),
          !1)
        : e.logonPassword.value != e.logonPasswordVerify.value
        ? (MessageHelper.formErrorHandleClient(
            e.logonPasswordVerify.id,
            MessageHelper.messages.PWDREENTER_DO_NOT_MATCH
          ),
          !1)
        : AddressHelper.validateAddressForm(e)
        ? (e.sendMeEmail && e.sendMeEmail.checked
            ? (e.receiveEmail.value = !0)
            : (e.receiveEmail.value = !1),
          e.sendMeSMSNotification && e.sendMeSMSNotification.checked
            ? (e.receiveSMSNotification.value = !0)
            : (e.receiveSMSNotification.value = !1),
          e.sendMeSMSPreference && e.sendMeSMSPreference.checked
            ? (e.receiveSMS.value = !0)
            : (e.receiveSMS.value = !1),
          (null == e.mobileDeviceEnabled ||
            "true" != e.mobileDeviceEnabled.value ||
            MyAccountDisplay.validateMobileDevice(e)) &&
          (null == e.birthdayEnabled ||
            "true" != e.birthdayEnabled.value ||
            MyAccountDisplay.validateBirthday(e))
            ? !0
            : !1)
        : !1;
    },
    validateAge: function (e) {
      var t = parseInt(e.birth_year.value),
        r = parseInt(e.birth_month.value),
        s = parseInt(e.birth_date.value);
      if (0 != t && 0 != r && 0 != s) {
        var a = parseInt(e.curr_year.value),
          i = parseInt(e.curr_month.value),
          n = parseInt(e.curr_date.value);
        13 > a - t
          ? alert(MessageHelper.messages.AGE_WARNING_ALERT)
          : a - t == 13 &&
            (r > i
              ? alert(MessageHelper.messages.AGE_WARNING_ALERT)
              : i == r &&
                s > n &&
                alert(MessageHelper.messages.AGE_WARNING_ALERT));
      }
    },
    checkAge: function (e) {
      1 == e.age.value && alert(MessageHelper.messages.AGE_WARNING_ALERT);
    },
  }),
  (MultipleWishLists = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    defaultListId: null,
    addItemAfterCreate: !1,
    preferredDefaultWishListName: "",
    wishListPrefix: "",
    updateAfterSwitch: !1,
    maxCharsToDisplay: 30,
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    switchList: function (e) {
      submitRequest() &&
        (cursor_wait(),
        $("#multipleWishlistController_select").attr("disabled", "true"),
        (this.updateAfterSwitch = !0),
        this.setAsDefault(e));
    },
    updateContextPostSwitch: function (e) {
      this.updateAfterSwitch &&
        (wcRenderContext.updateRenderContext("WishlistDisplay_Context", {
          giftListId: e,
        }),
        wcRenderContext.updateRenderContext("WishlistSelect_Context", {
          giftListId: e,
        })),
        (this.updateAfterSwitch = !1);
    },
    removeItem: function (e) {
      var t = {};
      if (
        ((t.storeId = this.storeId),
        (t.catalogId = this.catalogId),
        (t.langId = this.langId),
        (t.quantity = 0),
        null != $("#multipleWishlistController_select") &&
          "undefined" != $("#multipleWishlistController_select") &&
          0 != $("#multipleWishlistController_select").val() &&
          ((t.giftListId = $("#multipleWishlistController_select").val()),
          !this.empty(e)))
      ) {
        if (((t.giftListItemId = e), !submitRequest())) return;
        cursor_wait(), wcService.invoke("ShoppingListServiceRemoveItem", t);
      }
    },
    getWishListIdForEmail: function (e) {
      var t = document.getElementById(e);
      null != $("#multipleWishlistController_select") &&
        "undefined" != $("#multipleWishlistController_select") &&
        0 != $("#multipleWishlistController_select").val() &&
        (t.giftListId.value = $("#multipleWishlistController_select").val());
    },
    checkSOAEmailForm: function (e) {
      $("#WishListEmailSucMsg_Div").css("display", "none");
      var t = document.getElementById(e);
      return (
        (t.sender_name.value = t.sender_name.value.replace(/^\s+/g, "")),
        (t.recipient.value = t.recipient.value.replace(/^\s+/g, "")),
        "" == t.recipient.value
          ? void MessageHelper.formErrorHandleClient(
              document.getElementById("SendWishListForm_Recipient_Email").id,
              Utils.getLocalizationMessage("WISHLIST_MISSINGEMAIL")
            )
          : MultipleWishLists.validateWishListEmailString(t.recipient.value)
          ? "" == t.sender_name.value
            ? void MessageHelper.formErrorHandleClient(
                document.getElementById("SendWishListForm_Sender_Name").id,
                Utils.getLocalizationMessage("WISHLIST_MISSINGNAME")
              )
            : MultipleWishLists.validateWishListEmailString(
                t.sender_email.value
              )
            ? "" == t.giftListId.value ||
              "false" == t.wishListHasItem.value ||
              "-1" == t.giftListId.value
              ? void MessageHelper.displayErrorMessage(
                  Utils.getLocalizationMessage("WISHLIST_EMPTY")
                )
              : MultipleWishLists.validateSenderName(t.sender_name.value)
              ? ((t.recipientEmail.value = t.recipient.value),
                (t.recipient.value = ""),
                (t.senderName.value = t.sender_name.value),
                "" != t.sender_email.value &&
                  (t.senderEmail.value = t.sender_email.value),
                "" != t.wishlist_message.value &&
                  (t.message.value = t.wishlist_message.value),
                void (
                  submitRequest() &&
                  (cursor_wait(),
                  wcService
                    .getServiceById("AjaxGiftListAnnouncement")
                    .setFormId(e),
                  wcService.invoke("AjaxGiftListAnnouncement"),
                  (t.senderEmail.value =
                    "SOAWishListEmail@SOAWishListEmail.com"),
                  (t.message.value = "SOAWishListEmail"))
                ))
              : ((t.sender_name.value = ""),
                void MessageHelper.displayErrorMessage(
                  Utils.getLocalizationMessage("WISHLIST_INVALIDSENDERNAME")
                ))
            : void MessageHelper.formErrorHandleClient(
                document.getElementById("SendWishListForm_Sender_Email").id,
                Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT")
              )
          : void MessageHelper.formErrorHandleClient(
              document.getElementById("SendWishListForm_Recipient_Email").id,
              Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT")
            )
      );
    },
    setAsDefault: function (e) {
      if ("-1" != e) {
        var t = {};
        (t.storeId = this.storeId),
          (t.catalogId = this.catalogId),
          (t.langId = this.langId),
          (t.giftListId = e),
          (t.giftListState = "Default"),
          cursor_wait(),
          wcService.invoke("AjaxGiftListServiceChangeGiftListStatus", t);
      } else
        MultipleWishLists.setDefaultListId("-1"),
          MultipleWishLists.updateContextPostSwitch("-1");
    },
    empty: function (e) {
      return null == e || void 0 == e || "" == e;
    },
    setDefaultListId: function (e) {
      this.defaultListId = e;
    },
    getDefaultListId: function () {
      return this.defaultListId;
    },
    setPreferredDefaultWishListName: function (e) {
      this.preferredDefaultWishListName = e;
    },
    setWishListPrefix: function (e) {
      this.wishListPrefix = e;
    },
    validateSenderName: function (e) {
      var t = "~!@#$%^&*()+=[]{};:,<>?/|`";
      t += "    '\"\\/";
      for (var r = 0; r < e.length; r++)
        if (t.indexOf(e.substring(r, r + 1)) >= 0) return !1;
      return !0;
    },
    validateWishListEmailString: function (e) {
      for (var t = !0, r = e.split(","), s = 0; s < r.length; s++)
        MessageHelper.isValidEmail(r[s]) || (t = !1);
      return t;
    },
  }),
  (MyAccountControllersDeclarationJS = {
    declareProcessedOrdersStatusDisplayRefreshArea: function () {
      var e = $("#ProcessedOrdersStatusDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "ProcessedOrdersStatusDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "ProcessedOrdersStatusDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareWaitingForApprovalOrdersStatusDisplayRefreshArea: function () {
      var e = $("#WaitingForApprovalOrdersStatusDisplay"),
        t = wcRenderContext.getRenderContextProperties(
          "WaitingForApprovalOrdersStatusDisplay_Context"
        ),
        r = function () {
          wcRenderContext.testForChangedRC(
            "WaitingForApprovalOrdersStatusDisplay_Context",
            ["beginIndex"]
          ) && e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
  }),
  (MyAccountDisplay = {
    contextChanged: !1,
    isHistory: !1,
    currentSelection: "",
    currentTabId: "PreviouslyProcessed",
    isPreferredLanguageUpdated: !1,
    dropDownDlg: null,
    currentOrderTabId: "recurring_order_details",
    subscriptionDate: "",
    subscriptionOrderId: "",
    subscriptionOrderItemId: "",
    setPreferredLanguageUpdated: function (e) {
      this.isPreferredLanguageUpdated = e;
    },
    getPreferredLanguageUpdated: function () {
      return this.isPreferredLanguageUpdated;
    },
    setSubscriptionDate: function (e) {
      this.subscriptionDate = e;
    },
    getLastRecordInfo: function (e, t, r, s) {
      var a;
      r.split(";");
      return (
        s
          ? 1 == e || "" == e || void 0 == e
            ? (a = "" != t && void 0 != t ? t : " ")
            : "" != r &&
              void 0 != r &&
              (a =
                "" != t && void 0 != t
                  ? r.concat(";").concat(t)
                  : r.concat(";").concat(" "))
          : "" != r &&
            void 0 != r &&
            (a =
              r.lastIndexOf(";") > -1
                ? r.substring(0, r.lastIndexOf(";"))
                : ""),
        a
      );
    },
    updateRenderContextForPagination: function (e, t, r, s, a, i, n, o, d) {
      var l,
        c = this.getLastRecordInfo(a, i, n, o);
      (l = o ? parseInt(t) + parseInt(r) : parseInt(t) - parseInt(r)),
        wcRenderContext.updateRenderContext(e, {
          beginIndex: l,
          pageSize: r,
          isQuote: s,
          lastExternalOrderIds: c,
          recordSetTotal: d,
        });
    },
    escapeXML: function (e) {
      return e
        ? e
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/\"/g, "&quot;")
            .replace(/\'/g, "&#039;")
        : ProcessAuthoringConstants.EMPTY;
    },
    getSubscriptionDate: function () {
      var e = parseInt(this.subscriptionDate.substring(0, 4), 10),
        t = parseInt(this.subscriptionDate.substring(5, 7), 10),
        r = parseInt(this.subscriptionDate.substring(8, 10), 10);
      2 == t
        ? e % 4 == 0 && e % 100 != 0 && e % 400 == 0
          ? 29 != r
            ? ((r += 1), 10 > r && (r = "0" + r), (t = "02"))
            : ((r = "01"), (t = "03"))
          : 28 != r
          ? ((r += 1), 10 > r && (r = "0" + r), (t = "02"))
          : ((r = "01"), (t = "03"))
        : 12 == t
        ? 31 != r
          ? ((r += 1), 10 > r && (r = "0" + r), (t = "12"))
          : ((r = "01"), (t = "01"), (e += 1))
        : 4 == t || 6 == t || 9 == t || 11 == t
        ? (30 != r
            ? ((r += 1), 10 > r && (r = "0" + r))
            : ((r = "01"), (t += 1)),
          10 > t && (t = "0" + t))
        : (31 != r
            ? ((r += 1), 10 > r && (r = "0" + r))
            : ((r = "01"), (t += 1)),
          10 > t && (t = "0" + t));
      var s = this.subscriptionDate.indexOf("T", 0),
        a = this.subscriptionDate.indexOf("Z", s),
        i = this.subscriptionDate.substring(s + 1, a),
        n = e + "-" + t + "-" + r + "T" + i + "Z";
      return n;
    },
    setOff: function (e) {
      (document.getElementById(e + "_On").style.display = "none"),
        (document.getElementById(e + "_Off").style.display = "inline"),
        (document.getElementById(e).style.display = "none");
    },
    setOn: function (e) {
      (document.getElementById(e + "_On").style.display = "inline"),
        (document.getElementById(e + "_Off").style.display = "none"),
        (document.getElementById(e).style.display = "block");
    },
    selectTab: function (e) {
      (this.currentSelection = "trackOrderStatus"),
        this.setOff(this.currentTabId),
        this.setOn(e),
        (this.currentTabId = e);
    },
    prepareOrderCopy: function (e) {
      submitRequest() &&
        (cursor_wait(),
        wcService.getServiceById("OrderCopy").setUrl(e),
        wcService.invoke("OrderCopy"));
    },
    prepareSSFSOrderCopy: function (e) {
      submitRequest() &&
        (cursor_wait(),
        wcService.getServiceById("SSFSOrderCopy").setUrl(e),
        wcService.invoke("SSFSOrderCopy"));
    },
    prepareSubscriptionRenew: function (e) {
      submitRequest() &&
        (cursor_wait(),
        (wcService.getServiceById("SubscriptionRenew").url = e),
        wcService.invoke("SubscriptionRenew"));
    },
    cancelScheduledOrder: function (e) {
      if (submitRequest()) {
        cursor_wait();
        var t = [];
        (t.orderId = e),
          (t.URL = ""),
          (t.storeId = MyAccountServicesDeclarationJS.storeId),
          (t.catalogId = MyAccountServicesDeclarationJS.catalogId),
          (t.langId = MyAccountServicesDeclarationJS.langId),
          wcService.invoke("AjaxScheduledOrderCancel", t);
      }
    },
    changeSelection: function (e) {
      var t = e.indexOf("currentSelection", 0);
      if ("-1" != t)
        var r = e.indexOf("Slct", t),
          s = e.substring(t + 17, r);
      if (
        (this.currentSelection &&
          (document
            .getElementById(this.currentSelection)
            .setAttribute("class", ""),
          document
            .getElementById(this.currentSelection)
            .setAttribute("className", "")),
        (document.getElementById("MyAccountBreadcrumbLink").style.display =
          "none"),
        document.getElementById("RecurringOrderBreadcrumb") &&
          ((document.getElementById("RecurringOrderBreadcrumb").style.display =
            "none"),
          (document.getElementById("RecurringOrderBreadcrumb1").style.display =
            "none")),
        document.getElementById("SubscriptionBreadcrumb") &&
          ((document.getElementById("SubscriptionBreadcrumb").style.display =
            "none"),
          (document.getElementById("SubscriptionBreadcrumb1").style.display =
            "none")),
        document.getElementById("OrderHistoryBreadcrumb") &&
          ((document.getElementById("OrderHistoryBreadcrumb").style.display =
            "none"),
          (document.getElementById("OrderHistoryBreadcrumb1").style.display =
            "none")),
        s)
      )
        if ("trackOrderStatus" == s)
          document.getElementById("OrderHistoryBreadcrumb1").style.display =
            "inline";
        else if ("OrderDetail" == s) {
          document.getElementById("OrderHistoryBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "OrderHistoryDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else if ("trackRecurringOrderStatus" == s)
          document.getElementById("RecurringOrderBreadcrumb1").style.display =
            "inline";
        else if ("RecurringOrderDetail" == s) {
          document.getElementById("RecurringOrderBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "RecurringOrderDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else if ("trackSubscriptionStatus" == s)
          document.getElementById("SubscriptionBreadcrumb1").style.display =
            "inline";
        else if ("SubscriptionDetail" == s) {
          document.getElementById("SubscriptionBreadcrumb").style.display =
            "inline";
          var a = e.indexOf("breadCrumb", 0);
          if ("-1" != a)
            var i = e.indexOf("Brcmb", a),
              n = e.substring(a + 11, i);
          (n = n.replace(/%[0-9]*B/g, " ")),
            (document.getElementById(
              "SubscriptionDetailBreadcrumbLink"
            ).innerHTML = n.replace(/\+/g, " "));
        } else
          document.getElementById(s) &&
            ((document.getElementById("MyAccountBreadcrumbLink").style.display =
              "inline"),
            document.getElementById(s).setAttribute("class", "strong"),
            document.getElementById(s).setAttribute("className", "strong"),
            (this.currentSelection = s));
      else
        document.getElementById("MyAccountBreadcrumbLink").style.display =
          "inline";
    },
    prepareSubmit: function (e, t, r) {
      if (
        AddressHelper.validateAddressForm(e) &&
        (e.sendMeEmail && e.sendMeEmail.checked
          ? (e.receiveEmail.value = !0)
          : (e.receiveEmail.value = !1),
        e.sendMeSMSNotification && e.sendMeSMSNotification.checked
          ? (e.receiveSMSNotification.value = !0)
          : (e.receiveSMSNotification.value = !1),
        e.sendMeSMSPreference && e.sendMeSMSPreference.checked
          ? (e.receiveSMS.value = !0)
          : (e.receiveSMS.value = !1),
        (null == e.mobileDeviceEnabled ||
          "true" != e.mobileDeviceEnabled.value ||
          this.validateMobileDevice(e)) &&
          (null == e.birthdayEnabled ||
            "true" != e.birthdayEnabled.value ||
            this.validateBirthday(e)) &&
          submitRequest() &&
          (processAndSubmitForm(e),
          "true" != CSRWCParamJS.env_shopOnBehalfSessionEstablished))
      ) {
        var s = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        trim(s) != e.firstName.value + " " + e.lastName.value &&
          setCookie(
            "WC_LogonUserId_" + WCParamJS.storeId,
            e.firstName.value + " " + e.lastName.value,
            {
              path: "/",
              domain: cookieDomain,
            }
          );
      }
    },
    popupWindow: function (e) {
      window.open(e, "mywindow", "status=1,scrollbars=1,resizable=1");
    },
    deleteCoupon: function (e, t) {
      var r = document.forms[e];
      if (((r.couponId.value = t), (r.taskType.value = "D"), submitRequest())) {
        var s = wcService.getServiceById("AjaxRESTWalletCouponsDelete");
        s.setFormId(e),
          cursor_wait(),
          wcService.invoke("AjaxRESTWalletCouponsDelete");
      }
    },
    cancelRecurringOrder: function (e, t) {
      if (submitRequest()) {
        cursor_wait(),
          $("[data-widget-type='wc.WCDialog'][data-popupIndex='" + t + "']")
            .data("wc-WCDialog")
            .destroy();
        var r = {
          subscriptionId: e,
          URL: "",
          storeId: MyAccountServicesDeclarationJS.storeId,
          catalogId: MyAccountServicesDeclarationJS.catalogId,
          langId: MyAccountServicesDeclarationJS.langId,
        };
        wcService.invoke("AjaxCancelSubscription", r);
      }
    },
    updateContract: function (e, t, r) {
      var s = document.forms[e],
        a = !1;
      if (submitRequest()) {
        if (void 0 != s.contractId.length) {
          for (var i = 0; i < s.contractId.length; i++)
            if (s.contractId[i].checked) {
              a = !0;
              break;
            }
          if (!a) {
            for (var n = t.split(";"), o = 0; o < n.length; o++)
              document.getElementById(
                "WC_B2BMyAccountParticipantRole_checkbox_" + n[o]
              ).checked = !0;
            MessageHelper.displayErrorMessage(r), resetRequest();
          }
        } else
          s.contractId.checked
            ? (a = !0)
            : ((document.getElementById(
                "WC_B2BMyAccountParticipantRole_checkbox_" + s.contractId.value
              ).checked = !0),
              MessageHelper.displayErrorMessage(r),
              resetRequest());
        a && processAndSubmitForm(s);
      }
    },
    updateOrganization: function (e) {
      var t = document.forms[e];
      submitRequest() && processAndSubmitForm(t);
    },
    HistoryTracker: function (e, t, r) {
      (this.workAreaModeValue = e), (this.elementId = t), (this.changeUrl = r);
    },
    validateBirthday: function (e) {
      if (
        null != e.birth_year &&
        null != e.birth_month &&
        null != e.birth_date
      ) {
        if (
          0 != e.birth_year.value ||
          0 != e.birth_month.value ||
          0 != e.birth_date.value
        ) {
          if (0 == e.birth_month.value)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_month.id + "-button",
                MessageHelper.messages.ERROR_SpecifyMonth
              ),
              !1
            );
          if (0 == e.birth_date.value)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_SpecifyDate
              ),
              !1
            );
          var t = 29;
          0 != e.birth_year.value && e.birth_year.value % 4 != 0 && (t = 28);
          for (var r = ["4", "6", "9", "11"], s = !1, a = 0; a < r.length; a++)
            if (r[a] == e.birth_month.value) {
              s = !0;
              break;
            }
          if (s && e.birth_date.value > 30)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_InvalidDate1
              ),
              !1
            );
          if (2 == e.birth_month.value && e.birth_date.value > t)
            return (
              MessageHelper.formErrorHandleClient(
                e.birth_date.id + "-button",
                MessageHelper.messages.ERROR_InvalidDate1
              ),
              !1
            );
          if (
            null != e.curr_year &&
            null != e.curr_month &&
            null != e.curr_date
          ) {
            var i = parseInt(e.birth_year.value),
              n = parseInt(e.birth_month.value),
              o = parseInt(e.birth_date.value),
              d = parseInt(e.curr_year.value),
              l = parseInt(e.curr_month.value),
              c = parseInt(e.curr_date.value);
            if (i > d)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_year.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (i == d && n > l)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_month.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (i == d && n == l && o > c)
              return (
                MessageHelper.formErrorHandleClient(
                  e.birth_date.id + "-button",
                  MessageHelper.messages.ERROR_InvalidDate2
                ),
                !1
              );
            if (null != e.dateOfBirthTemp)
              if (0 != e.birth_month.value && 0 != e.birth_date.value) {
                var u = i,
                  m = n,
                  g = o;
                0 == i && (u = 1896),
                  10 > n && (m = "0" + n),
                  10 > o && (g = "0" + o),
                  (e.dateOfBirthTemp.value = u + "-" + m + "-" + g),
                  (document.getElementById(e.dateOfBirthTemp.id).name =
                    "dateOfBirth");
              } else e.dateOfBirthTemp.value = null;
          }
          return !0;
        }
        if (null != e.dateOfBirthTemp) {
          e.dateOfBirthTemp.value = "";
          if (null != document.getElementById(e.dateOfBirthTemp.id)) {
            document.getElementById(e.dateOfBirthTemp.id).name = "dateOfBirth";
          }
        }

        return (isGDPR && !gdpr_error) || !isGDPR;
      }
      return !0;
    },
    validateMobileDevice: function (e) {
      if (null != e.mobilePhone1 && "" != e.mobilePhone1) {
        if (!MessageHelper.isValidUTF8length(e.mobilePhone1.value, 32))
          return (
            MessageHelper.formErrorHandleClient(
              e.mobilePhone1.id,
              MessageHelper.messages.ERROR_PhoneTooLong
            ),
            !1
          );
        if (!MessageHelper.IsValidPhone(e.mobilePhone1.value))
          return (
            MessageHelper.formErrorHandleClient(
              e.mobilePhone1.id,
              MessageHelper.messages.ERROR_INVALIDPHONE
            ),
            !1
          );
      }
      return !0;
    },
    showActionsPopup: function (e, t) {
      if (null == e || e.keyCode == KeyCodes.DOWN_ARROW) {
        var r = $("#" + t).data("wc-WCDialog");
        r && ((this.dropDownDlg = r), this.dropDownDlg.open());
      }
    },
    showPopup: function (e, t, r, s) {
      var a = $("#Cancel_" + e + "_popup").data("wc-WCDialog");
      null != a
        ? (closeAllDialogs(),
          a.element.attr("data-popupIndex", r),
          a.open(),
          document
            .getElementById("Cancel_yes_" + e)
            .setAttribute(
              "onclick",
              "MyAccountDisplay.cancelRecurringOrder(" + t + "," + r + ");"
            ),
          document.getElementById("cancel_notice_" + e) &&
            document.getElementById(s) &&
            $("#cancel_notice_" + e).html($("#" + s).val()))
        : console.debug("Cancel_subscription_popup does not exist");
    },
    selectRecurringOrderTab: function (e) {
      this.setOff(this.currentOrderTabId),
        this.setOn(e),
        (this.currentOrderTabId = e);
    },
  }),
  (MyAccountServicesDeclarationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
  }),
  wcService.declare({
    id: "InterestItemDelete",
    actionId: "InterestItemDelete",
    url: "AjaxInterestItemDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.displayStatusMessage(
        MessageHelper.messages.WISHLIST_REMOVEITEM
      );
      for (var t in e) console.debug(t + "=" + e[t]);
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxInterestItemAdd",
    actionId: "AjaxInterestItemAdd",
    url: "AjaxInterestItemAdd",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.WISHLIST_ADDED
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "InterestItemListMessage",
    actionId: "InterestItemListMessage",
    url: "AjaxInterestItemListMessage",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AddBillingAddress",
    actionId: "AddBillingAddress",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "AddShippingAddress",
    actionId: "AddShippingAddress",
    url: "AjaxPersonChangeServiceAddressAdd",
    formId: "",
    successHandler: function (e) {
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "UpdateBillingAddress",
    actionId: "UpdateBillingAddress",
    url: "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      console.log("PSL::store.js::UpdateBillingAddress::successHandler::");
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
      /* HB-407 BEGIN */
      resetRequest();
      javascript: AddressHelper.saveAddress(
        "UpdateShippingAddress",
        "shippingAddressCreateEditFormDiv_1"
      );
      /* HB-407 END */
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "UpdateShippingAddress",
    actionId: "UpdateShippingAddress",
    url: "AjaxPersonChangeServiceAddressUpdate",
    formId: "",
    successHandler: function (e) {
      console.log("store.js::UpdateShippingAddress::successHandler");
      CheckoutHelperJS.updateAddressIdForOrderItem(e.addressId);
    },
    failureHandler: function (e) {
      console.log("store.js::UpdateShippingAddress::failureHandler");
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey);
    },
  }),
  wcService.declare({
    id: "AjaxCouponsAddRemove",
    actionId: "AjaxCouponsAddRemove",
    url: "AjaxCouponsAddRemove",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxRESTWalletCouponsDelete",
    actionId: "AjaxCouponsAddRemove",
    url: "AjaxRESTWalletCouponsDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxWalletItemProcessServiceDelete",
    actionId: "AjaxWalletItemProcessServiceDelete",
    url: "AjaxWalletItemProcessServiceDelete",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(), cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxCancelSubscription",
    actionId: "AjaxCancelSubscription",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        closeAllDialogs(),
        "RecurringOrder" == e.subscriptionType
          ? "PendingCancel" == e.state
            ? MessageHelper.displayStatusMessage(
                MessageHelper.messages.SCHEDULE_ORDER_PENDING_CANCEL_MSG
              )
            : MessageHelper.displayStatusMessage(
                MessageHelper.messages.SCHEDULE_ORDER_CANCEL_MSG
              )
          : "PendingCancel" == e.state
          ? MessageHelper.displayStatusMessage(
              MessageHelper.messages.SUBSCRIPTION_PENDING_CANCEL_MSG
            )
          : MessageHelper.displayStatusMessage(
              MessageHelper.messages.SUBSCRIPTION_CANCEL_MSG
            );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "OrderCopy",
    actionId: "OrderCopy",
    url: "AjaxRESTOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      if (null != e.newOrderItemsCount && e.newOrderItemsCount <= 0)
        MessageHelper.displayErrorMessage(
          MessageHelper.messages.CANNOT_REORDER_ANY_MSG
        );
      else {
        setDeleteCartCookie();
        var r = [],
          s = "AjaxRESTOrderPrepare",
          a = [];
        (a.orderId = e.orderId),
          r.push({
            URL: "AjaxCheckoutDisplayView",
            requestType: "GET",
            requestParams: {},
          });
        var i = getCustomServiceForURLChaining(s, r, null);
        wcService.invoke(i.getParam("id"), a);
      }
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SSFSOrderCopy",
    actionId: "SSFSOrderCopy",
    url: "AjaxSSFSOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      setDeleteCartCookie(),
        (document.location.href = appendWcCommonRequestParameters(
          "AjaxCheckoutDisplayView?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId
        ));
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.INVALID_CONTRACT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SubscriptionRenew",
    actionId: "SubscriptionRenew",
    url: "AjaxRESTOrderCopy",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      var r = [];
      (r.storeId = MyAccountServicesDeclarationJS.storeId),
        (r.catalogId = MyAccountServicesDeclarationJS.catalogId),
        (r.langId = MyAccountServicesDeclarationJS.langId),
        (r.orderId = e.orderId),
        (r.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
        (r.requestedShipDate = MyAccountDisplay.getSubscriptionDate()),
        (MyAccountDisplay.subscriptionOrderId = e.orderId),
        (MyAccountDisplay.subscriptionOrderItemId = e.orderItemId[0]),
        wcService.invoke("SetRequestedShippingDate", r);
    },
    failureHandler: function (e) {
      "_ERR_PROD_NOT_ORDERABLE" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.PRODUCT_NOT_BUYABLE
          )
        : "_ERR_INVALID_ADDR" == e.errorMessageKey
        ? MessageHelper.displayErrorMessage(
            MessageHelper.messages.INVALID_CONTRACT
          )
        : e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "SetRequestedShippingDate",
    actionId: "SetRequestedShippingDate",
    url: "AjaxRESTOrderShipInfoUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        (document.location.href = appendWcCommonRequestParameters(
          "RESTOrderPrepare?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId +
            "&orderId=" +
            e.orderId +
            "&URL=AjaxCheckoutDisplayView?langId=" +
            MyAccountServicesDeclarationJS.langId +
            "&storeId=" +
            MyAccountServicesDeclarationJS.storeId +
            "&catalogId=" +
            MyAccountServicesDeclarationJS.catalogId
        ));
    },
    failureHandler: function (e) {
      if (
        "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET" == e.errorMessageKey
      ) {
        var t = [];
        (t.storeId = MyAccountServicesDeclarationJS.storeId),
          (t.catalogId = MyAccountServicesDeclarationJS.catalogId),
          (t.langId = MyAccountServicesDeclarationJS.langId),
          (t.orderId = MyAccountDisplay.subscriptionOrderId),
          (t.orderItemId = MyAccountDisplay.subscriptionOrderItemId),
          (t.calculationUsage = "-1,-2,-3,-4,-5,-6,-7"),
          wcService.invoke("RemoveSubscriptionItem", t),
          MessageHelper.displayStatusMessage(
            MessageHelper.messages.CANNOT_RENEW_NOW_MSG
          );
      } else
        e.errorMessage
          ? MessageHelper.displayErrorMessage(e.errorMessage)
          : e.errorMessageKey &&
            MessageHelper.displayErrorMessage(e.errorMessageKey),
          cursor_clear();
    },
  }),
  wcService.declare({
    id: "RemoveSubscriptionItem",
    actionId: "RemoveSubscriptionItem",
    url: "AjaxRESTOrderItemDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear();
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        e.errorCode && wcTopic.publish("OrderError", e),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxScheduledOrderCancel",
    actionId: "AjaxScheduledOrderCancel",
    url: "AjaxRESTRecurringOrSubscriptionCancel",
    formId: "",
    successHandler: function (e) {
      MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.MO_ORDER_CANCELED_MSG
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  (QuickCheckoutProfile = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    pageVar: "aa",
    changed: "false",
    setCommonParameters: function (e, t, r) {
      (this.langId = e), (this.storeId = t), (this.catalogId = r);
    },
    valueChanged: function (e) {
      QuickCheckoutProfile.changed = e;
    },
    validateForm: function (e) {
      reWhiteSpace = new RegExp(/^\s+$/);
      var t = document.forms[e],
        r = null;
      null != t.pay_expire_year &&
        (r = new Date(
          t.pay_expire_year.value,
          t.pay_expire_month.value - 1,
          1
        ));
      var s = t.curr_month.value;
      if (
        ((s = 1 == s.length ? "0" + s : t.curr_month.value),
        !AddressHelper.validateAddressForm(t, "billing_"))
      )
        return !1;
      if (!AddressHelper.validateAddressForm(t, "shipping_")) return !1;
      var a = $("#payMethodId");
      if (null != a.find(":selected").val()) {
        if (
          (null != t.pay_temp_account &&
            reWhiteSpace.test(t.pay_temp_account.value)) ||
          "" == t.pay_temp_account.value
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_temp_account.id,
              MessageHelper.messages.REQUIRED_FIELD_ENTER
            ),
            !1
          );
        if (
          ("true" == QuickCheckoutProfile.changed
            ? (t.pay_temp_account.name = "pay_account")
            : (QuickCheckoutProfile.changed = "false"),
          null != t.pay_expire_year &&
            t.pay_expire_year.value < t.curr_year.value)
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_expire_year.id,
              MessageHelper.messages.INVALID_EXPIRY_DATE
            ),
            !1
          );
        if (
          null != t.pay_expire_year &&
          t.pay_expire_year.value == t.curr_year.value &&
          s > t.pay_expire_month.value
        )
          return (
            MessageHelper.formErrorHandleClient(
              t.pay_expire_month.id,
              MessageHelper.messages.INVALID_EXPIRY_DATE
            ),
            !1
          );
      }
      return !0;
    },
    getCurrentProfile: function (e, t) {
      var r = $("input[name=" + t + "_firstName]")[0],
        s = $("input[name=" + t + "_lastName]")[0],
        a = $("input[name=" + t + "_address1]")[0],
        i = $("input[name=" + t + "_address2]")[0],
        n = $("input[name=" + t + "_zipCode]")[0],
        o = $("input[name=" + t + "_email1]")[0],
        d = $("input[name=" + t + "_phone1]")[0],
        l = $("input[name=" + t + "_city]")[0],
        c = "";
      $("input[name=" + t + "_middleName]")[0] &&
        (c = $("input[name=" + t + "_middleName]")[0]),
        (r.value = e.firstName),
        (s.value = e.lastName),
        (a.value = e.address1),
        (i.value = e.address2),
        (n.value = e.zipCode),
        (o.value = e.email1),
        (d.value = e.phone1),
        (l.value = e.city),
        c && (c.value = e.middleName);
      var u =
          t +
          "_WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
          t +
          "_state_1",
        m = $("#" + u);
      if (
        ("" != e.state &&
          (void 0 !== m && null !== m
            ? (m.val(e.state), m.Select("refresh_noResizeButton"))
            : ((m = $("input[name=" + t + "_state]")[0].val()),
              m.val(e.state))),
        "" != e.country)
      ) {
        var g = $(
          "#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
            t +
            "_country_1"
        );
        g.val(e.country),
          g.Select("refresh_noResizeButton"),
          AddressHelper.loadAddressFormStatesUI(
            "QuickCheckout",
            t + "_",
            t + "_stateDiv",
            "WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_" +
              t +
              "_state_1",
            !1,
            e.state
          );
      }
    },
    showHide: function (e) {
      var t = document.getElementById("SameShippingAndBillingAddress");
      t.checked
        ? (hideElementById("shipAddr"), this.copyBillingAddress(e))
        : (showElementById("shipAddr"),
          ($("input[name=shipping_firstName]")[0].value = ""),
          ($("input[name=shipping_lastName]")[0].value = ""),
          ($("input[name=shipping_address1]")[0].value = ""),
          ($("input[name=shipping_address2]")[0].value = ""),
          ($("input[name=shipping_city]")[0].value = ""),
          ($("input[name=shipping_zipCode]")[0].value = ""),
          ($("input[name=shipping_phone1]")[0].value = ""),
          ($("input[name=shipping_email1]")[0].value = ""),
          ($("select,input[name=shipping_state]")[0].value = ""),
          $("input[name=shipping_middleName]")[0] &&
            ($("input[name=shipping_middleName]")[0].value = ""));
    },
    copyBillingAddress: function (e) {
      ($("input[name=shipping_firstName]")[0].value =
        e.billing_firstName.value),
        ($("input[name=shipping_lastName]")[0].value =
          e.billing_lastName.value),
        ($("input[name=shipping_address1]")[0].value =
          e.billing_address1.value),
        ($("input[name=shipping_address2]")[0].value =
          e.billing_address2.value),
        ($("input[name=shipping_city]")[0].value = e.billing_city.value),
        ($("input[name=shipping_zipCode]")[0].value = e.billing_zipCode.value),
        ($("input[name=shipping_phone1]")[0].value = e.billing_phone1.value),
        ($("input[name=shipping_email1]")[0].value = e.billing_email1.value),
        $("input[name=shipping_middleName]")[0] &&
          ($("input[name=shipping_middleName]")[0].value =
            e.billing_middleName.value);
      var t = $(
        "#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_country_1"
      );
      t.val(e.billing_country.value),
        t.Select("refresh_noResizeButton"),
        AddressHelper.loadAddressFormStatesUI(
          "QuickCheckout",
          "shipping_",
          "shipping_stateDiv",
          "WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_state_1",
          !1,
          e.billing_state.value
        );
    },
    UpdateProfile: function (e) {
      var t = document.getElementById("SameShippingAndBillingAddress");
      if (
        (t.checked && this.copyBillingAddress(e), this.validateForm(e.name))
      ) {
        var r,
          s = $("#payMethodId");
        if (
          (0 !== s.length && (r = s.val()),
          (e.pay_payment_method.value = r),
          (e.pay_cc_brand.value = r),
          (e.pay_payMethodId.value = r),
          !submitRequest())
        )
          return;
        processAndSubmitForm(e);
      }
    },
  }),
  (sterlingIntegrationJS = {
    langId: "-1",
    storeId: "",
    catalogId: "",
    locale: "",
    jspStoreImgDir: "",
    orderBeingCanceled: "",
    setCommonParameters: function (e, t, r, s, a) {
      (this.langId = e),
        (this.storeId = t),
        alert("-1 " + this.storeId),
        (this.catalogId = r),
        (this.locale = s),
        (this.jspStoreImgDir = a);
    },
    populateOrderLevelInfo: function (orderStr) {
      var jsonOrder = eval("(" + orderStr + ")"),
        locale = document.getElementById("Locale_String").innerHTML,
        shipmentType = 2;
      this.isNullObj(jsonOrder.Root.Order.shipmentTypeId) ||
        (shipmentType = jsonOrder.Root.Order.shipmentTypeId);
      var pmTotalNumber = 0;
      this.isNullObj(jsonOrder.Root.Order.countOfPaymentMethods) ||
        (pmTotalNumber = jsonOrder.Root.Order.countOfPaymentMethods);
      var oiTotalNumber = 1;
      if (
        (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
          (oiTotalNumber = jsonOrder.Root.Order.countOfOrderLines),
        !this.isNullObj(jsonOrder.Root.Order.OrderNo))
      ) {
        var orderNo = jsonOrder.Root.Order.OrderNo;
        if (this.isNullObj(jsonOrder.Root.Order.EntryType))
          document.getElementById("OrderNo").innerHTML = orderNo;
        else {
          var entryType = jsonOrder.Root.Order.EntryType;
          "WCS" == entryType
            ? (document.getElementById("OrderNo").innerHTML =
                orderNo.substring(3))
            : (document.getElementById("OrderNo").innerHTML = orderNo);
        }
      }
      if (!this.isNullObj(jsonOrder.Root.Order.OrderDate)) {
        var orderDate = jsonOrder.Root.Order.OrderDate,
          parsedOrderDate = new Date(orderDate);
        document.getElementById("OrderDate").innerHTML = Globalize.formatDate(
          parsedOrderDate,
          {
            date: "long",
          }
        );
      }
      if (1 == shipmentType) {
        var shippingAddress = null,
          orderLinePersonInfoShipTo = null;
        this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
          (this.isNullObj(
            jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo
          )
            ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0]) ||
              this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo
              ) ||
              (orderLinePersonInfoShipTo =
                jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo)
            : (orderLinePersonInfoShipTo =
                jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo)),
          this.isNullObj(orderLinePersonInfoShipTo)
            ? this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo) ||
              this.populateAddress(
                jsonOrder.Root.Order.PersonInfoShipTo,
                "Single_Shipping_Address",
                locale
              )
            : this.populateAddress(
                orderLinePersonInfoShipTo,
                "Single_Shipping_Address",
                locale
              );
        var shippingMethod = null;
        if (
          (this.isNullObj(jsonOrder.Root.Order.Shipments) ||
            this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment) ||
            (this.isNullObj(
              jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription
            )
              ? this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0]) ||
                this.isNullObj(
                  jsonOrder.Root.Order.Shipments.Shipment[0].shipModeDescription
                ) ||
                (shippingMethod =
                  jsonOrder.Root.Order.Shipments.Shipment[0]
                    .shipModeDescription)
              : (shippingMethod =
                  jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription)),
          this.isNullObj(shippingMethod) &&
            (this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
              (this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine.shipModeDescription
              )
                ? this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                  ) ||
                  this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                      .shipModeDescription
                  ) ||
                  (shippingMethod =
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                      .shipModeDescription)
                : (shippingMethod =
                    jsonOrder.Root.Order.OrderLines.OrderLine
                      .shipModeDescription))),
          this.isNullObj(shippingMethod) &&
            (this.isNullObj(jsonOrder.Root.Order.CarrierServiceCode) ||
              (shippingMethod = jsonOrder.Root.Order.shipModeDescription)),
          this.isNullObj(shippingMethod) ||
            (document.getElementById("Single_Shipping_Method").innerHTML =
              shippingMethod),
          !this.isNullObj(
            document.getElementById("Single_Shipping_Instruction")
          ))
        ) {
          var instructions = null;
          if (
            (this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine) ||
              (this.isNullObj(
                jsonOrder.Root.Order.OrderLines.OrderLine.Instructions
              )
                ? this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0]
                  ) ||
                  this.isNullObj(
                    jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions
                  ) ||
                  (instructions =
                    jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions)
                : (instructions =
                    jsonOrder.Root.Order.OrderLines.OrderLine.Instructions)),
            !this.isNullObj(instructions) &&
              !this.isNullObj(instructions.Instruction))
          ) {
            var instruction = instructions.Instruction;
            if (this.isNullObj(instruction.InstructionType)) {
              if (!this.isNullObj(instructions.Instruction[0]))
                for (var k in instructions.Instruction)
                  this.isNullObj(instructions.Instruction[k].InstructionType) ||
                    ("SHIP" == instructions.Instruction[k].InstructionType &&
                      (this.isNullObj(
                        instructions.Instruction[k].InstructionText
                      ) ||
                        ((document.getElementById(
                          "Single_Shipping_Instruction_Label"
                        ).style.display = "inline"),
                        (document.getElementById(
                          "Single_Shipping_Instruction"
                        ).innerHTML =
                          document.getElementById("Single_Shipping_Instruction")
                            .innerHTML +
                          instructions.Instruction[k].InstructionText +
                          "<br/>"))));
            } else
              "SHIP" == instruction.InstructionType &&
                (this.isNullObj(instruction.InstructionText) ||
                  ((document.getElementById(
                    "Single_Shipping_Instruction_Label"
                  ).style.display = "inline"),
                  (document.getElementById(
                    "Single_Shipping_Instruction"
                  ).innerHTML = instruction.InstructionText)));
          }
        }
      }
      if (
        !this.isNullObj(document.getElementById("Shipping_As_Complete_Y")) &&
        !this.isNullObj(jsonOrder.Root.Order.IsShipComplete)
      ) {
        var shipAsComplete = jsonOrder.Root.Order.IsShipComplete;
        "Y" == shipAsComplete
          ? ((document.getElementById("Shipping_As_Complete_Y").style.display =
              "inline"),
            (document.getElementById("Shipping_As_Complete_N").style.display =
              "none"))
          : ((document.getElementById("Shipping_As_Complete_Y").style.display =
              "none"),
            (document.getElementById("Shipping_As_Complete_N").style.display =
              "inline"));
      }
      var currencyCode = "USD";
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
        (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
      var currencyDecimals = 2;
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
        (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
      var currencySymbol = "$";
      this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
        (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.LineSubTotal) ||
          (document.getElementById("Order_SubTotal").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.LineSubTotal,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            ));
      var grandDiscount = jsonOrder.Root.Order.OverallTotals.GrandDiscount;
      this.isNullObj(grandDiscount) ||
        (grandDiscount > 0 && (grandDiscount = 0 - grandDiscount),
        (document.getElementById("Order_Discount").innerHTML =
          this.formatCurrency(
            grandDiscount,
            currencyDecimals,
            currencySymbol,
            currencyCode,
            locale
          ))),
        this.isNullObj(
          jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge
        ) ||
          (document.getElementById("Order_Shipping").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.salesTax) ||
          (document.getElementById("Order_Tax").innerHTML = this.formatCurrency(
            jsonOrder.Root.Order.OverallTotals.salesTax,
            currencyDecimals,
            currencySymbol,
            currencyCode,
            locale
          )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.shippingTax) ||
          (document.getElementById("Order_ShippingTax").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.shippingTax,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        this.isNullObj(jsonOrder.Root.Order.OverallTotals.GrandTotal) ||
          (document.getElementById("Order_Totals").innerHTML =
            this.formatCurrency(
              jsonOrder.Root.Order.OverallTotals.GrandTotal,
              currencyDecimals,
              currencySymbol,
              currencyCode,
              locale
            )),
        0 == pmTotalNumber &&
          (this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo) ||
            this.populateAddress(
              jsonOrder.Root.Order.PersonInfoBillTo,
              "Billing_Address_With_No_Payment_Method",
              locale
            ));
      for (var i = 0; pmTotalNumber > i; i++) {
        var paymentMethod = null;
        (paymentMethod =
          1 == pmTotalNumber
            ? jsonOrder.Root.Order.PaymentMethods.PaymentMethod
            : jsonOrder.Root.Order.PaymentMethods.PaymentMethod[i]),
          this.isNullObj(paymentMethod.PersonInfoBillTo)
            ? this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo) ||
              this.populateAddress(
                jsonOrder.Root.Order.PersonInfoBillTo,
                "Billing_Address_" + i,
                locale
              )
            : this.populateAddress(
                paymentMethod.PersonInfoBillTo,
                "Billing_Address_" + i,
                locale
              ),
          this.isNullObj(paymentMethod.paymentMethodName) ||
            (document.getElementById("Payment_Method_Name_" + i).innerHTML =
              paymentMethod.paymentMethodName),
          this.isNullObj(paymentMethod.PaymentType) ||
            ("CREDIT_CARD" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "inline"),
              (document.getElementById("Div_Check_" + i).style.display =
                "none"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "none"),
              this.isNullObj(paymentMethod.DisplayCreditCardNo) ||
                (document.getElementById("CreditCard_Account_" + i).innerHTML =
                  "************" + paymentMethod.DisplayCreditCardNo),
              this.isNullObj(paymentMethod.CreditCardExpDate) ||
                ((document.getElementById(
                  "CreditCard_Expiration_Month_" + i
                ).innerHTML = paymentMethod.CreditCardExpDate.substring(0, 2)),
                (document.getElementById(
                  "CreditCard_Expiration_Year_" + i
                ).innerHTML = paymentMethod.CreditCardExpDate.substring(
                  3,
                  7
                )))),
            "Check" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "none"),
              (document.getElementById("Div_Check_" + i).style.display =
                "inline"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "none"),
              this.isNullObj(paymentMethod.DisplayPaymentReference1) ||
                (document.getElementById("Check_Account_" + i).innerHTML =
                  "************" + paymentMethod.DisplayPaymentReference1)),
            "LineOfCreidt" == paymentMethod.PaymentType &&
              ((document.getElementById("Div_CreditCard_" + i).style.display =
                "none"),
              (document.getElementById("Div_Check_" + i).style.display =
                "none"),
              (document.getElementById("Div_LineOfCredit_" + i).style.display =
                "inline"),
              this.isNullObj(paymentMethod.DisplayCustomerAccountNo) ||
                (document.getElementById(
                  "LineOfCredit_Account_" + i
                ).innerHTML =
                  "************" + paymentMethod.DisplayCustomerAccountNo)),
            this.isNullObj(paymentMethod.MaxChargeLimit) ||
              (document.getElementById("Payment_Method_Amount_" + i).innerHTML =
                this.formatCurrency(
                  paymentMethod.MaxChargeLimit,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                )));
      }
    },
    populateAddress: function (e, t, r) {
      var s = "";
      this.isNullObj(e.AddressID) || (s = e.AddressID);
      var a = "";
      this.isNullObj(e.FirstName) || (a = e.FirstName);
      var i = "";
      this.isNullObj(e.MiddleName) || (i = e.MiddleName);
      var n = "";
      this.isNullObj(e.LastName) || (n = e.LastName);
      var o = "";
      this.isNullObj(e.AddressLine1) || (o = e.AddressLine1);
      var d = "";
      this.isNullObj(e.AddressLine2) || (d = e.AddressLine2);
      var l = "";
      this.isNullObj(e.City) || (l = e.City);
      var c = "";
      this.isNullObj(e.stateDisplayName) || (c = e.stateDisplayName);
      var u = "";
      this.isNullObj(e.countryDisplayName) || (u = e.countryDisplayName);
      var m = "";
      this.isNullObj(e.ZipCode) || (m = e.ZipCode);
      var g = "";
      this.isNullObj(e.DayPhone) || (g = e.DayPhone);
      var p = "";
      this.isNullObj(e.EMailID) || (p = e.EMailID);
      var h = "<p>" + s + "</p>";
      "ar_EG" == r
        ? ((a.length > 0 || i.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + i + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          l.length > 0 && (h = h + l + "<br />"),
          c.length > 0 && (h = h + c + "<br />"),
          u.length > 0 && (h = h + u + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : "ja_JP" == r || "ko_KR" == r || "zh_CN" == r || "zh_TW" == r
        ? ((n.length > 0 || a.length > 0) &&
            (h = h + n + "&nbsp;" + a + "<br />"),
          (u.length > 0 || m.length > 0) &&
            (h = h + u + "&nbsp;" + m + "&nbsp;<br />"),
          (c.length > 0 || l.length > 0) &&
            (h = h + c + "&nbsp;" + l + "&nbsp;<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : "de_DE" == r ||
          "es_ES" == r ||
          "fr_FR" == r ||
          "it_IT" == r ||
          "pl_PL" == r ||
          "ro_RO" == r ||
          "ru_RU" == r
        ? ((a.length > 0 || i.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + i + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          (m.length > 0 || l.length > 0) &&
            (h = h + m + "&nbsp;" + l + "&nbsp;<br />"),
          c.length > 0 && (h = h + c + "<br />"),
          u.length > 0 && (h = h + u + "<br />"),
          g.length > 0 && (h = h + g + "<br />"))
        : ((a.length > 0 || n.length > 0) &&
            (h = h + a + "&nbsp;" + n + "<br />"),
          (o.length > 0 || d.length > 0) &&
            (h = h + o + "&nbsp;" + d + "<br />"),
          (l.length > 0 || c.length > 0) &&
            (h = h + l + "&nbsp;" + c + "&nbsp;<br />"),
          (u.length > 0 || m.length > 0) &&
            (h = h + u + "&nbsp;" + m + "&nbsp;<br />"),
          g.length > 0 && (h = h + g + "<br />"),
          p.length > 0 && (h = h + p + "<br />")),
        (document.getElementById(t).innerHTML = h);
    },
    isNullObj: function (e) {
      return null != e && void 0 != typeof e ? !1 : !0;
    },
    formatCurrency: function (e, t, r, s, a) {
      return Utils.formatCurrency(e, {
        minimumFractionDigits: parseInt(t),
        maximumFractionDigits: parseInt(t),
        currency: s,
        locale: a,
      });
    },
    revertAllSpecialChars: function (e) {
      return this.isNullObj(e)
        ? e
        : e
            .replace(/&#62;/g, ">")
            .replace(/&#60;/g, "<")
            .replace(/&#39;/g, "'")
            .replace(/&#34;/g, '"')
            .replace(/&#92;/g, "\\")
            .replace(/&#38;/g, "&");
    },
    populateOrderLineInfoForSingleShipment: function (
      orderStr,
      beginIndex,
      pageSize
    ) {
      if (null != orderStr && "" !== orderStr) {
        orderStr = orderStr.replace("'", "27%");
        var jsonOrder = eval("(" + orderStr + ")"),
          imgDir = document.getElementById("Image_Dir").innerHTML,
          endIndex = document.getElementById("endIndex").innerHTML,
          locale = document.getElementById("Locale_String_S").innerHTML,
          orderLineNum = 1;
        if (
          (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
            (orderLineNum = jsonOrder.Root.Order.countOfOrderLines),
          "TBODY" ==
            document.getElementById("order_details").childNodes[0].tagName)
        )
          var parentTable =
            document.getElementById("order_details").childNodes[0];
        else if (
          "TBODY" ==
          document.getElementById("order_details").childNodes[1].tagName
        )
          var parentTable =
            document.getElementById("order_details").childNodes[1];
        for (var i = beginIndex; endIndex > i; i++) {
          var orderLine = null;
          orderLine =
            1 == orderLineNum
              ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])
                ? jsonOrder.Root.Order.OrderLines.OrderLine
                : jsonOrder.Root.Order.OrderLines.OrderLine[0]
              : jsonOrder.Root.Order.OrderLines.OrderLine[i];
          var nobottom = null;
          this.isNullObj(orderLine.CalculationCodes) ||
            this.isNullObj(orderLine.CalculationCodes.CalculationCode) ||
            (nobottom = "th_align_left_no_bottom"),
            this.isNullObj(nobottom) ||
              (document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("className") + nobottom
                ),
              this.isNullObj(
                document.getElementById(
                  "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                )
              ) ||
                (document
                  .getElementById(
                    "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                  )
                  .setAttribute(
                    "class",
                    document
                      .getElementById(
                        "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" +
                          i
                      )
                      .getAttribute("class") + nobottom
                  ),
                document
                  .getElementById(
                    "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" + i
                  )
                  .setAttribute(
                    "className",
                    document
                      .getElementById(
                        "WC_OrderItemDetailsSummaryf_td_requestedShippingDate_" +
                          i
                      )
                      .getAttribute("className") + nobottom
                  )),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("className") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                .setAttribute(
                  "class",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("class") + nobottom
                ),
              document
                .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                .setAttribute(
                  "className",
                  document
                    .getElementById("WC_OrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("className") + nobottom
                ));
          var catEntryName = null,
            thumbNail = null,
            objectPath = null,
            itemID = null;
          if (
            (this.isNullObj(orderLine.Item.CatalogEntry) ||
              (this.isNullObj(orderLine.Item.CatalogEntry.objectPath) ||
                (objectPath = orderLine.Item.CatalogEntry.objectPath),
              this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription
              ) ||
                (this.isNullObj(
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .catalogEntryName
                ) ||
                  (catEntryName =
                    orderLine.Item.CatalogEntry.CatalogEntryDescription
                      .catalogEntryName),
                this.isNullObj(
                  orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail
                ) ||
                  (thumbNail =
                    orderLine.Item.CatalogEntry.CatalogEntryDescription
                      .thumbNail))),
            this.isNullObj(orderLine.Item.ItemID) ||
              (itemID = orderLine.Item.ItemID),
            this.isNullObj(thumbNail)
              ? document
                  .getElementById("Product_Thumbnail_" + i)
                  .setAttribute("src", imgDir + "images/NoImageIcon_sm.jpg")
              : ((thumbNail = this.revertAllSpecialChars(thumbNail)),
                this.isNullObj(objectPath)
                  ? document
                      .getElementById("Product_Thumbnail_" + i)
                      .setAttribute("src", thumbNail)
                  : ((objectPath = this.revertAllSpecialChars(objectPath)),
                    document
                      .getElementById("Product_Thumbnail_" + i)
                      .setAttribute("src", objectPath + thumbNail))),
            this.isNullObj(catEntryName) ||
              (document
                .getElementById("SingleShipment_rowHeader_product" + i)
                .setAttribute(
                  "abbr",
                  document
                    .getElementById("SingleShipment_rowHeader_product" + i)
                    .getAttribute("abbr") + catEntryName
                ),
              document
                .getElementById("Product_Thumbnail_" + i)
                .setAttribute("alt", catEntryName),
              (document.getElementById("Catalog_Entry_Name_" + i).innerHTML =
                catEntryName)),
            this.isNullObj(itemID) ||
              (document.getElementById("Catalog_Entry_SKU_" + i).innerHTML =
                itemID),
            !this.isNullObj(orderLine.Item.CatalogEntry) &&
              !this.isNullObj(
                orderLine.Item.CatalogEntry.catalogEntryAttributes
              ))
          ) {
            document.getElementById(
              "Catalog_Entry_Defining_Attributes_" + i
            ).style.display = "inline";
            for (var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes
              .catalogEntryAttribute)
              document.getElementById(
                "Catalog_Entry_Defining_Attributes_" + i
              ).innerHTML =
                document.getElementById(
                  "Catalog_Entry_Defining_Attributes_" + i
                ).innerHTML +
                orderLine.Item.CatalogEntry.catalogEntryAttributes
                  .catalogEntryAttribute[dAttr].catalogEntryAttrName +
                ":" +
                orderLine.Item.CatalogEntry.catalogEntryAttributes
                  .catalogEntryAttribute[dAttr].catalogEntryAttrValue +
                "<br/>";
          }
          if (!this.isNullObj(orderLine.componentNames)) {
            var dkLabel = document.getElementById(
              "Dynamic_Kit_Components_Label_" + i
            );
            this.isNullObj(dkLabel) ||
              (document.getElementById(
                "Dynamic_Kit_Components_Label_" + i
              ).style.display = "inline");
            var ulForDK = document.getElementById(
              "Dynamic_Kit_Components_" + i
            );
            if (!this.isNullObj(ulForDK)) {
              var compNames = orderLine.componentNames.split(",");
              for (var j in compNames) {
                var li = document.createElement("li");
                (li.innerHTML = compNames[j]), ulForDK.appendChild(li);
              }
            }
          }
          if (
            !this.isNullObj(
              document.getElementById("Order_Item_Requested_Ship_Date_" + i)
            ) &&
            !this.isNullObj(orderLine.ReqShipDate)
          ) {
            var parsedReqShipDate = new Date(orderLine.ReqShipDate);
            document.getElementById(
              "Order_Item_Requested_Ship_Date_" + i
            ).innerHTML = Globalize.formatDate(parsedReqShipDate, {
              date: "long",
            });
          }
          this.isNullObj(orderLine.MaxLineStatus) ||
            (document.getElementById("Order_Item_Status_" + i).innerHTML =
              Utils.getLocalizationMessage(
                "ORDER_LINE_STATUS_" + orderLine.MaxLineStatus
              )),
            this.isNullObj(orderLine.OrderedQty) ||
              (document.getElementById("Order_Item_Quantity_" + i).innerHTML =
                Utils.formatNumber(orderLine.OrderedQty, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }));
          var currencyCode = "USD";
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
            (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
          var currencyDecimals = 2;
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
            (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
          var currencySymbol = "$";
          this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
            (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
            this.isNullObj(orderLine.LinePriceInfo.UnitPrice) ||
              (document.getElementById("Order_Item_Unit_Price_" + i).innerHTML =
                this.formatCurrency(
                  orderLine.LinePriceInfo.UnitPrice,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                ));
          var isFree = !1;
          if (
            !this.isNullObj(orderLine.Awards) &&
            !this.isNullObj(orderLine.Awards.Award)
          )
            if (this.isNullObj(orderLine.Awards.Award.AwardType)) {
              if (!this.isNullObj(orderLine.Awards.Award[0]))
                for (var award in orderLine.Awards.Award)
                  if ("FreeGift" == orderLine.Awards.Award[award].AwardType) {
                    isFree = !0;
                    break;
                  }
            } else
              "FreeGift" == orderLine.Awards.Award.AwardType && (isFree = !0);
          if (
            (1 == isFree
              ? ((document.getElementById(
                  "Order_Item_Total_Price_Free_" + i
                ).style.display = "inline"),
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).style.display = "none"))
              : ((document.getElementById(
                  "Order_Item_Total_Price_Free_" + i
                ).style.display = "none"),
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).style.display = "inline"),
                this.isNullObj(orderLine.ComputedPrice.ExtendedPrice) ||
                  (document.getElementById(
                    "Order_Item_Total_Price_" + i
                  ).innerHTML = this.formatCurrency(
                    orderLine.ComputedPrice.ExtendedPrice,
                    currencyDecimals,
                    currencySymbol,
                    currencyCode,
                    locale
                  ))),
            !this.isNullObj(orderLine.CalculationCodes))
          ) {
            var counter = 0;
            for (var j in orderLine.CalculationCodes.CalculationCode) {
              var calCode = orderLine.CalculationCodes.CalculationCode[j],
                code = calCode.code;
              code = this.revertAllSpecialChars(code);
              var tr = document.createElement("tr");
              parentTable.insertBefore(
                tr,
                document.getElementById("Product_Line_" + (parseInt(i) + 1))
              );
              var th = document.createElement("th");
              th.setAttribute("colSpan", "4"),
                th.setAttribute(
                  "class",
                  "th_align_left_dotted_top_solid_bottom"
                ),
                th.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom"
                );
              var abbrText = document.getElementById(
                "Product_Discount_Text"
              ).innerHTML;
              th.setAttribute("abbr", abbrText + catEntryName),
                th.setAttribute(
                  "id",
                  "SingleShipment_rowHeader_discount" + i + "_" + counter
                ),
                tr.appendChild(th);
              var div = document.createElement("div");
              div.setAttribute(
                "id",
                "WC_OrderItemDetailsSummaryf_div_3_" + i + "_" + counter
              ),
                div.setAttribute("class", "itemspecs"),
                div.setAttribute("className", "itemspecs"),
                th.appendChild(div);
              var a = document.createElement("a");
              a.setAttribute("class", "discount hover_underline"),
                a.setAttribute("className", "discount hover_underline"),
                a.setAttribute(
                  "id",
                  "WC_OrderItemDetails_Link_ItemDiscount_1_" + i + "_" + counter
                );
              var url_innerHTML =
                document.getElementById("Promotion_Url").innerHTML;
              this.isNullObj(url_innerHTML) ||
                (url_innerHTML = url_innerHTML.replace(/&amp;/g, "&"));
              var promotionUrl =
                url_innerHTML + "&code=" + encodeURIComponent(code);
              a.setAttribute("href", promotionUrl), div.appendChild(a);
              var img = document.createElement("img");
              if (
                (img.setAttribute("src", imgDir + "images/empty.gif"),
                img.setAttribute("alt", abbrText + catEntryName),
                a.appendChild(img),
                !this.isNullObj(calCode.calculationCodeDescription))
              ) {
                var calCodeDesc = this.revertAllSpecialChars(
                  calCode.calculationCodeDescription
                );
                a.appendChild(document.createTextNode(calCodeDesc));
              }
              var td = document.createElement("td");
              td.setAttribute(
                "class",
                "th_align_left_dotted_top_solid_bottom total"
              ),
                td.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom total"
                ),
                td.appendChild(document.createTextNode(" ")),
                tr.appendChild(td);
              var td1 = document.createElement("td");
              td1.setAttribute(
                "class",
                "th_align_left_dotted_top_solid_bottom total"
              ),
                td1.setAttribute(
                  "className",
                  "th_align_left_dotted_top_solid_bottom total"
                ),
                td1.setAttribute(
                  "id",
                  "WC_OrderItemDetailsSummaryf_td_5_" + i + "_" + counter
                ),
                td1.setAttribute(
                  "headers",
                  "SingleShipment_rowHeader_discount" + i + "_" + counter
                ),
                td1.appendChild(
                  document.createTextNode(
                    this.formatCurrency(
                      calCode.TotalAmount,
                      currencyDecimals,
                      currencySymbol,
                      currencyCode,
                      locale
                    )
                  )
                ),
                tr.appendChild(td1),
                counter++;
            }
          }
        }
      }
    },
    populateOrderLineInfoForMultipleShipment: function (
      orderStr,
      beginIndex,
      pageSize
    ) {
      var jsonOrder = eval("(" + orderStr + ")"),
        imgDir = document.getElementById("Image_Dir").innerHTML,
        locale = document.getElementById("Locale_String_M").innerHTML,
        endIndex = document.getElementById("endIndex").innerHTML,
        orderLineNum = 1;
      if (
        (this.isNullObj(jsonOrder.Root.Order.countOfOrderLines) ||
          (orderLineNum = jsonOrder.Root.Order.countOfOrderLines),
        "TBODY" ==
          document.getElementById("order_details").childNodes[0].tagName)
      )
        var parentTable =
          document.getElementById("order_details").childNodes[0];
      else if (
        "TBODY" ==
        document.getElementById("order_details").childNodes[1].tagName
      )
        var parentTable =
          document.getElementById("order_details").childNodes[1];
      for (var i = beginIndex; endIndex > i; i++) {
        var orderLine = null;
        orderLine =
          1 == orderLineNum
            ? this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])
              ? jsonOrder.Root.Order.OrderLines.OrderLine
              : jsonOrder.Root.Order.OrderLines.OrderLine[0]
            : jsonOrder.Root.Order.OrderLines.OrderLine[i];
        var nobottom = null;
        this.isNullObj(orderLine.CalculationCodes) ||
          this.isNullObj(orderLine.CalculationCodes.CalculationCode) ||
          (nobottom = "th_align_left_no_bottom"),
          this.isNullObj(nobottom) ||
            (document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("MultipleShipping_rowHeader_product" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("MultipleShipping_rowHeader_product" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_1_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_2_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_3_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_4_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_5_" + i)
                    .getAttribute("className")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
              .setAttribute(
                "class",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
                    .getAttribute("class")
              ),
            document
              .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
              .setAttribute(
                "className",
                nobottom +
                  document
                    .getElementById("WC_MSOrderItemDetailsSummaryf_td_6_" + i)
                    .getAttribute("className")
              ));
        var catEntryName = null,
          thumbNail = null,
          objectPath = null,
          itemID = null;
        if (
          (this.isNullObj(orderLine.Item.CatalogEntry) ||
            (this.isNullObj(orderLine.Item.CatalogEntry.objectPath) ||
              (objectPath = orderLine.Item.CatalogEntry.objectPath),
            this.isNullObj(
              orderLine.Item.CatalogEntry.CatalogEntryDescription
            ) ||
              (this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription
                  .catalogEntryName
              ) ||
                (catEntryName =
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .catalogEntryName),
              this.isNullObj(
                orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail
              ) ||
                (thumbNail =
                  orderLine.Item.CatalogEntry.CatalogEntryDescription
                    .thumbNail))),
          this.isNullObj(orderLine.Item.ItemID) ||
            (itemID = orderLine.Item.ItemID),
          this.isNullObj(thumbNail)
            ? document
                .getElementById("Product_Thumbnail_" + i)
                .setAttribute("src", imgDir + "images/NoImageIcon_sm.jpg")
            : ((thumbNail = this.revertAllSpecialChars(thumbNail)),
              this.isNullObj(objectPath)
                ? document
                    .getElementById("Product_Thumbnail_" + i)
                    .setAttribute("src", thumbNail)
                : ((objectPath = this.revertAllSpecialChars(objectPath)),
                  document
                    .getElementById("Product_Thumbnail_" + i)
                    .setAttribute("src", objectPath + thumbNail))),
          this.isNullObj(catEntryName) ||
            (document
              .getElementById("MultipleShipping_rowHeader_product" + i)
              .setAttribute(
                "abbr",
                document
                  .getElementById("MultipleShipping_rowHeader_product" + i)
                  .getAttribute("abbr") + catEntryName
              ),
            document
              .getElementById("Product_Thumbnail_" + i)
              .setAttribute("alt", catEntryName),
            (document.getElementById("Catalog_Entry_Name_" + i).innerHTML =
              catEntryName)),
          this.isNullObj(itemID) ||
            (document.getElementById("Catalog_Entry_SKU_" + i).innerHTML =
              itemID),
          !this.isNullObj(orderLine.Item.CatalogEntry) &&
            !this.isNullObj(orderLine.Item.CatalogEntry.catalogEntryAttributes))
        ) {
          document.getElementById(
            "Catalog_Entry_Defining_Attributes_" + i
          ).style.display = "inline";
          for (var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes
            .catalogEntryAttribute)
            document.getElementById(
              "Catalog_Entry_Defining_Attributes_" + i
            ).innerHTML =
              document.getElementById("Catalog_Entry_Defining_Attributes_" + i)
                .innerHTML +
              orderLine.Item.CatalogEntry.catalogEntryAttributes
                .catalogEntryAttribute[dAttr].catalogEntryAttrName +
              ":" +
              orderLine.Item.CatalogEntry.catalogEntryAttributes
                .catalogEntryAttribute[dAttr].catalogEntryAttrValue +
              "<br/>";
        }
        if (!this.isNullObj(orderLine.componentNames)) {
          var dkLabel = document.getElementById(
            "Dynamic_Kit_Components_Label_" + i
          );
          this.isNullObj(dkLabel) ||
            (document.getElementById(
              "Dynamic_Kit_Components_Label_" + i
            ).style.display = "inline");
          var ulForDK = document.getElementById("Dynamic_Kit_Components_" + i);
          if (!this.isNullObj(ulForDK)) {
            var compNames = orderLine.componentNames.split(",");
            for (var j in compNames) {
              var li = document.createElement("li");
              (li.innerHTML = compNames[j]), ulForDK.appendChild(li);
            }
          }
        }
        this.isNullObj(orderLine.PersonInfoShipTo)
          ? this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo) ||
            this.populateAddress(
              jsonOrder.Root.Order.PersonInfoShipTo,
              "WC_MSOrderItemDetailsSummaryf_div_3_" + i,
              locale
            )
          : this.populateAddress(
              orderLine.PersonInfoShipTo,
              "WC_MSOrderItemDetailsSummaryf_div_3_" + i,
              locale
            );
        var shippingMethod = null;
        if (!this.isNullObj(orderLine.ShipmentLines.ShipmentLine)) {
          var shipmentKey = null;
          if (
            (this.isNullObj(orderLine.ShipmentLines.ShipmentLine.ShipmentKey)
              ? this.isNullObj(
                  orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey
                ) ||
                (shipmentKey =
                  orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey)
              : (shipmentKey =
                  orderLine.ShipmentLines.ShipmentLine.ShipmentKey),
            !this.isNullObj(shipmentKey) &&
              !this.isNullObj(jsonOrder.Root.Order.Shipments) &&
              !this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment))
          )
            if (
              this.isNullObj(
                jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey
              )
            ) {
              if (!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0]))
                for (var s in jsonOrder.Root.Order.Shipments.Shipment)
                  if (
                    jsonOrder.Root.Order.Shipments.Shipment[s].ShipmentKey ==
                    shipmentKey
                  ) {
                    this.isNullObj(
                      jsonOrder.Root.Order.Shipments.Shipment[s]
                        .shipModeDescription
                    ) ||
                      (shippingMethod =
                        jsonOrder.Root.Order.Shipments.Shipment[s]
                          .shipModeDescription);
                    break;
                  }
            } else
              jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey ==
                shipmentKey &&
                (this.isNullObj(
                  jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription
                ) ||
                  (shippingMethod =
                    jsonOrder.Root.Order.Shipments.Shipment
                      .shipModeDescription));
        }
        this.isNullObj(shippingMethod) &&
          (this.isNullObj(orderLine.shipModeDescription)
            ? this.isNullObj(jsonOrder.Root.Order.shipModeDescription) ||
              (shippingMethod = jsonOrder.Root.Order.shipModeDescription)
            : (shippingMethod = orderLine.shipModeDescription)),
          this.isNullObj(shippingMethod) ||
            (document.getElementById(
              "Shipping_Mode_Description_" + i
            ).innerHTML = shippingMethod);
        var isFree = !1;
        if (
          !this.isNullObj(orderLine.Awards) &&
          !this.isNullObj(orderLine.Awards.Award)
        )
          if (this.isNullObj(orderLine.Awards.Award.AwardType)) {
            if (!this.isNullObj(orderLine.Awards.Award[0]))
              for (var award in orderLine.Awards.Award)
                if ("FreeGift" == orderLine.Awards.Award[award].AwardType) {
                  isFree = !0;
                  break;
                }
          } else
            "FreeGift" == orderLine.Awards.Award.AwardType && (isFree = !0);
        if (0 == isFree) {
          if (
            !this.isNullObj(
              document.getElementById("Shipping_Instruction_" + i)
            ) &&
            !this.isNullObj(orderLine.Instructions)
          ) {
            var instructions = orderLine.Instructions;
            if (!this.isNullObj(instructions.Instruction)) {
              var instruction = instructions.Instruction;
              if (this.isNullObj(instruction.InstructionType)) {
                if (!this.isNullObj(instructions.Instruction[0]))
                  for (var k in instructions.Instruction)
                    this.isNullObj(
                      instructions.Instruction[k].InstructionType
                    ) ||
                      ("SHIP" == instructions.Instruction[k].InstructionType &&
                        (this.isNullObj(
                          instructions.Instruction[k].InstructionText
                        ) ||
                          ((document.getElementById(
                            "Shipping_Instruction_Label_" + i
                          ).style.display = "inline"),
                          (document.getElementById(
                            "Shipping_Instruction_" + i
                          ).innerHTML =
                            document.getElementById("Shipping_Instruction_" + i)
                              .innerHTML +
                            instructions.Instruction[k].InstructionText +
                            "<br/>"))));
              } else
                "SHIP" == instruction.InstructionType &&
                  (this.isNullObj(instruction.InstructionText) ||
                    ((document.getElementById(
                      "Shipping_Instruction_Label_" + i
                    ).style.display = "inline"),
                    (document.getElementById(
                      "Shipping_Instruction_" + i
                    ).innerHTML = instruction.InstructionText)));
            }
          }
          if (
            !this.isNullObj(
              document.getElementById("Order_Item_Requested_Ship_Date_" + i)
            ) &&
            !this.isNullObj(orderLine.ReqShipDate)
          ) {
            document.getElementById(
              "Requested_Shipping_Date_Label_" + i
            ).style.display = "inline";
            var parsedReqShipDate = new Date(orderLine.ReqShipDate);
            document.getElementById(
              "Order_Item_Requested_Ship_Date_" + i
            ).innerHTML = Globalize.formatDate(parsedReqShipDate, {
              date: "long",
            });
          }
        }
        this.isNullObj(orderLine.MaxLineStatus) ||
          (document.getElementById("Order_Item_Status_" + i).innerHTML =
            Utils.getLocalizationMessage(
              "ORDER_LINE_STATUS_" + orderLine.MaxLineStatus
            )),
          this.isNullObj(orderLine.OrderedQty) ||
            (document.getElementById("Order_Item_Quantity_" + i).innerHTML =
              Utils.formatNumber(orderLine.OrderedQty, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              }));
        var currencyCode = "USD";
        this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency) ||
          (currencyCode = jsonOrder.Root.Order.PriceInfo.Currency);
        var currencyDecimals = 2;
        this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal) ||
          (currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal);
        var currencySymbol = "$";
        if (
          (this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol) ||
            (currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol),
          this.isNullObj(orderLine.LinePriceInfo.UnitPrice) ||
            (document.getElementById("Order_Item_Unit_Price_" + i).innerHTML =
              this.formatCurrency(
                orderLine.LinePriceInfo.UnitPrice,
                currencyDecimals,
                currencySymbol,
                currencyCode,
                locale
              )),
          1 == isFree
            ? ((document.getElementById(
                "Order_Item_Total_Price_Free_" + i
              ).style.display = "inline"),
              (document.getElementById(
                "Order_Item_Total_Price_" + i
              ).style.display = "none"))
            : ((document.getElementById(
                "Order_Item_Total_Price_Free_" + i
              ).style.display = "none"),
              (document.getElementById(
                "Order_Item_Total_Price_" + i
              ).style.display = "inline"),
              this.isNullObj(orderLine.ComputedPrice.ExtendedPrice) ||
                (document.getElementById(
                  "Order_Item_Total_Price_" + i
                ).innerHTML = this.formatCurrency(
                  orderLine.ComputedPrice.ExtendedPrice,
                  currencyDecimals,
                  currencySymbol,
                  currencyCode,
                  locale
                ))),
          !this.isNullObj(orderLine.CalculationCodes))
        ) {
          var counter = 0;
          for (var j in orderLine.CalculationCodes.CalculationCode) {
            var calCode = orderLine.CalculationCodes.CalculationCode[j],
              code = calCode.code;
            code = this.revertAllSpecialChars(code);
            var tr = document.createElement("tr");
            parentTable.insertBefore(
              tr,
              document.getElementById("Product_Line_" + (parseInt(i) + 1))
            );
            var th = document.createElement("th");
            th.setAttribute("colSpan", "5"),
              th.setAttribute("class", "th_align_left_dotted_top_solid_bottom"),
              th.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom"
              );
            var abbrText = document.getElementById(
              "Product_Discount_Text"
            ).innerHTML;
            th.setAttribute("abbr", abbrText + catEntryName),
              th.setAttribute(
                "id",
                "MultipleShipment_rowHeader_discount" + i + "_" + counter
              ),
              tr.appendChild(th);
            var div = document.createElement("div");
            div.setAttribute(
              "id",
              "WC_MSOrderItemDetailsSummaryf_div_5_" + i + "_" + counter
            ),
              div.setAttribute("class", "itemspecs"),
              div.setAttribute("className", "itemspecs"),
              th.appendChild(div);
            var a = document.createElement("a");
            a.setAttribute("class", "discount"),
              a.setAttribute("className", "discount"),
              a.setAttribute(
                "id",
                "WC_OrderItemDetails_Link_ItemDiscount_1_" + i + "_" + counter
              );
            var url_innerHTML =
              document.getElementById("Promotion_Url").innerHTML;
            this.isNullObj(url_innerHTML) ||
              (url_innerHTML = url_innerHTML.replace(/&amp;/g, "&"));
            var promotionUrl =
              url_innerHTML + "&code=" + encodeURIComponent(code);
            a.setAttribute("href", promotionUrl), div.appendChild(a);
            var img = document.createElement("img");
            if (
              (img.setAttribute("src", imgDir + "images/empty.gif"),
              img.setAttribute("alt", abbrText + catEntryName),
              a.appendChild(img),
              !this.isNullObj(calCode.calculationCodeDescription))
            ) {
              var calCodeDesc = this.revertAllSpecialChars(
                calCode.calculationCodeDescription
              );
              a.appendChild(document.createTextNode(calCodeDesc));
            }
            var td = document.createElement("td");
            td.setAttribute(
              "class",
              "th_align_left_dotted_top_solid_bottom total"
            ),
              td.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom total"
              ),
              td.appendChild(document.createTextNode(" ")),
              tr.appendChild(td);
            var td1 = document.createElement("td");
            td1.setAttribute(
              "class",
              "th_align_left_dotted_top_solid_bottom total"
            ),
              td1.setAttribute(
                "className",
                "th_align_left_dotted_top_solid_bottom total"
              ),
              td1.setAttribute(
                "id",
                "WC_MSOrderItemDetailsSummaryf_td_7_" + i + "_" + counter
              ),
              td1.setAttribute(
                "headers",
                "MultipleShipment_rowHeader_discount" + i + "_" + counter
              ),
              td1.appendChild(
                document.createTextNode(
                  this.formatCurrency(
                    calCode.TotalAmount,
                    currencyDecimals,
                    currencySymbol,
                    currencyCode,
                    locale
                  )
                )
              ),
              tr.appendChild(td1),
              counter++;
          }
        }
      }
    },
    cancelOrder: function (e, t) {
      submitRequest() &&
        (cursor_wait(),
        (this.orderBeingCanceled = t),
        wcService.getServiceById("CancelExternalOrder").setUrl(e),
        wcService.invoke("CancelExternalOrder"));
    },
  }),
  wcService.declare({
    id: "CancelExternalOrder",
    actionId: "CancelExternalOrder",
    url: "AJAXProcessExternalOrder",
    formId: "",
    successHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      var r =
          "OrderDetails_status_span_" +
          sterlingIntegrationJS.orderBeingCanceled,
        s = $("#" + r);
      s.length && s.html(MessageHelper.messages.MO_OrderStatus_X),
        (r =
          "OrderDetails_cancelButton_" +
          sterlingIntegrationJS.orderBeingCanceled);
      var s = $("#" + r);
      s.length && (s.css("display", "none"), s.css("visibility", "hidden")),
        MessageHelper.hideAndClearMessage(),
        cursor_clear(),
        MessageHelper.displayStatusMessage(
          MessageHelper.messages.MO_ORDER_CANCELED_MSG
        );
    },
    failureHandler: function (e) {
      for (var t in e) console.debug(t + "=" + e[t]);
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });
var toggleCollapsible = function (e) {
    var t = e.querySelector(".content"),
      r = $(e).attr("aria-expanded"),
      s = document.getElementById("mainESpotHome");
    t.id.match(/homeESpotDetails/)
      ? "closed" == s.className
        ? (s.className = "expand")
        : (s.className = "closed")
      : 0,
      "true" == r
        ? (window.setTimeout(function () {
            $(e).attr("aria-expanded", "false"),
              $(t).css("transition", "max-height .2s");
          }, 0),
          window.setTimeout(function () {
            $(t).css("transition", null);
          }, 200),
          window.setTimeout(function () {
            $(t).css("display", "none");
          }, 300))
        : "false" == r &&
          ($(e).attr("aria-expanded", "true"),
          $(t).css("transition", "max-height .2s"),
          window.setTimeout(function () {
            $(t).css("transition", null);
          }, 200),
          window.setTimeout(function () {
            $(t).css("display", "block");
          }, 300));
  },
  updateGrid = function (e, t) {
    var r = t.clientWidth,
      s = $(t).attr("data-min-col-width"),
      a = $(t).attr("data-min-col-count"),
      i = Math.floor(r / s);
    a > i && (i = a);
    var n = Math.floor(100 / i) + "%";
    $(".col", t).css("width", n);
  },
  toggleExpandNav = function (e) {
    var t = byId("icon_" + e),
      r = byId("section_list_" + e);
    "arrow" == t.className
      ? ((t.className = "arrow arrow_collapsed"),
        $(r).attr("aria-expanded", "false"),
        $(r).css("display", "none"))
      : ((t.className = "arrow"),
        $(r).attr("aria-expanded", "true"),
        $(r).css("display", "block"));
  };
$(document).ready(function () {
  var e = function (e) {
    var t = e ? !e.matches : document.documentElement.clientWidth > 583;
    0 == t
      ? $(".collapsible").attr("aria-expanded", t.toString())
      : $(".collapsible:not(.collapsedOnInit)").attr(
          "aria-expanded",
          t.toString()
        );
  };
  if (window.matchMedia) {
    var t = window.matchMedia("(max-width: 600px)");
    e(t), t.addListener(e);
  } else
    e(),
      $(window).on("resize", function (t) {
        e();
      });
  Utils.onOnce(
    $(document),
    "click",
    "collapsible",
    ".collapsible .toggle",
    function (e) {
      toggleCollapsible($(e.target).parents(".collapsible")[0]),
        e.preventDefault();
    }
  ),
    Utils.onOnce(
      $(document),
      "keydown",
      "collapsible",
      ".collapsible .toggle",
      function (e) {
        (e.keyCode === KeyCodes.RETURN || e.keyCode === KeyCodes.SPACE) &&
          (toggleCollapsible($(e.target).parents(".collapsible")[0]),
          e.preventDefault());
      }
    ),
    $(".grid").each(updateGrid),
    $(window).on("resize", function (e) {
      $(".grid").each(updateGrid);
    });
}),
  ("undefined" != typeof CompareProductJS &&
    null != CompareProductJS &&
    CompareProductJS) ||
    (CompareProductJS = {
      params: [],
      compareReturnName: "",
      returnUrl: "",
      cookieKeyPrefix: "CompareItems_",
      cookieDelimiter: ";",
      maxNumberProductsAllowedToCompare: 4,
      setCommonParameters: function (e, t, r, s, a) {
        (this.params.langId = e),
          (this.params.storeId = t),
          (this.params.catalogId = r),
          (this.compareReturnName = s),
          (this.returnUrl = decodeURIComponent(a));
      },
      remove: function (e) {
        var t = this.cookieKeyPrefix + this.params.storeId,
          r = getCookie(t);
        if (null != r) {
          if ("" == r.trim())
            setCookie(t, null, {
              expires: -1,
            });
          else {
            var s = r.split(this.cookieDelimiter),
              a = "";
            for (index in s)
              s[index] != e &&
                (a = "" === a ? s[index] : a + this.cookieDelimiter + s[index]);
            setCookie(t, a, {
              path: "/",
              domain: cookieDomain,
            });
          }
          var t = this.cookieKeyPrefix + this.params.storeId,
            r = getCookie(t),
            i = "",
            n = document.URL.split("catentryId=");
          if (2 == n.length) {
            i = n[0] + "catentryId=" + r;
            for (var o = n[1].split("&"), d = 0; d < o.length; d++)
              d > 0 && (i = i + "&" + n[d]);
          }
          var i = i.replace(/&&/, "&");
          location.href = i;
        }
      },
      compareProducts: function () {
        var e =
            "CompareProductsDisplayView?storeId=" +
            this.params.storeId +
            "&catalogId=" +
            this.params.catalogId +
            "&langId=" +
            this.params.langId +
            "&compareReturnName=" +
            this.compareReturnName,
          t = this.cookieKeyPrefix + this.params.storeId,
          r = getCookie(t);
        null != r && "" != r.trim() && (e = e + "&catentryId=" + r),
          (e = e + "&returnUrl=" + encodeURIComponent(this.returnUrl)),
          (location.href = getAbsoluteURL() + e);
      },
      add2ShopCart: function (e, t, r) {
        var s = {
          storeId: WCParamJS.storeId,
          catalogId: WCParamJS.catalogId,
          langId: WCParamJS.langId,
          orderId: ".",
        };
        (s.calculateOrder = "0"),
          updateParamObject(s, "catEntryId", e, !1, -1),
          updateParamObject(s, "quantity", t, !1, -1);
        var a = "AddOrderItem",
          i = this.getSkuAttributes(e);
        null == i && (i = this.getSkuAttributes(r)),
          submitRequest() &&
            (cursor_wait(),
            shoppingActionsJS.saveAddedProductInfo(t, r, e, i),
            wcService.invoke(a, s));
      },
      getSkuAttributes: function (catEntryId) {
        var jsonDiv = null,
          node = $("#SKUAttributesJSON_" + catEntryId);
        return (
          node &&
            null != node &&
            "undefined" != node &&
            (jsonDiv = eval("(" + node.innerHTML + ")")),
          null != jsonDiv && "undefined" != jsonDiv ? jsonDiv : null
        );
      },
    });
var updateDepartmentsMenu,
  activate,
  ajaxRefresh = "",
  setAjaxRefresh = function (e) {
    ajaxRefresh = e;
  };
$(document).ready(function () {
  var e = !1,
    t = null,
    r = null,
    s = {},
    a = "departmentMenu_",
    i = function () {
      e || ($(document.documentElement).on("mousedown.wc.header", o), (e = !0));
    },
    n = function () {
      e && ($(document.documentElement).off("mousedown.wc.header"), (e = !1));
    },
    o = function (e) {
      var s = e.target;
      if (null !== t && s != document.documentElement) {
        for (
          var a = !0, i = t.getAttribute("data-parent");
          s && s != document.documentElement;

        ) {
          if (
            s == t ||
            s == r ||
            $(s).hasClass("dijitPopup") ||
            i == s.getAttribute("data-parent")
          ) {
            a = !1;
            break;
          }
          s = s.parentNode;
        }
        if (null === s)
          for (var n = $("div", t), o = 0; o < n.length; o++) {
            var l = Utils.position(n[o]);
            if (
              e.clientX >= l.x &&
              e.clientX < l.x + l.w &&
              e.clientY >= l.y &&
              e.clientY < l.y + l.h
            ) {
              a = !1;
              break;
            }
          }
        a && d(t);
      }
    },
    d = function (e) {
      s[e.id] && d(s[e.id]),
        $(e).removeClass("active"),
        $("a[data-activate='" + e.id + "']").removeClass("selected"),
        $("a[data-toggle='" + e.id + "']").removeClass("selected");
      var a = e.getAttribute("data-parent");
      delete s[a], e == t && ((t = null), (r = null), n());
    },
    l = function (e) {
      $(e).hasClass("active") ? d(e) : activate(e);
    },
    c = function () {
      $(document).on("click", "a[data-activate]", function (e) {
        var t = this.getAttribute("data-activate");
        activate(document.getElementById(t)), Utils.stopEvent(e);
      }),
        $(document).on("click", "a[data-deactivate]", function (e) {
          var t = this.getAttribute("data-deactivate");
          d(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(document).on("click", "a[data-toggle]", function (e) {
          var t = this.getAttribute("data-toggle");
          l(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(document).on("keydown", "a[data-toggle]", function (e) {
          var t;
          if (27 === e.keyCode)
            (t = this.getAttribute("data-toggle")),
              d(document.getElementById(t)),
              Utils.stopEvent(e);
          else if (40 === e.keyCode) {
            t = this.getAttribute("data-toggle");
            var r = document.getElementById(t);
            activate(r),
              $('[class*="menuLink"]', r)[0].focus(),
              Utils.stopEvent(e);
          }
        });
      var e = Utils.get_IE_version();
      e &&
        10 > e &&
        $("input[placeholder]").each(function (e, t) {
          var r = t.getAttribute("placeholder");
          if (r) {
            var s = document.createElement("label");
            (s.className = "placeholder"),
              (s.innerHTML = r),
              t.parentNode.insertBefore(s, t);
            var a = function () {
              s.style.display = t.value ? "none" : "block";
            };
            window.setTimeout(a, 200),
              $(t).on("blur focus keyup", a),
              $(s).click(function (e) {
                t.focus();
              });
          }
        });
    };
  (activate = function (e) {
    var n = e.id.slice(0, a.length) == a;
    if ("true" == ajaxRefresh && n)
      return (
        setAjaxRefresh(""),
        wcRenderContext.updateRenderContext("departmentSubMenuContext", {
          targetId: e.id,
        }),
        void (
          "function" == typeof cX &&
          setTimeout(function () {
            cX("");
          }, 1e3)
        )
      );
    var o = e.getAttribute("data-parent");
    o && s[o] && d(s[o]),
      o && activate(document.getElementById(o)),
      $(e).addClass("active"),
      $("a[data-activate='" + e.id + "']").addClass("selected");
    var l = $("a[data-toggle='" + e.id + "']");
    l.addClass("selected"),
      o &&
        ((s[o] = e),
        null === t && ((t = e), (r = l.length > 0 ? l[0] : null), i()));
  }),
    c(),
    window.setTimeout(function () {
      var e = document.getElementById("quickLinksBar"),
        t = document.getElementById("quickLinksButton"),
        r = document.getElementById("quickLinksMenu"),
        s = $("> ul > li > a", r);
      document.getElementById("signInOutQuickLink");
      $("#quickLinksMenu > ul > li").each(function (t, r) {
        "facebookQuickLinkItem" != r.id &&
          "globalLoginWidget" != r.id &&
          ((r = r.cloneNode(!0)),
          $("[id]", r).each(function (e, t) {
            t.id += "_alt";
          }),
          e.insertBefore(r, e.firstChild));
      }),
        $(t).click(function (e) {
          var t = this.getAttribute("data-toggle");
          l(document.getElementById(t)), Utils.stopEvent(e);
        }),
        $(t).keydown(function (e) {
          var t;
          40 === e.keyCode
            ? ((t = this.getAttribute("data-toggle")),
              activate(document.getElementById(t)),
              s[0].focus(),
              Utils.stopEvent(e))
            : 9 === e.keyCode || (9 === e.keyCode && e.shiftKey)
            ? d(r)
            : 27 === e.keyCode &&
              ((t = this.getAttribute("data-toggle")),
              d(document.getElementById(t)),
              Utils.stopEvent(e));
        }),
        $(r).keydown(function (e) {
          if (
            27 === e.keyCode ||
            9 === e.keyCode ||
            (9 === e.keyCode && e.shiftKey)
          )
            d(r);
          else if (27 === e.keyCode) {
            var t = this.getAttribute("data-toggle");
            d(document.getElementById(t)), Utils.stopEvent(e);
          }
        }),
        s.each(function (e, t) {
          t.setAttribute("role", "menuitem"),
            t.setAttribute("tabindex", "-1"),
            $(t).keydown(function (t) {
              switch (t.keyCode) {
                case 38:
                  s[0 === e ? s.length - 1 : e - 1].focus(), Utils.stopEvent(t);
                  break;
                case 40:
                  s[(e + 1) % s.length].focus(), Utils.stopEvent(t);
              }
            });
        });
      var a = document.getElementById("searchFilterButton");
      a &&
        $(a).keydown(function (e) {
          (9 === e.keyCode || (9 === e.keyCode && e.shiftKey)) &&
            d(document.getElementById(a.getAttribute("data-toggle")));
        });
      var i = document.getElementById("SimpleSearchForm_SearchTerm");
      i &&
        $(i).click(function (e) {
          $(
            '.selected:not(a[data-toggle="searchBar"])',
            document.getElementById("header")
          ).each(function (e, t) {
            d(document.getElementById(t.getAttribute("data-toggle")));
          });
        });
      var n = document.getElementById("searchFilterMenu");
      n &&
        $('[class*="menuLink"]', n).each(function (e, t) {
          $(t).keydown(function (r) {
            27 === r.keyCode
              ? (d(n), Utils.stopEvent(r))
              : 9 === r.keyCode || (9 === r.keyCode && r.shiftKey)
              ? d(n)
              : 38 === r.keyCode
              ? (t[0 === e ? t.length - 1 : e - 1].focus(), Utils.stopEvent(r))
              : 40 === r.keyCode &&
                (t[(e + 1) % t.length].focus(), Utils.stopEvent(r));
          });
        });
    }, 100);
  if ($(document.getElementById("header")).length > 0) {
    var u = document.getElementById("header"),
      m = Utils.getTextDirection(u),
      g = function () {
        var e = document.getElementById("logo"),
          t = document.getElementById("quickLinksBar"),
          r =
            "rtl" === m
              ? e.offsetLeft - t.offsetLeft
              : t.offsetLeft + t.offsetWidth - (e.offsetLeft + e.offsetWidth),
          s = document.getElementById("facebookQuickLinkItem");
        if (s && s.parentNode != t && r > 1024) t.insertBefore(s, t.firstChild);
        else if (s && s.parentNode == t && 1024 >= r) {
          var a = $("#quickLinksMenu > ul")[0];
          a.append(s);
        }
        var i = $("#quickLinksBar > li");
        if ($(i).length > 0) {
          var n = i[i.length - 2],
            o = i[i.length - 1];
          r -= n.offsetWidth + o.offsetWidth;
          for (var d = i.length - 3; d >= 0; d--)
            (r -= i[d].offsetWidth),
              $(i[d]).toggleClass("border-right", r >= 0);
        }
      };
    window.setTimeout(g, 200), $(window).resize(g);
  }
  (updateDepartmentsMenu = function () {
    var e =
        (document.getElementById("departmentsMenu"), $(".departmentButton")),
      t = $(".departmentMenu"),
      r = $("#departmentsMenu > li");
    r[r.length - 1];
    e.each(function (e, t) {
      $(t).keydown(function (e) {
        (9 === e.keyCode || (9 === e.keyCode && e.shiftKey)) &&
          d(document.getElementById(t.getAttribute("data-toggle")));
      });
    }),
      t.each(function (e, t) {
        $(t).click(function (e) {
          var t = this.getAttribute("data-toggle");
          null !== t && (l(document.getElementById(t)), Utils.stopEvent(e));
        });
        var r = $('[class*="menuLink"]', t);
        r.each(function (e, s) {
          $(s).keydown(function (s) {
            27 === s.keyCode
              ? (d(document.getElementById(t.getAttribute("id"))),
                Utils.stopEvent(s))
              : 9 === s.keyCode || (9 === s.keyCode && s.shiftKey)
              ? d(document.getElementById(t.getAttribute("id")))
              : 38 === s.keyCode
              ? (r[0 === e ? r.length - 1 : e - 1].focus(), Utils.stopEvent(s))
              : 40 === s.keyCode &&
                (r[(e + 1) % r.length].focus(), Utils.stopEvent(s));
          });
        });
      });
  }),
    window.setTimeout(updateDepartmentsMenu, 200);
  var p = Utils.get_IE_version();
  (!p || p > 8) && $(window).resize(updateDepartmentsMenu),
    $("#searchFilterMenu > ul > li > a").click(function (e) {
      (document.getElementById("searchFilterButton").innerHTML =
        this.innerHTML),
        (document.getElementById("categoryId").value =
          this.getAttribute("data-value")),
        d(document.getElementById("searchFilterMenu"));
    }),
    $("#searchBox > .submitButton").click(function (e) {
      var t = document.getElementById("SimpleSearchForm_SearchTerm");
      t.value = $.trim(t.value);
      var r = $.trim(t.value.replace(/'|"/g, ""));
      t.value &&
        "" !== r &&
        processAndSubmitForm(document.getElementById("searchBox"));
    });
  var h = document.getElementById("searchBox");
  h &&
    $(h).submit(function (e) {
      updateFormWithWcCommonRequestParameters(e.target);
      var t = document.getElementById("SimpleSearchForm_SearchTerm"),
        r = t.value,
        s = $.trim(t.value.replace(/'|"/g, ""));
      return (
        (t.value = s),
        t.value ? void (t.value = $.trim(r)) : (Utils.stopEvent(e), !1)
      );
    });
});
var order_updated = {
    AjaxAddOrderItem: "AjaxAddOrderItem",
    AddOrderItem: "AddOrderItem",
    AjaxAddOrderItemWithShipingInfo: "AjaxAddOrderItemWithShipingInfo",
    AjaxDeleteOrderItem: "AjaxDeleteOrderItem",
    AjaxUpdateOrderItem: "AjaxUpdateOrderItem",
    AjaxUpdateOrderShippingInfo: "AjaxUpdateOrderShippingInfo",
    AjaxOrderCalculate: "AjaxOrderCalculate",
    AjaxLogoff: "AjaxLogoff",
    AjaxSetPendingOrder: "AjaxSetPendingOrder",
    AjaxUpdatePendingOrder: "AjaxUpdatePendingOrder",
    AjaxSingleOrderCancel: "AjaxSingleOrderCancel",
    AjaxUpdateRewardOption: "AjaxUpdateRewardOption",
  },
  dialogWidget,
  update_content = !1,
  dropdownUpdated = !1,
  dropdownInit = !1,
  productAddedList = {};
wcTopic.subscribe("ProductInfo_Added", setProductAddedList),
  ("undefined" != typeof ProductTabJS &&
    null != ProductTabJS &&
    ProductTabJS) ||
    (ProductTabJS = {
      lastTabId: null,
      selectTab: function (e) {
        $("div.tab_container").each(function (e, t) {
          $(t)
            .attr("aria-selected", "false")
            .attr("class", "tab_container inactive_tab")
            .attr("tabindex", "-1");
        }),
          $("div.tab").each(function (e, t) {
            $(t).css("display", "none");
          }),
          $("#" + e)
            .attr("aria-selected", "true")
            .attr("tabindex", "0")
            .attr("class", "tab_container active_tab"),
          $("#" + e + "Widget").css("display", "block"),
          $("#" + e + "Widget").each(function (e, t) {
            t.resize && t.resize();
          }),
          (null == this.lastTabId || this.lastTabId != e) &&
            (this.lastTabId = e);
      },
      selectTabWithKeyboard: function (e, t, r) {
        (r.keyCode == keys.DOWN_ARROW || r.keyCode == keys.RIGHT_ARROW) &&
          (e++,
          $("#tab" + e)
            ? (this.selectTab("tab" + e), this.focusTab("tab" + e))
            : (this.selectTab("tab1"), this.focusTab("tab1")),
          this.cancelEvent(r)),
          (r.keyCode == keys.UP_ARROW || r.keyCode == keys.LEFT_ARROW) &&
            ($("#tab" + (e - 1))
              ? (this.selectTab("tab" + (e - 1)),
                this.focusTab("tab" + (e - 1)))
              : (this.selectTab("tab" + t), this.focusTab("tab" + t)),
            this.cancelEvent(r));
      },
      cancelEvent: function (e) {
        Utils.stopEvent(e);
      },
      focusTab: function (e) {
        return $("#" + e).hasClass("focused_tab")
          ? void $("> div", "#" + e).css("border", "1px dotted #000000")
          : ($("#" + e).addClass("focused_tab"),
            $("> div", $("#" + e)).css("border", "1px dotted #000000"),
            $("#" + e).focus(),
            void 0);
      },
      blurTab: function (e) {
        $(e).removeClass("focused_tab"),
          $("> div", "#" + e).css("border", "1px solid transparent");
      },
    }),
  ("undefined" != typeof QuickInfoJS && null != QuickInfoJS && QuickInfoJS) ||
    (QuickInfoJS = {
      productImgDimensions: "1000x1000",
      quickInfoImgDimensions: "330x330",
      catEntryParams: {},
      selectedAttributes: new Object(),
      catEntryQuantity: 1,
      itemDetailsArr: new Object(),
      params: null,
      replaceOrderItemId: "",
      itemId: "",
      selectedSkuIndex: null,
      selectedThumbnailIndex: null,
      setReplaceOrderItemId: function (e) {
        this.replaceOrderItemId = e;
      },
      setValues: function () {
        $("#catEntryParamsForJS").length &&
          (this.catEntryParams = $.parseJSON($("#catEntryParamsForJS").val())),
          (this.catEntryParams.attributes = this.selectedAttributes);
      },
      setCatEntryQuantity: function (e) {
        this.catEntryQuantity = e;
      },
      showDetails: function (e, t, r, s, a) {
        if (
          (t ? (this.params = t) : (this.params = null),
          (this.selectedAttributes = new Object()),
          (this.selectedSkuIndex = null),
          (this.selectedThumbnailIndex = null),
          submitRequest())
        ) {
          this.close(), cursor_wait();
          var i = this.setCommonParams();
          r
            ? ((this.itemId = r), (i.updateAttributes = "true"))
            : ((this.itemId = ""), (i.updateAttributes = "false")),
            a && (i.parentPage = a),
            s && (this.catEntryQuantity = s),
            (i.productId = e),
            wcRenderContext.updateRenderContext("QuickInfoContext", i);
        }
      },
      changeAttributes: function (e, t, r, s) {
        this.setReplaceOrderItemId(e), this.showDetails(t, null, r, s);
      },
      changeImage: function (e, t) {
        (this.selectedThumbnailIndex = e - 1),
          $("#quickInfoMainImage").attr(
            "src",
            this.getQuickInfoImage(
              this.catEntryParams.skus[this.selectedSkuIndex]
                .thumbnailAttachments[this.selectedThumbnailIndex].path
            )
          ),
          $(".widget_quick_info_popup .other_views li").removeClass("selected"),
          "true" === isProduct
            ? $("#quickInfoProductThumbnail" + e).addClass("selected")
            : $("#quickInfoThumbnail" + e).addClass("selected");
      },
      setSelectedAttribute: function (e, t) {
        this.selectedAttributes[e] = t;
      },
      notifyAttributeChange: function () {
        wcTopic.publish("QuickInfo_attributesChanged", [
          JSON.stringify(this.selectedAttributes),
        ]),
          this.setValues();
        var e = this.resolveSKU();
        if (-1 != e)
          wcTopic.publish(
            "DefiningAttributes_Resolved",
            e,
            this.catEntryParams.id
          ),
            QuickInfoJS.selectItem(!0);
        else {
          wcTopic.publish("DefiningAttributes_Resolved", null, null);
          var t = !1;
          for (var r in this.selectedAttributes)
            null !== this.selectedAttributes[r] &&
              "" !== this.selectedAttributes[r] &&
              (t = !0);
          t ||
            ($("div[id^='quickinfoAngleImagesArea']").css("display", "none"),
            $("div[id^='quickinfoProductAngleImagesArea']").css(
              "display",
              "block"
            ),
            this.showDetails(this.catEntryParams.id, null, null, null, ""));
        }
      },
      selectItem: function (e, t) {
        (this.displayPriceRange = e), this.setValues();
        var r = this.resolveSKU();
        if (-1 == r && t) {
          var s = -1;
          for (idx = 0; idx < this.catEntryParams.skus.length; idx++)
            for (attribute in this.catEntryParams.skus[idx].attributes)
              if (
                this.catEntryParams.attributes &&
                this.catEntryParams.skus[idx].attributes[attribute] ==
                  this.catEntryParams.attributes[attribute]
              ) {
                s = this.catEntryParams.skus[idx].id;
                break;
              }
          -1 != s && ((r = s), (this.updateItemImageOnly = t));
        }
        if (-1 != r)
          if (
            null != this.itemDetailsArr[r] &&
            "undefined" != this.itemDetailsArr[r]
          )
            this.displayItemDetails(this.itemDetailsArr[r]);
          else {
            var a = this.setCommonParams();
            (a.catalogEntryId = r),
              wcService.declare({
                id: "getCatalogEntryDetailsQI",
                actionId: "getCatalogEntryDetailsQI",
                url:
                  getAbsoluteURL() +
                  appendWcCommonRequestParameters(
                    "GetCatalogEntryDetailsByIDView"
                  ),
                formId: "",
                successHandler: function (e, t) {
                  QuickInfoJS.setItemDetails(e, t);
                },
                failureHandler: function (e, t) {
                  console.debug(
                    "QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request."
                  );
                },
              }),
              wcService.invoke("getCatalogEntryDetailsQI", a);
          }
      },
      selectSwatch: function (e, t, r, s) {
        if (
          $("[id='quickInfoSwatch_" + e + "_" + t + "']").hasClass(
            "color_swatch_disabled"
          )
        )
          return alert("return.."), !1;
        this.setValues();
        for (
          var a = $("#WC_QuickInfo_SwatchNames").val().split("_"),
            i = -1,
            n = 0;
          n < a.length;
          n++
        )
          if (a[n] == e) {
            i = n;
            break;
          }
        var o = "quickInfoSwatch_" + e + "_" + t,
          d = "WC_QuickInfo_Swatch_" + e + "_" + t,
          l = new Array();
        for (idx in this.catEntryParams.skus) {
          var c = !1,
            u = this.catEntryParams.skus[idx];
          for (attribute in u.attributes)
            if (e == attribute && t == u.attributes[attribute] && u.buyable) {
              c = !0;
              break;
            }
          if (c)
            for (attribute in u.attributes) {
              for (var m = -1, n = 0; n < a.length; n++)
                if (a[n] == attribute) {
                  m = n;
                  break;
                }
              m > i && l.push(attribute + "_" + u.attributes[attribute]);
            }
        }
        var g = new Array(),
          p = new Array();
        for (idx in this.catEntryParams.skus) {
          var u = this.catEntryParams.skus[idx];
          for (attribute in u.attributes) {
            for (var m = -1, n = 0; n < a.length; n++)
              if (a[n] == attribute) {
                m = n;
                break;
              }
            if (m > i) {
              for (
                var h = attribute + "_" + u.attributes[attribute],
                  r = "quickInfoSwatch_" + h,
                  I = "WC_QuickInfo_Swatch_" + h,
                  y = -1,
                  n = 0;
                n < l.length;
                n++
              )
                if (l[n] == h) {
                  y = n;
                  break;
                }
              for (var f = -1, n = 0; n < g.length; n++)
                if (g[n] == h) {
                  f = n;
                  break;
                }
              y > -1
                ? $("[id='" + r + "']").hasClass("color_swatch_selected") ||
                  ($("[id='" + r + "']").attr("class", "color_swatch"),
                  $("[id='" + r + "']").attr(
                    "src",
                    $("[id='" + r + "']")
                      .attr("src")
                      .replace("_disabled.png", "_enabled.png")
                  ),
                  $("[id='" + I + "']").attr("aria-disabled", "false"))
                : -1 == f &&
                  (g.push(h),
                  $("[id='" + r + "']").hasClass("color_swatch_selected") &&
                    p.push(r),
                  $("[id='" + r + "']").attr("class", "color_swatch_disabled"),
                  $("[id='" + r + "']").attr(
                    "src",
                    $("[id='" + r + "']")
                      .attr("src")
                      .replace("_enabled.png", "_disabled.png")
                  ),
                  $("[id='" + I + "']").attr("aria-disabled", "true"));
            }
            $(
              "[id='WC_QuickInfo_Swatch_" +
                attribute +
                "_" +
                u.attributes[attribute] +
                "']"
            ).attr("aria-checked", "false");
          }
        }
        for (idx in p) {
          var S = p[idx],
            v = "img[id^='" + S.substring(0, S.lastIndexOf("_")) + "']",
            _ = !1;
          $(v).each(function (e, t, r) {
            if (!_ && $(t).hasClass("color_swatch")) {
              var s = t.id.split("_");
              QuickInfoJS.selectSwatch(
                s[1],
                s[2],
                "quickInfoSwatch_" + s[1] + "_" + s[2],
                "quickInfoSwatch_" + s[1] + "_"
              ),
                QuickInfoJS.selectItem(!0),
                (_ = !0);
            }
          });
        }
        (selector = "img[id^='" + s + "']"),
          $(selector).each(function (e, t, r) {
            $(t).hasClass("color_swatch_disabled") ||
              ($(t).addClass("color_swatch"),
              $(t).hasClass("color_swatch_selected") &&
                $(t).removeClass("color_swatch_selected"));
          }),
          $("[id='" + o + "']").attr("class", "color_swatch_selected"),
          $("[id='quickinfo_swatch_selection_" + e + "']").html(t),
          $("[id='" + d + "']").attr("aria-checked", "true"),
          this.setSelectedAttribute(e, t);
      },
      setCommonParams: function () {
        var e = new Object();
        return (
          (e.storeId = WCParamJS.storeId),
          (e.catalogId = WCParamJS.catalogId),
          (e.langId = WCParamJS.langId),
          e
        );
      },
      setItemDetails: function (e, t) {
        (QuickInfoJS.itemDetailsArr[
          e.catalogEntry.catalogEntryIdentifier.uniqueID
        ] = e.catalogEntry),
          QuickInfoJS.displayItemDetails(e.catalogEntry);
      },
      displayItemDetails: function (e) {
        if (null != this.catEntryParams)
          for (idx in this.catEntryParams.skus)
            if (
              null != this.catEntryParams.skus[idx] &&
              this.catEntryParams.skus[idx].id ==
                e.catalogEntryIdentifier.uniqueID
            ) {
              var t = $("div[id^='quickinfoAngleImagesArea']"),
                r = $("div[id^='quickinfoProductAngleImagesArea']");
              if (t.length) var s = t[0];
              if (
                null != this.catEntryParams.skus[idx].thumbnailAttachments &&
                this.catEntryParams.skus[idx].thumbnailAttachments.length > 0
              ) {
                r.css("display", "none");
                var a = $("ul[id^='quickInfoAngleImagesAreaList']");
                if (a.length) {
                  var i = a[0];
                  for (
                    null != s && $(s).css("display", "block"), idx2 = 1;
                    idx2 <=
                    this.catEntryParams.skus[idx].thumbnailAttachments.length;
                    idx2++
                  ) {
                    var n = document.createElement("li"),
                      o = document.createElement("a"),
                      d = document.createElement("img");
                    (n.id = "quickInfoThumbnail" + idx2),
                      (o.href =
                        "javaScript:QuickInfoJS.changeImage(" +
                        idx2 +
                        ",'" +
                        this.catEntryParams.skus[idx].fullImageAttachments[
                          idx2 - 1
                        ].path +
                        "');"),
                      (o.id = "WC_QuickInfo_Link_thumbnail_" + idx2),
                      (o.className = "tlignore"),
                      "undefined" !=
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].shortDesc &&
                        null !=
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc &&
                        (o.title =
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc),
                      (d.src =
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].path),
                      "undefined" !=
                        this.catEntryParams.skus[idx].thumbnailAttachments[
                          idx2 - 1
                        ].shortDesc &&
                        null !=
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc &&
                        (d.alt =
                          this.catEntryParams.skus[idx].thumbnailAttachments[
                            idx2 - 1
                          ].shortDesc),
                      1 == idx2 && $(i).empty(),
                      o.appendChild(d),
                      n.appendChild(o),
                      i.appendChild(n);
                  }
                }
              } else {
                var l = "block";
                for (attribute in this.selectedAttributes)
                  null != this.selectedAttributes[attribute] &&
                    "" != this.selectedAttributes[attribute] &&
                    (l = "none");
                if (null != r)
                  for (var c = 0; c < r.length; c++)
                    null != r[c] && $(r[c]).css("display", l);
                null != s && $(s).css("display", "none");
              }
              null == this.selectedThumbnailIndex &&
                (this.selectedThumbnailIndex = 0),
                (this.selectedSkuIndex = idx);
              var u = e.description[0].thumbnail;
              null != u &&
                0 != u.length &&
                $("#quickInfoMainImage").attr("src", u),
                $("#ProductInfoImage_" + this.catEntryParams.id).length &&
                  (document.getElementById(
                    "ProductInfoImage_" + this.catEntryParams.id
                  ).value = u);
            }
        if (this.updateItemImageOnly)
          return void (this.updateItemImageOnly = !1);
        if (
          ($(".widget_quick_info_popup .main_header")
            .first()
            .html(e.description[0].name),
          $("#ProductInfoName_" + this.catEntryParams.id).length &&
            (document.getElementById(
              "ProductInfoName_" + this.catEntryParams.id
            ).value = e.description[0].name),
          e.listPriced && e.listPrice > e.offerPrice)
        )
          if (null != $(".widget_quick_info_popup .old_price")[0])
            $(".widget_quick_info_popup .old_price").first().html(e.listPrice);
          else {
            var m = "<span class='old_price'>" + e.listPrice + "</span>",
              g = $(".widget_quick_info_popup .price")[0];
            $(m).before(g);
          }
        else
          null != $(".widget_quick_info_popup .old_price")[0] &&
            $(".widget_quick_info_popup .old_price").remove();
        $(".widget_quick_info_popup .price").first().html(e.offerPrice),
          $(".widget_quick_info_popup .sku")
            .first()
            .html(
              Utils.getLocalizationMessage("SKU") +
                " " +
                e.catalogEntryIdentifier.externalIdentifier.partNumber
            ),
          $("#ProductInfoPrice_" + this.catEntryParams.id).length &&
            (document.getElementById(
              "ProductInfoPrice_" + this.catEntryParams.id
            ).value = e.offerPrice);
      },
      validate: function () {
        return "ProductBean" != this.catEntryParams.type ||
          (null != this.catEntryParams.attributes &&
            "undefined" != this.catEntryParams.attributes)
          ? isPositiveInteger(this.catEntryQuantity)
            ? !0
            : (MessageHelper.displayErrorMessage(
                Utils.getLocalizationMessage.QUANTITY_INPUT_ERROR
              ),
              !1)
          : (MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage.ERR_RESOLVING_SKU
            ),
            !1);
      },
      add2ShopCart: function (e) {
        if (browseOnly)
          return void MessageHelper.displayErrorMessage(
            Utils.getLocalizationMessage.ERROR_ADD2CART_BROWSE_ONLY
          );
        if ((this.setValues(), this.validate())) {
          null == this.params &&
            ((this.params = this.setCommonParams()),
            (this.params.orderId = "."),
            (this.params.inventoryValidation = "true"),
            (this.params.calculateOrder = "0"));
          var t = "";
          if (
            "itembean" == this.catEntryParams.type.toLowerCase() ||
            "packagebean" == this.catEntryParams.type.toLowerCase() ||
            "dynamickitbean" == this.catEntryParams.type.toLowerCase()
          )
            updateParamObject(
              this.params,
              "catEntryId",
              this.catEntryParams.id,
              !1,
              -1
            ),
              updateParamObject(
                this.params,
                "quantity",
                this.catEntryQuantity,
                !1,
                -1
              ),
              (t = this.catEntryParams.id);
          else {
            var r = this.resolveSKU();
            if (-1 == r)
              return void MessageHelper.displayErrorMessage(
                Utils.getLocalizationMessage.ERR_RESOLVING_SKU
              );
            updateParamObject(this.params, "catEntryId", r, !1, -1),
              updateParamObject(
                this.params,
                "quantity",
                this.catEntryQuantity,
                !1,
                -1
              ),
              (t = r);
          }
          var s = "AddOrderItem";
          if (null != e && "undefined" != e) {
            for (i in e) this.params[i] = e[i];
            "dynamicKit" == e.catalogEntryType &&
              (s = "AddPreConfigurationToCart");
          }
          "dynamicKit" == this.params.catalogEntryType &&
            (s = "AddPreConfigurationToCart"),
            shoppingActionsJS.saveAddedProductInfo(
              this.catEntryQuantity,
              this.catEntryParams.id,
              t,
              this.selectedAttributes
            ),
            this.close(),
            submitRequest() &&
              (cursor_wait(), wcService.invoke(s, this.params));
        }
      },
      resolveSKU: function () {
        if (1 == this.catEntryParams.skus.length)
          return this.catEntryParams.skus[0].id;
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
          var e = 0,
            t = 0;
          for (attribute in this.catEntryParams.skus[idx].attributes) {
            if (
              (t++,
              !this.catEntryParams.attributes ||
                this.catEntryParams.skus[idx].attributes[attribute] !=
                  this.catEntryParams.attributes[attribute])
            )
              break;
            e++;
          }
          if (0 != e && e == t) return this.catEntryParams.skus[idx].id;
        }
        return -1;
      },
      showQuickInfoButton: function (e) {
        $("#" + e).css("visibility", "visible");
      },
      hideQuickInfoButton: function (e) {
        $("#" + e).css("visibility", "");
      },
      shiftTabHideQuickInfoButton: function (e, t) {
        t.shiftKey && t.keyCode === KeyCodes.TAB && this.hideQuickInfoButton(e);
      },
      close: function (e) {
        $("#quickInfoPopup").WCDialog("close"),
          null != e &&
            "undefined" != e &&
            document.getElementById(e) &&
            document.getElementById(e).focus();
      },
      setFocus: function (e) {
        if (e.keyCode === KeyCodes.ESCAPE && $("#catEntryParamsForJS").length) {
          var t = $("#catEntryParamsForJS").val(),
            r = $.parseJSON(t).id;
          document.getElementById("catalogEntry_img" + r) &&
            document.getElementById("catalogEntry_img" + r).focus();
        }
      },
      selectDefaultSwatch: function () {
        var swatchElement = $("a[id^='WC_QuickInfo_Swatch_']")[0];
        swatchElement && eval($(swatchElement).attr("href"));
      },
      replaceCartItem: function () {
        if ((this.setValues(), this.validate())) {
          var e = this.resolveSKU();
          if (-1 == e)
            return void MessageHelper.displayErrorMessage(
              Utils.getLocalizationMessage.ERR_RESOLVING_SKU
            );
          this.close();
          var t = "",
            r = "",
            s = "",
            a = $("#shipmentTypeId");
          $("#addressId_all").length && $("#shipModeId_all").length
            ? (0 === a.length || "1" != a.val()
                ? (t = $("#addressId_all").val())
                : $("#physicalStoreId").length &&
                  (s = $("#physicalStoreId").val()),
              (r = $("#shipModeId_all").val()))
            : $("#MS_ShipmentAddress_" + this.replaceOrderItemId).length &&
              $("#MS_ShippingMode_" + this.replaceOrderItemId).length &&
              ((t = $("#MS_ShipmentAddress_" + this.replaceOrderItemId).val()),
              (r = $("#MS_ShippingMode_" + this.replaceOrderItemId).val())),
            "" != this.replaceOrderItemId && categoryDisplayJS
              ? shoppingActionsJS.replaceItemAjaxHelper(
                  e,
                  this.catEntryQuantity,
                  this.replaceOrderItemId,
                  t,
                  r,
                  s
                )
              : console.error("categoryDisplayJS not defined");
        }
      },
      selectCurrentAttributes: function () {
        for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
          var e = this.catEntryParams.skus[idx];
          if (e.id == this.itemId) {
            for (attribute in e.attributes) {
              var t = $("select[alt='" + attribute + "']")[0];
              if (t)
                (t.value = e.attributes[attribute]),
                  this.setSelectedAttribute(attribute, t.value);
              else {
                var r = e.attributes[attribute];
                $("[id='quickInfoSwatch_" + attribute + "_" + r + "']")
                  .length &&
                  this.selectSwatch(
                    attribute,
                    r,
                    "quickInfoSwatch_" + attribute + "_" + r,
                    "quickInfoSwatch_" + attribute + "_"
                  );
              }
            }
            return this.notifyAttributeChange(), void this.selectItem(!0);
          }
        }
      },
    }),
  ("undefined" != typeof SearchJS && null != SearchJS && SearchJS) ||
    (SearchJS = {
      autoSuggestTimer: -1,
      autoSuggestKeystrokeDelay: 400,
      autoSuggestHover: !1,
      autoSuggestPreviousTerm: "",
      autoSuggestURL: "",
      autoSelectOption: -1,
      historyIndex: -1,
      retrievedCachedSuggestions: !1,
      TOTAL_SUGGESTED: 4,
      TOTAL_HISTORY: 2,
      AUTOSUGGEST_THRESHOLD: 1,
      DYNAMIC_AUTOSUGGEST_THRESHOLD: 1,
      CACHED_AUTOSUGGEST_OFFSET: 1e3,
      END_OF_LIST: !1,
      STATIC_CONTENT_SECTION_DIV: [
        "autoSuggestStatic_1",
        "autoSuggestStatic_2",
        "autoSuggestStatic_3",
      ],
      staticContentHeaderHistory: "",
      SearchAutoSuggestServletURL: "",
      searchDepartmentHoverTimeout: "",
      searchSuggestionHoverTimeout: "",
      mouseDownConnectHandle: null,
      searchDepartmentSelect: function (e, t) {
        return (
          $("#searchDepartmentLabel").html(t.innerHTML),
          ($("#search_categoryId").value = e),
          this.hideSearchDepartmentList(),
          !1
        );
      },
      cancelEvent: function (e) {
        e.stopPropagation && e.stopPropagation(),
          e.preventDefault && e.preventDefault(),
          (e.cancelBubble = !0),
          (e.cancel = !0),
          (e.returnValue = !1);
      },
      searchDepartmentKeyPressed: function (e, t, r, s, a) {
        if (e.keyCode === KeyCodes.RETURN) {
          this.searchDepartmentSelect(s, a);
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus();
        } else if (e.keyCode === KeyCodes.UP_ARROW)
          0 != t &&
            ($("#searchDepartmentList_" + (t - 1)).focus(),
            this.cancelEvent(e));
        else if (e.keyCode === KeyCodes.DOWN_ARROW)
          t != r &&
            ($("#searchDepartmentList_" + (t + 1)).focus(),
            this.cancelEvent(e));
        else if (e.keyCode === KeyCodes.ESCAPE) {
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus(),
            this.hideSearchDepartmentList();
        } else if (e.shiftKey && e.keyCode === KeyCodes.TAB) {
          var i = document.getElementById("mobileSearchDropdown");
          null != i && "block" == i.style.display
            ? $("#MobileSimpleSearchForm_SearchTerm").focus()
            : document.CatalogSearchForm.searchTerm.focus(),
            this.cancelEvent(e),
            this.hideSearchDepartmentList();
        } else
          e.keyCode === KeyCodes.TAB &&
            ($("#search_submit").focus(),
            this.cancelEvent(e),
            this.hideSearchDepartmentList());
        return !1;
      },
      hideSearchDepartmentList: function () {
        $("#searchDepartmentList").css("display", "none");
      },
      init: function () {
        $(document.CatalogSearchForm.searchTerm).on(
          "focus",
          $.proxy(SearchJS._onFocus, SearchJS)
        ),
          $(document.CatalogSearchForm.searchTerm).on(
            "keydown",
            $.proxy(SearchJS._onKeyDown, SearchJS)
          ),
          $(document.CatalogSearchForm.searchTerm).on(
            "keyup",
            $.proxy(SearchJS._onKeyUp, SearchJS)
          ),
          $("#searchDropdown").on(
            "keyup",
            $.proxy(SearchJS._onKeyTab, SearchJS)
          );
      },
      showSearchComponent: function () {
        var e = document.getElementById("searchDropdown");
        null != e && (e.style.display = "block");
      },
      hideSearchComponent: function () {
        var e = document.getElementById("searchDropdown");
        null != e && (e.style.display = "none");
      },
      _showMobileSearchComponent: function () {
        var e = document.getElementById("mobileSearchDropdown");
        null != e &&
          ("block" == e.style.display
            ? (DepartmentJS.close("mobileSearchDropdown"),
              (e.style.display = "none"))
            : ($(".subDeptDropdown ").each(function (e, t) {
                DepartmentJS.close(t.id);
              }),
              DepartmentJS.close("departmentsDropdown"),
              (e.style.display = "block")));
      },
      setAutoSuggestURL: function (e) {
        this.SearchAutoSuggestServletURL = getAbsoluteURL() + e;
      },
      _onFocus: function (e) {
        this.showSearchComponent(), this.retrieveCachedSuggestions();
      },
      _MobileonFocus: function (e) {
        this.showSearchComponent(), this.retrieveCachedSuggestions();
      },
      _MobileonBlur: function (e) {
        clearTimeout(this.searchSuggestionHoverTimeout),
          (this.searchSuggestionHoverTimeout = setTimeout(
            "SearchJS.showAutoSuggest(false)",
            100
          ));
      },
      _onKeyPress: function (e) {
        return e.keyCode !== KeyCodes.RETURN;
      },
      _onKeyDown: function (e) {
        e.keyCode === KeyCodes.RETURN
          ? (this._handleEnterKey(), this.cancelEvent(e))
          : e.keyCode === KeyCodes.TAB &&
            (clearTimeout(this.searchSuggestionHoverTimeout),
            (this.searchSuggestionHoverTimeout = setTimeout(
              "SearchJS.showAutoSuggest(false)",
              200
            )));
      },
      _onKeyUp: function (e) {
        var t = document.getElementById("searchDropdown");
        (t.style.display = "block"),
          this.doAutoSuggest(
            e,
            this.SearchAutoSuggestServletURL,
            document.CatalogSearchForm.searchTerm.value
          );
      },
      _onKeyTab: function (e) {
        e.keyCode === KeyCodes.TAB && $("#searchFilterButton").focus();
      },
      _MobileonKeyUp: function (e) {
        var t = document.getElementById("mobileSearchDropdown");
        (t.style.display = "block"),
          this.doAutoSuggest(
            e,
            this.SearchAutoSuggestServletURL,
            $("#MobileSimpleSearchForm_SearchTerm").val()
          );
      },
      _handleEnterKey: function () {
        (document.CatalogSearchForm.searchTerm.value = trim(
          document.CatalogSearchForm.searchTerm.value
        )),
          document.CatalogSearchForm.searchTerm.value.length > 0 &&
            (this.END_OF_LIST
              ? this.gotoAdvancedSearch(byId("advancedSearch").href)
              : "" !== this.autoSuggestURL &&
                this.autoSuggestURL != document.location.href + "#"
              ? (document.location.href = appendWcCommonRequestParameters(
                  this.autoSuggestURL
                ))
              : ((document.CatalogSearchForm.searchTerm.value = trim(
                  document.CatalogSearchForm.searchTerm.value
                )),
                submitSpecifiedForm(document.CatalogSearchForm)));
      },
      _onClick: function (e) {
        return (
          (document.CatalogSearchForm.searchTerm.value = trim(
            document.CatalogSearchForm.searchTerm.value
          )),
          document.CatalogSearchForm.searchTerm.value.length > 0 &&
            ("undefined" != typeof TealeafWCJS &&
              TealeafWCJS.processDOMEvent(e),
            submitSpecifiedForm(document.CatalogSearchForm)),
          !1
        );
      },
      _MobileonClick: function (e) {
        return (
          (document.MobileCatalogSearchForm.searchTerm.value = trim(
            document.MobileCatalogSearchForm.searchTerm.value
          )),
          document.MobileCatalogSearchForm.searchTerm.value.length > 0 &&
            ("undefined" != typeof TealeafWCJS &&
              TealeafWCJS.processDOMEvent(e),
            submitSpecifiedForm(document.MobileCatalogSearchForm)),
          !1
        );
      },
      doDynamicAutoSuggest: function (e, t, r) {
        -1 != this.autoSuggestTimer &&
          (clearTimeout(this.autoSuggestTimer), (this.autoSuggestTimer = -1)),
          (this.autoSuggestTimer = setTimeout(function () {
            var s = e + "&term=" + encodeURIComponent(t) + "&showHeader=" + r;
            $("#autoSuggestDynamic_Result_div").refreshWidget("updateUrl", s),
              console.debug("update autosuggest " + e),
              wcRenderContext.updateRenderContext("AutoSuggest_Context", {}),
              (this.autoSuggestTimer = -1);
          }, this.autoSuggestKeystrokeDelay));
      },
      gotoAdvancedSearch: function (e) {
        var t = $("#SimpleSearchForm_SearchTerm").val();
        document.location.href =
          appendWcCommonRequestParameters(e) + "&searchTerm=" + t;
      },
      showAutoSuggest: function (e) {
        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        var t = document.getElementById("autoSuggest_Result_div"),
          r = Utils.get_IE_version();
        if (r && 7 > r)
          var s = document.getElementById("autoSuggest_content_div"),
            a = document.getElementById("autoSuggestDropDownIFrame");
        if (isMobile) {
          null != t && "undefined" != typeof t
            ? e
              ? ((t.style.display = "block"),
                r &&
                  7 > r &&
                  ((a.style.height = s.scrollHeight),
                  (a.style.display = "block")),
                this.registerMouseDown(),
                $(".header__first-login").hide(),
                $(".header__search").css({ "max-height": "500px" }),
                $("#firstLogin").css({ "z-index": "19" }),
                $("#searchBox").css({ height: "500px" }),
                $("#searchDropdown").css({
                  left: "0px",
                  right: "0px",
                  width: "100%",
                }))
              : (r &&
                  7 > r &&
                  ((a.style.display = "none"), (a.style.height = 0)),
                (t.style.display = "none"),
                this.unregisterMouseDown(),
                $(".header__first-login").show(),
                $(".header__search").css({ "max-height": "64px" }),
                $("#firstLogin").css({ "z-index": "20" }),
                $("#searchBox").css({ height: "32px" }))
            : this.unregisterMouseDown();
        } else {
          null != t && "undefined" != typeof t
            ? e
              ? ((t.style.display = "block"),
                r &&
                  7 > r &&
                  ((a.style.height = s.scrollHeight),
                  (a.style.display = "block")),
                this.registerMouseDown(),
                $("#searchBox").css({ height: "225px" }))
              : (r &&
                  7 > r &&
                  ((a.style.display = "none"), (a.style.height = 0)),
                (t.style.display = "none"),
                this.unregisterMouseDown(),
                $("#searchBox").css({ height: "68px" }))
            : this.unregisterMouseDown();
        }
      },
      showAutoSuggestIfResults: function () {
        var e = document.getElementById("mobileSearchDropdown");
        "undefined" != typeof staticContent &&
        "" === $("#" + this.STATIC_CONTENT_SECTION_DIV[0]).html() &&
        "" === $("#autoSuggestHistory").html() &&
        null == document.getElementById("dynamicAutoSuggestTotalResults")
          ? this.showAutoSuggest(!1)
          : null != e && "block" == e.style.display
          ? $("#MobileSimpleSearchForm_SearchTerm").val().length <=
            this.AUTOSUGGEST_THRESHOLD
            ? this.showAutoSuggest(!1)
            : this.showAutoSuggest(!0)
          : document.CatalogSearchForm.searchTerm.value.length <=
            this.AUTOSUGGEST_THRESHOLD
          ? this.showAutoSuggest(!1)
          : this.showAutoSuggest(!0);
      },
      selectAutoSuggest: function (e) {
        var t = document.getElementById("mobileSearchDropdown");
        if (null != t && "block" == t.style.display)
          var r = document.getElementById("MobileSimpleSearchForm_SearchTerm");
        else var r = document.CatalogSearchForm.searchTerm;
        (r.value = e),
          r.focus(),
          (this.autoSuggestPreviousTerm = e),
          "undefined" != typeof TealeafWCJS &&
            TealeafWCJS.createExplicitChangeEvent(r),
          submitSpecifiedForm(document.CatalogSearchForm);
      },
      highLightSelection: function (e, t) {
        var r = document.getElementById("autoSelectOption_" + t);
        if (null != r && "undefined" != typeof r) {
          if (e) {
            r.className = "autoSuggestSelected";
            var s = document.getElementById("mobileSearchDropdown");
            if (null != s && "block" == s.style.display)
              var a = document.getElementById(
                "MobileSimpleSearchForm_SearchTerm"
              );
            else var a = document.CatalogSearchForm.searchTerm;
            $(a).attr("aria-activedescendant", "suggestionItem_" + t);
            var i = document.getElementById("dynamicAutoSuggestTotalResults");
            ((null != i && "undefined" != typeof i && t < i.value) ||
              t >= this.historyIndex) &&
              ((a.value = r.title), (this.autoSuggestPreviousTerm = r.title)),
              (this.autoSuggestURL = r.href);
          } else r.className = "";
          return !0;
        }
        return !1;
      },
      enableAutoSelect: function (e) {
        this.highLightSelection(!1, this.autoSelectOption);
        var t = document.getElementById("autoSelectOption_" + e);
        (t.className = "autoSuggestSelected"), (this.autoSelectOption = e);
      },
      resetAutoSuggestKeyword: function () {
        var e = document.getElementById("autoSuggestOriginalTerm");
        if (null != e && "undefined" != typeof e) {
          var t = document.getElementById("mobileSearchDropdown");
          if (null != t && "block" == t.style.display)
            var r = document.getElementById(
              "MobileSimpleSearchForm_SearchTerm"
            );
          else var r = document.CatalogSearchForm.searchTerm;
          (r.value = e.value), (this.autoSuggestPreviousTerm = e.value);
        }
      },
      clearAutoSuggestResults: function () {
        for (var e = 0; e < staticContent.length; e++)
          $("#" + this.STATIC_CONTENT_SECTION_DIV[e]).html("");
        (this.autoSuggestPreviousTerm = ""),
          (this.autoSuggestURL = ""),
          $("#autoSuggestDynamic_Result_div").html(""),
          this.showAutoSuggest(!1);
      },
      doAutoSuggest: function (e, t, r) {
        if (
          ((r = r.trim()),
          r.length <= this.AUTOSUGGEST_THRESHOLD && this.showAutoSuggest(!1),
          e.keyCode !== KeyCodes.RETURN)
        ) {
          if (e.keyCode === KeyCodes.TAB)
            return void (this.autoSuggestHover = !0);
          if (e.keyCode === KeyCodes.ESCAPE)
            return void this.showAutoSuggest(!1);
          if (e.keyCode !== KeyCodes.UP_ARROW) {
            if (e.keyCode !== KeyCodes.DOWN_ARROW) {
              if (
                !(
                  (r.length > this.AUTOSUGGEST_THRESHOLD &&
                    r == this.autoSuggestPreviousTerm) ||
                  ((this.autoSuggestPreviousTerm = r),
                  r.length <= this.AUTOSUGGEST_THRESHOLD)
                )
              )
                if (
                  (-1 != this.autoSuggestTimer &&
                    (clearTimeout(this.autoSuggestTimer),
                    (this.autoSuggestTimer = -1)),
                  "" !== r)
                ) {
                  this.autoSelectOption = -1;
                  this.doStaticAutoSuggest(r);
                  if (r.length > this.DYNAMIC_AUTOSUGGEST_THRESHOLD) {
                    var s = !0;
                    this.doDynamicAutoSuggest(t, r, s);
                  } else $("#autoSuggestDynamic_Result_div").html("");
                } else this.clearAutoSuggestResults();
            } else if (this.highLightSelection(!0, this.autoSelectOption + 1))
              this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption++;
            else if (
              this.autoSelectOption < this.CACHED_AUTOSUGGEST_OFFSET &&
              this.highLightSelection(!0, this.CACHED_AUTOSUGGEST_OFFSET)
            )
              this.highLightSelection(!1, this.autoSelectOption),
                (this.autoSelectOption = this.CACHED_AUTOSUGGEST_OFFSET),
                this.resetAutoSuggestKeyword();
            else if (!this.END_OF_LIST) {
              $("#autoSuggestAdvancedSearch").addClass("autoSuggestSelected"),
                this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption++,
                (this.END_OF_LIST = !0);
              var a = document.getElementById("mobileSearchDropdown");
              if (null != a && "block" == a.style.display)
                var i = document.getElementById(
                  "MobileSimpleSearchForm_SearchTerm"
                );
              else var i = document.CatalogSearchForm.searchTerm;
              $(i).attr("aria-activedescendant", "advancedSearch");
            }
          } else {
            var n = document.getElementById("dynamicAutoSuggestTotalResults");
            if (this.END_OF_LIST)
              $("#autoSuggestAdvancedSearch").removeClass(
                "autoSuggestSelected"
              ),
                (this.END_OF_LIST = !1),
                this.autoSelectOption--,
                this.highLightSelection(!0, this.autoSelectOption) ||
                  (this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET &&
                    null != n &&
                    "undefined" != typeof n &&
                    ((this.autoSelectOption = n.value - 1),
                    this.highLightSelection(!0, this.autoSelectOption)));
            else if (this.highLightSelection(!0, this.autoSelectOption - 1))
              this.highLightSelection(!1, this.autoSelectOption),
                this.autoSelectOption == this.historyIndex &&
                  this.resetAutoSuggestKeyword(),
                this.autoSelectOption--;
            else if (
              this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET &&
              null != n &&
              "undefined" != typeof n
            )
              this.highLightSelection(!1, this.CACHED_AUTOSUGGEST_OFFSET),
                (this.autoSelectOption = n.value - 1),
                this.highLightSelection(!0, this.autoSelectOption);
            else {
              this.highLightSelection(!1, this.autoSelectOption),
                (this.autoSelectOption = -1);
              document.getElementById("autoSuggestOriginalTerm");
              this.resetAutoSuggestKeyword();
            }
          }
        }
      },
      tokenizeForBidi: function (e, t, r, s) {
        var a = e.split(" > "),
          n = "",
          o = "";
        if (a.length > 0) {
          for (n += "<div class='category_list'>", i = 0; i < a.length; i++) {
            if (
              (0 != i && (n += "<span class='gt'>&nbsp; > &nbsp;</span>"),
              i == a.length - 1)
            ) {
              var d = t.toLowerCase().indexOf(s),
                l = t.substr(0, d),
                c = t.substr(d + r.length),
                u = "<span class='highlight'>" + r + "</span>";
              o = l + u + c;
            } else o = a[i];
            n += o;
          }
          n += "</div>";
        }
        return n;
      },
      // doStaticAutoSuggest: function (e) {
      //   for (
      //     var t = ["", "", "", "", "", ""],
      //       r = 0,
      //       s = e.toLowerCase(),
      //       a = this.CACHED_AUTOSUGGEST_OFFSET,
      //       i = "<div class='list_section'><div",
      //       n = "</div></div>",
      //       o = 0;
      //     o < staticContent.length;
      //     o++
      //   )
      //     for (var d = 0, l = 0; l < staticContent[o].length; l++) {
      //       var c = staticContent[o][l][0],
      //         u = staticContent[o][l][1],
      //         m = staticContent[o][l][2],
      //         g = c.toLowerCase().indexOf(s);
      //       if (-1 != g) {
      //         var p = this.tokenizeForBidi(m, c, e, s);
      //         if (
      //           ((t[o] =
      //             t[o] +
      //             "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" +
      //             a +
      //             "' role='listitem' tabindex='-1'><a id='autoSelectOption_" +
      //             a +
      //             "' title='" +
      //             escapeXml(c, !0) +
      //             "' onmouseout='this.className=\"\"; this.autoSuggestURL=\"\";' onclick='SearchJS.hideSearchComponent();' onmouseover='SearchJS.enableAutoSelect(" +
      //             a +
      //             "); this.autoSuggestURL=this.href;' href=\"" +
      //             u +
      //             '">' +
      //             p +
      //             "</a></li></ul>"),
      //           d++,
      //           a++,
      //           d >= this.TOTAL_SUGGESTED)
      //         )
      //           break;
      //       }
      //     }
      //   for (var o = 0; o < staticContent.length; o++)
      //     if (
      //       ($("#" + this.STATIC_CONTENT_SECTION_DIV[o]).html(""), "" !== t[o])
      //     ) {
      //       var h =
      //         "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" +
      //         staticContentHeaders[o] +
      //         "</span></li></ul>";
      //       $("#" + this.STATIC_CONTENT_SECTION_DIV[r]).html(
      //         h +
      //           i +
      //           " role='list' title='" +
      //           staticContentHeaders[o] +
      //           "' aria-label='" +
      //           staticContentHeaders[o] +
      //           "'>" +
      //           t[o] +
      //           n
      //       ),
      //         r++;
      //     }
      //   var I = "",
      //     y = document.getElementById("autoSuggestHistory");
      //   y.innerHTML = "";
      //   var f = [];
      //   this.historyIndex = a;
      //   var S = getCookie("searchTermHistory");
      //   if ("undefined" != typeof S)
      //     for (var v = S.split("|"), d = 0, o = v.length - 1; o > 0; o--) {
      //       var _ = v[o],
      //         C = _.toLowerCase();
      //       if (C.match("^" + s) == s) {
      //         for (var A = !1, l = 0; l < f.length; l++)
      //           if (f[l] == C) {
      //             A = !0;
      //             break;
      //           }
      //         if (!A) {
      //           if (d >= this.TOTAL_HISTORY) break;
      //           (I =
      //             I +
      //             "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" +
      //             a +
      //             "' role='listitem' tabindex='-1'><a href='#' onmouseout='this.className=\"\"' onmouseover='SearchJS.enableAutoSelect(" +
      //             a +
      //             ");' onclick='SearchJS.selectAutoSuggest(this.title); return false;' title='" +
      //             _ +
      //             "' id='autoSelectOption_" +
      //             a +
      //             "'><strong>" +
      //             e +
      //             "</strong>" +
      //             _.substring(e.length, _.length) +
      //             "</a></li></ul>"),
      //             f.push(C),
      //             d++,
      //             a++;
      //         }
      //       }
      //     }
      //   if (
      //     ("" === this.staticContentHeaderHistory &&
      //       (this.staticContentHeaderHistory =
      //         Utils.getLocalizationMessage("HISTORY")),
      //     "" !== I)
      //   ) {
      //     var h =
      //       "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" +
      //       this.staticContentHeaderHistory +
      //       "</span></li></ul>";
      //     (y.innerHTML =
      //       h +
      //       i +
      //       " title='" +
      //       this.staticContentHeaderHistory +
      //       "'>" +
      //       I +
      //       n),
      //       r++;
      //   }
      //   return r > 0 ? (this.showAutoSuggest(!0), !0) : !1;
      // },
      retrieveCachedSuggestions: function () {
        this.retrievedCachedSuggestions ||
          wcRenderContext.updateRenderContext("CachedSuggestions_Context", {});
      },
      // updateSearchTermHistoryCookie: function (e) {
      //   var t = "searchTermHistory",
      //     r = "|" + e,
      //     s = getCookie(t);
      //   "undefined" != typeof s && (r = setCookie(t) + r),
      //     setCookie(t, r, {
      //       path: "/",
      //       domain: cookieDomain,
      //     });
      // },
      // updateSearchTermHistoryCookieAndRedirect: function (e, t) {
      //   this.updateSearchTermHistoryCookie(e),
      //     -1 == navigator.userAgent.toLowerCase().indexOf("firefox") &&
      //       (document.location.href = appendWcCommonRequestParameters(t));
      // },
      isValidNumber: function (e) {
        return !isNaN(parseFloat(e)) && isFinite(e) && e >= 0;
      },
      validateForm: function (e) {
        (e.minPrice.value = trim(e.minPrice.value)),
          (e.maxPrice.value = trim(e.maxPrice.value));
        var t = e.minPrice.value,
          r = e.maxPrice.value,
          s = this.isValidNumber(t),
          a = this.isValidNumber(r);
        if (t.length > 0 && !s)
          return (
            MessageHelper.formErrorHandleClient(
              e.minPrice.id,
              MessageHelper.messages.EDPPaymentMethods_AMOUNT_NAN
            ),
            !1
          );
        if (r.length > 0 && !a)
          return (
            MessageHelper.formErrorHandleClient(
              e.maxPrice.id,
              MessageHelper.messages.EDPPaymentMethods_AMOUNT_NAN
            ),
            !1
          );
        if (t.length > 0 && r.length > 0 && parseFloat(t) > parseFloat(r))
          return (
            MessageHelper.formErrorHandleClient(
              e.maxPrice.id,
              MessageHelper.messages.ERROR_PRICE_RANGE
            ),
            !1
          );
        (e.searchTerm.value = trim(e.searchTerm.value)),
          (e.filterTerm.value = trim(e.filterTerm.value)),
          (e.manufacturer.value = trim(e.manufacturer.value));
        var i = e.searchTerm.value,
          n = e.filterTerm.value,
          o = e.manufacturer.value;
        return 0 == i.length && 0 == n.length && 0 == o.length
          ? (MessageHelper.formErrorHandleClient(
              e.searchTerm.id,
              MessageHelper.messages.ERROR_EMPTY_SEARCH_FIELDS
            ),
            !1)
          : void processAndSubmitForm(e);
      },
      registerMouseDown: function () {
        null == this.mouseDownConnectHandle &&
          (this.mouseDownConnectHandle = $(document.documentElement).on(
            "mousedown",
            $.proxy("handleMouseDown", this)
          ));
      },
      unregisterMouseDown: function () {
        null != this.mouseDownConnectHandle &&
          ($(document.documentElement).off("mousedown"),
          (this.mouseDownConnectHandle = null));
      },
      handleMouseDown: function (e) {
        var t = e.target;
        if (t != document.documentElement) {
          for (
            var r = document.getElementById("searchDropdown"),
              s = document.CatalogSearchForm.searchTerm,
              a = !0;
            t;

          ) {
            if (t == r || t == s) {
              a = !1;
              break;
            }
            t = t.parentNode;
          }
          a && this.showAutoSuggest(!1);
        }
      },
      declareAutoSuggestRefreshArea: function () {
        wcRenderContext.declare(
          "AutoSuggest_Context",
          ["autoSuggestDynamic_Result_div"],
          null
        );
        var e = function () {
            var e = wcRenderContext.getRenderContextProperties(
              "AutoSuggest_Context"
            );
            $("#autoSuggestDynamic_Result_div").refreshWidget("refresh", e);
          },
          t = function () {
            var e = document.getElementById("suggestedKeywordResults"),
              t = document.getElementById("suggestedProductsResults");
            null == e &&
              null == t &&
              $("#autoSuggestDynamic_Result_div").html(""),
              SearchJS.showAutoSuggestIfResults();
          };
        $("#autoSuggestDynamic_Result_div").refreshWidget({
          renderContextChangedHandler: e,
          postRefreshHandler: t,
        });
      },
      declareAutoSuggestCachedSuggestionRefreshArea: function () {
        wcRenderContext.declare(
          "CachedSuggestions_Context",
          ["autoSuggestCachedSuggestions_div"],
          null
        );
        var e = function () {
            var e = wcRenderContext.getRenderContextProperties(
              "CachedSuggestions_Context"
            );
            $("#autoSuggestCachedSuggestions_div").refreshWidget("refresh", e);
          },
          t = function () {
            var e = document.getElementById("cachedSuggestions");
            if (null == e) $("#autoSuggestCachedSuggestions_div").html("");
            else {
              for (
                var t = e.getElementsByTagName("script"), r = t.length, s = 0;
                r > s;
                s++
              ) {
                var a = document.createElement("script");
                (a.type = "text/javascript"),
                  (a.text = t[s].text),
                  document
                    .getElementById("autoSuggestCachedSuggestions_div")
                    .appendChild(a);
              }
              SearchJS.retrievedCachedSuggestions = !0;
              var i = document.getElementById("mobileSearchDropdown");
              null != i && "block" == i.style.display
                ? (searchTerm = $("#MobileSimpleSearchForm_SearchTerm").val())
                : (searchTerm = document.CatalogSearchForm.searchTerm.value),
                searchTerm.length > SearchJS.AUTOSUGGEST_THRESHOLD &&
                  SearchJS.doStaticAutoSuggest(searchTerm);
            }
          };
        $("#autoSuggestCachedSuggestions_div").refreshWidget({
          renderContextChangedHandler: e,
          postRefreshHandler: t,
        });
      },
    }),
  ("undefined" != typeof ShoppingListDialogJS &&
    null != ShoppingListDialogJS &&
    ShoppingListDialogJS) ||
    ((ShoppingListDialogJS = {
      storeParams: null,
      dialogParams: null,
      setDialogParams: function (e, t) {
        (this.storeParams = e),
          (this.dialogParams = t),
          null == this.dialogParams.image || "" == this.dialogParams.image
            ? this.fetchAddedItem()
            : this.displayItemAddedWithoutFetching();
      },
      fetchAddedItem: function () {
        var e = this.setCommonParams();
        (e.productId = this.dialogParams.catEntryId),
          (e.catalogEntryId = this.dialogParams.catEntryId),
          $.ajax({
            url: getAbsoluteURL() + "GetCatalogEntryDetailsByIDView",
            method: "post",
            dataType: "json",
            data: e,
            success: ShoppingListDialogJS.displayItemAddedDialog,
            error: function (e, t, r) {
              console.debug(
                "QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request."
              );
            },
          });
      },
      displayItemAddedDialog: function (e) {
        var t = $("#shoppingListItemAddedPopup");
        if (t.length > 0) {
          var r = e.catalogEntry.description[0];
          $("#shoppingListItemAddedImg")
            .attr("src", r.thumbnail)
            .attr("alt", r.name),
            $("#shoppingListItemAddedName").html(r.name),
            $("#shoppingListItemAddedPopup").data("wc-WCDialog").open();
        } else console.debug("shoppingListItemAddedPopup does not exist");
      },
      displayItemAddedWithoutFetching: function () {
        $("#shoppingListItemAddedPopup").length
          ? ($("#shoppingListItemAddedImg").attr(
              "src",
              this.dialogParams.image
            ),
            $("#shoppingListItemAddedImg").attr("alt", this.dialogParams.name),
            $("#shoppingListItemAddedName").html(this.dialogParams.name))
          : console.debug("shoppingListItemAddedPopup does not exist");
      },
      showDialog: function () {
        var e = $("#shoppingListItemAddedPopup");
        e.length > 0
          ? e.data("wc-WCDialog").open()
          : console.debug("shoppingListItemAddedPopup does not exist");
      },
      setCommonParams: function () {
        var e = new Object();
        return (
          (e.storeId = this.storeParams.storeId),
          (e.catalogId = this.storeParams.catalogId),
          (e.langId = this.storeParams.langId),
          e
        );
      },
      close: function () {
        $("#shoppingListItemAddedPopup").hide(),
          this.dialogParams.focusElement &&
            "" != this.dialogParams.focusElement &&
            $("#" + this.dialogParams.focusElement).focus();
      },
    }),
    wcTopic.subscribe(
      "ShoppingListItem_Added",
      ShoppingListDialogJS.showDialog
    )),
  wcRenderContext.declare(
    "WishlistDisplay_Context",
    ["WishlistDisplay_Widget"],
    {
      url: "",
    }
  ),
  wcRenderContext.declare(
    "SharedWishlistDisplay_Context",
    ["SharedWishlistDisplay_Widget"],
    {
      url: "",
    }
  ),
  (ShoppingListControllersJS = {
    declareWishlistDisplayWidgetRefreshController: function () {
      var e = $("#WishlistDisplay_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "WishlistDisplay_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        };
      wcTopic.subscribe(
        [
          "ShoppingListServiceCreate",
          "ShoppingListServiceUpdate",
          "ShoppingListServiceDelete",
          "ShoppingListServiceRemoveItem",
          "ShoppingListServiceAddItem",
        ],
        function () {
          e.refreshWidget("refresh");
        }
      );
      var s = function () {
        null != $("#multipleWishlistController_select") &&
          "undefined" != $("#multipleWishlistController_select") &&
          ($("#multipleWishlistController_select").disabled = !1),
          cursor_clear();
      };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareSharedWishlistDisplayRefreshController: function () {
      var e = $("#SharedWishlistDisplay_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "SharedWishlistDisplay_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        },
        s = function () {
          cursor_clear();
        };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
    declareWishlistSelectWidgetRefreshController: function () {
      wcRenderContext.declare(
        "WishlistSelect_Context",
        ["WishlistSelect_Widget"],
        ""
      );
      var e = $("#WishlistSelect_Widget"),
        t = wcRenderContext.getRenderContextProperties(
          "WishlistSelect_Context"
        ),
        r = function () {
          e.refreshWidget("refresh", t);
        };
      wcTopic.subscribe(
        [
          "ShoppingListServiceCreate",
          "ShoppingListServiceUpdate",
          "ShoppingListServiceDelete",
          "ShoppingListServiceAddItem",
        ],
        function () {
          e.refreshWidget("refresh");
        }
      );
      var s = function () {
        cursor_clear();
        var e = $("#multipleWishlistController_select");
        null == e
          ? ((MultipleWishLists.defaultListId = null),
            (MultipleWishLists.addItemAfterCreate = null))
          : e.length > 0 &&
            ((MultipleWishLists.defaultListId = $(
              "#multipleWishlistController_select"
            ).val()),
            shoppingListJS.refreshLinkState());
      };
      e.refreshWidget({
        renderContextChangedHandler: r,
        postRefreshHandler: s,
      });
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceCreate",
    actionId: "ShoppingListServiceCreate",
    url: getAbsoluteURL() + "AjaxRestWishListCreate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: e.descriptionName,
          action: "add",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceUpdate",
    actionId: "ShoppingListServiceUpdate",
    url: getAbsoluteURL() + "AjaxRestWishListUpdate",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("LIST_EDITED")
        ),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: e.descriptionName,
          action: "edit",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceDelete",
    actionId: "ShoppingListServiceDelete",
    url: getAbsoluteURL() + "AjaxRestWishListDelete",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        closeAllDialogs(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("LIST_DELETED")
        ),
        wcTopic.publish("ShoppingList_Changed", {
          listId: e.uniqueID,
          listName: "",
          action: "delete",
        });
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceAddItem",
    actionId: "ShoppingListServiceAddItem",
    url: getAbsoluteURL() + "AjaxRestWishListAddItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), wcTopic.publish("ShoppingListItem_Added");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceRemoveItem",
    actionId: "ShoppingListServiceRemoveItem",
    url: getAbsoluteURL() + "AjaxRestWishListRemoveItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("ITEM_REMOVED")
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "ShoppingListServiceAddItemAndRemoveFromCart",
    actionId: "ShoppingListServiceAddItemAndRemoveFromCart",
    url: getAbsoluteURL() + "AjaxRestWishListAddItem",
    formId: "",
    successHandler: function (e) {
      cursor_clear(), wcTopic.publish("ShoppingListItem_Added");
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxGiftListServiceChangeGiftListStatus",
    actionId: "AjaxGiftListServiceChangeGiftListStatus",
    url: getAbsoluteURL() + "AjaxRestWishListChangeState",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        MultipleWishLists.setDefaultListId(e.uniqueID),
        MultipleWishLists.updateContextPostSwitch(e.uniqueID);
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  }),
  wcService.declare({
    id: "AjaxGiftListAnnouncement",
    actionId: "AjaxGiftListAnnouncement",
    url: getAbsoluteURL() + "AjaxRESTWishListAnnounce",
    formId: "",
    successHandler: function (e) {
      cursor_clear(),
        MessageHelper.hideAndClearMessage(),
        shoppingListJS.showMessageDialog(
          Utils.getLocalizationMessage("WISHLIST_EMAIL_SENT")
        ),
        $("#WishListEmailSucMsg_Div").css("display", "block"),
        $("#recipientEmail_wishListDisplay").html(
          e.recipient[0].substring(0, 25)
        );
    },
    failureHandler: function (e) {
      e.errorMessage
        ? MessageHelper.displayErrorMessage(e.errorMessage)
        : e.errorMessageKey &&
          MessageHelper.displayErrorMessage(e.errorMessageKey),
        cursor_clear();
    },
  });


/* jshint esversion: 6 */
/**
 * @fileOverview Generic JS file for Persol brand
 *
 **/
/* detect mobile*/

// .includes polyfill
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement /*, fromIndex*/) {
    'use strict';
    if (this == null) {
      return;
    }

    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {k = 0;}
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement ||
         (searchElement !== searchElement && currentElement !== currentElement)) { // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}
// starts with polyfill
if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
      value: function(search, rawPos) {
          var pos = rawPos > 0 ? rawPos|0 : 0;
          return this.substring(pos, pos + search.length) === search;
      }
  });
}
/* this remove the page positioning on his previous scroll position*/
if (!isIOS() && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

var didResize;

var phoneWidth = 600;
var tabletWidth = 1024;
var countPrescription = 0;

var catalogEntryDetails = "";
var idSection;

function showSubmenu() {
  $(".nav__section").removeClass( "show") ;
  idSection= "#"+ $(this).attr('id') + "_Section";
  $( idSection ).addClass( "show" );
  $('html').addClass('no-scroll');
  $('.facet__fade').addClass('fade');
  $('.facet__fade').css('z-index','10');
  $('.facet__fade').show();

}

function hideSubmenu() {
  $( idSection ).removeClass( "show");
  $('html').removeClass('no-scroll');
  $('.facet__fade').removeClass('fade');
  $('.facet__fade').css('z-index','');
  var nav = idSection.replace("_Section","");
  $( nav ).css("text-decoration","none");

}

function hideshowallsite() {
    var allsite = $("#allsite-content").html();
    if (allsite !== ''){
        var row4 = document.getElementById("footerRow4");
        $("#allsite-content").empty();
        row4.innerHTML = allsite;
    }else;
    
    if ( $("#otherall label").hasClass("active") ){
        $("#otherall label").toggleClass('active');
        $("#footerRow4").hide();
    }
    else{
        $("#otherall label").addClass('active');
        $("#footerRow4").show();
    }
} 

function refreshNavItemSettings(isDesktop) {
if(isDesktop) {		
  $('.sale_badge').removeClass('submenu__subheader');
  $('.sale_badge').removeClass('submenu__subheader--mobile');
  $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
  $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
  
  if($('#closeIcon').css('display') != 'none' && $('#closeIcon').css('display') != undefined) //chiudi il menu se aperto
    document.getElementById('header__checkbox').click();
  
  $('.header__block-search').removeClass( "hidden" );
  
  $( ".nav__item" ).hover(
            function(){
            	setDDMPosition();
                $(".nav__section").removeClass( "show") ;
                idSection= "#"+ $($(this).find(".nav__link.desktop")).attr('id') + "_Section";
                $( idSection ).addClass( "show" );
               callAlgoliaServiceEspot(idSection);

                $('html').addClass('no-scroll');
                $('.facet__fade').addClass('fade');
                $('.facet__fade').css('z-index','10');
                $('.facet__fade').show();
                $(this).find(".nav__link.desktop").css("text-decoration","underline");
                $(".nav__item a[id!='"+$(this).find("a").attr("id")+"'].nav__link.desktop").css("text-decoration","none");
            },
            function(){
              //if the cursor is not in hover on the sub menu --> hide the submenu
              if($(".nav__section:hover").length < 1) {
                hideSubmenu();
              }
            }
        );
  
} else {
  //sezione mobile
  $( ".nav__item" ).unbind();
  $('.sale_badge').addClass('submenu__subheader');
  $('.sale_badge').addClass('submenu__subheader--mobile');
  $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
  $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
  //loadHeaderEspot("X_Header_NavSunglasses_BestsellersCards"); 
  //loadHeaderEspot("X_Header_NavEyeglasses_BestsellersCards");
}
}  



$(document).ready(function () {
    if (!window.mobilecheck() || !window.tabletPortraitCheck()){
        setDDMPosition();
    }
    

  if($('#page').hasClass('pdp')){

    /* handle when sticky bar doesn't become sticky on landing for HB-12208*/
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if(!$(".shopper-action-bar").hasClass("sticky-active")){
            manageStickyElement();
        }
      }


      var timestamp = new Date().getTime() / 1000;
      var diff = timestamp - renderingPageStarterTime;
      console.log('Performance Improvements PDP - #21 - document.ready in store-persol.js (PO only) - ' + diff.toString().slice(0 , 5) + 's');
    }


  var catEntryIdSubscribe;
   // apertura section #departmentLink_sun
  $("#departmentLink_OurWorld_Section,#departmentLink_Gif_Section").addClass("vertical-carousel");
  //apertura menu mobile
  $(".nav__link.phone").click(function() {
    
      var idSection;
      $($(this).siblings()).each(function(){
          if($(this).hasClass("desktop")){
              idSection = "#"+ $(this).attr('id') + "_Section";
          }
          callAlgoliaServiceEspot(idSection); //provare questa
          console.log("idSection",idSection);
          if(idSection == "#departmentLink_collab_Section"){//quando apro collab devo vedere sempre collectio e nascondo i contenuti
              idSection= "#departmentLink_Collection_Section";
              console.log("this",this);
              if($(this).find("subheader__collection")){
                  console.log("ok");
                  $(".subheader__collection").css("display","none");
                  if($(this).find("subheader__collaboration")){
                      $(".subheader__collaboration").css("display","block");
                  }

              }
          }else if(idSection=="#departmentLink_Collection_Section"){
              if($(this).find("subheader__collection")){
                  $(".subheader__collection").css("display","block");
                  if($(this).find("subheader__collaboration")){
                      $(".subheader__collaboration").css("display","none");
                  }

              }

          }
      })

      
      if($( idSection).hasClass('show')){
          $( idSection).removeClass( "show" );
          if(isIOS()){
              document.getElementsByTagName('body')[0].classList.add('iosBody');
          }
      }
      else{
          if(isIOS()){
              document.getElementsByTagName('body')[0].classList.remove('iosBody');
          }
          $( idSection).addClass( "show" );
      }
  });
  //funzione back dopo apertuta menu mobile
  $(".nav_back--phone, .back-arrow-mobile-menu").click(backMenu);

  //enable click on span item in mobile menu
  $('.submenu__subheader--mobile').click(function() {
      if($(this).find("a").attr("href")){
          window.location = $(this).find("a").attr("href");
          return false;
       }
});
  var windowSize = window.innerWidth;
  
  refreshNavItemSettings(windowSize >= tabletWidth);

  $(".nav__link.desktop" ).focusin(
      showSubmenu
  );

  $( ".nav__section" ).hover(
      function(){
          idVoceMenu= "#"+ $(this).attr('id').replace("_Section","");
          $(idVoceMenu).css("text-decoration","underline");

      },
      function(){
          idVoceMenu= "#"+ $(this).attr('id').replace("_Section","");
          $(idVoceMenu).css("text-decoration","none");
          hideSubmenu();
      }
  );
  

  //accesibilità nav bar
  var navActive="";
  document.body.classList.add('using-mouse');
document.body.addEventListener('mousedown', function() {
      document.body.classList.add('using-mouse');
  });


  document.body.addEventListener('wheel', function() {
      document.body.classList.add('using-mouse');
  });


  document.body.addEventListener('keydown', function(e) {
      var keycode;
       if (e.key !== undefined) {
         keycode= e.key
       } else if (e.keyIdentifier !== undefined) {
          keycode=e.keyIdentifier;
      } else if (e.keyCode !== undefined) {

          keycode=e.keyCode;
      }
      console.log("key",keycode)
       if(keycode == "Tab" || keycode==9){
            document.body.classList.remove('using-mouse');

            if($(document.activeElement).hasClass("nav__link")) {
              var idSection = "#"+ $(document.activeElement).attr('id') + "_Section";//compongo id sottomenu
              var link = $(idSection).find(".submenu__item a")[0];
              navActive = document.activeElement;
              $($(idSection).find(".start-section")).focus();
            }
       }
  });

  var navActive = null;
  $(".end-section").focusin(function(){
      $($(this).closest(".nav__section")).removeClass("show"); //dopo aver visto ultimo elemento chiudi in sottomenu
      console.log("end-section")
      if(navActive) {
          var navNext = $($(navActive).closest(".nav__item")).next(); //vado al successivo nav item rispetto a quello con il focus all'inizio
          $($(navNext).find("a")).focus();
      }

  })
  // eyeglasses menu script
  $(document).ready(function(){if(storeDirectory=="PersolUS" || storeDirectory=="PersolUK"||storeDirectory=="PersolDE"){$("#li-prescription").show();}});
// sunglasses menu script
  $(document).ready(function(){if(storeDirectory=="PersolUS" || storeDirectory=="PersolUK"){$("#li-sun-prescription").show();}});


/* var map = {9: false, 16: false};
  $(document).keydown(function(e) {
      if (e.keyCode in map) {
          map[e.keyCode] = true;
          if (map[16] && map[9]) {
           if($(document.activeElement).hasClass("start-section")) {
               var Section = $($(document.activeElement).closest(".nav__section"));
               idLink= "#"+$(Section).attr('id').replace("_Section","");
               var index=$($(idLink).closest(".nav__item")).index()
               console.log(index)
              var navItem=$(".nav__items")[index+1];
              $($(navItem).find("a")).focus();
               // non funziona come dovrebbe

              }
             /*  if($(document.activeElement).hasClass("nav__link")) {
                  var navPrec = $($(document.activeElement).closest(".nav__item")).prev(); // prendo la voce di menu prec
                  $($(document.activeElement).closest(".nav__section")).removeClass("show"); // tolgo la classe show da quella in cui sto
                  var idPrec= $($(navPrec).find(".nav__link")).att("id"); //prendo l'id della precedente voce di menu
                  var idSectionPrec= "#"+ idPrec+ "_Section";//compongo l'id della section prec
                  $(idSectionPrec).addClass("show"); //mostro il sottomenu
                  $(idSectionPrec).find(".end-section").focus(); // metto il focus sull'end section

              }
          }
      }
  }).keyup(function(e) {
      if (e.keyCode in map) {
          map[e.keyCode] = false;
      }
  });*/
  windowSize = window.innerWidth;
  var windowSizePrevious = window.innerWidth;
  /* check promoCalloutCookie */
  checkPromoCookie();
  var ts;
  //stop hiding header on hover
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      //sposto i other colors per evitare la cash delle var IOS e ANDROID in jsp
      //$('.catalog-entry-recommendation-widget.other_colors').appendTo($('.bottom-section'));
      
      if ($('.ct-promo-bannerTop').is(':visible') && $('.ct-promo-bannerTop').text() !== '') {
        //$('.long-description-widget').css("padding-top", "72px");
        
      } else {
        //$('.catalog-entry-recommendation-widget.other_colors').css("bottom", "28%");
      }
      $('.catalog-entry-recommendation-widget.other_colors').css('display','flex');
      $('.presc--body').css('height', window.innerHeight - $('.presc--content header').outerHeight()-$('.presc--content__button').outerHeight()-$('.presc--content__message').outerHeight()-70+'px'); //40px
      $('.presc--content__fade').width($('.pdp .presc--content--options label').outerWidth());
      $(document).mousemove(function(e){
          var vertical = e.pageY;
          if($('#page').hasClass('pdp') && vertical <= 20
          && !$('#header').is(":visible")
          && $('.slot4').hasClass('fixed-bottom')
          && !$('.presc').hasClass('.showed-presc')
          && !$('.op-pdp-popup-other-colors').hasClass('active')
          && !$('.shopperActions--monogram--pop-up').is(':visible')) {
              if(!window.mobilecheck() || !window.tabletPortraitCheck()){//solo in desktop
                  if($('#page').find('.ct-promo-bannerTop').length) {
                      //$("#bannerTop").css("display","flex");
                      $('#bannerTop').slideDown();
                  }
              } else{
                  if($('#page').find('.ct-promo-bannerTop').length) {
                      //$("#bannerTop").css("display","flex");
                      $('#bannerTop').slideDown();
                  }
              }
            /*   $('#header').slideDown("", function(){
                   setHeightFullImage(true)
                 }); */
              $('.freeShipping').show()
          }
          if(vertical > 120 && $('#header').is(":visible") && !$(".header__nav-menu").hasClass("opend") && !$("#headerRow1--wrapper").siblings() && !$('.presc').hasClass('.showed-presc') && !$('.op-pdp-popup-other-colors').hasClass('active') && !('.shopperActions--monogram--pop-up').is(':visible')) {
              if($('#page').find('.ct-promo-bannerTop').length) {
                  $('#bannerTop').slideUp();
              }
            //   $('#header').slideUp();
              setHeightFullImage(false)
          }
      });
      $('.pdp #header').on('mouseenter', function(){
          hideHeaderTimeout.cancel();
      }).on( 'mouseleave', function(){
          if(!$('#Header_GlobalLogin_signInQuickLink').hasClass('active')){
              hideHeaderTimeout.setup();

          }
          if(!window.mobilecheck() || !window.tabletPortraitCheck()){//solo in desktop controlla
              if($('#page').find('.ct-promo-bannerTop').length) {
                  $("#bannerTop").css("display","flex");
              }}
      });
  } else {
      if($('#page').hasClass('pdp')){
          //event for touch mobile
          $(document).bind('touchstart', function (e){
              ts = e.originalEvent.touches[0].clientY;
          });

          $(document).bind('touchend', function (e){
              var te = e.originalEvent.changedTouches[0].clientY;
              if(ts < te-100 && !$("#vm_box").is(':visible')){
                  hideHeaderTimeout.showHeader();
              }
          });

          $(".othercolors-mobile").prepend($('.catalog-entry-recommendation-widget.other_colors'));
      }
  }
  if($('#page').hasClass('pdp')){
      //retrieveS7multiimage();
      if(!window.mobilecheck() && !window.tabletPortraitCheck()){
        animationInit();
      }

      if(window.mobilecheck() || window.tabletPortraitCheck()){
          $("#monogramText3").on("keydown", function(event){
              if (event.keyCode == 13) {
                      event.preventDefault();
                      event.target.blur()
                  }
          })
      }
  }

  $(document).click(function (e) {

      // Ignore this event if preventDefault has been called.
      if (e.defaultPrevented) return;

      var popup = $(".popUp");
      var cpopup = $('.popUpPersolTechnology');
      if (cpopup.length > 0) {
          if (!cpopup.is(e.target) && cpopup.has(e.target).length == 0) {
              $.each(popup, function (index, value) {
                  if ($(this).dialog('instance')) {
                      if ($(this).dialog('isOpen'))
                          $(this).dialog('close');
                  }
              });
          }
      }


  });

  $(window).resize(function () {
      windowSize = $(document).width();
      if ((windowSize > tabletWidth) && (windowSizePrevious <= tabletWidth)) {
        refreshNavItemSettings(true);
          // We have just passed from a phone resolution to a bigger one
          if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive > div').length > 0) {
              if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .wrapperClose > div').hasClass("close")) {
                  $('.navInfo #myAccountNavigationWidget #myAccountOptions .content').removeAttr('style');
                  $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').addClass("closed");
                  //$('#footerCorporateInfoSection h6').removeClass("close");
              }
          }

          if ($('#footerCorporateInfoSection h6').length > 0) {
              if ($('#footerCorporateInfoSection h6').hasClass("close")) {
                  $('#footerCorporateInfoSection ul').show();
                  $('#footerCorporateInfoSection h6').removeClass("close");
              }
          }

          if ($('#footer-sx h6').length > 0) {
              if ($('#footer-sx h6').hasClass("close")) {
                  $('#footer-sx ul').show();
                  $('#footer-sx h6').removeClass("close");
              }
          }

          if ($('.persolTech h2').length > 0) {
              if ($('.persolTech h2').hasClass("close")) {
                  $('.persolTech ul').show();
                  $('.persolTech h2').removeClass("close");
              }
          }

          if ($('.tSeries > h2').length > 0) {
              if ($('.tSeries > h2').hasClass("close")) {
                  $('.tSeries .wrapperSeries').show();
                  $('.tSeries > h2').removeClass("close");
              }
          }

          if ($('.tEvolution > h2').length > 0) {
              if ($('.tEvolution > h2').hasClass("close")) {
                  $('.tEvolution .wrapperEvolution').show();
                  $('.tEvolution > h2').removeClass("close");
              }
          }

          /*if ($('#contentWrapper.pageContent .slot5 > h2.product-details').length > 0) {
              if ($('#contentWrapper.pageContent .slot5 > h2.product-details').hasClass("close")) {
                  $('#contentWrapper.pageContent .slot5 ul').show();
                  $('#contentWrapper.pageContent .slot5 > h2.product-details').removeClass("close");
              }
          }*/

          if ($('#footerQuickLinksSection h6').length > 0) {
              if ($('#footerQuickLinksSection h6').hasClass("close")) {
                  $('#footerQuickLinksSection ul').show();
                  $('#footerQuickLinksSection h6').removeClass("close");
              }
          }
      } else if ((windowSize <= tabletWidth) && (windowSizePrevious > tabletWidth)) {
          // We have just passed from a bigger resolution of phone to a phone resolution
        refreshNavItemSettings(false);
          hideElements();
      }
      if(!(window.mobilecheck() || window.tabletPortraitCheck() && $('#page').hasClass('pdp'))){
          animationInit();
          /*Start EARLY ACCESS */
          if ($("#pdp_bottom-section .list-price").css("display") != "none" && $("#pdp_bottom-section .list-price").text() != ""){
              $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").css("right", "33%");
          } else $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").css("right", "30%");
      
          /*End EARLY ACCESS */
      }
      //  else if( window.mobilecheck() || window.tabletPortraitCheck()  && $('#page').hasClass('pdp')){
      //     didResize = true;
      //     var inHeight;
      //     if(window.innerHeight > window.startingHeight ){
      //         inHeight = window.marginScrollable + window.innerHeight - window.startingHeight ;
      //         var newHeight = window.slot2Height +  window.innerHeight - window.startingHeight ;
      //         $('.slot3').height(newHeight);
      //         $('.bottom-scrollable-section').css('margin-top', inHeight )
      //     } else {
      //         inHeight = window.slot2Height + window.startingHeight  - window.innerHeight ;
      //         $('.slot3').height(inHeight)
      //     }
      //     setInterval(function() {
      //         if (didResize) {
      //             didResize = false;
      //         }
      //     }, 300);
      // }
      // I assign the actual width resolution as the PREVIOUS because in the next check I would do I will compare it with the "resized width" (wich it will be the real actual size).
      windowSizePrevious = $(document).width();
  });

  $('.freeShipping').addClass("hidden");;

  if (!isEmpty($('#freeShippingGlobbal').html())) {
      $('.freeShipping').removeClass("hidden");
  }

  // Toggle of the PRODUCT DETAILS (Product Page) section only when the resolution is equals or less than 600px
  // $('#contentWrapper.pageContent .slot5 > h2.product-details').click(function() {
  //     if (window.innerWidth <= tabletWidth) {
  //         $('#contentWrapper.pageContent .slot5 > ul').slideToggle('400');
  //         if( $('#contentWrapper.pageContent .slot5 > h2.product-details').hasClass("close")) {
  //             $('#contentWrapper.pageContent .slot5 > h2.product-details').removeClass("close");
  //         } else {
  //             $('#contentWrapper.pageContent .slot5 > h2.product-details').addClass("close");
  //         }
  //     }
  // });c

  // Toggle of the PERSOL'S TECHNOLOGY (Product Page) section only when the resolution is equals or less than 600px
  $('.persolTech h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.persolTech .tTechnology').slideToggle('400');
          if ($('.persolTech h2').hasClass("close")) {
              $('.persolTech h2').removeClass("close");
          } else {
              $('.persolTech h2').addClass("close");
          }
      }
  });

  // Toggle of the PERSOL'S TECHNOLOGY (Product Page) section only when the resolution is equals or less than 600px
  $('.tSeries > h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.tSeries .wrapperSeries').slideToggle('400');
          if ($('.tSeries > h2').hasClass("close")) {
              $('.tSeries > h2').removeClass("close");
          } else {
              $('.tSeries > h2').addClass("close");
          }
      }
  });

  // Toggle of the SERIES EVOLUTION (Product Page) section only when the resolution is equals or less than 600px
  $('.tEvolution > h2').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.tEvolution .wrapperEvolution').slideToggle('400');
          if ($('.tEvolution > h2').hasClass("close")) {
              $('.tEvolution > h2').removeClass("close");
          } else {
              $('.tEvolution > h2').addClass("close");
          }
      }
  });

  // Toggle of the SPECIAL EDITIONS section only when the resolution is equals or less than 600px
  $('#footerCorporateInfoSection h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footerCorporateInfoSection ul').slideToggle('400');
          if ($('#footerCorporateInfoSection h6').hasClass("close")) {
              $('#footerCorporateInfoSection h6').removeClass("close");
          } else {
              $('#footerCorporateInfoSection h6').addClass("close");
          }
      }
  });

  // Toggle of the PERSOL section only when the resolution is equals or less than 600px
  $('#footer-sx h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footer-sx ul').slideToggle('400');
          if ($('#footer-sx h6').hasClass("close")) {
              $('#footer-sx h6').removeClass("close");
          } else {
              $('#footer-sx h6').addClass("close");
          }
      }
  });

  // Toggle of the QUICK LINKS section only when the resolution is equals or less than 600px
  $('#footerQuickLinksSection h6').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('#footerQuickLinksSection ul').slideToggle('400');
          if ($('#footerQuickLinksSection h6').hasClass("close")) {
              $('#footerQuickLinksSection h6').removeClass("close");
          } else {
              $('#footerQuickLinksSection h6').addClass("close");
          }
      }
  });

  $("#openSeoLinks").click(function(e){
    e.preventDefault();
      $(".footer-allsites").removeClass('footer-allsites-hide');
      $('html, body').animate({scrollTop:$(document).height()}, 'slow');
  });

  $("#allSitesCloseLink").click(function(e){
    e.preventDefault();
      $(".footer-allsites").addClass('footer-allsites-hide');
  });

  $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive').click(function () {
      if (window.innerWidth <= tabletWidth) {
          $('.navInfo #myAccountNavigationWidget #myAccountOptions .content').slideToggle('400');
          if ($('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').hasClass("close")) {
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').removeClass("close");
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').removeClass("closed");
              if ((window.mobilecheck() || window.tabletPortraitCheck())){
                $('.navInfo ~ .navInfo-fade').show();
              }
          } else {
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose > div').addClass("close");
              $('.navInfo #myAccountNavigationWidget #myAccountOptions .headerResponsive .wrapperClose').addClass("closed");
              if ((window.mobilecheck() || window.tabletPortraitCheck())){
                $('.navInfo ~ .navInfo-fade').hide();
              }
          }
      }
  });

  $("#page.personal-information-page .gdpr__input-block .wrapper label").html("");

  if ($("#contentWrapper").hasClass("myAccountSummary")){
    checkEditFormInputs();
  }

  // When the page is ready, we will check if its resolution is lesser than 601 to hide the toggled elements
  if (windowSize < tabletWidth + 1)
      hideElements();

  // Display the header's "dropdown" menu
  if ($(window).width() > tabletWidth) {
      $('#departmentsMenu > li').hover(function () {
          if ($(" > section", this).length > 0) {
              $(" > section", this).stop(true, false, true).slideToggle(200);
              $(this).addClass('hover');
          }
      }, function () {
          $(" > section", this).stop(true, false, true).slideToggle(200);
          $(this).removeClass('hover');
          // $(" > section", this).stop(true, false, true).slideToggle(200);
      });
  }

  // $('#searchIcon').click(function() {
  //     if ($('#searchBar').length > 0) {
  //         $('#searchBar').slideToggle('400');
  //     }
  // });

  /* BEGIN - Responsive Header */
  /* Show/hide lateral menu */
  $('#hamResponsive .menuExpand').click(function () {
    if (window.innerWidth <= tabletWidth) {
          if ($(this).hasClass('open')) {
              /* Responsive menu is opened */
              $(this).removeClass('open');
              $('#page .siteContainer').removeClass('opened');
              $('#page').removeClass('opened');
          } else {
              /* Responsive menu is closed */
              $(this).addClass('open');
              $('#page .siteContainer').addClass('opened');
              $('#page').addClass('opened');
          }
      }
  });

  /* Add 'open' class to the item we click */
  $('#departmentsMenu .dropdownMenu > a, #departmentsMenu li.dropdownMenu > span').click(function (event) {
      if (window.innerWidth <= tabletWidth) {
          var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          if (iOS) {
              console.log("iOS -> %o", iOS);
              $(this).one(function () {
                  console.log("iOS.one()");
                  $(this).click();
                  console.log("iOS.click()");
              });
          }
          event.preventDefault();
          if ($(this).parent().hasClass('open')) {
              $(this).parent().removeClass('open');
          } else {
              $('#departmentsMenu .dropdownMenu').removeClass('open');
              $(this).parent().addClass('open');
          }
      }
  });
  /* END - Responsive Header */

  /* BEGIN - POP UP PERSOL TECHNOLOGY */
  /* Open the pop up with properties */
  $('.persolTech .tTechnology li .openPopUp').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if ($(this).parents('li').length > 0) {
          if ($(this).parents('li').find('.popUp').length > 0) {
              // I will create the dialog
              $(this).parents('li').find('.popUp').dialog({
                  modal: true,
                  classes: {
                      "ui-dialog": "popUpPersolTechnology popUp-" + $(this).parents('li>div').attr('id')
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: 'auto',
                  maxWidth: tabletWidth,
                  fluid: true, //new option
                  resizable: false,
                  close: function () {
                      // Stop the video when we close the pop up.
                      $(this).parent().find('video').get(0).pause();
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                  }
              });
          } else {
              // I have already created the dialog, so I have just to open it
              var popUpName = '.popUp-' + $(this).parent().attr('id') + ' .popUp';
              $(popUpName).dialog('open');
          }
          // Launch the function for the new fluid option
          fluidDialog();
      }
  });

  // On window resize run function
  $(window).resize(function () {
      fluidDialog();
  });
  

  function fluidDialog() {
      var $visible = $(".ui-dialog:visible");
      $visible.each(function () {
          var $this = $(this);
          var dialog = $this.find(".ui-dialog-content").data("ui-dialog");
          // If the new fluid option is able
          if (typeof dialog !== 'undefined'
          && typeof dialog.options !== 'undefined'
          && typeof dialog.options.fluid !== 'undefined') {

              var wWidth = $(window).width();
              // Check window width against dialog width
              if (wWidth < (parseInt(dialog.options.maxWidth) + 80)) {
                  // Keep dialog from filling entire screen
                  $this.css("max-width", "90%");
              } else {
                  // Fix maxWidth bug
                  $this.css("max-width", dialog.options.maxWidth + "px");
              }
              // Reposition dialog
              dialog.option("position", dialog.options.position);
          }
      });
  }

  // Play or pause the video on clicking the image above.
  $('.popUp .video .playPause').click(function () {
      if ($(this).parent().find('video').length > 0) {
          var vid = $(this).parent().find('video').get(0);
          if ($(this).hasClass('playing')) {
              $(this).removeClass('playing');
              vid.pause();
          } else {
              $(this).addClass('playing');
              vid.play();
          }
      }
  });

  $(document).click(function (e) {
      var popup = $(".popUp");
      var cpopup = $('.popUpPersolTechnology');
      if (cpopup.length > 0) {
          if (!cpopup.is(e.target) && cpopup.has(e.target).length == 0) {
              $.each(popup, function (index, value) {
                  if ($(this).dialog('instance')) {
                      if ($(this).dialog('isOpen'))
                          $(this).dialog('close');
                  }
              });
          }
      }
  });


  $('.product_page_content .polarizedPersol').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if ($('#lenses').parent().find('.popUp').length > 0) {
          // I will create the dialog
          $('#lenses').parent().find('.popUp').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "popUpPersolTechnology popUp-lenses"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: tabletWidth,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  // Stop the video when we close the pop up.
                  $(this).parent().find('video').get(0).pause();
                  $('.ui-widget-overlay').removeClass('custom-overlay');
                  $('body').removeAttr('style');
              },
              open: function () {
                  $('.ui-widget-overlay').addClass('custom-overlay');
                  $('body').css('position', 'relative');
              }
          });
      } else {
          // I have already created the dialog, so I have just to open it
          var popUpName = '.popUp-lenses .popUp';
          $(popUpName).dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - POP UP PERSOL TECHNOLOGY */

  /* BEGIN - POP-UP ZOOM & 360 */
  $('.viewBy > span').click(function (event) {
      if ($('#pdp-360-popup').length > 0) {
          var tabOpen = event.currentTarget.className == 'viewBy--p360' ? 1 : 0;
          $('#pdp-360-popup').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "popUp-zoom360"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: 800,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  $('.ui-widget-overlay').removeClass('custom-overlay');
                  $('body').removeAttr('style');
              },
              open: function() {
                  $(this).parent().attr('tabindex','0');

                  var displayedImage = null;

                  if ($('#productMainImage').length) {
                      displayedImage = $('#productMainImage');
                  } else if ($('#sliderProductMainPage0').length) {
                      displayedImage = $('#sliderProductMainPage0');
                  }

                  var pathImg = "";
                  if (displayedImage != null) {
                      console.log("PSL::store-persol.js::Displayed image URL = " + displayedImage.attr('src'));
                      var displayedImageSource = displayedImage.attr('src');
                      if (displayedImageSource.includes("_noshad")) {
                          pathImg = displayedImageSource.split("_noshad")[0];
                      } else if (displayedImageSource.includes("_shad")) {
                          pathImg = displayedImageSource.split("_shad")[0];
                      } else {
                          pathImg = displayedImageSource.split("_")[0];
                      }
                  }
                  console.log("PSL::store-persol.js::Final base image URL = " + pathImg);

                  var imgZoom = pathImg + '_noshad_qt?scl=1';

                  $('.nextCircle').css("display", "none");

                  $('#pdp-360-popup--container').tabs({
                      active: tabOpen
                  });

                  $('#pdp-360-popup--container--zoom--img > img').attr('src', displayedImage.attr('src'));

                  $('#pdp-360-popup--container--zoom--img').zoom({
                      url: imgZoom,
                      on: 'grab'
                  });

                  $("#pdp-360-popup--container--360").spritespin({
                      source: [
                          pathImg + '_noshad_fr?$594$',
                          pathImg + '_noshad_qt?$594$',
                          pathImg + '_060A?$594$',
                          pathImg + '_090A?$594$',
                          pathImg + '_120A?$594$',
                          pathImg + '_150A?$594$',
                          pathImg + '_180A?$594$',
                          pathImg + '_210A?$594$',
                          pathImg + '_240A?$594$',
                          pathImg + '_270A?$594$',
                          pathImg + '_300A?$594$',
                          pathImg + '_330A?$594$'
                      ],
                      width: 595,  // width in pixels of the window/frame
                      height: 385,  // height in pixels of the window/frame
                      animate: false,
                      responsive: true,
                  });

                  $('.ui-widget-overlay').addClass('custom-overlay');
                  $('body').css('position','relative');
                  $(this).parent().find(".ui-button").attr('tabindex','0');
              }
          });
      } else {
          var popUpName = '.popUp-zoom360';
          $(popUpName).dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - POP-UP ZOOM & 360 */

  /* BEGIN - SHOPPING INFO & RETURN POPUP */
  $('#ci_espot__footerCheckout_Left .left_espot #shopping').click(function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').length > 0) {
          // I will create the dialog
          $('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').dialog({
              modal: true,
              classes: {
                  "ui-dialog": "shopping-popup"
              },
              draggable: false,
              closeText: "",
              height: 'auto',
              width: 'auto',
              maxWidth: tabletWidth,
              fluid: true, //new option
              resizable: false,
              close: function () {
                  $('.ui-widget-overlay').removeClass('custom-overlay').removeClass("shopping_overlay");
                  $('body').removeAttr('style');
              },
              open: function () {
                  $('.ui-widget-overlay').addClass('custom-overlay').addClass("shopping_overlay");
                  $('body').css('position', 'relative');
              }
          });
      } else {
          // I have already created the dialog, so I have just to open it
          $('#ci_espot__footerCheckout_Left .left_espot #shopping-popup').dialog('open');
      }
      // Launch the function for the new fluid option
      fluidDialog();
  });
  /* END - SHOPPING INFO & RETURN POPUP */
  /* START - catalogEntryDetails for Content Team */
  if ($("#page.pdp").length > 0) {
    catalogEntryDetails = JSON.parse($('#catalogEntryDetails_temp').text());
  }
  /* END - catalogEntryDetails for Content Team */


  /*HB-4558
   * prevent the background page to scroll
   */
        document.ontouchmove = function ( event ) {

            var isTouchMoveAllowed = true, target = event.target;

            while ( target !== null ) {
              if ( target.classList && target.classList.contains('submenu' ) ) {
                isTouchMoveAllowed = false;
                break;
              }
              target = target.parentNode;
            }

            if ( !isTouchMoveAllowed ) {
              event.preventDefault();
            }

       };

  //$('#attrValue_Size-menu .ui-menu-item').click(function(event) {
  $('#attrValue_Size-menu li').click(function (event) {
      // console.log("YEAH CLICK");
      if ($(this).attr('value') == 'dontClick') {
          //console.log("YEAH CLICK INSIDE");
      }
  });

  //console.log("YEAH 2");
  $('ul#attrValue_Size-menu').click(function (event) {
      //        console.log("YEAH CLICK 2 -> %o",$(this));
      //        console.log("YEAH CLICK 3 -> %o",$(this).find('li'));
      if ($(this).find('li').attr('value') == 'dontClick') {
          //console.log("YEAH CLICK INSIDE 2");
      }
  });


  /* Show default payment placement */
  var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
   showDefaultPaymentPlacement(defaultPaymentPlacement);


});


function backMenu(div){
    var idSection = $(this).closest("section");
    if(idSection.length == 0){
        idSection = $(div).closest("section")
    }
      $( idSection).hasClass('show') ?  $( idSection).removeClass( "show" ) :  $( idSection).addClass( "show" );
      $('.header__block-search').removeClass( "hidden" );
      if(isIOS()){
          document.getElementsByTagName('body')[0].classList.add('iosBody');
      }
}


// This function is for hide the toggle elements when we go through a tablet resolution (> 600 & < 1281) to a phone resolution (< 600)
function hideElements() {
  /*if ($('#contentWrapper.pageContent .slot5 > h2.product-details').length > 0) {
      $('#contentWrapper.pageContent .slot5 > h2.product-details').addClass("close");
      $('#contentWrapper.pageContent .slot5 ul').hide();
  }*/

  if ($('#footerCorporateInfoSection h6').length > 0) {
      $('#footerCorporateInfoSection h6').addClass("close");
      $('#footerCorporateInfoSection ul').hide();
  }

  if ($('#footer-sx h6').length > 0) {
      $('#footer-sx h6').addClass("close");
      $('#footer-sx ul').hide();
  }

  if ($('.persolTech h2').length > 0) {
      $('.persolTech h2').addClass("close");
      $('.persolTech ul').hide();
  }

  if ($('.tSeries > h2').length > 0) {
      $('.tSeries > h2').addClass("close");
      $('.tSeries .wrapperSeries').hide();
  }

  if ($('.tEvolution > h2').length > 0) {
      $('.tEvolution > h2').addClass("close");
      $('.tEvolution .wrapperEvolution').hide();
  }

  if ($('#footerQuickLinksSection h6').length > 0) {
      $('#footerQuickLinksSection h6').addClass("close");
      $('#footerQuickLinksSection ul').hide();
  }
}


// STATIC PAGES SCRIPTS  ///////////////////////////////////////////////////////////////////////////////////////////////

/**
* Convert URL's from received html to absolute
*/
function convertDataToAbsolute(data) {
  //Here we receive specific data of selected page
  //Now we add absolute address value 'http://www.persol.com/'
  var data_absolute = data;

  //replaces all occurrences of searchValue in data
  function replaceValues(data, searchValue, replacementValue) {
      var myString = data;
      while (myString.indexOf(searchValue) > 0) {
          myString = myString.replace(searchValue, replacementValue);
      }
      return myString;
  }

  //remove all occurrences of "this.href + "
  data_absolute = replaceValues(data_absolute, "this.href + ", "");
  data_absolute = replaceValues(data_absolute, "img src=\"/_events", "img src=\"http://www.persol.com/_events");
  data_absolute = replaceValues(data_absolute, "\"/international", "\"http://www.persol.com/international");
  data_absolute = replaceValues(data_absolute, "img src=\"/Content", "img src=\"http://www.persol.com/Content");
  data_absolute = replaceValues(data_absolute, "\"/Scripts", "\"http://www.persol.com/Scripts");
  data_absolute = replaceValues(data_absolute, ";/_events", ";http://www.persol.com/_events");
  data_absolute = replaceValues(data_absolute, "<script type=\"text/javascript\" src=\"http://www.persol.com/Scripts/custom/cufon.js\"></script>", "");
  // <script type="text/javascript" src="http://www.persol.com/Scripts/custom/cufon.js"></script>

  return data_absolute;
}

// // Vintage Celebration Page scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#vintageCelebrationPage").ready(function () {
//     $("#vintageCelebrationPage .scrollVintage").click(function (event) {
//         //console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $("#vintageCelebrationPage #skipVideo").click(function () {
//         event.preventDefault();
//         $("#vintageCelebrationPage #skipVideo").fadeOut("slow");
//         $("#vintageCelebrationPage #video").fadeOut("slow");
//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.unload().then(function () {
//             // the video was unloaded
//         }).catch(function (error) {
//             // an error occurred
//         });
//     });

//     $("#vintageCelebrationPage #but_video").click(function () {
//         event.preventDefault();
//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         $("#vintageCelebrationPage #video").fadeIn("slow");
//         $("#vintageCelebrationPage #skipVideo").fadeIn("slow");
//     });

//     /* Cambio de m�todo a carga sin ajax */
//     var flipSpeed = 500;
//     var box1opened = false;
//     var box3opened = false;

//     function box1Flip() {
//         if (box3opened) {
//             box3Back();
//         }
//         $('#vintageCelebrationPage #vintage_years_box1 .one').animate({
//             marginLeft: "-960px" //moves left
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box1 .two').animate({
//             marginLeft: "0px" //moves left
//         }, flipSpeed, "easeInOutCubic");
//         box1opened = true;
//     }

//     function box1Back() {
//         $('#vintageCelebrationPage #vintage_years_box1 .one').animate({
//             marginLeft: "0px" //moves right
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box1 .two').animate({
//             marginLeft: "960px" //moves right
//         }, flipSpeed, "easeInOutCubic");
//         box1opened = false;
//     }

//     $('#vintageCelebrationPage #vintage_years_box1 .backTo').click(function () { box1Back(); });

//     function box3Flip() {
//         if (box1opened) {
//             box1Back();
//         }
//         $('#vintageCelebrationPage #vintage_years_box3 .one').animate({
//             marginLeft: "-960px" //moves left
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box3 .two').animate({
//             marginLeft: "0px" //moves left
//         }, flipSpeed, "easeInOutCubic");
//         box3opened = true;
//     }

//     function box3Back() {
//         $('#vintageCelebrationPage #vintage_years_box3 .one').animate({
//             marginLeft: "0px" //moves right
//         }, flipSpeed, "easeInOutCubic");

//         $('#vintageCelebrationPage #vintage_years_box3 .two').animate({
//             marginLeft: "960px" //moves right
//         }, flipSpeed, "easeInOutCubic");
//         box3opened = false;
//     }

//     $('#vintageCelebrationPage #vintage_years_box3 .backTo').click(function () { box3Back(); });


//     $("#vintageCelebrationPage #btn-tabacco-virginia").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_tabacco-virginia").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-miele").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_miele").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-madreterra").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_madreterra").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-terra-di-siena").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_terra-di-siena").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-caffe").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box1 .model_content").html($("#vintageCelebrationPage .ajax_caffe").html()).promise().done(function () { box1Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-fuoco-e-ardesia").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_fuoco-e-ardesia").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-resina-e-sale").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_resina-e-sale").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-ebano-e-oro").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_ebano-e-oro").html()).promise().done(function () { box3Flip(); });
//     });
//     $("#vintageCelebrationPage #btn-terra-e-oceano").click(function () {
//         $("#vintageCelebrationPage #vintage_years_box3 .model_content").html($("#vintageCelebrationPage .ajax_terra-e-oceano").html()).promise().done(function () { box3Flip(); });
//     });

//     //Vintage Celebration Mobile Page scripts  ///////////////////////////////////////////////////////////////////////////////////////////////

//     var vintageDelay = 500;

//     $("#vintageCelebrationPage .scrollTo").click(function () {
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $("#vintageCelebrationPage .videoCover").click(function () {
//         event.preventDefault();
//         var iframe = document.querySelector('#player_2');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         $("#vintageCelebrationPage .mobile .videoCover").fadeOut("slow");
//         $("#vintageCelebrationPage .mobile #player_2").fadeIn("slow");
//     });

//     function closeHavanasSelector() {
//         $('#vintageCelebrationPage #select-btn-havanas').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "auto");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.havanas .shade').animate({
//             opacity: 0,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "none");
//         });
//     }
//     function closeHavanasSectionModels() {
//         $('#vintageCelebrationPage .section-models.havanas').animate({
//             opacity: 0,
//             height: "0px"
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.havanas').addClass("hidden");
//         });
//     }

//     $("#vintageCelebrationPage #select-btn-havanas").click(function () {
//         $('#vintageCelebrationPage #select-btn-havanas').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "none");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.havanas .shade').animate({
//             opacity: 1,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.havanas .selector').css("pointer-events", "auto");
//         });
//     });

//     $("#vintageCelebrationPage .section-combo.havanas .selector .close-btn").click(function () {
//         closeHavanasSelector();
//     });

//     $("#vintageCelebrationPage .section-models.havanas .close-btn").click(function () {
//         closeHavanasSectionModels();
//     });

//     $("#vintageCelebrationPage .section-combo.havanas .selector .link").click(function () {
//         closeHavanasSelector();
//         // console.log("Modelo: "+$(this).attr("model"));
//         var myModel = $(this).attr("model");
//         var myHeight;

//         $("#vintageCelebrationPage .section-models.havanas").removeClass("hidden");
//         $("#vintageCelebrationPage .section-models.havanas .model-container").addClass("hidden");

//         $("#vintageCelebrationPage .section-models.havanas .model-container").each(function () {
//             if ($(this).attr("model") === myModel) {
//                 $(this).removeClass("hidden");
//                 myHeight = $(this).children(".text-container").css("height");
//             }
//         });

//         $('#vintageCelebrationPage .section-models.havanas').animate({
//             opacity: 1,
//             height: myHeight
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.havanas').removeClass("hidden");
//             $('#vintageCelebrationPage .section-models.havanas').css("height", "100%");
//         });
//     });

//     function closeContemporarySelector() {
//         $('#vintageCelebrationPage #select-btn-contemporary').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "auto");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .shade').animate({
//             opacity: 0,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "none");
//         });
//     }
//     function closeContemporarySectionModels() {
//         $('#vintageCelebrationPage .section-models.contemporary').animate({
//             opacity: 0,
//             height: "0px"
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.contemporary').addClass("hidden");
//         });
//     }

//     $("#vintageCelebrationPage #select-btn-contemporary").click(function () {
//         $('#vintageCelebrationPage #select-btn-contemporary').animate({
//             opacity: 0,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "none");
//         });

//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .shade').animate({
//             opacity: 1,
//         }, vintageDelay, function () { });
//         $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').animate({
//             opacity: 1,
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .mobile .section-combo.contemporary .selector').css("pointer-events", "auto");
//         });
//     });

//     $("#vintageCelebrationPage .section-combo.contemporary .selector .close-btn").click(function () {
//         closeContemporarySelector();
//     });

//     $("#vintageCelebrationPage .section-models.contemporary .close-btn").click(function () {
//         closeContemporarySectionModels();
//     });

//     $("#vintageCelebrationPage .section-combo.contemporary .selector .link").click(function () {
//         closeContemporarySelector();
//         // console.log("Modelo: "+$(this).attr("model"));
//         var myModel = $(this).attr("model");
//         var myHeight;

//         $("#vintageCelebrationPage .section-models.contemporary").removeClass("hidden");
//         $("#vintageCelebrationPage .section-models.contemporary .model-container").addClass("hidden");

//         $("#vintageCelebrationPage .section-models.contemporary .model-container").each(function () {
//             if ($(this).attr("model") === myModel) {
//                 $(this).removeClass("hidden");
//                 myHeight = $(this).children(".text-container").css("height");
//             }
//         });

//         $('#vintageCelebrationPage .section-models.contemporary').animate({
//             opacity: 1,
//             height: myHeight
//         }, vintageDelay, function () {
//             $('#vintageCelebrationPage .section-models.contemporary').removeClass("hidden");
//             $('#vintageCelebrationPage .section-models.contemporary').css("height", "100%");
//         });
//     });


//     //control video autoplay
//     var iframe_desktop = document.querySelector('#player_1');
//     var player_desktop = null;

//     if (iframe_desktop != null) {
//         player_desktop = new Vimeo.Player(iframe_desktop);
//     }

//     var iframe_mobile = document.querySelector('#player_2');
//     var player_mobile = null;

//     if (iframe_mobile != null) {
//         player_mobile = new Vimeo.Player(iframe_mobile);
//     }

//     //check window width
//     //    console.log("window width: "+$(window).width());
//     if ($(window).width() > 930 && player_desktop != null && player_mobile != null) {
//         player_desktop.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//         player_mobile.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//     } else if (player_desktop != null && player_mobile != null) {
//         player_desktop.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//         player_mobile.unload().catch(function (error) {
//             console.error('error stoping the video:', error.name);
//         });
//     }
// });

// // Calligrapher page ///////////////////////////////////////////////////////////////////////////////////////////////
// $("calligrapherEditionPage").ready(function () {
//     $(".scrollCalligrapher").click(function (event) {
//         // console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

//     $(".mainVideo").click(function (event) {
//         event.preventDefault();
//         $(".mainVideo .playVideo").hide();
//         $(".mainVideo #play-button-video1").hide();

//         var iframe = document.querySelector('#player_1');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//     });

//     $(".interviewVideo").click(function (event) {
//         event.preventDefault();
//         $(".interviewVideo .playVideo2").hide();
//         $(".interviewVideo #play-button-video2").hide();

//         var iframe = document.querySelector('#player_2');
//         var player = new Vimeo.Player(iframe);

//         player.play().catch(function (error) {
//             console.error('error playing the video:', error.name);
//         });
//     });
// });

// // Galleria900 scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $(document).ready(function () {

//     var owl = $('#galleria900Page .owl-carousel');
//     var currentFrame = 0;
//     var movedWithSlide = true;

//     owl.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         singleItem: true,
//         addClassActive: true,
//         afterMove: function () {
//             currentFrame = $(".owl-item.active .item").attr("data-slide-index");
//             updatePager();
//         }
//     });

//     function updatePager() {
//         $(".pager .item a").each(function () {
//             var itemIndex = $(this).attr("data-slide-index");
//             if (itemIndex == currentFrame) {
//                 $(this).children(".photo").removeClass("hidden");
//                 $(this).children(".point").removeClass("hidden");
//             } else {
//                 $(this).children(".photo").addClass("hidden");
//                 $(this).children(".point").addClass("hidden");
//             }
//         });
//     }

//     // Go to the next item
//     $('#galleria900Page #carousel-button-prev').click(function () {
//         owl.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#galleria900Page #carousel-button-next').click(function () {
//         owl.trigger('owl.next');
//     });

//     $(".pager .item a").click(function () {
//         currentFrame = $(this).attr("data-slide-index");
//         owl.trigger("owl.goTo", currentFrame);
//         updatePager();
//     });

// });

// //Icons Collection Page Scripts  ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsPage").ready(function () {
//     $('#iconsPage .but').bind("mouseenter", function () {

//         var i = $(this);

//         $('.but').removeClass('fullopt').addClass('halfopt');
//         $('.boxtitle').css('visibility', 'hidden');
//         $('.boxlink').css('visibility', 'hidden');
//         i.removeClass('halfopt').addClass('fullopt');
//         i.prev().css('visibility', 'visible');
//         i.next().css('visibility', 'visible');

//         var bgmodel = $(this).find('img').attr('alt');
//         var bg = 'bg_' + bgmodel;
//         $('#deficons_header').hide().removeClass().addClass(bg).show();
//     });
// });

// // Typewriter Subpages Scripts //////////////////////////////////////////////////////////////////////////////////////////
// $("#typewriterEditionPage").ready(function () {
//     var owl = $('#typewriterEditionPage .owl-carousel');

//     owl.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         addClassActive: true,
//         singleItem: true
//     });

//     // Go to the next item
//     $('#typewriterEditionPage #slide_prev').click(function () {
//         owl.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#typewriterEditionPage #slide_next').click(function () {
//         owl.trigger('owl.next');
//     });

//     // Pager
//     $('#typewriterEditionPage .custom-pager .point').click(function () {
//         var currentFrame = $(this).attr("item-pos");
//         owl.trigger("owl.goTo", currentFrame);
//     });

// });

// // Reflex Edition Scripts //////////////////////////////////////////////////////////////////////////////////////////
// $("#reflexEditionPage").ready(function () {

//     var reflexDelay = 500;
//     var currentOption = 0;

//     $('#reflexEditionPage .up').click(function () {
//         var aTag = $("a[name='gale']");
//         $('html,body').animate({
//             scrollTop: aTag.offset().top
//         }, 'slow');
//     });

//     $("#reflexEditionPage a").mouseover(function () {
//         $("li img").removeAttr("title");
//     });

//     $('#reflexEditionPage .bxslider').bxSlider({
//         captions: true,
//         minSlides: 1,
//         maxSlides: 4,
//         slideWidth: 230,
//         slideMargin: 5,
//         auto: true,
//         infiniteLoop: false,
//         pager: false
//     });

//     function setActiveModel(model) {
//         //mark selected button
//         $("#reflexEditionPage .buttons-container div").removeClass("selected");
//         $("#reflexEditionPage .buttons-container div").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).addClass("selected");
//             }
//         });

//         //show image of selected model
//         $("#reflexEditionPage .moveimg img").addClass("hidden");
//         $("#reflexEditionPage .moveimg img").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).removeClass("hidden");
//             }
//         });

//         //show link of selected model
//         $("#reflexEditionPage .reflex-colori-link").addClass("hidden");
//         $("#reflexEditionPage .reflex-colori-link").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == model) {
//                 $(this).removeClass("hidden");
//             }
//         });
//     }

//     $('#reflexEditionPage .sunBut').click(function () {
//         if (currentOption != 1) {
//             if ($(this).hasClass('stopMenu')) { } else {
//                 closeProduct();
//                 setTimeout(function () {
//                     $("#reflexEditionPage .reflex-glass-details.sun").show();
//                     $("#reflexEditionPage .reflex-glass-details.optical").hide();
//                     setActiveModel("PO3046S");
//                     openProduct("");
//                 }, reflexDelay);

//                 $(this).addClass('stopMenu').next().removeClass('stopMenu');
//                 $(this).addClass('activeMenu').next().removeClass('activeMenu');
//             }
//             setTimeout(function () {
//                 $('#reflexEditionPage #bullets-mobile').removeClass("hidden");
//                 $('#reflexEditionPage #bullets-mobile').css("opacity", "1");
//                 $('#reflexEditionPage #bullets-mobile').css("height", "auto");
//             }, reflexDelay * 2);
//             currentOption = 1;
//         }
//     });

//     $('#reflexEditionPage .optiBut').click(function () {
//         if (currentOption != 2) {
//             if ($(this).hasClass('stopMenu')) { } else {
//                 //select first item
//                 closeProduct();
//                 setTimeout(function () {
//                     $("#reflexEditionPage .reflex-glass-details.sun").hide();
//                     $("#reflexEditionPage .reflex-glass-details.optical").show();
//                     setActiveModel("PO3046V");
//                     openProduct();
//                 }, reflexDelay);

//                 $(this).addClass('stopMenu').prev().removeClass('stopMenu');
//                 $(this).addClass('activeMenu').prev().removeClass('activeMenu');
//             }

//             setTimeout(function () {
//                 $('#reflexEditionPage #bullets-mobile').removeClass("hidden");
//                 $('#reflexEditionPage #bullets-mobile').css("opacity", "1");
//                 $('#reflexEditionPage #bullets-mobile').css("height", "auto");
//             }, reflexDelay * 2);
//             currentOption = 2;
//         }
//     });

//     $('#reflexEditionPage .modelContainer .buttons-container div').click(function () {
//         //mark selected button
//         $("#reflexEditionPage .modelContainer .buttons-container div").removeClass("selected");
//         $(this).addClass("selected");

//         //show selected model
//         var modelNum = $(this).attr("data-name");

//         $("#reflexEditionPage .moveimg img").addClass("hidden");
//         //show image of selected model
//         $("#reflexEditionPage .moveimg img").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == modelNum) {
//                 $(this).removeClass("hidden");
//             }
//         });

//         //show link of selected model
//         $("#reflexEditionPage .reflex-colori-link").addClass("hidden");
//         $("#reflexEditionPage .reflex-colori-link").each(function () {
//             var dn = $(this).attr("data-name");
//             if (dn == modelNum) {
//                 $(this).removeClass("hidden");
//             }
//         });
//     });

//     $(window).resize(function () {
//         if (currentOption > 0) {
//             var altura = $(".reflex-glass-details").height();
//             $("#reflex-glass-details-container").height(altura);
//         }
//     });

//     function openProduct() {
//         var altura = $(".reflex-glass-details").height();
//         //console.log("Altura: "+altura)
//         $('#reflex-glass-details-container').animate({
//             opacity: 1,
//             height: "" + altura + "px"
//         }, reflexDelay, function () { });

//         //        $('#reflex-glass-details').animate({
//         //            opacity: 1,
//         //            height: ""+altura+"px"
//         //        }, reflexDelay, function() {});
//     }

//     function closeProduct() {
//         $('#reflexEditionPage .optiBut').removeClass('stopMenu');
//         $('#reflexEditionPage .sunBut').removeClass('stopMenu');

//         $('.reflex-box-txt').removeClass('activeMenu');
//         $('#reflex-glass-details-container').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () { });

//         $("#reflex-glass-details").html("");
//     }

//     $('#reflexEditionPage #closebtn').click(function () {
//         $('#reflexEditionPage .optiBut').removeClass('stopMenu');
//         $('#reflexEditionPage .sunBut').removeClass('stopMenu');

//         $('.reflex-box-txt').removeClass('activeMenu');
//         $('#reflex-glass-details-container').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () { });

//         $("#reflex-glass-details").html("");

//         $('#reflexEditionPage #bullets-mobile').animate({
//             opacity: 0,
//             height: "0px"
//         }, reflexDelay, function () {
//             $('#reflexEditionPage #bullets-mobile').addClass("hidden");
//         });

//         currentOption = 0;
//     });

//     $("#reflexEditionPage #bullet_1").hover(function () {
//         $("#reflexEditionPage #tip_01").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_01").addClass("hidden");
//     });

//     $("#reflexEditionPage #bullet_2").hover(function () {
//         $("#reflexEditionPage #tip_02").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_02").addClass("hidden");
//     });

//     $("#reflexEditionPage #bullet_3").hover(function () {
//         $("#reflexEditionPage #tip_03").removeClass("hidden");
//     }, function () {
//         $("#reflexEditionPage #tip_03").addClass("hidden");
//     });

//     /* Gallery */
//     $('#reflexEditionPage .showgallery').click(function () {
//         if ($('#reflex-gallery-container').css('display') == 'none') {
//             $('#slideshow_reflex, #reflex-actions-on-gallery').css('display', 'none');
//             $('#reflex-gallery-container').css('display', 'block');
//             var aTag = $("a[name='gale']");
//             //          $('html,body').animate({
//             //              scrollTop: aTag.offset().top
//             //          }, 'slow');
//         }

//         $.ajax({
//             url: "http://www.persol.com/international/reflex-edition/gallery",
//             type: "POST",
//             success: function (data) {
//                 //Debug code BEGIN
//                 var a = convertDataToAbsolute(data);
//                 // console.log(a);
//                 //Debug code END
//                 $("#galleryContent").html(convertDataToAbsolute(data));
//             }
//         });
//     });

//     $('#reflexEditionPage .hidegallery').click(function () {
//         if ($('#reflex-gallery-container').css('display') == 'block') {
//             $('#reflex-gallery-container').css('display', 'none');
//             $('#slideshow_reflex, #reflex-actions-on-gallery').css('display', 'block');
//             $("#galleryContent").html('');
//             $('#dvnlcontDetail').remove();
//         }
//     });


// });

// // History Page Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// var slider = null;
// $("#historyPage").ready(function () {

//     /*Slideshow*/
//     slider = $('#historyPage .bxslider').bxSlider({
//         mode: 'fade',
//         captions: true,
//         auto: true,
//         //tickerHover: true,
//         pause: 10000,
//         pagerCustom: '#bx-pager',
//         onSlideNext: function (obj, currentindex, newindex) {
//             gotoPeriodBySlideIndex(newindex);
//         },
//         onSlidePrev: function (obj, currentindex, newindex) {
//             gotoPeriodBySlideIndex(newindex);
//         },
//         onSlideAfter: function (obj, oldindex, newindex) {
//             var degrees = 0;
//             var revdegrees = 0;
//             switch (newindex) {
//                 /*17-30*/
//                 case 0:
//                     degrees = 0;
//                     rotateArrow(8);
//                     break;
//                 case 1:
//                     degrees = 4;
//                     break;
//                 case 2:
//                     degrees = 8;
//                     break;
//                 case 3:
//                     degrees = 12;
//                     break;
//                 case 4:
//                     degrees = 16;
//                     break;
//                 case 5:
//                     degrees = 20;
//                     break;
//                 case 6:
//                     degrees = 24;
//                     break;
//                 /*30-50*/
//                 case 7:
//                     degrees = 36;
//                     rotateArrow(45);
//                     break;
//                 case 8:
//                     degrees = 40;
//                     break;
//                 case 9:
//                     degrees = 44;
//                     break;
//                 case 10:
//                     degrees = 48;
//                     break;
//                 case 11:
//                     degrees = 52;
//                     break;
//                 case 12:
//                     degrees = 56;
//                     break;
//                 /*50-70*/
//                 case 13:
//                     degrees = 67;
//                     rotateArrow(82);
//                     break;
//                 case 14:
//                     degrees = 71;
//                     break;
//                 case 15:
//                     degrees = 75;
//                     break;
//                 case 16:
//                     degrees = 79;
//                     break;
//                 case 17:
//                     degrees = 83;
//                     break;
//                 /*70-90*/
//                 case 18:
//                     degrees = 103;
//                     rotateArrow(110);
//                     break;
//                 case 19:
//                     degrees = 107;
//                     break;
//                 case 20:
//                     degrees = 111;
//                     break;
//                 case 21:
//                     degrees = 115;
//                     break;
//                 case 22:
//                     degrees = 119;
//                     break;
//                 case 23:
//                     degrees = 123;
//                     break;
//                 /*90-oggi*/
//                 case 24:
//                     degrees = 134;
//                     rotateArrow(147);
//                     break;
//                 case 25:
//                     degrees = 138;
//                     break;
//                 case 26:
//                     degrees = 142;
//                     break;
//                 case 27:
//                     degrees = 146;
//                     break;
//                 case 28:
//                     degrees = 150;
//                     break;
//                 case 29:
//                     degrees = 154;
//                     break;
//                 case 30:
//                     degrees = 159;
//                     break;
//             }
//         }
//     });

//     function rotateArrow(deg) {
//         $('#storia-cerchio').stop().animate(
//             { rotation: deg },
//             {
//                 duration: 500,
//                 step: function (now, fx) {
//                     $(this).css({ 'transform': 'rotate(' + now + 'deg)', 'opacity': '1' });
//                 }
//             }
//         );
//     }

//     /*Slideshow*/
//     $('.goto_1730').click(function () {
//         goto1730();
//         rotateArrow(8);
//         slider.goToSlide(0);
//     });

//     $('.goto_3050').click(function () {
//         goto3050();
//         rotateArrow(45);
//         slider.goToSlide(7);
//     });

//     $('.goto_5070').click(function () {
//         goto5070();
//         rotateArrow(82);
//         slider.goToSlide(13);
//     });

//     $('.goto_7090').click(function () {
//         goto7090();
//         rotateArrow(110);
//         slider.goToSlide(18);
//     });

//     $('.goto_90today').click(function () {
//         goto90oggi();
//         rotateArrow(147);
//         slider.goToSlide(24);
//     });
//     /*Cerchio dinamico*/

//     /*Funzioni cambio temporale*/
//     function goto1730() {

//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_1730) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto1-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr("src", "https://assets.persol.com/extra/image/TargetOptical/icons/1730-1.jpg");
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_1730').html());
//         $('#dyn-excerpt').html($('#html_excerpt_1730').html());
//         $('.anno-big-hero').html($('#anno_big_1730').html());
//         $('.anno-small-hero').html($('#anno_small_1730').html());
//     }

//     function goto3050() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_3050) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto2-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr("src", "https://assets.persol.com/extra/image/TargetOptical/icons/3050-1.jpg");
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_3050').html());
//         $('#dyn-excerpt').html($('#html_excerpt_3050').html());
//         $('.anno-big-hero').html($('#anno_big_3050').html());
//         $('.anno-small-hero').html($('#anno_small_3050').html());
//     }

//     function goto5070() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_5070) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto3-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/5070-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_5070').html());
//         $('#dyn-excerpt').html($('#html_excerpt_5070').html());
//         $('.anno-big-hero').html($('#anno_big_5070').html());
//         $('.anno-small-hero').html($('#anno_small_5070').html());
//     }

//     function goto7090() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_7090) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto4-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/7090-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_7090').html());
//         $('#dyn-excerpt').html($('#html_excerpt_7090').html());
//         $('.anno-big-hero').html($('#anno_big_7090').html());
//         $('.anno-small-hero').html($('#anno_small_7090').html());
//     }

//     function goto90oggi() {
//         if ($('#dyn-h2excerpt').html() != html_h2excerpt_90today) {
//             $('#cerchio').fadeOut(500, function () { $('#cerchio').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/foto5-redux.png'); $('#cerchio').fadeIn(1500, function () { }); });
//             $('#storia-box-picture-sx').fadeOut(500, function () {
//                 $('#storia-box-picture-sx-img').attr('src', 'https://assets.persol.com/extra/image/TargetOptical/icons/90today-1.jpg');
//                 $('#storia-box-picture-sx').fadeIn(1500, function () { });
//             });
//         }

//         $('#dyn-h2excerpt').html($('#html_h2excerpt_90today').html());
//         $('#dyn-excerpt').html($('#html_excerpt_90today').html());
//         $('.anno-big-hero').html($('#anno_big_90today').html());
//         $('.anno-small-hero').html($('#anno_small_90today').html());
//     }
//     /*Funzioni cambio temporale*/

//     /*Funzioni navigazione slideshow e cambio temporale*/
//     function gotoPeriodBySlideIndex(nextindex) {
//         //alert("a");
//         if (nextindex >= 0 && nextindex <= 6) {
//             goto1730();
//         } else if (nextindex >= 7 && nextindex <= 12) {
//             goto3050();
//         } else if (nextindex >= 13 && nextindex <= 17) {
//             goto5070();
//         } else if (nextindex >= 18 && nextindex <= 23) {
//             goto7090();
//         } else {
//             goto90oggi();
//         }
//     }
//     /*Funzioni navigazione slideshow e cambio temporale*/

//     //var wrapper = document.getElementById('cn-wrapper');

//     //
//     $("#historyPage li.goto_1730").click(function () {
//         slider.goToSlide(0);
//         goto1730();
//     });
//     $("#historyPage li.goto_3050").click(function () {
//         slider.goToSlide(7);
//         goto3050();
//     });
//     $("#historyPage li.goto_5070").click(function () {
//         slider.goToSlide(13);
//     });
//     $("#historyPage li.goto_7090").click(function () {
//         slider.goToSlide(18);
//     });
//     $("#historyPage li.goto_90today").click(function () {
//         slider.goToSlide(24);
//     });

// });

// // Icons Series Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsSeriesPage").ready(function () {
//     $("#img_cont_1_m1").click(function () {
//         $("#img_cont_1_m2").removeClass("active-marker");
//         $("#img_cont_1_m1").addClass("active-marker");
//         $("#img_cont_1_img1").fadeIn("slow", function () { });
//         $("#img_cont_1_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_1_m2").click(function () {
//         $("#img_cont_1_m1").removeClass("active-marker");
//         $("#img_cont_1_m2").addClass("active-marker");
//         $("#img_cont_1_img2").fadeIn("slow", function () { });
//         $("#img_cont_1_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_2_m1").click(function () {
//         $("#img_cont_2_m2").removeClass("active-marker");
//         $("#img_cont_2_m1").addClass("active-marker");
//         $("#img_cont_2_img1").fadeIn("slow", function () { });
//         $("#img_cont_2_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_2_m2").click(function () {
//         $("#img_cont_2_m1").removeClass("active-marker");
//         $("#img_cont_2_m2").addClass("active-marker");
//         $("#img_cont_2_img2").fadeIn("slow", function () { });
//         $("#img_cont_2_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_3_m1").click(function () {
//         $("#img_cont_3_m2").removeClass("active-marker");
//         $("#img_cont_3_m1").addClass("active-marker");
//         $("#img_cont_3_img1").fadeIn("slow", function () { });
//         $("#img_cont_3_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_3_m2").click(function () {
//         $("#img_cont_3_m1").removeClass("active-marker");
//         $("#img_cont_3_m2").addClass("active-marker");
//         $("#img_cont_3_img2").fadeIn("slow", function () { });
//         $("#img_cont_3_img1").fadeOut("slow", function () { });
//     });

//     $("#img_cont_4_m1").click(function () {
//         $("#img_cont_4_m2").removeClass("active-marker");
//         $("#img_cont_4_m1").addClass("active-marker");
//         $("#img_cont_4_img1").fadeIn("slow", function () { });
//         $("#img_cont_4_img2").fadeOut("slow", function () { });
//     });

//     $("#img_cont_4_m2").click(function () {
//         $("#img_cont_4_m1").removeClass("active-marker");
//         $("#img_cont_4_m2").addClass("active-marker");
//         $("#img_cont_4_img2").fadeIn("slow", function () { });
//         $("#img_cont_4_img1").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.one .pager.one").click(function () {
//         $(".twin-view-container.one .pager.one").addClass("active-marker");
//         $(".twin-view-container.one .pager.two").removeClass("active-marker");
//         $(".twin-view-container.one .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.one .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.one .pager.two").click(function () {
//         $(".twin-view-container.one .pager.two").addClass("active-marker");
//         $(".twin-view-container.one .pager.one").removeClass("active-marker");
//         $(".twin-view-container.one .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.one .twin-img.one").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.two .pager.one").click(function () {
//         $(".twin-view-container.two .pager.one").addClass("active-marker");
//         $(".twin-view-container.two .pager.two").removeClass("active-marker");
//         $(".twin-view-container.two .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.two .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.two .pager.two").click(function () {
//         $(".twin-view-container.two .pager.two").addClass("active-marker");
//         $(".twin-view-container.two .pager.one").removeClass("active-marker");
//         $(".twin-view-container.two .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.two .twin-img.one").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.three .pager.one").click(function () {
//         $(".twin-view-container.three .pager.one").addClass("active-marker");
//         $(".twin-view-container.three .pager.two").removeClass("active-marker");
//         $(".twin-view-container.three .twin-img.one").fadeIn("slow", function () { });
//         $(".twin-view-container.three .twin-img.two").fadeOut("slow", function () { });
//     });

//     $(".twin-view-container.three .pager.two").click(function () {
//         $(".twin-view-container.three .pager.two").addClass("active-marker");
//         $(".twin-view-container.three .pager.one").removeClass("active-marker");
//         $(".twin-view-container.three .twin-img.two").fadeIn("slow", function () { });
//         $(".twin-view-container.three .twin-img.one").fadeOut("slow", function () { });
//     });

//     //Hide on document ready;
//     $(".twin-img.two").hide();


// });

// // Icons 100 Anniversary Scripts ///////////////////////////////////////////////////////////////////////////////////////////////
// $("#iconsPersol100Page").ready(function () {
//     var sliderDesktop = $('#iconsPersol100Page .bxslider.desktop').bxSlider({
//         minSlides: 2,
//         maxSlides: 2,
//         //slideWidth: 390,
//         //slideMargin: 20,
//         moveSlides: 1,
//         pager: false,
//         speed: 1000,
//         infiniteLoop: true,
//         hideControlOnEnd: false
//     });

//     var sliderMobile = $('#iconsPersol100Page .bxslider.mobile').bxSlider({
//         minSlides: 1,
//         maxSlides: 1,
//         //slideWidth: 390,
//         //slideMargin: 20,
//         moveSlides: 1,
//         pager: false,
//         speed: 1000,
//         infiniteLoop: true,
//         hideControlOnEnd: false
//     });

//     $("#iconsPersol100Page .bx-next").click(function () {
//         sliderDesktop.goToNextSlide();
//         sliderMobile.goToNextSlide();
//         return false;
//     });

//     $("#iconsPersol100Page .bx-prev").click(function () {
//         sliderDesktop.goToPrevSlide();
//         sliderMobile.goToPrevSlide();
//         return false;
//     });

//     // tagboard.js BEGIN
//     // <script type="text/javascript" src="https://static.tagboard.com/public/js/embed.js"></script>
//     (function (window) {
//         var embedIDs = 1,
//             scrollTimer = -1,
//             previousHeight = {},

//             con = {
//                 log: function (s) { console.log(s); },
//                 warn: function (s) { console.warn ? console.warn(s) : console.log(s); },
//                 error: function (s) { console.error ? console.error(s) : console.log(s); }
//             },
//             tgbDivs = (function () {
//                 var divs = [],
//                     elems = document.getElementsByClassName('tagboard-embed');
//                 for (var i = 0; i < elems.length; ++i) {
//                     if (elems[i].nodeName === 'DIV') {
//                         divs.push(elems[i]);
//                     }
//                 }
//                 return divs;
//             })(),
//             tgbDomain = (window.tagboardOptions && window.tagboardOptions.domain) || window.tagboardDomain || "https://embeds.tagboard.com" || "http://localhost",

//             pageScrolled = function _pageScrolled() {
//                 if (scrollTimer != -1) {
//                     clearTimeout(scrollTimer);
//                 }

//                 scrollTimer = window.setTimeout(scrollFinished, 50);
//             },

//             execForFrames = function _execForFrame(func, frame_id) {
//                 // Optional frame_id to run for specific embed frame
//                 var iframes = document.getElementsByClassName('tagboard-iframe');
//                 for (var i = 0; i < iframes.length; ++i) {
//                     var ifrm = iframes[i],
//                         match = ifrm.getAttribute('tgb-frame-id') == frame_id;
//                     if (ifrm.tagName.toLowerCase() === 'iframe' && (!frame_id || match)) {
//                         func(ifrm);
//                         if (frame_id) {
//                             return;
//                         }
//                     }
//                 }
//             },

//             scrollFinished = function _scrollFinished(frame_id) {
//                 execForFrames(function (ifrm) {
//                     var divYOffset = 0;

//                     for (var element = ifrm; element != null; element = element.offsetParent) {
//                         divYOffset += element.offsetTop;
//                     }

//                     ifrm.contentWindow.postMessage('scrollPos:' + Math.max(0, window.pageYOffset - divYOffset), tgbDomain);
//                 }, frame_id);
//             },

//             setFrameHeight = function _setFrameHeight(height, frame_id) {
//                 execForFrames(function (ifrm) {
//                     if (ifrm.getAttribute('fixed-height') != 1) {
//                         var prev = parseInt(ifrm.style.height, 10),
//                             newHeight = height,
//                             event = document.createEvent("CustomEvent");

//                         if (height < prev && previousHeight[frame_id] !== height) { newHeight = prev; }

//                         ifrm.style.height = newHeight + "px";

//                         // Fire off event only if height has changed
//                         if (previousHeight[frame_id] !== height) {
//                             event.initCustomEvent("tgb.embedHeight", true, true, { height: height, iframe: ifrm }); // Because IE
//                             window.dispatchEvent(event);
//                         }

//                         previousHeight[frame_id] = height;
//                     }
//                 }, frame_id);
//             },

//             tagboardAuthWindow,
//             authRequested = function _authRequested(network, doConnect) {
//                 var top = (window.innerHeight / 2) - 300;
//                 left = (window.innerWidth / 2) - 400,
//                     authUrl = tgbDomain + "/u/auth_child?network=" + network + "&connect=" + (doConnect ? "1" : "");
//                 tagboardAuthWindow = window.open(authUrl, "tgbauthwin", "width=800,height=600,resizable=1,location=1,top=" + top + ",left=" + left);
//                 // check for window open fail - i.e. pop-up blocker doing it's thing
//                 if (!tagboardAuthWindow) {
//                     return window.tagboardAuthComplete(false, "The sign-in window was blocked due to a popup blocker. Please allow it to be opened and try again.");
//                 }

//                 function checkChild() {
//                     if (tagboardAuthWindow.closed) {
//                         return window.tagboardAuthComplete(true);
//                     }
//                     setTimeout(checkChild, 500);
//                 }

//                 checkChild();
//             },

//             insertIFrame = function _insertIFrame(div, options) {
//                 var opts = [],
//                     embedID = embedIDs++;

//                 if (options.mobilePostCount) { opts.push('mpc=' + options.mobilePostCount); }
//                 if (options.postCount) { opts.push('pc=' + options.postCount); }
//                 if (options.darkMode) { opts.push('dm=' + !!options.darkMode); }
//                 if (options.autoLoad) { opts.push('al=' + !!options.autoLoad); }
//                 if (options.inlineMedia) { opts.push('im=' + !!options.inlineMedia); }
//                 if (options.moderate) { opts.push('md=' + !!options.moderate); }

//                 opts.push('id=' + embedID);
//                 opts.push('ver=' + options.version);
//                 opts = '#' + opts.join('&');

//                 var ifrm = document.createElement("IFRAME");
//                 ifrm.setAttribute("src", tgbDomain + "/" + options.tagboard + "/embed" + opts);
//                 ifrm.setAttribute("onload", "tagboardQueryHeight(" + embedID + ")");
//                 if (options.version < 3) { ifrm.id = "tagboard-iframe"; iframe = ifrm; }
//                 ifrm.setAttribute("class", "tagboard-iframe");
//                 ifrm.setAttribute("tgb-frame-id", embedID);
//                 ifrm.name = "tagboard";
//                 ifrm.setAttribute("style", "border:0; width:100%;");
//                 ifrm.setAttribute("title", "Tagboard Social Content Web Display");
//                 if (options.fixedHeight) {
//                     ifrm.setAttribute("fixed-height", "1");
//                     ifrm.style.height = "100%";
//                 } else {
//                     ifrm.style.height = "600px"; // Default initial height
//                     ifrm.setAttribute("scrolling", "no");
//                 }
//                 div.appendChild(ifrm);
//             },

//             handleFrameMessage = function _handleFrameMessage(e) {
//                 if (e.origin == tgbDomain) {
//                     var dataObj = {};
//                     e.data.split('&').forEach(function (e) {
//                         var d = e.split(':');
//                         dataObj[d[0]] = d.length > 1 ? d[1] : d[0];
//                     });

//                     if (dataObj.height) {
//                         setFrameHeight(parseInt(dataObj.height), dataObj.frame_id);
//                     }

//                     if (dataObj.auth) {
//                         authRequested(dataObj.auth, dataObj.frame_id);
//                     }
//                     if (e.data.indexOf('tgbRemoveIframe') === 0) {
//                         var id = e.data.substr(e.data.indexOf(':') + 1);
//                         var element = document.querySelector("iframe[tgb-frame-id='" + id + "']");
//                         element.parentNode.removeChild(element);
//                     }
//                 }
//             };

//         if ((window.tagboard && typeof window.tagboard === 'string') || (window.tagboardOptions && window.tagboardOptions.tagboard)) {
//             var tagboardOptions = window.tagboardOptions || {};
//             tagboardOptions.tagboard = tagboardOptions.tagboard || window.tagboard;

//             if (window.tagboard) {
//                 tagboardOptions.version = 1;
//                 con.error("Using deprecated version of Tagboard embed. Update embed code. https://support.tagboard.com/docs/embedding-a-tagboard");
//             } else {
//                 tagboardOptions.version = 2;
//                 con.warn("Using an out-of-date version of Tagboard embed. Please update embed code. https://support.tagboard.com/docs/embedding-a-tagboard");
//             }

//             try {
//                 insertIFrame(document.getElementById("tagboard-embed"), tagboardOptions);
//             } catch (e) {
//                 con.error("Exception generating iFrame for tagboard embed: ", e);
//                 return;
//             }
//         } else if (tgbDivs.length > 0) {
//             tgbDivs.forEach(function (div) {
//                 var options = {
//                     tagboard: div.getAttribute('tgb-slug'),
//                     version: 3,
//                     mobilePostCount: div.getAttribute('tgb-mobile-count'),
//                     postCount: div.getAttribute('tgb-post-count'),
//                     darkMode: div.getAttribute('tgb-dark-mode') === 'true',
//                     autoLoad: div.getAttribute('tgb-auto-load') === 'true',
//                     fixedHeight: div.getAttribute('tgb-fixed-height') === 'true',
//                     inlineMedia: div.getAttribute('tgb-inline-media') === 'true',
//                     moderate: div.getAttribute('tgb-mod') === 'true'
//                 };
//                 if (options.tagboard && !div.getAttribute('tgb-built-iframe')) {
//                     insertIFrame(div, options);
//                     div.setAttribute('tgb-built-iframe', "1");
//                 }
//             });
//         } else {
//             //con.error("Tagboard script expected DIV with class: 'tagboard-embed'");
//             return;
//         }

//         window.tagboardQueryHeight = function queryHeight(frame_id) {
//             execForFrames(function (ifrm) {
//                 ifrm.contentWindow.postMessage('height?', tgbDomain);
//                 scrollFinished(frame_id);
//             }, frame_id);
//         };

//         window.tagboardAuthComplete = function _tagboardAuthComplete(success, failMessage) {
//             var authMessage = ["authComplete", success ? "1" : "", failMessage].join(":");
//             // close the auth child window
//             tagboardAuthWindow && typeof tagboardAuthWindow.close === "function" && tagboardAuthWindow.close();
//             // notify the embed of the auth status

//             execForFrames(function (ifrm) {
//                 ifrm.contentWindow.postMessage(authMessage, tgbDomain);
//             });
//         };

//         window.handleFrameMessage = handleFrameMessage;
//         window.pageScrolled = pageScrolled;

//         window.addEventListener('message', window.handleFrameMessage, false);
//         window.addEventListener('scroll', window.pageScrolled, false);

//         if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
//             window.addEventListener('resize', function () {
//                 execForFrames(function (ifrm) {
//                     ifrm.style.width = ifrm.parentNode.clientWidth + "px";
//                     setTimeout(function () { ifrm.style.width = "100%"; }, 2500);
//                 });
//             }, true);
//         }

//     })(window);
//     // tagboard.js END

//     $('#iconsPersol100Page .butOpen').click(function () {
//         $(this).hide();
//         $('.butClose').show();
//         $(".persol100_reg").show();
//     });

//     $('#iconsPersol100Page .butClose').click(function () {
//         $(this).hide();
//         $('.butOpen').show();
//         $(".persol100_reg").hide();
//     });


//     $('#iconsPersol100Page .play-button, .playVideo').click(function () {
//         $(this).siblings("#player_1").attr('src', $(this).siblings("iframe").attr('src') + '?autoplay=1');
//         $('.play-button, .playVideo').css("display", "none");
//     });

// });

// $("#iconsNewGenerationPage").ready(function () {

//     ! function (d, s, id) {
//         var js, fjs = d.getElementsByTagName(s)[0];
//         if (!d.getElementById(id)) {
//             js = d.createElement(s);
//             js.id = id;
//             js.src = "https://platform.twitter.com/widgets.js";
//             fjs.parentNode.insertBefore(js, fjs);
//         }
//     }(document, "script", "twitter-wjs");

//     // Owl carousel 3D
//     var owl3d = $(".owl-carousel-container-3d .owl-carousel").owlCarousel({
//         /* Not working with current owl carousel version (embedded in WCS).
//          * Needs animate.css (https://daneden.github.io/animate.css/)

//         animateOut: 'slideOutDown',
//         animateIn: 'flipInX',*/
//         loop: true,
//         margin: 10,
//         nav: true,
//         responsive: false,
//         items: 1,
//         singleItem: true
//     });

//     // Go to the next item
//     $('.owl-carousel-container-3d #slide_prev').click(function () {
//         owl3d.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('.owl-carousel-container-3d #slide_next').click(function () {
//         owl3d.trigger('owl.next');
//     });

//     // Owl carousel 2D
//     var owl2d = $(".owl-carousel-container-2d .owl-carousel").owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         /*singleItem: true*/
//         responsive: false,
//         items: 2
//     });

//     // Go to the next item
//     $('.owl-carousel-container-2d #slide_prev').click(function () {
//         owl2d.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('.owl-carousel-container-2d #slide_next').click(function () {
//         owl2d.trigger('owl.next');
//     });

//     //Slider1 mobile
//     var owlCarousel1m = $('#iconsNewGenerationPage .owl-carousel1m');

//     owlCarousel1m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#iconsNewGenerationPage #slide_prev1m').click(function () {
//         owlCarousel1m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#iconsNewGenerationPage #slide_next1m').click(function () {
//         owlCarousel1m.trigger('owl.next');
//     });

//     //Slider2 mobile
//     var owlCarousel2m = $('#iconsNewGenerationPage .owl-carousel2m');

//     owlCarousel2m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#iconsNewGenerationPage #slide_prev2m').click(function () {
//         owlCarousel2m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#iconsNewGenerationPage #slide_next2m').click(function () {
//         owlCarousel2m.trigger('owl.next');
//     });




//     $('#iconsNewGenerationPage .play-button').click(function (ev) {
//         $("#video")[0].src += "&autoplay=1";
//         $(this).fadeOut('fast');
//         ev.preventDefault();
//     });
//     $('#iconsNewGenerationPage .play-button2').on('click', function (ev) {
//         $("#video2")[0].src += "&autoplay=1";
//         ev.preventDefault();
//         $(this).fadeOut('fast');
//     });

//     $("#iconsNewGenerationPage .scroll").click(function (event) {
//         //console.log($(this.hash).offset());
//         event.preventDefault();
//         $('html,body').animate({ scrollTop: $(this.hash).offset().top }, 1300, "easeInOutCubic");
//     });

// });

// //Technology Scripts //////////////////////////////////////////////////////////////////////////////////////////////
// $("#technology").ready(function () {
//     var techVideo = document.getElementById("techVideo");
//     var owlTech = $('#technology .owl-carousel');

//     owlTech.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: true,
//         singleItem: true,
//         autoPlay: 5000,
//         stopOnHover: true
//     });

//     // Go to the next item
//     $('#technology .carousel-prev').click(function () {
//         owlTech.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#technology .carousel-next').click(function () {
//         owlTech.trigger('owl.next');
//     });


//     $("#techVideo").bind("ended", function () {
//         $(this).addClass("play-button");
//         $(this).removeClass("pause-button");
//     });

//     $(".play-pause-button").click(function () {
//         if (techVideo.paused) {
//             techVideo.play();
//             $(this).removeClass("play-button");
//             $(this).addClass("pause-button");
//         } else {
//             techVideo.pause();
//             $(this).addClass("play-button");
//             $(this).removeClass("pause-button");
//         }
//     });

//     $(".video-container").hover(
//         function () {
//             $(".play-pause-button").fadeIn("slow");
//         }, function () {
//             $(".play-pause-button").fadeOut("slow");
//         });

// });

// // SteveMcQueen Scripts ///////////////////////////////////////////////////////////////////////////////////////////////////////
// $("#McQueenPage").ready(function () {
//     var owlCarousel1 = $('#McQueenPage #owl-carousel1');
//     var owlCarousel2 = $('#McQueenPage #owl-carousel2');
//     var owlCarousel3 = $('#McQueenPage #owl-carousel3');
//     var owlCarousel1m = $('#McQueenPage #owl-carousel1m');
//     var owlCarousel2m = $('#McQueenPage #owl-carousel2m');
//     var owlCarousel3m = $('#McQueenPage #owl-carousel3m');

//     owlCarousel1.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel2.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel3.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel1m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel2m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     owlCarousel3m.owlCarousel({
//         loop: true,
//         margin: 10,
//         nav: false,
//         singleItem: true,
//         addClassActive: true,
//         slideSpeed: 1000
//     });

//     // Go to the next item
//     $('#McQueenPage .carousel-container1 .carousel-prev').click(function () {
//         owlCarousel1.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container1 .carousel-next').click(function () {
//         owlCarousel1.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container2 .carousel-prev').click(function () {
//         owlCarousel2.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container2 .carousel-next').click(function () {
//         owlCarousel2.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container3 .carousel-prev').click(function () {
//         owlCarousel3.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container3 .carousel-next').click(function () {
//         owlCarousel3.trigger('owl.next');
//     });

//     //MOBILE
//     // Go to the next item
//     $('#McQueenPage .carousel-container1m .carousel-prev').click(function () {
//         owlCarousel1m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container1m .carousel-next').click(function () {
//         owlCarousel1m.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container2m .carousel-prev').click(function () {
//         owlCarousel2m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container2m .carousel-next').click(function () {
//         owlCarousel2m.trigger('owl.next');
//     });
//     // Go to the next item
//     $('#McQueenPage .carousel-container3m .carousel-prev').click(function () {
//         owlCarousel3m.trigger('owl.prev');
//     });
//     // Go to the previous item
//     $('#McQueenPage .carousel-container3m .carousel-next').click(function () {
//         owlCarousel3m.trigger('owl.next');
//     });

//     // steve2017.js
//     var box_360_clicked = false;
//     var box_360_pos = 0;
//     var giftimer = null;
//     var gifcount = 1;

//     $('.area .bullet').mouseenter(function () {
//         $(this).stop(true, false).animate({ 'opacity': 0 }, 200);
//         $(this).siblings('.detail_' + $(this).attr('rel')).stop(true, false).fadeIn(200);
//         $('.menu .menu_' + $(this).attr('rel')).addClass('hover');
//     }).mouseleave(function () {
//         $(this).stop(true, false).animate({ 'opacity': 1 }, 200);
//         $(this).siblings('.detail_' + $(this).attr('rel')).stop(true, false).fadeOut(200);
//         $('.menu .menu_' + $(this).attr('rel')).removeClass('hover');
//     }).click(function () {
//         $('.menu .menu_' + $(this).attr('rel')).click();
//     });
//     var prevFocusedElement;
//     $('.menu a').click(function () {
//         var menuIndex= $(this).attr("rel");
//         prevFocusedElement=this;
//         changeTabIndex($(".menu"));
//         changeTabIndex($("#group"+menuIndex));
//         changeTabIndex($(".product_360"));
//         // changeTabIndex($("details"));


//         $(this).addClass('sel').siblings().removeClass('sel');
//         $('.area .popup_' + $(this).attr('rel')).fadeIn(500, function () {
//             if ($(this).hasClass('popup_2')) {
//                 giftimer = setInterval(function () {
//                     var left = -gifcount * 449 - 120;
//                     document.getElementById("gif-img").style.backgroundPosition = left + "px 0px";
//                     gifcount = gifcount >= 5 ? 0 : gifcount + 1;
//                 }, 2000);
//             }
//         }).siblings('.popup').fadeOut();


//         // $("popup"+menuIndex).addClass("focus");
//         $("#popup"+menuIndex).focus();


//     }).mouseenter(function () {
//         pos = $(this).attr('rel');
//         $('.area .bullet_' + pos).stop(true, false).animate({ 'opacity': 0 }, 300);
//         $('.area .detail_' + pos).stop(true, false).fadeIn(300);
//         $('.menu .menu_' + $(this).attr('rel')).addClass('hover');
//     }).mouseleave(function () {
//         lev = $(this).attr('rel');
//         $('.bullet_' + lev).show().animate({ 'opacity': 1 }, 300);
//         $('.area .detail_' + lev).stop(true, false).fadeOut(300);
//         $('.menu .menu_' + $(this).attr('rel')).removeClass('hover');
//     });



//     $('.popup .close').click(function () {
//         var menuIndex= $(this).attr("rel");

//         changeTabIndex($(".menu"));
//         changeTabIndex($("#group"+menuIndex));
//         changeTabIndex($(".product_360"));
//         // changeTabIndex($(".details"));


//         clearInterval(giftimer);
//         $('.menu a').removeClass('sel');
//         $(this).parent().fadeOut();
//         if(this.parentElement.parentElement && $(this.parentElement.parentElement).hasClass('activated-perks')){
            
//         }else{
//             prevFocusedElement.focus();
//         }
        


//     });

//     $('.product_360 .move').mousemove(function (e) {
//         if (box_360_clicked) {
//             frameid = Math.round((e.clientX - box_360_pos.left) * 12 / 520);
//             $('#frame_360_' + frameid).show().siblings('.frame').hide();
//         }
//     });


//     $('.next').click(function () {
//         var $visible = $('.frame:visible');
//         if ($visible.hasClass('last')) { $('.frame').first().show(); }
//         if ($visible.next().length) $visible.hide().next().show();
//         else {
//             $visible.hide();
//             $('.frame').first().show();
//         }
//     });

//     $('.prev').click(function () {
//         var $visible = $('.frame:visible');
//         if ($visible.prev().length) $visible.hide().prev().show();
//         else {
//             $visible.hide();
//             $('.frame').last().show();
//         }
//     });
// });

// function switch360Left() {
//     $('.product_360 .frame').hide().eq(2).show().addClass('sel');
//     $('.area .details .item, .area .details .bullet, .area .detail, .link_360').fadeOut();
//     $('.product_360').fadeIn(500, function () {
//         box_360_pos = $('.product_360').offset();

//         setTimeout(function () {

//             $('.product_360 .loading').fadeOut();

//         }, 2000);

//         $('body').mousedown(function () {
//             box_360_clicked = true;
//         }).mouseup(function () {
//             box_360_clicked = false;
//         });
//     });
// }

// function switch360Right() {
//     $('.product_360 .frame').hide().first().show().addClass('sel');
//     $('.area .details .item, .area .details .bullet, .area .detail, .link_360').fadeOut();
//     $('.product_360').fadeIn(500, function () {
//         box_360_pos = $('.product_360').offset();
//         setTimeout(function () {
//             $('.product_360 .loading').fadeOut();
//         }, 2000);

//         $('body').mousedown(function () {
//             box_360_clicked = true;
//         }).mouseup(function () {
//             box_360_clicked = false;
//         });
//     });
// }

// function switchBack() {
//     $('.product_360').fadeOut();
//     $(' .area .details .bullet, .area .detail, .link_360left, .link_360right').fadeIn();
// }


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

$("#customerCarePage").ready(function () {
  $("#faqs dd").hide();
  $("#faqs dt").click(function () {
      $(this)
          .next("#faqs dd")
          .slideToggle(500);
      $(this)
          .toggleClass("expanded");
  });
});


// HB-1028 BEGIN Restore all loadingInternal buttons to its initial state
function showLoadingInternal(hide, id) {
  console.log("PSL::LEGACY::showLoadingInternal function invoked");
}

function disableButton(id) {
  console.log("PSL::LEGACY::disableButton function invoked");
}

function enableButton(id) {
  console.log("PSL::LEGACY::enableButton function invoked");
}

function restoreLoadingInternalButtons() {
  console.log("PSL::LEGACY::showLoadingInternal function invoked");
}
// HB-1028 END


/**
* This functions validates payment form input fields and legal terms checkbox to continue checkout
* @param payType Currently, possible values are 'cc' for Credit Card and 'paypal' for Paypal
* Related files: PersolSAS\Snippets\EDP\PaymentMethods\StandardVisa.jsp
*/
function makePayment(payType) {
  var error = false;
  var cardType;

  if (payType == 'cc') {
      var validCardNumber = $.payment.validateCardNumber($('#account1_1').val());

      //if not valid card number...
      if ($("#account1_1").val().length == 0 || !validCardNumber) {
          $("#account1_1").addClass("field-error-message");
          $('#account1_1').parent().addClass("isNotValid");
          $('#emptyCreditCard').css('display','inline-block');
          //tealiumPushFormError($('#emptyCreditCard').html());
          var message = $('#emptyCreditCard').html();
          newTealiumPushFormError(message,message);
          error = true;
      } else {
        cardType = GetCardType($("#account1_1").val());
          $("#account1_1").removeClass("field-error-message");
          $('#emptyCreditCard').css('display', 'none');
      }

      //if name on card number...
      if ($('#cc_nameoncard_1').val().trim().length == 0) {
          $('#cc_nameoncard_1').addClass("field-error-message");
          $('#cc_nameoncard_1').parent().addClass("isNotValid");
          $('#emptyNameCard').css('display','inline-block');
          var message = $('#emptyNameCard').html();
          newTealiumPushFormError(message,message);
          error=true;
      } else {
          $('#cc_nameoncard_1').removeClass("field-error-message");
          $('#emptyNameCard').css('display', 'none');
      }

      //if Month select box empty...
      var monthError, yearError;
      if ($('#expire_month_1').val() == undefined || $('#expire_month_1')[0].value == "") {
          $('#emptyExpirationDate').css('display', 'inline-block');
          $('#expire_month_1').addClass("field-error-message");
          $('#expire_month_1').parent().addClass("isNotValid");
          var message = $('#emptyExpirationDate').html();
          newTealiumPushFormError(message,message);
          error = true;
          monthError = true;
      } else {
          monthError = false;
          $('#expire_month_1').removeClass("field-error-message");
          if (!monthError && !yearError) {
              $('#emptyExpirationDate').css('display', 'none');
          }
      }

      //if Year select box empty...
      if ($('#expire_year_1').val() == undefined || $('#expire_year_1')[0].value == "") {
          $('#emptyExpirationDate').css('display', 'inline-block');
          $('#expire_year_1').addClass("field-error-message");
          $('#expire_year_1').parent().addClass("isNotValid");
          var message = $('#emptyExpirationDate').html();
          newTealiumPushFormError(message,message);
          error = true;
          yearError = true;
      } else {
          yearError = false;
          $('#expire_year_1').removeClass("field-error-message");
          if (!monthError && !yearError) {
              $('#emptyExpirationDate').css('display', 'none');
          }
      }

      //if CVV empty...
      var cvvErrors = 0;
      if( $('#cc_cvc_1').val().trim().length == 0 ){
          $('#emptyCVV').css('display','inline-block');
          $('#emptyCVV').parent().addClass("isNotValid");
          var message =$('#emptyCVV').html();
          newTealiumPushFormError(message,message);
          error = true;
          cvvErrors++;
      } else {
          $('#emptyCVV').css('display', 'none');
      }

      if (cvvErrors == 0 && !matchCreditCardCVV($("#account1_1").val(), $('#cc_cvc_1').val().trim())){
          $('#wrongCVVLength').css('display','inline-block');
          $('#emptyCVV').parent().addClass("isNotValid");
          var message = $('#wrongCVVLength').html();
          newTealiumPushFormError(message,message);
          error = true;
          cvvErrors++;
      } else {

          $('#wrongCVVLength').css('display', 'none');
      }
      if (cvvErrors > 0) {
          $('#cc_cvc_1').addClass("field-error-message");
      } else {
          $('#cc_cvc_1').removeClass("field-error-message");
      }
  }

  if ($('.card-info--wrapper--terms--input').length > 0) {
      if ($('.card-info--wrapper--terms--input')[0].checked == false) {
          $('.card-info--wrapper--terms--alert').css('display','inline-block');
          $('.card-info--wrapper--terms--input').closest("div").addClass("field-error-message");
          error = true;
      } else {
          $('.card-info--wrapper--terms--input').closest("div").removeClass("field-error-message");
          $('.card-info--wrapper--terms--alert').css('display', 'none');
      }
  }

    if ($('.pres-checkout__input').length > 0) {
    	if(storeDirectory=="PersolUK" || storeDirectory=="PersolUS" || storeDirectory=="PersolDE"){
    		if ($('#pres-checkout__input').prop('checked') === false) {
	            //            $('.card-info--wrapper--terms--alert').css('display','inline-block');
	            $('.pres-checkout__input').closest("div").addClass("pres-checkout__error--show");
	            error = true;
	        } else {
	            $('.pres-checkout__input').closest("div").removeClass("pres-checkout__error--show");
	            //            $('.card-info--wrapper--terms--alert').css('display','none');
	        }
    	}
    }
    if (countPrescription > 1) {
        $(".prescription__wrapper-error-msg").show();
        $("html, body").animate({ scrollTop: 0 }, 500);
        error = true;
    }

  // If telephone1 empty ...
  var telephoneNumber = $('#telephone1').text().trim();
  if (!MessageHelper.isValidUTF8length(telephoneNumber, 32) || !MessageHelper.IsValidPhone(telephoneNumber)) {
      error = true;
      MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_INVALIDTELEPHONE"]);
  }

  if (error) {
	  removeCheckoutLoader();
      restoreAjaxButtons();
      moveToError();
      setTimeout(removeCheckoutLoader, 250);
  } else  {
      try {
          var paymentForm = document.getElementById('PaymentForm1');

          if (payType == 'cc') {
              setCurrentId('shippingBillingPageNext');

              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="Cybersource" />');
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep(cardType);
              CheckoutPayments.processCheckout('PaymentForm');


          } else if (payType == 'paypal') {
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="PayPal" />');
              $(paymentForm).find('input[name="customerWebId"]').val(window.forterWebId);
              $(paymentForm).find('input[name="customerIPAddress"]').val(window.ipaddress);
              $(paymentForm).find('input[name="forterToken"]').val(window.forterToken);
              setCurrentId('shippingBillingPageNext');
              //The event should not be triggered on the click, it should be triggered when the user is going to be redirected to the payment gateway
              tealiumPushCheckoutStep('PayPal');
              document.getElementById('PaymentForm1').submit();


          } else if (payType == 'affirm'){
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              $(paymentForm).append('<input type="hidden" name="payMethodId" value="Affirm" />');
              $(paymentForm).attr('action', 'AffirmForwardCmd');
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep('Affirm');
              document.getElementById('PaymentForm1').submit();


          } else if (payType == 'klarna'){
              addCheckoutLoader();
              //Remove all payMethodId input and insert the good one
              $(paymentForm).find('input[name="payMethodId"]').remove();
              setCurrentId('shippingBillingPageNext');
              tealiumPushCheckoutStep("Klarna");

              // Call Klarna Credit authorize and retrieve authorization_token
              Klarna.Credit.authorize({}, function (res) {
                  var auth_token = res["authorization_token"];
                  var isApproved = res["approved"];
                  var show_form = res["show_form"];
                  if (!auth_token || auth_token.length == 0 || !isApproved || isApproved.length == 0) {
                      if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                          MessageHelper.displayErrorMessage("Beim Autorisieren der Klarna-Zahlung ist ein Fehler aufgetreten.");
                      } else{
                          MessageHelper.displayErrorMessage("There was an error with Authorize Klarna Payment.");
                      }
                      setTimeout(removeCheckoutLoader, 250);
                  } else {
                      // Note: we need to pass the token store in auth_token to authorize against it.
                      $(paymentForm).append('<input type="hidden" name="payMethodId" value="Klarna" />');
                      $(paymentForm).append('<input type="hidden" name="checkout_token" value="' + auth_token + '" />');
                      $(paymentForm).attr('action', 'KlarnaReturnCmd');
                      document.getElementById('PaymentForm1').submit();
                  }
              });

          } else {
              console.log("PSL :: Unknown Payment Method = " + payType);
          }
      } catch (e) {
          console.error("Error in makePayment:",e);
          setTimeout(removeCheckoutLoader, 250);
      }
  }
}

$(document).ready(function() {
	//setCidCookie
	if(getUrlParam("cid") != undefined){
        var cidCookieValue = getUrlParam("cid");
        const d = new Date();
        d.setTime(d.getTime() + (28*24*60*60*1000)); //cookie 28 days
        var expires = "expires="+ d.toUTCString();
        document.cookie = "X_WC_CID=" + cidCookieValue + ";" + expires + ";path=/"
        
    }
  var windowWidth = window.innerWidth
  if (windowWidth < 1024) {
      $("#shoppingCart").appendTo("#headerRow1");
  } else {
      $("#shoppingCart").appendTo(".header__block-search");
  }

  //Search Optimization -- Init search Panel
  if (typeof fn_InitSearchPanel == 'function') {
    fn_InitSearchPanel();
}



});
$(window).resize(function() {
  var windowWidth = window.innerWidth
  if (windowWidth < 1024) {
      $("#shoppingCart").appendTo("#headerRow1");
  } else {
      $("#shoppingCart").appendTo(".header__block-search");
  }
});

// Contact Us page START ///////////////////////////////////////////////////////////////////////////////////////////////
$("ContactUsPage").ready(function() {
	
	if($('#contactus-form_EMEA').length > 0){
		manageEMEAForm();
	}else{
		manageOldForm();
	}
	
});

function validateOnlyNumberContactForm(field){
	if($(field).attr('id') == 'ContactUsForm_User_Phone'){
		$('#errorPhone .contact-us-form__error-msg').hide();
	}else{
		$(field).parent().parent().find(".error-message--form .contact-us-form__error-msg").hide();
	}
	
	phone = trim(field.value);
	var isValid = true;
    var digits = "0123456789";
    var digitsCount = 0;
    var validCharsRegexp = /^-?\d+\.?\d*$/;

    for (var i = 0; i < phone.length; i++) {
        if (digits.includes(phone[i])){
            digitsCount++;
        }
    }

    if ((digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp) == null) && phone.length != 0){
        isValid = false;
    }

    if(!isValid){
    	var errorToPlace;
        var errorMessagge = "";
        if(field.id=="ContactUsForm_User_Phone"){
        	errorMessagge = $("#error_phoneNumber").attr('value');
        	errorToPlace = $('#errorPhone');
        }else if(field.id=="ContactUsForm_User_OrderNumber"){
        	errorMessagge = $("#error_order").attr('value');
        	errorToPlace = $(field).parent().parent().find(".error-message--form");
        }
    	errorToPlace ? createErrorContactUsEmea((errorToPlace), errorMessagge) : '';
		error = true;
    }
    return isValid;
}


function validateEmailFormFieldContactForm (formField) {
	var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,3})$/;
	$('#errorEmail .contact-us-form__error-msg').hide();
	var formFieldValue = trim(formField.value);
    var isEmpty = formFieldValue == "";
	var isValid = true;
		
	if (isEmpty || !emailRegexp.test(formFieldValue)) {
		errorToPlace = document.querySelector("#errorEmail");
	    errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
		error = true;
		isValid = false;
	} 
	return isValid;
}

function manageEMEAForm(){
	/**
	*  Mattia A.M. CSE Project
	*/
	var btnSubmitContactUs = document.querySelector('#WC_ContactUsDisplay_links_1');
	if (!btnSubmitContactUs) {
		return false;
	}

	console.log("WC_ContactUsDisplay_links_1 exists");
	//Fill list of phone number;
	var urlFillPhonePrefix  = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_list';
	
	$.ajax({
        url: urlFillPhonePrefix,
        dataType: "json"}
    ).then(function(phoneList){
    	for(var i = 0; i < phoneList.countries.length; i++){
    		$('#containerPhoneNumber .select-items').append('<div class="listReason" id="'+ phoneList.countries[i].callingCode +'"><span>'+  phoneList.countries[i].displayName+'</span><span>'+ phoneList.countries[i].callingCode +'</span></div>')
    		if((WCParamJS.countryCode === phoneList.countries[i].code) || (WCParamJS.countryCode == 'UK' && phoneList.countries[i].code == 'GB')){
    			$('#prefixNumber').html(phoneList.countries[i].callingCode); 
    			$('#prefixNumber').attr('value', phoneList.countries[i].callingCode);
    		}
    	}
    	$('#containerPhoneNumber .listReason').on('click', function(){
    		$('#prefixNumber').html($(this).attr('id')); 
    		$('#prefixNumber').attr('value', $(this).attr('id'));
    	});
    });
	
	function toBase64(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();
		    reader.readAsDataURL(file);
		    reader.onload = () => resolve(reader.result);
		    reader.onerror = reject;
		});
	}
	
	btnSubmitContactUs.addEventListener('click', function(e) {
		e.preventDefault();
	    var topicValue = $('#selection4ReasonDSK').attr('codeReason');
	    var firstNameValue = document.querySelector("#ContactUsForm_User_FirstName");
	    var lastNameValue = document.querySelector("#ContactUsForm_User_LastName");
	    var emailValue = document.querySelector("#ContactUsForm_User_Email");
	    var orderValue =  document.querySelector("#ContactUsForm_User_OrderNumber");
	    var phoneNumber = $('#prefixNumber').attr('value') + document.getElementById("ContactUsForm_User_Phone").value;
	    var msgValue = document.querySelector("#ContactUs_message");
	    var file = document.querySelector('#attachInput').files[0];
	    var attach64 = null;
	    var attachName = null;
	    var error = false;

	    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
	    if (allErrors.length > 0) {
	    	allErrors.forEach(function(el) {
	        	el.remove();
	    	})
	    }
	    if(file != null){
	    	if(file.size > 2097152 || !(file.type.includes('jpeg') || file.type.includes('png') || file.type.includes('pdf'))){
		    	var errorToPlace = document.querySelector("#errorAttach");
		        errorToPlace ? createErrorContactUsEmea($("#errorAttach"), $("#error_attachment").attr('value')) : '';
		        error = true;
		    }else{
		    	attachName = file.name;
		    }
	    }
	    
	    if(document.getElementById("ContactUsForm_User_Phone").value === '' && document.getElementById("ContactUsForm_User_Phone")){
	    	phoneNumber = '';
	    }else if (document.getElementById("ContactUsForm_User_Phone").value != ''){
	    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_Phone"))){
		    	error = true;
		    }
	    }
	    
	    if(orderValue.value != ''){
	    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_OrderNumber"))){
		    	error = true;
		    }
	    }
	    
	    if (topicValue == null) {
	    	var errorToPlace = document.querySelector("#errorTopic");
	        errorToPlace ? createErrorContactUsEmea($("#errorTopic"), $("#error_topic").attr('value')) : '';
	        error = true;
	    }

	    if (firstNameValue && firstNameValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorFirstname");
	        errorToPlace ? createErrorContactUsEmea($("#errorFirstname"), $("#error_firstName").attr('value')) : '';
	        error = true;
	    }
	    
	    if (lastNameValue && lastNameValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorLastname");
	        errorToPlace ? createErrorContactUsEmea($("#errorLastname"), $("#error_lastName").attr('value')) : '';
	        error = true;
	    }

	    if (!validateEmailFormFieldContactForm(document.querySelector("#ContactUsForm_User_Email")) || (emailValue && emailValue.value === '')) {
	    	var errorToPlace = document.querySelector("#errorEmail");
	        errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
	        error = true;
	    }

	    if (msgValue && msgValue.value === '') {
	    	var errorToPlace = document.querySelector("#errorNotes");
	        errorToPlace ? createErrorContactUsEmea($("#errorNotes"), $("#error_desription").attr('value')) : '';
	        error = true;
	    }

	    if (error === true) {
	    	focusOnElement(document.querySelectorAll('.contact-us-form__error-msg')[0]);
	        return false;
	    }

	    var action = document.querySelector("#contactus-form_EMEA").getAttribute('action');
	    if (action) {
	    	if(attachName != null){
	    		toBase64(file).then(function (data) {
		    		attach64 = data;
		    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
		    	});
	    	}else{
	    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
	    	}
	    	
	    	// HB-16527 Disable button after first click
	    	btnSubmitContactUs.classList.add('disabled');
	    	btnSubmitContactUs.setAttribute('aria-disabled', 'true');
	    	btnSubmitContactUs.style.cursor = 'default';
	    	btnSubmitContactUs.removeEventListener('click', arguments.callee);
	    	
	    } else {
	    	// ERROR WITH ACTION
	    	console.error("Can not retrieve the form's action.");
	    }
	});
	
	a = document.getElementsByClassName("select-selected");

	for (var i = 0; i < a.length; i++) {
		a[i].addEventListener("click", function(e) {
			/*when the select box is clicked, close any other select boxes,
		    and open/close the current select box:*/
		    e.stopPropagation();
		    closeAllSelect(this);
		    this.nextElementSibling.classList.toggle("select-hide");
		    this.classList.toggle("select-arrow-active");
		});
	}
	  
	function closeAllSelect(elmnt) {
	  /*a function that will close all select boxes in the document,
	  except the current select box:*/
	  var x, y, i, xl, yl, arrNo = [];
	  x = document.getElementsByClassName("select-items");
	  y = document.getElementsByClassName("select-selected");
	  xl = x.length;
	  yl = y.length;
	  for (i = 0; i < yl; i++) {
	    if (elmnt == y[i]) {
	      arrNo.push(i)
	    } else {
	      y[i].classList.remove("select-arrow-active");
	    }
	  }
	  for (i = 0; i < xl; i++) {
	    if (arrNo.indexOf(i)) {
	      x[i].classList.add("select-hide");
	    }
	  }
	}
	
	$('#reason-of-contact .listReason').on('click', function(){
		$(this).parent().attr('codeReason',$(this).attr('id'));
		$(this).parent().siblings().text(this.textContent);
	});
	
	/*if the user clicks anywhere outside the select box,
	then close all select boxes:*/
	document.addEventListener("click", closeAllSelect);
	
	$('#textRemove').on('click', function(){
		document.getElementById('attachInput').value = "";
	});
	
	function callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber){

		$.post(action, {
			firstName: firstNameValue.value,
			lastName: lastNameValue.value,
	        email: emailValue.value,
	        intentCode: topicValue,
	        order_id: orderValue.value,
	        note: msgValue.value,
	        attachName: attachName,
	        attach64: attach64,
	        mobile: phoneNumber
	    }, function(data) {
	    	var response = data.replace(/\*/g,"");
	        response = response.replace(/\//g,"");
	        var arr = JSON.parse(response);
	        if (arr['ResponseMessage'] == '1') {
	        	var msgOK = $("#ContactUsForm_msgOK").text();
	            $("#ContactUsForm_Returnmessage").text(msgOK);
	            $("#ContactUsForm_Returnmessage").show();
	        } else {
	        	var msgKO = $("#ContactUsForm_msgKO").text();
	            $("#ContactUsForm_Returnmessage").text(msgKO);
	            $("#ContactUsForm_Returnmessage").show();
	        }
	        // Append returned message to message paragraph.
	        $("#contactus-form_EMEA").hide();
	    });

	}
}


function manageOldForm(){
	/*
	*  Daniel Rilo Ferrero - BEGIN - NERD-656
	*/
	
	var btnSubmitContactUs = document.querySelector('#WC_ContactUsDisplay_links_1');
	if (!btnSubmitContactUs) {
		return false;
	}

	console.log("WC_ContactUsDisplay_links_1 exists");

	btnSubmitContactUs.addEventListener('click', function(e) {
		e.preventDefault();
	    var topicValue = document.querySelector("#ContactUsForm_Topic");
	    var nameValue = document.querySelector("#ContactUsForm_User_Name");
	    var emailValue = document.querySelector("#ContactUsForm_User_Email");
	    var msgValue = document.querySelector("#ContactUs_message");
	    var error = false;

	    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
	    if (allErrors.length > 0) {
	    	allErrors.forEach(function(el) {
	        	el.remove();
	    	})
	    }

	    if (topicValue && topicValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_7");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Topic error') : '';
	        error = true;
	    }

	    if (nameValue && nameValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_9");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Name error') : '';
	        error = true;
	    }

	    if (emailValue && emailValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_11");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Email error') : '';
	        error = true;
	    }

	    if (msgValue && msgValue.value === '') {
	    	var errorToPlace = document.querySelector("#WC_ContactUsDisplay_div_13");
	        errorToPlace ? createErrorContactUs(errorToPlace, 'Message error') : '';
	        error = true;
	    }

	    if (error === true) {
	    	focusOnElement(document.querySelectorAll('.contact-us-form__error-msg')[0]);
	        return false;
	    }

	    var action = document.querySelector("#contactus-form").getAttribute('action');
	    if (action) {
	    	$.post(action, {
	    		name: nameValue.value,
	            email: emailValue.value,
	            topic: topicValue.value,
	            message: msgValue.value
	        }, function(data) {
	        	var response = data.replace(/\*/g,"");
	            response = response.replace(/\//g,"");
	            var arr = JSON.parse(response);
	            if (arr['ResponseMessage'] == 'MSG_SENT') {
	            	var msgOK = $("#ContactUsForm_msgOK").text();
	                $("#ContactUsForm_Returnmessage").text(msgOK);
	                $("#ContactUsForm_Returnmessage").show();
	            } else {
	            	var msgKO = $("#ContactUsForm_msgKO").text();
	                $("#ContactUsForm_Returnmessage").text(msgKO);
	                $("#ContactUsForm_Returnmessage").show();
	            }
	            // Append returned message to message paragraph.
	            $("#contactus-form").hide();
	        });
	    } else {
	    	// ERROR WITH ACTION
	    	console.error("Can not retrieve the form's action.");
	    }
	});
}

function createErrorContactUs(whereToPlaceError, errorMsg) {
  whereToPlaceError.insertAdjacentHTML('afterend','<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
}

function createErrorContactUsEmea(whereToPlaceError, errorMsg) {
	  whereToPlaceError.html('<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
	}

function focusOnElement(whereToPlaceFocus) {
  whereToPlaceFocus.focus();
}
/**
*  Daniel Rilo Ferrero - END - NERD-656
*/
//Contact Us page END ///////////////////////////////////////////////////////////////////////////////////////////////

function sleep(miliseconds) {
  console.log("Sleeping... I will wake up in " + miliseconds + " ms");
  var currentTime = new Date().getTime();
  while (currentTime + miliseconds >= new Date().getTime()) {
  }
  console.log("Waking up!");
}




/**
* @param {*} measurements
*/
function getMeasurementsDisplayValue(measurements) {
  var arrM = measurements.split(",");
  return arrM.join("-");
}

/**
* Updates the product name in the NameAndPrice widget.
*
* @param {string} catEntryId The catentryId of the selected product
* @param {string} productId The productId of the product shown
*/
function updateItemName(catEntryId, productId) {
  var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
  //var modelCodeValueElement = document.querySelector(".model_code_display .attr-value");
 // if (modelCodeValueElement != null) {
   //     modelCodeValueElement.innerHTML = catEntry.description[0].name;
       //modelCodeValueElement = modelCodeAttr;
  //}

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	  var modelCodeLabel= $("#tabAttr .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelPopUp = $("#detailFeatures .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
	  
	  if(typeof modelCodeLabel != 'undefined'){
          modelCodeLabel.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelPopUp != 'undefined'){
      	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
      }
      
  } else {
	  var modelCodeLabel= $("#tabAttr .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelPopUp = $(".accordion-content .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeLabelLoad= $(".descriptive-attributes-widget .item-descriptive-attributtes-wrapper .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
	  var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
	  
	  if(typeof modelCodeLabel != 'undefined'){
          modelCodeLabel.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelPopUp != 'undefined'){
      	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
      }
      if(typeof modelCodeLabelLoad != 'undefined'){
    	modelCodeLabelLoad.innerText = modelCodeDisplay.innerText;
      }
  }
 


  var modelMeasurements = document.querySelector(".ItemMeasurements_" + catEntryId);

  var modelMeasurementsValueElement = document.querySelector("#featureMenu .descAttributeValue_modelMeasurements");
  var modelMeasurementsValueElementFirstGridMobile = document.querySelector("#tabAttr .descAttributeValue_modelMeasurements");
  
  if (modelMeasurementsValueElement != null) {
      modelMeasurementsValueElement.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
      if (modelMeasurementsValueElementFirstGridMobile != null) {
        modelMeasurementsValueElementFirstGridMobile.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
      }
      
  }

  var price = document.querySelector("#listPrice_" + productId);
  if(price != null){
      price.innerHTML = catEntry.listPrice;
  }

  var offer = document.querySelector("#offerPrice_" + productId);
  if(offer != null){
      offer.innerHTML = catEntry.offerPrice;
  }

}

$(".product_page_content").ready(function () {
  wcTopic.subscribe('DefiningAttributes_Resolved', updateItemName);
});




//function assureCityValue(){

// var city = $(".shipping_address_summary > .address > .city > span")[0].innerHTML.trim();
// $("#WC_UserRegistrationAddForm_AddressEntryForm_FormInput_city_1").val( city );
//}
/* HB-587 END *************************************************************************************************/


// /**
//  * HB-550 BEGIN Improve PLP loading time + HB-678 Different behavior for PLP with or without hash
//  * The next code loads dinamically plp sections using Ajax
//  */
// var isAjaxPLP = false;                  //True if we are in a PLP with ajax elements
// var isAjaxPLPHash = false;              //True if we are in a PLP with hash
// var ajaxPLPClass = "plp-ajax-section";  //Class name of PLP elements to load using Ajax
// var ajaxPLPLocked = false;              //Used to lock multiple ajax calls at the same time
// var ajaxPLPHash = "";                   //location.hash of current URL
// var ajaxPLPHashScrollDone = false;      //True if the scroll to hash was done
// var ajaxPLPNoScrollSuffix = "_noScrollToHash"; //Suffix added to collection id to stop default scroll

// $(document).ready(function () {
//     ajaxPLPSetup();

//     if (isAjaxPLP) {
//         // HB-678 BEGIN Different behavior for PLP with or without hash
//         // Without hash: Load collections from top to bottom as they become visible
//         // With hash: Load collections as they become visible
//         if (isAjaxPLPHash) {
//             //ajaxPLPLocked=true;
//             loadCategoryAjax(ajaxPLPHash);
//         } else {
//             ajaxPLPRemoveSuffix();
//             loadVisibleCategoriesAjax();
//         }
//         // HB-678 END
//     }
// });

// $(window).resize(function () {
//     if (!ajaxPLPLocked && isAjaxPLP) {
//         loadVisibleCategoriesAjax();
//         activateContent();
//     }
// });
// $(window).scroll(function () {
//     if (!ajaxPLPLocked && isAjaxPLP) {
//         loadVisibleCategoriesAjax();
//         activateContent();
//     }
// });

// $(document).ajaxComplete(function () {
//     if (isAjaxPLP) {
//         //Check if ajax load worked correctly
//         var linksError = document.querySelectorAll("a." + ajaxPLPClass + ".loaded");
//         for (var i = 0; i < linksError.length; i++) {
//             if ($(linksError[i]).next().html() == "") {
//                 $(linksError[i]).removeClass("loaded");
//                 $(linksError[i]).next().removeClass("loaded");
//             } else {
//                 //Hide ajax link image
//                 $(linksError[i]).find("img.ajaxloadingImg").hide();
//                 $(linksError[i]).hide();
//             }
//         }

//         //This is to double check that ajax img are hidden when the content is loaded
//         linksError = document.querySelectorAll("a." + ajaxPLPClass);
//         for (var i = 0; i < linksError.length; i++) {
//             if ($(linksError[i]).next().html() != "") {
//                 $(linksError[i]).addClass("loaded");
//                 $(linksError[i]).next().addClass("loaded");
//                 $(linksError[i]).find("img.ajaxloadingImg").hide();
//                 $(linksError[i]).hide();
//             }
//         }

//         //Activate inactive carousels
//         var cs = document.querySelectorAll(".wrapperCategories--owl-carousel:not(.active)");
//         for (var i = 0; i < cs.length; i++) {
//             $(cs[i]).owlCarousel({
//                 items: 1,
//                 lazyLoad: true,
//                 singleItem: true,
//                 navigation: true,
//                 navigationText: false,
//                 addClassActive: true,
//                 //The afterAction is for solve a 'problem' with the Owl Carousel Framework.
//                 //When we resize the size of the browser, the Carousel is refreshd.
//                 //This way, we can control the resize and put the colors in the nav menu.
//                 afterAction: function (event) {
//                     event.onresize = colorCarousel();
//                 }
//             });
//             $(cs[i]).addClass('active');
//         }

//         if (isAjaxPLPHash && !ajaxPLPHashScrollDone && $(ajaxPLPHash + " ." + ajaxPLPClass + ".loaded").length > 0) {
//             //Scroll to loaded category
//             $('html,body').animate(
//                 { scrollTop: $(ajaxPLPHash).offset().top },
//                 1300,
//                 "easeInOutCubic",
//                 function () {
//                     ajaxPLPLocked = false;
//                     //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+"::"+new Date().toString());
//                     ajaxPLPHashScrollDone = true;
//                     loadVisibleCategoriesAjax();
//                     activateContent();
//                     ajaxPLPRemoveSuffix();
//                 });
//         } else {
//             ajaxPLPLocked = false;
//             //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+"::"+new Date().toString());
//         }
//     }
// });


// //Initialization of Ajax PLP page
// function ajaxPLPSetup() {
//     if ($("a." + ajaxPLPClass).length > 0) {
//         isAjaxPLP = true;

//         //Add content DIV after each AjaxLink
//         var cont = 0;
//         $("a." + ajaxPLPClass).each(function () {
//             cont++;
//             $(this).html("<img class='ajaxloadingImg' src='https://assets.persol.com/extra/image/TargetOptical/icons/ajax_transparent_20x20.png' width='20' height='20'>");
//             $(this).after("<div id='loadedContent_" + cont + "' style='display:none;'></div>");
//         });

//         // HB-678 BEGIN
//         if (location.hash) {
//             //Check if hash collection exists
//             if ($(location.hash + ajaxPLPNoScrollSuffix).length > 0) {
//                 //The collection exists
//                 //console.log("PSL::ajaxPLPSetup::Collection found="+location.hash);
//                 isAjaxPLPHash = true;
//                 ajaxPLPHash = location.hash + ajaxPLPNoScrollSuffix;
//             } else {
//                 //The collection doesn't exist
//                 //console.log("PSL::ajaxPLPSetup::Collection not found="+location.hash);
//             }
//         }
//         // HB-678 END
//     }
// }

// //Remove ajaxPLPNoScrollSuffix from id in all collections to enable default scroll
// function ajaxPLPRemoveSuffix() {
//     $("div.wrapperCategories").each(function () {
//         $(this).attr('id', $(this).attr('id').replace(ajaxPLPNoScrollSuffix, ''));
//     });
// }

// function loadVisibleCategoriesAjax() {
//     if (isAjaxPLP && !ajaxPLPLocked) {
//         if (isAjaxPLPHash) {
//             //Load categories as they become visible
//             var linksArray = document.querySelectorAll("a." + ajaxPLPClass + ":not(.loaded)");
//             for (var i = 0; i < linksArray.length; i++) {
//                 if ($(linksArray[i]).visible()) {
//                     if ($(linksArray[i]).next().html() == "") {
//                         ajaxPLPLocked = true;
//                         //console.log("PSL::ajaxPLPLocked::"+ajaxPLPLocked+" "+new Date().toString());
//                         $(linksArray[i]).next().load($(linksArray[i]).attr('href'), null, activateContent($(linksArray[i]).next()));
//                         $(linksArray[i]).addClass('loaded');
//                         $(linksArray[i]).next().addClass('loaded');
//                         $(linksArray[i]).next().fadeIn(2500);

//                         break;
//                     }
//                 }
//             }

//         } else {
//             //Load visible categories FROM TOP TO BOTTOM
//             var linksArray = document.querySelectorAll("a." + ajaxPLPClass + ":not(.loaded)");
//             var loadNeeded = false;
//             for (var i = 0; i < linksArray.length; i++) {
//                 if ($(linksArray[i]).visible()) {
//                     if ($(linksArray[i]).next().html() == "") {
//                         loadNeeded = true;
//                         break;
//                     }
//                 }
//             }
//             if (loadNeeded) {
//                 if (!ajaxPLPLocked) {
//                     var firstEmptyLink = document.querySelector("a." + ajaxPLPClass + ":not(.loaded)");
//                     ajaxPLPLocked = true;
//                     $(firstEmptyLink).next().load($(firstEmptyLink).attr('href'), null, activateContent($(firstEmptyLink).next()));
//                     $(firstEmptyLink).addClass('loaded');
//                     $(firstEmptyLink).next().addClass('loaded');
//                     $(firstEmptyLink).next().fadeIn(2500);
//                 }
//             }
//         }
//     }
// }

// /**
//  * HB-678 Loads category using Ajax
//  * @param {string} categoryHash Category id hash, for example #Galleria900
//  */
// function loadCategoryAjax(categoryHash) {
//     var aElement = document.querySelector(categoryHash + " a.plp-ajax-section:not(.loaded)");
//     if (aElement == undefined) {
//         //The category was not found
//         //console.log("PSL::store-persol.js::loadCategoryAjax::Category not found or already loaded.");
//     } else {
//         //console.log("PSL::store-persol.js::loadCategoryAjax::Category found, array elements = "+aElement);
//         if ($(aElement).next().html() == "") {
//             ajaxPLPLocked = true;
//             $(aElement).next().load($(aElement).attr('href'), null, activateContent($(aElement).next()));
//             $(aElement).addClass('loaded');
//             $(aElement).next().addClass('loaded');
//             $(aElement).next().fadeIn(2500);
//         }
//     }
// }
// /* HB-678 END *************************************************************************************************/

// //Shows section
// function activateContent(contentElement) {
//     if (isAjaxPLP && contentElement !== undefined && $(contentElement).is(":hidden")) {
//         $(contentElement).fadeIn(2000);
//     }
// }

// /*
// We use a key-value variable owlColors and the 'aria-color' found in each class 'product'
// to put the background-color to each button of the carousel.
// */
// function colorCarousel() {
//     $('.wrapperCategories--owl-carousel').each(function (index) {
//         var thisItem = $(this);
//         thisItem.find('.product').each(function (indexItem) {
//             if ($(this).attr('aria-color')) {
//                 $(thisItem).find('.owl-page > span').eq(indexItem).css('background-color', owlColors[$(this).attr('aria-color')]);
//             }
//         });
//     });
// }
// /* HB-550 END *************************************************************************************************/

// /**
//  * HB-638 BEGIN Disable context menu on images
//  */
// function disableContextMenuOnImages() {
//     for (var i = 0; i < document.images.length; i++) {
//         document.images[i].addEventListener("contextmenu", function (e) {
//             e.preventDefault();
//         });
//     }
//     return false;
// }
// $(document).ready(function () {
//     //disableContextMenuOnImages();
// });
// $(document).ajaxComplete(function () {
//     //disableContextMenuOnImages();
// });
/* HB-638 END *************************************************************************************************/

/**
* Function for the checking of the State.
* If the State is California, we have to
* show a new line with a link to a popup
* with a message about some risks.
*/
// function changeState(sel) {
//   sel.value === 'CA' ? $('.prop65').addClass('shown') : $('.prop65').removeClass('shown');
// }

/**
* GDPR BEGIN
*/

/**
* Calculates if age greater than 16 years
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {boolean} true if age >= 16, false otherwise
*/
function olderThan16(year, month, day) {
  var year = parseInt(year);
  var month = parseInt(month);
  var day = parseInt(day);
  var age = calculateAge(year, month, day);
  if (age >= 16)
      return true;
  return false;
}

/**
* Calculates age in years.
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {int} age in years
*/
function calculateAge(year, month, day) {
  var birthdate = new Date(year, month - 1, day);
  var cur = new Date();
  var diff = cur - birthdate; // This is the difference in milliseconds
  var age = Math.floor(diff / 31557600000); // Divide by 1000*60*60*24*365.25
  return age;
}
/* GDPR END *************************************************************************************************/

/**
* Shows a price without the currency, note that the string decimals MUST match the NUMBER_OF_DECIMALS constant
* @param {String} inPrice String with price i.e. something like "$ 100.00"
* @param {boolean} If true, decimals are removed (Default false)
* @returns String without the currency "100.00"
*/
function cleanPrice(inPrice, removeDecimals) {
  if (typeof removeDecimals === 'undefined' || removeDecimals != true) {
      removeDecimals = false;
  }
  var NUMBER_OF_DECIMALS = 2;
  var numbers = "0123456789";
  var validSeparators = ",.";
  var validChars = numbers + ",.";
  var decimalSeparator = "";
  var tempPrice = "";
  var cleanedPrice = "";
  var hasDecimals = true;
  var decimalChar = ".";

  for (var i = 0; i < inPrice.length; i++) {
      if (validChars.includes(inPrice[i])) {
          tempPrice += inPrice[i];
      }
  }

  if (tempPrice.length >= NUMBER_OF_DECIMALS + 2) {
      decimalChar = tempPrice[tempPrice.length - (NUMBER_OF_DECIMALS + 1)];
      if (!validSeparators.includes(decimalChar)) {
          hasDecimals = false;
      }
  }

  if (removeDecimals) {
      if (hasDecimals) {
          tempPrice = tempPrice.substring(0, tempPrice.length - (NUMBER_OF_DECIMALS + 1));
      }
  }

  for (var i = 0; i < tempPrice.length; i++) {
      if (numbers.includes(tempPrice[i]) || tempPrice[i] == decimalChar) {
          cleanedPrice += tempPrice[i];
      }
  }

  return cleanedPrice;
}


/**
* HB-828 BEGIN Expansible address2 line in US
$(document).ready(function () {
  $(".address2_wrapper").click(function () {
      $(this).css("text-decoration", "none");
      $(this).find(".expansible_symbol").html("");
      $(this).find(".address2-input_wrapper").slideDown("fast");
      $(this).find(".optional").fadeIn("fast");
  });

  if ($(".address2_wrapper input").first().val() != "") {
      $(".address2_wrapper").click();
  }
});
*/
/* HB-828 END ******************************************************************************/

/**
* HB-1669 BEGIN Enable or disable addToCart button depending of current catentry stock
*/
function hideOrShowCartBtn (showAdd) {
  if(showAdd) {
      $("#add2CartBtnDisabled").hide();
      if(!$("#add2CartBtnDisabled").hasClass("hidden")) $("#add2CartBtnDisabled").addClass("hidden");
      $("#add2CartBtn").show();
      $("#add2CartBtn").removeClass("hidden");
  } else {
      $("#add2CartBtnDisabled").show();
      $(".namePartPriceContainer").css('visibility', 'hidden');
      $("#add2CartBtnDisabled").removeClass("hidden");
      $("#add2CartBtn").hide();
      // $('.fixed-navbar').addClass('three-columns');
      $('#pdp-presc-and-clip-on').css('visibility', 'hidden');
      if(!$("#add2CartBtn").hasClass("hidden")) $("#add2CartBtn").addClass("hidden");
  }
  createTopRecap();
}


//Show the AddToCart button when only one size available (no size combo)
$(document).ready(function () {
  if ($('.product_page_content').length > 0) {
      if ($('.namePartPriceContainer .old_price').length > 0) {
          $('.namePartPriceContainer').addClass('namePartPriceContainer--offer-price');
//            $('.product_page_content .namePartPriceContainer .vat').css('margin-right', $('.product_page_content .namePartPriceContainer--offer-price .old_price').width() + 5);
      }
  }
  /*if (typeof inventoryMap !== 'undefined') {
      var size = Object.keys(inventoryMap).length;
      if (size == 1) {
          var stock = inventoryMap[Object.keys(inventoryMap)[0]];
          if (stock > 0) {
              //Enable AddToCart button
              hideOrShowCartBtn(true)
              $("#add2CartBtnDisabled").hide();
              $("#add2CartBtn").show();
          } else {
              //Disable AddToCart button
              hideOrShowCartBtn(false)

              $("#add2CartBtnDisabled").show();
              $("#add2CartBtn").hide();
          }
      }
  }*/
  $('.namePartPriceContainer').show();
  
  //$('#add2CartBtn').show();  the addtocart button is shown already by a script in PDP_Prescription
});

/* HB-1669 END ******************************************************************************/

// Daniel Rilo - END - CREV NERD-569
$(document).ready(function () {
  /**
   * When we click ENTER, the form must be submitted
   */
  var newsletterEmail = document.getElementById('newsletterEmail');
  if (newsletterEmail !== null) {
      newsletterEmail.addEventListener('keyup', function (event) {
          event.preventDefault();
          if (event.keyCode === 13) {
              // TODO
          }
      });
  }
});

/**
* Daniel Rilo -BEGIN - WCAG
*/
window.addEventListener('load', function () {
  // Add title to he iFrame without this attribute
  document.querySelectorAll('iframe').forEach(function (el, index) {
      if (el.title === '') {
          el.title = 'iFrame number ' + index;
      }

      /**
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       * @@@@@    WIP !!!!    @@@@@
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       */
      // Loop thru iFrame attributes to remove these ones are not allowed
      // var notAllowedAttr = [
      //     'scrolling'
      // ]

      // var attrLength = el.attributes.length;
      // var notAllowedAttrLength = notAllowedAttr.length;
      // for (i=0; i < attrLength; i++) {
      //     for (j=0; j < notAllowedAttrLength; j++) {
      //         var test = '';
      //         // console.log("el.getAttribute(notAllowedAttr[j]) -> " + el.getAttribute(notAllowedAttr[j]));
      //         // console.log("el.attributes[i] -> " + el.attributes[i]);
      //         // console.log("el.attributes[i] -> %o", el.attributes[i]);
      //         // console.log("el.hasAttribute("+notAllowedAttr[j]+") -> " + el.hasAttribute(notAllowedAttr[j]));
      //         // test = notAllowedAttr[j].indexOf(el.attributes[i].name);
      //         console.log(el.getAttribute(notAllowedAttr[j]));
      //         console.log("test !== null -> " + (test !== null));
      //         // console.log(test);
      //         // test ? console.log('true') : console.log('falase');
      //         if (test !== null) {
      //             console.log("Removing " + notAllowedAttr[j]);
      //             console.log("1. %o",el);
      //             el.removeAttribute("'"+notAllowedAttr[j]+"'");
      //             console.log("2. %o",el);
      //         }
      //     }
      // }
      /**
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       * @@@@@    WIP !!!!    @@@@@
       * @@@@@@@@@@@@@@@@@@@@@@@@@@
       */
  });
})
/**
* Daniel Rilo - END - WCAG
*/

function closeMobileMenu(){
    
    $("#headerWrapper.header-fixed").removeClass("header-fixed");
    if($('#page').hasClass('pdp') ){
      $('#header').css('z-index', '5');
      hideHeaderTimeout.setup();
    }
    document.getElementById('header').classList.remove('header--opend');
    document.getElementsByTagName('html')[0].classList.remove('open-menu');
    document.getElementsByTagName('body')[0].classList.remove('open-menu');
    document.getElementById('searchBar').style.display = 'none';
    closeSearchBar();
    document.getElementsByClassName('signInContainer')[0].style.display = 'none';
    $('.signInRegisterRow').removeClass('signInOpened');
    document.getElementById('shoppingCart').style.display = 'block';
    document.getElementById('logo').style.display = 'block';
    $('#closeIcon').hide();
    $('#searchIcon').show();
    if(isPersol){
        document.getElementsByClassName('header_wishlist')[0].style.display = 'block';
    }
    if(isIOS() && sessionStorage.getItem('menu_scrollY')) {
        window.scrollTo(0,sessionStorage.getItem('menu_scrollY'));
        sessionStorage.removeItem('menu_scrollY');
        document.getElementsByTagName('body')[0].classList.remove('iosBody');
    }
    if($(this).hasClass("close-mobile-menu")){
        var headerCheckbox = document.getElementById("header__checkbox");
        headerCheckbox.checked = false;
        backMenu($(this));
    }
}

// Daniel Rilo - END - CREV NERD-569
$(document).ready(function () {
  /**
   * When we click ENTER, the form must be submitted
   */
  var newsletterEmail = document.getElementById('newsletterEmail');
  if (newsletterEmail !== null) {
      newsletterEmail.addEventListener('keyup', function (event) {
          event.preventDefault();
          if (event.keyCode === 13) {
              // TODO
          }

          newsletterEmail.checkValidity() && newsletterEmail.value !== '' ? document.querySelector('#newsLetter').classList.add('btn-visible') : document.querySelector('#newsLetter').classList.remove('btn-visible');
      });

      // newsletterEmail.addEventListener('blur', function(event) {
      // });
  }

  /**
   *
   */
    var headerChk = document.getElementById('header__checkbox');
    $(".close-mobile-menu").click(closeMobileMenu) ;
    if (headerChk !== null) {
        headerChk.addEventListener('click', function () {
        if (this.checked) {
          $("#headerWrapper").addClass("header-fixed");
              if(isIOS()){
                  sessionStorage.setItem('menu_scrollY',window.scrollY);
                  document.getElementsByTagName('body')[0].classList.add('iosBody');
              }
              /*z-index mobile pdp*/
              if($('#page').hasClass('pdp')) {
                  $('#header').css('z-index', '1001');
              }
              document.getElementById('header').classList.add('header--opend');
              document.getElementsByTagName('html')[0].classList.add('open-menu');
              document.getElementsByTagName('body')[0].classList.add('open-menu');
              document.getElementById('searchBar').style.display = 'block';
              document.getElementsByClassName('signInContainer')[0].style.display = 'flex';
              document.getElementById('shoppingCart').style.display = 'none';
             
            if(!isPersol){
                 document.getElementById('logo').style.display = 'none'; 
             }
            
             if(isPersol){ 
                document.getElementsByClassName('header_wishlist')[0].style.display = 'none'; 
             }
            
              $('#searchIcon').hide();
              $('#closeIcon').show();
              hideHeaderTimeout.cancel();
              
              //HB-17211
              if ((window.mobilecheck() || window.tabletPortraitCheck()) && pageType == 'Search'){
            	  $("#searchBar.header__search-wrapper").css("top","unset");
              }

              if ((window.mobilecheck() || window.tabletPortraitCheck()) && $("#Header_GlobalLogin").hasClass("opend")){
                $("#" + LOGINPANEL_ID + "_signInDropdown .panel .close-btn").click();
              }
          } else {
            closeMobileMenu();
          }
        var headerObj = $("#headerRow1 nav.nav");
        headerObj.attr("data-description",$(".nav__list.nav-menu").text().replace(/'/g,"\\'"));
        tealiumPushClickMenu(headerObj[0]);
      });
  }

  var navLink = document.getElementsByClassName('nav__link--phone');
  if (navLink.length > 0) {
      [].forEach.call(navLink, function (el) {
          el.addEventListener('click', function (event) {
              if (this.classList.contains('nav__link--opend')) {
                  this.classList.remove('nav__link--opend');
                 // document.getElementById("caroselOurWord").style.display = 'none';
              } else {
                  var navLength = navLink.length;
                  for (var i = 0; i < navLength; i++) {
                      navLink[i].classList.remove('nav__link--opend');
                  }
                  this.classList.add('nav__link--opend');
               //   document.getElementById("caroselOurWord").style.display = 'block';
              }
          });
      });
  }

  var menuCarousel = $('.submenu__carousel');
  if (menuCarousel.length > 0) {
      menuCarousel.owlCarousel();
  }

  var backButton = document.getElementsByClassName('submenu__back');
  if (backButton.length > 0) {
      [].forEach.call(backButton, function (el) {
          el.addEventListener('click', function (event) {
              var checkList = document.querySelectorAll('.submenu__list-item input');
              var checkListLength = checkList.length;
              for (var i = 0; i < checkListLength; i++) {
                  document.querySelector('.nav__list').classList.remove('nav_list--opend');
                  checkList[i].checked ? checkList[i].checked = false : '';
              }
             // document.querySelector('.header__first-login').classList.remove('header__first-login--opend');
          });
      });
  }

  var navInput = document.querySelectorAll('.submenu__list-item input');
  if (navInput.length > 0) {
      [].forEach.call(navInput, function (el) {
          el.addEventListener('click', function () {
              document.querySelector('.nav__list').classList.add('nav__list--opend');
            //document.querySelector('.header__first-login').classList.add('header__first-login--opend');
          });
      });
  }

  //   var navSearchIcon = document.querySelector('.header__search-icon');
  // var navSearchIcon = document.getElementById('searchIcon');
  // if (navSearchIcon !== null) {
  //     navSearchIcon.addEventListener('click', function() {
  //         var searchID = document.getElementById('searchBar');
  //         changeTabIndex($("#searchBox"));
  //         searchID.classList.contains('search--opend') ? searchID.classList.remove('search--opend') : searchID.classList.add('search--opend');
  //     });
  // }

  /**
   * Country selector:
   * Hide or show the country selector section.
   */
  var countrySelector = document.querySelector('.country-selected__wrapper');
  if (countrySelector) {
      countrySelector.addEventListener('click', function () {
          countrySelector.classList.toggle('--open');
      });
  }
  /**
      * Block for the Filters.
      */
  var facetFilter = document.getElementsByClassName('facet-sort');
  if (facetFilter.length > 0) {
      /*
      facetFilter = facetFilter[0];
      var windowScroll = window.scrollY;
      var top = facetFilter.offsetTop;
      var plp = document.getElementsByClassName('plp')[0];
      var sorting =  document.getElementsByClassName('sorting')[0];
      var wcSelectorSorting = document.getElementsByClassName('sorting__wc-selector')[0];

      window.onscroll = function() {
          windowScroll = window.scrollY;
          if (windowScroll >= top) {
              facetFilter.classList.add('facet--sticky');
              sorting.classList.add('sorting--sticky');
              plp.classList.add('plp--sticky');
              wcSelectorSorting.classList.add('sorting__wc-selector--sticky');
          } else {
              facetFilter.classList.remove('facet--sticky');
              sorting.classList.remove('sorting--sticky');
              plp.classList.remove('plp--sticky');
              wcSelectorSorting.classList.remove('sorting__wc-selector--sticky');
          }
      };
      window.onresize = function() {
          top = facetFilter.offsetTop;
      }
      var facetWidgetTitle = document.getElementsByClassName('facet__title-filter')[0];
      var facetWidget = document.getElementsByClassName('facet__widget')[0];
      facetWidgetTitle.addEventListener('click', function() {
          facetWidget.classList.contains('facet__widget--opend') ? facetWidget.classList.remove('facet__widget--opend') : facetWidget.classList.add('facet__widget--opend');
      });
      */

      var facetSubtitle = document.querySelectorAll('.facet__subtitle');
      if (facetSubtitle.length > 0) {
          [].forEach.call(facetSubtitle, function (el) {
              el.addEventListener('click', function () {
                  if (this.classList.contains('facet__subtitle--opend')) {
                      this.classList.remove('facet__subtitle--opend');
                  } else {
                      var facetSubtitleOpend = document.querySelectorAll('.facet__subtitle--opend');
                      var lengthFacet = facetSubtitleOpend.length;
                      if (lengthFacet > 0) {
                          for (var i = 0; i < lengthFacet; i++) {
                              facetSubtitleOpend[i].classList.remove('facet__subtitle--opend');
                          }
                      }
                      this.classList.add('facet__subtitle--opend');
                  }
              });
          });
      }
  }


  var sortBy = document.getElementsByClassName('sorting__dropdown');
  if (sortBy.length > 0) {
      sortBy[0].addEventListener('click', function () {
          console.log('click sortBy');
          var nameList = document.getElementsByClassName('sorting__list')[0];
          var sortWrapper = document.getElementsByClassName('sorting')[0];
          nameList.classList.contains('ui-selectmenu-button-open') ? sortWrapper.classList.add('sorting--open') : sortWrapper.classList.remove('sorting--open');
      });


      document.querySelector('body').addEventListener('click', function (e) {
          var sortingOpen = document.querySelector('.sorting__wc-selector');
          var sortWrapper = document.querySelector('.sorting')

          // If element .sorting__wc-selector exists
          // AND does not contain .ui-selectmenu-open
          // AND element .sorting contains .sorting--open
          // THEN we remove the class .sorting--open BECAUSE the combobox is closed
          if (sortingOpen && !sortingOpen.classList.contains('ui-selectmenu-open') && sortWrapper.classList.contains('sorting--open'))
              sortWrapper.classList.remove('sorting--open');
      });
  }

  var plpCarousel = $('.plp__other-product-carousel');
  var plpCarouselLength = plpCarousel.length;
  if (plpCarouselLength > 0) {
    //   $.each(plpCarousel, function (key, val) {
    //       $(this).owlCarousel({
    //           items: 3,
    //           pagination: false,
    //           navigation: true,
    //           navigationText: [
    //               "<button class='btn--owl-nav btn--owl-prev'></button>",
    //               "<button class='btn--owl-nav btn--owl-next'></button>"
    //           ],
    //           lazyLoad: true,
    //           addClassActive: true,
    //           rewindNav: false
    //       });
    //   })
  }

 
 

  /**
   * Country selector:
   * Hide or show the country selector section.
   */
  var countrySelector = document.querySelector('.country-selected__wrapper');
  if (countrySelector) {
      countrySelector.addEventListener('click', function () {
          countrySelector.classList.toggle('country-selected__wrapper--open');
          $("#footerWrapper").addClass("footer-pop-open");
      });
  }
});



function onSelectPLP(sel) {
  var str = sel.value;
  var url = window.location.href;
  var newUrl = "";
  var variable = "";
  var variable1 = "";
  var variable2 = "";
  var link = url.indexOf("?") >= 0 ? "&" : "?";

  if (url.indexOf("?orderBy=") >= 0) {
      variable = window.location.href.slice(0, window.location.href.indexOf('?orderBy='));
      variable1 = url.split("?orderBy=");
      variable2 = variable1[1];
      variable2 = variable2.slice(1);
      newUrl = variable + "?orderBy=" + str + variable2;
  } else if (url.indexOf("&orderBy=") >= 0) {
      variable = window.location.href.slice(0, window.location.href.indexOf('&orderBy='));
      variable1 = url.split("&orderBy=");
      variable2 = variable1[1];
      variable2 = variable2.slice(1);
      newUrl = variable + "&orderBy=" + str + variable2;
  } else {
      newUrl = window.location.href + link + "orderBy=" + str;
  }

  window.location.href = newUrl;
}


// Daniel Rilo - END - CREV NERD-569



/**
* Daniel Rilo -BEGIN - WCAG
*/
window.addEventListener('load', function () {
  // Add title to he iFrame without this attribute
  document.querySelectorAll('iframe').forEach(function (el, index) {
      if (el.title === '') {
          el.title = 'iFrame number ' + index;
      }
  });
})
/**
* Daniel Rilo -END - WCAG
*/

$(document).ready(function () {
  /**
   * @desc When you click on the "NEWSLETTER" link (in the footer), the "Newsletter" section show/hide.
   * @summary Show/hide Newsletter
   * @author Daniel Rilo
   */
  var btnNewsletterShowHide = document.querySelector('#sxShowNewsletter');
  if (btnNewsletterShowHide) {
      btnNewsletterShowHide.addEventListener('click', function (e) {
          e.preventDefault();

          var newsletterSection = document.querySelector('#newsLetterForm');
          newsletterSection ? newsletterSection.classList.toggle('opend') : '';
      })
  }

  var signInImg = document.querySelector('.signInRegistration__wrapper--left');
  if (signInImg) {
      signInImg.children.length < 1 ? signInImg.classList.add('signInRegistration__wrapper--hide') : '';
  }

  /**
   * @desc When you click on the Cross button, the pop up must hidden.
   * @summary Show/hide Popup
   * @author Daniel Rilo
   */
  var firstSignInPopupCloseCross = document.querySelector(".first-session__button-a");
  if (firstSignInPopupCloseCross) {
      addClosePopupSignIn(firstSignInPopupCloseCross);
  }

  /**
   * @desc When you click on the SHOP NOW button, the pop up must hidden.
   * @summary Show/hide Popup
   * @author Daniel Rilo
   */
  var firstSignInPopupCloseBtn = document.querySelector(".first-session__shop-button");
  if (firstSignInPopupCloseBtn) {
      addClosePopupSignIn(firstSignInPopupCloseBtn);
  }

  if((pageType == 'Plp' || pageType=='Static') && !(window.mobilecheck() || window.tabletPortraitCheck())) {
      mapMenuAndUnderline();
  } 
  
});


function mapMenuAndUnderline() {
  var allLinksSun = $('[data-espot-name="X_Header_NavSunglasses_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksEye = $('[data-espot-name="X_Header_NavEyeglasses_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksCollection = $('[data-espot-name="X_Header_NavCollections_Left"] a').map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();

  var allLinksOurWorld = $("#X_Header_NavOurWorld_RightCards a").map( function() {
      return $(this).attr('href').split('/').pop();
  }).get();
  

  var currentPage = window.location.pathname.split('/').pop();

  if(allLinksSun.indexOf(currentPage) != -1) {
     $('[data-element-id="X_X_MainNav_Sun"]').addClass('underline');
  }
  else if (allLinksEye.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_Optical"]').addClass('underline');
  }
  else if (allLinksCollection.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_Collection"]').addClass('underline');
  }    
  else if (allLinksOurWorld.indexOf(currentPage) != -1) {
      $('[data-element-id="X_X_MainNav_World"]').addClass('underline');
  }    
}

/**
* @function addClosePopupSignIn
* @param {HTML object} item Object where I'll add the 'click' listener.
* @desc Add an Event Listener to a given HTML Object
* @summary Add Close Listener
* @author Daniel Rilo
*/
function addClosePopupSignIn(item) {
  item.addEventListener('click', function() {
      var firstSignInPopupCloseCross = document.querySelector(".first-session");
      if (firstSignInPopupCloseCross) {
          firstSignInPopupCloseCross.remove()
          noScrollFirstLogin(false);
      }
  });
}

/**
* This function keeps accesible the privacy policy link on the newsletter form input once it loses the focus.
*/
$(function(){
  $('#newsletterPolicy').focus(function(){
      $('#newsletterEmail').addClass('focus');
  })
  $('#newsletterPolicy').blur(function(){
      $('#newsletterEmail').removeClass('focus');
  })
});

/**
* Show/hide password in registration form
*/
$(document).ready(function () {
  var buttonShowPassword = document.querySelectorAll('.btn-show-hide-password');
  if (!buttonShowPassword) return false;
  buttonShowPassword.forEach(function(el) {
      el.addEventListener('click', function(e) {
          e.preventDefault();
          showHidePassword(this);
      });

      el.addEventListener('keyup', function(e) {
          if (e.keyCode == 13) showHidePassword(this);
      });
  });
});

/**
* Create sign in pop-up.
*/
$(document).ready(function () {
  $('.have_an_account').on('click', '.shipping_sign_in',function(e){
      e.preventDefault();
      e.stopPropagation();
      var signInPopUp = $(this).parent().find('#sign_in_popUp');
      if (signInPopUp.length > 0) {
          if($(window).width() < 1024) {
              signInPopUp.dialog({
                  modal: true,
                  classes: {
                      "ui-dialog": "checkout-sign-in-popup"
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: '100%',
                  position: 'bottom',
                  maxWidth: tabletWidth,
                  fluid: true,
                  resizable: false,
                  close: function () {
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                      $('body').removeClass('no-scroll');
                      $('body, html').css('height', 'auto');
                      $('body, html').css('overflow', 'visible');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                      $('body').addClass('no-scroll');
                      $('body, html').css('height', '100%');
                      $('body, html').css('overflow', 'hidden');
                      $('.checkout-sign-in-popup .ui-dialog-titlebar-close').attr('aria-label','Close button');
                  }
              });
          } else {
              signInPopUp.dialog({
                  modal: false,
                  classes: {
                      "ui-dialog": "checkout-sign-in-popup"
                  },
                  draggable: false,
                  closeText: "",
                  height: 'auto',
                  width: 'auto',
                  maxWidth: tabletWidth,
                  fluid: true,
                  resizable: false,
                  close: function () {
                      $('.ui-widget-overlay').removeClass('custom-overlay');
                      $('body').removeAttr('style');
                      $('body').removeClass('no-scroll');
                  },
                  open: function () {
                      $('.ui-widget-overlay').addClass('custom-overlay');
                      $('body').css('position', 'relative');
                      $('body').addClass('no-scroll');
                      $('.checkout-sign-in-popup .ui-dialog-titlebar-close').attr('aria-label','Close button');
                  }
              });
          }
      } else {
          var checkoutSignInPopUp = $('.checkout-sign-in-popup').find('#sign_in_popUp');
          if (checkoutSignInPopUp.length > 0) {
              checkoutSignInPopUp.dialog('open');
          }
      }
  });
});

function showHidePassword(elem) {
  var inputType = elem.parentNode.querySelector('input');

  if (!inputType) return false;

  var imgType = elem.parentNode.querySelector('a img');
  var imgName = '';

  if (inputType.getAttribute('type') === 'text') {
      inputType.setAttribute('type', 'password');
      imgName = 'view.svg';
  } else {
      inputType.setAttribute('type', 'text');
      imgName = 'view-strike.svg';
  }

  imgType.src = imgType.src.substring(0, imgType.src.indexOf('view')) + imgName;
}

function noScrollFirstLogin(show) {
  show ? document.querySelector('body').classList.add('no-scroll') : document.querySelector('body').classList.remove('no-scroll');
}

/***
* Error Message
*/
displayLoginErrorMessage = function() {
  var loginError = $('.login-error');
  if (loginError.length > 0) {
      loginError.find('.myaccount_error').text(MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"]);
  }
};


/* START NEW PDP */
function insertCurrentGlassInOtherColors() {
  //TODO: CHECK IF THERE IS IMAGE
var url1 = $.parseJSON($('[id^="entitledItem_"]')[0].innerText)[0].ItemThumbnailImage + "&bgcolor=ffffff";
  var img1 = $('#productMainImage')[0].outerHTML;
  var url = $('#productMainImage')[0].src.replace("f8f8fb", "e3e3f0");
  var img2 = "<img class='image--hover' src=" + url + ">";
  var imgs = img1 + img2;
  $("#current-glass .img-container").html(imgs);

}



function createMiniature () {
  $("#persol_popup-images-carousel img[data-thumbnail]").each(function(index){
          var item = $("#persol_popup-images-carousel .owl-pagination .owl-page span")[index];
          var img = "<img src='" + $(this).data("thumbnail") + "' alt='" + $(this).attr("alt") + "' title='" + $(this).attr("title") + "' />"
          $(item).html(img)
      }
  )
}

handleSize = function(){
  if(window.mobilecheck() || window.tabletPortraitCheck()) {
      $('.size-option-selected').on('click',function(e){
          $('.bottom-scrollable-section').css('z-index', "1000");
         $("html").toggleClass("overflow-hidden"); 
          $("#page").addClass("hidden-scroll-body");
          e.stopPropagation();

          $('.modal-background').slideDown(0);
          manageScrollOverlay(true);
      })

      $('.definingAttributes .modal-background').on('click',function(e) {
          if(e.target.classList.contains('modal-background') && typeof closeSize === 'function') {
              closeSize();
          }
      })
  } else {
      $('.size-option-selected').on('click',function(e){

          $('.modal-background').toggle('hide');
          e.stopPropagation();
          if($('.modal-background').is(':visible')){
              managePopupTabIndex('.size-option-div', true);
          }

          for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
              if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                  $('#presc--side--button a[data-element-id="X_Pdp_Prod_AddLens"]').attr('data-prescription',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                  break;
              }
          }

      })
      /*$(window).on('click', function(e){
          if(e.target !== $('.size-option-div') && e.target !== $('.size-option-div li.size-options')){
              $('.modal-background').toggle('hide');
              $(window).off( "click")
          }
      })*/
  }
}

/* Show default payment placement */
/* PDP called function: #11
* prev function: setInventoryMapEntry()
* next function:  ()
*/
function showDefaultPaymentPlacement(payment) {
  var defaultPaymentPlacementCookie = getCookie("defaultPaymentPlacement");
  if (defaultPaymentPlacementCookie != undefined && defaultPaymentPlacementCookie != ""){
      payment = defaultPaymentPlacementCookie;
  }
  if (payment == ""){
      if (klarnaEnabled == 'true'){
          showKlarnaPlacements();
      } else if (affirmEnabled == 'true'){
          $('.pdp .affirm').show();
          $(".checkout__affirm").show();
      }
  } else {
      if (payment == 'klarna'){
          showKlarnaPlacements();
      } else if (payment == 'affirm'){
          $('.pdp .affirm').show();
          $(".checkout__affirm").show();
      }
  }
}

function initAccessibility(){
  //accessibility screen reader
  $('#owl-pdp .owl-item').attr('aria-selected','false');
  $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}

function manageAccessibility(){
   // apply meta info to next and previous buttons and make them focusable
  //  $('#owl-pdp').attr('role', 'carousel');
   $('#owl-pdp .owl-item.active .popup_link').attr('tabindex','0');
   $('#owl-pdp .owl-item').attr('aria-selected','false');
   $('#owl-pdp .owl-item.active').attr('aria-selected','true');
   $('#owl-pdp .owl-pagination .owl-page').attr('role','button').attr('tabindex','0');
   $('#owl-pdp .owl-pagination .owl-page.active') .attr('title','Active Slide')
   $('#owl-pdp .owl-pagination .owl-page').on('keydown', function(e){
       if(e.keyCode == 13){
           var slideToGO = parseFloat($(this).children('.owl-numbers').html());
           $("#owl-pdp").data('owlCarousel').goTo(slideToGO - 1);
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).focus().attr('title','Active Slide')
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO]).attr('title','Next Slide');
           $($('#owl-pdp .owl-pagination .owl-page')[slideToGO - 2]).attr('title','Prev Slide');
       }

   })

   $('#owl-pdp .owl-item').attr('aria-selected','false');
   $('#owl-pdp .owl-item.active').attr('aria-selected','true');
}


$(document).ready(function(){
  // if page is pdp on orientation change trigger page reload
  if($('#page').hasClass('pdp')){ 
      /*
      //START Early Access
      $('.prices-container #listPrice_' + parentCatId.uniqueID).addClass('hidden-price');
      $('.prices-container #offerPrice_' + parentCatId.uniqueID).addClass('hidden-price');
      //END Early Access
      */
      window.addEventListener("orientationchange", function() {
          location.reload();
          }, false);

          
      var otherColors = $(".catalog-entry-recommendation-widget.other_colors").children(".catalogEntryRecommendationWidget");
      if(otherColors.length === 0){
          $(".catalog-entry-recommendation-widget.other_colors").addClass("other-colors-empty");
      }

      

  }

  // var zIndexSlot3 = $('.slot3').css('z-index');
  $(document).off("click", "#owl-pdp .popup_link").on("click", "#owl-pdp .popup_link", function(){
      //aumento z-index per nascondere le nav in sticky
      // $('.slot3').css('z-index', '6');
      $("html").addClass("overflow-hidden");
      $("#page-overflow-wrapper").addClass("overflow-hidden");
  $('.col12.slot3').css('position','relative');
      if($(this).attr("data-index") !== 0 || $(this).attr("data-index") !== "0")
          $("#persol_popup-images-carousel").trigger('owl.goTo', [$(this).attr("data-index")]);

      var len = $("#persol_popup-images-carousel [id^='lens-magnifier_']").length;
      var windowWidth = window.innerWidth;
      var zoomLevel = 1.5;
      if (windowWidth > 1600){
          zoomLevel = 1.8;
      }
      if(!(window.mobilecheck() || tabletPortraitCheck() )){
          for (var i = 0; i < len; i++) {
              $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").mlens({
                  imgSrc: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-big"),      // path of the hi-res version of the image
                  imgSrc2x: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-big2x"),  // path of the hi-res @2x version of the image
                  lensShape: "circle",                // shape of the lens (circle/square)
                  lensSize: ["256px","256px"],            // lens dimensions (in px or in % with respect to image dimensions)
                  borderSize: 1,                  // size of the lens border (in px)
                  borderColor: "#bfbfbf",            // color of the lens border (#hex)
                  borderRadius: 0,                // border radius (optional, only if the shape is square)
                  imgOverlay: $("#persol_popup-images-carousel #lens-magnifier_" + i + " img").attr("data-overlay"), // path of the overlay image (optional)
                  overlayAdapt: true,    // true if the overlay image has to adapt to the lens size (boolean)
                  zoomLevel: zoomLevel,          // zoom level multiplicator (number)
                  responsive: true       // true if mlens has to be responsive (boolean)
              });
              $("#mlens_wrapper_" + i).css('position', 'relative');
          }
      }

      togglePopupCarosel(true);
  });

  $("#persol_popup-images .closeButton").click(function(){
      // $('.slot3').css('z-index', '1');
      $("html").removeClass("overflow-hidden");
      $("#page-overflow-wrapper").removeClass("overflow-hidden");
      $('.col12.slot3').css('position','');
      togglePopupCarosel(false);
      manageScrollOverlay(false);
  })

  handleSize();
//   if(window.mobilecheck() || window.tabletPortraitCheck() ){
//       $('.slot4').next().css('visibility', 'hidden')
//   }

  //variables for scroll mobile
  // lazyLoading();

  $(".promo-callout .close-icon").click(function(){
      $(".promo-callout").hide();
      setCookie('promoCalloutCookie', true, {expires: 1} )
  })

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      $('body').on('wheel', function(event) {
          if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20){
              $('.slot3').slideDown({
                  duration:300,
                  complete:function(){
                          stickyBottomDesktop();
                          $(window).scrollTop(0);
                      }
                  });
          }
      });

      $('body').on('wheel', function(event) {
          if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20 && $('.slot3').is(":visible")){
            if(!$('#page').hasClass('pdp')){
                hideHeaderTimeout.showHeader();
            }
          }
      });
  } else {
      if (!$("#image-soldOut").is(":visible")) {
          //calcolo altezza img centrale
          if( $('.slot3 .full-image-widget').hasClass('other-colors-empty')){
              $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight() );
          } else{
              //$('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight()  - $('.other_colors').outerHeight());
          }
      }
  }

  $('.you_might_also_like .product').on('click', function(){
      var url = $(this).find('a.product__image-link')[0];
      window.location.href = $(url).attr("href")
  })

  var currentImgUrl = null;
  var currentColors = null;
  var currentBadges = null;
  var currentOfferPrice;
  var currentOldPrice;
  var isCaseSlide = false;
  var currentOfferPriceNumber;
  var currentOldPriceNumber;

  //On mouse enter...
  $(document).on('mouseenter','#other_colors .other-colors-desktop .product:not(.active)', function(e) {
    //pdp offer and list price
      currentOfferPrice = window.productDisplayJS.itemPriceJsonOject[window.productDisplayJS.changedCatEntryId]['catalogEntry'].offerPrice;
      currentOldPrice = window.productDisplayJS.itemPriceJsonOject[window.productDisplayJS.changedCatEntryId]['catalogEntry'].listPrice;

      currentOfferPriceNumber = parseFloat(currentOfferPrice.replace(/[^0-9\.-]+/g,""));
      currentOldPriceNumber = parseFloat(currentOldPrice.replace(/[^0-9\.-]+/g,""));

      if(isNaN(currentOldPriceNumber)) { 
          //prendilo da FE
          if($(".namePartPriceContainer .list-price").length >0) {
              currentOldPrice =$(".namePartPriceContainer .list-price")[0].innerHTML;
              currentOldPriceNumber = parseFloat(WCCurrencyJS.format(currentOldPrice)).toFixed(2);
          }
      }

      currentColors = $(".current-product-colors").html();
      var infos = $(this).find(".attr--list span");
      var colorsToPrint = ""
      var colorsToPrintDiv = "<div class='product-colors frameProduct'>"
      var subtitleToPrint = ""
      $(infos).each(function(index){

          if($(this).hasClass('frameFitSpan')|| $(this).hasClass('polarized-span')) {
              subtitleToPrint += $(this).html();
          }
         // if((index == 1 || index == 3)) {
             //  if((!$(this).hasClass('frameFitSpan')|| $(this).hasClass('polarized-span'))){

                  if($(this).hasClass('front-color-value')){
                      colorsToPrint += $(this).html();
                      colorsToPrintDiv +=  $(this).html();
                  }else if($(this).hasClass('lens-color-value')){
                      colorsToPrint += " /";
                      colorsToPrintDiv += " /";
                      colorsToPrintDiv += $(this).html();
                      colorsToPrintDiv += "</div>";
                  }
                      
            //  }
         // }
      });
      if(!colorsToPrintDiv.includes('</div>')){//for eyeglasses 
          colorsToPrintDiv += '</div>'
      }
      if(subtitleToPrint != "<div class='sizeAndFitContainer'>"){//there are no attributes of geo fit frame fit and polarised
          subtitleToPrint += '</div>';
          $(".current-product-colors").html(colorsToPrintDiv + subtitleToPrint );
      }else{
          $(".current-product-colors").html(colorsToPrint);
      }

      

      //init badge
      if($(".long-description-widget .badge-container").length > 0){
          currentBadges = $(".long-description-widget .badge-container").html();
          if($(this).find(".badge--list").length > 0){
              var badges = $(this).find(".badge--list").html();
              $(".long-description-widget .badge-container").html(badges);
          }
      }
      //finish badge

      //var productID =  $(this).find('.catalog__image--front').attr('data-partNumber');
      //var urlOfferPrice = '/wcs/resources/store/' + WCParamJS.storeId + '/price?q=byPartNumbers&partNumber=' + productID;
      
      var catEntryID =  $(this).find('.catalog__image--front').attr('data-catalogEntryID');
      var urlOldPrice  = '/wcs/resources/store/' + WCParamJS.storeId + '/display_price?q=byCatalogEntryIdsAndPriceRuleName&catalogEntryId=' + catEntryID; //prezzo barrato

      // q=byCatalogEntryIdsAndPriceRuleName&catalogEntryId=3074457345616683669&currency=USD&checkEntitlement=false&timestamp=1589464328709
      var srcUrl = $(this).find('.catalog__image--front').attr('data-src-hover');
      var imgHover = "<img src='" + srcUrl + "' style='margin-top:"+longDescriptionWidgetMarginTop+"px'/>"
      currentImgUrl = $('.full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper').html();
      if($('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').hasClass('case')){
          $('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').removeClass('case');
          isCaseSlide = true;
      }
      $('.full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper').html(imgHover);

      //mouseover item offer and list price
      var offerPriceItem = '';
      var oldPriceItem = '';

      //START Early Access    
      offerPriceItem =  $(this).data('price');;
      //END Early Access

      if(this.getElementsByClassName('list-price').length > 0)
          oldPriceItem = WCCurrencyJS.unformat(this.getElementsByClassName('list-price')[0].innerText);

      if(offerPriceItem){
          $(".namePartPriceContainer .offer-price").html(WCCurrencyJS.format(offerPriceItem));
          if(oldPriceItem) {
              $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(oldPriceItem));
              if(oldPriceItem > offerPriceItem){
                  $(".namePartPriceContainer .list-price").show();
                  updatePriceInDiscountBadge(oldPriceItem,offerPriceItem);
              }
              else {
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }
          }
          else {// provo a interrogare il solr
              $.ajax({
                  url: urlOldPrice,
                  dataType: "json"}
              ).then(function(dataOld){
                  if (isEcommerceStoreJS === 'TRUE'
                      && dataOld !== undefined && dataOld[0].resultList !== undefined
                      && dataOld[0].resultList[0] !== undefined && dataOld[0].resultList[0].unitPrice !== undefined
                      && dataOld[0].resultList[0].unitPrice[0].price !== undefined &&  dataOld[0].resultList[0].unitPrice[0].price.value
                      ) {
                          oldPriceItem = parseFloat(dataOld[0].resultList[0].unitPrice);
                      }
                      if(oldPriceItem) {
                          $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(oldPriceItem));
                          if(oldPriceItem > offerPriceItem){
                              $(".namePartPriceContainer .list-price").show();
                              updatePriceInDiscountBadge(oldPriceItem,offerPriceItem);
                          }
                          else{ 
                              $(".namePartPriceContainer .list-price").hide();
                              $('#X_PDP_Hero__PromoBadge').addClass("hidden");
                          }
                      }
                      else {
                          $(".namePartPriceContainer .list-price").html("");
                          $(".namePartPriceContainer .list-price").hide();
                          $('#X_PDP_Hero__PromoBadge').addClass("hidden");
                      }
              }, function(){
                  console.log('error');
          })
          }
      } else {
          $(".namePartPriceContainer .offer-price").html(MESSAGE_NO_PRICE_AVAILABLE)
          $(".namePartPriceContainer .list-price").hide();
          $('#X_PDP_Hero__PromoBadge').addClass("hidden");
      }
  });

 $(document).on('mouseleave', '.other_colors .other-colors-desktop .product:not(.active)', function(e) {
    //On mouse leave...
    if(isCaseSlide){
          $('.full-image-widget #slick-pdp .slick-slide.slick-active .popup_link').addClass('case')
      }
      $(".full-image-widget #slick-pdp .slick-slide.slick-active .owl-pdp__image-wrapper").html(currentImgUrl);
      $(".current-product-colors").html(currentColors);
      if($(".long-description-widget .badge-container").length > 0){
        $(".long-description-widget .badge-container").html(currentBadges);
      }

      //restore base price
      var prescriptionPrice = $('.namePartPriceContainer .offer-price').attr('data-prescription-price')
      if(prescriptionPrice !== undefined && prescriptionPrice != "") {
          $(".namePartPriceContainer .offer-price").html(WCCurrencyJS.format(prescriptionPrice))

          var prescriptionPriceOld = $('.namePartPriceContainer .list-price').attr('data-prescription-price')
          if(prescriptionPriceOld !== undefined && prescriptionPriceOld != "" && $(".namePartPriceContainer .list-price").length > 0){
              $(".namePartPriceContainer .list-price").html(WCCurrencyJS.format(prescriptionPriceOld))
              if(prescriptionPriceOld > prescriptionPrice){
                  $(".namePartPriceContainer .list-price").show();
                  updatePriceInDiscountBadge(WCCurrencyJS.unformat(prescriptionPriceOld),WCCurrencyJS.unformat(prescriptionPrice));
              }
              else{
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }

          }
      } else {
          if(currentOfferPrice){
              $('.namePartPriceContainer .offer-price').html(currentOfferPrice);
              if(currentOfferPrice !== currentOldPrice && $('.namePartPriceContainer .list-price').length > 0) {
                  $('.namePartPriceContainer .list-price').html(currentOldPrice);
                  $(".namePartPriceContainer .list-price").show(); 
                  updatePriceInDiscountBadge(WCCurrencyJS.unformat(currentOldPrice),WCCurrencyJS.unformat(currentOfferPrice));
              }
              else {
                  $(".namePartPriceContainer .list-price").hide();
                  $('#X_PDP_Hero__PromoBadge').addClass("hidden");
              }
          } else {
              $(".namePartPriceContainer .offer-price").html(MESSAGE_NO_PRICE_AVAILABLE)
          }
      }
      //START Early Access
      if (window.lastOfferPrice != ""
            && $('.namePartPriceContainer .offer-price').length > 0){
          $('.namePartPriceContainer .offer-price')[0].innerText = window.lastOfferPrice;
      } else replacePDPMainPrice(catEntryIdSubscribe);
      //END Early Access
  });

})



var isFirstTime = true;
var endSlider;
var startSlider;
function setStickyProductDetailsNavbar() {
  if(!$('.slot3').is(':visible')){
      if(isFirstTime) {
          startSlider = Math.round($(".product-details-slider").position().top);
          endSlider = Math.round($(".product-details-slider").height() + $(".product-details-slider").position().top);
          isFirstTime = false;
      }

      var tabHeight = 40;
      var heightBlackBar = $(".slot4.fixed-navbar").height();
      if((window.pageYOffset + heightBlackBar) > (startSlider) && (window.pageYOffset + heightBlackBar) < (endSlider - tabHeight)){
          //$("#tab-products-details").addClass("sticky-bar");
          $('.slot5').css('padding-top', $('.tab-bar').height() +'px');
      } else {
          $("#tab-products-details").removeClass("sticky-bar");
          $('.slot5').css('padding-top', 0);
      }
  }
  if($('.slot3').is(':visible')) {
      //$("#tab-products-details").removeClass("sticky-bar");
      $('.slot5').css('padding-top', 0);
  }
}

//editorial JS
  animationInit = function () {
    if ($('#page').hasClass('pdp')){
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            window.onscroll = function() {
               // var header = $('.slot4.fixed-navbar').get(0);
               // var positionSticky = header.offsetTop;
                //var slide = $('.slot3');
                //setStickyHeader(header, positionSticky, slide)
                setCtabarStickyDesktop();
                //event.preventDefault();
                //event.stopPropagation();
                //setStickyProductDetailsNavbar();
            }
        } else {
            //$('.slot4 .defining-attributes-widget').css('height', '0' );
            //window.addEventListener('scroll', animationScroll);
        }
      }
 }


function setStickyHeader (header, positionSticky, slide) {
  var st = window.pageYOffset || document.documentElement.scrollTop;

  if (st >= 20 && st > window.lastScrollTopBarAnimation && window.isFirstScrollStickyBar && !$('.shopperActions--monogram--pop-up').is(':visible')) {
      if($('#page').find('.ct-promo-bannerTop').length) {
          $('#bannerTop').slideUp();
      }
    //   $('#header').slideUp();
      $('[aria-describedby="quick_cart_container"]').hide();
      $('.freeShipping').slideUp();
      $('.long-description-widget').fadeOut();
      $('.bottom-section').css("bottom","auto");
      $('.col12.slot4.fixed-navbar.tall-bottom--mobile.fixed-bottom.sticky-bottom').css("bottom","auto");

      $("#tab-products-details").addClass("sticky-bar");

      $('.slot3').slideUp({
          duration:300,
          complete:function(){
              stickyTopDesktop();
              $(window).scrollTop(21);
          }
      });
      // if(!$(header).hasClass("sticky-top") && st >= scrollTopLimit){
      //     stickyTopDesktop();
      // }

  } else if(st < window.lastScrollTopBarAnimation && !$('.shopperActions--monogram--pop-up').is(':visible')) {
      if(!$('.slot3').is('visible') && st < 20){
          $('.slot3').slideDown({
              duration:300,
              complete:function(){
                  stickyBottomDesktop();
                  $(window).scrollTop(0);
                  }
              });
          $('.col12.slot4.fixed-navbar.tall-bottom--mobile.fixed-bottom.sticky-bottom').css("bottom","0px");
        $('.bottom-section').css("bottom","0px");
      }
  }

  window.lastScrollTopBarAnimation = st <= 20 ? 1 : st
}

function goBackToTopMobile () {
  $(window).scrollTop(0);
  hideHeaderTimeout.showHeader();
}

function createTopRecap(){
  $("#add2CartBtnNavBar").appendTo( "#fixed-top--mobile .cta-buttons" ).show();
  if($("#add2CartBtnDisabled").is(":visible")) $("#add2CartBtnNavBar").addClass('disabled')
  var url = 'https://assets.persol.com/is/image/Persol/8056597315685_000A.png?bgcolor=%23f7f7f7&impolicy=HB_parameters&wid=290&cropnorth=-7&cropsouth=-8';
  $("#fixed-top--mobile .navbar-product .product-image img").attr("src",url);
  $("#fixed-top--mobile .navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopMobile)
  var prodName = $(".long-description-widget .persol-product-title").html();
  $("#fixed-top--mobile .navbar-product .product-name").html(prodName);
}

var firstTime = true;
function animationScroll(){
  if(parseInt($('#header').css('z-index')) > parseInt($('.bottom-scrollable-section').css('z-index')) && $("#MiniShopCartProductAdded").length === 0) {
      $('#header').css('z-index', '5')
  }
  if($("#fixed-top--mobile .navbar-product .product-price").html().length == 0){
      $("#fixed-top--mobile .navbar-product .product-price").html($(".prices-container .offer-price").html());
  }
  var st = $(window).scrollTop();
  var scroll = st + $("#fixed-top--mobile").height();
  event.preventDefault();
  event.stopPropagation();

  if($("#fixed-top--mobile").hasClass("animation-show") && firstTime) {
      window.productDetailTop = $('.slot5').offset().top;
      window.endSlider = parseInt($("#product-detail-carousel").height() + $('.slot5').offset().top);
      firstTime = false
  }

  if (st > window.lastScrollTopMobile){
      if( st < window.heightHiddenActions ){
          $('.slot4 .defining-attributes-widget').outerHeight(st);
      }
      if(st >= window.heightHiddenActions){
          $('.slot4 .defining-attributes-widget').outerHeight(window.heightHiddenActions);
          $('.slot4').next().css('visibility', 'visible');
      }

      var windowHeight;
      if(isSafari()){
        windowHeight = window.innerHeight-100;
      }else{
        windowHeight = window.innerHeight;
      }

      if (st >= windowHeight){
          $("#fixed-top--mobile .navbar-product .product-name").show()
          $('#fixed-top--mobile').addClass('animation-show');
      }

      //fisso la barra product detail se è presente
      if($('.slot5').length > 0){

          if(scroll >= window.productDetailTop && scroll < window.endSlider){
              $("#tab-products-details").addClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
              //$('#product-detail-carousel').css('padding-top', $('#tab-products-details').height() +'px');
          } else{
              $("#tab-products-details").removeClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
          }
      }

  } else if( st < window.lastScrollTopMobile ) {
       // upscroll code
      if($('.slot5').length > 0){

          if(scroll >= window.productDetailTop && scroll < window.endSlider){
              $("#tab-products-details").addClass("sticky-bar");
              $('#product-detail-carousel').css('padding-top', '0');
          } else {
              $('#product-detail-carousel').css('padding-top', '0');
              $("#tab-products-details").removeClass("sticky-bar");
          }
      }

      if(st <= window.innerHeight){
          $("#fixed-top--mobile .navbar-product .product-name").hide()
          $('#fixed-top--mobile').removeClass('animation-show');
      }
      if(st <= window.heightHiddenActions ){
          $('.slot4').next().css('visibility', 'hidden');
          $('.slot4 .defining-attributes-widget').css('height', 0);
          hideHeaderTimeout.showHeader();
      }
  }
      window.lastScrollTopMobile = st <= 0 ? 0 : st;
}
function pinchZoom(){
  // if(window.mobilecheck() || window.tabletPortraitCheck()){
      $("#persol_popup-images-carousel .owl-item img").swipe( {
        pinchStatus:function(event, phase, direction, distance , duration , fingerCount, pinchZoom) {
          if(fingerCount >= 2){
              event.stopPropagation();
          }
          console.log("Pinch zoom scale "+pinchZoom +"Distance pinched "+distance+"Direction " + direction);
          $(this).css('transform', 'scale('+ pinchZoom +')');
          $('#persol_popup-images-carousel .owl-carousel .owl-wrapper-outer').css('overflow', 'visible')
        },
        fingers:2,
        pinchThreshold:0
      });
  // }
}
function stickyTopDesktop(){
  window.isFirstScrollStickyBar = false;
  var header = $('.slot4').get(0);
  //$(header).removeClass("sticky-bottom");
  $(header).addClass("sticky-top");
  $("#add2CartBtn").attr("data-element-id", "X_Pdp_Stickybar_AddCart")
  $(".estimated").hide();
  $(".navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopDesktop)
  var prodName = $(".long-description-widget .persol-product-title").html();
  var link = "<a>"+ $(".current-product-colors .product-colors").html().trim() +"</a>";
  $(".navbar-product .product-name").html(prodName);
  $(".navbar-product .product-colors").html(link);
  $(".navbar-placeholder").addClass("fixed-top-navbar");
  $(".bottom-section").addClass("fixed-top-navbar");
  $('.catalog-entry-recommendation-widget.other_colors').hide();/*wcag reason*/
  $('.navbar-product .product-image').focus();
}

function stickyBottomDesktop() {
  window.isFirstScrollStickyBar = true;
  var header = $('.slot4').get(0);
  $(header).removeClass("sticky-top");
  // if(!$("#add2CartBtnDisabled").is(':visible')){
      $(".estimated").show();
  $(header).addClass("sticky-bottom");
  $('.long-description-widget').show();
  $('.catalog-entry-recommendation-widget.other_colors').show();/*wcag reason*/
  $("#add2CartBtn").attr("data-element-id", "X_Pdp_Prod_AddCart")
  if(!$('#page').hasClass('pdp')) hideHeaderTimeout.showHeader();
  $(".navbar-placeholder").removeClass("fixed-top-navbar");
  $(".bottom-section").removeClass("fixed-top-navbar");
}

function goBackToTopDesktop(){
  $('.slot3').slideDown({
      duration:300,
      complete:function(){
          $(window).scrollTop(0);
          stickyBottomDesktop();
      }
  });
}

var hideHeaderTimeout = {

  hideHeader: function() {
      /*
      if($('[productAdded=yes]').length < 1){
          if($('#page').find('.ct-promo-bannerTop').length) {
              $('#bannerTop').slideUp();
          }
          $('#header').slideUp({
            complete:function(){
                setHeightFullImage(false)
            }
        })
        $('.freeShipping').slideUp()
        this.timeoutID = undefined;
    }
    */
  },

  showHeader: function() {
      if($('#page').find('.ct-promo-bannerTop').length) {
          $('#bannerTop').slideDown();
      }
      $("#header").slideDown({
          complete:function(){
              setHeightFullImage(true)
          }
      });
      $('.freeShipping').slideDown()
      this.setup();
  },

  setup: function() {
    if (window.mobilecheck() || window.tabletPortraitCheck()){
      if (typeof this.timeoutID === 'number') {
          this.cancel();
      }
      this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);
    }
  },/*
  setup: function() {

    if (typeof this.timeoutID === 'number') {

        this.cancel();

    }

    this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);

},*/

  cancel: function() {
      window.clearTimeout(this.timeoutID);
  }
}

//wcag close popup pressing escape
$(document).keyup(function (e) {
  if (e.key === "Escape") {
      if ($('.presc').hasClass('showed-presc')) {
          $('#close-prescriptions').click();
      }
      if ($('.op-pdp-popup-other-colors').hasClass("active")) {
          togglePopupOtherColors(false);
      }
      if ($('.modal-background').is(':visible')) {
          $('.modal-background').toggle('hide');
      }
      if ($('#persol_popup-images').is(':visible')) {
        $("html").removeClass("overflow-hidden");
        $("#page-overflow-wrapper").removeClass("overflow-hidden");
    $('.col12.slot3').css('position','fixed');
        togglePopupCarosel(false);
      }
      if ($('.shopperActions--monogram--pop-up').is(':visible')) {
         $('#close-monogram').click();
      }
  }
});


// ON load risposto al top
window.addEventListener('load',function(){

  if ($('#page').hasClass('pdp')){

      setTimeout(function(){
          // scrollTo(0,-1);
          calculateDistances();
          // if(window.mobilecheck()|| window.tabletPortraitCheck()){
          handleSwipeBounce();
          // }
      },0);

      window.zIndexBS = $('.bottom-scrollable-section').css('z-index');
      hideHeaderTimeout.setup();

      if(!(window.mobilecheck()|| window.tabletPortraitCheck())){
          window.lastScrollTopBarAnimation = 0;
          window.isFirstScrollStickyBar = true;
          //trigger click you may also like
          $('.slot7 .owl-item  .product').on('click', function(){
              $(this).find('a.product__image-link')[0].click()
          })
      } else {
          $('.selector-area-wrapper .size-option').on('click', function(){
              for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
                  if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
                      $('#presc--side--button a[data-element-id="X_Pdp_Prod_AddLens"]').attr('data-prescription',productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
                      break;
                  }
              }
          });
      }

      if ($("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").length > 0) $("[id$=X_PDP_CustomerSegment_Tooltip].contentRecommendationWidget").show();
  }
});

function checkPromoCookie (){
  var promoCookie = getCookie("promoCalloutCookie");
  if (promoCookie == null) {
      if(window.mobilecheck() || window.tabletPortraitCheck()){
          $(' .promo-callout').css('top', $('#header').outerHeight() + 10)
      }
      $(' .promo-callout-container').show()
  }
}
//wcag
function managePopupTabIndex(container, isOpen){
  if(isOpen){
      $(container).on('keydown', function(e){
          $(container).addClass('focus');
          $(container).focus();
          var focusableEls = $(container + " input:visible, "+ container + " button:visible, " + container + " a:visible, "+ container + " [tabindex]:not([tabindex='-1'])" )
          var firstFocusableEl = focusableEls[0];
          var lastFocusableEl = focusableEls[focusableEls.length - 1];
          var KEYCODE_TAB = 9;
          var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
          if (!isTabPressed) {
              return;
          }
          if ( e.shiftKey ) /* shift + tab */ {
              if (document.activeElement === firstFocusableEl) {
                  lastFocusableEl.focus();
                  e.preventDefault();
              }
          } else /* tab */ {
              if (document.activeElement === lastFocusableEl) {
                  firstFocusableEl.focus();
                  e.preventDefault();
              }
          }
      })
  } else {
      $(container).off('keydown');
  }
}


/**
* NEW LOGIC FOR FORMS NEWSLETTER
*/

/**
* Function that open the newsletter from footer
*/
$(document).on('click','#newsletter-wrapper .newsletter-subscribe span',function() {
 changeTabIndex($('.newsletter'));
 if(checkMobilePdpPage()){
     changeFooterIndex(true)
 }
 $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
 $('.newsletter--fade').show();
 $('body').addClass('no-scroll');
 $('body, html').css('height', '100%');
 $('body, html').css('overflow', 'hidden');
 $("#newsletter-wrapper").hide();
 $(this).attr("data-element-id","X_HP_OverlayNewsletter");
 tealiumPushHPNewsletterSticky($(this)[0]);
});

/**
* Function close sticky and save cookie
*/
$(document).on('click','#newsletter-wrapper .closebutton',function() {
    $("#newsletter-wrapper").fadeOut('fast');
    setCookie("WELCOME_STICKY_SHOWN_"+storeDirectory,true,{expires: 10000,path: "/", domain: cookieDomain});
    $('body').removeClass('no-scroll');
    $('body, html').css('overflow', 'auto');
});

function setHeightFullImage(showHeader) {
    var longDescriptionWidgetMarginTop = $('#header').height();
    if($('.ct-promo-bannerTop').is(':visible') && $('.ct-promo-bannerTop').text() !== '') {
        longDescriptionWidgetMarginTop += $('.ct-promo-bannerTop').height();
        $('.bottom-scrollable-section').addClass('visible-bannerTop');
    } else {
        $('.bottom-scrollable-section').removeClass('visible-bannerTop');
    }

  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
      if (!$("#image-soldOut").is(":visible")) {
          var fullHeight = window.innerHeight - 160;
          var fullHeightNoColor = window.innerHeight - 80;
        //   $('.full-image-widget').not('.no-prescription.other-colors-empty').css('height', fullHeight + 'px');
      }
      $('.full-image-widget.no-prescription.other-colors-empty').css('height', fullHeightNoColor + 'px')

      if($('.full-image-widget').hasClass("no-prescription") && $('.full-image-widget').hasClass("other-colors-empty")){
          $(".bottom-section").addClass("no-colors")
      }

      if(showHeader){
         // $(".long-description-widget").css("margin-top", longDescriptionWidgetMarginTop + "px");
          //$(".full-image-widget .widget_product_multiple_image_viewer .popup_link:not(.model):not(.case) .owl-pdp__image-wrapper:not('glass-img-container')").css("transform", "translateY(10%)");
      } else {
         //$(".long-description-widget").css("margin-top", "0");
          //$(".full-image-widget .widget_product_multiple_image_viewer .owl-pdp__image-wrapper").css('transform', 'translateY(0)');
      }
  }else {
      if(showHeader){
         // $(".long-description-widget").css("margin-top", longDescriptionWidgetMarginTop + "px");
          $(".full-image-widget .widget_product_multiple_image_viewer .popup_link:not(.model):not(.case) .owl-pdp__image-wrapper:not('glass-img-container')").css("transform", "translateY(10%)");
      } else {
          //$(".long-description-widget").css("margin-top", "0");
          $(".full-image-widget .widget_product_multiple_image_viewer .owl-pdp__image-wrapper").css('transform', 'translateY(0)');
      }
  }
}

/**
* Function for check email
*/
function validateFormNewsletter() {
  //var inputValue = $('#mce-EMAIL').val();
  var inputValue = $('#newsletterEmail').val();

  if (inputValue == '') {
      $('#mce-error-response').show();
      $('#mce-error-response').children().hide();
      $("#mce-error-response-empty").show();
  } else {
      $('#mce-error-response').css('display') != 'none' ? $('#mce-error-response').hide() : '';
      $('#mce-error-response').css('display') != 'none' ? $('#mce-success-response').hide() : '';

      //if (validateEmail(inputValue)) {
      if (!validateEmail(inputValue)) {
          $('#mce-error-response').show();
          $('#mce-error-response').children().hide();
          $('#mce-error-response-invalid').show();
      }
      else {
          $('#mc-embedded-subscribe-form').submit();
      }
  }
}

/* Function to validate the email */
function validateEmail(email) {
  var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
}


$(document).ready(function () {
  /**
  * Function that open the newsletter from nav menu in desktop mode
  * and hide the nav menu
  */
  $('.nav-social__item-newsletter').click(function () {
      $('.header__nav-close').click();
      setTimeout(function () {
          $('.newsletter').addClass('opend').find(':focusable').first().focus().addClass('focus');
          $('.newsletter--fade').show();
          $('body').addClass('no-scroll');
          $('body, html').css('height', '100%');
          $('body, html').css('overflow', 'hidden');
          changeTabIndex($('.newsletter'));
      }, 500);
  });

  /**
  * Function that open the newsletter from nav menu in mobile mode
  */
  $('.nav-user__item--newsletter').click(function () {
      changeTabIndex($('.newsletter'));
      if(checkMobilePdpPage()){
          changeFooterIndex(true)
      }
      $('.newsletter').addClass('opend');
      $('.newsletter--fade').show();
      $('body').addClass('no-scroll');
      $('body, html').css('height', '100%');
      $('body, html').css('overflow', 'hidden');
  });

  /**
  * Function that open the newsletter from footer
  */
  $('.newsletter-cta__button, #segment-subscribe-cta').click(function () {
      if(checkMobilePdpPage()){
          changeFooterIndex(true);
      }
      changeTabIndex($('.newsletter'));
      $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
      $('.newsletter--fade').show();
      $('body').addClass('no-scroll');
      $('body, html').css('height', '100%');
      $('body, html').css('overflow', 'hidden');
      if (!getCookie($("#welcomePopupCookieName").val())) {
        $("#newsletter-wrapper").hide();
      }
  });

  /**
  * Function that close the newsletter
  */
  $('.newsletter__close').click(function () {
      if(checkMobilePdpPage()){
          changeFooterIndex(false)
      }
      changeTabIndex($('.newsletter'));
      $('.newsletter').removeClass('opend');
      $("#footerWrapper").removeClass("footer-pop-open");
      $('.newsletter--fade').hide();
      $('body').removeClass('no-scroll');
      $('body, html').css('height', 'auto');
      $('body, html').css('overflow', 'visible');
      if (!getCookie($("#welcomePopupCookieName").val())) {
        $("#newsletter-wrapper").show();
      }
  });

  /**
  * Function that close the newsletter when click in fade layer
  */
  $('.newsletter--fade').click(function () {
      $('.newsletter__close').click();
      $('body').removeClass('no-scroll');
      $('body, html').css('height', 'auto');
      $('body, html').css('overflow', 'visible');
  });

}).mouseup(function (e) {

});


function printEllipsis (text) {
  var checkForSpace = true;
  var index = 250;

  if(text.length < index) return;
  while (checkForSpace) {
      if(text[index] === " " || index > 300) {
          checkForSpace = false;
          // index = 180;
      } else {
          index++;
      }
  }

  return text.slice(0, index) + "...";
}


//open pop up klarna payment page
function openPopup(){
  $('.pop-container iframe').eq(0).attr('scrolling','yes');
  if (window.mobilecheck() || window.tabletPortraitCheck()){
      $(".pop-container.only-mobile").css('display','block');
      bodyScrollLock.disableBodyScroll(document.querySelector('.pop-wrap'));
  } else {
      $(".pop-container.only-desktop").css('display','block');
  }
  $("body").css("overflow","hidden");
$(".pop-bg, .pop-x").bind("click", function() {
  pop_close();
});

}

function pop_close() {
  $(".pop-container").css('display','none');
  $("body").css("overflow","auto");
$("body").unbind("click");
  if (window.mobilecheck() || window.tabletPortraitCheck()){
      bodyScrollLock.enableBodyScroll(document.querySelector('.pop-wrap'));
  }
}

function updateLastOfferUpsell(upsell){
//HB-7718
lastOfferPrice=$('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '');

/*Now we create a div with list price and offer price of upsell product.
this div will be used into:
in productPageAdd2Cart (present in CommonUtilities) to set the pst in minicart.
In the end of this function we will remove this div*/

$('body').append('<div id="upsell-added-inicart"><span id="upsell-list-price">' + $('.espot-complete-order-upsell #listPrice_' + upsell).text().replace(/\s/g, '') + ' </span><span id="upsell-offer-price">' + $('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '') + '</span></div>')
  if(typeof tealiumProducts === 'undefined'){
      tealiumProducts = {};
  }
  var upSellDetails = $('[data-catentry-id='+upsell+'] .product_name a');
  var upsellSku = upSellDetails.length > 0 ? upSellDetails[0].dataset.partnumber : upsell;
  if (typeof tealiumProducts[upsellSku]=== 'undefined'){
      var tealiumProduct = {};

      var listPrice = $('#listPrice_'+upsell).length > 0 ? cleanPrice($('#listPrice_'+upsell)[0].innerText) : '';
      var offerPrice = $('#offerPrice_'+upsell).length > 0 ? cleanPrice($('#offerPrice_'+upsell)[0].innerText) : '';
      if (listPrice != ""){
          listPrice = parseFloat(listPrice).toFixed(2);
      }
      else 
          listPrice = parseFloat(offerPrice).toFixed(2);

      if (offerPrice != ""){
          offerPrice = parseFloat(offerPrice).toFixed(2);
      }
      
      tealiumProduct['Sku']= upsellSku;
      tealiumProduct['ModelName']= upSellDetails.length > 0 ? upSellDetails[0].dataset.description : '';
      tealiumProduct['Category'] = upSellDetails.length > 0 ? upSellDetails[0].dataset.category.toUpperCase() : '';
      tealiumProduct['Price'] = offerPrice;
      tealiumProduct['Status'] = "Available";
      tealiumProduct['PriceFull'] = listPrice;
      tealiumProduct['Engraving'] = "N";
      tealiumProduct['Brand'] = currentBrand;
      tealiumProduct['Units'] = 1;
      
      tealiumProducts[upsellSku] = tealiumProduct;
  } else {
      tealiumProducts[upsellSku].Units++;
  }       
}

function checkEditFormInputs(){
    $(".myAccountSummary .form-group .input_field, .myAccountSummary .form-group .input_field_myacc").each(function(){
        if ($(this).val() == ''){
            $(this).siblings("label").removeClass("labelOnTop");
        } else {
            $(this).siblings("label").addClass("labelOnTop");
        }
    });
}

function setDDMPosition(){
    $("#all_section section").each(function(index,singleSection){
        if ($('#page').hasClass('plp')){
            $( singleSection ).css('top', $('#headerWrapper').height()-$('.ct-global--slider-container.ct-strip').height());
        } else {
            var globalBannerHeight = $('#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner').height();
            if(globalBannerHeight === undefined){
            globalBannerHeight = 0;
            }
            var headerHeight = $('#header').height();
            if ($('#page').hasClass('pdp')){
                headerHeight = $('.header__row1-wrapper').outerHeight(); 
            }
            $( singleSection ).css('top', headerHeight+globalBannerHeight-1); 
        }
    });
}

$(window).scroll(function() {
    if (!window.mobilecheck() || !window.tabletPortraitCheck()){
        setDDMPosition();
    }
});

function callAlgoliaServiceEspot(idSection){
    //I caroselli di algolia nel ddm sono inseriti qui
    if(idSection == '#departmentLink_sun_Section'){
        if(!isEspotAlreadyLoaded('X_Header_NavSunglasses_BestsellersCards')){
            loadHeaderEspot("X_Header_NavSunglasses_BestsellersCards"); 
        }
        if(!isEspotAlreadyLoaded('X_Header_NavSunglasses_IconsCards')){
            loadHeaderEspot("X_Header_NavSunglasses_IconsCards"); 
        }
    }
    else if (idSection == '#departmentLink_eyes_Section') {
        if(!isEspotAlreadyLoaded('X_Header_NavEyeglasses_BestsellersCards')){
            loadHeaderEspot("X_Header_NavEyeglasses_BestsellersCards");
        }
    }
    
}

function isEspotAlreadyLoaded(idContainer){
    var container = document.getElementById(idContainer);
    return container.childElementCount != 0;
}

document.addEventListener("DOMContentLoaded", function(event) {
  var lazyImages =[].slice.call(
   document.querySelectorAll(".telecomando-lower-container picture")
  )
  let lazyImageCheck = false; 
  if ("IntersectionObserver" in window && 'IntersectionObserverEntry' in window) {
     let lazyImageObserver = 
      new IntersectionObserver(function(entries, observer) {
         entries.forEach(function(entry) {
          if (entry.isIntersecting) {      
             let lazyImage = entry.target;
             lazyImage.lastElementChild.style.display = "block";
             lazyImageObserver.unobserve(lazyImage);
             lazyImageCheck = true;
           }
        });
         if(lazyImageCheck){
        	 setTimeout(function () {      
            	 $(".telecomando-lower-container .item").removeClass("skeleton-element");       
             }, 3000); 
         }
       });

     lazyImages.forEach(function(lazyImage) {
      lazyImageObserver.observe(lazyImage);
     });
  } else {
    
    // Not supported, load all images immediately
    let active = false;
 
    const lazyLoad = function() {
      if (active === false) {
        active = true;
        setTimeout(function() {
          lazyImages.forEach(function(lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.lastElementChild.style.display = "block";
              lazyImageCheck = true;
              lazyImages = lazyImages.filter(function(image) {
                return image !== lazyImage;
              });
  
              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
              }
            }
            if(lazyImageCheck){
	        	setTimeout(function () {      
	              	 $(".telecomando-lower-container .item").removeClass("skeleton-element");       
	            }, 3000);
            }
          });
  
          active = false;
        }, 200);
      }
    };
  
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
   }
 });


// -----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2006, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
// -----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the store jsp's related to address creation and maintenance.
 * @version 1.0
 */

/**
 * The functions defined in this class enable address creation across the store.
 *
 * @class The functions and variables defined in this class validate the form
 *        input field values entered by the customer. Another set of functions
 *        help in loading the UI for the state field when there is a change in
 *        the country field. Another set of functions enable creating an address
 *        in the shopcart page and guest user checkout page.
 */
var zipCodeError= false;
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}





var continents = [
    {
      continent: 'AF',
      countries: ['DZ','AO','BW','BI','CM','CV','CF','TD','KM','YT','CG','CD','BJ','GQ','ET','ER','DJ','GA','GM','GH','GN','CI','KE','LS','LR','LY','MG','MW','ML','MR','MU','MA','MZ','NA','NE','NG','GW','RE','RW','SH','ST','SN','SC','SL','SO','ZA','ZW','SS','EH','SD','SZ','TG','TN','UG','EG','TZ','BF','ZM']
    },
    {
      continent: 'AS',
      countries: ['AF','AZ','BH','BD','AM','BT','IO','BN','MM','KH','LK','CN','TW','CX','CC','CY','GE','PS','HK','IN','ID','IR','IQ','IL','JP','KZ','JO','KP','KR','KW','KG','LA','LB','MO','MY','MV','MN','OM','NP','PK','PH','TL','QA','RU','SA','SG','VN','SY','TJ','TH','AE','TR','TM','UZ','YE','XE','XD','XS']
    },
    {
      continent: 'EU',
      countries: ['AL','UK','AD','AZ','AT','AM','BE','BA','BG','BY','HR','CY','CZ','DK','EE','FO','FI','AX','FR','GE','DE','GI','GR','VA','HU','IS','IE','IT','KZ','LV','LI','LT','LU','MT','MC','MD','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SJ','SE','CH','TR','UA','MK','GB','GG','JE','IM']
    },
    {
      continent: 'NA',
      countries: ['AG','BS','BB','BM','BZ','VG','CA','KY','CR','CU','DM','DO','SV','GL','GD','GP','GT','HT','HN','JM','MQ','MX','MS','AN','CW','AW','SX','BQ','NI','UM','PA','PR','BL','KN','AI','LC','MF','PM','VC','TT','TC','US','VI']
    },
    {
        continent: 'OC',
        countries: ['AS','AU','SB','CK','FJ','PF','KI','GU','NR','NC','VU','NZ','NU','NF','MP','UM','FM','MH','PW','PG','PN','TK','TO','TV','WF','WS','XX']
    },
    {
        continent: 'SA',
        countries: ['AR','BO','BR','CL','CO','EC','FK','GF','GY','PY','PE','SR','UY','VE']
    }
  ];

function getContinent(country){
	for (var key in continents) {
	    // check if the property/key is defined in the object itself, not in parent
	    if (continents.hasOwnProperty(key)) {
	    	if(continents[key].countries.includes(country)){
	    		return continents[key].continent;
	    	}        
	    }
	}
}

//ChangeDone
AddressHelper = {
    /* The name of the state field div. */
    stateDivName: "stateDiv",
    storeCountry: "",
    storeName: "",
    /* styling class for the state field. */
    stateClass: null,
    selectedCountryCode: null,
    cityId: null,
    stateId: null,
    maxNeighborhoodChar : 31,
    validZipCode: null,
    zipCodeNotFound:false,
    validZipCodeShipping: null,
    validZipCodeBilling: null,
    isSameCountryAsStore: true,
    zipCount: 0,
    validCPF: false,
    hasTaxes: false,

    setStoreName: function (storeName) {
        this.storeName = storeName;
    },

    /**
     * This function set the value of hasTaxes
     *
     * @param {boolean} hasTaxes show if store has taxes or not
     */
    setStoreHasTaxes: function (hasTaxes) {
        this.hasTaxes = (hasTaxes == 'true');
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
            $('.ui-widget-overlay').hasClass('custom-overlay') ? '' : $('.ui-widget-overlay').addClass('custom-overlay');
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showAddEditAddressPopup: function (widgetId, addressIdDiv, storeId) {
        this.showWCDialogPopup(widgetId);
        if (addressIdDiv && addressIdDiv != '') {
            var addressId = $('#' + addressIdDiv)[0].value;
            if (addressId && addressId != '') {
                $.ajax({
                    type: "GET",
                    url: "/wcs/resources/store/" + storeId  + "/person/@self/contact/byAddressId/" + addressId,
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    success: function (data) {
                     // fill address
                        var addEditAddressForm = document.forms['addEditAddressForm'];

                        addEditAddressForm.firstName.value = data.firstName;
                        addEditAddressForm.lastName.value = data.lastName;
                        addEditAddressForm.address1.value = data.addressLine[0];
                        addEditAddressForm.state.value = data.state;
                        addEditAddressForm.city.value = data.city;
                        addEditAddressForm.zipCode.value = data.zipCode;
                        addEditAddressForm.phone1.value = data.phone1;
                        if($('#emailAddress1')[0]) {
                            addEditAddressForm.email1.value = data.email1;
                        }

                        if (typeof addEditAddressForm.addressId == 'undefined' ) {
                            $('<input>').attr({
                                type: 'hidden',
                                id: 'addressId',
                                name: 'addressId',
                                value: addressId
                            }).appendTo(addEditAddressForm);
                        } else {
                            addEditAddressForm.addressId.value = addressId;
                        }

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {

                    }
                });
            }

        } else {
            // clears
            var addEditAddressForm = document.forms['addEditAddressForm'];

            addEditAddressForm.firstName.value = '';
            addEditAddressForm.lastName.value = '';
            addEditAddressForm.address1.value = '';
            addEditAddressForm.state.value = '';
            addEditAddressForm.city.value = '';
            addEditAddressForm.zipCode.value = '';
            addEditAddressForm.phone1.value = '';
            if (addEditAddressForm.addressId) {
                addEditAddressForm.addressId.remove();
            }
        }

    },
    /**
     * This function sets the name for the state field.
     *
     * @param {string}
     *            stateDivName The name to be set for the state field.
     */
    setStateDivName: function (stateDivName) {
        this.stateDivName = stateDivName;
    },

    /**
     * This function sets the styling class for the state field.
    *
    * @param {string}
    *            stateClass The name of the styling class to be set for the
    *            state field.
     */
    setStateClass: function (stateClass) {
        this.stateClass = stateClass;
    },

    /**
     * set selected country code on change country event
     */
    setSelectedCountryCode: function (selectedCountryCode) {
        this.selectedCountryCode = selectedCountryCode;
    },

    setStoreCountry: function (storeCountry) {
        this.storeCountry = storeCountry;
    },

    /**
     * set default selected country onload, in order to perfom zip validation
     */
    setSelectedCountryId: function (selectedCountryId) {
        this.selectedCountryId = selectedCountryId;

        var selectedCountry = document.getElementById(selectedCountryId);

        if (selectedCountry != null) {
            //set default selectedcountry code
            var currentCountryCode = null;

            if (selectedCountryId == "_state1") {
                currentCountryCode = selectedCountry.value;
            } else {
                currentCountryCode = selectedCountry.value;
            }

            this.setSelectedCountryCode(currentCountryCode);
        }


    },

    /**
     * This function return an array of countries from a global variable called
     * countries. If that variable does not already exist then it will be
     * created and populated from a JSON of country objects which should have
     * been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     */
    getCountryArray: function () {

        //If the countries array does not already exist then create it.

        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined')
                return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].statesArray = new Array();
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].statesArray.push({
                            value: state.code,
                            label: state.displayName
                        });
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;

    },

    /**
     * This function will load the state field depending on the country
     * selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     */
    loadStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }
        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
        }

        var stateDivObj = document.getElementById(stateDiv);
        if (Utils.get_IE_version()) { /* For IE */
            var stateClass = ($("#" + newid)).attr("className");
        } else {
            var stateClass = ($("#" + newid)).attr("class");
        }

        if (stateClass != "drop_down_country") {
            this.setStateClass(stateClass);
        }
        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode].states) {
            /* switch to state list. */
            stateDivObj.appendChild(this.createStateWithOptions(paramPrefix,
                currentCountryCode, currentState, id, required));
        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     *	This function creates an input element to represent the state.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createState: function (paramPrefix, currentState, id, required) {
        var stateInput = document.createElement("input");
        stateInput.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateInput.setAttribute("name", paramPrefix + "_state");
        } else {
            stateInput.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateInput.setAttribute("aria-required", "true");
        }
        stateInput.setAttribute("class", this.stateClass);
        stateInput.setAttribute("className", this.stateClass);
        stateInput.setAttribute("size", "35");
        stateInput.setAttribute("maxlength", "49");
        if (currentState != null && currentState != 'undefined') {
            stateInput.setAttribute("value", currentState);
        }
        return stateInput;
    },

    /**
     * This function creates a <select> element to represent the state field and
     * loads it with the states corresponding to the country field.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentCountryCode The country code of the selected country.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createStateWithOptions: function (paramPrefix, currentCountryCode, currentState, id, required) {

        this.getCountryArray();
        var stateSelect = document.createElement("select");
        stateSelect.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateSelect.setAttribute("name", paramPrefix + "_state");
        } else {
            stateSelect.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateSelect.setAttribute("aria-required", "true");
        }
        stateSelect.setAttribute("class", "drop_down_country");
        stateSelect.setAttribute("className", "drop_down_country");
        /*clear old options. */
        stateSelect.options.length = 0;

        /* add all states. */
        for (state_code in countries[currentCountryCode].states) {

            aOption = document.createElement("option");
            stateSelect.options[stateSelect.length] = aOption;
            aOption.text = countries[currentCountryCode].states[state_code];
            aOption.value = state_code;

            if (state_code == currentState
                || countries[currentCountryCode].states[state_code] == currentState) {
                aOption.selected = true;
            }
        }

        return stateSelect;
    },

    /**
     * This function will load the state field for selection dropdown using
     * wc.Select in AdressForm.jsp depending on the country selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     * @param {boolean}
     *            addEmptyOption - If true, it adds 'Please Select' as the first
     *            option with value set to ''.
     */
    loadAddressFormStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue, addEmptyOption) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required = false;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }

        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        }

        var stateDivObj = document.getElementById(stateDiv);
        var stateClass = ($("#" + newid)).attr("class");

        if (stateClass !== "drop_down_country") {
            this.setStateClass(stateClass);
        }

        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode]
            && countries[currentCountryCode].statesArray) {
            /* switch to state list. */
            var statesData = countries[currentCountryCode].statesArray;
            if (addEmptyOption) {
                var option1 = new Object({
                    label: Utils.getLocalizationMessage("PLEASE_SELECT"),
                    value: ''
                });
                statesData.unshift(option1);
            }

            if (this.stateClass == "" || this.stateClass == null
                || this.stateClass == undefined
                || this.stateClass == "null") {
                this.stateClass = "wcSelect";
            }

            $('<select>').attr({
                'name': paramPrefix + 'state',
                'id': paramPrefix + id,
                'class': this.stateClass,
                required: 'required'
            }).appendTo(stateDivObj);
            statesData.forEach(function (item) {
                $('<option>').attr({
                    'value': item.value
                }).html(item.label).appendTo('#' + paramPrefix + id);
            });

            var options = {
                "wcMenuClass": "wcSelectMenu",
            }
            var statesSelect = $("#" + paramPrefix + id).Select(options);
            statesSelect.val(currentState);
            statesSelect.Select("refresh_noResizeButton");

        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     * This function validates the address form independently from the order of the fields displayed on the form, i.e. independent from the locale.
     * A  hidden field named "fields" must be set in the jsp/jspf file that calls this method. The purpose of this hidden field is to set all the mandatory
     * input fields and the order of these fields displayed on each locale-specific address entry page, so that this method knows which input
     * fields to validate and in which order it should validate them.
     *
     * assumptions:
     **1. Mandatory fields use UPPER CASE, non-mandatory fields use lower case.
     **2. The error messages used in this method are declared in the
     * jsp/jspf files that call this method.
     *
     * @param {string} form: The name of the address form obtained from the page containing address input fields.
     * @param {string} prefix: The value is set to shipping or billing.
     * @return {boolean} return: true if no error was found, or the hidden field "fields" were not set in the jsp/jspf file that calls this
     * method, return false if form could not be found, or if there was  an error validating a particular field.
     */
    validateAddressForm: function (form, prefix) {
        reWhiteSpace = new RegExp(/^\s+$/);
        if (prefix == null) {
            prefix = ""
        };
        if (prefix) {
            this.setStateDivName(prefix + "stateDiv")
        };

        if (form != null) {
            var fieldsOrderByLocaleInput = $(form).find("input[id^='AddressForm_FieldsOrderByLocale']");
            if (fieldsOrderByLocaleInput.length>0){
                $(fieldsOrderByLocaleInput).attr("id","AddressForm_FieldsOrderByLocale");
            }

            var fields = "";
            /** The hidden field "AddressForm_FieldsOrderByLocale" is to set all the mandatory fields AND the order of the fields
            *   that are going to be displayed in each locale-dependent address form, so that the JavaScript
            *   used for validation knows which fields to validate and in which order it should validate them. **/
            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
            	fields = document.getElementById("AddressForm_PickUp").value.split(",");
            }else{
            	if (form["UserDetailsForm_FieldsOrderByLocale"] != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserDetailsForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["UserAddressForm_FieldsOrderByLocale"] != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserAddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form[prefix + "AddressForm_FieldsOrderByLocale"] != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form[prefix + "AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["AddressForm_FieldsOrderByLocale"] != null
                          && form["AddressForm_FieldsOrderByLocale"].value != null
                          && form["AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (document.getElementById("AddressForm_FieldsOrderByLocale").value != null
                          && document.getElementById("AddressForm_FieldsOrderByLocale").value != "") {
                            fields = document.getElementById("AddressForm_FieldsOrderByLocale").value.split(",");
                    }
            }
            

            var nickName = prefix + "nickName";
            var lastName = prefix + "lastName";
            var firstName = prefix + "firstName";
            var middleName = prefix + "middleName";
            var address1 = prefix + "address1";
            var address2 = prefix + "address2";
            var address3 = prefix + "address3";
            var city = prefix + "city";
            var state = prefix + "state";
            var country = prefix + "country";
            var zipCode = prefix + "zipCode";
            var email1 = prefix + "email1";
            var phone1 = prefix + "phone1";
            var cpf = prefix + "fax1";
            var neighborhood = prefix + "fax2";
            var birth_date = prefix + "birth_date";
            var birth_month = prefix + "birth_month";
            var birth_year = prefix + "birth_year";

            var isValid = true;
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                //console.log("PSL::"+field);
                if (field == "NICK_NAME" || field == "nick_name") {
                    if (form[nickName] != null) {
                        form[nickName].value = trim(form[nickName].value);
                        if (field == "NICK_NAME" && (form[nickName].value == "" || reWhiteSpace.test(form[nickName].value))) {
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], false);
                            isValid = false;
                        } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], true);
                        }
                        if (!MessageHelper.isValidUTF8length(form[nickName].value, 254)) {
                            MessageHelper.formErrorHandleClient( form.nickName.id, MessageHelper.messages["ERROR_RecipientTooLong"]);
                            //tealiumPushFormError(MessageHelper.messages["ERROR_RecipientTooLong"]);
                            isValid = false;
                        }
                    }
                } else if (field == "LAST_NAME" || field == "last_name") {
                    if ($(form[lastName]).attr("disabled") == undefined){
                        form[lastName].value = trim(form[lastName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (field == "LAST_NAME" && (form[lastName].value == "" || reWhiteSpace.test(form[lastName].value))) {
                            this.manageMultipleEmptyFields(form[lastName], MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        } else if(xss.test(form[lastName].value)){
                            this.manageMultipleEmptyFields(form[lastName],MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        }else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[lastName], "", true);
                            this.validateNotEmpty(form.lastName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[lastName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[lastName].id,MessageHelper.messages["ERROR_LastNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_LastNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "FIRST_NAME" || field == "first_name") {
                    if ($(form[firstName]).attr("disabled") == undefined){
                        form[firstName].value = trim(form[firstName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (form[firstName].value == "" || reWhiteSpace.test(form[firstName].value)) {
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                            this.removeSuccesIcon(form.firstName);
                            isValid = false;
                        }else if(xss.test(form[firstName].value)){
                        		this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                                this.removeSuccesIcon(form.firstName);
                                isValid = false;
                          } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], true);
                            this.validateNotEmpty(form.firstName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[firstName].value,128)) {
                        MessageHelper.formErrorHandleClient(form[firstName].id,MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "MIDDLE_NAME" || field == "middle_name") {
                    form[middleName].value = trim(form[middleName].value);
                    if (field == "MIDDLE_NAME" && (form[middleName].value == "" || reWhiteSpace.test(form[middleName].value))) {
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[middleName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[middleName].id,MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "use_org_address" || field == 'new_line' || field == "PASSWORD" || field == "PASSWORD_VERIFY") {
                } else if (field == "ADDRESS" || field == "address") {
                    form[address1].value = trim(form[address1].value);
                    xss = new RegExp(".*[%<>&;'\0].*"); 
                    if (field == "ADDRESS" && (form[address1].value == "" || reWhiteSpace.test(form[address1].value))) {
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    } /*else if(xss.test(form[address1].value)){
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    }*/else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[address1].value,100)) {
                        MessageHelper.formErrorHandleClient(form[address1].id,MessageHelper.messages["ERROR_AddressTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_AddressTooLong"]);
                        isValid = false;
                    }
                } else if (field == "ZIP" || field == "zip") {
                   var isMandatory = field == "ZIP";
                   if(zipCodeError){
                       isValid= false;
                   }
                   if (!this.validateZipCodeFormField(form[zipCode], isMandatory)){
                       isValid = false;
                   }

                } else if (field == "CITY" || field == "city") {
                    form[city].value = trim(form[city].value);
                    if (field == "CITY" && (form[city].value == "" || reWhiteSpace.test(form[city].value))) {
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], false);
                        this.removeSuccesIcon(form.city);
                            isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], true);
                        }
                    if (!MessageHelper.isValidUTF8length(form[city].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[city].id,MessageHelper.messages["ERROR_CityTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CityTooLong"]);
                        isValid = false;
                    }
                } else if ((field == "STATE/PROVINCE" || field == "state/province") && form.action.indexOf("PersonChangeServiceAddressAdd") == -1) {
                    state = form[state];
                    if (state == null || state == "") {
                        state = document.getElementById(this.stateDivName).firstElementChild;
                    }

                   
                    if(state.value==""){
                        var stateProvince = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
                        state.value = trim(stateProvince.value);
                    }
                    if (state.value != undefined) {
                        state.value = trim(state.value);
                    }
                    if (field == "STATE/PROVINCE" && (state.value == null || state.value == "" || reWhiteSpace.test(state.value))) {
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(state.value, 128)) {
                        if (state.tagName == "INPUT" || state.tagName == "input") {
                            MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateTooLong"]);
                        } else {
                            MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR _StateTooLong"]);
                        }
                        //tealiumPushFormError(MessageHelper.messages["ERROR_StateTooLong"]);
                        isValid = false;
                    }
                } else if (field == "COUNTRY/REGION" || field == "country/region") {
                    form[country].value = trim(form[country].value);
                    // if (field == "COUNTRY/REGION" && (form[country].value == "" || reWhiteSpace.test(form[country].value)) || !this.isSameCountryAsStore) {
                    if (form[country].value == "" || reWhiteSpace.test(form[country].value)) {
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], true)
                    }
                    if (!MessageHelper.isValidUTF8length(form[country].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CountryTooLong"]);
                        isValid = false;
                    }
                } else if (field == "EMAIL1" || field == "email1") {
                    if  (form.name !== "Register" && form.action.indexOf("PersonChangeServiceAddressAdd") == -1){
                        var isMandatory = field == "EMAIL1";
                        if (!this.validateEmailFormField(form.email1, isMandatory)){
                            isValid = false;
                        }
                    }
                } else if ((field == "PHONE1" || field == "phone1") && (form.id.includes("shipping") || form.id.includes("billing") ||form.id.includes("recipient"))) {
                    var isMandatory = field == "PHONE1";
                    if (!this.validatePhoneNumberFormField(form.phone1, isMandatory)){
                        isValid = false;
                    }
                } else if (field == "CODICE_FISCALE" || field == "codice_fiscale") {
                    var isMandatory = field == "CODICE_FISCALE";
                    //codice fiscale is stored in the custom address field 1
                    if (!this.validateCodiceFiscaleFormField(form.addressField1, isMandatory)){
                        isValid = false;
                    }
                } else if ((field == "NUMERO" || field == "numero")){
                    var formField = form[address2];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NUMERO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NUMERO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NUMERO field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "COMPLEMENTO" || field == "complemento")){
                    var formField = form[address3];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "COMPLEMENTO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_COMPLEMENTO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: COMPLEMENTO field empty.NEEDS COMPLETITION");
                    } else  {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "NEIGHBORHOOD" || field == "neighborhood")){
                    var formField = form[neighborhood];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NEIGHBORHOOD") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NEIGHBORHOOD_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NEIGHBORHOOD field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "CPF" || field == "cpf")){
                    var formField = form[cpf];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "CPF") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field empty.NEEDS COMPLETITION");
                    }
                    else if(!(validateCPFCNPJ(formField, false))){
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Invalid"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field not valid");
                    } else {
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "DATEOFBIRTH" || field == "dateofbirth") && $('.checkout-quick-register .dob').length == 0){
                    var formField = document.getElementsByClassName("dob__content")[0];

                    if ($(formField).parent().attr("disabled") == undefined){
                        // var formField = form[birth_date];
                        var birthdate = trim(form[birth_date].value);
                        var birthmonth = trim(form[birth_month].value);
                        var birthyear = trim(form[birth_year].value);


                        var isEmpty =  false;
                        if (  (birthdate == "" || reWhiteSpace.test(birthdate))
                            ||(birthmonth == "" || reWhiteSpace.test(birthmonth))
                            ||(birthyear == "" || reWhiteSpace.test(birthyear)) ){
                                isEmpty = true;
                        };

                        if (isEmpty) {
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Empty"]);
                        }
                        else if (!this.validateAge(birthyear)){
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Invalid"]);
                        }
                    }

                    else {
                        //delete error Messages
                        // this.manageFormErrorFields(formField, "");
                        this.deleteFormErrorMessageFields(formField);
                    }
                }
            } //end for loop

            if (!isValid) {
                $("body").scrollTop(0);

                //this if prevents js error if WCAG.js are not imported
                if(typeof moveToError === 'function'){
                    moveToError();
                }
                restoreAjaxButtons();
                return false;
            }

            return true;
        }
        // /The form is null so..
        return false;
    },
    ////************************************************************************************************* */

/**
 * Function to validate that the register user is older than 18
 * @param {*} form
 */
    validateAge: function(birthYear){
        var isValidAge=true;
        var currentYear = new Date().getFullYear();
        if (isGDPR){
            if (currentYear-birthYear<16){
                isValidAge = false;
            }
        }else if (isCarol){
            if (currentYear-birthYear<18){
                isValidAge = false;
            }
        }
        return isValidAge;
    },

    createFormErrorMessageField: function (fieldID, errorMsg) {
    //If the error message does not exist, sets a generic error message.
        // if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
        //     errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        // }
    //Otherwise, creates a new div to display the error message
        var errorMessageField = document.createElement('div');
        errorMessageField.setAttribute("class", "address-erros-message-cont error-message-wrapper");
        errorMessageField.innerHTML = '<span tabindex="0" id="errorMessageFieldFor_' + fieldID + '" class="error-message form-error-message wcag__error">' + errorMsg + '</span>';

        return errorMessageField;
    },

/**
 * Manage multiple address form error messages for each concerned field.
 */
    manageFormErrorMessageFields: function (field, errorMsg) {


            this.deleteFormErrorMessageFields(field);
            var errorMessageField = this.createFormErrorMessageField(field.id, errorMsg);
            $(field).addClass("field-error-message inputField--invalid");
            field.parentNode.appendChild(errorMessageField);






            //Prevents js error if WCAG.js is not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }

            //Tealium filling form Errors
            //if (typeof tealiumPushFormError !== "undefined" ) {
                //tealiumPushFormError(errorMsg);
                //tealiumPushFormError(errorMsg);
            //}
    }, 

    /**
     * Deletes the error message if the field is not empty anymore.
     * @param {*} field
     */
    deleteFormErrorMessageFields: function (field){
        $("#"+field.id).parent().find(".address-erros-message-cont").remove();
        $("#"+field.id).parent().find(".error-message-wrapper").remove();
    },

    ////************************************************************************************************* */



    /**
     * mandatory field shown when one or multiple empty fields in forms
     */
    getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
    //If the error message does not exist, sets a generic error message.
        if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
            errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        }
    //Otherwise, creates a new div to display the error message
        var mandatoryField = document.createElement('div');
        mandatoryField.setAttribute("class", "address-erros-message-cont");
        mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';

        return mandatoryField;
    },
    /**
      * manage multiple address form empty fields add Error message for each
      * concerned field
     */
    manageMultipleEmptyFields: function (field, errorMsg, isNotEmpty) {

        var mandatoryErrorFieldId = "mandatoryField_" + field.id;

        // delete error message if field is no more empty
        var currentField = document.getElementById(mandatoryErrorFieldId);
        if (currentField != null) {
            $(field).removeClass("field-error-message");
            if (currentField.parentNode != null && currentField.parentNode.className != undefined && currentField.parentNode.className.indexOf("address-erros-message-cont") >= 0) {
                $(currentField.parentNode).remove();
            } else {
                currentField.remove();
            }
        }

        if (!isNotEmpty) {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (!isOliver && field.name != undefined && field.name.toLocaleLowerCase().indexOf('address') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name != 'state' ){//pre modifica ||(isPersol && field.name == 'address1' && $('.myAccountSummary').length == 0) 
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                    //Tealium filling form Errors
                    //tealiumPushFormError(errorMsg);
                }
            }
        }

    },


    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        //Sets the field that the error will be associated to.
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // field.parentNode.appendChild(mandatoryField);
                    field.parentNode.insertAdjacentElement('beforeend', mandatoryField);

                    //this if prevents js error if WCAG.js are not imported
                    if(typeof moveToError === 'function'){
                        moveToError();
                    }

                    //Tealium filling form Errors
                    //if (typeof tealiumPushFormError !== "undefined" ) {
                        //tealiumPushFormError(errorMsg);
                    //}
                }
            }
        }

    },

    /**
     *
     * @param {*} formName Controls if the field is still empty
     */
    isEmpty: function (formField){
        if (formField.value == "" || reWhiteSpace.test(formField.value)){
            return true;
        }
        else{
            this.manageMultipleErrorFields(formField, "", true);
            return false;
        }
    },


    /* NEW */
    validateZipCodeFormField: function(formField, isMandatory){
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value.toUpperCase());
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeEmpty"]);       
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,40)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeTooLong"]); 
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeTooLong"]);
        } else if (!isEmpty) {
            var zipCodeRegexp = this.getZipCodeRegexpForCurrentCountryCode();
            if (!zipCodeRegexp.test(formFieldValue)){
                isValid = false;
                this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //BEGIN HB-10030 - when the call is from goToOrderPaymentViewOnClickHandler
                //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                    //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //END HB-10030
            }
        }
        if (!isValid) {
            isValid = false;
        } else if (!isEmpty) {
            //We check if the country is the same as in the store
            if (this.storeCountry == 'UK') {
                this.storeCountry = 'GB';
            }
            this.isSameCountryAsStore = (this.storeCountry === countryCode);

            this.autofillFormAddressFromZipCode(formField);

            if (this.hasTaxes && formField.form.name.includes("shipping")) {
                CheckoutHelperJS.calculateTaxesFromZipCode(formField);
            }
            isValid = true;
        }
        if(isValid){
            this.addSuccesIcon(formField);
            setTimeout(function() { 
               AddressHelper.showHiddenField(formField);
            }, 500);   
            
        }
        this.removeSuccesIcon(formField);
        return isValid;
    },

    validatePhoneNumberFormField: function(formField, isMandatory){
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var phoneNumber = formFieldValue;
        var isValid = true;

        function isCybersourceValidPhoneNumber(phone){
            var isValid = true;
            var digits = "0123456789";
            var digitsCount = 0;
            var validCharsRegexp = /[a-zA-Z0-9\-\(\)\+\,\*\.\#\/\s]/g;

            for (var i = 0; i < phone.length; i++) {
                if (digits.includes(phone[i])){
                    digitsCount++;
                }
            }

            if (digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp).length != phone.length){
                isValid = false;
            }
            
        
            return isValid;
        }

        function parsePhoneNumberSAP(phone){
            var invalidCharsSAP = "-;/+";
            var parsedPhoneNumber = "";
            for (var i = 0; i < phone.length; i++) {
                var element = phone[i];
                if (invalidCharsSAP.includes(element)){
                    parsedPhoneNumber += " ";
                } else {
                    parsedPhoneNumber += element;
                }
            }
            return parsedPhoneNumber;
        }

        this.removeFieldErrorMessages(formField);
        if (isMandatory && isEmpty) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhonenumberEmpty"]);
        } else if (!isCybersourceValidPhoneNumber(phoneNumber)){
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
        } else {
            formField.value = parsePhoneNumberSAP(phoneNumber);
        }
        if (isValid){
            this.addSuccesIcon(formField);
            return true;
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateEmailFormField: function(formField, isMandatory) {
        //var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        this.removeFieldErrorMessages(formField);
        $(formField).next().removeClass('labelOnTop');
        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailTooLong"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!emailRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            //We have to clear input's email value before setting it again because of
            //the "special" behavior of the <input type="email"> tag containing spaces
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            this.addSuccesIcon(formField);
            return true;
        }else if(!isEmpty){
            $(formField).next().addClass('labelOnTop');//class that block label on top when the email is invalid and not empty
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateCodiceFiscaleFormField: function(formField, isMandatory) {

        var codiceFiscaleRegexp = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale mandatory and empty"/*MessageHelper.messages["ERROR_EmailEmpty"]*/);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale too long"/*MessageHelper.messages["ERROR_EmailTooLong"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!isEmpty && !codiceFiscaleRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale bad format"/*MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            return true;
        }
        return false;
    },
    showHiddenField : function(formField){
            if(formField.matches(":-webkit-autofill") || $(formField).is(".GoogleAutoFilled")){
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").each(function(index){$( this ).prop("readonly",true)})
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").addClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
            }else{
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").removeClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.prov").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").removeClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.cityfield").find("input").prop("readonly",false);               
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").trigger("change");
            }
            
         },
      
      
    validateNotEmpty : function (formField, isMandatory) {

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
        }
        if (isValid) {


            this.addSuccesIcon(formField);
            
            return true;
        }
        this.removeSuccesIcon(formField);
        
       
        return false;


    },
   
    addFieldErrorMessage: function(formField, errorText){
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        var errorMessageClassName = "address-field-error-message--"+formField.name;

        //Add class to the field in order to change its CSS
        $(formField).addClass("field-error-message");
        //Create error messages container if it does not exist already
        if ($("."+errorContainerClassName).length==0){
            $(formField).parent().append("<div class='" + errorContainerClassName + " error-message wcag__error' tabindex='0'></div>");
        }
        $("."+errorContainerClassName).append("<div class='"+errorMessageClassName+"'>"+errorText+"</div>");
    },

    removeFieldErrorMessages: function(formField){
        $(formField).removeClass("field-error-message");
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        if ($("."+errorContainerClassName).length>0){
            $("."+errorContainerClassName).remove();
        }
    },

    /**
     * Returns data into shipping/billing form as JSON
     */
    getJSONContactDataFromAddressForm: function (formName) {
        var form = document.forms[formName];
        var dataArray = {};
        if (form.addressType != undefined) dataArray.addressType = form.addressType.value;
        if (form.nickName != undefined) dataArray.nickName = form.nickName.value;
        if (form.firstName != undefined) dataArray.firstName = form.firstName.value;
        if (form.lastName != undefined) dataArray.lastName = form.lastName.value;
        if (form.phone1 != undefined) dataArray.phone1 = form.phone1.value;
        if (form.email1 != undefined) dataArray.email1 = form.email1.value;
        dataArray.addressLine = ["", "", ""];
        if (form.address1 != undefined) dataArray.addressLine[0] = form.address1.value;
        if (form.address2 != undefined) dataArray.addressLine[1] = form.address2.value;
		if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        if (form.zipCode != undefined) dataArray.zipCode = form.zipCode.value;
        if (form.city != undefined) dataArray.city = form.city.value;
        if (form.country != undefined) dataArray.country = form.country.value;
        if (form.state != undefined) dataArray.state = form.state.value;
        if (form.fax1 != undefined) dataArray.fax1 = form.fax1.value;
        if (form.fax2 != undefined) dataArray.fax2 = form.fax2.value;

        if (countryCode == "US" || countryCode == "CA"){
            //In US and Canada Address3 field will be set as ZIPCODE-STATE. E.g. 10507-NW
            dataArray.addressLine[2] = dataArray.zipCode + "-" + dataArray.state;
        } else {
            if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        }

        return JSON.stringify(dataArray);
    },

    /**
     * This function saves the address entry form when a registered customer
     * wants to edit/add a new address during checkout from his/her shopping
     * cart.
     *
     * @param {string}
     *            The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            The name of the form containing address information.
     * @param {string}
     *            The addressTypeIn being saved.
     */

    saveShopCartAddress: function (serviceId, formName, addressTypeIn) {
        var form = document.forms[formName];
        if (addressTypeIn == 'ShippingAndBilling' || addressTypeIn == 'Shipping') {
            if (serviceId == 'AjaxUpdateAddressForPerson') {
                serviceId = 'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout';
            } else {
                serviceId = 'AjaxAddShippingAndBillingAddressForPersonDuringCheckout';
            }
        }
        if (this.validateAddressForm(form)) {
            this.saveAddress(serviceId, formName);
        }
    },

    /**
     *
     * @param {*} addressId
     * @param {*} addressType Accepted values are "S" for Shipping, "B" for Billing, and "SB" for ShippingBilling
     */
    updateAddressCookies: function(addressId, addressType){
        var error = false;

        if (typeof addressId !== 'undefined' && addressId != null
            && typeof addressType !== 'undefined' && addressType != null){

            if (addressType === "Billing") {
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "Shipping") {
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "ShippingAndBilling"){
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else {
                error = true;
            }
        } else {
            error = true;
        }

        if (error){
            console.log("PSL::AddressHelper.js::updateAddressCookies::Invalid parameters: "
            + "addressType = " + addressType + ", "
            + "addressId = " + addressId);
        } else {
            console.log("PSL::AddressHelper.js::updateAddressCookies::Address cookies updated");
            addressId_formS = getCookie("addressId_formS_"+storeDirectory);
            addressId_formB = getCookie("addressId_formB_"+storeDirectory);
        }
    },

    /**
     *
     */
    initAddressCookies: function(){

        function logAddressErrors(shippingAddressType, billingAddressType){
            if ((shippingAddressType == "" && billingAddressType == "")
            ||(shippingAddressType == "SB" && billingAddressType == "")
            ||(shippingAddressType == "S" && billingAddressType == "B")) {
                plog("AddressHelper.js::initAddressCookies:: Address settings OK");
            } else {
                plog("AddressHelper.js::initAddressCookies:: Address settings KO");
            }
        }

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
        $.ajax({
            method: "GET",
            url: url,
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            dataType: "json",
            data: {
                "timestamp": Date.now()
            },
            success: function(data, textStatus, jqXHR){
                if (typeof data.contact === 'undefined'){
                    plog("AddressHelper.js::initAddressCookies::Address not found");
                } else {
                    for (var i = 0; i<data.contact.length; i++){
                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
                        }
                    }
                }
            },
            error: function(jqXHR, exception){
                plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
            },
            complete: function(){
            }
        });
    },

    /**
     *
     * @param storeId current store id
     * @param onSuccessURL if the update is ok, go to this url
     * @returns
     */
    updateUnregisteredCheckoutAddress: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        location.href = onSuccessURL; 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
                form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    resetUnregisteredCheckoutAddressCookies: function () {
        setCookie("addressId_formS_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
        setCookie("addressId_formB_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
    },

    /**
     * This function saves the address entry form on an unregistered user's
     * checkout page.
     *
     * @param {string} formName1 The name of the billing address form.
     * @param {string} formName2 The name of the shipping address form.
     * @param {string} stateDivName1 The name of the state field in the billing address form.
     * @param {string} stateDivName2 The name of the state field in the shipping address form.
     */
    saveUnregisteredCheckoutAddress: function (formName1, formName2, stateDivName1, stateDivName2/*, buttonId, event*/) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];

        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: Valores iniciales:");
        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form1.nickName.value = " + form1.nickName.value);
        if (form2) {
            console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form2.nickName.value = " + form2.nickName.value);
        }

        this.setStateDivName(stateDivName1);
        /* Validate form input fields */
        if (this.validateAddressForm(form1)) {
            var addressNickNameBase = "MyAddress_";
            var sameaddress = document.getElementById("SameShippingAndBillingAddress");

            if (!sameaddress || sameaddress.checked) {
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }

                form1.addressType.value = 'ShippingAndBilling';
                if (form1.addressId == undefined || form1.addressId.value === '') {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('AddShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }
                else {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, UpdateShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('UpdateShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }

            }
            else {
                //var form2 = document.forms[formName2];
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }
                if (form2.nickName.value == undefined || form2.nickName.value == "") {
                    form2.nickName.value = addressNickNameBase + "Billing";
                }

                console.log("PSL::AddressHelper.js:: form1.nickName.value = " + form1.nickName.value);
                console.log("PSL::AddressHelper.js:: form2.nickName.value = " + form2.nickName.value);

                // Store form1 email as billing address email
                if(!isPersol && !isOliver){
                    form2.email1.value = form1.email1.value;
                }
                

                /* Validate form input fields */
                if (this.validateAddressForm(form2)) {
                    this.setStateDivName(stateDivName2);

                    /*
                     * Note that, when want to save different shipping and billing addresses, we only call AddBillingAddress,
                     * because AddShippingAddress will be called in the successHandler of the service AddBillingAddress
                     * declared in MyAccountServicesDeclaration.js
                     * This is the out-of-the-box behavior in AuroraStorefrontStore
                     */
                    if (form2.addressId == undefined || form2.addressId.value === '') {
                        //console.log("PSL::AddressHelper.js::Add billing address");
                        //$(buttonId).off(event);
                        if (form1.addressId != undefined && form2.addressId != undefined &&
                            form2.addressId.value == form1.addressId.value) {
                            form2.addressId.value = "";
                        }
                        console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                        this.saveAddressCheckoutGuest('AddBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                    else {
                        //$(buttonId).off(event);
                        console.log("PSL::AddressHelper.js::Update billing address");
                        this.saveAddressCheckoutGuest('UpdateBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                }
                else {
                    //FIXME
                    restoreAjaxButton("WC_UnregisteredCheckout_links_4");
                }
            }
        }
        else {
            //FIXME over only a form
            restoreAjaxButton("WC_UnregisteredCheckout_links_4");
        }
    },

    /**
     * This function saves an address entry form to the associated service.
     *
     * @param {string}
     *            serviceId The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            formName The name of the form containing address information.
     */
    saveAddress: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        //		if (form.address1.value == "" && form.address2.value != "") {
        //			form.address1.value = form.address2.value;
        //			form.address2.value = "";
        //		}
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */

        // should migrate this solution to GlobalLoginActions.js to avoid
        // GlobalLoginJS.updateGlobalLoginUserDisplay("...");
        var header = document.getElementById("header");
        if (header == null || !this.hasClass(header, "checkout")) {
            if (!submitRequest()) {
                return;
            }
        }

        cursor_wait();
        wcService.invoke(serviceId);
    },

    ajaxSaveAddress: function (serviceId, formName) {
        // AjaxAddAddressForPerson or AjaxUpdateAddressForPerson
        resetRequest();
        var service = serviceId;
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        if(!this.validateAddressForm(form)) {

            return false;
        } else {
            var dialog = $("#addEditAddressPopup").data("wc-WCDialog");
            if (dialog) {
                dialog.close();
                $("#addEditAddressPopup").css("display", "none");
            }

        }
        if (form.addressId != undefined && form.addressId.value != '') {
            service = 'AjaxUpdateAddressForPerson';
            form.nickName.remove();
        }
        if (form.nickName && form.nickName.value == '') {
            form.nickName.value = new Date().getTime();
        }

        var addressService = wcService.getServiceById(service);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(service);
    },

    /**
     * This function saves an address entry form to the associated service only
     * in the ShippingAndBilling screen in checkout as a Guest.
     *
     * @param {string} serviceId The id of the service that was invoked, e.g. AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string} formName The name of the form containing address information.
     */
    saveAddressCheckoutGuest: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);

        cursor_wait();
        wcService.invoke(serviceId);
    },

    hasClass: function (element, inputClass) {
        return (" " + element.className + " ").indexOf(" " + inputClass + " ") > -1;
    },

    /**
     * This function calls UpdateOrderItem/AjaxUpdateOrderItem service to update
     * order calculation
     */
    updateOrderAfterAddressUpdate: function () {
        var params = {
            storeId: ServicesDeclarationJS.storeId,
            catalogId: ServicesDeclarationJS.catalogId,
            langId: ServicesDeclarationJS.langId
        };
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.orderId = ".";

        cursor_wait();
        //wcService.invoke("AjaxUpdateOrderAfterAddressUpdate", params);
    },

    /**
     * This function populates the country code to mobile phone based on the
     * selected country.
     *
     * @param {string} countryDropDownId The id of the mobile country drop down list
     * @param {string} countryCallingCodeId The id of the mobile country calling code  text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = $("#" + countryDropDownId).val()
        if (countryCode === undefined || countryCode === null)
        // we are using wc.Select
        {
            var countryDropDownWidget = $("#" + countryDropDownId);
            if (countryDropDownWidget !== undefined
                && countryDropDownWidget !== null) {
                countryCode = countryDropDownWidget.val();
            }
        }
        $("#" + countryCallingCodeId).val(
            countries[countryCode].countryCallingCode);
    },

    /**
     * This function checks for an entry in the Mobile Phone Number field. If a
     * Mobile Phone number has been entered, it enables the SMS
     * Notifications/Promotions checkbox, else it disables the SMS
     * Notifications/Promotions checkbox.
     *
     * @param {string} form The name of the form containing the Mobile Phone Number entry field.
     * @param {string} jspStoreImgDir The directory for images
     */
    enableSMSNotifications: function (form, jspStoreImgDir) {
        var form = document.forms[form];
        if (form.mobilePhone1.value !== "") {
            form.sendMeSMSNotification.disabled = false;
            form.sendMeSMSPreference.disabled = false;
            $(".checkedCheckBox.mobileOption").removeClass("disabled").attr(
                "tabindex", "0");
        } else {
            form.sendMeSMSNotification.disabled = true;
            form.sendMeSMSPreference.disabled = true;
            form.sendMeSMSNotification.checked = false;
            form.sendMeSMSPreference.checked = false;
            $(".checkedCheckBox.mobileOption").addClass("disabled").attr(
                "tabindex", "-1").removeClass("checked").attr(
                    "aria-checked", "false").attr("src",
                        jspStoreImgDir + "images/checkbox.png");
        }
    },


    /**
     * Sets the address type when a user wants to add a new address of type
     * shipping and billing during order check out.
     *
     * @param {Object}: checkbox The HTML checkbox input object.
     * @param {Object}: form The form that includes the new address information.
     */
    setAddressTypeInCreatingNewAddressDuringCheckout: function (checkbox, form) {
        if (form.addressType != null && form.originalAddressType != null) {
            if (checkbox.checked) {
                form.addressType.value = 'ShippingAndBilling';
            } else {
                form.addressType.value = form.originalAddressType.value;
            }
        }
    },

    /**
     * Set checkbox state to true when checked and false when unchecked
     *
     * @param String jspStoreImgDir The directory for store images.
     * @param String checkbox The checkbox element.
     * @param String checkboxImg The checkbox image element.
     * @param String checkedValue The value of the input when checked.
     * @param String uncheckedValue The value of the input when unchecked.
     */
    changeCheckboxState: function (jspStoreImgDir, checkbox, checkboxImg, checkedValue, uncheckedValue) {
        var $checkboxImg = $("#" + checkboxImg), $checkbox = $("#" + checkbox);
        if (!$checkboxImg.hasClass("disabled")) {
            if ($checkboxImg.hasClass("checked")) {
                $checkboxImg.removeClass("checked");
                $checkboxImg.attr("aria-checked", "false");
                $checkboxImg
                    .attr("src", jspStoreImgDir + "images/checkbox.png");
                $checkbox.attr("value", uncheckedValue);
                $checkbox.removeAttr("checked");
            } else {
                $checkboxImg.addClass("checked");
                $checkboxImg.attr("src", jspStoreImgDir
                    + "images/checkbox_checked.png");
                $checkboxImg.attr("aria-checked", "true");
                $checkbox.attr("value", checkedValue);
                $checkbox.attr("checked", "checked");
            }
        }
    },
/** FORM VALIDATIONS *************************************************************************************************************************/

    validateEmail: function (email) {
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var isValidEmail = emailRegexp.test(email.value);
        // managing inline style and error message
        this.manageInlineValidationError(isValidEmail, email, 'emailError');
        return isValidEmail;
    },

    validateZipCode: function (zipCodeId, countryId, stateId, cityId, lang, storeName) {
        //getting zip code value
        var countrySelected = document.getElementById(countryId).value;
        var zipCode = document.getElementById(zipCodeId);

        //getting zipcode pattern per selected country
        var selectedCountryPattern = this.returnZipCodePattern();
        var zipRegex = new RegExp(selectedCountryPattern);

        //We match it to uppercase, always have to be like 'ZIP'
        var isValidZip = zipCode != '' && zipRegex.test(zipCode.value.toUpperCase());
        var isZipCodeChange = false;

        //We check if the country is the same as in the store
        if (this.storeCountry == 'UK') {
            this.storeCountry = 'GB';
        }
        this.isSameCountryAsStore = (this.storeCountry === countrySelected);

        //managing inline style and error message
        this.manageInlineValidationError(isValidZip, zipCode, zipCodeId + '_Error');

        // if(!isSameCountryAsStore) this.manageInlineValidationError(isSameCountryAsStore, countrySelected, countryId + '_Error');
        if (isValidZip) {
            //autofill city and state with data
            if (zipCode.value !== "") {
                this.fillFormAddressWithData(zipCode, countryId, stateId, cityId, lang);
            }

            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = true;
            } else {
                this.validZipCodeShipping = true;
            }
            var countryCode = jQuery('#' + countryId).val();
            if (zipCodeId.indexOf("shippingAddress") >= 0) {
                isZipCodeChange= (getCookie("addressId_formB_"+storeDirectory)!=undefined|| getCookie("addressId_formS_"+storeDirectory)!=undefined);
                if (this.hasTaxes) {
                    CheckoutHelperJS.calculateEstematedTax(zipCode.value, countryCode, lang, true, isZipCodeChange, storeName);
                }
            }

        } else {
            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = false;
            } else {
                this.validZipCodeShipping = false;
            }
        }
    },

    /**
     * HB-343 , inline codice fiscale validation
     */
    validateCodiceFiscale: function (codiceId) {
        var selectedCountryCode = this.selectedCountryCode;

        if (selectedCountryCode == 'IT') {
            // getting zip code value
            var codice = document.getElementById(codiceId);

            // getting zipcode pattern per selected country
            var codiceRegex = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

            var isValidCodice = (codice == undefined || codice == null
                || codice.value == undefined || codice.value == ''
                || codiceRegex.test(codice.value));

            // managing inline style and error message
            this.manageInlineValidationError(isValidCodice, codice, codiceId + '_Error');

            return isValidCodice;

        } else {
            return true;
        }
    },

    /**
     * show,hide error message for inline validation
     * @param : isValidInput boolean for valid / invalid input
     * @param : element : input element concerned by validation
     * @param : errorMessageId : span containing error message for input
     */
    manageInlineValidationError: function (isValidInput, element, errorMessageId) {
        if (isValidInput) {
            return true;
        } else {
            return false;
        }
    },


/** END FORM VALIDATIONS *************************************************************************************************************************/

    /* NEW */
    getZipCodeRegexpForCurrentCountryCode: function () {
        var countryregex = "";

        if (countryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        } else if (countryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        } else if (countryCode == 'IT' || countryCode == 'FR' || countryCode == 'ES') {
            countryregex = /^\d{5}$/;
        } else if (countryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        } else if (countryCode == 'GB' || countryCode == 'UK') {
            countryregex = /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/;
        } else {
            countryregex = /./;
            plog("AddressHelper.js::getZipCodeRegexpForCurrentCountryCode()::Error: Regexp not found for countryCode:"+countryCode);
        }

        return countryregex;
    },


    /**
     * return country zipCode pattern per country
     * @param : countryCode : code of concerned country
     */
    returnZipCodePattern: function () {
        var selectedCountryCode = this.selectedCountryCode;
        var countryregex = "";

        if (selectedCountryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        }
        if (selectedCountryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        }
        if (selectedCountryCode == 'IT' || selectedCountryCode == 'FR' || selectedCountryCode == 'ES') {
            countryregex = /^\d{5}$/;
        }
        if (selectedCountryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        }
        if (selectedCountryCode == 'GB') {
            countryregex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;
        }

        return countryregex;

    },


    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     * @param {*} countryId
     * @param {*} stateId
     * @param {*} cityId
     * @param {*} lang
     */
    fillFormAddressWithData: function (zip, countryId, stateId, cityId, lang) {
        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zip.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zip.value;
            var neightborhoodChars = this.maxNeighborhoodChar;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                //Tuncate string -> OCPD-670
                                autofilledNeighborhood.val((data.addressInfo[0].neighborhood).substring(0,neightborhoodChars));
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zip.value, lang, function(result){
                var error = false;
                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                		AddressHelper.zipCodeNotFound = true;
                		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                	}
                	else {
                		error=true;
	                    console.log("PSL::AddressHelper.js::fillFormAddressWithData function ajax error (GoogleAPI):"+result.error_description);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zip, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zip.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zip, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
                        var city = "";

                        if(document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1')!=null){
                            city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
                        }else{
                            city = document.getElementById('WC_UserRegistrationUpdateForm_AddressEntryForm_FormInput_city_1').value;
                        }
	                	
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zip, "", true);
                	}
                	/*else {
                		if(autofilledState != null && autofilledState.value != '') {
                			autofilledStateHidden.value = autofilledState.value;
                		}
                	}*/
                }

            });
        }
    },

    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     */
    autofillFormAddressFromZipCode: function (zipCodeFormField /*, countryId, stateId, cityId, lang*/) {

        var zipCodeFormFieldId = zipCodeFormField.id;
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");

        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zipCodeFormField.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipCodeFormField.value;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                autofilledNeighborhood.val(data.addressInfo[0].neighborhood);
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
                var error = false;
                if (typeof zipCodeFormField.form.city !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.city);
                }
                if (typeof zipCodeFormField.form.state_full !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.state_full);
                }

                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                 		AddressHelper.zipCodeNotFound = true;
                 		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                 	}
                 	else {
                 		error=true;
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error (GoogleAPI): "+result.error_description);
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error: ",result.raw);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zipCodeFormField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
	                    $(zipCodeFormField.form).find("input[name=city]").val("");
	                    $(zipCodeFormField.form).find("input[name=state]").val("");
	                    $(zipCodeFormField.form).find("input[name=state_full]").val("");
                 	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zipCodeFormField.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zipCodeFormField, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
	                	var city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zipCodeFormField, "", true);
                     
	                    if(($('#errorAddressValidation').is(":visible") && $('#addressValidationFirstTime').val() == 'false') || $('#errorAddressValidation').is(":hidden")){
	                    	AddressHelper.addSuccesIcon(zipCodeFormField);
	                    }
	                    
                        AddressHelper.addSuccesIcon('#'+countryId);
                        AddressHelper.addSuccesIcon('#'+stateId);
                        AddressHelper.addSuccesIcon('#'+cityId);
                        
                	}
                }else{
                    AddressHelper.removeSuccesIcon(zipCodeFormField);
                        AddressHelper.removeSuccesIcon('#'+countryId);
                        AddressHelper.removeSuccesIcon('#'+stateId);
                        AddressHelper.removeSuccesIcon('#'+cityId);
                }
                var shippingSelected = $('.shipping_method_content input[name="singleShipmentShippingMode"]:checked').attr("typeshipping").toUpperCase();
                if(shippingSelected == 'COLLECT IN STORE') {
                    autofilledCity.classList.add("blockForBoss");
                    autofilledState.classList.add("blockForBoss");
                }

            });
        }
    },

    fillFormAddressFromAddressDataObject: function(destForm, addressObj){
        if (typeof destForm.city !== 'undefined') {
            destForm.city.value = addressObj.address.city;
        }
        if (typeof destForm.state !== 'undefined') {
            destForm.state.value = addressObj.address.prov_state_short;
        }
        if (typeof destForm.state_full !== 'undefined') {
            destForm.state_full.value = addressObj.address.prov_state;
        }
        if (typeof destForm.zipCode !== 'undefined') {
            destForm.zipCode.value = addressObj.address.zipcode;
        }
    },

    /**
     * Function that launches the command to join the newsletter with the email from the Shipping address
     */
    joinNewsletter: function (form, langId, storeId) {
        reWhiteSpace = new RegExp(/^\s+$/);

        var subscriptionOn = false;
        var updateop = true;
        if ($('#joinNewsletterCheck').is(':checked')) {
        	subscriptionOn = true;
        }else{
        	if(userType == 'R' ){
        		updateop = false;
        	}
        }

        var emailValue = $("#" + form).find("input[name='email1']").val();
        if (localStorage != undefined) {
            localStorage.setItem('encryptedUserEmail',md5(emailValue.toLowerCase()).toString());
            if(isPersol || isOliver || isVogue)
                localStorage.setItem('encryptedUserEmailSHA256',sha256(emailValue.toLowerCase().trim()).toString());
        }
        var fName = $("#" + form).find("input[name='firstName']").val();
        var lName = $("#" + form).find("input[name='lastName']").val();
        
        var cidCookie = null;
        
        if(document.cookie.includes('X_WC_CID')){
        	cidCookie = $.cookie("X_WC_CID");
        }
        
        // Validation of email not in blank and well-formed
        if (emailValue != undefined && emailValue != "" && !reWhiteSpace.test(trim(emailValue))
            && MessageHelper.isValidUTF8length(emailValue, 256)
            && MessageHelper.isValidEmail(emailValue)) {
            var params = {
                storeId: storeId,
                langId: langId,
                email: emailValue,
                viewName: "",
                subscription: subscriptionOn,
                firstName: fName,
                lastName: lName,
                update: updateop,
                isCheckoutForm: true,
                cid: cidCookie
            };

            cursor_wait();

            wcService.invoke("JoinNewsletterService", params);
        }

    }, 
    joinSMS: function (fromPopup) {
        var params = {};
        var phone1Value = $("input[name='phone1']").val();
        if(phone1Value.indexOf("+") == -1 && localStorage.prefixNumberPhone1 != 'undefined'){
            var phone1ValuePrefix = String(localStorage.prefixNumberPhone1) + String(phone1Value);
        }
        
        //start CRM - BANNER
        if(fromPopup){
        	params.isFromPopup = fromPopup;
        }else{
        	params.isFromPopup = false;
        }
        //end CRM - BANNER
        
        
        if (localStorage != undefined ) {
            if(phone1ValuePrefix != undefined){
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1ValuePrefix.trim().toLowerCase()).toString());
                if(typeof sha256(phone1ValuePrefix.toString()) === 'object' && typeof sha256(phone1ValuePrefix.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } ); 
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1ValuePrefix.toString()));
                
            }else{
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1Value.trim().toLowerCase()).toString());
                if(typeof sha256(phone1Value.toString()) === 'object' && typeof sha256(phone1Value.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } );  
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1Value.toString())); 
            }
        }

        wcService.declare({
            id: "JoinSMSCmdService",
            actionId: "JoinSMSCmd",
            url: "JoinSMSCmd",
        
            successHandler: function(serviceResponse) {
                if(serviceResponse.responseMessage == 'duplicate'){
                    $('#mce-error-sms-duplicate').show();
                    console.log("Duplicate - This Number is already registered");
                    if(serviceResponse.userSMSOptin != 'undefined')
                        tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }else if(serviceResponse.responseMessage == 'success'){
                    tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }
                if(isVogue)
                    localStorage.setItem('tealiumUserSMSOptin',tealiumUserSMSOptin);
            },
            failureHandler: function(serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
        }
        });
        if(userType == 'R'){
            params.userRegistered = 'true';
            params.user_id = userInfo.userId;
        }else{
            params.userRegistered = 'false';
            if(fromPopup){
            	 params.email = $("#homepageSmsPopupFormDiv .emailLbl input").val();
            	if(getUserId() == '-1002'){
            		userId = setUserIdentity();
            	}
            	params.user_id = userId;
            }
        }
        params.store_id = WCParamJS.storeId;
        params.language_id = WCParamJS.langId;
        params.phone1 = phone1Value;
        params.store_identifier = storeDirectory;
        
        var myaccountCheckbox = $("div[id*='WC_UserRegistrationAddForm_myAccount_CheckBoxSMS']").is(":visible");
        var checkoutCheckbox  = $("div[name*='checkbox-sms']").is(":visible");
        var homepagePopupCheckbox = $("div[id*='WC_homepageSmsPopupFormDiv_CheckBoxSMS']").is(":visible");

        if(myaccountCheckbox)
            params.receivesms = $('#WC_UserRegistrationAddForm_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(checkoutCheckbox)
            params.receivesms = $('#WC_shippingAddressCreateEditFormDiv_1_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(homepagePopupCheckbox)
        params.receivesms = $('#WC_homepageSmsPopupFormDiv_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        else if(userType == 'R' && !checkoutCheckbox)
            tealiumUserSMSOptin  = "1";
         
        if((params.phone1 != '' && params.phone1.match(/^\d+$/) != null ) && (checkoutCheckbox))
            wcService.invoke("JoinSMSCmdService", params);    
    },

    updatePhysicalStoresArea: function (zipCodeValue) {
        if (typeof displayPhysicalStoreOptionsInCheckoutShipping != "undefined" && displayPhysicalStoreOptionsInCheckoutShipping == true && zipCodeValue == undefined) {
            var zipcode = $('#WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_zipCode_1').val();
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipcode;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        } else if (zipCodeValue != undefined) {
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipCodeValue;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        }
    },

    saveSelectedPhysicalStoreForOrder: function(ordersId, stloc_id) {

        console.log("saveSelectedPhysicalStoreForOrder");
        $.ajax({
            type: "POST",
            url: "OrderPhysicalStoreAddUpdate?ordersId=" + ordersId + "&stloc_id=" + stloc_id + "&storeId=" + WCParamJS.storeId,
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            success: function (data) {
                console.log(" Selected physical store has been saved successfully");
            }, error: function (data) {
                console.log("An error has been occurred while trying to save the selected physical store");
            }
        });
    },

    /**
     * Funtion that fills the AddressForm from Thank you page with order data
     */
    fillFormAddressThankyouPage: function() {
        $('input[name="firstName"]').attr('value', $('.address #firstName').text());
        $('input[name="lastName"]').attr('value', $('.address #lastName').text());
        $("input[name='logonId']").attr('value', $('.address #emailAddress1').text());
        $("input[name='email1']").attr('value', $('.address #emailAddress1').text());
        $("input[name='usr_email1']").attr('value', $('.address #emailAddress1').text());
        if ($("input[name='middleName']"))
            $("input[name='middleName']").attr('value', $('.address #middleName').text());
        $("input[name='usr_address1']").attr('value', $('.address #addressLine1').text());
        $("input[name='usr_address2']").attr('value', $('.address #addressLine2').text());
        $("input[name='usr_zipCode']").attr('value', $('.address #postalCode').text());
        $("input[name='usr_city']").attr('value', $('.address #city').text());
        $("input[name='usr_state']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_stateName']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_phone1']").attr('value', $('.address #telephone1').text());
    },
        //START - new functions for checkout_3_0 Oliver/Persol
    updateUnregisteredCheckoutAddressAndGoPaymentStep: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        loadAddressInfo(); // added for checkout 3.0
                       // location.href = onSuccessURL; //non deve più essere indirizzato nella view succesiva 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 loadAddressInfo(); // added for checkout 3.0
                                 //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
               // form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    addSuccesIcon: function (formField) {
          
               // $(formField).parent().addClass('validCheck');

                $(formField).parent().removeClass('isNotValid');
                
                if($(formField).siblings('.address-erros-message-cont').length > 0){
                	$(formField).siblings('.address-erros-message-cont').remove();
                }
                
                if($(formField).attr('formtmoreturn') && (isOliver || isPersol) && $('.form-page-container .find-order-wrapper .form-container .input-style input#email').length  > 0){
                	if($('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').length > 0){
                		$('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').remove();
                    }
                }
                
                if (typeof formField === 'string'){
                	if(formField.includes("country")){
                    	//$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').hide();
                    }
                }else{
                    $(formField).parent().addClass('validCheck');
                }
                
                
    },

    removeSuccesIcon: function (formField) {
          
        $(formField).parent().removeClass('validCheck');
        if($(formField).hasClass('field-error-message')){
            $(formField).parent().addClass('isNotValid');
        }
        
        if($(formField).attr('formtmoreturn')){
        	$(formField).parent().addClass('isNotValid');
        }
        
        
        if (typeof formField === 'string'){
        	if(formField.includes("country")){
            	$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').show();
            }
        }
}
//END - new functions for checkout_3_0 Oliver/Persol
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */



shoppingActionsServicesDeclarationJS = {

	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxCustomRESTOrderItemAdd",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {

			if(productDisplayJS.wasEngraved && productDisplayJS.wasEngraved != null && productDisplayJS.wasEngraved != undefined) {
				var wasEngravedOrderItems = JSON.parse(sessionStorage.getItem("wasEngravedOrderItems"));
				if(checkIsNull(wasEngravedOrderItems)) {
					wasEngravedOrderItems = [];
				}
				wasEngravedOrderItems.push(serviceResponse.orderItemId[0]);
				sessionStorage.setItem("wasEngravedOrderItems", JSON.stringify(wasEngravedOrderItems));
			}

			//START Wunderkind
			if(typeof updateWkndCartValue == 'function') {
				updateWkndCartValue();
			}
			//END Wunderkind
			MessageHelper.hideAndClearMessage();
			// Do not show this message. When item is added, we open up mini cart to display the currently added item.
			// MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
            cursor_clear();
            
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END
            
			if(shoppingActionsJS){

				var attributes_container = $('div[id^="attrValue_"]');

				if (($(".definingAttributes")[0]) != null) {
					var attributes_container = $(".definingAttributes");
				}
				else if (($(".product_sizes")[0]) != null) {
					var attributes_container = $(".product_sizes");
				}
				else if (($(".product_info")[0]) != null) {
					var attributes_container = $(".product_info");
				}

				var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

				var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

				var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					wcTopic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}

			//BEGIN Lens Configurator
			//update prescription with the generated orderitemsid from cart service
			if(productDisplayJS.prescription === true){
                _prescriptionObject = $.cookie("_prescriptionObject");
				if(_prescriptionObject != undefined){
                    $.ajax({
                        url: "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self",
                        method: "GET",
                        async: false,
						headers: {
							"Content-Type": "application/json",
							"Cache-Control": "no-cache, no-store, must-revalidate"
						},
						data: {
							"timestamp": Date.now()
						},
                        success: function(data) {
                                var maxOrderItemId = 0;
								var roxFrameSelected = $('#roxFrameID').val();
                                //retrieve object with roxframeId in the array orderitem and extract the orderitemsid
                                //in case there are more than one item with same catentry take the greater one
                                $.each(data.orderItem,(index,element) => {
                                    if(element.productId === roxFrameSelected && maxOrderItemId < element.orderItemId){
                                        console.log(element.orderItemId);
                                         maxOrderItemId = element.orderItemId;
                                    }
                                });
                                
                                _prescriptionObject = JSON.parse(_prescriptionObject);
                                parameters = {};
                                parameters.orderItemsId = maxOrderItemId;
                                parameters.prescriptionId = _prescriptionObject.prescriptionId;
                                
                                parameters.type = "S";
                                if (productDisplayJS.lensOptionValue === "Progressive"){
                                    parameters.type = "P";
                                }
                                
                            
                                var docStr = generateXML(parameters);
                                var xmldoc = {};
                                xmldoc.XML = docStr;
                                //asynchronous call: if the prescription hasn't be updated it will not go to the cart
                                AddPrescription(xmldoc).then(function(){
                                    console.log("prescription updated with orderitemsid"  + parameters.orderItemsId);
                                    
                                    /* remove cookie when item have been added to cart so if the same user add a new prescription
                                     both for error (more the one prescription are not allowed) or for replace the old one
                                     it will be treated as new prescription in the configurator */
                                     //$.removeCookie("_prescriptionObject");
									 $.removeCookie("_userId");
                                    goToCart2();
                                }).catch(function(){
									console.log("prescription not updated");
                                    console.log("orderitemsId used" + parameters.orderItemsId);

								});
                        
                        },
                        error: function(err) {
                            console.log("failed to updated the prescription");
                        }
                    });
                }else{
                    //it has choosen the send it later option
                    goToCart2();
                }
			}


			if(productDisplayJS.isFrameOnly){ //this if is necessary because the sunglasses still have add to cart button 
				//it has choose the frame  only option
				goToCart2();
			}

			//END
			
			wcTopic.publish('ProductAddedToCart');
			
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {
		    if(productDisplayJS && productDisplayJS.YMALProductFlag) //reset flag if add fails
				productDisplayJS.YMALProductFlag = false;
				
		    var productUPC = $('#parentProductUpc').val();
			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else if ("_API_CANT_RESOLVE_FFMCENTER" == serviceResponse.errorMessageKey) {
 		            MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
 		        } else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			 	
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING" || serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE" 
                    || serviceResponse.errorMessageKey == "_API_CANT_RESOLVE_FFMCENTER" || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
                   trackAddToCartFailure('Product', serviceResponse.errorMessage, productUPC);
                }
                else{
                   trackAddToCartFailure('Server', serviceResponse.errorMessage, productUPC); 
                }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					trackAddToCartFailure('Product', serviceResponse.errorMessageKey, productUPC);
				 }
			}

			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}

			cursor_clear();
		}

	}),

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT",{0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})

/*
 * Common utilities for all brands in the NERD project
 */

/**
 * isMobile https://github.com/kaimallea/isMobile
 * This function detects mobile devices and then it then creates a JavaScript object with the results.
 * version 0.5.1
 */
!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,l=/\bAndroid(?:.+)SD4930UR\b/i,b=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,u=/\bWindows(?:.+)ARM\b/i,c=/BlackBerry/i,s=/BB10/i,v=/Opera Mini/i,h=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/\Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(l,i),tablet:!m(l,i)&&m(b,i),device:m(l,i)||m(b,i)},android:{phone:!m(f,i)&&m(l,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(l,i)&&!m(a,i)&&(m(b,i)||m(p,i)),device:!m(f,i)&&(m(l,i)||m(b,i)||m(a,i)||m(p,i))},windows:{phone:m(f,i),tablet:m(u,i),device:m(f,i)||m(u,i)},other:{blackberry:m(c,i),blackberry10:m(s,i),opera:m(v,i),firefox:m(w,i),chrome:m(h,i),device:m(c,i)||m(s,i)||m(v,i)||m(w,i)||m(h,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=i():"function"==typeof define&&define.amd?define([],e.isMobile=i()):e.isMobile=i()}(this);

/**
 * replaceAll function. Replaces all occurrences of a string (since the js replace function only replaces the first one)
 * @param {String} search String to search for
 * @param {String} replacement Replacement string
 * @returns String with all replacements done
 */
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function plog(str){
    console.log(new Date().toISOString()+"::PSL::"+str);
}
/** custom function  **/
window.setQueryParams = function (url, params) { // case 2
    let pasreUrl = url.split('?')[0];
    let result =  pasreUrl + params;
    return result;
}

window.setAttr = function (id, attributeName, url, params) { // per jsp
    let tag = document.getElementById(id)
    if (tag)  tag.setAttribute(attributeName, window.setQueryParams(url, params))
}

/**
 * HB-1995 Checkout | Payment | AMEX card: add field validation CVV should have 4 digits (3 if cc is not amex)
 */

/**
 * This function check if the credit card passed as parameter is an American Express
 * Following this guide: https://www.cybersource.com/developers/getting_started/test_and_manage/best_practices/card_type_id/
 * Amex rules are: Valid length: 15 digits. First digit must be a 3 and second digit must be a 4 or 7.
 *
 * @param {String} ccNumber Credit card number with or without spaces
 * @param {boolean} strictTest If false this function will only test the first digits condition
 */
function isAmexCreditCard(ccNumber, strictTest){
    var ccNumberParsed;
    if (ccNumber.includes(" ")){
        ccNumberParsed = ccNumber.split(" ");
        ccNumberParsed = ccNumberParsed.join("");
    } else {
        ccNumberParsed = ccNumber;
    }
    if (ccNumberParsed.length<2){
        return false;
    }else{
        var ccHead = ccNumberParsed.substring(0,2);
        //Check if the credit card is American Express
        if (ccHead != "34" && ccHead != "37"){
            return false;
        } else {
            if (strictTest){
                if (ccNumberParsed.length == 15){
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    }
}




function addDirectToCart(moco) {
	  //Declare a service for retrieving catalog entry detailed information for an item...
	isAdd2CartClicked=true;
	
	 var parameters = {
           moco : moco 
       };

	 
  wcService.declare({
      id: "GetCatalogEntryByMocoCmd",
      actionId: "GetCatalogEntryByMocoCmd",
      url: "GetCatalogEntryByMocoCmd",
      
      successHandler: function (serviceResponse) {
    	  //productDisplayJS.productAdd2Cart('entitledItem_'+serviceResponse.catentry);
    	  productDisplayJS.Add2ShopCartAjax('entitledItem_'+serviceResponse.catentry,1, false);
          productPageAdd2Cart();
          
          showDropdown=true;
          
          if (showDropdown && isVogue) {
        	  $('#shoppingCart').addClass('open');
              $('#MiniShopCartProductAdded').show();
              update_content = true;
              //We have added item to cart..So display the drop down with item added message..
              positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
              showDropdown = false;
              populateProductAddedDropdown();
          }
      },
      failureHandler: function (serviceResponse) {
          console.debug("We can't add to cart Item "+moco);
      }
  });
	 
  wcService.invoke("GetCatalogEntryByMocoCmd", parameters);
  
}





function GetCardType(number) {

	var retval="";
	
	var re = new RegExp("^4");
	if (number.match(re) != null)
		retval = "Visa";

	// Mastercard
	// Updated for Mastercard 2017 BINs expansion
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
    	retval = "MasterCard";

	// AMEX
	re = new RegExp("^3[47]");
	if (number.match(re) != null)
		retval = "Amex";

	// Discover
	re = new RegExp(
			"^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
	if (number.match(re) != null)
		retval = "Discover";

	// Diners
	re = new RegExp("^36");
	if (number.match(re) != null)
		retval = "Diners";

	// Diners - Carte Blanche
	re = new RegExp("^30[0-5]");
	if (number.match(re) != null)
		retval = "Diners";

	// JCB
	re = new RegExp("^35(2[89]|[3-8][0-9])");
	if (number.match(re) != null)
		retval =  "JCB";

	
	if(retval != '')
		return retval;
	else
		return "CC";

}

/**
 * This function changes the maxlength of the CVV input field, according to the
 * card number input value
 * 
 * @param {String}
 *            ccInputId Id of the credit card input field
 * @param {String}
 *            cvvInputId Id of the cvv input field
 */
function updateCVVInputLength(ccInputId, cvvInputId){
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    document.getElementById(cvvInputId).setAttribute("maxlength", maxVal);
}

/**
 * This function tests if the cvv length is valid for the credit card number passed as paramenter
 * Currently the logic is:
 *  If the card is Amex and ccv lenght = 4, then return true,
 *  if the card is not Amex and ccv lenght = 3, then return true,
 *  otherwise return false
 *
 * @param {String} ccNumber Credit card number
 * @param {String} cvv CVV number
 */
function matchCreditCardCVV(ccNumber, cvv){
    if (isAmexCreditCard(ccNumber, false)){
        //is American Express
        if (cvv.length==4){
            return true;
        }else{
            return false;
        }
    } else {
        //not American Express
        if (cvv.length==3){
            return true;
        }else{
            return false;
        }
    }
}

/* HB-1995 END ******************************************************************************/

/**
 * This function validates the maxlength of the CVV input field, according to the type of card card gotten from the input value of the card field
 *
 * @param {String} ccInputId Id of the credit card input field
 * @param {String} cvvInputId Id of the cvv input field
 */
function validateCVVInputLength(ccInputId, cvvInputId) {
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    var ccvInputValue = document.getElementById(cvvInputId).value;
    if (undefined != ccvInputValue && "" !== ccvInputValue) {
    	if (ccvInputValue.length != maxVal) {
    		$("#wrongCVVLength").css("display", "block");
    	} else {
    		$("#wrongCVVLength").css("display", "none");
    	}
    }
}

/**
 * getGoogleAddress(countryCode, zipCode, language, callbackFunction)
 *
 * This function provides a common interface to access the Google Address API.
 * First it makes an async call to Google API sending required parameters and,
 * when the response is received, it parses the data to fit our requirements.
 * Finally launches callbackFunction sending the parsed data object as parameter.
 *
 * Usage: e.g. (Named function)     getGoogleAddress("ES","15001", "es", myFunction);
 *             (Anonymous function) getGoogleAddress("ES","15001", "es", function(data){
 *                                      //Your code here
 *                                      //At this point data is an object with all the address info
 *                                  });
 *
 * Parsed address object:
 *      {
 *          status : <success | error>,
 *          error_description : <error description (only when status = error)>,
 *          address :
 *              {
 *                  city : <city name>,
 *                  country : <country name>,
 *                  country_short : <short country name>,
 *                  locality : <locality name>,
 *                  neighborhood : <neighborhoodId name>,
 *                  prov_state : <province name (state in the US), e.g."Citta Metropolitana di Milano">,
 *                  prov_state_short : <short province name (state in the US) e.g."MI">
 *                  zipcode : <zip code>
 *              },
 *          raw :
 *              {
 *                  <data object received from Google API>
 *              }
 *      }
 *
 * Usage samples:
 *    getGoogleAddress("US","10462", "en", showAddressData);
 *    getGoogleAddress("ES","15001", "es", showAddressData);
 *    getGoogleAddress("IT","20099", "it", showAddressData);
 *    getGoogleAddress("FR","20099", "it", showAddressData);
 *    getGoogleAddress("US","10462", "en", function(result){
 *        if (result.status == "error"){
 *            console.log(result.error_description);
 *        } else {
 *            console.log(result);
 *        }
 *    });
 *
 *
 * @param {String} countryCode e.g."ES"
 * @param {String} zipCode e.g."15001"
 * @param {String} language e.g. "es"
 * @param {function} callbackFunction
 */
function getGoogleAddress(countryCode, zipCode, language, callbackFunction){
    try{
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            componentRestrictions: {
              country: countryCode,
              postalCode: zipCode
            }
          }, function(results, status) {
            
                if(status != "OK"){
                    if(AddressHelper.zipCodeNotFound ||status == "ZERO_RESULTS") {
                        zipCodeError = false;
                    }
                    else {
                        zipCodeError = true
                    }
                }
                else{
                    zipCodeError=false;
                }
                
                findAddressInformation(results);
            
          });
    }catch(e){
        console.log("getGoogleAddress : the promise constructor cannot be invoked directly");
    }
    

      function findAddressInformation (results){
            var city = null;
            var locality = null;
            var neighborhood = null;
            var maxNeighborhoodlenght = 31;
            var province = null;
            var province_short = null;
            var postalCode = null;
            var administrativeArea2 = null;
            var administrativeArea1 = null;
            var administrativeArea3 = null;
            var administrativeArea2_short = null;
            var administrativeArea1_short = null;
            var administrativeArea3_short = null;
            var country = null;
            var country_short = null;
            var responseObj={};
            var addressData={};

            if (results == null || results[0] == null ||  results[0].address_components == null || results[0].address_components.length == 0
                    || (results[0].address_components.length == 1 && results[0].address_components[0].types[0] == "country")) {

                responseObj.status = "error";
                responseObj.error_description = "zipcode_not_found";
                responseObj.raw = results;

            } else {

                if (results != null && results[0] != null) {
                    var addressComponents = results[0].address_components;
                    for (var i = 0; i < addressComponents.length; i++) {

                        if (addressComponents[i].types[0] == "postal_code") {
                            postalCode = addressComponents[i].long_name;
                        }
                        //getting city
                        if (addressComponents[i].types[0] == "postal_town") {
                            city = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "country") {
                            country = addressComponents[i].long_name;
                            country_short = addressComponents[i].short_name;
                        }
                        //getting locality
                        if (addressComponents[i].types[0] == "locality") {
                            locality = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "neighborhood") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        if (addressComponents[i].types[2] == "sublocality_level_1") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        //getting administrative Area1 (state)
                        if (addressComponents[i].types[0] == "administrative_area_level_1") {
                            administrativeArea1 = addressComponents[i].long_name;
                            administrativeArea1_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area2
                        if (addressComponents[i].types[0] == "administrative_area_level_2") {
                            administrativeArea2 = addressComponents[i].long_name;
                            administrativeArea2_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area3
                        if (addressComponents[i].types[0] == "administrative_area_level_3") {
                            administrativeArea3 = addressComponents[i].long_name;
                            administrativeArea3_short = addressComponents[i].short_name;
                        }
                    }
                }

                if (city == null) {

                    if (locality == null){
                        if (neighborhood == null){
                            if (administrativeArea3 == null){
                                city = administrativeArea2;
                            } else {
                                city = administrativeArea3;
                            }
                        } else {
                            city = neighborhood;
                        }
                    } else {
                        city = locality;
                    }
                }

                // For america and canada administrativeArea1 represents the province
                // For italy and spain this value is stored on administrativeArea2
                if (country_short === 'ES') {
                    province = administrativeArea2;
                    province_short = zipCode.substring(0,2);
                    //HB-5761: revert HB-5556
                    //province_short = administrativeArea2_short; 
                } else if (country_short === 'IT') {
                    province = administrativeArea2;
                    province_short = administrativeArea2_short;
                } else {
                    province = administrativeArea1;
                    province_short = administrativeArea1_short;
                }

                addressData.city = city;
                addressData.locality = locality;
                addressData.neighborhood = neighborhood;
                addressData.prov_state = province;
                addressData.prov_state_short = province_short;
                addressData.country = country;
                addressData.country_short = country_short;
                addressData.zipcode = postalCode;

                /*
                addressData.administrativeArea1 = administrativeArea1;
                addressData.administrativeArea2 = administrativeArea2;
                addressData.administrativeArea3 = administrativeArea3;
                addressData.administrativeArea1_short = administrativeArea1_short;
                addressData.administrativeArea2_short = administrativeArea2_short;
                addressData.administrativeArea3_short = administrativeArea3_short;
                */
                
                responseObj.status = "success";
                responseObj.address = addressData;
                responseObj.raw = results;

                
            }
            callbackFunction(responseObj);
        
      }


}

function getGoogleAddressPromise(countryCode, zipCode, language){
   return new Promise(function(resolve, reject) {
                var geocoder = new google.maps.Geocoder();
        
                geocoder.geocode({
                    componentRestrictions: {
                    country: countryCode,
                    postalCode: zipCode
                }
                }, function(results, status) {
                        var data= {
                        results:"",
                         status:""
                        }
                    if (status == 'OK') {
                        zipCodeError=false;
                        data.results=results;
                        data.status= status;
                        resolve(data);
                    } else {     	
                        reject(function(data){
                            console.log("UnregisteredCheckout.jsp::","Zip code unknown");
                        });
       
                    }
       
                  });
    });
      
}

function convertGoogleAddressResponse(data){
    var responseObj = {};

    if (data.status != "OK"){
        responseObj.status = "error";
        responseObj.error_description = "google_api_error";
        responseObj.raw = data;
    } else {
        var addressData = {};

        var city = null;
        var locality = null;
        var neighborhood = null;
        var province = null;
        var province_short = null;
        var postalCode = null;
        var administrativeArea2 = null;
        var administrativeArea1 = null;
        var administrativeArea3 = null;
        var administrativeArea2_short = null;
        var administrativeArea1_short = null;
        var administrativeArea3_short = null;
        var country = null;
        var country_short = null;

        if (data == null || data.results[0] == null ||  data.results[0].address_components == null || data.results[0].address_components.length == 0
                || (data.results[0].address_components.length == 1 && data.results[0].address_components[0].types[0] == "country")) {

            responseObj.status = "error";
            responseObj.error_description = "zipcode_not_found";
            responseObj.raw = data;

        } else {

            if (data != null && data.results[0] != null) {
                var addressComponents = data.results[0].address_components;
                for (var i = 0; i < addressComponents.length; i++) {

                    if (addressComponents[i].types[0] == "postal_code") {
                        postalCode = addressComponents[i].long_name;
                    }
                    //getting city
                    if (addressComponents[i].types[0] == "postal_town") {
                        city = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "country") {
                        country = addressComponents[i].long_name;
                        country_short = addressComponents[i].short_name;
                    }
                    //getting locality
                    if (addressComponents[i].types[0] == "locality") {
                        locality = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "neighborhood") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[2] == "sublocality_level_1") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    //getting administrative Area1 (state)
                    if (addressComponents[i].types[0] == "administrative_area_level_1") {
                        administrativeArea1 = addressComponents[i].long_name;
                        administrativeArea1_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area2
                    if (addressComponents[i].types[0] == "administrative_area_level_2") {
                        administrativeArea2 = addressComponents[i].long_name;
                        administrativeArea2_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area3
                    if (addressComponents[i].types[0] == "administrative_area_level_3") {
                        administrativeArea3 = addressComponents[i].long_name;
                        administrativeArea3_short = addressComponents[i].short_name;
                    }
                }
            }

            if (city == null) {
                //city = locality == null ? (neighborhood == null ? (administrativeArea3 == null ? administrativeArea2 : administrativeArea3) : neighborhood) : locality;
                if (locality == null){
                    if (neighborhood == null){
                        if (administrativeArea3 == null){
                            city = administrativeArea2;
                        } else {
                            city = administrativeArea3;
                        }
                    } else {
                        city = neighborhood;
                    }
                } else {
                    city = locality;
                }
            }

            // For america and canada administrativeArea1 represents the province
            // For italy and spain this value is stored on administrativeArea2
            if (country_short === 'ES') {
                province = administrativeArea2;
                //province_short = postalCode.substring(0,2);
                //fix
                province_short = administrativeArea2_short;
            } else if (country_short === 'IT') {
                province = administrativeArea2;
                province_short = administrativeArea2_short;
            } else {
                province = administrativeArea1;
                province_short = administrativeArea1_short;
            }

            addressData.city = city;
            addressData.locality = locality;
            addressData.neighborhood = neighborhood;
            addressData.prov_state = province;
            addressData.prov_state_short = province_short;
            addressData.country = country;
            addressData.country_short = country_short;
            addressData.zipcode = postalCode;

            responseObj.status = "success";
            responseObj.address = addressData;
            responseObj.raw = data;
        }
    }

    return responseObj;
}

function getUserAddressListPromise(){
    var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
    return $.ajax({
        method: "GET",
        url: url,
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        data: {
            "timestamp": Date.now()
        },
        dataType: "json"
    });
}

function updateCurrentOrderShippingDatePromise(){
    var time = "0700";
    if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
        time = "1200";
    } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
        time = "1800";
    }

    var date = $("#datepicker-holder").datepicker('getDate');
    var formattedDate = $.datepicker.formatDate("yymmdd", date);

    $.ajax({
        type: "POST",
        url: "AjaxShippingDateUpdate?requestType=update&shippingDate=" + formattedDate + time + "&ordersId=.&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId,
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate"
        }
    });
}



/**
 * This function transform a jQuery ajax error response to a string error message
 * Usage:
 *   $.ajax({
 *       ...
 *       success: function (data) {
 *           ...
 *       },
 *       error: function(jqXHR, exception){
 *           console.log(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
 *       },
 *       complete: function(){
 *           ...
 *       }
 *   });
 *
 * @param {Object} jqXHR
 * @param {String} exception
 * @returns {String} Error message
 */
function getAjaxErrorMessage(jqXHR, exception){
    var msg = "";
    if (jqXHR.status === 0) {
        msg = "Not connected.\n Verify Network.";
    } else if (jqXHR.status == 404) {
        msg = "Requested page not found. [404]";
    } else if (jqXHR.status == 500) {
        msg = "Internal Server Error [500].";
    } else if (exception === "parsererror") {
        msg = "Requested JSON parse failed.";
    } else if (exception === "timeout") {
        msg = "Time out error.";
    } else if (exception === "abort") {
        msg = "Ajax request aborted.";
    } else {
        msg = "Uncaught Error.\n" + jqXHR.responseText;
    }

    return msg;
}
/**
 * @desc Compare arrays
 * @param {Array} array
 * @see https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript?page=1&tab=votes#tab-top
 * @return True or False
 */

// Warn if overriding existing method
if (Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");

// Attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array) {
    // If the other array is a falsy value, return
    if (!array) return false;

    // Compare lengths - can save a lot of time
    if (this.length != array.length) return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // Recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

/**
 * Add NodeList.forEach and Element.remove support to IE9+
 */
(function() {
    if (typeof NodeList.prototype.forEach !== "function"){
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    if (typeof Element.prototype.remove !== "function"){
        Element.prototype.remove = function(){
            this.parentElement.removeChild(this);
        }
    }
})();

/**
 * This function creates a cookie named 'WC_X_LoggedUser=No' when the user is G (guest).
 * If the storeUserType changes to registered, the cookie is deleted by the function.
 * This function helps Akamai to determinate if the jsp should be cached or not.
 * NERD-761
 * 23-11-23
 * hb-14987 --> in this function is been added sessionStorage["logged"] = 'false'; 
 * 				to indicated the user is not logged
 * 			    
 */

loggedUserCookieManager();

function loggedUserCookieManager(){
    //If the user is G=Guest, creates the cookie
    if (storeUserType === "G"){
        document.cookie="WC_X_LoggedUser=No;;path=/";

    }
    //Otherwise, the cookie is deleted
    else{
        var today = new Date();
        today.setTime(today.getTime() - 1000);
        var expires = "expires="+today.toUTCString();
        document.cookie="WC_X_LoggedUser=;" + expires + ";path=/";
    }
}




function getTaxesFromZipCodePromise(srcForm){
    if (!AddressHelper.hasTaxes){
        return "";
    }else{
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var city = srcForm.city.value;
        var state = srcForm.state.value;
        var zipcode = srcForm.zipCode.value;

        // submit AjaxOrderCalculate request
        var params = [];

        params.storeId      = WCParamJS.storeId;
        params.catalogId    = WCParamJS.catalogId;
        params.langId       = WCParamJS.langId;

        params.updatePrices = "0";
        if(isCheckOut){
            params.orderId = ".";
        } else {
            params.orderId = $('#wcs_calTax_notification #orderId').val();
        }

        params.addressFlag = true;
        params.isDeliveryAddressAdded = false;
        params.zipCode = zipcode != null ? zipcode : "";
        params.city = city != null ? city : "";
        params.state = state != null ? state : "";
        params.country = "us";
        params.isZipChange = true;//isZipChange;

        var url = getAbsoluteURL() + "AjaxOrderCalculate?";
        for (var param  in params) {
            url += param + "=" + params[param] + "&";
        }
        url += "calculationUsageId=-1&";
        url += "calculationUsageId=-2&";
        url += "calculationUsageId=-3&";
        url += "calculationUsageId=-4";

        //Make the call to AjaxOrderCalculate
        return $.ajax({
            url: url,
            type: 'POST',
        });
    }
}

function goToOrderShippingBillingViewOnClickHandler(event){
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    let isFormNoError = true; //true if form is without error in checkout 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }
    
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    form2.email1.value=form1.email1.value;
    if(isFormNoError){
        isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    }else {
        AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>')
    }
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
                  if (typeof data.contact === 'undefined'){
                      plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                      AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                  } else {
                      for (var i = 0; i<data.contact.length; i++){
                          if (data.contact[i].nickName == 'MyAddress_Shipping'){
                              plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                              AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                              break;
                          }
                      }
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
        	if(AddressHelper.validateAddressForm(form3)) {
        		/*
        		 * //REPLACE BOSS: 
        		 * 70128 with zipcode of pickupstore
        		 * we will take this zipcode by the tab services
        		 
        		getGoogleAddressPromise(countryCode, '70128', storeLanguage) 
		        .then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + '70128' + " not valid for country "+countryCode;
		            } else {
		            	/*
		            	 * REPLACE BOSS: 
		            	 * var city will be the city of store
		            	 * we will take this city by the tab services
		            	
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_billingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form3, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form3);
		        }).then(function(data){
		        	//Billing Address
		            return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		        }).then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		            	formValidationError = true;
		                throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		            } else {
		            	AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		            }
		            return getUserAddressListPromise();
		        }).then(function(data){
			    	if (typeof data.contact !== 'undefined'){
			        	for (var i = 0; i<data.contact.length; i++){
			            	if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
			                	AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
			                    plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
			                }
			            }
			        }
			    }, function(err){
			    	 console.log(err);
			    }).then(function(){
		            if (!AddressHelper.validateAddressForm(form3)){
		                formValidationError = true;
		            }
		            if (!AddressHelper.validateAddressForm(form2)){
		            	formValidationError = true;
		           	}
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            AddressHelper.joinNewsletter('recipient_detail', WCParamJS.langId, WCParamJS.storeId);
		            
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv2');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, false, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        }); 
        	}
        }else{*/
	    	if(AddressHelper.validateAddressForm(form1)) {
                if(isFormNoError)
                    isFormNoError  = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		
		            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
		
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        })
	    	}else{
                isFormNoError = false;
            }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError){ 
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc'); 
    }  
}


// NERD-760 Functions that help Akamai to determinate if it is necesary to activate the cache depending if the user is logged and / or if there are items on cart

/**
 * This function calls updateItemsInCartBadge() passing it the number of items that have been added to the cart by the user.
 * NERD-762
 */
function getNumberOfItemsInCart(){
    if(personInfo.userId !== '-1002' || (isVogue && document.querySelectorAll('.pdp').length > 0)){
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
        getAjaxCallInfo(url, null, numberOfItemsInCartCallback);

        function numberOfItemsInCartCallback(response) {
            if(response.recordSetTotal !== '0') {
                var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self";
                getAjaxCallInfo(url, null, orderitemsInfoInCartCallback);
            } else {
                updateItemsInCartBadge(response.recordSetTotal);
            }
        }
        function orderitemsInfoInCartCallback(response) {
        	var total= 0;
        	if(response != undefined && response.recordSetTotal != 0) {
        		total = response.recordSetTotal;
        		response.orderItem.forEach(function(item) {
        			if(item.partNumber.includes('Service') || item.partNumber.endsWith("SV") || item.partNumber.endsWith("PG") ) { //non contare engraving, lenti e servizi 
        				total-=1;
                    }
        		});
        		
        	}
        	updateItemsInCartBadge(total);
            /**if(response.orderItem) {
                for(var i = 0; i < response.orderItem.length; i++) {
                    if((response.orderItem[i].xitem_field2 && (response.orderItem[i].xitem_field2).indexOf("|") !== -1)
                     || (response.orderItem[i].partNumber && (response.orderItem[i].partNumber).indexOf("K-") !== -1)) {
                        total--;
                    }
                }
                updateItemsInCartBadge(total);
            }*/
        }
    }
}

/**
 * This function updates the number rendered into the shoping bag badge according to the number of items included in the cart.
 * As well, if the amount is equal to 0, adds the class 'empty' to the element.
 * @param {*} itemsInCartBadge Amount of items added to the cart by the user.
 * NERD-762
 */

var itemsInCartBadge = "0";
function updateItemsInCartBadge(paramItemsInCart){

    var itemsInCartBadgeElement;
    if (document.getElementById("minishopcart_total") !== null) {
        itemsInCartBadgeElement = document.getElementById("minishopcart_total");
    } else {
        itemsInCartBadgeElement = "0";
    }
    itemsInCartBadge = paramItemsInCart;
    itemsInCartBadgeElement.innerHTML  = itemsInCartBadge;

    if (itemsInCartBadgeElement.innerHTML === "0"){
        itemsInCartBadgeElement.classList.add("empty");
    }

    if(isPersol && paramItemsInCart > 0){
    	var minicartHtml = $('#minishopcart_total');
    	if(minicartHtml.length == 0){
    	minicartHtml = $('<div/>',{id: 'minishopcart_total', class: 'minishopcart-quantity-number'});
    	}
    	minicartHtml.text(paramItemsInCart);
    	$('#widget_minishopcart').prepend(minicartHtml);
    }
    
    if(isVogue) {
        var shopElem =  document.getElementById('shoppingCart');
        var isPDP = document.querySelectorAll('.pdp').length > 0;
        if(isPDP) {
            if(!isAdd2CartClicked && personInfo.userId === '-1002') {
                shopElem.classList.remove('fill');
            } else if(isAdd2CartClicked) {
                shopElem.classList.remove('fill','added');
                shopElem.classList.add('added');
                isAdd2CartClicked = false;
            } else if(!isAdd2CartClicked && personInfo.userId !== '-1002' && paramItemsInCart !== '0' && paramItemsInCart !== '') {
                shopElem.classList.add('fill');
            }
        } else {
            if(itemsInCartBadgeElement.innerHTML !== "0") {
                shopElem.classList.add('fill');
            } else {
                shopElem.classList.remove('fill');
            }
        }
    }
}

/**
 * Function that make a GET ajax call and execute a callback if success
 * @param {string} url - the url to make the ajax call
 * @param {object} params - ajax call params if its needed
 * @param {function} callback - function that it will be executed if ajax call is success
 */
function getAjaxCallInfo(url, params, callback) {
    var parameters = {};
    if(params) {
        parameters = params;
    }
    parameters["timestamp"] = Date.now();
    $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters,
        success: function (response, textStatus, request) {
            callback(response);
        },
        error: function(response){
            console.log(response);
            if(typeof pageType != "undefined")
				callback(response);
        }
    });
}

// BEGIN NERD-795 PSD2 | Front-end | Adaptation
// Those functions are called from servicesDeclaration.js AjaxSubmitOrder service
    /**
     * This function creates a dark overlay with a loader spinner that fits the whole page and adds a 'noScroll' class to the body.
     * The scope is to improve the UX while the PSD2 payment is in process.
     */
    function createPaymentLoaderOverlay(){
        $("body").append("<div class='paymentLoaderOverlay'></div>");
        $('body').addClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner that fits the whole page and removes a 'noScroll' class from the body.
 */
    function deletePaymentLoaderOverlay(){
        $(".paymentLoaderOverlay").remove();
        $('body').removeClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner when any error message is closed by clicking on its closing buton
 */
    $(function(){
        $('#clickableErrorMessageImg').click(deletePaymentLoaderOverlay);

    });

// END NERD-795 PSD2 | Front-end | Adaptation
// BEGIN HB-3160: recover parameter from URL generic function.
/**
 * Recover a parameter from URL, returning the default value if does not exist.
 *
 * @param parameter Parameter name
 * @param defaultValue Parameter default value when it does not exist in URL
 * @return Parameter value
 */
function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        urlparameter = vars[parameter];
        if (urlparameter === undefined || urlparameter === null) {
            urlparameter = defaultvalue;
        }
    }
    return urlparameter;
}
// END HB-3160

/**
 * HB-3032 | All | Analytics | Do not push to Tealium certain payment response codes
 * This variable is used in Stores/WebContent/<Brand>SAS/javascript/ServicesDeclaration.js, in failureHandler of AjaxRESTOrderSubmit service
 *
 * Those response values are not application errors so they should not be shown in Analytics
 * 202 - Expired card
 * 203 - Card refused
 * 204 - Insufficient funds
 * 205 - Stolen card
 * 208 - Inactive card
 * 209 - CVN doesn't match
 * 210 - Reached the credit limit
 * 211 - Invalid CVN
 * 230 - Soft decline
 * 231 - Invalid account number
 * 233 - General decline
 * 481 - Decision manager decline (now managed by Forter)
 */

var paymentResponseCodesNotWCSError = [
    "PLUGIN_RC_202",
    "PLUGIN_RC_203",
    "PLUGIN_RC_204",
    "PLUGIN_RC_205",
    "PLUGIN_RC_208",
    "PLUGIN_RC_209",
    "PLUGIN_RC_210",
    "PLUGIN_RC_211",
    "PLUGIN_RC_230",
    "PLUGIN_RC_231",
    "PLUGIN_RC_233",
    "PLUGIN_RC_481"
];

var paymentErrorMessageMeaning = {};

paymentErrorMessageMeaning["PLUGIN_RC_202"] = "Expired card";
paymentErrorMessageMeaning["PLUGIN_RC_203"] = "Card refused";
paymentErrorMessageMeaning["PLUGIN_RC_204"] = "Insufficient funds";
paymentErrorMessageMeaning["PLUGIN_RC_205"] = "Stolen card";
paymentErrorMessageMeaning["PLUGIN_RC_208"] = "Inactive card";
paymentErrorMessageMeaning["PLUGIN_RC_209"] = "CVN doesn't match";
paymentErrorMessageMeaning["PLUGIN_RC_210"] = "Reached the credit limit";
paymentErrorMessageMeaning["PLUGIN_RC_211"] = "Invalid CVN";
paymentErrorMessageMeaning["PLUGIN_RC_230"] = "Soft decline";
paymentErrorMessageMeaning["PLUGIN_RC_231"] = "Invalid account number";
paymentErrorMessageMeaning["PLUGIN_RC_233"] = "General decline";
paymentErrorMessageMeaning["PLUGIN_RC_481"] = "Decision manager decline";

function sendPaymentErrorMessageToTealium(errorMessageKey, errorMessage){
    if (paymentResponseCodesNotWCSError.includes(errorMessageKey)){
        pushErrorToTealium('Client', "Cybersource Error " + errorMessageKey + " (" + paymentErrorMessageMeaning[errorMessageKey] + ")", 'Error in CyberSource occurred on payment of order',CheckoutHelperJS.getOrderId());
    } else {
        //pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order <' + CheckoutHelperJS.getOrderId() + '>');
    	//HB-3186
    	pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order',CheckoutHelperJS.getOrderId());
    }
}

// HB-3032 END

function getAjaxPromise(url) {
    var parameters = {};
    parameters["timestamp"] = Date.now();

    return $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters
    });
}

function removeErrorMessagesFromElement(element){
    $(element).find(".error-messages-section").remove();
    $('#WC_PromotionCodeDisplay_div_2').removeClass('error');
}

function addErrorMessageToElement(element, message){
    var el = $(element);
    var noErrorSection = false;

    if ($(el).find(".error-messages-section").length==0){
        if(el.attr('id')== 'PromotionCodeForm' && (isOliver ||isPersol) ){ //only checkout 3.0
            $('#WC_PromotionCodeDisplay_div_2').addClass('error');
            $('#PromotionCodeForm #PromotionCodeForm_upper .input-style').after("<div class='error-messages-section'></div>");
        }else{
        $(el).append("<div class='error-messages-section'></div>");
        }
        noErrorSection = true;
    }

    el = $(element).find(".error-messages-section");

    if (noErrorSection || $(el).find(".error-message.error-message-md5-"+md5(message).toString()).length==0){
    	if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
    		$('#PromotionCodeForm .error-message').remove();
    		$('#PromotionCodeForm input#promoCode.error , #PromotionCodeForm input#coupon-value.error').removeClass('ea_input');
    	}
    	var finalMessage = "<div class='error-message error-message-md5-"+ md5(message).toString() +"'>" + message + "</div>";
        $(el).append(finalMessage);
    }
}

/* detect mobile*/ 
window.mobilecheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

window.tabletPortraitCheck = function(){
    var tabletPortrait = false;
    var mq =  window.matchMedia( "screen and (min-width:1024");
    var portrait =  window.matchMedia("(orientation: portrait)");
    if(!mq.matches  && portrait.matches){
        tabletPortrait = true; 
    }
    return tabletPortrait;
}

/* function to manage header z-index in pdp mobile  */
function checkMobilePdpPage(){
    if((window.mobilecheck() || window.tabletPortraitCheck()) && $('#page').hasClass('pdp')){
        return true
    }
}

//its also used in WCAG.js too
function productPageAdd2Cart(wishlistProductId) {

    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
			showCTAloaderClip();
		}else{
			showCTAloader("productPageAdd2Cart");
		}
	} else if (isPersol || isOliver){
        if (!isWishlistPage){
            showCTAloader("productPageAdd2Cart");
        } else {
            showWishlistCTAloader(wishlistProductId);
        }
    }

    var waitForEl = function(selector, callback) {
        if ($(selector).length) {
            callback();
        } else {
            setTimeout(function() {
                waitForEl(selector, callback);
            }, 1000);
        }
    };

    var selector = '[aria-describedby="MiniShopCartProductAdded"]';

    waitForEl(selector, function() {

    	if(isPersol && !productDisplayJS.priceSwitched){
    		if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	    			var clip_on_selected = $('.product-clip-on.selected').attr('catentryClip');
	    			var clip_on_sku_selected = $('#current-clipon-catentry').val();
	    			var offer_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].price;
	                var list_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].listprice;
	                productDisplayJS.lastPriceSaved = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
    		} else {
	            var offer_price = !isWishlistPage ? document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('offerPrice_'+wishlistProductId).innerText;
	            //document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
	            productDisplayJS.lastPriceSaved = offer_price;
	            var list_price = !isWishlistPage ? document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
	            if (!isWishlistPage) {
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	            } else {
	                document.getElementById('listPrice_'+wishlistProductId).innerText = productDisplayJS.lastOfferPriceSaved;
	            }
	            productDisplayJS.lastOfferPriceSaved = list_price;
    		}
            
            
           
            /*
             // Show complete pair offer price if frame has a promotion
             // Now handled by LensConfigurator

                if (completePairTotalPrice != undefined && completePairTotalPrice[frameId] != undefined && completePairTotalPrice[frameId][selectedLendCatentryId] != undefined) {
                    var frameId = $("#roxLenses").val();
                    var selectedLensID = $("#presc--lens--id").val();
                    var hasPromotion = completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] != undefined ? completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] : false;
                    if (hasPromotion) {
                        var completePairOfferPrice = completePairTotalPrice[frameId][selectedLensID]['offerPrice'];
                        var completePairListPrice = completePairTotalPrice[frameId][selectedLensID]['listPrice']; 
                        $('.priceCart')[0].innerText = WCCurrencyJS.format(completePairOfferPrice);
                        $('#minicartPST.price__list')[0].innerText = WCCurrencyJS.format(completePairListPrice);
                        document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    }
                }
            */
	    	if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
	    	productDisplayJS.priceSwitched = true;
            
    	}
    	else if(isOliver && !productDisplayJS.priceSwitched) {
    		var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+wishlistProductId+']');
    		var div;
    		for(var i = 0; i<elements.length;i++) {
    			if(elements[i].nodeName == "DIV") {
    				div = elements[i];
    			}
    		}
    		if(div != undefined) {
    			var temp = div.getElementsByClassName('price__unity')[0].innerText;
    			productDisplayJS.lastPriceSaved = temp;
        		div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        	}
    		
    		var temp = !isWishlistPage ? document.getElementById('listPrice_'+productParent).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
    		if (!isWishlistPage){
                document.getElementById('listPrice_'+productParent).innerText=productDisplayJS.lastOfferPriceSaved;
            } else {
                document.getElementById('listPrice_'+wishlistProductId).innerText=productDisplayJS.lastOfferPriceSaved;
            }
            
    		productDisplayJS.lastOfferPriceSaved = temp;
    		if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
    		productDisplayJS.priceSwitched = true;
    	}
        //reset size
        $('.options_dropdown_column input').each(function( index,input ) {
            if(isOliver){
                var stringCmp = "normal"
            }else{
                var stringCmp = "standard"
            }         
            if(input.value.toLowerCase().includes(stringCmp)){
                $('.options_dropdown_column .size-option-selected span').html(input.value);
            }
        //reset z-index bottom-scrollable-section
        $('.bottom-scrollable-section').css('z-index', "3"); 
            
        });
    	// work the magic
        var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
        showDefaultPaymentPlacement(defaultPaymentPlacement);
        $('[aria-describedby="MiniShopCartProductAdded"]').addClass("opend");
        // $('#page-overflow-wrapper').addClass('overflow-hidden');
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            $('body').addClass('no-scroll');
        }

        if($('#page').hasClass('pdp') && brandCode=="PO"){
            $('#header').css('z-index', '1000') 
        }

        $(".minishopcartadded--fade").show(); 
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            if(!$('#header').is(":visible")) $('#header').slideDown()
            hideHeaderTimeout.cancel();
        }
        if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			setTimeout(function() {
    				hideCTAloaderClip();
                }, 1000)
    		}else{
    			setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
    		}
    	} else if (isPersol || isOliver){
            if (!isWishlistPage){
                setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
            } else {
                setTimeout(function() {
                    hideWishlistCTALoader(wishlistProductId);
                }, 1000)
            }
        }

        if (minicartYMALCallback != undefined) {
            minicartYMALCallback.onWidgetLoaded();
        }

        //HB-7718 
        //check if the add to cart is related to upsell
        var isUpsell = false;
        if($('#upsell-added-inicart').length > 0){
            isUpsell = true;
        }

        //START Early Access
        if (isPersol){
        	var offer_price;
        	var list_price;
        	
            //Wishlist
            if (isWishlistPage) window.lastOfferPrice = returnLastOfferPrice();
            //Wishlist

            //if a upsell products is been added in cart we must use the offerprice and listprice of the upsell product
        	//this listprice and offerprice are in a div created in updateLastOfferUpsell() in store-presol.js
        	//after this we must delete the div with upsell product's listprice and offerprice.
        	if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	        		var str_offer_price = offer_price.trim();
	            	var str_list_price = list_price.trim();
        	} else {
        		var str_offer_price = returnLastOfferPrice().trim();
            	var str_list_price = productDisplayJS.lastOfferPriceSaved.trim();
        	}
        	
        	//SETTING PRICE IN MINICART
        	if(!isUpsell){
        		if(productDisplayJS.engraving){
        			 str_offer_price = document.getElementById('offerPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 if(productDisplayJS.lastOfferPriceSaved!==""){
        				 str_list_price = document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 }
        		}
        		$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html(str_offer_price);
        		
        		
        		if(str_offer_price != str_list_price && !str_list_price.includes("NaN")){
        			document.getElementById("minicartPST").innerHTML=str_list_price;
        		}
                if (!isWishlistPage){
	        		if(!($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true')){
		        		offer_price = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
		        		list_price = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
	        		}
                } else {
                    offer_price = document.getElementById('offerPrice_'+wishlistProductId).innerText;
                    list_price = document.getElementById('listPrice_'+wishlistProductId).innerText;
                } 
        	}else{
        		if($('#upsell-added-inicart #upsell-offer-price').text().length > 0){
        			$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html($('#upsell-added-inicart #upsell-offer-price').text());
        		}
        		offer_price = $('#upsell-added-inicart #upsell-offer-price').text();
        		list_price = $('#upsell-added-inicart #upsell-list-price').text();
                //hide carousel for new upsell
                hideCarouselRecommend('#minicartYMAL');
        	}
        	
        	//upload PST in minicart
            if((document.cookie.includes('X_WC_PR_SEGMENTS') || isUpsell) && list_price.length > 0){
            	if(parseFloat(list_price.replace( /^\D+/g, '')) != parseFloat(offer_price.replace( /^\D+/g, ''))){
            		$('#minicartPST.price__list')[0].innerText = list_price;
            	}
            	
            	if(isUpsell){
            		$('#upsell-added-inicart').remove();
            	}
            }
        }else{
            if(isUpsell){
                //hide carousel for new upsell
                $('#upsell-added-inicart').remove();
                hideCarouselRecommend('#minicartYMAL');
            }
        }
        //END Early Access

        //Show badge in minicart
        if (isOliver || isPersol){
            if ( $('.minicart-badge .prescription_added').length > 0 || $('.minicart-badge .product_polarized').length > 0) {
                if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                    $(".minicart-badge").show();
                } else $(".minicart-badge.mobile").show();
            }
        }

        //added manifest map in localStorage
        if(localStorage != undefined){
            if(localStorage['manifestMap']!= undefined){ 
                try {
                    var manifestMapMerged = $.extend($.parseJSON(localStorage['manifestMap']),$.parseJSON($("#manifestMap").val()));
                    localStorage.setItem('manifestMap', JSON.stringify(manifestMapMerged));
                }
                catch(e) {
                    localStorage.setItem('manifestMap',$("#manifestMap").val());
                }
            }else{

                localStorage.setItem('manifestMap',$("#manifestMap").val());
            }

            if (isOliver || isPersol) {
                // var upSellPartNumber = $("#upSellPartnumber").val();
                // const upSellPartnumberArray = upSellPartNumber.split(" ").slice(1);
                if (isWishlistPage){
                    replaceImageMinicart($("#cartDropdown .product_image img"));
                } else {
                    replaceImageMinicart($("#cartDropdown .product_image img"), partNumber);
                }
                replaceImageMinicart($("#cartSuggestion .owl-item.active .product_image  img:nth-child(2)"));
                $("#skeleton-minicart").hide();
                $("#cartDropdown .product_image img").eq(0).show();
            }
        
        }

    });
}

function changeHeaderIndex(isOpening){
    isOpening ? $('#header').css('z-index', '1001') :  $('#header').css('z-index', '600')
}
function changeFooterIndex(isOpening){
    isOpening ? $('#footerWrapper').css('z-index', '1002') :  $('#footerWrapper').css('z-index', '600')
}

function hideCarouselRecommend(container){
    switch(container){
      case "#minicartYMAL":
        if(isPersol) $('#widget_minishopcart_popup_1').addClass('disable-carousel');
      default:
        $(container).hide();
      break;
    }
}
function getPreOrderBadge(attributes) {
    var preOrder = null;
    preOrder = attributes.find(x=>(x.identifier == 'PREORDER' && x.usage == 'Descriptive'));
    if(isPreOrderActive && preOrder) {
        var preOrderVal = preOrder.values[0].value ? preOrder.values[0].value.toString().toLowerCase() : null;
        if(preOrderVal && preOrderVal == 'true') {
            return preOrder.identifier;
        }
    }
}


function printBadges(attributes){
    /**
     * OP Badge Hierarchy
     * PremiumMaterials > Exclusive > Pre-release > New > Clip Available
    */
    if(isOliver) {
        var newRelease = null;
        var exclusive = null;
        var clipsAvailable = null;
        var premiumMaterial = null;
        var preRelease = null;
        
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        preRelease = attributes.find(x=>(x.identifier == 'PRE_RELEASE' && x.usage == 'Descriptive')); 
        if(preRelease) {
            var preReleaseVal = preRelease.values[0].value ? preRelease.values[0].value.toString().toLowerCase():null;
            if(preReleaseVal && preReleaseVal =='true')
                return preRelease.name;
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
        clipsAvailable = attributes.find(x=>(x.identifier == 'MATCH_WITH_CLIPS' && x.usage == 'Descriptive'));
        if(clipsAvailable) {
            var clipsAvailableVal = clipsAvailable.values[0].value ? clipsAvailable.values[0].value.toString().toLowerCase() : null;
            if(clipsAvailableVal && clipsAvailableVal =='true')
                return  $('#clipAvailable').val();
        }  
    }
     /**
     * PO Badge Hierarchy
     * Limited Edition > Exclusive > PremiumMaterials > New
    */
    if(isPersol){
        
        var premiumMaterial = null;
        var exclusive = null;
        var newRelease = null;
        var limited = null;
        
       
        limited = attributes.find(x=>(x.identifier == 'LIMITED_EDITION' && x.usage == 'Descriptive'));
        if(limited) {
            var limitedEditionVal = limited.values[0].value ? limited.values[0].value.toString().toLowerCase() : null;
            if( limitedEditionVal && limitedEditionVal == 'true')
                return limited.name;
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
    }

    return "";
}

//Begin of EMAIL_ME
function printStatus(product){
    
    if(isEcommerceStoreJS == 'TRUE' && !(typeof product['inventory'] === 'undefined')){
        
        var comingSoon = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'true';
        var soldOut = product['inventory']['ranking'] == '0';
        var comingSoonBack = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'false';
        if(soldOut == false && comingSoonBack == false && comingSoon == false){
            return false; //se non ci sono badge da mostrare ritorna falso ==>serve per il controllo in CatalogENtryList_Oliver/persol_ui.jspf 
        }else{
            return {'SoldOut': SOLD_OUT_STATUS ,
                        'isSoldOut': soldOut , 
                        'Coming': COMING_SOON_STATUS, 
                        'isComing': comingSoon,
                        'ComingSoonBack': COMING_SOON_BACK_STATUS,
                        'isComingSoonBack': comingSoonBack,
                        }
        }
                    
    }   else{
        return false;
    }    
    
}
//End of EMAIL_ME




function getPolarized (attributes,isClass) {
    var polarized = null;
    var isPolar = false;
    if (attributes != undefined) {
        polarized = attributes.find(x=>(x.identifier == 'POLARIZED' && x.usage == 'Descriptive'));
        var polarizedValue = polarized && polarized.values[0].value ? polarized.values[0].value.toString().toLowerCase(): 'false';
        if(polarizedValue == 'true' || polarizedValue == 'yes') {
            polarized = polarized.name;
            if(polarized == null){
                polarized = POLARIZED_TEXT;
            }
            isPolar= true;
        }
        else polarized=null;
    }
    return isClass ? isPolar : polarized;    
}

function getTransitionBadge (attributes,isClass) {
    var transition = null;
    var isTransition = false;

    if (attributes != undefined) {
        transition = attributes.find(x=>(x.identifier == 'TRANSITIONS' && x.usage == 'Descriptive'));
        var transitionValue = transition && transition.values[0].value ? transition.values[0].value.toString().toLowerCase(): 'false';
        if(transitionValue == 'true' || transitionValue == 'yes') {
            transition = transition.name;
            if(transition == null){
                transition = TRANSITION_TEXT;
            }
            isTransition= true;
        }
        else transition=null;
    }
    return isClass ? isTransition : transition;
}


function isPrescription(attributes){
    var isRoxable=false;
    for (var index = 0; index < attributes.length; index++) {
    
           
            if ( attributes[index].identifier == 'IS_ROXABLE') {
                isRoxable = (attributes[index].values[0].value.toLowerCase() == 'yes' || attributes[index].values[0].value.toLowerCase() == 'true');
                break;
            }else{
                isRoxable = false;
            }
        
    }
    return isRoxable;
}



function getElementPosition(idClass) {
    var element = $(idClass);
    var offset = element.offset();

    return {
        'top': offset.top,
        'right': offset.left + element.outerWidth(),
        'bottom': offset.top + element.outerHeight(),
        'left': offset.left,
    };
};
          
function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
   };

function replaceImage(picture,typeImg){
        var urlBase_Persol = "https://assets2.persol.com/is/image/";
        var urlBase_Oliver = "https://assets2.oliverpeoples.com/is/image/";
        var urlBaseAccessories_Oliver = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var urlBaseAccessories_Persol = "https://assets.persol.com/extra/image/TargetOptical/accessories/";
        var FOLDER_NAME_Persol = "Persol";
        var FOLDER_NAME_Oliver = "OliverPeoples";
        var SUFFIX_AKAMAI_WS = "_manifest_2.json";
        var FOLDER_ACCESSORIES_IMAGES_PERSOL = "https://assets.persol.com/extra/image/Persol/accessories/";
        var FOLDER_ACCESSORIES_IMAGES_OLIVER = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var productPartNumber;
        if(isOliver){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }else if(isPersol){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }
        if (screenWidthPx <= 400) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=400');
        } else if (400 < screenWidthPx && screenWidthPx <= 750) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=800');
        } else if (1200 < screenWidthPx) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=2000');
        }

        //get partnumber and create url for call to manifest
        for(var i = 0; i < picture.length; i++) {
        	if(picture[i].className == 'lazy catalog__image--front'){
        		productPartNumber= picture[i].dataset.partnumber;
        		if(isPersol){
                    var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }else{
                    var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }
        	}else{
        		for(var j = 0; j < picture[i].childNodes.length; j++){
                    if(picture[i].childNodes[j].nodeName == 'IMG'){
                        productPartNumber= picture[0].childNodes[5].dataset['partnumber'];
                        if(isPersol){
                            var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }else{
                            var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }                        
                    }
                }
        	}            
        }
        var thumbnail="";
        var hasImage=false;
         //call service (manifest)
        $.ajax({
            url: akamaiAPI,
            dataType: "json",
            success: function(data) {
                //check if there is the required image
                for (var i = 0; i < data.items.length; i++) {
                    var imageFileKey = data.items[i].file_key;
                    if (imageFileKey.includes(typeImg)) {
                        hasImage= true;
                    }
                }

            }, error: function(requestObject, error, errorThrown){
                console.error("error in rest call to manifest",error);
            }, complete: function(){
                if(hasImage){//if it exists  create URL images
                    if(isPersol){
                        thumbnail= baseUrlAkamaiIMPO + classicPathAkamaiIMPO + productPartNumber +"__"+ typeImg+'.png' + ymalAkamaiPolicy;
                    }else{
                        thumbnail = baseUrlAkamaiIMOP + classicPathAkamaiIMOP + productPartNumber +"__"+ typeImg+'.png'+ymalAkamaiPolicy;
                    } 
                }else{ //else put 001 image or 002 image
                        if(isPersol && typeImg == 'STD__shad__fr'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isPersol && typeImg == 'STD__shad__qt'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy); 
                        }else if(isOliver && typeImg == 'STD__shad__fr'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isOliver && typeImg == 'STD__shad__qt'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy);
                        }      
                }
                //replace picture srcset
                for(var g = 0; g < picture.length; g++) {
                	if(picture[g].className == 'lazy catalog__image--front'){
                		thumbnail = thumbnail.split('=')[0] + '=HB_parameters_transp&wid=720&cropnorth=-9&cropsouth=-9';
                		picture[g].dataset["srcset"]= thumbnail;
                	}else{
                		for(var j = 0; j < picture[g].childNodes.length; j++){
                            if(picture[g].childNodes[j].nodeName == "SOURCE"){
                               picture[g].childNodes[j].dataset["srcset"]= thumbnail;
                            }
                        }
                	}
                }
            }
        });
}

function replaceTileImgByDevice(url,pattern,tileType) {
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    if (typeof url == 'string') {
        var screenWidthPx = Math.round(window.innerWidth*window.devicePixelRatio);
        if (screenWidthPx < 400/* mobile */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=400');
            }
        } else if (400 < screenWidthPx && screenWidthPx <= 750/* tablet */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=500');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=100');
            }
        } else if (750 < screenWidthPx && screenWidthPx <= 1200/* desktop 1x */) {
            if (tileType == 'small') {
                if(isWishlistPage){
                    return url.replace(pattern,'wid=800');
                }else{
                    return url.replace(pattern,'wid=400');
                } 
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=150');
            }
        } else if (1200 < screenWidthPx)/* desktop 2x */ {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=1600');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=300');
            }
        }
    }
    return url;
}

function removeIOSRubberEffect( element ) {
	element.addEventListener( "touchstart", function () {
		var top = element.scrollTop, totalScroll = element.scrollHeight, currentScroll = top + element.offsetHeight;
		if ( top === 0 ) {
			element.scrollTop = 1;
		} else if ( currentScroll === totalScroll ) {
			element.scrollTop = top - 1;
		}
	} );
}

function handleSwipeBounce(){
    var startX = 0, startY = 0;

    $('.owl-wrapper').on( "touchstart", function(e){
            e=(e.touches)?e.touches[0]:e;//e.touches[0] is for ios
            startX = e.clientX;
            startY = e.clientY; 
    } );

    $('.owl-wrapper').on( "touchmove", function(event){
        var e=(event.touches)?event.touches[0]:event;//e.touches[0] is for ios
        var deltaX = Math.abs(e.clientX - startX);
        var deltaY = Math.abs(e.clientY - startY);

        if(deltaX > deltaY) {
          event.preventDefault();
        }
    });

    $('.owl-item').on( "touchend", function(e){ 
        if (isOliver) {
            $('body').css('overflow', 'auto'); 
        }
    });
}

function disableScrollingByClass() {
    document.ontouchmove = function ( event ) {

        var isTouchMoveAllowed = true, target = event.target;
    
        while ( target !== null ) {
            if ( target.classList && target.classList.contains( 'disable-scrolling' ) ) {
                isTouchMoveAllowed = false;
                break;
            }
            target = target.parentNode;
        }
    
        if ( !isTouchMoveAllowed ) {
            event.preventDefault();
        }
    
    };
}

function manageScrollOverlay(isOpen){
    /*
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if (isOpen) {
            if (myPane !== undefined){
                myPane.disableDrag();
                bodyScrollLock.enableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").hide();
        } else {
            if (myPane !== undefined) {
                myPane.enableDrag();
                bodyScrollLock.disableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").show();
        }
    }
    */
}
/** jQuery Get Browser Plugin
 * @version: 1.01
 * @author: Pablo E. Fernández (islavisual@gmail.com).
 * Copyright 2016-2018 Islavisual. 
 * Licensed under MIT (https://github.com/islavisual/getBrowser/blob/master/LICENSE). 
 * Last update: 07/02/2018
 **/
 !function(e){e.extend({browser:function(){var e,r=navigator.userAgent,t=r.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];/trident/i.test(t[1])&&(e=/\brv[ :]+(\d+)/g.exec(r)||[],t[1]="Internet Explorer",t[2]=e[1]),"Chrome"===t[1]&&(e=r.match(/\b(OPR|Edge)\/(\d+)/),t[1]=null!=e?e.slice(1).join(" ").replace("OPR","Opera"):"Chrome"),t=t[2]?[t[1],t[2]]:[navigator.appName,navigator.appVersion,"-?"],null!=(e=r.match(/version\/(\d+)/i))&&t.splice(1,1,e[1]);var o=/firefox/.test(navigator.userAgent.toLowerCase())&&!/webkit    /.test(navigator.userAgent.toLowerCase()),a=/webkit/.test(navigator.userAgent.toLowerCase()),s=/opera/.test(navigator.userAgent.toLowerCase()),n=/edge/.test(navigator.userAgent.toLowerCase())||/msie/.test(navigator.userAgent.toLowerCase())||/msie (\d+\.\d+);/.test(navigator.userAgent.toLowerCase())||/trident.*rv[ :]*(\d+\.\d+)/.test(navigator.userAgent.toLowerCase()),i=n?"":a?"-webkit-":o?"-moz-":"";return{name:t[0],version:t[1],firefox:o,opera:s,msie:n,chrome:a,prefix:i}}}),jQuery.browser=e.browser()}(jQuery);

 /** Handle multiple promises */
 function all(array,promises) {
     var deferred = $.Deferred();
     var fulfilled = 0, length = array.length;
     var results = [];
     if (length === 0) {
         deferred.resolve(results);
     } else {
             for (var index=0; index<array.length; index++) {
            	 
            	 (function (index) {
            		 var upc = array[index];
                     promises[upc].then(function(response){
                       results[index] = response;
                       fulfilled++;
                       if (fulfilled === length) {
                           deferred.resolve(results);
                       }
                     });
            	 }(index));
                 
           }
     }
     return deferred.promise();
 };
 
 /** getScript with cache */
 jQuery.cachedScript = function(url,options) {
   // Allow user to set any option except for dataType, cache, and url
   options = $.extend(options || {},{
     dataType: "script",
     cache: true,
     url: url
   });
   // Use $.ajax() since it is more flexible than $.getScript
   // Return the jqXHR object so we can chain callbacks
   return jQuery.ajax(options);
 };
 
//left: 37, up: 38, right: 39, down: 40,
//spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
	e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
	if (keys[e.keyCode]) {
	  preventDefault(e);
	  return false;
	}
}

//modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
	get: function () { supportsPassive = true; } 
}));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

//call this to Disable
function disableScroll() {
	window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
	window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
	window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
	window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

//call this to Enable
function enableScroll() {
	window.removeEventListener('DOMMouseScroll', preventDefault, false);
	window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
	window.removeEventListener('touchmove', preventDefault, wheelOpt);
	window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

function capitalizeEachWord(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }



function iOSversion() {
	if (/iP(hone|od|ad)/.test(navigator.platform)) {
		// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
	    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
	    return parseInt(v[1], 10);
	}
}
/**
 * Check if we are in Chrome on an iOS device
 * becase function isSafari returns true even when we are in chrome
 * @returns true if is chrome on iOS, false otherwise
 */
function isChromeOnIOS() { 
    return navigator.userAgent.indexOf('CriOS') >= 0;
}

 
/* START Early Access */

function getPriceByCustomerSegment(priceObj) {
    if (isPersol || isVogue){
        //  Check User Customer Segment using cookie
        if (document.cookie.includes("X_WC_PR_SEGMENTS") && window.customerSegment != undefined){
            //  Get price for my customer segment
            if (priceObj["price_"+window.customerSegment] != undefined && priceObj["price_"+window.customerSegment] != ""){
                price = priceObj["price_"+window.customerSegment];
            } else price = priceObj.price;
        } else price = priceObj.price;
    } else if (isOliver){
        price = priceObj.price;
    }
    return price; //  Return price
}

function returnLastOfferPrice() {
    var lastOfferPrice;
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
  
    if (!isWishlistPage) {
      if(productParent[0]){
        if ((window.mobilecheck() || window.tabletPortraitCheck()) && !isPersol){
            lastOfferPrice = document.querySelectorAll('#offerPrice_'+productParent[0])[1].innerText;
        } else if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerHTML;
        }else if(isVogue){
        	lastOfferPrice = document.getElementsByClassName('offerPrice_'+productParent[0]).innerHTML;
        }else{
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerText;
        }
      }
    } else {
      lastOfferPrice = document.getElementById('offerPrice_'+ minicartAddedId).innerText;
    }

    return lastOfferPrice;
}

/* END Early Access */

//checkout 3.0

function goToOrderPaymentViewOnClickHandler(event){
    
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }

    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    	//form2.email1.value=form1.email1.value;
    let isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
            	  var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		          }
                  if(addressValidate){
                	  if (typeof data.contact === 'undefined'){
                          plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                          AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                      } else {
                          for (var i = 0; i<data.contact.length; i++){
                              if (data.contact[i].nickName == 'MyAddress_Shipping'){
                                  plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                                  AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                                  break;
                              }
                          }
                      }
                      /* START - OP BOSS */
                      if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
                    }
                    /* END - OP BOSS */  
                  }else{
                	  restoreAjaxButtons();
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        
        if(AddressHelper.validateAddressForm(form1)) {
            //if(isFormNoError)//isFormNoError check if one of th input field in checkoutform is with error in this case if email is with error with need to send error to analytics 
                isFormNoError = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderPaymentsViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		        	}
		        	
		        	if(addressValidate){
			            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
	
			            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
			            //calling the rest service. If success then address exist else address does not exist.
			            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
			            $.ajax({
			                method: "GET",
			                url: url,
			                headers: {
			                    "Content-Type": "application/json",
			                    "Cache-Control": "no-cache, no-store, must-revalidate"
			                },
			                dataType: "json",
			                success:function(data, textStatus, jqXHR){
			                    if (typeof data.contact === 'undefined'){
			                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
			                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
			                    } else {
			                        for (var i = 0; i<data.contact.length; i++){
			                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
			                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
			                                AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
			                                break;
			                            }
			                        }
			                    }
			                },
			                error:function(jqXHR, exception){
			                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
			                }
			            });
			
			            moveToError();
		        	}else{
		        		restoreAjaxButtons();
		        	}
		        }).then(function(){
                    if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
		            }
		        })
        }else{
            isFormNoError = false;
        }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError)
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc');   
}

function parseStoreHours(storeHours){
	var weekDays = getWeekDays(locale.replace('_','-'));
	var hourString = titleCase(weekDays[0]);
	var existAnotherWithTheSameHours = '';
	//we start from second day
	for(var i = 1; i < storeHours.length; i++){
		if(storeHours[i].opening === storeHours[i-1].opening && storeHours[i].closing === storeHours[i-1].closing){
			if (existAnotherWithTheSameHours == ''){
				existAnotherWithTheSameHours = ' - ';
			}
		}else{
			if(storeHours[i-1].isClosed){
				if(i == 1){
					hourString = hourString + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}
			}else{
				if(i == 1){
					hourString = hourString + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);	
				}
			}
			existAnotherWithTheSameHours =  '';
		}
	}
	
	if( existAnotherWithTheSameHours == '' ){
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}else{
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) +  ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}
	return hourString.replaceAll('"','');
}

function titleCase(string){
	return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

function getWeekDays(locale){
    var baseDate = new Date(Date.UTC(2017, 0, 2)); // just a Monday
    var weekDays = [];
    for(i = 0; i < 7; i++){       
        weekDays.push(baseDate.toLocaleDateString(locale, { weekday: 'long' }));
        baseDate.setDate(baseDate.getDate() + 1);       
    }

    //HB-9317. This fix is related to common weeksdays order in America. In USA , Sunday is considered the first day of week. This 
    // caused a strange parsing in storeHours. We have aligne the weekdays orders to the classic one.
    if(locale=='en-US' && weekDays[0]=='Sunday'){
        weekDays = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    }
    return weekDays;
}


function iPhoneVersion() {
	  var iHeight = window.screen.height;
	  var iWidth = window.screen.width;

	  
	  if (iWidth === 390 && iHeight === 844) {
		    return "12-13";
	  }
	  
	  if (iWidth === 414 && iHeight === 896) {
		    return "11";
	  }

	  if (iWidth === 414 && iHeight === 896) {
	    return "Xmax-Xr";
	  }
	  else if (iWidth === 375 && iHeight === 812) {
	    return "X-Xs";
	  }
	  else if (iWidth === 320 && iHeight === 480) {
	    return "4";
	  }
	  else if (iWidth === 375 && iHeight === 667) {
	    return "6-7";
	  }
	  else if (iWidth === 414 && iHeight === 736) {
	    return "6+";
	  }
	  else if (iWidth === 320 && iHeight === 568) {
	    return "5";
	  }
	  else if (iHeight <= 480) {
	    return "2-3";
	  }
	  return 'none';
	}



//checkout 3.0

/* START - Online Return Form */

function cleanCartForShipOrder(isReturnForm = false,callback) {
    if(personInfo.userId !== '-1002') {
        
        var url = '/wcs/resources/store/' + WCParamJS.storeId + '/cart/@self';
        function deleteCart(url,callback) {
            $.ajax({
                url: url,
                type: 'DELETE',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: "json",
                data: [],
                success: function (response, textStatus, request) {
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                },
                error: function(response){
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                }
            });
        }

        if (isReturnForm) {
            //  When Return Form, simply delete the cart
            deleteCart(url,callback);
        } else {
            //  When in classic cart, delete the cart after checking it is a Ship Order
            getAjaxCallInfo(url, null, function(response) {
                let isShipOrder = false;
                if (response.orderItem !== undefined) {
                    response.orderItem.forEach(function(item) {
                        if (item.partNumber == 'RETURN_SHIPPING_CHARGE_SKU') {
                            isShipOrder = true;
                        }
                    });
                }
                if (isShipOrder) {
                    deleteCart(url,callback);
                }
            });
        }

    }
}

/* END - Online Return Form */

function checkPasswordStrenght(passwordField) {
    var password = passwordField.value;
    const conditionThreshold = 5;
    var sumConditions = 0;
    if(RegExp('(?=.{8,})').test(password)) { //at least 8 characters long
        $('#password_length').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_length').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[A-Z])').test(password)) {//at least one uppercase letter
        $('#password_uppercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_uppercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[a-z])').test(password)) { //at least one lowercase letter
        $('#password_lowercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_lowercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[0-9])').test(password)) { //at least one digit 
        $('#password_number').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_number').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('([^A-Za-z0-9])').test(password)) { //at least one special character
        $('#password_special').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_special').attr("checked",false);
        sumConditions--;
    }
    console.log(sumConditions==conditionThreshold);
    return sumConditions==conditionThreshold;
}

function checkPasswordFieldAndSubmit(form) {
	
	if(form.validationCode.value == ''){
		$('.password-policies-title').addClass('hidden');
		$('#validationCodeError').removeClass('hidden');
	}else{
	 if(checkPasswordStrenght(form.logonPassword)){
	        $('.password-policies-title').removeClass('hidden');
	        $('.password-policies-title-error').addClass('hidden');
	        $('[name="logonPassword"').removeClass('error');
	        submitSpecifiedForm(form);
	    }
		else {
			$('.password-policies-title').addClass('hidden');
	        $('.password-policies-title-error').removeClass('hidden');
	        $('[name="logonPassword"').addClass('error')
		}
	}
   
}

function openPasswordPolicyDiv() {
    $('.password-policies-container').show();
    $('.input-style--password').addClass('passPolicyOpen'); //Persol
}


/*Check specific browser version*/
navigator.sayswho= (function(){
    var N= navigator.appName, ua= navigator.userAgent, tem;
    var M= ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
    if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];
    M= M? [M[1], M[2]]: [N, navigator.appVersion,'-?'];
    return M;
})();

function getAttributeValue(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].value : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}

function getAttributeIdentifier(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].identifier : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}
function getConvertedDistance(distance) {
    //var inchMeasure = 25.4;
	var cleanNumber = "";
	
	if(typeof distance != 'undefined'){
		cleanNumber = distance.replace(/\D/g,'');
	}
    return '('+ cleanNumber + ' mm)';
}

function showKlarnaPlacements(){
    $('.pdp .klarna-mess-pdp').show();
    $('.pdp .klarna-minicart, .wishListDisplay .klarna-minicart').show();
    $('.minicart-klarna').show();
    $(".checkout__klarna").show();
    $('#vat_klarna:not(#cartSuggestion .content .espot-complete-order-upsell #vat_klarna)').show();
}

async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);                    

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

//Resolve promise for sha256
function getSha256Promise(message) {
    const result = sha256(message);
    return result instanceof Promise ? result : Promise.resolve(result);
}

//Return FALSE if VARIABLE DOESN'T CONTAINS VALUE; Return TRUE if VARIABLE CONTAINS VALUE;
function checkIsNull(variable){
    if(typeof(variable)!='undefined' &&  variable != '' && variable != null)
        return false;
    else
        return true;
}

window.addEventListener('load', (event) => {
    if (typeof fn_FrameAdvisor === 'function') {
        fn_FrameAdvisor();
    }
});


//CRM Banner - this function opens up promo popups with a promocode in cart on PO and VO
function fn_CartPromoCode(promoCode,copyPromoCode) {
    if (isPersol || isVogue){    
        if (typeof promoCode !== 'undefined' && typeof copyPromoCode !== 'undefined' ||
        promoCode != "" && copyPromoCode != "") {
        	window.isCRMPromo = true;
        	if(isVogue){
        		if($('#promoCodeCRM').length < 1){
        			$('#headerWidget').append('<input type="hidden" id="promoCodeCRM" name="promoCodeCRM" value="' + promoCode +'" autocomplete="off">');
        		}
        		if($('#copyPromoCodeCRM').length < 1){
        			$('#headerWidget').append("<input type='hidden' id='copyPromoCodeCRM' name='copyPromoCodeCRM' value='"+ copyPromoCode.replaceAll("'", '"') +"' autocomplete='off'>");
        		}
        		promoCode = $('#promoCodeCRM').val();
        		copyPromoCode = $('#copyPromoCodeCRM').val();
        	}
            $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
            $(".cart-crm-banner .promo-description").html(copyPromoCode);

            if (isVogue) {
                $("#cart-crm-promocode-box-banner .use-promocode-container").off("click").on("click", function(){
                    if ($("#promo-form-title.dropdown").hasClass("opend")){
                        $("#promo-form-title.dropdown").removeClass("opend");
                    }else{
                        $('#promo-form-title.dropdown').removeClass("opend");
                        $("#promo-form-title.dropdown").addClass("opend");
                    }
                });

                if ((window.mobilecheck() || window.tabletPortraitCheck())) {
                    $("#promo-form-title.dropdown").addClass("available-promocode");
                }

                CRMRemovePromoCode();
            }

            if (isPersol) {
                $("#cart-crm-promo-banner").addClass("showed").removeClass("hidden");
                $("#promotions .wrapperPromotions .promotion-code__label").addClass("available-promocode");

                $(".promotion-code__label.available-promocode, .use-promocode-container").on("click", function(){
                    $(".promocode-box-reminder .apply-promocode-cta").on("click", function(event){
                        event.stopPropagation();
                    });
                    if(isVogue){
                    	if ($("#promotion-code__input").is(":checked")){
                            $(".promotion-code__label.available-promocode").addClass("expanded");
                        } else {
                            $(".promotion-code__label.available-promocode").removeClass("expanded");
                        }
                    }else{
                    	if ($("#promotion-code__input").is(":checked")){
                    		$(".promotion-code__label.available-promocode").removeClass("expanded");
                        } else {
                        	$(".promotion-code__label.available-promocode").addClass("expanded");
                        }
                    }
                    
                });
            }

            $('.cart-crm-banner .apply-promocode-cta').off('click').on('click', function(){
                if (isPersol) {
                    if ($("input#promoCode").val() == "") {
                        $("input#promoCode").val(promoCode.toString());
                        $(".promocode-button-wrapper button").click();
                    }
                } else if (isVogue) {
                    if ($("input#coupon-value").val() == "") {
                        $("input#coupon-value").val(promoCode.toString());
                        $(".promotion_button button").click();
                    }
                }

            });
        } else {
            window.isCRMPromo = false;
        }
    }
}

function CRMRemovePromoCode (){
    if ($("#isPromocodeApplied").val() == 'true') {
        $("#cart-crm-promocode-box-banner").addClass("hidden").removeClass("showed");
        $(".visibleOrderDiscount td").css("color", "#000");
        $("#appliedPromotionCodes").hide();
        $("#CRMappliedPromotionCodes").show();
        $(".removePromotionLink").hide();
        $(".CRMremovePromotionLink").css("display","flex");
        if (!(window.mobilecheck() || window.tabletPortraitCheck())){
            $("#PromotionCodeForm").css("padding-bottom", "16px");
        } else {
            $("#promo-form-title").css("border-bottom", "none");
        }
    } else {
        $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
        $("#CRMappliedPromotionCodes").hide();
    }
}

//retrive all parameters from url
function getAllUrlParams() {
	var queryString = window.location.href.split('?')[1];
	var obj = {};

    if (queryString) {
        queryString = queryString.split('#')[0];
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            var a = arr[i].split('=');

            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            if (paramName.match(/\[(\d+)?\]$/)) {
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                if (paramName.match(/\[\d+\]$/)) {
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    obj[key].push(paramValue);
                }
            } else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}


//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

shoppingActionsJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not. 
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to diplay the price range when the catEntry is selected. 
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object retured from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /** 
     * stores all name and value of all swatches 
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item Ids. 
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item Ids in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone. 
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone. 
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry. 
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    /**
     * An array to keep the details of the newly added products.
     */
    productAddedList: {},

    setCompareReturnName: function (compareReturnName) {
        this.compareReturnName = compareReturnName;
    },

    setSearchTerm: function (searchTerm) {
        this.searchTerm = searchTerm;
    },

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.userType = userType;
        this.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        this.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return this.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    var attributeValue2 = attributeValue.replace(this.search02, this.search01);
                    if (attributeValue in Attributes || attributeValue2 in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField) {
        console.debug(selectedAttributeName + " : " + selectedAttributeValue);
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
        selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        this.moreInfoUrl = this.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        this.selectedAttributesList[entitledItemId] = selectedAttributes;
        this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);
    },

    /**
     * setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
     *								This function is used to set the assigned value of defining attributes to specific 
     *								products which will be stored in the selectedProducts map.
     *
     * @param {String} productId The catalog entry ID of the catalog entry to use.
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {boolean} true, if it is single SKU
     *
     **/
    setSelectedAttributeOfProduct: function (productId, selectedAttributeName, selectedAttributeValue, isSingleSKU) {

        var selectedAttributesForProduct = null;

        if (this.selectedProducts[productId]) {
            selectedAttributesForProduct = this.selectedProducts[productId];
        } else {
            selectedAttributesForProduct = {};
        }

        // add only if attribute has some name. value can be empty
        if (null != selectedAttributeName && '' != selectedAttributeName) {
            selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
        }
        this.selectedProducts[productId] = selectedAttributesForProduct;

        //the json object for entitled items are already in the HTML. 
        var entitledItemJSON = eval('(' + $("#entitledItem_" + productId).html() + ')');

        this.setEntitledItems(entitledItemJSON);

        var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

        if (catalogEntryId == null) {
            catalogEntryId = 0;
        } else {
            // pass true to display price range
            this.changePrice("entitledItem_" + productId, false, true, productId);

            //Update selected sku in merchandising association array
            if (typeof MerchandisingAssociationJS != 'undefined') {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
                            }
                        }
                    }
                }
            }
        }
        var productDetails = null;
        if (this.productList[productId]) {
            productDetails = this.productList[productId];
        } else {
            productDetails = {};
            this.productList[productId] = productDetails;
            productDetails.baseItemId = productId;
        }

        productDetails.id = catalogEntryId;
        if (productDetails.quantity) {
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        }

        if (!isSingleSKU) {
            // publish the attribute change event
            if (catalogEntryId != 0) {
                wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);
            } else {
                wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            }
        }
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up. 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" +entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            this.baseItemAddedToCart = true;
        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            this.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        this.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in this.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = this.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        this.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart.
     **/
    AddBundle2ShopCartAjax: function () {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var ajaxShopCartService = "AddOrderItem";
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
            inventoryValidation: "true",
            calculateOrder: "0"
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        
        var idx = 1;
        this.productAddedList = {};

        for (productId in this.productList) {
            var productDetails = this.productList[productId];
            var quantity = Utils.parseNumber(productDetails.quantity);

            if (quantity == 0) {
                continue;
            }
            if (productDetails.id == 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            }
            if (isNaN(quantity) || quantity < 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            params["catEntryId_" + idx] = productDetails.id;
            params["quantity_" + idx++] = quantity;
            this.baseItemAddedToCart = true;

            this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(ajaxShopCartService, params);

    },

    resetProductAddedList: function () {
        shoppingActionsJS.productAddedList = {};
    },
    /**
     * Save the product information of the newly added product(s) to be used for the mini cart product added popup
     *
     * @param {String} quantity The quantity of the product being purchased.
     * @param {String} productId The id of the product.
     * @param {String} skuId The id of the sku.
     * @param {String} attrList The list of selected attributes for the product, if any.
     **/
    saveAddedProductInfo: function (quantity, productId, skuId, attrList) {

        var productName = "";
        if ($("#ProductInfoName_" + productId).length) {
            productName = document.getElementById("ProductInfoName_" + productId).value;
        } else if ($("#ProductInfoName_" + skuId).length) {
            productName = document.getElementById("ProductInfoName_" + skuId).value;
        }

        var productThumbnail = "";
        if ($("#ProductInfoImage_" + productId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + productId).value;
        } else if ($("#ProductInfoImage_" + skuId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + skuId).value;
        }

        var productPrice = "";
        if ($("#ProductInfoPrice_" + productId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + productId).value;
        } else if ($("#ProductInfoPrice_" + skuId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + skuId).value;
        }

        var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
        if (productId != skuId) {
            this.productAddedList[skuId] = productAdded;
        } else {
            this.productAddedList[productId] = productAdded;
        }

        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },

    /* SwatchCode start */

    /**
     *setSKUImageId Sets the ID of the image to use for swatch.
     **/
    setSKUImageId: function (skuImageId) {
        this.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     * 
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },

    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //				disable the add to cart button
        var btn = document.getElementById("listViewAdd2Cart_" + this.entitledItems[entitledItemIndex].productId);
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;
            $("#WC_CachedProductOnlyDisplay_images_1_" + imageCount).attr('src', itemAngleThumbnail[x]);
            if ($("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).length) {
                $("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).attr('href',
                    "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');");
            }

            if ($("#productAngleLi" + prodAngleCount).length && $("#productAngleLi" + prodAngleCount).attr('className') === ('selected')) {
                changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
            }
        }
    },


    /**
     * updates the product image from the PDP page to use the selected SKU image
     * @param String swatchAttrName the newly selection attribute name
     * @param String swatchAttrValue the newly selection attribute value
     * @param {String} imageField, the field name from which the image should be picked
     **/
    changeProdImage: function (entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField) {
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);
        var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
        if (imageArr != null) {
            skuImage = imageArr[0];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId).length) {
                document.getElementById(this.skuImageId).src = skuImage;
                if ($("#ProductInfoImage_" + productId).length) {
                    document.getElementById("ProductInfoImage_" + productId).value = skuImage;
                }

                var itemAngleThumbnail = imageArr[2];
                var itemAngleFullImage = imageArr[3];
                if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                    shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                if (null != imageField) {
                    var itemImage = this.entitledItems[x][imageField];
                } else {
                    var itemImage = this.entitledItems[x].ItemImage467;
                }


                var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
                var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        // set sku image only if the img element is present
                        if ($("#" + this.skuImageId).length) {
                            $("#" + this.skuImageId).attr('src', itemImage);
                            if (document.getElementById("ProductInfoImage_" + productId) != null) {
                                document.getElementById("ProductInfoImage_" + productId).value = itemImage;
                            }
                        }
                        if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                            shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = swatchArray[i];
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = swatchSkuImage[i];
            eval($(swatchSkuImageElement).attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval($(swatchDefaultElement).attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
                document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
            }
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        // setSelectedAttribute internally calls changeProdImage method to change product image.
        this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = selectedAttributeDisplayValue;
        } else {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
        }

        this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.	
     * @param {String} swatchImg1 The path to the swatch image.
     **/
    addToAllSwatchsArray: function (swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.		
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.		
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            this.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = this.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled 
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    swatchElement.src = swatchElement.src.replace("_enabled.png", "_disabled.png");

                    //change the title text of the swatch link

                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);

                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * This function is used to change the price displayed in the Product Display Page on change of  a attribute of the product using an AJAX call. 
     * This function will resolve the catentryId using entitledItemId and displays the price of the catentryId.
     *				
     * @param {Object} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {Boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then donot display the price range.
     *
     **/
    changePrice: function (entitledItemId, isPopup, displayPriceRange, productId) {
        this.displayPriceRange = displayPriceRange;
        this.isPopup = isPopup;
        var entitledItemJSON;

        if ($("#" + entitledItemId).length && !this.isPopup) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#"+ entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }
        var catalogEntryId = null;
        this.setEntitledItems(entitledItemJSON);

        if (this.selectedProducts[productId]) {
            var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
        } else {
            var catalogEntryId = this.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            //check if the json object is already present for the catEntry.
            if (this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined') {
                this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry, productId);
                console.debug("ShoppingActions.changePrice: using stored json object.");
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: this.storeId,
                    langId: this.langId,
                    catalogId: this.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetailsSA",
                    actionId: "getCatalogEntryDetailsSA",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        shoppingActionsJS.displayPriceServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetailsSA", parameters);
            }
        } else {
            console.debug("ShoppingActions.changePrice: all attributes are not selected.");
        }

    },

    /** 
     * Displays price of the catEntry selected with the JSON objrct returned from the server.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    displayPriceServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        shoppingActionsJS.displayPrice(serviceResponse.catalogEntry, productId);
    },

    /** 
     * Displays price of the attribute selected with the JSON oject.
     * 
     * @param {object} catEntry The JSON object with catalog entry details.
     */
    displayPrice: function (catEntry, productId) {

        var tempString;
        var popup = shoppingActionsJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
            document.getElementById('productName').innerHTML = catEntry.description[0].name;
            document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
        }

        if (popup == false) {
            var innerHTML = "";
            var listPrice = Utils.parseNumber(catEntry.listPrice);
            var offerPrice = Utils.parseNumber(catEntry.offerPrice);

            this.setPriceInProductList(productId, offerPrice);

            if (!catEntry.listPriced || listPrice <= offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

            innerHTML = "";
            if (shoppingActionsJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            var quantityDiscount = document.getElementById("productLevelPriceRange_" + productId);
            var itemQuantityDiscount = document.getElementById("itemLevelPriceRange_" + productId);

            // if product level price exists and no section to update item level price
            if (null != quantityDiscount && null == itemQuantityDiscount) {
                quantityDiscount.style.display = ""; //display product level price range
            }
            // if item level price range is present
            else if ("" != innerHTML && null != itemQuantityDiscount) {
                innerHTML = Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML;
                itemQuantityDiscount.innerHTML = innerHTML;
                itemQuantityDiscount.style.display = "";
                // hide the product level price range
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = "none";
                }
            }
            // if item level price range is not present
            else if ("" == innerHTML) {
                if (null != itemQuantityDiscount) {
                    itemQuantityDiscount.style.display = "none"; //hide item level price range
                }
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = ""; //display product level price range
                }
            }

            /*
             * If the product name is a link, do not replace the link only replace the text in the link.
             * Otherwise, replace the whole text
             */
            var productNameLink = $('#product_name_' + productId + ' > a');
            if (productNameLink.length == 1) {
                $(productNameLink[0]).html(catEntry.description[0].name);
            } else if ($('#product_name_' + productId)) {
                $('#product_name_' + productId).html(catEntry.description[0].name);
            }

            if ($("#widget_product_info_viewer > div[id^='PageHeading_']").length) {
                $("#widget_product_info_viewer > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }
            if (document.getElementById("ProductInfoName_" + productId) != null) {
                document.getElementById("ProductInfoName_" + productId).value = catEntry.description[0].name;
            }
            if (document.getElementById('product_shortdescription_' + productId)) {
                document.getElementById('product_shortdescription_' + productId).innerHTML = catEntry.description[0].shortDescription;
            }
            if (document.getElementById('product_SKU_' + productId)) {
                document.getElementById('product_SKU_' + productId).innerHTML = Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            }
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to DefiningAttributes_Resolved_[productId] event.
     */
    notifyAttributeChange: function (catalogEntryID) {
        this.baseCatalogEntryId = catalogEntryID;
        var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
        wcTopic.publish('DefiningAttributes_Resolved_' + catalogEntryID, catalogEntryID, -1);
    },

    /**
     * To notify the change in quantity to other components that is subscribed to Quantity_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish("Quantity_Changed", quantity);
    },

    /**
     * Initializes the compare check box for all the products added to compare.
     */
    initCompare: function (fromPage) {
        if (fromPage == 'compare' || fromPage == 'catalogEntryList') {
            this.checkForCompare();
        } else {
            var cookieKey = this.cookieKeyPrefix + this.storeId;
            var newCookieValue = "";
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
        }

    },

    /**
     * Change the compare box status to checked or unchecked
     * @param{String} cbox The ID of the compare check box of the given catentry identifier.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    changeCompareBox: function (cbox, catEntryIdentifier) {
        box = document.getElementById(cbox);
        box.checked = !box.checked;
        this.addOrRemoveFromCompare(catEntryIdentifier, box.checked);
    },

    /**
     * Adds or removes the product from the compare depending on the compare box checked or unchecked.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     * @param{boolean} checked True if the checkbox is checked or False
     */
    addOrRemoveFromCompare: function (catEntryIdentifier, checked) {
        //box = eval(cbox);
        if (checked) {
            this.addToCompare(catEntryIdentifier);
        } else {
            this.removeFromCompare(catEntryIdentifier);
        }
    },

    /**
     * Adds the product to the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    addToCompare: function (catEntryIdentifier) {

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);

        if (cookieValue != null) {
            if (cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS"));
                return;
            }
        }

        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null && cookieValue !== "") {
            currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
        }

        if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
            var newCookieValue = "";
            if (cookieValue == null || cookieValue === "") {
                newCookieValue = catEntryIdentifier;
            } else {
                newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
            }
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
            shoppingActionsJS.checkForCompare();
        } else {
            this.showWCDialogPopup('widget_product_comparison_popup');
            document.getElementById("comparebox_" + catEntryIdentifier).checked = false;
            console.debug("You can only compare up to 4 products");
        }
    },

    /**
     * Removes the product from the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    removeFromCompare: function (catEntryIdentifier) {
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null) {
            if (cookieValue.trim() == "") {
                setCookie(cookieKey, null, {
                    expires: -1
                });
            } else {
                var cookieArray = cookieValue.split(this.cookieDelimiter);
                var newCookieValue = "";
                for (index in cookieArray) {
                    if (cookieArray[index] != catEntryIdentifier) {
                        if (newCookieValue === "") {
                            newCookieValue = cookieArray[index];
                        } else {
                            newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
                        }
                    }
                }
                setCookie(cookieKey, newCookieValue, {
                    path: '/',
                    domain: cookieDomain
                });
                currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
            }
            shoppingActionsJS.checkForCompare();
        }
    },

    /**
     * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
     */
    compareProducts: function (categoryIds, manufacturer) {
        var url = appendWcCommonRequestParameters("CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + encodeURIComponent(this.compareReturnName) + "&searchTerm=" + this.searchTerm);
        if ('' != categoryIds.top_category) {
            url = url + "&top_category=" + categoryIds.top_category;
        }
        if ('' != categoryIds.parent_category_rn) {
            url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
        }
        if ('' != categoryIds.categoryId) {
            url = url + "&categoryId=" + categoryIds.categoryId;
        }
		if (manufacturer != undefined && '' != manufacturer) {
			url = url + "&manufacturer=" + manufacturer;
		}
		
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        if (cookieValue != null && cookieValue.trim() != "") {
            url = url + "&catentryId=" + cookieValue;
        }
        var returnUrl = appendWcCommonRequestParameters(location.href);
        if (returnUrl.indexOf("?") === -1) {
            returnUrl = returnUrl + "?fromPage=compare";
        } else if (returnUrl.indexOf("fromPage=compare") === -1) {
            returnUrl = returnUrl + "&fromPage=compare";
        }
        url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
        location.href = getAbsoluteURL() + url;
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {String} catalogEntryType, type of catalogEntry (item/product/bundle/package)
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     * @param {float} price The price of current product.
     */
    setProductQuantity: function (catalogEntryType, catalogEntryId, quantity, price) {
        var productDetails = null;
        if (this.productList[catalogEntryId]) {
            productDetails = this.productList[catalogEntryId];
        } else {
            productDetails = {};
            this.productList[catalogEntryId] = productDetails;
            productDetails.baseItemId = catalogEntryId;
            if ("item" == catalogEntryType) {
                productDetails.id = catalogEntryId;
            } else {
                productDetails.id = 0;
            }
        }
        productDetails.quantity = quantity;
        wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        productDetails.price = Utils.parseNumber(price);
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     */
    quantityChanged: function (catalogEntryId, quantity) {
        if (this.productList[catalogEntryId]) {
            var productDetails = this.productList[catalogEntryId];
            productDetails.quantity = quantity.trim();
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));

            //Update quantity for catentries in the merchandising association array
            if (MerchandisingAssociationJS != null) {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Sets the price of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} price The price of current product.
     */
    setPriceInProductList: function (catalogEntryId, price) {
        var productDetails = this.productList[catalogEntryId];
        if (productDetails) {
            productDetails.price = price;
        }
    },

    /**
     * Select bundle item swatch
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {String} swatchName
     * @param {String} swatchValue
     * @param {String} doNotDisable, the first swatch, that should not be disabled
     */
    selectBundleItemSwatch: function (catalogEntryId, swatchName, swatchValue, doNotDisable) {
        if ($("#swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue).hasClass("color_swatch_disabled")) {
            return;
        }
        if ($("#entitledItem_" + catalogEntryId).length) {
            var entitledItemJSON;
            var currentSwatchkey = swatchName + "_" + swatchValue;
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = JSON.stringify($("#entitledItem_" + catalogEntryId).html());
            var validSwatchArr = [];
            for (idx in entitledItemJSON) {
                var validItem = false;
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {

                    if (currentSwatchkey == attribute) {
                        validItem = true;
                        break;
                    }
                }
                if (validItem) {
                    for (attribute in entitledItem.Attributes) {
                        var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                        if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                            validSwatchArr.push(attribute);
                        }
                    }
                }
            }

            var swatchesDisabled = [];
            var selectedSwatches = [];
            for (idx in entitledItemJSON) {
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {
                    var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                    if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                        var swatchId = "swatch_" + catalogEntryId + "_" + attribute;
                        var swatchLinkId = swatchId.replace("swatch_", "swatch_link_");
                        if (validSwatchArr.indexOf(attribute) > -1) {
                            if (!$("#" + swatchId).hasClass("color_swatch_selected")) {
                                document.getElementById(swatchId).className = "color_swatch";
                                document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_disabled.png", "_enabled.png");

                                //change the title text of the swatch link
                                document.getElementById(swatchLinkId).title = document.getElementById(swatchId).alt;
                                document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
                            }
                        } else if (swatchesDisabled.indexOf(attribute) === -1) {
                            swatchesDisabled.push(attribute);
                            if ($("#" + swatchId).hasClass("color_swatch_selected")) {
                                selectedSwatches.push(swatchId);
                            }
                            document.getElementById(swatchId).className = "color_swatch_disabled";
                            document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_enabled.png", "_disabled.png");

                            //change the title text of the swatch link
			    
			    var altText = document.getElementById(swatchId).alt;
                            var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [altText]);
                            

                           
                            $("#" + swatchLinkId).attr("aria-disabled", "true");
                        }
                    }
                    if (document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute) != null) {
                        document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute).setAttribute("aria-checked", "false");
                    }
                }
            }

            for (idx in selectedSwatches) {
                var selectedSwatch = selectedSwatches[idx];
                var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_|_"));
                var swatchSelected = false;
                $("[id^='" + idSelector + "']").each(function (index, node, arr) {
                    if (!swatchSelected && $(node).hasClass("color_swatch")) {
                        var values = node.id.split("_");
                        shoppingActionsJS.selectBundleItemSwatch(values[1], values[2], values[3], doNotDisable);
                        shoppingActionsJS.setSelectedAttributeOfProduct(values[1], values[2], values[3], false);
                        swatchSelected = true;
                    }
                });
            }
        }

        if ($("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display") == ("none")) {
            $("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display", "inline");
        }
        $("#swatch_selection_" + catalogEntryId + "_" + swatchName).html(swatchValue);

        var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
        var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

        $("img[id^='" + swatchItem + "']").each(function (index, node, arr) {
            if ($(node).hasClass("color_swatch_disabled")) {
                $(node).removeClass("color_swatch")
            } else {
                $(node).addClass("color_swatch");
            }
            $(node).removeClass("color_swatch_selected");
        });

        $("#" + swatchItem + swatchValue).attr("className", "color_swatch_selected");
        document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

        this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue, false);
        // select image
        this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

    },

    changeBundleItemImage: function (catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId) {
        var entitledItemId = "entitledItem_" + catalogEntryId;
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
        if (imageArr != null) {
            skuImage = imageArr[1];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId) != null) {
                document.getElementById(this.skuImageId).src = skuImage;
                if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                    document.getElementById("ProductInfoImage_" + catalogEntryId).value = skuImage;
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                var itemImage = this.entitledItems[x].ItemThumbnailImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        document.getElementById(this.skuImageId).src = itemImage;
                        if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                            document.getElementById("ProductInfoImage_" + catalogEntryId).value = itemImage;
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    getImageForBundleItem: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedProducts[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray);
    },

    /**
     * Check if any product is already selected for compare in other pages and select them
     */
    checkForCompare: function () {
        var cookieValues = getCookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
        cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
        var labels = $(".compareCheckboxLabels > label");
        $(".compare_target").each(function (i, div) {
            var checkbox = $("input[type=\"checkbox\"]", div)[0];
            checkbox.checked = (cookieValues.indexOf(checkbox.value) !== -1);
            var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
            div.setAttribute("data-state", state.toString());
            var label = $("label[for=\"" + checkbox.id + "\"]", div)[0];
            $(label).html($(labels[state]).html());
        });
    },

    /**
     * replaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
     *
     * @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
     * @param {int} qty The quantity of the item to add.
     * @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
     * @param {String} addressId The address ID of the order item.
     * @param {String} shipModeId The shipModeId of the order item.
     * @param {String} physicalStoreId The physicalStoreId of the order item.
     *
     **/
    replaceItemAjaxHelper: function (catalogEntryId, qty, removeOrderItemId, addressId, shipModeId, physicalStoreId) {

        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderItemId: removeOrderItemId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params2 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: ".",
	    calculateOrder: "1"
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params2.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params3 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params3.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var shipInfoUpdateNeeded = false;
        var orderItemReqd = true;
        if (addressId != null && addressId !== "") {
            params3.addressId = addressId;
        }
        if (shipModeId != null && shipModeId !== "") {
            params3.shipModeId = shipModeId;
        }
        if (physicalStoreId != null && physicalStoreId !== "") {
            params3.physicalStoreId = physicalStoreId;
            orderItemReqd = false;
        }
        if (params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)) {
            shipInfoUpdateNeeded = true;
        }

        if (orderItemReqd) {
            params3.allocate = "***";
            params3.backorder = "***";
            params3.remerge = "***";
            params3.check = "*n";
        }

        //Delcare service for deleting item...
        wcService.declare({
            id: "AjaxReplaceItem",
            actionId: "AjaxReplaceItem",
            url: "AjaxRESTOrderItemDelete",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                //Now add the new item to cart..
                if (!shipInfoUpdateNeeded) {
                    //We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
                    wcService.invoke("AjaxAddOrderItem", params2);
                } else {
                    //We need to update the adderessId and shipModeId..so call our temp service to add..
                    wcService.invoke("AjaxAddOrderItemTemp", params2);
                }
            }

            ,
            failureHandler: function (serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }

        });

        //Delcare service for adding item..
        wcService.declare({
            id: "AjaxAddOrderItemTemp",
            actionId: "AjaxAddOrderItemTemp",
            url: "AjaxRESTOrderItemAdd",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                // setting the newly created orderItemId
                params3.orderItemId = (serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId;

                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

                //Now item is added.. call update to set addressId and shipModeId...
                wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
            }

            ,
            failureHandler: function (serviceResponse) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        });

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxReplaceItem", params);
    },

    /**
     * customizeDynamicKit This function is used to call the configurator page for a dynamic kit.
     * @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
     * @param {int} quantity A quantity of the item to add to the cart.
     * @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
     *
     **/
    customizeDynamicKit: function (catEntryIdentifier, quantity, customParams) {
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catEntryIdentifier,
            quantity: quantity
        };

        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        var configureURL = "ConfigureView";
        var i = 0;
        for (param in params) {
            configureURL += ((i++ == 0) ? "?" : "&") + param + "=" + params[param];
        }
        document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
    }

}

wcTopic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]:click", function (event) {
            this.blur();
            this.focus();
        });
    }
});

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
ServicesDeclarationJS = {
    langId: "-1", /* language of the  store */
    storeId: "", /*numeric unique identifier of the store */
    catalogId: "", /*catalog of the store that is currently in use */

    /**
     * Sets common parameters used by the services
     * @param (int) langId The language of the store.
     * @param (int) storeId The store currently in use.
     * @param (int) catalogId The catalog of the store currently in use.
     */
    setCommonParameters:function(langId,storeId,catalogId){
            this.langId = langId;
            this.storeId = storeId;
            this.catalogId = catalogId;
    }
}

function nullCartTotalCookie(orderId){
    setCookie("WC_CartTotal_"+orderId, null, {expires: -1, path:'/', domain:cookieDomain});

    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("=");
        var name = cookies[i].substr(0,index);
        var value = cookies[i].substr(index+1)
        name = name.replace(/^\s+|\s+$/g,"");
        value = value.replace(/^\s+|\s+$/g,"");
        if (value == orderId) {
            setCookie(name, null, {expires: -1, path:'/', domain:cookieDomain});
            break;
        }
    }
}

    /**
    * Adds an item to to the wishlist and remove the same item from the shopping
    * cart.
    * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAddAndDeleteFromCart",
        actionId: "AjaxInterestItemAddAndDeleteFromCart",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            MessageHelper.hideAndClearMessage();
            resetRequest();
            CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId,true);
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Add an item to a shopping cart in Ajax mode. A message is displayed after
     * the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddOrderItem",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
            cursor_clear();
            if(categoryDisplayJS){

                var attributes = document.getElementsByName("attrValue");

                var singleSKU = true;

                for(var i=0; i<attributes.length; i++){
                    if (attributes[i].options.length > 1)
                    {
                        singleSKU = false;
                    }
                }

                if (!singleSKU)
                {
                    categoryDisplayJS.selectedAttributes = [];
                    for(var i=0; i<attributes.length; i++){
                        if(attributes[i] != null){
                            attributes[i].value = "";
                        }
                    }
                }
            }
            if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
                ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

   /**
   * Add an item to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
    wcService.declare({
        id: "AjaxAddOrderItem_shopCart",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
        formId: ""

     /**
     * redirects to the shopping cart page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            document.location.href =  appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Remove an item from shopping cart. A message is displayed after the service
     * call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""
    /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse, params) {
            MessageHelper.hideAndClearMessage();
            if (typeof addCheckoutLoader === 'function') {
                addCheckoutLoader();
            }
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            /* HB-1050 :: workaround */
            if (!$("#page").hasClass("pdp")) {
            	setTimeout(function() { location.reload(); }, ($("#page.shopping-bag-page").length == 1 ? 2500 : 500));
            }
            if (typeof addToCartInput !== "undefined") {
                fn_ext_genericAddToCart(addToCartInput.frameObject, addToCartInput.lensObject, addToCartInput.warrantyObject, addToCartInput.reviewObject, addToCartInput.imagery, addToCartInput.merchandisingAssociations);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),


    /**
     * Removes an item from shopping cart on the shipping & billing page. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemForShippingBillingPage",
        actionId: "AjaxDeleteOrderItemForShippingBillingPage",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

        /**
         * display a success message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
        }

        /**
         * display an error message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),


    /**
     * Remove an item from shopping cart. A message is only displayed if the service
     * call returns an error Message. It is used to remove an item from the shopping
     * cart and add the same item to the wish list.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemFromCart",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }


    }),

    /**
     * Remove an item from shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page or the OrderShippingBillingView page depending on what page the service was invoked from.
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem1",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                setDeleteCartCookie();
                if(CheckoutHelperJS.shoppingCartPage){

                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }else{
                    document.location.href = appendWcCommonRequestParameters("OrderShippingBillingView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service updates an order item in the shopping cart.
     * A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.hideFormErrorHandle();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),

    /**
     * Updates an order item in the shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem1",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""
    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                if(CheckoutHelperJS.shoppingCartPage){
                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service updates shipping information (shipping mode, shipping address)
     * for a shopping cart. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderShippingInfo",
        actionId: "AjaxUpdateOrderShippingInfo",
        url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service prepares an order for submission. Upon success, it submits the order.
     * @constructor
     */
    wcService.declare({
        id: "AjaxPrepareOrderForSubmit",
        actionId: "AjaxPrepareOrderForSubmit",
        url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
        formId: ""

    /**
     * On success, checkout the order by calling order submit.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            CheckoutHelperJS.setOrderPrepared("true");
            CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service submits the order. Upon success, the order billing confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitOrder",
        actionId: "AjaxSubmitOrder",
        url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
        formId: ""

    /**
     *redirect to the Order Confirmation page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            nullCartTotalCookie(serviceResponse.orderId);
            /* START - Online Return Form */
            if (typeof goToOnlineReturnTYP == 'function') {
                goToOnlineReturnTYP();
            } else {
                var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
                document.location.href = appendWcCommonRequestParameters("OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId);
            }
            /* END - Online Return Form */
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     *
     * In case of failure, the next error messages will not be sent to Tealium: See paymentResponseCodesNotToSendToTealium set in CommonUtilities.js
     *
     */
        ,failureHandler: function(serviceResponse) {
            //NERD-727: Start the authentication session in case the card is enrolled in pyaer authentications.
            if (serviceResponse.errorMessageKey == "PLUGIN_RC_475" && $("#JWT").length > 0) {
                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/cart/@self/payment_instruction";
                createPaymentLoaderOverlay() //creates a dark overlay with a spinner;

                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                    data: {
                        "timestamp": Date.now()
                    },
                    success: function (data) {
                        if (data != undefined) {
                            var payerAuthEnrollReply_paReq;
                            var payerAuthEnrollReply_acsURL;
                            var payerAuthEnrollReply_authenticationTransactionID;
                            $.each(data.paymentInstruction[0].protocolData, function (index, value) {
                                if (value.name == 'payerAuthEnrollReply_paReq') {
                                    payerAuthEnrollReply_paReq = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_acsURL') {
                                    payerAuthEnrollReply_acsURL = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_authenticationTransactionID') {
                                    payerAuthEnrollReply_authenticationTransactionID = value.value;
                                }
                            });
                            // Start the authentication session.
                            Cardinal.continue('cca',
                            {
                                "AcsUrl": payerAuthEnrollReply_acsURL,
                                "Payload": payerAuthEnrollReply_paReq
                            },
                            {
                                "OrderDetails":{
                                    "TransactionId" : payerAuthEnrollReply_authenticationTransactionID
                                }
                            });
                        }
                    },
                    error: function(data){
                        deletePaymentLoaderOverlay();

                        MessageHelper.displayErrorMessage("There was a problem while retrieving the payment data.");
                        cursor_clear();
                    }
                });
            } else if (serviceResponse.errorMessage) {
                deletePaymentLoaderOverlay();
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);

                sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                cursor_clear();
            } else {
                if (serviceResponse.errorMessageKey) {
                    deletePaymentLoaderOverlay();
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);

                    sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                }
                cursor_clear();
            }
        }
    }),

    /**
     * This service submits the quote. Upon success, the quote  confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitQuote",
        actionId: "AjaxSubmitQuote",
        url: getAbsoluteURL() + "AjaxSubmitQuote",
        formId: ""

   /**
    *redirect to the Quote Confirmation page
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,successHandler: function(serviceResponse) {
            var redirectURL = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId
            + "&catalogId=" + ServicesDeclarationJS.catalogId
            + "&langId=" + ServicesDeclarationJS.langId
            + "&orderId=" + CheckoutHelperJS.getOrderId()
            + "&shipmentTypeId=" + CheckoutHelperJS.getShipmentTypeId()
            + "&isQuote=true"
            + "&quoteId=" + serviceResponse.outOrderId// outOrderId is the id of the new quote created.

            if(serviceResponse.outExternalQuoteId != undefined && serviceResponse.outExternalQuoteId != null){
                redirectURL += redirectURL + "&externalQuoteId=" + serviceResponse.outExternalQuoteId;
            }
            document.location.href = appendWcCommonRequestParameters(redirectURL);
        }

   /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddAddressForPerson",
        actionId: "AjaxAddAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateAddressForPerson",
        actionId: "AjaxUpdateAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service calls AjaxRESTOrderItemUpdate to update order total after shipping address is updated in the order.
     */
    wcService.declare({
        id: "AjaxUpdateOrderAfterAddressUpdate",
        actionId: "AjaxUpdateOrderAfterAddressUpdate",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
            categoryDisplayJS.selectedAttributes = [];
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist in non-Ajax mode. Upon success,
     * the shopping cart page is displayed. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd_shopCart",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This service deletes an item from the wish list. An error message will be
   * displayed if the service call failed.
   */
    wcService.declare({
        id: "AjaxInterestItemDelete",
        actionId: "AjaxInterestItemDelete",
        url: getAbsoluteURL() + "AjaxInterestItemDelete",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service sends the wish list to a specified email address.
     */
    wcService.declare({
        id: "AjaxInterestItemListMessage",
        actionId: "AjaxInterestItemListMessage",
        url: getAbsoluteURL() + "AjaxInterestItemListMessage",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeManage",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
        	var obj = {
        			'id' : 'Event',
                    'Events_DiscountApplied' : '1',
        			'Order_DiscountCode':serviceResponse.promoCode,
                    'Order_DiscountName':serviceResponse.promoCode
        	}
        	pushDiscountCode(obj);
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";
            wcService.invoke("AjaxUpdateOrderItem",params);*/
            
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse){
            if (serviceResponse.errorMessage){
                $("#promoCode").addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, serviceResponse.errorMessage);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessage,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName': "",
                        'Error_Message' : 'PromoCode -'+ serviceResponse.errorMessage
                }
                pushDiscountCode(obj);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            } else if (serviceResponse.errorMessageKey){
                $("#promoCode").addClass("error");
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessageKey,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName': ""
                }
                pushDiscountCode(obj);
            }
            cursor_clear();
        }
    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeDelete",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/
            
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsAdd",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsRemove",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds a billing address to the order(s).
     */
    wcService.declare({
        id: "AddBillingAddress",
        actionId: "AddBillingAddress",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            console.log("PSL::ServicesDeclaration.js::AddBillingAddress::successHandler");
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            console.log("PSL::ServicesDeclaration.js::AddBillingAddress::failureHandler");
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        var originalOrderId = document.getElementById("orderIdToSchedule").value;
        var newOrderId = serviceResponse.orderId;
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var purchaseOrderNumber = "";
        if(document.forms["purchaseOrderNumberInfo"].purchase_order_number.value != null){
            purchaseOrderNumber = document.forms["purchaseOrderNumberInfo"].purchase_order_number.value;
        }
        var url = "RESTOrderCancel?orderId=" + originalOrderId + "&storeId="  + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" + newOrderId + "%26originalOrderId%3D" + originalOrderId + "%26shipmentTypeId%3D" + shipmentTypeId + "%26purchaseOrderNumber%3D" + purchaseOrderNumber;
        document.location.href = appendWcCommonRequestParameters(url);
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var url = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId;
        document.location.href = appendWcCommonRequestParameters(url);
        cursor_clear();
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service updates the free gift choices made by the shopper for the
 * promotion.
 */
wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: ""

/**
 * Hides all the messages and the progress bar.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();

    }
 /**
 * Display an error message.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {

        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }

}),

    /**
     * Create a new saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCreate",
        actionId: "AjaxOrderCreate",
        url: getAbsoluteURL() + "AjaxOrderCreate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_CREATED"]);

            cursor_clear();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {

                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CREATED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a single saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCancel",
        actionId: "AjaxSingleOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDERS_CANCELLED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a saved order. This service is used to delete multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCancel",
        actionId: "AjaxOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.cancelSavedOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Update the description of a saved order. This service is used to update the description of multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderSave",
        actionId: "AjaxOrderSave",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.saveOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SAVED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Set the current order to be that of a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSetPendingOrder",
        actionId: "AjaxSetPendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();

            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);

            savedOrdersJS.determinePageForward("AjaxSetPendingOrder");

            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E" || serviceResponse.errorCode == "CMN1024E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Updates the current pending order setting it to the current shopping cart.
     * This service does not cause a refresh of the ListOrdersDisplay_Controller registered widgets.
     * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
     * Perform the service or command call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdatePendingOrder",
        actionId: "AjaxUpdatePendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * There is nothing to do in the event of a success of this service since it is executed in the background.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder");
            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCopy",
        actionId: "AjaxSingleOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxSingleOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCopy",
        actionId: "AjaxOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

    /**
    * display a success message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

    /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCalculate",
        actionId: "AjaxSingleOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_COPIED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxCurrentOrderCalculate",
        actionId: "AjaxCurrentOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCalculate",
        actionId: "AjaxOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            // Call again to copy any other orders in the list.
            savedOrdersJS.copyOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Processes a punchout payment request.
     */
    wcService.declare({
        id: "AjaxPunchoutPay",
        actionId: "AjaxPunchoutPay",
        url: "AjaxRESTOrderRePay",
        formId: ""

        /**
         * Calls PunchoutJS.handleResponse to render the punchout payment section on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            PunchoutJS.handleResponse(serviceResponse.orderId);
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),


    /**
     * Subscribes to or unsubscribes from receiving information related to a particular category in the store.
     */
    wcService.declare({
        id: "AjaxCategorySubscribe",
        actionId: "AjaxCategorySubscribe",
        url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
        formId: ""

        /**
         * Clear messages on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_UPDATED"]);
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    })

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Global Login widget to handle the services
 * @version 1.10
 */

/* global document, window, $, wc, Utils, WCParamJS, MessageHelper, cursor_clear, getAbsoluteURL */


/**
 * This service allows customer to sign in
 * @constructor
 */
wcService.declare({
    id: "globalLoginAjaxLogon", 
    actionId: "globalLoginAjaxLogon",
    url: getAbsoluteURL() + "AjaxLogon",
    formId: "",

    /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        cursor_clear();
        var errorMessage = "";
        if (serviceResponse.ErrorCode != null) {
            var errorCode = Number(serviceResponse.ErrorCode);
            switch (errorCode) {
            case 2000:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2000"];
                break;
            case 2010:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2010"];
                break;
            case 2020:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2020"];
                break;
            case 2030:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"];
                break;
            case 2110:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2300:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2300"];
                break;
            case 2340:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2340"];
                break;
            case 2400:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2400"];
                break;
            case 2410:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2410"];
                break;
            case 2420:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2420"];
                break;
            case 2430:
                document.location.href = "ResetPasswordForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode;
                break;
            case 2170:
                document.location.href = "ChangePassword?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode + "&logonId=" + serviceResponse.logonId;
                break;
            case 2570:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2570"];
                    break;
                case 2440:
                    errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2440"];
                    break;
                case 2450:
                    errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2450"];
                    break;
                case 2711 : 
                	GlobalLoginJS.InitHTTPSecureFromPolicy();
                	GlobalLoginJS.showPolicyPopup();
                	
            }
            if (document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL") != null) {
                document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL").innerHTML = errorMessage;
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.querySelectorAll(".form-group .myaccount_error").forEach((el) => {
                    el.classList.add("active");
                });
            }

            /*--- WCAG Begin MCB --*/
            var attr = $('.myaccount_error').attr('tabindex');
            if(!(typeof attr !== typeof undefined && attr !== false)) {
                $('.myaccount_error').attr('tabindex', '0');
            }
            //this if prevents js error if WCAG.js are not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }
            /*--- WCAG Begin MCB --*/

            /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
	            var code = 'Error while trying to login user';
	            pushErrorToTealium('Server', '', code, errorMessage);
            }
            /* TEALIUM END */

        } else {
        	sessionStorage.setItem('logged', 'true');
            var url = serviceResponse.URL[0].replace(/&amp;/g, '&'),
                languageId = serviceResponse.langId;
            if (languageId != null && document.getElementById('langSEO' + languageId) != null) { // Need to switch language.

                var browserURL = document.location.href,
                    currentLangSEO = '/' + $('#currentLanguageSEO').val() + '/';

                if (browserURL.indexOf(currentLangSEO) !== -1) {
                    // If it's SEO URL.
                    var preferLangSEO = '/' + $('#langSEO' + languageId).val() + '/';

                    var query = url.substring(url.indexOf('?') + 1, url.length),
                        parameters = Utils.queryToObject(query);
                    if (parameters["URL"] != null) {
                        var redirectURL = parameters["URL"],
                            query2 = redirectURL.substring(redirectURL.indexOf('?') + 1, redirectURL.length),
                            parameters2 = Utils.queryToObject(query2);
                        // No redirect URL
                        if (parameters2["URL"] != null) {
                            var finalRedirectURL = parameters2["URL"];
                            if (finalRedirectURL.indexOf(currentLangSEO) != -1) {
                                // Get the prefer language, and replace with prefer language.
                                finalRedirectURL = finalRedirectURL.replace(currentLangSEO, preferLangSEO);
                                parameters2["URL"] = finalRedirectURL;
                            }
                            query2 = $.param(parameters2);
                            redirectURL = redirectURL.substring(0, redirectURL.indexOf('?')) + '?' + query2;
                        } else {
                            //Current URL is the final redirect URL.
                            redirectURL = redirectURL.toString().replace(currentLangSEO, preferLangSEO);
                        }
                        parameters["URL"] = redirectURL;
                    }
                    query = $.param(parameters);
                    url = url.substring(0, url.indexOf('?')) + '?' + query;

                } else {
                    // Not SEO URL.
                    // Parse the parameter and check whether if have langId parameter.
                    if (url.contains('?')) {
                        var query = url.substring(url.indexOf('?') + 1, url.length),
                            parameters = Utils.queryToObject(query);
                        if (parameters["langId"] != null) {
                            parameters["langId"] = languageId;
                            var query2 = $.param(parameters);
                            url = url.substring(0, url.indexOf('?')) + '?' + query2;
                        } else {
                            url = url + "&langId=" + languageId;
                        }
                    } else {
                        url = url + "?langId=" + languageId;
                    }
                }
            }

            if (isPersol && $("#page").hasClass("checkout")){
                var physicalStoreSelectionURL = $("#GLPhysicalStoreSelectionURL").val();
                var billingShippingPageURLForOnline = $("#GLRegisteredUserOrderCalculateURL").val();
		
                if (ShipmodeSelectionExtJS.isBOPISEnabled() && ShipmodeSelectionExtJS.isPickUpInStore()) {
                    url = physicalStoreSelectionURL;
                } else {
                    url = billingShippingPageURLForOnline;
                }
            }

            if (serviceResponse["MERGE_CART_FAILED_SHOPCART_THRESHOLD"] == "1") {
                setCookie("MERGE_CART_FAILED_SHOPCART_THRESHOLD", "1", {path: "/", domain: cookieDomain});
            }

            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */

            /* START - Wishlist */
            if (isPersol || isOliver) {
                sessionStorage.removeItem("defaultWishlistExternalId");
                sessionStorage.removeItem("wishlistObj");
            }
            /* END - Wishlist */

            window.location = url;

             /*--- WCAG Begin MCB --*/
             var attr = $('.myaccount_error').attr('tabindex');
             if(typeof attr !== typeof undefined && attr !== false) {
                 $('.myaccount_error'). removeAttr('tabindex');
             }
             /*--- WCAG Begin MCB --*/
            
            /* TEALIUM BEGIN Login success */
            /* HB-11904 BEGIN*/
            /*if(typeof tealium_data2track !== 'undefined'){
                tealium_data2track.push({
             	   'id' : 'X-X-CheckoutDelivery-Login',
             	   'User_Email_MD5' : serviceResponse.userEmail
             	});
            }*/
            /* HB-11904 END*/
            /* TEALIUM END */
        }
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides all the functions and variables to manage Global Login panel.
 */

/* global document, window, $, setCookie, getCookie, cookieDomain, WCParamJS, GlobalLoginJS, Utils, cursor_clear, cursor_wait, submitRequest, wc, processAndSubmitForm, invokeItemAdd, invokeOtherService, isOnPasswordUpdateForm, service */

/**
* Constant key in activePanel
*/
var KEY_ACTIVE = 'active',

    /**
    * Constant key in activePanel
    */
    KEY_SELECTED = 'selected'; 

GlobalLoginJS = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    activePanel: {},

    widgetsLoadedOnPage: [],

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    isPanelVisible: true,

    /**
     * True if mouse down event registered, false otherwise (prevents registering
     * event more than once).
     */
    mouseDownConnectHandle: null,
          
    logonId:null,
        
    reLogonURL : null,
       
    URL:null,
    
    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        cursor_clear();
    },

    hideGLPanel: function (isPanelVisible) {
        this.isPanelVisible = isPanelVisible;
    },

    registerWidget: function (widgetId) {
        this.widgetsLoadedOnPage.push(widgetId);
    },
    
       
      /**
       * 
       */
     InitHTTPSecureFromPolicy : function(){
        	
        	 var href = document.location.href;
             var index = href.lastIndexOf("s", 4);
        	
             if(index == -1){
             	// Loaded with HTTP. Change it to HTTPS along with appropriate port.
         		if (WCParamJS.urlPrefixForHTTP) {
         			var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
         			index = newHref.indexOf("/");
         			newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
         		} else {
         			var newHref = href.substring(0,4) + "s" + (href.substring(4));
        		}
                 setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                     path: '/',
                     domain: cookieDomain
                 });
                 window.location = newHref;
             }
    
            
            return;
        	
     },

    InitHTTPSecure: function (widgetId) {
        var href = document.location.href;
        var index = href.lastIndexOf("s", 4);

        if (index != -1) {
            // Open sign in panel if loaded with HTTPS.
            GlobalLoginJS.displayPanel(widgetId);

        } else {
			// Loaded with HTTP. Change it to HTTPS along with appropriate port.
			if (WCParamJS.urlPrefixForHTTP) {
				var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
				index = newHref.indexOf("/");
				newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
			} else {
				var newHref = href.substring(0,4) + "s" + (href.substring(4));
			}
            setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                path: '/',
                domain: cookieDomain
            });
            window.location = newHref;
            return;
        }
    },

    displayPanel: function (widgetId) {
        //check if the sign in panel is loaded. if loaded, toggle the dropdown. Else, trigger a refresh.
        var widgetNode = $("#" + widgetId);
        if (widgetNode.length > 0) {
            var panelLoaded = widgetNode.attr("panel-loaded");
            if (panelLoaded) {
                this.togglePanel(widgetNode);
            } else if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
                if (!submitRequest()) {
                    return;
                }
                cursor_wait();
                wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId" : widgetId});
            }
        }
    },

    togglePanel: function (widgetNode) {
        // toggle the current active global login panel
    	 if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
    		 //HB-661
    		 var idPrefix = this.activePanel[KEY_ACTIVE] + "_";
    		 var form_input_user = idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1";
    		 var form_input_pass = idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1";
    		 if (!$("#" + form_input_user).is(":focus") && !$("#" + form_input_pass).is(":focus")) {
    			 $("#" + this.activePanel[KEY_ACTIVE]).toggleClass("active");
	             $("#" + this.activePanel[KEY_SELECTED]).toggleClass("selected");
	
	             //if the current active panel is not the caller
	             if (this.activePanel[KEY_ACTIVE] != widgetNode.attr("id")) {
	                 var toggleControl = widgetNode.attr("data-toggle-control");
	                 //toggle current widget
	                 widgetNode.toggleClass("active");
	                 toggleControl.toggleClass("selected");
	
	                 //set the current caller as active
	                 this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
	                 this.activePanel[KEY_SELECTED] = toggleControl;
	             } else {
	                 delete this.activePanel.active;
	                 delete this.activePanel.selected;
	                 widgetNode.attr("panel-loaded", false);
	                 this.unregisterMouseDown();
	             }
    		 }
         } else {
             var toggleControl = widgetNode.attr("data-toggle-control");
             //no panel is active. toggle the current
             widgetNode.toggleClass("active");
             $("#" + toggleControl).toggleClass("selected");

             //set the current caller as active
             this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
             this.activePanel[KEY_SELECTED] = toggleControl;
             this.registerMouseDown();
         }
    },

    updateGlobalLoginSignInContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        var redirectToPageName = getCookie("WC_RedirectToPage_" + WCParamJS.storeId);
        if (redirectToPageName != undefined && redirectToPageName != null) {
            setCookie("WC_RedirectToPage_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId": widgetId, "redirectToPageName": redirectToPageName});
    },

    updateGlobalLoginUserDisplay: function (displayName) {
        $("#Header_GlobalLogin_signOutQuickLinkUser").html(displayName);
    },

    updateGlobalLoginContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if($('#'+widgetId).length){
	    	wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"true", "widgetId": widgetId});
	    }else{
	    	cursor_clear();
	    }
    },

    updateOrganization: function (formName, widgetId) {
        var orgSetInSessionURL = widgetId + '_' + 'orgSetInSessionURL';
        var orgSetInSessionURLEle = document.getElementById(orgSetInSessionURL);
        if (orgSetInSessionURLEle != null) {
            var href = document.location.href;
            orgSetInSessionURLEle.value = href;
        }
        var form = document.forms[widgetId + '_' + formName];
        if (!submitRequest()) {
            return;
        }
        processAndSubmitForm(form);
    },

    prepareSubmit: function (widgetId) {
        var idPrefix = widgetId + "_";
        if (document.getElementById(idPrefix + "signInDropdown") != null && document.getElementById(idPrefix + "signInDropdown").className.indexOf("active") > -1) {
            document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").setAttribute("class", "wcag__error errorLabel");
            document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").setAttribute("class", "wcag__error errorLabel");
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className = document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className + " active";
                    return false;
                }
            }
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className = document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className + " active";
                    return false;
                }
            }
        }
        return true;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str == '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Updates the contract that is available to the current user.
     * @param {string} formName  The name of the form that contains the selected contracts.
     */
    updateContract: function (formName) {
        var form = document.forms[formName];

        /* For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }

        form.submit();
    },

    deleteUserLogonIdCookie: function (contractURL) {
        var userLogonIdCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        sessionStorage.setItem('logged', 'false');
        if (userLogonIdCookie != null) {
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        /* START - Wishlist */
        if (isPersol || isOliver) {
            sessionStorage.removeItem("defaultWishlistExternalId");
            sessionStorage.removeItem("wishlistObj");
        }
        /* END - Wishlist */
    },

    changeRememberMeState: function (jspStoreImgDir, target) {
        var targetEle = document.getElementById(target);
        if (targetEle.className.indexOf("active") > -1) {
            targetEle.className = targetEle.className.replace('active', '');
            targetEle.setAttribute("aria-checked", "false");
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox.png");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "false");
        } else {
            targetEle.className = targetEle.className + " active";
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox_checked.png");
            targetEle.setAttribute("aria-checked", "true");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "true");
        }
    },

    deleteLoginCookies: function () {
        this.deleteUserLogonIdCookie();
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
    },

    /**
     * Submit a global login sign in form
     * @param (object) widgetId The form widgetId id.
     */
    submitGLSignInForm: function (formId, widgetId) {
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var logonForm = document.getElementById(formId);
        if(logonForm != null){
        	if(logonForm.logonId != null){
                this.logonId = logonForm.logonId.value;
        	}
        	if(logonForm.URL != null){
        		this.URL = logonForm.URL.value
        	}
        	if(logonForm.reLogonURL != null){
        		this.relogonURL = logonForm.reLogonURL.value;
        	}
        }

        
        var params = {
            widgetId: widgetId,
            acceptedPolicyValue: 'false',
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke('globalLoginAjaxLogon', params);
    },
    
    /**
     * 
     */
    submitGLSignInFormFromPolicyPopup : function(formId,widgetId,reLogonURL){
    	
        var encodedReLogonURI = encodeURI(reLogonURL);
        var acceptedPolicyValue = "";
           	
        //NERD-93 accept policy
        var acceptPolicyCheckBox = document.getElementById('agreeConcent_popup');

        
        if(acceptPolicyCheckBox != null){
        	acceptedPolicyValue = acceptPolicyCheckBox.checked;
        }
                
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var params = {
            acceptedPolicyValue:acceptedPolicyValue,
        	reLogonURL : this.relogonURL,
            URL : this.URL,
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        
        wcService.invoke('globalLoginAjaxLogon', params);
    	
    },

    /**
     * After successful login and setting a contract in session, we need to process the action that the shopper
     * was performing before signing in. It will do nothing if shopper was not trying to perform any actions.
     */
    processNextURL: function () {
        var myNextURL = getCookie("WC_nextURL_" + WCParamJS.storeId);
        if (myNextURL != undefined && myNextURL.length > 0) {
            myNextURL = myNextURL.replace(/&amp;/g, "&");
            if (myNextURL.indexOf('AjaxRESTOrderItemAdd') != -1) {
                invokeItemAdd(myNextURL);
            } else {
                invokeOtherService(myNextURL);
            }
        }
    },

    registerMouseDown: function () {
        if (!this.mouseDownConnectHandle) {
            $(document.documentElement).on("mousedown", $.proxy(this.handleMouseDown, this));
            this.mouseDownConnectHandle = true;
        }
    },

    unregisterMouseDown: function () {
        if (this.mouseDownConnectHandle) {
            $(document.documentElement).off("mousedown");
            this.mouseDownConnectHandle = false;
        }
    },

    handleMouseDown: function (evt) {
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            Utils.ifSelectorExists("#" + this.activePanel[KEY_ACTIVE], function(widgetNode) {
                var toggleControl = $("#" + this.activePanel[KEY_SELECTED]);
                var node = evt.target;
                if (node != document.documentElement) {
                    var close = true;
                    while (node && node != document.documentElement) {
                        if (Utils.elementExists("#" + node.id + "_dropdown") && Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") != null && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position(node),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropdownHeight = $("#" + node.id + "_dropdown").get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                $("#" + node.id + "_dropdown").css("height", newHeight + "px");
                            }
                        }
                        if (widgetNode.is(node) || toggleControl.is(node) || $(node).hasClass("dijitPopup")) {
                            close = false;
                            break;
                        }
                        node = node.parentNode;
                    }
                    node = null;
                    if (node == null) {
                        widgetNode.children("div").each(function(i, e) {
                            var position = Utils.position(e);
                            if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                                evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                                close = false;
                                return false; // breaks
                            }
                        });
                        if (Utils.elementExists("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown") &&
                            $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown").css("display") != "none" &&
                            Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2"),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropDown = $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown"),
                                dropdownHeight = dropDown.get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                dropDown.css("height", newHeight + "px");
                            }
                        }
                    }
                    if (close) {
                        this.togglePanel(widgetNode);
                    }
                }
            }, this);
        }
    },
    
      /**
        * show store policy popup
        */
       showPolicyPopup : function(){
         var policyPopup = $('#acceptance_policy_popup');
         policyPopup.data("wc-WCDialog").open();
        },
        
        /**
         * hides store policy popup
         */
        hidePolicyPopup : function(){
        	var policyPopup = $('#acceptance_policy_popup');
        	policyPopup.data("wc-WCDialog").close();
         }
};
!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

/*
Copyright © 2013 Adobe Systems Incorporated.
Licensed under the Apache License, Version 2.0 (the “License”);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an “AS IS” BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * See <a href="http://jquery.com">http://jquery.com</a>.
 * @name jquery
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 */

/**
 * See <a href="http://jquery.com">http://jquery.com</a>
 * @name fn
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @memberOf jquery
 */

/**
 * @fileOverview accessibleMegaMenu plugin
 *
 *<p>Licensed under the Apache License, Version 2.0 (the “License”)
 *<br />Copyright © 2013 Adobe Systems Incorporated.
 *<br />Project page <a href="https://github.com/adobe-accessibility/Accessible-Mega-Menu">https://github.com/adobe-accessibility/Accessible-Mega-Menu</a>
 * @version 0.1
 * @author Michael Jordan
 * @requires jquery
 */

/*jslint browser: true, devel: true, plusplus: true, nomen: true */
/*global jQuery, window, document */
(function ($, window, document) {
    "use strict";
    var pluginName = "accessibleMegaMenu",
        defaults = {
            uuidPrefix: "accessible-megamenu", // unique ID's are required to indicate aria-owns, aria-controls and aria-labelledby
            menuClass: "accessible-megamenu", // default css class used to define the megamenu styling
            topNavItemClass: "accessible-megamenu-top-nav-item", // default css class for a top-level navigation item in the megamenu
            panelClass: "accessible-megamenu-panel", // default css class for a megamenu panel
            panelGroupClass: "accessible-megamenu-panel-group", // default css class for a group of items within a megamenu panel
            hoverClass: "hover", // default css class for the hover state
            focusClass: "focus", // default css class for the focus state
            openClass: "open", // default css class for the open state,
            toggleButtonClass: "accessible-megamenu-toggle", // default css class responsive toggle button
            openDelay: 0, // default open delay when opening menu via mouseover
            closeDelay: 250, // default open delay when opening menu via mouseover
            openOnMouseover: false // default setting for whether menu should open on mouseover
        },
        Keyboard = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
            keyMap: {
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
                190: "."
            }
        },
        clearTimeout = window.clearTimeout,
        setTimeout = window.setTimeout,
        isOpera = window.opera && window.opera.toString() === '[object Opera]';
    /**
     * @desc Creates a new accessible mega menu instance.
     * @param {jquery} element
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @constructor
     */
    function AccessibleMegaMenu(element, options) {
        this.element = element;

        // merge optional settings and defaults into settings
        this.settings = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.mouseTimeoutID = null;
        this.focusTimeoutID = null;
        this.mouseFocused = false;
        this.justFocused = false;

        this.init();
    }

    AccessibleMegaMenu.prototype = (function () {

        /* private attributes and methods ------------------------ */
        var uuid = 0,
            keydownTimeoutDuration = 1000,
            keydownSearchString = "",
            isTouch = 'ontouchstart' in window || window.navigator.msMaxTouchPoints,
            _getPlugin,
            _addUniqueId,
            _togglePanel,
            _clickHandler,
            _touchmoveHandler,
            _clickOutsideHandler,
            _DOMAttrModifiedHandler,
            _focusInHandler,
            _focusOutHandler,
            _keyDownHandler,
            _mouseDownHandler,
            _mouseOverHandler,
            _mouseOutHandler,
            _clickToggleHandler,
            _toggleExpandedEventHandlers,
            _addEventHandlers,
            _removeEventHandlers;

        /**
         * @name jQuery.fn.accessibleMegaMenu~_getPlugin
         * @desc Returns the parent accessibleMegaMenu instance for a given element
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _getPlugin = function (element) {
            return $(element).closest(':data(plugin_' + pluginName + ')').data("plugin_" + pluginName);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_addUniqueId
         * @desc Adds a unique id and element.
         * The id string starts with the
         * string defined in settings.uuidPrefix.
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _addUniqueId = function (element) {
            element = $(element);
            var settings = this.settings;
            if (!element.attr("id")) {
                element.attr("id", settings.uuidPrefix + "-" + new Date().getTime() + "-" + (++uuid));
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_togglePanel
         * @desc Toggle the display of mega menu panels in response to an event.
         * The optional boolean value 'hide' forces all panels to hide.
         * @param {event} event
         * @param {Boolean} [hide] Hide all mega menu panels when true
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _togglePanel = function (event, hide) {
            var target = $(event.target),
                that = this,
                settings = this.settings,
                menu = this.menu,
                topli = target.closest('.' + settings.topNavItemClass),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                newfocus;

            _toggleExpandedEventHandlers.call(this, true);

            if (hide) {
                topli = menu.find('.' + settings.topNavItemClass + ' .' + settings.openClass + ':first').closest('.' + settings.topNavItemClass);
                if (!(topli.is(event.relatedTarget) || topli.has(event.relatedTarget).length > 0)) {
                    if ((event.type === 'mouseout' || event.type === 'focusout') && topli.has(document.activeElement).length > 0) {
                        return;
                    }
                    topli.find('[aria-expanded]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                    if ((event.type === 'keydown' && event.keyCode === Keyboard.ESCAPE) || event.type === 'DOMAttrModified') {
                        newfocus = topli.find(':tabbable:first');
                        setTimeout(function () {
                            menu.find('[aria-expanded].' + that.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
                            newfocus.focus();
                            that.justFocused = false;
                        }, 99);
                    }
                } else if (topli.length === 0) {
                    menu.find('[aria-expanded=true]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                }
            } else {
                clearTimeout(that.focusTimeoutID);
                topli.siblings()
                    .find('[aria-expanded]')
                    .attr('aria-expanded', 'false')
                    .removeClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'true');
                topli.find('[aria-expanded]')
                    .attr('aria-expanded', 'true')
                    .addClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'false');

                var pageScrollPosition = $('html')[0].scrollTop;
                var openPanelTopPosition = $('.' + settings.panelClass + '.' + settings.openClass).parent().offset().top;

                if(pageScrollPosition > openPanelTopPosition) {
                    $('html')[0].scrollTop = openPanelTopPosition;
                }

                if (event.type === 'mouseover' && target.is(':tabbable') && topli.length === 1 && panel.length === 0 && menu.has(document.activeElement).length > 0) {
                    target.focus();
                    that.justFocused = false;
                }

                _toggleExpandedEventHandlers.call(that);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickHandler
         * @desc Handle click event on mega menu item
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickHandler = function (event) {
            var target = $(event.target).closest(':tabbable'),
                topli = target.closest('.' + this.settings.topNavItemClass),
                panel = target.closest('.' + this.settings.panelClass);
            if (topli.length === 1
                    && panel.length === 0
                    && topli.find('.' + this.settings.panelClass).length === 1) {
                if (!target.hasClass(this.settings.openClass)) {
                    event.preventDefault();
                    event.stopPropagation();
                    _togglePanel.call(this, event);
                    this.justFocused = false;
                } else {
                    if (this.justFocused) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.justFocused = false;
                    } else if (isTouch || !isTouch && !this.settings.openOnMouseover) {
                        event.preventDefault();
                        event.stopPropagation();
                        _togglePanel.call(this, event, target.hasClass(this.settings.openClass));
                    }
                }
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_touchmoveHandler
         * @desc Handle touch move event on menu
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _touchmoveHandler = function () {
            this.justMoved = true;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickOutsideHandler
         * @desc Handle click event outside of a the megamenu
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickOutsideHandler = function (event) {
            if ($(event.target).closest(this.menu).length === 0) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_DOMAttrModifiedHandler
         * @desc Handle DOMAttrModified event on panel to respond to Windows 8 Narrator ExpandCollapse pattern
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _DOMAttrModifiedHandler = function (event) {
            if (event.originalEvent.attrName === 'aria-expanded'
                    && event.originalEvent.newValue === 'false'
                    && $(event.target).hasClass(this.settings.openClass)) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusInHandler
         * @desc Handle focusin event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusInHandler = function (event) {
            clearTimeout(this.focusTimeoutID);
            var target = $(event.target),
                panel = target.closest('.' + this.settings.panelClass);
            target
                .addClass(this.settings.focusClass);
            this.justFocused = !this.mouseFocused || (!this.settings.openOnMouseover && this.mouseFocused);
            this.mouseFocused = false;
            if (this.justFocused && this.panels.not(panel).filter('.' + this.settings.openClass).length) {
                _togglePanel.call(this, event);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusOutHandler
         * @desc Handle focusout event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusOutHandler = function (event) {
            this.justFocused = false;
            var that = this,
                target = $(event.target),
                topli = target.closest('.' + this.settings.topNavItemClass);
            target
                .removeClass(this.settings.focusClass);

            if (window.cvox) {
                // If ChromeVox is running...
                that.focusTimeoutID = setTimeout(function () {
                    window.cvox.Api.getCurrentNode(function (node) {
                        if (topli.has(node).length) {
                            // and the current node being voiced is in
                            // the mega menu, clearTimeout,
                            // so the panel stays open.
                            clearTimeout(that.focusTimeoutID);
                        } else {
                            that.focusTimeoutID = setTimeout(function (scope, event, hide) {
                                _togglePanel.call(scope, event, hide);
                            }, 275, that, event, true);
                        }
                    });
                }, 25);
            } else {
                that.focusTimeoutID = setTimeout(function () {
                    if (that.mouseFocused && event.relatedTarget === null) {
                        return;
                    }
                    _togglePanel.call(that, event, true);
                }, 300);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_keyDownHandler
         * @desc Handle keydown event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _keyDownHandler = function (event) {
            var that = (this.constructor === AccessibleMegaMenu) ? this : _getPlugin(this), // determine the AccessibleMegaMenu plugin instance
                settings = that.settings,
                target = $($(this).is('.' + settings.hoverClass + ':tabbable') ? this : event.target), // if the element is hovered the target is this, otherwise, its the focused element
                menu = that.menu,
                topnavitems = that.topnavitems,
                topli = target.closest('.' + settings.topNavItemClass),
                tabbables = menu.find(':tabbable'),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                panelGroups = panel.find('.' + settings.panelGroupClass),
                currentPanelGroup = target.closest('.' + settings.panelGroupClass),
                next,
                keycode = event.keyCode || event.which,
                start,
                i,
                o,
                label,
                found = false,
                newString = Keyboard.keyMap[event.keyCode] || '',
                regex,
                isTopNavItem = (topli.length === 1 && panel.length === 0);

            if (target.is("input:focus, select:focus, textarea:focus, button:focus")) {
                // if the event target is a form element we should handle keydown normally
                return;
            }

            if (target.is('.' + settings.hoverClass + ':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }

            switch (keycode) {
            case Keyboard.ESCAPE:
                this.mouseFocused = false;
                _togglePanel.call(that, event, true);
                break;
            case Keyboard.DOWN:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    _togglePanel.call(that, event);
                    found = (topli.find('.' + settings.panelClass + ' :tabbable:first').focus().length === 1);
                } else {
                    found = (tabbables.filter(':gt(' + tabbables.index(target) + '):first').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.UP:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = (next.find('[aria-expanded]')
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus() === 1);
                    }
                } else if (!isTopNavItem) {
                    found = (tabbables.filter(':lt(' + tabbables.index(target) + '):last').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.RIGHT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':gt(' + topnavitems.index(topli) + '):first').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the next panel group
                        found = (panelGroups.filter(':gt(' + panelGroups.index(currentPanelGroup) + '):first').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.LEFT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the previous panel group
                        found = (panelGroups.filter(':lt(' + panelGroups.index(currentPanelGroup) + '):last').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.TAB:
                this.mouseFocused = false;
                i = tabbables.index(target);
                if (event.shiftKey && isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = next.children()
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus();
                    }
                } else if (event.shiftKey && i > 0) {
                    found = (tabbables.filter(':lt(' + i + '):last').focus().length === 1);
                } else if (!event.shiftKey && i < tabbables.length - 1) {
                    found = (tabbables.filter(':gt(' + i + '):first').focus().length === 1);
                } else if (isOpera) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    if (event.shiftKey) {
                        found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):last').focus().length === 1);
                    } else {
                        found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                    }
                }

                if (found) {
                    event.preventDefault();
                }
                break;
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                if (isTopNavItem) {
                    event.preventDefault();
                    _clickHandler.call(that, event);
                } else {
                    return true;
                }
                break;
            default:
                // alphanumeric filter
                clearTimeout(this.keydownTimeoutID);

                keydownSearchString += newString !== keydownSearchString ? newString : '';

                if (keydownSearchString.length === 0) {
                    return;
                }

                this.keydownTimeoutID = setTimeout(function () {
                    keydownSearchString = '';
                }, keydownTimeoutDuration);

                if (isTopNavItem && !target.hasClass(settings.openClass)) {
                    tabbables = tabbables.filter(':not(.' + settings.panelClass + ' :tabbable)');
                } else {
                    tabbables = topli.find(':tabbable');
                }

                if (event.shiftKey) {
                    tabbables = $(tabbables.get()
                        .reverse());
                }

                for (i = 0; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    if (o.is(target)) {
                        start = (keydownSearchString.length === 1) ? i + 1 : i;
                        break;
                    }
                }

                regex = new RegExp('^' + keydownSearchString.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), 'i');

                for (i = start; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    label = $.trim(o.text());
                    if (regex.test(label)) {
                        found = true;
                        o.focus();
                        break;
                    }
                }
                if (!found) {
                    for (i = 0; i < start; i++) {
                        o = tabbables.eq(i);
                        label = $.trim(o.text());
                        if (regex.test(label)) {
                            o.focus();
                            break;
                        }
                    }
                }
                break;
            }
            that.justFocused = false;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseDownHandler
         * @desc Handle mousedown event on mega menu.
         * @param {event} Event object
         * @memberof accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseDownHandler = function (event) {
            if ($(event.target).closest(this.settings.panelClass) || $(event.target).closest(":focusable").length) {
                this.mouseFocused = true;
                if ($(event.target).closest(this.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }
            clearTimeout(this.mouseTimeoutID);
            this.mouseTimeoutID = setTimeout(function () {
                clearTimeout(this.focusTimeoutID);
            }, 1);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOverHandler
         * @desc Handle mouseover event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOverHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            this.mouseTimeoutID = setTimeout(function () {
                $(event.target).addClass(that.settings.hoverClass);
                _togglePanel.call(that, event);
                if ($(event.target).closest(that.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }, this.settings.openDelay);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOutHandler
         * @desc Handle mouseout event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOutHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            $(event.target)
                .removeClass(that.settings.hoverClass);

            that.mouseTimeoutID = setTimeout(function () {
                _togglePanel.call(that, event, true);
            }, this.settings.closeDelay);
            if ($(event.target).is(':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickToggleHandler
         * @desc Handle click event on menu toggle button.
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickToggleHandler = function () {
            var isExpanded = this.toggleButton.attr('aria-expanded') === 'true';
            this.toggleButton.attr({'aria-expanded': !isExpanded, 'aria-pressed': !isExpanded});
        };

        _toggleExpandedEventHandlers = function (hide) {
            var menu = this.menu;
            if (hide) {
                $('html').off('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu');

                menu.find('[aria-expanded].' + this.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
            } else {
                $('html').on('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu', $.proxy(_clickOutsideHandler, this));

                /* Narrator in Windows 8 automatically toggles the aria-expanded property on double tap or click.
                   To respond to the change to collapse the panel, we must add a listener for a DOMAttrModified event. */
                menu.find('[aria-expanded=true].' + this.settings.panelClass).on('DOMAttrModified.accessible-megamenu', $.proxy(_DOMAttrModifiedHandler, this));
            }
        };

        _addEventHandlers = function() {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.on("focusin.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusInHandler, this))
                .on("focusout.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusOutHandler, this))
                .on("keydown.accessible-megamenu", $.proxy(_keyDownHandler, this))
                .on("mouseover.accessible-megamenu", $.proxy(_mouseOverHandler, this))
                .on("mouseout.accessible-megamenu", $.proxy(_mouseOutHandler, this))
                .on("mousedown.accessible-megamenu", $.proxy(_mouseDownHandler, this))
                .on("click.accessible-megamenu", $.proxy(_clickHandler, this));

            toggleButton.on('click.accessible-megamenu', $.proxy(_clickToggleHandler, this));

            if (isTouch) {
                menu.on("touchmove.accessible-megamenu", $.proxy(_touchmoveHandler, this));
            }

            if ($(document.activeElement).closest(menu).length) {
              $(document.activeElement).trigger("focusin.accessible-megamenu");
            }
        };

        _removeEventHandlers = function () {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.off('.accessible-megamenu');
            if (menu.find('[aria-expanded=true].' + this.settings.panelClass).length) {
                _toggleExpandedEventHandlers.call(this, true);
            }

            toggleButton.off('.accessible-megamenu');
        };

        /* public attributes and methods ------------------------- */
        return {
            constructor: AccessibleMegaMenu,

            /**
             * @lends jQuery.fn.accessibleMegaMenu
             * @desc Initializes an instance of the accessibleMegaMenu plugins
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            init: function () {
                var settings = this.settings,
                    nav = $(this.element),
                    menu = nav.children('ol,ul').first(),
                    topnavitems = menu.children(),
                    toggleButton = nav.children('button').first();
                this.start(settings, nav, menu, topnavitems, toggleButton);
            },

            start: function(settings, nav, menu, topnavitems, toggleButton) {
                var that = this;
                this.settings = settings;
                this.menu = menu;
                this.topnavitems = topnavitems;
                this.toggleButton = toggleButton;

                nav.attr("role", "navigation");
                _addUniqueId.call(that, menu);
                menu.addClass(settings.menuClass);
                menu.addClass(['js', settings.menuClass].join('-'));
                topnavitems.each(function (i, topnavitem) {
                    var topnavitemlink, topnavitempanel;
                    topnavitem = $(topnavitem);
                    topnavitem.addClass(settings.topNavItemClass);
                    topnavitemlink = topnavitem.find(":tabbable:first");
                    topnavitempanel = topnavitem.children(":not(:tabbable):last");
                    _addUniqueId.call(that, topnavitemlink);
                    if (topnavitempanel.length) {
                        _addUniqueId.call(that, topnavitempanel);
                        topnavitemlink.attr({
                            "role": "button",
                            "aria-controls": topnavitempanel.attr("id"),
                            "aria-expanded": false,
                            "tabindex": 0
                        });

                        topnavitempanel.attr({
                            "role": "region",
                            "aria-expanded": false,
                            "aria-hidden": true
                        })
                            .addClass(settings.panelClass)
                            .not("[aria-labelledby]")
                            .attr("aria-labelledby", topnavitemlink.attr("id"));
                    }
                });

                this.panels = menu.find("." + settings.panelClass);

                menu.find("hr").attr("role", "separator");

                toggleButton.addClass(settings.toggleButtonClass);
                toggleButton.attr({'aria-expanded': false, 'aria-pressed': false, 'aria-controls': menu.attr('id')});

                _addEventHandlers.call(this);
            },

            /**
             * @desc Removes maga menu javascript behavior
             * @example $(selector).accessibleMegaMenu("destroy");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            destroy: function () {
                this.menu.removeClass(['js', this.settings.menuClass].join('-'));
                _removeEventHandlers.call(this, true);
            },

            /**
             * @desc Get default values
             * @example $(selector).accessibleMegaMenu("getDefaults");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getDefaults: function () {
                return this._defaults;
            },

            /**
             * @desc Get any option set to plugin using its name (as string)
             * @example $(selector).accessibleMegaMenu("getOption", some_option);
             * @param {string} opt
             * @return {string}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getOption: function (opt) {
                return this.settings[opt];
            },

            /**
             * @desc Get all options
             * @example $(selector).accessibleMegaMenu("getAllOptions");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getAllOptions: function () {
                return this.settings;
            },

            /**
             * @desc Set option
             * @example $(selector).accessibleMegaMenu("setOption", "option_name",  "option_value",  reinitialize);
             * @param {string} opt - Option name
             * @param {string} val - Option value
             * @param {boolean} [reinitialize] - boolean to re-initialize the menu.
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            setOption: function (opt, value, reinitialize) {
                this.settings[opt] = value;
                if (reinitialize) {
                    this.init();
                }
            }
        };
    }());

    /* lightweight plugin wrapper around the constructor,
       to prevent against multiple instantiations */

    /**
     * @class accessibleMegaMenu
     * @memberOf jQuery.fn
     * @classdesc Implements an accessible mega menu as a jQuery plugin.
     * <p>The mega-menu It is modeled after the mega menu on {@link http://adobe.com|adobe.com} but has been simplified for use by others. A brief description of the interaction design choices can be found in a blog post at {@link http://blogs.adobe.com/accessibility/2013/05/adobe-com.html|Mega menu accessibility on adobe.com}.</p>
     * <h3>Keyboard Accessibility</h3>
     * <p>The accessible mega menu supports keyboard interaction modeled after the behavior described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern}, however we also try to respect users' general expectations for the behavior of links in a global navigation. To this end, the accessible mega menu implementation permits tab focus on each of the six top-level menu items. When one of the menu items has focus, pressing the Enter key, Spacebar or Down arrow will open the submenu panel, and pressing the Left or Right arrow key will shift focus to the adjacent menu item. Links within the submenu panels are included in the tab order when the panel is open. They can also be navigated with the arrow keys or by typing the first character in the link name, which speeds up keyboard navigation considerably. Pressing the Escape key closes the submenu and restores focus to the parent menu item.</p>
     * <h3>Screen Reader Accessibility</h3>
     * <p>The accessible mega menu models its use of WAI-ARIA Roles, States, and Properties after those described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern} with some notable exceptions, so that it behaves better with screen reader user expectations for global navigation. We don't use <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menu"</span></code> for the menu container and <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menuitem"</span></code> for each of the links therein, because if we do, assistive technology will no longer interpret the links as links, but instead, as menu items, and the links in our global navigation will no longer show up when a screen reader user executes a shortcut command to bring up a list of links in the page.</p>
     * @example <h4>HTML</h4><hr/>
&lt;nav&gt;
    &lt;ul class=&quot;nav-menu&quot;&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?movie&quot;&gt;Movies&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=0&quot;&gt;Action &amp;amp; Adventure&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=2&quot;&gt;Children &amp;amp; Family&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=7&quot;&gt;Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=9&quot;&gt;Foreign&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=14&quot;&gt;Musicals&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=15&quot;&gt;Romance&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?tv&quot;&gt;TV Shows&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=20&quot;&gt;Classic TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=21&quot;&gt;Crime TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=27&quot;&gt;Reality TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=30&quot;&gt;TV Action&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=33&quot;&gt;TV Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=34&quot;&gt;TV Horror&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
    &lt;/ul&gt;
&lt;/nav&gt;
     * @example <h4>CSS</h4><hr/>
&#47;* Rudimentary mega menu CSS for demonstration *&#47;
&#47;* mega menu list *&#47;
.nav-menu {
    display: block;
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 15;
}
&#47;* a top level navigation item in the mega menu *&#47;
.nav-item {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
}
&#47;* first descendant link within a top level navigation item *&#47;
.nav-item &gt; a {
    position: relative;
    display: inline-block;
    padding: 0.5em 1em;
    margin: 0 0 -1px 0;
    border: 1px solid transparent;
}
&#47;* focus/open states of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a:focus,
.nav-item &gt; a.open {
    border: 1px solid #dedede;
}
&#47;* open state of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a.open {
    background-color: #fff;
    border-bottom: none;
    z-index: 1;
}
&#47;* sub-navigation panel *&#47;
.sub-nav {
    position: absolute;
    display: none;
    top: 2.2em;
    margin-top: -1px;
    padding: 0.5em 1em;
    border: 1px solid #dedede;
    background-color: #fff;
}
&#47;* sub-navigation panel open state *&#47;
.sub-nav.open {
    display: block;
}
&#47;* list of items within sub-navigation panel *&#47;
.sub-nav ul {
    display: inline-block;
    vertical-align: top;
    margin: 0 1em 0 0;
    padding: 0;
}
&#47;* list item within sub-navigation panel *&#47;
.sub-nav li {
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
     * @example <h4>JavaScript</h4><hr/>
&lt;!-- include jquery --&gt;
&lt;script src=&quot;http://code.jquery.com/jquery-1.10.1.min.js&quot;&gt;&lt;/script&gt;
&lt;!-- include the jquery-accessibleMegaMenu plugin script --&gt;
&lt;script src=&quot;js/jquery-accessibleMegaMenu.js&quot;&gt;&lt;/script&gt;
&lt;!-- initialize a selector as an accessibleMegaMenu --&gt;
&lt;script&gt;
    $(&quot;nav:first&quot;).accessibleMegaMenu({
        &#47;* prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby *&#47;
        uuidPrefix: &quot;accessible-megamenu&quot;,
        &#47;* css class used to define the megamenu styling *&#47;
        menuClass: &quot;nav-menu&quot;,
        &#47;* css class for a top-level navigation item in the megamenu *&#47;
        topNavItemClass: &quot;nav-item&quot;,
        &#47;* css class for a megamenu panel *&#47;
        panelClass: &quot;sub-nav&quot;,
        &#47;* css class for a group of items within a megamenu panel *&#47;
        panelGroupClass: &quot;sub-nav-group&quot;,
        &#47;* css class for the hover state *&#47;
        hoverClass: &quot;hover&quot;,
        &#47;* css class for the focus state *&#47;
        focusClass: &quot;focus&quot;,
        &#47;* css class for the open state *&#47;
        openClass: &quot;open&quot;
    });
&lt;/script&gt;
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @param {string} [options.openDelay=0] - Open delay when opening menu via mouseover
     * @param {string} [options.closeDelay=250] - Open delay when opening menu via mouseover
     * @param {boolean} [options.openOnMouseover=false] - Should menu open on mouseover
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            var pluginInstance = $.data(this, "plugin_" + pluginName);
            if (!pluginInstance) {
                $.data(this, "plugin_" + pluginName, new $.fn[pluginName].AccessibleMegaMenu(this, options));
            } else if (typeof pluginInstance[options] === 'function') {
                pluginInstance[options].apply(pluginInstance, Array.prototype.slice.call(arguments, 1));
            }
        });
    };

    $.fn[pluginName].AccessibleMegaMenu = AccessibleMegaMenu;

    /* :focusable and :tabbable selectors from
       https://raw.github.com/jquery/jquery-ui/master/ui/jquery.ui.core.js */

    /**
     * @private
     */
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
            return $.css(this, "visibility") === "hidden";
        }).length;
    }

    /**
     * @private
     */
    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img,
            nodeName = element.nodeName.toLowerCase();
        if ("area" === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
                return false;
            }
            img = $("img[usemap=#" + mapName + "]")[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled :
                "a" === nodeName ?
                        element.href || isTabIndexNotNaN :
                        isTabIndexNotNaN) &&
                            // the element and all of its ancestors must be visible
                            visible(element);
    }

    $.extend($.expr[":"], {
        data: $.expr.createPseudo ? $.expr.createPseudo(function (dataName) {
            return function (elem) {
                return !!$.data(elem, dataName);
            };
        }) : // support: jQuery <1.8
                function (elem, i, match) {
                    return !!$.data(elem, match[3]);
                },

        focusable: function (element) {
            return focusable(element, !isNaN($.attr(element, "tabindex")));
        },

        tabbable: function (element) {
            var tabIndex = $.attr(element, "tabindex"),
                isTabIndexNaN = isNaN(tabIndex);
            return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
        }
    });
}(jQuery, window, document));
window.addEventListener('load', (event) => {

    if($('#page').hasClass('pdp')){
        var timestamp = new Date().getTime() / 1000;
        var diff = timestamp - renderingPageStarterTime;
        console.log('Performance Improvements PDP - #22 - Header_Content.js (PO only) - ' + diff.toString().slice(0 , 5) + 's');
    }
    

  //Sunglasses
  loadHeaderEspot("X_Header_NavSunglasses_EditorialCards"); 
  //Eyeglasses
  loadHeaderEspot("X_Header_NavEyeglasses_EditorialCards");

  if (window.mobilecheck() || window.tabletPortraitCheck()) {
    loadHeaderEspot("M_Header_NavCollection_RightCards");
    loadHeaderEspot("M_Header_NavCollaboration_RightCards");
  } else {
    loadHeaderEspot("D_Header_NavCollection_RightCards");
  }
  loadHeaderEspot("X_Header_NavGifts_RightCards");
  loadHeaderEspot("X_Header_NavOurWorld_RightCards");
  loadHeaderEspot("X_Header_NavSale_RightCards");
  //adattare header quando c'è banner
  if ($("#page").hasClass("pdp")) {
    if ($("#page").find(".ct-promo-bannerTop").length) {
      //solo se c'è il banner sposta in basso la barra dei menu
      //$("#header").css("top", "35px");
      $(".header .nav__section").css("top", "90px !important");
      if (window.mobilecheck() || window.tabletPortraitCheck()) {
        //da fare solo in mobile
       // $("#shoppingCart").css("top", "16px");
        //$("#hamResponsive").css("top", "12px");
        //$("#header").css("top", "40px");
        //$(".long-description-widget").css("top","37px");
        /*$(".long-description-widget").css(
          "margin-top",
          $(".ct-promo-bannerTop").height()
        ); commented in PDP Resesign_2023*/
      }
    } else {
      if (!window.mobilecheck() || !window.tabletPortraitCheck()) {
        $(".nav__section.sub.nav").css("top", "62px");
      }
      $("#header").css("height", "53px");
    }
  }

  $(document)
    .find("#TitleLiMobile")
    .find(".submenu__subheader--mobile")
    .html($("#ourWorld").val());

  $(document)
    .find("#TitleLiMobile_Gift")
    .find(".submenu__subheader--mobile")
    .html($("#gifts").val());  

  //  Remove SALES badge from non e-commerce countries
  if (isEcommerceStoreJS.toLowerCase() != "true") {
    $(".submenu__list-block .submenu__item.sale_badge").remove();
  }

});



function espotCallback(products, contents, espotName) {
  // Get HTML content
  var content = productPlusContentHtmlHeader(products, contents, false, espotName); // chiamo la funzione che mi restituisce in ordine contenuti e prodotti con la struttura html
  var espotWithCarousel = false;

  if(espotName == "X_Header_NavEyeglasses_IconsCards" || espotName == "X_Header_NavEyeglasses_BestsellersCards" || espotName == "X_Header_NavEyeglasses_EditorialCards" || espotName== "X_Header_NavSunglasses_IconsCards" || espotName == "X_Header_NavSunglasses_BestsellersCards" || espotName == "X_Header_NavSunglasses_EditorialCards" || espotName== "X_Header_NavSale_IconsCards" || espotName == "X_Header_NavSale_BestsellersCards" || espotName == "X_Header_NavSale_RightCards"){
    if((Object.keys(products).length > 0 || !isScriptContent(contents[0])) && (window.mobilecheck() || window.tabletPortraitCheck())){
      espotWithCarousel = true;
    }
  }

  if( (espotName == "X_Header_NavOurWorld_RightCards" || espotName == "X_Header_NavGifts_RightCards" ) && contents.length != 0 && !isScriptContent(contents[0])){
    espotWithCarousel = true;
  }

  $("#" + espotName).html(content); // stampa il contenuto html (nel caso di uno script lo esegue)
  var items = 4.3;
  var isGifOrWorld = false;
  if (
    espotName === "X_Header_NavOurWorld_RightCards" ||
    espotName == "X_Header_NavGifts_RightCards"
  ) {
    items = 5.9;
    isGifOrWorld = true;
  } else if (espotName === "X_Header_NavEyeglasses_RightCards") {
    items = 5.2;
  }
  if(espotName != "" && espotWithCarousel){
    drawCarouselHeader(espotName, items);
  }
    
  if (
    espotName == "X_Header_NavOurWorld_RightCards" &&
    (pageType == "Plp" || pageType == "Static") &&
    !(window.mobilecheck() || window.tabletPortraitCheck())
  ) {
    mapMenuAndUnderline();
  } 
}

function isScriptContent(content){
  return (typeof(content) === 'string' && content.includes("<script>"));
}

function productPlusContentHtmlHeader(products, contents, productFirst, espotName) {
  var contentHtml = "";
  var productHtml = ""; // concatena tutti i div di prodotto all'interno ci sarà il template di mustache

  contents.forEach(function (cont, index) {
    contentHtml += cont; // concatena tutte i div con solo il contenuto html
  });

  Object.keys(products).forEach(function (prod, index) {
    productHtml += printMustacheProducts(products[prod], espotName); // concatena tutte i div con solo il contenuto html
  });

  if (productFirst) return productHtml + contentHtml;
  else return contentHtml + productHtml;
}

function printMustacheProducts(prod, espotName) {
  var modelNameValue = "";
  var polarized = "";

  if (prod != undefined) {
    var productModel = prod.productModel;
    if (productModel && productModel.length != 0) {
      for (var i = 0; productModel.attributes.length > i; i++) {
        if (
          productModel.attributes[i].identifier === "MODELNAME" &&
          productModel.attributes[i].usage === "Descriptive"
        )
          modelNameValue = productModel.attributes[i].values[0].value;
        if (
          productModel.attributes[i].identifier === "POLARIZED" &&
          productModel.attributes[i].usage === "Descriptive"
        ) {
          for (var k = 0; productModel.attributes[i].values.length > k; k++) {
            if (
              productModel.attributes[i].values[k].value == true ||
              productModel.attributes[i].values[k].value.toLowerCase() === "yes"
            ) {
              polarized = prodproductModel.attributes[i].name;
            }
          }
        }
      }
    }
  }
  console.log(espotName)

  var mustacheObj = {
    modelName: modelNameValue != undefined ? modelNameValue : "",
    image:
      replaceTileImgByDevice(
        productModel.thumbnail,
        "sclw=0.25&sclh=0.25",
        "small"
      ) + "&bgcolor=%23ffffff",
    uniqueID: productModel != undefined ? productModel.uniqueID : "",
    partNumber: productModel.partNumber,
    partNumberAlt: function () {
      return this.partNumber
        .replace("__", "--")
        .replace("_", "-")
        .replace("/", "-");
    },
    baseURL: WCParamJS.homePageURL,
    replaceImageUrl: function () {
      return this.image.replace("_fr", "_qt");
    },
    checkisPolar: function () {
      return getPolarized(productModel.attributes, true);
    },
    printPolarBadge: function () {
      return getPolarized(productModel.attributes);
    },
    espotName
  };

  var templateHtml = $("#CaroselMustacheHeader").html();

  var html = Mustache.to_html(templateHtml, mustacheObj);

  return html;
}

function drawCarouselHeader(id, items) {
  // if(window.mobilecheck()|| window.tabletPortraitCheck()){
  //     $("#"+id).owlCarousel({
  //         items: 1,
  //         pagination: false,
  //         responsive: true,
  //         mouseDrag: true,
  //         touchDrag: true,
  //         navigation: false,
  //         lazyLoad: true,
  //         rewindNav: false,
  //         singleItem:false,
  //         addClassActive: false,
  //     });
  // } else {
  $("#" + id).on("init", function (event, slick) {
    setTimeout(function () {
      var slide = $("#" + id).find(".slick-slide");
      //$(slide).height($(slide).width());

      //$(".nav-left").css("display", "flex");
    }, 1500);
  });

  if (
    id == "X_Header_NavOurWorld_RightCards" ||
    id == "X_Header_NavGifts_RightCards"
  ) {
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow:
        window.mobilecheck() || window.tabletPortraitCheck()
          ? undefined
          : items,
      slidesToScroll: undefined,
      infinite: false,
      prevArrow: `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow: `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: undefined,
            slidesToScroll: undefined,
            vertical: true,
          },
        },
        {
          breakpoint: 1250,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 2,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 4.8,
            slidesToScroll: 2.3,
            prevArrow:
            `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 5.1,
            slidesToScroll: 2.3,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1681,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 3,
            prevArrow:
            `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
      ],
      vertical:
        window.mobilecheck() || window.tabletPortraitCheck() ? true : false,
      accessibility: false,
    });
  } if( id == "X_Header_NavSunglasses_EditorialCards" || id == "X_Header_NavEyeglasses_EditorialCards" || id == "X_Header_NavSunglasses_IconsCards" ||
         id == "X_Header_NavEyeglasses_IconsCards" || id == "X_Header_NavSale_IconsCards" || id == "X_Header_NavSale_RightCards"){
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow: 1.48,
      slidesToScroll: 1.48,
      infinite: false,
      prevArrow:
        `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow:
        `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      accessibility: false,
    });
  } else if(id == "X_Header_NavSunglasses_BestsellersCards" || id == "X_Header_NavEyeglasses_BestsellersCards"|| id == "X_Header_NavSale_BestsellersCards"){
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow: 1.55,
      slidesToScroll: 1.55,
      infinite: false,
      prevArrow:
        `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow:
        `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      accessibility: false,
    });
  }
  else {
    $("#" + id).slick({
      lazyLoad: "ondemand",
      slidesToShow: items,
      slidesToScroll: undefined,
      infinite: false,
      prevArrow:
        `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" > <span class="prev" id="prev-${id}">  </span> </span>`,
      nextArrow:
        `<span class="nav-right" id="nav-right-${id}" aria-label="next slide" role="button" tabindex="0"> <span class="next" id="next-${id}">  </span> </span>`,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1.7,
            slidesToScroll: 1.7,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow:
              id == "X_Header_NavSunglasses_RightCards" ||
              id == "D_Header_NavCollection_RightCards"
                ? 2.5
                : 3,
            slidesToScroll: 1.5,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1400,
          settings: {
            slidesToShow:
              id == "X_Header_NavSunglasses_RightCards" ||
              id == "D_Header_NavCollection_RightCards"
                ? 3
                : 3.9,
            slidesToScroll: id == "X_Header_NavSunglasses_RightCards" ? 2 : 1.7,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: id == "X_Header_NavEyeglasses_RightCards" ? 4.2 : 3.5,
            slidesToScroll:
              id == "X_Header_NavEyeglasses_RightCards" ? 2.3 : 1.7,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
        {
          breakpoint: 1681,
          settings: {
            slidesToShow: id == "X_Header_NavEyeglasses_RightCards" ? 4.9 : 4,
            slidesToScroll: 1.7,
            prevArrow:
              `<span class="nav-left" id="nav-left-${id}" aria-label="previous slide" role="button" tabindex="0" style="display: flex;"> <span class="prev" id="prev-${id}">  </span> </span>`,
          },
        },
      ],
      accessibility: false,
    });
  }

  // $("#"+id).owlCarousel({
  //     items: items,
  //     pagination: false,
  //     responsive: true,
  //     mouseDrag: true,
  //     touchDrag: true,
  //     navigation: true,
  //     lazyLoad: true,
  //     rewindNav: false,
  //     singleItem:false,
  //     addClassActive: false,
  //     navigationText:[
  //         '<span class="nav-left" aria-label="next slide" role="button" tabindex="0" >PREV</span>',
  //         '<span class="nav-right" aria-label="next slide" role="button" tabindex="0">NEXT</span>'
  //     ],
  //     afterInit: function(){
  //         var owlitems = $('#'+ id).find(".owl-item")
  //         $(owlitems).height($(owlitems).width());
  //     }
  // });
  // }

  $("#" + id + " .slick-slide a").focusin(function () {
    $(this).get(0).scrollIntoView();
  });
}

//countdown
// Set the date we're counting down to
var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
/*
// Update the count down every 1 second
var interval = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();
    
  // Find the distance between now and the count down date
  var distance = countDownDate - now;
    
  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
  // Output the result in an element with id="demo"
  if(document.getElementsByClassName("ct-promo-countTop")[0]){
 document.getElementsByClassName("ct-promo-countTop")[0].innerHTML ="- "+"End in " + " " + hours + "H " + ": "
  + minutes + "M "+ ": " + seconds + "S ";
  document.getElementsByClassName("ct-promo-countTop")[0].innerHTML ="- "+"End in " + " " + '10' + "H " + ": "
  + '20' + "M "+ ": " + '10' + "S ";
  }
  // If the count down is over, write some text 
  if (distance < 0) {
    clearInterval(interval);
  //  document.getElementById("demo").innerHTML = "EXPIRED";
  }
}, 1000);}*/


window.onload = function() {
	  const navBeansElement = document.querySelector('.nav-beans');
	  if (navBeansElement || window.mobilecheck() || window.tabletPortraitCheck() ) {
		  // Se .nav-beans è presente, attiva il bottone in FilterButtonsBar.jspf 
		  // e rimuovi la classe dal bottone in PersolSubCategoryPageContainer.jsp
		  const persolButton = document.querySelector('.persol-page .plp-filter-button');
		  if (persolButton) {
			  persolButton.classList.remove('plp-filter-button');
			  persolButton.classList.add('plp-filter-button--inactive');
		  }
		  const filterButton = document.querySelector('.filter-bar-page .plp-filter-button');
		  if (filterButton) {
			  filterButton.classList.add('plp-filter-button');
			  filterButton.classList.remove('plp-filter-button--inactive');
		  }
	  	} else {
		// Esegui solo su desktop
		// Se .nav-beans non è presente, attiva il bottone in PersolSubCategoryPageContainer.jsp
		// e rimuovi la classe dal bottone in FilterButtonsBar.jspf
		const filterButton = document.querySelector('.filter-bar-page .plp-filter-button');
		if (filterButton) {
			filterButton.classList.remove('plp-filter-button');
			filterButton.classList.add('plp-filter-button--inactive');
		}
		//rimuovo la barra grigia di FilterButtonsBar.jspf
	    const onlyFilterButton = document.querySelector('.filter-bar-page');
	    if (onlyFilterButton){
		    onlyFilterButton.classList.remove('filter-bar-page');
		    onlyFilterButton.classList.add('filter-bar-page--inactive');
	    }
		const persolButton = document.querySelector('.persol-page .plp-filter-button');
		if (persolButton) {
			persolButton.classList.add('plp-filter-button');
			persolButton.style.display = 'flex';
			persolButton.classList.remove('plp-filter-button--inactive');
		}
	  }
  };
  

/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.5
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var l=new Error("Cannot find module '"+s+"'");throw l.code="MODULE_NOT_FOUND",l}var u=e[s]={exports:{}};t[s][0].call(u.exports,function(e){var n=t[s][1][e];return i(n?n:e)},u,u.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new h(16),this._normalQueue=new h(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var l;try{throw new Error}catch(u){l=u}var p=t("./schedule"),h=t("./queue"),f=t("./util");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},r.prototype.disableTrampolineIfNecessary=function(){f.hasDevTools&&(this._trampolineEnabled=!1)},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},f.hasDevTools?(r.prototype.invokeLater=function(t,e,n){this._trampolineEnabled?i.call(this,t,e,n):this._schedule(function(){setTimeout(function(){t.call(e,n)},100)})},r.prototype.invoke=function(t,e,n){this._trampolineEnabled?o.call(this,t,e,n):this._schedule(function(){t.call(e,n)})},r.prototype.settlePromises=function(t){this._trampolineEnabled?s.call(this,t):this._schedule(function(){t._settlePromises()})}):(r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s),r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=l},{"./queue":26,"./schedule":29,"./util":36}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var l=n(o),u=new t(e);u._propagateFrom(this,1);var p=this._target();if(u._setBoundTo(l),l instanceof t){var h={promiseRejectionQueued:!1,promise:u,target:p,bindingPromise:l};p._then(e,s,void 0,u,h),l._then(a,c,void 0,u,h),u._setOnCancel(l)}else u._resolveCallback(p);return u},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var l=a._boundValue();t:for(var u=0;u<t.length;++u){var p=t[u];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(l,c)}else if("function"==typeof p){var h=o(p).call(l,c);if(h===s)return h;if(h)return o(n).call(l,c)}else if(r.isObject(c)){for(var f=i(p),_=0;_<f.length;++_){var d=f[_];if(p[d]!=c[d])continue t}return o(n).call(l,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,e){return{promise:e}}function i(){return!1}function o(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+H.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function s(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?H.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function a(){return this._onCancelField}function c(t){this._onCancelField=t}function l(){this._cancellationParent=void 0,this._onCancelField=void 0}function u(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function p(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function f(){this._trace=new O(this._peekContext())}function _(t,e){if(U(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=E(t);H.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),H.notEnumerableProp(t,"__stackCleaned__",!0)}}}function d(){this._trace=void 0}function v(t,e,n,r,i){if(void 0===t&&null!==e&&J){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=C(a),l=c.length-1;l>=0;--l){var u=c[l];if(!q.test(u)){var p=u.match($);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var h=c[0],l=0;l<a.length;++l)if(a[l]===h){l>0&&(s="\n"+a[l-1]);break}}var f="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(f,!0,e)}}function y(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),m(n)}function m(t,n,r){if(at.warnings){var i,o=new N(t);if(n)r._attachExtraTrace(o);else if(at.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=E(o);o.stack=s.message+"\n"+s.stack.join("\n")}nt("warning",o)||k(o,"",!0)}}function g(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function b(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function w(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function C(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||Q.test(r),o=i&&it(r);i&&!o&&(z&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function j(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||Q.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function E(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?j(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:C(e)}}function k(t,e,n){if("undefined"!=typeof console){var r;if(H.isObject(t)){var i=t.stack;r=e+G(i,t)}else r=e+String(t);"function"==typeof V?V(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function F(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){L.throwLater(o)}"unhandledRejection"===t?nt(t,n,r)||i||k(n,"Unhandled rejection "):nt(t,r)}function T(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():H.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+x(e)+">, no stack trace)"}function x(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function P(){return"function"==typeof st}function S(t){var e=t.match(ot);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function R(t,e){if(P()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var l=S(i[c]);if(l){n=l.fileName,s=l.line;break}}for(var c=0;c<o.length;++c){var l=S(o[c]);if(l){r=l.fileName,a=l.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(it=function(t){if(M.test(t))return!0;var e=S(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function O(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);st(this,O),e>32&&this.uncycle()}var A,D,V,I=e._getDomain,L=e._async,N=t("./errors").Warning,H=t("./util"),B=t("./es5"),U=H.canAttachTrace,M=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,q=/\((?:timers\.js):\d+:\d+\)/,$=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,Q=null,G=null,z=!1,X=!(0==H.env("BLUEBIRD_DEBUG")||!H.env("BLUEBIRD_DEBUG")&&"development"!==H.env("NODE_ENV")),W=!(0==H.env("BLUEBIRD_WARNINGS")||!X&&!H.env("BLUEBIRD_WARNINGS")),K=!(0==H.env("BLUEBIRD_LONG_STACK_TRACES")||!X&&!H.env("BLUEBIRD_LONG_STACK_TRACES")),J=0!=H.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(W||!!H.env("BLUEBIRD_W_FORGOTTEN_RETURN"));e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){if(0===(524288&this._bitField)){this._setRejectionIsUnhandled();var t=this;setTimeout(function(){t._notifyUnhandledRejection()},1)}},e.prototype._notifyUnhandledRejectionIsHandled=function(){F("rejectionHandled",A,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),F("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return m(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var e=I();D="function"==typeof t?null===e?t:H.domainBind(e,t):void 0},e.onUnhandledRejectionHandled=function(t){var e=I();A="function"==typeof t?null===e?t:H.domainBind(e,t):void 0};var Y=function(){};e.longStackTraces=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!at.longStackTraces&&P()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;at.longStackTraces=!0,Y=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),L.enableTrampoline(),at.longStackTraces=!1},e.prototype._captureStackTrace=f,e.prototype._attachExtraTrace=_,e.prototype._dereferenceTrace=d,n.activateLongStackTraces(),L.disableTrampolineIfNecessary()}},e.hasLongStackTraces=function(){return at.longStackTraces&&P()};var Z=function(){try{if("function"==typeof CustomEvent){var t=new CustomEvent("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n={detail:e,cancelable:!0};B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason});var r=new CustomEvent(t.toLowerCase(),n);return!H.global.dispatchEvent(r)}}if("function"==typeof Event){var t=new Event("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n=new Event(t.toLowerCase(),{cancelable:!0});return n.detail=e,B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason}),!H.global.dispatchEvent(n)}}var t=document.createEvent("CustomEvent");return t.initCustomEvent("testingtheevent",!1,!0,{}),H.global.dispatchEvent(t),function(t,e){var n=document.createEvent("CustomEvent");return n.initCustomEvent(t.toLowerCase(),!1,!0,e),!H.global.dispatchEvent(n)}}catch(e){}return function(){return!1}}(),tt=function(){return H.isNode?function(){return process.emit.apply(process,arguments)}:H.global?function(t){var e="on"+t.toLowerCase(),n=H.global[e];return n?(n.apply(H.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),et={promiseCreated:r,promiseFulfilled:r,promiseRejected:r,promiseResolved:r,promiseCancelled:r,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:r},nt=function(t){var e=!1;try{e=tt.apply(null,arguments)}catch(n){L.throwLater(n),e=!0}var r=!1;try{r=Z(t,et[t].apply(null,arguments))}catch(n){L.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&Y()),"warnings"in t){var n=t.warnings;at.warnings=!!n,J=at.warnings,H.isObject(n)&&"wForgottenReturn"in n&&(J=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!at.cancellation){if(L.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=l,e.prototype._propagateFrom=u,e.prototype._onCancel=a,e.prototype._setOnCancel=c,e.prototype._attachCancellationCallback=s,e.prototype._execute=o,rt=u,at.cancellation=!0}return"monitoring"in t&&(t.monitoring&&!at.monitoring?(at.monitoring=!0,e.prototype._fireEvent=nt):!t.monitoring&&at.monitoring&&(at.monitoring=!1,e.prototype._fireEvent=i)),e},e.prototype._fireEvent=i,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var rt=p,it=function(){return!1},ot=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;H.inherits(O,Error),n.CapturedTrace=O,O.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var l=c._length+1,u=r-2;u>=0;--u)e[u]._length=l,l++;return}}}},O.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=E(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(C(i.stack.split("\n"))),i=i._parent;w(r),b(r),H.notEnumerableProp(t,"stack",g(n,r)),H.notEnumerableProp(t,"__stackCleaned__",!0)}};var st=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():T(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,Q=t,G=e;var n=Error.captureStackTrace;return it=function(t){return M.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return Q=/@/,G=e,z=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(G=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?T(e):e.toString()},null):(Q=t,G=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(V=function(t){console.warn(t)},H.isNode&&process.stderr.isTTY?V=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:H.isNode||"string"!=typeof(new Error).stack||(V=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var at={warnings:W,longStackTraces:!1,cancellation:!1,monitoring:!1};return K&&e.longStackTraces(),{longStackTraces:function(){return at.longStackTraces},warnings:function(){return at.warnings},cancellation:function(){return at.cancellation},monitoring:function(){return at.monitoring},propagateFromFunction:function(){return rt},boundValueFunction:function(){return h},checkForgottenReturns:v,setBounds:R,warn:m,deprecated:y,CapturedTrace:O,fireDomEvent:Z,fireGlobalEvent:tt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return u(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,l=t("./util"),u=l.inherits,p=l.notEnumerableProp,h=r("Warning","warning"),f=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),m=0;m<y.length;++m)"function"==typeof Array.prototype[y[m]]&&(d.prototype[y[m]]=Array.prototype[y[m]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var g=0;d.prototype.toString=function(){var t=Array(4*g+1).join(" "),e="\n"+t+"AggregateError of:\n";g++,t=Array(4*g+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return g--,e},u(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:f,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:h}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},l=function(t,e,n){return t[e]=n.value,t},u=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},h=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:h,keys:a,names:a,defineProperty:l,getDescriptor:c,freeze:u,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return l.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(h.e=t,h)}function l(t){var i=this.promise,l=this.handler;if(!this.called){this.called=!0;var u=this.isFinallyHandler()?l.call(i._boundValue()):l.call(i._boundValue(),t);if(u===r)return u;if(void 0!==u){i._setReturnedNonUndefined();var f=n(u,i);if(f instanceof e){if(null!=this.cancelPromise){if(f._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),h.e=_,h}f.isPending()&&f._attachCancellationCallback(new o(this))}return f._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),h.e=t,h):(s(this),t)}var u=t("./util"),p=e.CancellationError,h=u.errorObj,f=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,l,l)},e.prototype.tap=function(t){return this._passThrough(t,1,l)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,l);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!u.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+u.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(f(i,a,this),1,void 0,l)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=f(n[o])(t);if(r._popContext(),s===h){r._pushContext();var a=e.reject(h.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var l=this._promise=new e(r);l._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var l=t("./errors"),u=l.TypeError,p=t("./util"),h=p.errorObj,f=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=f(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=f(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=f(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=f(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===h)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),
null===o))return void this._promiseRejected(new u("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new u("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new u("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){var a=t("./util");a.canEvaluate,a.tryCatch,a.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,e,n,r){this.constructor$(t),this._promise._captureStackTrace();var i=l();this._callback=null===i?e:u.domainBind(i,e),this._preservedValues=r===o?new Array(this.length()):null,this._limit=n,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0)}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var l=e._getDomain,u=t("./util"),p=u.tryCatch,h=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var l=this._promise,u=this._callback,f=l._boundValue();l._pushContext();var _=p(u).call(f,t,n,o),d=l._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",l),_===h)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var m=++this._totalResolved;return m>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var l=arguments[1],u=arguments[2];c=s.isArray(l)?a(t).apply(u,l):a(t).call(u,l)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&u.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new l(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=u.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),l=c.OperationalError,u=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new m("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new m("expecting a function but got "+f.classString(e))}function i(t){t!==b&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(b);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c,l=function(){return new m("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},p=function(t){return i.reject(new m(t))},h={},f=t("./util");c=f.isNode?function(){var t=process.domain;return void 0===t&&(t=null),t}:function(){return null},f.notEnumerableProp(i,"_getDomain",c);var _=t("./es5"),d=t("./async"),v=new d;_.defineProperty(i,"_async",{value:v});var y=t("./errors"),m=i.TypeError=y.TypeError;i.RangeError=y.RangeError;var g=i.CancellationError=y.CancellationError;i.TimeoutError=y.TimeoutError,i.OperationalError=y.OperationalError,i.RejectionError=y.OperationalError,i.AggregateError=y.AggregateError;var b=function(){},w={},C={},j=t("./thenables")(i,b),E=t("./promise_array")(i,b,j,p,n),k=t("./context")(i),F=k.create,T=t("./debuggability")(i,k),x=(T.CapturedTrace,t("./finally")(i,j,C)),P=t("./catch_filter")(C),S=t("./nodeback"),R=f.errorObj,O=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return p("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new m("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,P(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(T.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?p("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,w,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new E(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(b);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=O(t)(S(e,n));return r===R&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new E(t).promise()},i.cast=function(t){var e=j(t);return e instanceof i||(e=new i(b),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(b);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));return v.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(b),l=this._target(),u=l._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():l===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var p=c();if(0!==(50397184&u)){var h,_,d=l._settlePromiseCtx;0!==(33554432&u)?(_=l._rejectionHandler0,h=t):0!==(16777216&u)?(_=l._fulfillmentHandler0,h=e,l._unsetRejectionIsUnhandled()):(d=l._settlePromiseLateCancellationObserver,_=new g("late cancellation observer"),l._attachExtraTrace(_),h=e),v.invoke(d,l,{handler:null===p?h:"function"==typeof h&&f.domainBind(p,h),promise:a,receiver:r,value:_})}else l._addCallbacks(t,e,a,r,p);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){v.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===h?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=h),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=h),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=null===i?e:f.domainBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this[s+1]=null===i?e:f.domainBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(l(),!1);var n=j(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(l());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var c=new g("late cancellation observer");r._attachExtraTrace(c),this._reject(c)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&T.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==b){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===w?n&&"number"==typeof n.length?o=O(t).apply(this._boundValue(),n):(o=R,o.e=new m("cannot .spread() a non-array: "+f.classString(n))):o=O(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===C?r._reject(n):o===R?r._rejectCallback(o.e,!1):(T.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof x&&r.isFinallyHandler()?(r.cancelPromise=t,O(e).call(r,o)===R&&t._reject(R.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof E?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=l();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():v.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?v.fatalError(t,f.isNode):void((65535&e)>0?v.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&_.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){T.deprecated("Promise.defer","new Promise");var t=new i(b);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",l),t("./method")(i,b,j,p,T),t("./bind")(i,b,j,T),t("./cancel")(i,E,p,T),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,E,j,b,v,c),i.Promise=i,i.version="3.5.5",t("./call_get.js")(i),t("./generators.js")(i,p,b,j,n,T),t("./map.js")(i,E,p,j,b,T),t("./nodeify.js")(i),t("./promisify.js")(i,b),t("./props.js")(i,E,j,p),t("./race.js")(i,b,j,p),t("./reduce.js")(i,E,p,j,b,T),t("./settle.js")(i,E,T),t("./some.js")(i,E,p),t("./timers.js")(i,b,T),t("./using.js")(i,p,j,F,b,T),t("./any.js")(i),t("./each.js")(i,b),t("./filter.js")(i,b),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(b)),T.setBounds(d.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&r._propagateFrom(t,3),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function l(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(l,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var u=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(u,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=f.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new m("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=f.inheritedDataKeys(t),c=[],l=0;l<a.length;++l){var u=a[l],p=t[u],h=r===j?!0:j(u,p,t);"function"!=typeof p||i(p)||o(t,u,e)||!r(u,p,t,h)||c.push(u,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===h&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof u&&this!==l?this[u]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var l=function(){return this}(),u=t;return"string"==typeof u&&(t=o),f.notEnumerableProp(c,"__isPromisified__",!0),c}function l(t,e,n,r,i){for(var o=new RegExp(E(e)+"$"),s=a(t,e,o,n),c=0,l=s.length;l>c;c+=2){var u=s[c],p=s[c+1],_=u+e;if(r===k)t[_]=k(u,h,u,p,e,i);else{var d=r(p,function(){return k(u,h,u,p,e,i)});f.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return f.toFastProperties(t),t}function u(t,e,n){return k(t,e,void 0,t,null,n)}var p,h={},f=t("./util"),_=t("./nodeback"),d=f.withAppended,v=f.maybeWrapAsError,y=f.canEvaluate,m=t("./errors").TypeError,g="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return f.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},E=function(t){return t.replace(/([$])/,"\\$")},k=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?h:e.context,o=!!e.multiArgs,s=u(t,n,o);return f.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new m("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=g);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=k),!f.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=f.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&f.isClass(c)&&(l(c.prototype,r,i,o,n),l(c,r,i,o,n))}return l(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=u.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return l(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),l=c.isObject,u=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),h=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=h(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var l=new e(n);void 0!==o&&l._propagateFrom(o,3);for(var u=l._fulfill,p=l._reject,h=0,f=t.length;f>h;++h){var _=t[h];(void 0!==_||h in t)&&e.cast(_)._then(u,p,void 0,l,null)}return l}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=h();this._fn=null===s?n:f.domainBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function l(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function u(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=_(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var h=e._getDomain,f=t("./util"),_=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;if(void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n,!n.isRejected())for(;i>r;++r){var o={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(u,void 0,void 0,o,void 0)}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return l(this,t,e,null)},e.reduce=function(t,e,n,r){return l(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){var l=s.resolve();r=function(t){l.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36
}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,l=s.isArray,u={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=l(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(u),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==u&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(u(t)){if(t instanceof e)return t;var i=o(t);if(i===l){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return l.e=e,l}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),u=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,h=c.tryCatch(r).call(t,o,s);return p=!1,a&&h===l&&(a._rejectCallback(h.e,!0,!0),a=null),u}var c=t("./util"),l=c.errorObj,u=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var l=function(t){return u(+this).thenReturn(t)},u=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(l,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return u(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function l(t,n){function i(){if(s>=l)return u._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,l=t.length,u=new e(o);return i(),u}function u(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function h(t){return u.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function f(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,m=_.tryCatch,g={};u.prototype.data=function(){return this._data},u.prototype.promise=function(){return this._promise},u.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():g},u.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==g?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},u.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,u),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},f.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new f(t),p=0;t>p;++p){var d=o[p];if(u.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var g=r(d);g instanceof e&&(d=g._then(h,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=m(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return l(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return x.e=e,x}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function l(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function u(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function h(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function f(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return D.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function m(t){try{u(t,"isOperational",!0)}catch(e){}}function g(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return H?process.env[t]:void 0}function E(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"==={}.toString.call(t))return Promise}catch(e){}}function k(t,e){return t.bind(e)}var F=t("./es5"),T="undefined"==typeof navigator,x={e:{}},P,S="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,R=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var l=Object.getOwnPropertyDescriptor(t,c);null!=l&&null==l.get&&null==l.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,D=/^[a-z$_][a-z$_0-9]*$/i,V=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),I=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var L="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};I=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?L(t):null}}var N="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),H="undefined"!=typeof process&&"undefined"!=typeof process.env,B={isClass:h,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:l,thrower:p,isArray:F.isArray,asArray:I,notEnumerableProp:u,isPrimitive:o,isObject:s,isError:y,canEvaluate:T,errorObj:x,tryCatch:i,inherits:R,withAppended:c,maybeWrapAsError:a,toFastProperties:f,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:V,originatesFromRejection:g,markAsOriginatingFromRejection:m,classString:w,copyDescriptors:C,hasDevTools:"undefined"!=typeof chrome&&chrome&&"function"==typeof chrome.loadTimes,isNode:N,hasEnvVariables:H,env:j,global:S,getNativePromise:E,domainBind:k};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(U){B.lastLineError=U}e.exports=B},{"./es5":13}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
/**
* @fileOverview This javascript contains javascript functions used by the newsletter function
*/

NewsLetterJS={
        
    version: "Common Implementation v0.01",
	/** language ID to be used, default to -1 (English) */
	langId: "-1",
	
	/** store ID to be used */
	storeId: "",
	
	/** store Name to be used */
	appName :"",
	/** catalog ID to be used */
	catalogId: "",
	
	email :"",
	
	formId:"",
	
	/** 
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use

	*/	
	setCommonParameters:function(langId,storeId,catalogId,appName){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
        this.appName = appName;
	},
	
	updateParamObject:function(params, key, value, index){
		if(params == null){
			params = [];
		}

		if(index != null && index !== "" && index !== -1){
			//overwrite the old value at specified index
			params[key+"_"+index] = value;
		}else if(index === -1){
			var i = 1;
			while(params[key + "_" + i] != null){
				i++;
			}
			params[key + "_" + i] = value;
		}else{
			params[key] = value;
		}
		return params;
	},
	
	/**
	* This function clears all the input fields of the form passed in by parameter
	* @param {String} formName The name of the form containing the input fields.	
	*/
	 clearForm:function(formName){
		var form = document.forms[formName];
		for(var i=0; i<form.elements.length; i++) {
			if (form.elements[i].type == "text") {
				form.elements[i].value = "";
			}
		}
	},
	
	/**
	 * submitting to newsletter after checking email param
	 */
	subscribeToNewsLetter:function(formName, page){
		if(this.validateSubscriptionParams(formName)){
            var zipcode = '';  
            var firstName = '';
            var lastName = '';
            var gender = '';
            var dateOfBirth = '';
            var promo = false;
            var primaryNewsLetterFlow=true;
		    this.formId = formName;
		    emailInput = document.querySelector("form[name="+formName+"] #newsletterPopupEmail");
		    if (formName == "newsLetterForm") {
		        emailInput = document.querySelector("form[name="+formName+"] #newsletterEmail");
		        if (isCarol) {
		            emailInput.parentElement.classList.remove("errorGeneric");
	                emailInput.parentElement.classList.remove("errorDuplicate");
		        }
            }
            if(formName == "newsLetterFormLandingPage" && isOliver) {
                emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
                if(countryCode == 'US' || countryCode == 'CA') {
                	zipcode = document.querySelector("form[name="+formName+"] #newsletterZipcodeLandingPage").value;
                }
                firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            } else if (formName == "newsLetterFormPromoLandingPage"){
            	emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
            	firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            	promo = true;
            } //#EMAIL_ME# 
            else if (formName == "newsLetterForm_emailme") { 
		        emailInput = document.querySelector("form[name="+formName+"] #input_Emailme");
			} //#EMAIL_ME#
		    this.email = emailInput.value.toLowerCase();
		    
		    var cidCookie = null;
	        
	        if(document.cookie.includes('X_WC_CID')){
	        	cidCookie = $.cookie("X_WC_CID");
	        }
		    
			var params = {
				storeId: this.storeId,
				langId : this.langId,
				email: this.email,
                zipCode: zipcode,
                promo: promo,
                pageIdentifier: page,
                firstName: firstName,
                lastName: lastName,
                gender: gender,
                dob: dateOfBirth,
                primaryNewsLetterFlow:primaryNewsLetterFlow,
                cid: cidCookie
			}
            if(typeof updateDuplicate != 'undefined' && updateDuplicate == 'true')
                params.update = updateDuplicate

		 	cursor_wait();
		 	wcService.invoke("JoinNewsletterService", params);
		 	
		 	if(formName=="newsletterPopupForm"){
		 		setCookie("WELCOME_STICKY_SHOWN_"+this.appName,true,{expires: 10000,path: "/", domain: cookieDomain});
		 	}
		}
		
	},

    validateSubscriptionParams: function(formName) {
        this.cleanErrors(formName); 
        var namePattern = /[A-Za-z]/;
        var isValid = true; //we use this variable to check all fields and show,eventually, all errors

        /*EMAIL VALDATION - MANDATORY*/
        var emailInput = $("form[name="+formName+"] [name='EMAIL']");
        if (!emailInput.val()) { //empty or undefined
            this.toggleFormError('EMAIL','EMPTY',formName);
            isValid = false;
        } else if (emailInput.length > 0 && !AddressHelper.validateEmail(emailInput.get(0))) {
            this.toggleFormError('EMAIL','INVALID',formName);
            isValid = false;
        }
        
        /*FIRSTNAME VALDATION*/
        var firstNameInput = $("form[name="+formName+"] [name='NAME'],form[name="+formName+"] [name='FIRSTNAME']");
        if (firstNameInput.length > 0 && needsValidation(firstNameInput)) { //if fild not available or disabled do not check
            var firstNameValue = firstNameInput.val();
            if (!firstNameValue) {
                this.toggleFormError('NAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(firstNameValue)){
                this.toggleFormError('NAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*LASTNAME VALIDATION*/
        var lastNameInput = $("form[name="+formName+"] [name='LASTNAME']");
        if (lastNameInput.length > 0 && needsValidation(lastNameInput)) { //if fild not available or disabled do not check
            var lastNameValue = lastNameInput.val();
            if (!lastNameValue) {
                this.toggleFormError('LASTNAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(lastNameValue)){
                this.toggleFormError('LASTNAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*GENDER VALIDATION*/
        var genderInput = $("form[name="+formName+"] [name='gender']");
        if (genderInput.length > 0 && needsValidation(genderInput)) { //if fild not available or disabled do not check
            var genderSelected = genderInput.find('option:selected').val();

            if(!genderSelected) {
                this.toggleFormError('GENDER','EMPTY',formName);  
                isValid = false;
            } 
        }
       
        /*BIRTHDAY VALIDATION*/
        var birthdayInput = $("form[name="+formName+"] [name='BIRTHDAY']");
        if (birthdayInput.length > 0 && needsValidation(birthdayInput)) { //if fild not available or disabled do not check
            var  dateOfBirth = birthdayInput.val();
            // Variables for birthday validation
            var birthdayDate = new Date(dateOfBirth);
            var birthdayYear = birthdayDate.getFullYear();
            var currentYear = new Date().getFullYear();
            var maxAge = currentYear - birthdayYear;

            if (dateOfBirth == '') {
                this.toggleFormError('BIRTHDAY','EMPTY',formName);   
                isValid = false;
            } else if (maxAge > 100 || maxAge < 16 || birthdayYear >= currentYear){
                this.toggleFormError('BIRTHDAY','INVALID',formName);  
                isValid = false;
            }
        }

         /*ZIPCODE VALIDATION*/
         var zipCodeInput = $("form[name="+formName+"] [name='ZIPCODE']");
         if (zipCodeInput.length > 0 && needsValidation(zipCodeInput)) { //if fild not available or disabled do not check
            var  zipCodeValue = zipCodeInput.val();
            var zipCodeRegexp = AddressHelper.getZipCodeRegexpForCurrentCountryCode();
            
            if (!zipCodeRegexp.test(zipCodeValue)){
                this.toggleFormError('ZIPCODE','INVALID',formName);  
                isValid = false;
            }
         }

                 
        return isValid;
    },

    toggleFormError: function(element,error, formName) {
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                switch(element) {
                    case 'EMAIL': {
                        $("#mce-error-response-landingpage--email").show();
                        $("#mce-error-response-landingpage--email").children().hide();
                        $("#newsletterEmailForm input").css('border','solid 1px red');
                        if(error=='EMPTY'){ 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }    
                        else if (error=='INVALID') { 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-invalid-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - EMAIL CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    case 'NAME': {
                        $('#mce-error-response-landingpage--name').show();
                        $('#mce-error-response-landingpage--name').children().hide();
                        $('#newsletterNameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--name [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--name  [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - NAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'LASTNAME': {
                        $('#mce-error-response-landingpage--lastname').show();
                        $('#mce-error-response-landingpage--lastname').children().hide();
                        $('#newsletterLastnameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--lastname [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--lastname [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - LASTNAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    } 
        
                    case 'GENDER': {
                        $('#mce-error-response-landingpage--gender').show();
                        $('#mce-error-response-landingpage--gender').children().hide();
                        $('#newsletterGenderForm select').css('border','solid 1px red');
                        $('#newsletterGenderForm select').css('margin-bottom','0');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--gender [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - GENDER CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'BIRTHDAY': {
                        $('#mce-error-response-landingpage--birthday').show();
                        $('#mce-error-response-landingpage--birthday').children().hide();
                        $('#newsletterBirthdayForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--birthday [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--birthday [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - BIRTHDAY CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
        
                    case 'ZIPCODE': {
                        $('#mce-error-response-landingpage').show();
                        $('#mce-error-response-landingpage').children().hide();
                        $('#newsletterZipCodeForm input').css('border','solid 1px red');
        
                        if(error == 'INVALID') {
                            $('#mce-error-response-zipcode-landingpage').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - ZIPCODE CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    default: console.log('NewsletterJS.toggleFormError - '+element+' CASE  NOT DEFINED')
                }

                break;
            }
            case 'newsLetterForm_emailme' : {
                $("#mce-error-response_emailme").show();
                $("#mce-error-response_emailme").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty_emailme").show();  
                else if (error=='INVALID') $("#mce-error-response-invalid_emailme").show();
                else console.log('NewsletterJS.toggleFormError - EMAILME - CASE '+error+' NOT DEFINED')
                break;
            }
            default : {
                $("#mce-error-response").show();
                $("#mce-error-response").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty").show();
                else if (error=='INVALID') $("#mce-error-response-invalid").show();
                else console.log('NewsletterJS.toggleFormError - '+formName+' - CASE '+error+' NOT DEFINED');
            }
        }
    },

    cleanErrors: function(formName) {
        $("[id^=mce-error-response").hide()
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                $("form[name="+formName+"] input").css('border','');
                $("form[name="+formName+"] select").css('border','');
                $("form[name="+formName+"] select").css('margin-bottom','40px');
                break;
            }
            default : {
                $("#mce-error-response").hide();
            }
        }
    },

	hideAllMessagews : function () {
	    $('#newsletterSignUpResultPopup .message-error').hide();
	    $('#newsletterSignUpResultPopup .message-duplicate').hide();
	    $('#newsletterSignUpResultPopup .message-success').hide();
	},
    handleJoinNewsletterError : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorGeneric");
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-error').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#mce-error-response-error-landingpage').show();
        } else {
            $('#newsletterSignUpResultPopup .message-error').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  

    handleJoinNewsletterDuplicate : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorDuplicate");           
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                if(window.innerWidth < 1024) {
                    $('.newsletter__title').hide();
                }
                //$('.newsletter__policy').hide();
                //$('.newsletter__form').hide();
                $('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-duplicate-landingpage').show();
            
        } else if (this.formId == "newsLetterFormPromoLandingPage") {
            $('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-landingpage--email #mce-error-response-duplicate-landingpage').show();
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
         /* email me messaggi di errore per duplicati newsletter 
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-error-response-duplicate_emailme').show();
            $('#mce-success-response_emailme').hide();*/
        } //#EMAIL_ME#
        else {
            $('#newsletterSignUpResultPopup .message-duplicate').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  
    
    handleJoinNewsletterSuccess : function(){
        this.hideAllMessagews();
        
        /*if(typeof customerWeekActive != 'undefined' && customerWeekActive){
          activateCustomerWeek();
        }*/
        
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                $('#newsLetterFormDiv').hide();
                $('#newsLetterSuccessDiv').fadeIn("fast");
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                $('.newsletter__policy').hide();
                $('.newsletter--form--input.input-style').hide();
                $('.button.gray-alpha.button--newsletter').hide()
                $('#mce-success-response').show();
                
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-success-response').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
            $('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#opnewsletter-success-response-landingpage').show();
            $('.newsletter__wrapper').hide();
        } else if (this.formId == "newsLetterFormPromoLandingPage"){
        	//Generic
        	 $('.newsletter-page .newsletter__form').hide();
        	 $('.newsletter_homepage-button').show();
        	 $('.newsletter__policy.no-gdpr').hide();
        	//Vogue
        	 $('#mbb-success-response-landingpage').show();
        	 $('.newsletter__title-mbb').hide();
 	         $('.newsletter__info-mbb').hide();
 	         $('.newsletter__image.newsletter-mbb_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-mbb_image img:nth-child(3)').show();
        	//Persol
        	 $('#ponewsletter-success-response-landingpage').show();
        	 $('.newsletter__title-ponewsletter').hide();
 	         $('.newsletter__info-ponewsletter').hide();
 	         $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(3)').show();
             $('#POnewsletterImage').hide();
             $('#POnewsletterImageMobile').hide();
             if(window.mobilecheck()){
            	 $('#POnewsletterImageMobile_TP').show();
             }
             else {
            	 $('#POnewsletterImage_TP').show();
             }

            window.scrollTo(0,0);
            if (isPersol || isVogue) {
                window.setTimeout(function(){
                    window.location.href = WCParamJS.homePageURL + ($('#redirectSunglasses').length > 0 && $('#redirectSunglasses').attr('value') != undefined && $('#redirectSunglasses').attr('value') != '' ? $('#redirectSunglasses').attr('value') : '');
                }, 3200);
            }
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-success-response_emailme').show();
            $('#mce-error-response-duplicate_emailme').hide();//#EMAIL_ME#
        } else {
            $('#newsletterSignUpResultPopup .message-success').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }

        /* START Early Access */
        if (isPersol || isVogue) { 
            if ($("#boxCheckout").length == 0){
                assignCustomerSegment();
                if (this.formId == "newsLetterForm"){
                    if (window.customerSegment != undefined && document.cookie.includes("X_WC_PR_SEGMENTS")){
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        if (!urlParams.has('promo')) {
                            if (location.href.indexOf("?") === -1){
                                window.setTimeout(function(){
                                    window.location = location.href += "?promo=" + window.customerSegment;
                                }, 2000);
                            } else {
                                window.setTimeout(function(){
                                    window.location = location.href += "&promo=" + window.customerSegment;
                                }, 2000);
                            }
                        }   
                    }
                }
            }
        }
        /* END Early Access */
    }		
},
 
/**
 * This service calls JoinNewsletterCmd to make a subscription to newsLetter
 */
wcService.declare({
	id: "JoinNewsletterService",
	actionId: "JoinNewsletterService",
	url: "JoinNewsletterService",
	formId: "",

	successHandler: function(serviceResponse) {
		localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
		if(serviceResponse.responseMessage == 'duplicate'){
		    NewsLetterJS.handleJoinNewsletterDuplicate();
		}else if(serviceResponse.responseMessage == 'success'){
		    if(typeof utag_data !== 'undefined')
               utag_data.User_EmailOptin = serviceResponse.userOptin;
		    if(pageType!=='Delivery'){
		    	tealiumPushUserOptin(serviceResponse.userOptin,serviceResponse.email);
		    }
			NewsLetterJS.handleJoinNewsletterSuccess();
            if(isVogue){
                setCookieNlEvent();
            }
		}
		cursor_clear();
		
	},

	failureHandler: function(serviceResponse) {
	    NewsLetterJS.handleJoinNewsletterError();
	    cursor_clear();
	}
});

//  Display/undisplay Landing Page fields
function toggleLandingPageFields() {
    var landingForm = $("form[name='newsLetterFormPromoLandingPage'],form[name='newsLetterFormLandingPage']");
    if (landingForm.length > 0) {
        var formId = landingForm.attr('id')
        toggleSubscriptionForms("X_SignInForms_Info");
        if (typeof subscriptionFormsJSONData != 'undefined'){
        for (var key in subscriptionFormsJSONData) {
            var dataValue = subscriptionFormsJSONData[key];
            switch(dataValue) {
                case 'disabled','false': {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("disabled","disabled");
                    $("#"+formId+" #"+key).hide();
                    if (key == 'newsletterBirthdayForm') {
                        $('#newsletter_age-disclaimer').hide();
                    }
                    break;
                }
                case 'optional' : {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("optional","optional");
                    break;
                }
                default:{}
            }
        }
      }
    }
}

function toggleSubscriptionForms(espotName){

    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
  
    $.ajax({
      type: "GET", 
      dataType: 'json', 
      url: espotServiceUrl,
      async: false,
      contentType: "application/json",
      success: function (data) {
        //console.log(data);
        if (data.MarketingSpotData[0].baseMarketingSpotActivityData != undefined) {
          window.subscriptionFormsJSONData = JSON.parse(data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText);
        }
      },
      error: function(data){
        console.log("Error retrieving newsletter subscription forms info");
      }
    });
}

function needsValidation(inputElement) {
    var needValidation = true;

    if(inputElement.attr('disabled'))
        needValidation = false;

    if(inputElement.attr('optional'))
        needValidation = false;

    return needValidation;
}

/* ---- START - DOCUMENT LOAD  ---- */

window.addEventListener('load', (event) => {
    nonCriticalLogic()
});

/* ---- END - DOCUMENT LOAD  ---- */


function toggleDiscoverMoreOverlay(){
    var EditorialCursor = {
        initCursor: function (cursorClass) {
            $('.editorial-content-custom-cursor[data-cursor-editorial="' + cursorClass + '"]').css({
                'cursor': 'none'
            });
            EditorialCursor.deleteCursor();
            EditorialCursor.changeCursorMouseMove(cursorClass);
        },
        deleteCursor: function () {
            $('html').css({
                'cursor': ''
            });
            $('.editorial-cursor-dark').css({
                'opacity': '0'
            });
            $('.editorial-cursor-dark > div').css({
                'transform': 'scale(0)'
            });
        },
        changeCursorMouseMove: function (cursorClass) {
            $('.editorial-content-custom-cursor[data-cursor-editorial="' + cursorClass + '"]').mousemove(function (e) {
                var leftEspot = $(this).parent().parent();
                var cursor = $(leftEspot).find("." + cursorClass);
                var divCursor = $(leftEspot).find('.' + cursorClass + ' > div');
                $(cursor).css({
                    'position': 'fixed',
                    'opacity': '1',
                    'user-select': 'none',
                    'top': e.clientY + -50 + 'px',
                    'left': e.clientX + -50 + 'px'
                });
                $(divCursor).css({
                    'transform': 'scale(1)'
                });

            });

        }
    }
    var zIndexScrollable =  $(".bottom-scrollable-section").css("z-index")
    var parentEl;
    var editorial;
    var editorialBg;
    var closeButton;
    var editorialEspot;
    var edWrapper;
    $('#Discover_More_CTA,[data-element-id="X_Pdp_Hero_CTA"], #Discover_More_CTA ~ .btn-mobile, #Discover_More_Monogram_CTA, #Discover_More_Monogram_CTA ~ .btn-mobile'+(isPersol ? ',.editorial-espot a:not(.not-overlay)' : '')).click(function(){
        parentEl = $(this).closest( ".left_espot" );
        editorialEspot = $(parentEl).parent().parent();
        editorial = $(parentEl).find(".editorial");
        editorialBg = $(parentEl).find(".editorial-background");
        closeButton = $(parentEl).find(".close");
        edWrapper = $(parentEl).find(".editorial-wrapper");
        edWrapper[0].addEventListener('wheel', transformScroll);

        $(editorial).css("transform", "translateY(0px)");
        $(editorial).addClass("show");
        $(editorialBg).show();
        if(mobilecheck() || tabletPortraitCheck()){
            $("body").addClass("overflow-hidden");
        }
        $("body").css("overscroll-behavior", "contain")
        $(".bottom-scrollable-section").css("z-index", "1000");
        $(closeButton).css("display", "flex");
        $(closeButton).css("opacity", "1");
        manageScrollOverlay(true);
    })

    function closeEditorial() {
        if(mobilecheck() || tabletPortraitCheck()){
            $("body").removeClass("overflow-hidden");
            $('html,body').animate({
                scrollTop: $(editorialEspot).offset().top
            }, 600);
            $(editorialBg).hide();
            $(closeButton).fadeOut();
            $(editorial).removeClass("show");
            $(".bottom-scrollable-section").css("z-index", '333');
            manageScrollOverlay(false);
        } else {
           $(".bottom-scrollable-section").css("z-index", zIndexScrollable);
            $(editorialBg).hide();
            
            $(editorial).removeClass("show");
            $(closeButton).hide();
        }

        $("body").css("overscroll-behavior", "initial");
        if(edWrapper != undefined)
            edWrapper[0].removeEventListener('wheel', transformScroll);
        event.preventDefault();
        event.stopPropagation();
    }

    function scrollEditorial(distance, duration) {
        $(editorial).css("transition-duration", +(duration /2000).toFixed(1) +"s");
        //inverse the number we set in the css
        var value = (distance < 0 ? "" : "-") + Math.abs(distance).toString();
        $(editorial).css("transform", "translateY(" + value + "px)");
        var opacity = 1 - (value / 200);
        $(closeButton).css("opacity", opacity)
        $(editorialBg).css("background-color", "rgba(0, 0, 0, " + opacity + ")")
    }

    function transformScroll(event) {
      if (!event.deltaY) {
        return;
      }

      event.currentTarget.scrollLeft += event.deltaY + event.deltaX;
      event.preventDefault();
    }

    $("#Prescription_lenses_editorial ~ .close,[data-espot-name='X_PDP_Editorial_Top'] .close, #Monogram_lenses_editorial ~ .close ,#Prescription_lenses_editorial  .close, [data-espot-name='X_PDP_Editorial_Bottom'] .close, .editorial-content .close").click(function(){
        closeEditorial();
    })
    if ($(window).width() > 1024) {
        // CUSTOM CURSOR SET MOUSE ENTER/LEAVE
        $('.editorial-content-custom-cursor').on({
            mouseenter: function() {
                EditorialCursor.initCursor($(this).data('cursor-editorial'));
            },
            mouseleave: function() {
                EditorialCursor.deleteCursor();
            }
        });
    }
    if(mobilecheck() || tabletPortraitCheck()){
        $(".editorial").swipe( {
            //Generic swipe handler for all directions
            swipe:function(event,direction){
                if(direction == "down") {
                    closeEditorial();
                }
            },
            swipeStatus:function(event, phase, direction, distance, duration) {
                var duration = 0;
                if (phase == 'move' && direction == "down") {
                    scrollEditorial(-distance , duration);
                };
                if (phase=="cancel") {
                    scrollEditorial(0, duration);
                }
                if (phase=="end" && direction == "down") {
                    scrollEditorial(-800, duration);
                }
            },
            allowPageScroll:"vertical",
            threshold:300
        });
    }
}

function toggleMonogramPanel(){
    if(!(window.mobilecheck() || window.tabletPortraitCheck())) managePopupTabIndex('.shopperActions--monogram--pop-up--right--wrapper' , true)
    hideHeaderTimeout.cancel();
    $('.bottom-scrollable-section').css('z-index', "1000");
    $(".shopperActions--monogram--pop-up").show();
    $("html").addClass("overflow-hidden");
    //$("#page-overflow-wrapper").addClass("overflow-hidden");

    if(window.mobilecheck() || window.tabletPortraitCheck() ){
        var windowCloseInputHeight = $(window).innerHeight();
        $(window).resize(function () {
                var windowOpenInputHeight = $(window).innerHeight();
            if(windowCloseInputHeight >  windowOpenInputHeight){
                $('.shopperActions--monogram--pop-up--right--wrapper--step-one').slideUp()
            } else {
                $('.shopperActions--monogram--pop-up--right--wrapper--step-one').slideDown()
            }
        });
        $('#fixed-top--mobile').hide();
        manageScrollOverlay(true);
        $(".shopperActions--monogram--pop-up").css("pointer-events","auto");
        $(".shopperActions--monogram--pop-up").css("overflow","auto");
        $("body").css("pointer-events","none");
        $("body").css("overflow","hidden");
        currentBreak = 'top';

        $('#addMonogram').click(function() {
            manageScrollOverlay(false);
            $(".shopperActions--monogram--pop-up").css("pointer-events","");
            $(".shopperActions--monogram--pop-up").css("overflow","");
            $("body").css("pointer-events","");
            $("body").css("overflow","");
        });
    }

    $(".shopperActions--monogram--pop-up .ui-dialog-titlebar-close, #close-monogram").click(function(){
        $(".shopperActions--monogram--pop-up").hide()
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) managePopupTabIndex('.shopperActions--monogram--pop-up' , false)
        hideHeaderTimeout.setup()
        if(window.mobilecheck() || window.tabletPortraitCheck()){
           // $('.bottom-scrollable-section').css('z-index', '801');
        } else{
            $('.bottom-scrollable-section').css('z-index', zIndexBS);
        }
        $("html").removeClass("overflow-hidden");
        //$("#page-overflow-wrapper").removeClass("overflow-hidden");
        if (window.mobilecheck() || window.tabletPortraitCheck()){
            manageScrollOverlay(false);
            $(".shopperActions--monogram--pop-up").css("pointer-events","");
            $(".shopperActions--monogram--pop-up").css("overflow","");
            $("body").css("pointer-events","");
            $("body").css("overflow","");
        }
    });
}



function printBadgesCarousel(attributes, isPrintClass){
    if(isOliver) {
        var newRelease = null;
        var limited = null;
        var exclusive = null;
        var clipsAvailable = null;
        var premiumMaterial = null;

        $(attributes).each(function (){
            if(this.identifier === 'NEWRELEASES' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k ; k++ ){
                    if(this.values[k].value === true || this.values[k].value.toLowerCase() === 'new' || this.values[k].value.toLowerCase() === 'true'){
                        newRelease = '—New—';
                    }
                }
            }
            if(this.identifier === 'LIMITED_EDITION' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].value == true || this.values[k].value.toLowerCase() === 'true'){
                        limited = '—'+this.name+'—';
                    }
                }
            }
            if(this.identifier === 'EXCLUSIVE' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].value == true || this.values[k].value.toLowerCase() === 'true'){
                        exclusive = '—'+this.name+'—';
                    }
                }
            }
            if(this.identifier === 'MATCH_WITH_CLIPS' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].value == true || this.values[k].value.toLowerCase() === 'true'){
                        clipsAvailable = '—'+$('#clipAvailable').val()+'—';
                    }
                }
            }
            if(this.identifier === 'FRAMEMATERIAL_FACET' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].identifier.toLowerCase() === 'horn' || this.values[k].identifier.toLowerCase() === 'solid gold'){
                        premiumMaterial = '—'+$('#premiumMaterial').val()+'—';
                    }
                }
            }
        })

        if(isPrintClass){
            if(newRelease || limited || exclusive || premiumMaterial || clipsAvailable) {
                return "badge-show";
            }
        }

        if(limited){
            return limited;
        } else if(exclusive){
            return exclusive;
        } else if(premiumMaterial) {
            return premiumMaterial;
        } else if(clipsAvailable) {
            return clipsAvailable;
        } else if(newRelease) {
            return newRelease;
        }
    }

    return "";

}

function calculateHeightImg(){
    if (!$("#image-soldOut").is(":visible")) {
        //central img height calculation
        if( $('.slot3 .full-image-widget').hasClass('other-colors-empty')){
            if($('#soldOut').is(":visible")){
                $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight() )
            }
        } else{
            if($('#soldOut').is(":visible")){
                $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight()  - $('.other_colors').outerHeight() );
            }

        }
    }
}

function loadEspotPDP(espotName,featureEspot) {
    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName + '?langId=' + WCParamJS.langId;
    var content ='';
    return new Promise((resolve, reject) => {
        $.ajax({
            url: espotServiceUrl,
            type: 'GET',
            data: '',
            async: false,
            success: function(data) {
                data["MarketingSpotData"].forEach(function(msd, index) {
                    if(msd["baseMarketingSpotActivityData"] && msd["baseMarketingSpotActivityData"][0]["baseMarketingSpotDataType"] === "MarketingContent"){
                        content= msd["baseMarketingSpotActivityData"][0]["marketingContentDescription"][0]["marketingText"]; //html text
                    }
                });
                if (content != '') {
                    if((!isPersol && featureEspot == 'lenses-sun') || featureEspot == 'folding-all'){
                        var div="<div class='product-features inverted-order-mobile'>"+content.toString()+"</div>"
                    }
                    else{
                        var div="<div class='product-features'>"+content.toString()+"</div>"
                    }
                    if(isPersol){
                        $('#product-detail-carousel').append(div);
                        var product = $(".product-features img[data-preset]");
                    }else if(isOliver){
                        $('#op-pdp__section-carousel').append(div);
                        var product = $(".op-pdp__product-details img[data-preset]");
                    }
                    if (product.length>0) {
                        handleProduct(product);
                    }
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);
                reject(error);
            }
        });
    });

}

function setPaginationOtherColors(maxPagination) {
    if(isPersol) {
        if (window.mobilecheck() || window.tabletPortraitCheck()) {  
            var array = $('.oos-Color .owl-page').toArray();
            var activeIndex = $('.oos-Color .owl-page.active').index();
            if(array.length > maxPagination && activeIndex == 0) {
                array[maxPagination].classList.add('small');
                var sliced = array.slice(maxPagination+1,array.length);
                sliced.forEach((el)=>el.classList.add('hide'));
            }
        }
    }
}

/* START - Size guide overlay */

/* PDP_W2
 * Add parameter dataElementId, in this way we can use this function also for FadeClipon
 * */
function freezeWindowForOverlay(dataElementId) {
    hideHeaderTimeout.cancel();
    if(dataElementId == 'X_X_Prod_Size&Fitting_Tooltip'){
    	$(".fade-size-guide").show();
    }else{
    	$(".fade-clipon").show();
    }
    
    if (isPersol) {
      if(!$('#header').is(':visible')){
        $("#bannerTop").css("display", "flex");
        $('#header').slideDown();
      }
      $("html").addClass("overflow-hidden");
    } else {
      $("body").addClass("overflow-hidden");
      $("body").css("position", "relative");
      if (typeof vmSwitchOff === 'function') {
      	vmSwitchOff(false);
  	   }
    }
    $('#header').attr('productAdded','yes');
    $("#page-overflow-wrapper").addClass("overflow-hidden");
    manageScrollOverlay(true);
}

function showSizeGuideOverlay() {
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        $('.size-guide--body').css('height', '90%');
    } else {
        var windowHeight = window.innerHeight;
        var overlayHeadHeight = $('.size-guide--content__header').css('height').replace(/[^-\d\.]/g, '');
        $('.size-guide--body').css('height', (windowHeight - overlayHeadHeight));
    }
    $(".size-guide").addClass('showed');
}

function unfreezeWindowForOverlay(className) {
    hideHeaderTimeout.setup();
    $('#header').removeAttr('productAdded');
    if(className != undefined){
    	$("." + className).hide();
    }else{
    	$(".fade-size-guide").hide();
    }
    if (isPersol) {
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            $("html").removeClass("overflow-hidden");
        }else if ((window.mobilecheck() || window.tabletPortraitCheck()) && className != undefined ){
        	$("html").removeClass("overflow-hidden");
        }
      
    } else {
      $("body").removeClass("overflow-hidden");
      $("body").css("position", "");
    }
    $("#page-overflow-wrapper").removeClass("overflow-hidden");
    //manageScrollOverlay(false);
}

function closeSizeGuideOverlay() {
    unfreezeWindowForOverlay();
    $(".size-guide").removeClass('showed');
}

function loadSizeGuideOverlay(elementClicked) {
    var dataElementId = elementClicked.getAttribute('data-element-id');
    
    //Analytics Size&Fit
    tealium_data2track.push({
        id: "Click",
        data_element_id: dataElementId, // data-element-id requested
        data_description: " ", // data-description only if requested
      });
    
    /* PDP_W2
     * Add parameter dataElementId to freezeWindowForOverlay, in this way we can use this function also for FadeClipon
     * */
    
    freezeWindowForOverlay(dataElementId);
    showSizeGuideOverlay();
}


/* END - Size guide overlay */

function nonCriticalLogic(){

    if (!calledNonCritical) {

        calledNonCritical = true;

        if (isOliver) {
        if(typeof attributesMap[keysAttributes[2].toString()] != 'undefined' && attributesMap[keysAttributes[2].toString()] == 'Accessories'){
            $('#cbs-desktop .button_text').html(mexAccessories);
        }else{
            $('#cbs-desktop .button_text').html(mexOthers);
        }
        var img = "1";
        var pdp_hero_gallery_m_policy = "?bgcolor=%23f8f8fa&impolicy=OV_parameters&wid=790&cropwest=21&cropeast=19";
        var pdp_hero_gallery_d_policy ="?impolicy=HB_parameters&wid=2000";
        if(typeof attributesMap[keysAttributes[2].toString()] != 'undefined' && attributesMap[keysAttributes[2].toString()] == 'Accessories'){
            img = "<picture><source media='(max-width: 767px)' data-srcset='https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/"+partNumber +"_noshad_qt.jpg"+ pdp_hero_gallery_m_policy.replace('bgcolor=%23f8f8fa', 'bgcolor=%23ffffff') +"'/> <source media='(min-width: 769px)' data-srcset='https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/"+ partNumber +"_noshad_qt.jpg"+ pdp_hero_gallery_d_policy +"'/> <img alt='"+ partNumber + "main image' 	class='lazy catalog__image placeholder' 	src='/wcsstore/OliverSAS/images/lazyload.png' 			 data-src='https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/" + partNumber +"_noshad_qt.jpg"+pdp_hero_gallery_d_policy + "'/> </picture>";
        }else{
            var urlimage = $("#thumbnailImage").val()
            img = "<picture>"+
            "<source media='(max-width: 767px)' data-srcset='"+ window.setQueryParams(urlimage, pdp_hero_gallery_m_policy.replace('bgcolor=%23f8f8fa', 'bgcolor=%23ffffff') ) +"' />"+
            "<source media='(min-width: 769px)' data-srcset='"+ window.setQueryParams(urlimage, pdp_hero_gallery_d_policy) +"'/> "+
            "<img alt='" + partNumber + "main image'  class='lazy catalog__image placeholder'  src='/wcsstore/OliverSAS/images/lazyload.png' data-src='"+ window.setQueryParams(urlimage , pdp_hero_gallery_d_policy ) + "' /> "+
            "</picture>";
        }
        $('#newsLetterForm_emailme .comingSoon__newimage').html(img);
        }
    
        setTimeout(() => {
            var espotPromises = [];
            if(attributesMap['attrFeatures']){
                var split = attributesMap['attrFeatures'].split(';');
                split.forEach(function(obj){
                    var featureEspot= obj.replaceAll("_", "-").replaceAll(" ", "-");
                    featureEspot= featureEspot.toLowerCase();
                    if(isPersol){
                        var espotName = "PDP_"+featureEspot
                    }else if(isOliver){
                        var espotName = "PDP_"+featureEspot+"_2020"
                    }
                    espotPromises.push(loadEspotPDP(espotName,featureEspot));
                });
            }
        }, 0);

        setTimeout(() => {
            if(window.mobilecheck() || window.tabletPortraitCheck()){
                placeProductDetailsNew();
                //  New PDP 2021
                if (isPersol) {
                    setProductDetailPopup('#product-detail-carousel');
                } else if (isOliver) {
                    setProductDetailPopup('#op-pdp__section-carousel');
                }
            }else{
                if (isOliver) {
                    placeProductDetailsNew();
                    setProductDetailPopup('#op-pdp__section-carousel'); 
                }else if (isPersol){
                    placeProductDetailsNew();
                    setProductDetailPopup('#product-detail-carousel');;
                } 
            }
        }, 0);
        
    
        /* START - Size guide overlay */
        
        $(document).on("click",".sizeFitPanel .learnMorePanel",function() {
        	
        	loadSizeGuideOverlay(this);
        	
        	
        	if(window.mobilecheck() || window.tabletPortraitCheck()){
        	/*handle with bottom bar safari. if distance from bottom viewport is a negative value add a padding-bottom*/
	        	$(".size-guide--body").scroll(function(){
	        		 if (this.offsetHeight + this.scrollTop >= this.scrollHeight) {
	        			 var distBottom = window.innerHeight  - document.querySelector("#size-guide-BridgeDiv").getBoundingClientRect().bottom;	
	        			 if(distBottom < 0 && isOliver){
	        				 distBottom = (distBottom * -1) + 80;
	        				 $(this).css('padding-bottom', distBottom + 'px');
	        			 }else if(distBottom < 0 && isPersol){
                            distBottom = (distBottom * -1) + 16;
	        				$(this).css('padding-bottom', distBottom + 'px');
	            		 }
	        		 }
	        	});
        	}
        	
        });
        

        $(document).on("click",'.fade-size-guide, .size-guide--content__header > .closeButton',function() {
            closeSizeGuideOverlay();
            if (isOliver){
                $(".fade-size-guide").data('clicked', true);
                $("#close-size-guide").data('clicked', true);
            }
        });
        /* END - Size guide overlay */
        
        //Set bottom on size guide
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            var iOSVersion = iOSversion();
            if(iOSVersion != undefined){
                //Set bottom on size guide if  version of iOS >= 15
                $(window).on('resize touchmove', function () {
                    if ($(window).height() < window.innerHeight) { //  URL bar collapsed
                        $('.size-option-div').css('bottom','');
                    } else if ($(window).height() == window.innerHeight) { //  URL bar expanded
                        //$('.size-option-div').css('bottom','80px');
                    }
                });		
            }
        }   

        $('#Add_monogram_CTA').click(function(){
            if($(".shopperActions--monogram--pop-up").length > 0) //Do nothing if the monogram pop-up has not been loaded
                toggleMonogramPanel(); 
        });
    
        toggleDiscoverMoreOverlay();
        
        if (isPersol && window.mobilecheck() || window.tabletPortraitCheck()){
            $("#ci_espot__X_PDP_Editorial_Bottom .ct-editorial-button").on("click", function(){
                $("#fixed-top--mobile").removeClass("animation-show");
            });
            $("#ci_espot__X_PDP_Editorial_Bottom a.close").on("click", function(){
                $("#fixed-top--mobile").addClass("animation-show");
            });
        }
        
        if(typeof stock != 'undefined'){
            enableEditorialCta(stock);
        }
    
        if (typeof isSafari == 'function' && isSafari()
                && ((window.mobilecheck() || window.tabletPortraitCheck()))) {
            $('.shopperActions--monogram--pop-up--right').css('height','auto');
        }
    
      //switch button other color
        $(document).off("change",".switchButtonOtherColorsContainer input").on("change",".switchButtonOtherColorsContainer input",function(){
            if($(".switchButtonOtherColorsContainer input").is(":checked")){
                $('#popup-content-container .product[data-is-roxable!="true"]').hide();
                tealium_data2track.push({
                    id : 'SearchFilterUpdated',
                    'Search_ResultItemsQnt' : '',
                    'Search_FacetValues_String' : ''
                });
            }
            else if($(".switchButtonOtherColorsContainer input").is(":not(:checked)")){
                $('#popup-content-container .product[data-is-roxable!="true"]').show();
                tealium_data2track.push({
                    id : 'SearchFilterUpdated',
                    'Search_ResultItemsQnt' : '',
                    'Search_FacetValues_String' : ''
                });
            }
        });
    
        // BEGIN HB-9422 sizeGuideOverlay
        $(".size-guide--body").on('scroll',function () {
            if (isOliver){ 
                if($('.nav-div').offset().top <= $(window).scrollTop() + $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight() +6 ){ //6px padding-top
                    $('.size-guide--body .nav-beans').addClass('nav-div--sticky');
                    $('.size-guide--body .nav-beans').css({'top': $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight(),'width':$('.nav-div').width()});
                    $('.size-guide--body .nav-div').addClass('-sticky');
                    $('.size-guide--body #size-guide-FitDiv').addClass('-sticky');
                }else{
                    $('.size-guide--body .nav-beans').removeClass('nav-div--sticky');
                    $('.size-guide--body #size-guide-FitDiv').removeClass('-sticky');
                    $('.size-guide--body .nav-div').removeClass('-sticky');
    
                }
            }else{
                if($('.nav-div').offset().top <= $(window).scrollTop() + $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight()){
                    $('.size-guide--body .nav-beans').addClass('nav-div--sticky');
                    $('.size-guide--body .nav-beans').css({'top': $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight(),'width':$('.nav-div').width()});
                    $('.size-guide--body .nav-div').addClass('-sticky');
                    $('.size-guide--body #size-guide-FitDiv').addClass('-sticky');
                }else{ 
                    $('.size-guide--body .nav-beans').removeClass('nav-div--sticky');
                    $('.size-guide--body #size-guide-FitDiv').removeClass('-sticky');
                    $('.size-guide--body .nav-div').removeClass('-sticky');
                } 
            }
        });
        //END HB-9422
        if($("a[id='add2CartBtnNavBar']:not(:nth-child(1))").length>1){
            $("a[id='add2CartBtnNavBar']:not(:nth-child(1))").remove();
        }
    
        /**
        * Function that close the newsletter
        */
        $('.comingSoon__close').click(function () {
        closeform();
        });
    
        /**
         * Function that close the newsletter emailme when click in fade layer
         */
        $('.comingSoon--fade').click(function () {
            $('.comingSoon__close').click();
            $('body').removeClass('no-scroll');
            $('body, html').css('height', 'auto');
            $('body, html').css('overflow', 'visible');
        });
    
        $('#close_emailme').click(function () { 
        closeform();
        });

        if($('#below-clipon-section').length > 0){
        	manageCliponSection();
        }
    	$('.product-image-sticky').css('cursor', 'pointer');
        $('.product-image-sticky').click(function (){
        	$(window).scrollTop(0);
        });

    }

    if (typeof init_wishlist_tooltip === 'function') {
        if(!(window.tabletPortraitCheck() || window.mobilecheck())){
            init_wishlist_tooltip();
        }
        
    }

  
}

function placeProductDetailsNew(){
	//carousel product detail
	if(isPersol && (window.mobilecheck() || window.tabletPortraitCheck())){
		$('.view-product-details-container').before('<div id="titleProductDetail">' + $('.persol-product-title').text() + '</div>');
	}else if (isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
		$('.view-product-details-container').before('<div class="titleProductDetail">' + $('.product_text--title h1').text() + '</div>');
	}

    if(window.tabletPortraitCheck()){
        if(isPersol){
            $('.right-side .product-description').prepend('<div class="titleProductDetailTablet">' + $('#titleProductDetail').first().text() + '</div>');
        }else if(isOliver){
            $('.left-side .product-description').prepend('<div class="titleProductDetailTablet">' + $('.titleProductDetail').first().text() + '</div>');
        }
    }
	var cloneProductDetail;
	cloneProductDetail = document.querySelector('.descriptive-attributes-widget').cloneNode(true );
	cloneProductDetail .setAttribute('id', 'productDetail');
	$('.view-product-details-container').before(cloneProductDetail);
	if(window.mobilecheck() || window.tabletPortraitCheck() || isPersol){
		var cloneTab;
		if(isPersol){
			cloneTab = document.querySelector('.accordion-content').cloneNode( true );
			cloneButton = document.querySelector('.view-product-details-container').cloneNode( true );
		}else if(isOliver){
			if((isAccessory && !isClipon && $('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details').length == 0) || (!isAccessory && !isClipon) || isClipon){
	        	//if is a product, clipon or case 
				cloneTab = document.querySelector('#descriptiveAttributes').cloneNode( true );
	        }else{
	        	cloneTab = document.querySelector('.left_espot .ct-pdp--tab-details').cloneNode( true );	        	
	        }
		}    
	    cloneTab.setAttribute('id', 'tabAttr');
	    //table in persol desktop with only 8 tab
	    if(isPersol && !(window.mobilecheck() || window.tabletPortraitCheck() )){
	    	$('#productDetail #product-details-popup .text-content').append(cloneTab);
	    	$('#productDetail #product-details-popup').append(cloneButton);
	    }else{
	    	$('.view-product-details-container').not('.view-product-details-container.dsk_pdp').before(cloneTab);
	    }
	    while($('#tabAttr li').length > 8){
	    	//we wish see only the first 8 element of table
	    	$('#tabAttr li:last-child').remove();
	    }
	    //after delete the rows we can show the table 
	    if(isPersol){
	    	$('#tabAttr').css('display','block');
	    }else if((isAccessory && !isClipon && $('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details').length > 0)){
	    	//if is an collaboration acc
	    	$('#tabAttr.tabContent.ct-pdp--tab-details').addClass('blockImportant');
	    }
	    
	}else{
		//if is OP Desktop
		if(isAccessory){
			while($('#productDetail .tabContent.ct-pdp--tab-details li').not('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details li').length > 5){
		    	//we wish see only the first 6 element of table
				$('#productDetail .tabContent.ct-pdp--tab-details li:last-child').not('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details li').remove();
		    }			
		}
	} 
    //insert voice product details
    if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
    	//insert voice product details
    	$('#descriptiveAttributes.tabContent ul').before('<div id="nameDetailTab" class ="opened" >'+ $('#prodAttr').text() +'</div> ');	
    	
    	//Insert Premium Package if isn't accessory
    	if((isAccessory && isClipon)|| (!isAccessory && !isClipon)){
            if(oliverCase != ""){
                createOliverCaseDiv();
        	    $('#descriptiveAttributes.tabContent').after($('.slide-type.front-frame.case'));
        	    $('.slide-type.front-frame.case').before('<div id="titleFeature" class="tabPack" aria-expanded="false">' + $('#tab-presc .description-packaging h3')[0].innerText  +'</div>')
            }
    	}
    }else if(isOliver){
    	//insert tab in popup desktop
    	$("#productDetail #popupDetail #detailDescription").append('<div id="nameDetailTab" class ="opened" >'+ $('#prodAttr').text() +'</div> ');
    	var tabDetail = document.querySelectorAll('#descriptiveAttributes.tabContent');
    	$("#nameDetailTab").after(tabDetail[0].cloneNode(true));
    	$('#popupDetail #detailImage').append("<div feature='detailTabImg'>" +
				  // "<img src = 'https://assets.oliverpeoples.com/is/image/OliverPeoples/" + partNumber + "_shad_fr.png?bg=f8f8fb&impolicy=OV_parameters&wid=2000&cropeast=1000'>" +
				  "</div>");
    	
    	createOliverCaseDiv();    	
    }
    
}

function closeform(){
    changeTabIndex($('.comingSoon'));
    $('.comingSoon').removeClass('opend');
    $('.comingSoon--fade').hide();
    $('body').removeClass('no-scroll');
    $('body, html').css('height', 'auto');
    $('body, html').css('overflow', 'visible');
}

function resetFrom(){
//form completo da visualizzare
$('#mce-error-response_emailme').hide();
$('.comingSoon__infoSuccess').hide();
$('.comingSoon__titleSuccess').hide();
$('.comingSoon__info').show();
$('.comingSoon__title').show();
$('.input_emailme').show();
$('.check_emailme').show();
$('#confirm_emailme').show();
$('#close_emailme').hide();
$('.buttonEmailme').css('margin-top','0px');
}
//#EMAIL_ME#

function newOpenSizeGuide(){
    $('.fade-size-guide').show();
    $('.size-guide').addClass('showed');
    manageScrollOverlay(true);
}

/* This function checks replaces the current image in the minicart with the STD one for the given partnumber */
function replaceImageMinicart(imges, partnumber){
    $.each(imges, function(index,img){
       var urlImg= img.dataset['src'];
       if(urlImg != undefined){
         img.dataset['src'] = urlImg;
         img.src = urlImg;
        }
       
       
    });
}


function scrolltoDiv(id){    
    if(id == '#size-guide-BridgeDiv'){
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            var scrollTop = $(id).offset().top - 90 ;
        }else{
            var scrollTop = $(id).offset().top +500;
        }
       
    }else{
        var scrollTop = $(id).offset().top-150;
    }  
    $('.size-guide--body').animate(
        {
            
          scrollTop: scrollTop
        },
        800 //speed
      ); 
}


function closePromoBox(id){

    $("#"+id).addClass('hide-promo');
    $("#"+id).parent().addClass('hide-promo-parent');
    if(id.includes("X_PDP_Hero__Promo")){
        $("#X_PDP_Hero__Promo_mobile").addClass('hide-promo');
        $("#X_PDP_Hero__Promo").addClass('hide-promo');
        $("#X_PDP_Hero__Promo").parent().addClass('hide-promo-parent');
        $("X_PDP_Hero__Promo_mobile").parent().addClass('hide-promo-parent');
    } 
    if (isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
        if(id == "X_PDP_Hero__Clipon"){
            //$(".shopper-action-bar").css("padding-bottom","0");
        }
    }
}

function setCtabarStickyDesktop(){

    var st = document.documentElement.scrollTop;
    var upperBarOriginalHeigth = $("#upperBarOriginalHeigth").val();
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    

    if (st >= ($( window ).height() - upperBarOriginalHeigth - 64  - $("#header").height() - ($('#bannerTop').length > 0 ?($('#bannerTop').height()): 0 ))){ // viewport - ctaupperBar height - 64(space below ctabar) - header height - banner top height (if present) = scrollable area without sticky 
        $('.cta-upperBar').addClass("sticky-top");
        $('.cta-bar-container').addClass("sticky-top");
        $("#bannerTop").parent().hide();
        $(".product-image-sticky").show();
        $(".espot-promo-container").hide();
        $(".cta-lowerBar").hide();
        if(!$('.cta-bar-container').hasClass("sold-out")){
            $(".name-partnumber-and-price-widget").hide();
        }
        if($('.cta-bar-container').hasClass("coming-soon")){
            $("#comingSoon").hide();
            $('.pdp .name-part-price-container').hide();
        }
          
    
    }else{
      $("#bannerTop").parent().show();
      $(".product-image-sticky").hide();
      $('.cta-upperBar').removeClass("sticky-top");
      $('.cta-bar-container').removeClass("sticky-top");
      $(".name-partnumber-and-price-widget").show();
      if(!$('.cta-bar-container').hasClass("sold-out")){
        if (!urlParams.has('bypassPromo') || urlParams.get("bypassPromo").toLowerCase() != 'true') {
            $(".espot-promo-container").show();
        }
        $(".cta-lowerBar").show();
      }
      if($('.cta-bar-container').hasClass("coming-soon")){
        $("#comingSoon").show();
        $('.pdp .name-part-price-container').show();
    }
    $("#X_PDP_Hero__Promo_mobile").hide();
    }
    
}


function showCTAloader(buttonId){
    button = document.getElementById(buttonId);
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        
        $(button).removeClass("loaded");
        if(buttonId === 'productPageAdd2Cart'){
          button = document.getElementById('add2CartBtn');
          $(button).removeClass("loaded");
        }
    
      }else{
    
          $(button).find(".bag-icon").hide();
          if (isOliver) {
              $(button).find(".presc--side--button--icon").hide();
          } else {
              $(button).find(".plus-symbol").hide();
          }
          $(button).find(".loadpanel_loader").css("display","inline-block");
    
      }
  
}


function hideCTALoader(buttonId){
    button = document.getElementById(buttonId);
  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
    
    $(button).addClass("loaded");
    if(buttonId === 'productPageAdd2Cart'){
      button = document.getElementById('add2CartBtn');
      $(button).addClass("loaded");
    }

    }else{
        
    $(button).find(".bag-icon").show();
        if (isOliver) {
            $(button).find(".presc--side--button--icon").show();
        } else {
            $(button).find(".plus-symbol").show();
        }
        $("div.loadpanel_loader").hide();
    }

 }
/* PDP called function: #3
*  prev function: getAttributes()
*  next function: checkStockRX()
*/


function open_monogram(){
		if(!(window.mobilecheck() || window.tabletPortraitCheck())) managePopupTabIndex('.shopperActions--monogram--pop-up--right--wrapper' , true)
			 hideHeaderTimeout.cancel();
		$('.bottom-scrollable-section').css('z-index', "1000"); 
		if ($.cookie("isVMOpen") == "1" && !$('#vm_box').hasClass('hide')) {
			if (typeof vmSwitchOff === 'function') {
				vmSwitchOff(false);
			}
   		}
		$(".shopperActions--monogram--pop-up").addClass('opened');
		$("html").addClass("overflow-hidden");
		$("#page-overflow-wrapper").addClass("overflow-hidden");

		if(window.mobilecheck() || window.tabletPortraitCheck() ){
			var windowCloseInputHeight = $(window).innerHeight();
			$(window).resize(function () {
				var windowOpenInputHeight = $(window).innerHeight();
				if(windowCloseInputHeight >  windowOpenInputHeight){						
					$('.shopperActions--monogram--pop-up--right--wrapper--step-one').slideUp()
				} else {
							$('.shopperActions--monogram--pop-up--right--wrapper--step-one').slideDown()
				}
			})
			manageScrollOverlay(true);
			$(".shopperActions--monogram--pop-up").css("pointer-events","auto");
			$(".shopperActions--monogram--pop-up").css("overflow","auto");
			$("body").css("pointer-events","none");
			$("body").css("overflow","hidden");
		}
	
		$('.fade-monogram').show();
}

function movingElementsToNewLayout(){

    var timestamp = new Date().getTime() / 1000;
    var diff = timestamp - renderingPageStarterTime;
    console.log('Performance Improvements PDP - #18 - movingElementsToNewLayout (PO only) - ' + diff.toString().slice(0 , 5) + 's');

    if (window.innerWidth > 768) {
        $("#pdp-presc-and-clip-on").append($(".shopperActions--monogram"));
    } else {
        $("#pdp-presc-and-clip-on").append($(".shopperActions--monogram"));
    }
    $(".defining-attributes-widget").after($(".shopperActions .estimated"));

}

//For other colors popup interactions
function togglePopupOtherColors(toOpen) {
	if ($.cookie("isVMOpen") == "1" && !$('#vm_box').hasClass('hide')) {
		if (typeof vmSwitchOff === 'function') {
	    	vmSwitchOff(false);
	   }
	}else if ($.cookie("isVMOpen") == "1" && $('#vm_box').hasClass('hide')){
		moveVMOverProduct();
		vmTryThemOn();
	}

    var zIndex;
    if(toOpen){
        zIndex = $('.bottom-scrollable-section').css('z-index');
    }

    if(toOpen){
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            //$('.slot3').css('z-index', '1001');
            $(".op-pdp-popup-other-colors").scrollTop(0);
        } else {
            $('.bottom-scrollable-section').css('z-index', '1000');
        }
        hideHeaderTimeout.cancel()
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
            //wcag
            $('.op-pdp-popup-other-colors .product a.product__image-link').on('focus', function(){
                $(this).parents('.product').addClass('classHover');
            }).on('blur', function(){
                $(this).parents('.product').removeClass('classHover');
            });
            managePopupTabIndex(".op-pdp-popup-other-colors", true);
        }
        $(".op-pdp-popup-other-colors").addClass("active");
        $(".op-pdp-popup-other-colors-background").addClass("active");
        $("html").addClass("overflow-hidden");
        $("#page-overflow-wrapper").addClass("overflow-hidden");
        $('.popup-content .product .product--wrapper').on('click', function(){
            $(this).find('a.product__name-link')[0].click();
        })
    } else {
        if(window.mobilecheck() || window.tabletPortraitCheck()){
           // $('.slot3').css('z-index', '3')
        } else{
            zIndex ? $('.bottom-scrollable-section').css('z-index', zIndex) : $('.bottom-scrollable-section').css('z-index', '2');
        }
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            //wcag
            managePopupTabIndex(".op-pdp-popup-other-colors", false);
            $('.op-pdp-popup-other-colors .product a.product__image-link').off('focus');
        }
        hideHeaderTimeout.setup();
        $(".op-pdp-popup-other-colors").removeClass("active");
        $(".op-pdp-popup-other-colors-background").removeClass("active");
        $("html").removeClass("overflow-hidden");
        $("#page-overflow-wrapper").removeClass("overflow-hidden");
        $('.popup-content .product .product--wrapper').off('click');
    }
}

var zIndexP;
var zIndexBMP;
//For other colors popup interactions
function togglePopupCarosel(isOpen) {

    if(isOpen){
        zIndexP = $('#headerWrapper #header').css('z-index');
        zIndexBMP = $('.bottom-scrollable-section').css('z-index');
    }

    if(isOpen){
        hideHeaderTimeout.cancel()
        $("#persol_popup-images-carousel").show();
        $("#persol_popup-images").css('display', 'flex');
        $('#headerWrapper #header').css('z-index', '1');
        $('#headerWrapper #header').hide();
        $('.ct-promo-bannerTop').length > 0 ? $('.ct-promo-bannerTop').hide() : "";
        $('.bottom-scrollable-section').css('z-index', '1');
        $(".owl-pdp__image-wrapper").css('position','unset');
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            pinchZoom()
            manageScrollOverlay(true);
        }
        managePopupTabIndex("#persol_popup-images", true);
    } else {
        hideHeaderTimeout.setup()
        $("#persol_popup-images-carousel").hide();
        $("#persol_popup-images").css('display', 'none');
        $('#headerWrapper #header').css('z-index', zIndexP);
        $('#headerWrapper #header').show();
        $('.ct-promo-bannerTop').length > 0 ? $('.ct-promo-bannerTop').show() : "";
        $('.bottom-scrollable-section').css('z-index', zIndexBMP);
        $(".owl-pdp__image-wrapper").css('position','');
        managePopupTabIndex("#persol_popup-images", false);
    }
}


function initAccessibilityFullImage(){
    //accessibility screen reader
    $('#persol_popup-images-carousel .owl-item').attr('aria-selected','false');
    $('#persol_popup-images-carousel .owl-item.active').attr('aria-selected','true');
    $('#persol_popup-images-carousel .nav-left').attr('aria-label','previous slide').attr('role', 'button').attr('tabindex', '0');
    $('#persol_popup-images-carousel .nav-right').attr('aria-label','next slide').attr('role', 'button').attr('tabindex', '0');
}

function manageAccessibilityFullImage(){
    if(!(window.mobilecheck() || window.tabletPortraitCheck()))
    // apply meta info to next and previous buttons and make them focusable
        $('#persol_popup-images-carousel .owl-item.active .popup_link').attr('tabindex','0');
        $('#persol_popup-images-carousel .owl-item').attr('aria-selected','false');
        $('#persol_popup-images-carousel .owl-item.active').attr('aria-selected','true');
        $('#persol_popup-images-carousel .owl-pagination .owl-page').attr('role','button').attr('tabindex','0');
        $('#persol_popup-images-carousel .owl-pagination .owl-page.active').attr('title','Active Slide')
        $('#persol_popup-images-carousel .owl-pagination .owl-page').on('keydown', function(e){
            if(e.keyCode == 13){
                var slideToGO = parseFloat($(this).children().children('img').attr('data-index'));
                $("#persol_popup-images-carousel").data('owlCarousel').goTo(slideToGO);
                $($('#persol_popup-images-carousel .owl-pagination .owl-page')[slideToGO]).attr('title','Active Slide')
                $($('#persol_popup-images-carousel .owl-pagination .owl-page')[slideToGO]).attr('title','Next Slide');
                $($('#persol_popup-images-carousel .owl-pagination .owl-page')[slideToGO - 2]).attr('title','Prev Slide');
            }

        })
        $('#persol_popup-images-carousel .owl-item').attr('aria-selected','false');
        $('#persol_popup-images-carousel .owl-item.active').attr('aria-selected','true');
}   

function calculateDistances(){

    var timestamp = new Date().getTime() / 1000;
    var diff = timestamp - renderingPageStarterTime;
    console.log('Performance Improvements PDP - #20 - calculateDistances (PO only) - ' + diff.toString().slice(0 , 5) + 's');

    if(window.mobilecheck() || window.tabletPortraitCheck()){
        window.headerHeight = parseInt($('#headerRow1').outerHeight());
        $('.other_colors').outerHeight()
        var heightVisibleElements = $('.defining-attributes-widget').children(':visible');
        window.heightHiddenActions = 1;
        for ( i=0; i < ($('.defining-attributes-widget').children(':visible').length); i++){
            window.heightHiddenActions += parseInt($(heightVisibleElements[i]).outerHeight());
            window.heightHiddenActions += 10;
        }

        window.lastScrollTopMobile = 0;
        animationInit();

        if($('.slot5').length > 0 ) {
            window.productDetailTop = $('.slot5').offset().top  - $('#tab-products-details').height() + window.heightHiddenActions;
            window.endSlider = parseInt($(".slot5").height() + window.productDetailTop) + window.heightHiddenActions;
        }
    }else {
        $('.catalog-entry-recommendation-widget.other_colors').css('position','absolute');
        $('.navbar-placeholder').css('height','0px');
       // $('[data-slot-id="4"]').attr('style', "position: relative; margin-top:" + $('.catalog-entry-recommendation-widget.other_colors').outerHeight() + "px !important"); commented in PDP Resesign_2023
    }
}

function setProductDetailPopup (featuresContainerId) {
    if(window.mobilecheck() || window.tabletPortraitCheck()) {
        $("body").append($("#product-details-popup"));
        $("#product-details-popup").append('<div id="featureMenu"></div>');
        $("#featureMenu").append('<div id = "productDetails" class ="featurePopUp"><div class ="titleFeature">' + capitalizeEachWord($('.title-product-details:first').text()) + '<div></div>');
        $($('.text-content')[0]).appendTo($('#featureMenu #productDetails'));
        $('#productDetails .text-content .product-name').prependTo($('#featureMenu'));
    }else{
    	var sourceImage = $('.imageThumbailPdp').val();
    	if(sourceImage.includes('impolicy=HB_parameters&sclw=0.25&sclh=0.25')){
    		sourceImage = sourceImage.replace('impolicy=HB_parameters&sclw=0.25&sclh=0.25','bg=f7f7f7&impolicy=HB_parameters&wid=2000&cropwest=1000');
    	}else{
    		sourceImage = sourceImage + '?bg=f7f7f7&impolicy=HB_parameters&wid=2000&cropwest=1000';
    	}
    	
    	$("body").append($("<div id= 'product-details-popup-desktop'><div><a class='close-product-details'><span>" + closeMessage + "</span></a></div><div id='featureMenu'><div id='detailImage' class='product-features'></div><div id= 'detailFeatures'></div></div></div>"));
        $("#featureMenu #detailFeatures").append('<div id = "productDetails" class ="featurePopUp"><div class ="titleFeature" feature-number="detailTabImg">' + capitalizeEachWord($('.title-product-details:first').text()) + '<div></div>');
        $('#featureMenu #detailImage').append("<div feature-number='detailTabImg'>" +
				  "<img class='lazy' src='/wcsstore/OliverSAS/images/lazyload.png' data-src = '" + sourceImage + "'>" +
				  "</div>");
        $($('.text-content .accordion-content')[0]).appendTo($('#featureMenu #productDetails'));
        $($('.text-content .product-name')[0]).prependTo($('#featureMenu #detailFeatures'));
    }
    
        //  Populate features
    var allFeature;
    var allFeatureImage;
    if(window.mobilecheck() || window.tabletPortraitCheck()) {
    	var allFeature = document.querySelectorAll(featuresContainerId+' .product-features');
    }else{
    	allFeature = document.querySelectorAll(featuresContainerId+' .product-features .description');
    	allFeatureImage = document.querySelectorAll(featuresContainerId+' .side.left-side');
    } 
    var allNameFeature = document.querySelectorAll(featuresContainerId+' .product-features h3');
        for (var i = 0 ; i < allFeature.length; i++){
        	if(window.mobilecheck() || window.tabletPortraitCheck()) {
        		$("#featureMenu").append('<div id="featureN'+ i + '" class ="featurePopUp"> <div class="titleFeature">' + capitalizeEachWord(allNameFeature[i].getAttribute('data-title')) +'</div></div>' );
        	}else{
        		$("#featureMenu #detailFeatures").append('<div id="featureN'+ i + '" class ="featurePopUp"> <div class="titleFeature" feature-number="' + i +'">' + capitalizeEachWord(allNameFeature[i].getAttribute('data-title')) +'</div></div>' );
        		$("#featureMenu #detailImage [feature-number='detailTabImg']").after('<div feature-number="' + i +'"></div>');
        		$("#featureMenu #detailImage [feature-number=" + i + "]").append(allFeatureImage[i].cloneNode(true));
        	}            
            $("#featureN" + i).append(allFeature[i].cloneNode(true));
            $('#featureN' + i + ' .description-text').after($('#featureN' + i + ' .side.left-side'));
        }
        $('#featureMenu #descAttributeValue_modelMeasurements').text($('#tabAttr #descAttributeValue_modelMeasurements').text())
        if($(".featurePopUp").length > 0){
            $(".featurePopUp").accordion({
                collapsible: true,
                heightStyle: "content",
                activate: function( event, ui ) {
                    if(event.target) {
                        event.target.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
                    }
                    
                }
            });
            $( ".featurePopUp:not(#productDetails)" ).accordion('option', 'active', false);
            $( ".featurePopUp#productDetails" ).accordion('option', 'active', 0);
            $(' .titleFeature').off('click').on('click',function (e) {
                e.preventDefault();
                //  Prevent from closing the first
                
                if ($(this).index(".titleFeature") > 0 && $(this).hasClass('ui-state-active')) {
                    return;
                } else if ($(this).index(".titleFeature") > 0) {
                    $( ".featurePopUp" ).not(this).accordion('option', 'active', false);
                    $($( ".featurePopUp" )[$(this).index(".titleFeature")]).accordion('option', 'active', 0);
                } else {
                    if ($('.featurePopUp#productDetails [aria-expanded="true"]').length == 0) {
                        $( ".featurePopUp" ).not(this).accordion('option', 'active', false);
                        $($( ".featurePopUp" )[$(this).index(" .titleFeature")]).accordion('option', 'active', 0);
                    }
                }
            });
        }

        $(document).off('click',".view-product-details").on('click',".view-product-details",function(){
        	if(window.mobilecheck() || window.tabletPortraitCheck()) {
            	$("#product-details-popup").show();
        		$('body').addClass('no-scroll');
                $('body, html').css('height', '100%');
                $('body, html').css('overflow', 'hidden');
        	}else{
        		$("#product-details-popup-desktop").show();
        		$('body').css('overflow-y','hidden');
        	}
            $('#fixed-top--mobile').removeClass('animation-show');
            manageScrollOverlay(true);
        });
 
        $(document).off('click',".close-product-details").on('click',".close-product-details",function(){
        	if(window.mobilecheck() || window.tabletPortraitCheck()) {
            	$("#product-details-popup").hide();
        		$('body').removeClass('no-scroll');
                $('body, html').css('height', 'auto');
                $('body, html').css('overflow', 'visible');
            	window.scroll(0,$('.defining-attributes-widget').offset().top);
        	}else{
        		$("#product-details-popup-desktop").hide();
        		$('body').css('overflow-y','');
            	window.scroll(0,$('.defining-attributes-widget').offset().top);
        		
        	}
            $('#fixed-top--mobile').addClass('animation-show');
            manageScrollOverlay(false);
        });
        
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
        	$(document).off('click',$('#featureMenu .titleFeature.ui-accordion-header')).on('click',"#featureMenu .titleFeature.ui-accordion-header",function(){
        		$('#featureMenu #detailImage [feature-number]').hide();
        		$('#featureMenu #detailImage [feature-number="' + $(this).attr('feature-number') +'"]').show();
            });
        	//HB-7655
        	try {
	            if(($('#tabAttr #descAttributeValue_modelMeasurements').text() == '' || $('#featureMenu #descAttributeValue_modelMeasurements').text() == '')  && productDisplayJS.changedCatEntryId != null && productParent[0] != null){
	            	updateItemName(productDisplayJS.changedCatEntryId, productParent[0]);
	            }
        	}catch (error) {
            	console.error('error in updateItemName function');
            	console.error(error);
            }
        }else{
        	try {
	            if(($('#tabAttr #descAttributeValue_modelMeasurements').text() == '' || $('#featureMenu #descAttributeValue_modelMeasurements').text() == '')  && productDisplayJS.changedCatEntryId != null && productParent[0] != null){
	            	updateItemName(productDisplayJS.changedCatEntryId, productParent[0]);
	            }
        	}catch (error) {
            	console.error('error in updateItemName function');
            	console.error(error);
            }
        }
        $('.descriptive-attributes-widget:not(#productDetail) #product-details-popup').remove();
}

//	Retrieve Features' Images
function handleProduct(product) {

    $.each($(".product-features img[data-preset]"),function(j,feature) {
        try {
            var featPreset = $(feature).data("preset");
            var featNomencl = JSON.parse($(feature).data("nomencl").replaceAll("'","\""));
            featNomencl[0] = featNomencl[0].replace("_noshad_fr","__001").replace("_noshad_qt","__002");
            
            var urlMustCointains1 = ''; //url with priority 1 or 2 or 3
            var urlMustCointains2 = ''; //url with priority 5
            var urlMustCointains3 = ''; //url with priority 4
            
            if(featNomencl[0] == '__001'){
                urlMustCointains1 = '_shad__fr';
                urlMustCointains2 = '_000A';
                urlMustCointains3 = 'shad_frN';
            }else if(featNomencl[0] == '__002'){
                urlMustCointains1 = '_shad__qt';
                urlMustCointains2 = '030A';
                urlMustCointains3 = '_shad_qtN';
            }else if(featNomencl[0] == '_090A'){
                urlMustCointains1 = '_shad__lt';
                urlMustCointains2 = '_090A';
                urlMustCointains3 = '_shad_ltN';
            }else if(featNomencl[0] == '_180A'){
                urlMustCointains1 = '_shad__bk';
                urlMustCointains2 = '_180A';
                urlMustCointains3 = '_shad_bkN';
            }else if( featNomencl[0] == '_TOP_shad_al20'){
                urlMustCointains1 = '_shad__fld';
                urlMustCointains2 = '';
                urlMustCointains3 = 'shad_fld';
            }
            
            var arrayPriorityNomencl = [];
            var objectPriorityNomencl = {};
            for(var i =0; i < fullList.length; i++){
                if(fullList[i].includes(urlMustCointains1) && urlMustCointains1 != ''){
                    var objectPriorityNomencl = {};
                    if(fullList[i].includes('VIP')){
                        objectPriorityNomencl['priority'] = '1';
                        objectPriorityNomencl['urlImage'] = fullList[i];
                    }else if(fullList[i].includes('P21')){
                        objectPriorityNomencl['priority'] = '2';
                        objectPriorityNomencl['urlImage'] = fullList[i];
                    }else if(fullList[i].includes('STD')){
                        objectPriorityNomencl['priority'] = '3';
                        objectPriorityNomencl['urlImage'] = fullList[i];
                    }else if(fullList[i].includes('TOP')){
                        objectPriorityNomencl['priority'] = '4';
                        objectPriorityNomencl['urlImage'] = fullList[i];
                    }
                    arrayPriorityNomencl[arrayPriorityNomencl.length] = objectPriorityNomencl;
                }else if(fullList[i].includes(urlMustCointains2) && urlMustCointains2 != ''){
                    var objectPriorityNomencl = {};
                    objectPriorityNomencl['priority'] = '5';
                    objectPriorityNomencl['urlImage'] = fullList[i];
                    arrayPriorityNomencl[arrayPriorityNomencl.length] = objectPriorityNomencl;
                }else if(fullList[i].includes(urlMustCointains3) && urlMustCointains3 != ''){
                    var objectPriorityNomencl = {};
                    objectPriorityNomencl['priority'] = '4';
                    objectPriorityNomencl['urlImage'] = fullList[i];
                    arrayPriorityNomencl[arrayPriorityNomencl.length] = objectPriorityNomencl;
                }
            }
            if(arrayPriorityNomencl.length == 1){
                urlFeature= arrayPriorityNomencl[0]['urlImage'] + '?' +featPreset;
            }else{
                var tmp = arrayPriorityNomencl.map(function(o) {return o.priority;});
                urlFeature = arrayPriorityNomencl[tmp.indexOf(Math.min.apply(Math, tmp) + '')]['urlImage'] + '?' + featPreset;
            }
            
            $(feature).attr("data-src",urlFeature).attr("alt",$(feature).parent().parent().find(".description h3").text()).removeAttr("data-nomencl").removeAttr("data-preset");
        } catch (e) {
            console.error("Error in parsing featNomencl for "+productPartNumber,e);
        }
    });

};




//for size section
$(".info-icon.size:not(.mobile)").mouseenter(
    function(){
        $(this).addClass("onHover");
        $(".infoMessage_popup.size:not(.mobile)").addClass("readable");
    }
).mouseleave(
    function(){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.size:not(.mobile)").removeClass("readable");
    }
).click(function(){
    $(this).removeClass("onHover");
    $(".infoMessage_popup.size:not(.mobile)").removeClass("readable");
    
});

//for size mobile
$(".info-icon.size.mobile").on("click",function(){
    if( $(this).hasClass("onHover") ){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.size.mobile").removeClass("readable");
    }else{
        $(this).addClass("onHover");
        $(".infoMessage_popup.size.mobile").addClass("readable");
    }
});


//for monogram section
$(".info-icon.monogram:not(.mobile)").mouseenter(
    function(){
        $(this).addClass("onHover");
        $(".infoMessage_popup.monogram:not(.mobile)").addClass("readable");
    }
).mouseleave(
    function(){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.monogram:not(.mobile)").removeClass("readable");
    }
).click(function(){
    $(this).removeClass("onHover");
    $(".infoMessage_popup.monogram:not(.mobile)").removeClass("readable");
});

//for monogram mobile
$(".info-icon.monogram.mobile").on("click",function(){
    if( $(this).hasClass("onHover") ){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.mobile.monogram").removeClass("readable");
    }else{
        $(this).addClass("onHover");
        $(".infoMessage_popup.mobile.monogram").addClass("readable");
    }
});

//for prescription section
$(".info-icon.prescription:not(.mobile)").mouseenter(
    function(){
        $(this).addClass("onHover");
        $(".infoMessage_popup.prescription:not(.mobile)").addClass("readable");
    }
).mouseleave(
    function(){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.prescription:not(.mobile)").removeClass("readable");
    }
).click(function(){
    $(this).removeClass("onHover");
    $(".infoMessage_popup.prescription:not(.mobile)").removeClass("readable");
});

//for prescription mobile
$(".info-icon.prescription.mobile").on("click",function(){
        if( $(this).hasClass("onHover") ){
            $(this).removeClass("onHover");
            $(".containerInfo").hide();
            $(".infoMessage_popup.mobile.prescription").removeClass("readable");
        }else{
            $(this).addClass("onHover");
            $(".containerInfo").show();
            $(".infoMessage_popup.mobile.prescription").addClass("readable");
        }
});


//for sun clip desk 
$(".info-icon.sun-clip:not(.mobile)").mouseenter(
    function(){
        $(this).addClass("onHover");
        $(".infoMessage_popup.sun-clip:not(.mobile)").addClass("readable");
    }
).mouseleave(
    function(){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.sun-clip:not(.mobile)").removeClass("readable");
    }
).click(function(){
    
    $(this).removeClass("onHover");
    $(".infoMessage_popup.sun-clip:not(.mobile)").removeClass("readable");

});

//for add sun clip mobile
$(".info-icon.sun-clip.mobile").on("click",function(){
    if( $(this).hasClass("onHover") ){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.sun-clip.mobile").removeClass("readable"); //without mobile to hide the message at click also when is on desktop
    }else{
        $(this).addClass("onHover");
        $(".infoMessage_popup.sun-clip.mobile").addClass("readable");
    }
});


//hide the infomessage popup for mobile
$(document).on("click", function (event) {
        // If the target is not the container or a child of the container, then process
        // the click event for outside of the container.
        if ($(event.target).closest("span.info-icon.mobile").length === 0) {
            $("span.info-icon.mobile").removeClass("onHover");
            $(".infoMessage_popup").removeClass("readable");
            //console.log("You clicked outside of the container element");
        }
  });

/*start store-pdp-clipon.js
* this file was created for PDP_W2 Project
*/


/*
 * add to fade for clipon function to close popup
 */
$('.fade-clipon').on("click",function() {
	unfreezeWindowForOverlay($(this).attr('class'));
	$('#popup-clipon-section').hide();
});


/*
 * Function to open clipon popup
 */
function openPopupClipon(){
	$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+$('#popup-clipon-section .product-clip-on.selected').attr('catentryclip')+'] .slick-dots li').first().children().click();
	$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+$('#popup-clipon-section .product-clip-on.selected').attr('catentryclip')+'] .currentNumber').text('1');
	freezeWindowForOverlay();
	$('#popup-clipon-section').show();
	$("#popup-clipon-section .container-info-clipon").scrollTop(0);
	$('#popup-clipon-section .clipon-main-carousel').slick('refresh');
}


/*
 * function to manage and initialize popup and below clipon section
 */
function manageCliponSection(){
	
	for(var i = 0; i < $('.options_dropdown_column input').not('.modelSizeAttribute').length; i++){
		var frameSize =  $($('.options_dropdown_column input').not('.modelSizeAttribute')[i]).attr('value-en') + '|' + $($('.options_dropdown_column input').not('.modelSizeAttribute')[i]).attr('modelSizeAttribute');
		mapSizeFrameClip[frameSize] =  {};
	}
	
	var clipCatentry = [];
	
	for( var i = 0; i < clipOnAssoc.length; i++){
		/*
		 * With this For loop we enhance the json Object arrayOfClip
		 * with the data we have in clipOnAssoc (this variable is enhance PDP_Accessories.jsp)
		 */
		var frontColorValueClip = "";
		var lensColorValueClip = "";
		var isPolarizedClip = false;
		var modelNameValueClip = "";
		var madeInValueClip = "";
		var isLimitedEditionClip = false;
		var isExclusiveClip = false;
		var isNewReleaseClip = false;
		var isPreorderable = false;
		
		var jsonOfClip = clipOnAssoc[i]; 
		var catentryProductBean = jsonOfClip.uniqueID;
		clipCatentry.push(jsonOfClip.uniqueID);
		
		for( var j = 0; j < jsonOfClip.attributes.length; j++){
			if(jsonOfClip.attributes[j].identifier === 'MODELNAME' && jsonOfClip.attributes[j].usage === 'Descriptive' ) modelNameValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'FRONT_COLOR' && jsonOfClip.attributes[j].usage === 'Descriptive' )
            	frontColorValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'LENS_COLOR' && jsonOfClip.attributes[j].usage === 'Descriptive' ) lensColorValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'MADEIN' && jsonOfClip.attributes[j].usage === 'Descriptive' ) madeInValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'LIMITED_EDITION' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isLimitedEditionClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
            if(jsonOfClip.attributes[j].identifier === 'EXCLUSIVE' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isExclusiveClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
            if(jsonOfClip.attributes[j].identifier === 'NEWRELEASES' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isNewReleaseClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
            if(jsonOfClip.attributes[j].identifier === 'POLARIZED' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isPolarizedClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
			if(isPreOrderActive && jsonOfClip.attributes[j].identifier === 'PREORDER' && jsonOfClip.attributes[j].usage === 'Descriptive' )  isPreorderable = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
		}  
		
		var skus = {};
		for( var j = 0; j < jsonOfClip.sKUs.length; j++){
			skus[jsonOfClip.sKUs[j].uniqueID] = {};
			clipCatentry.push(jsonOfClip.sKUs[j].uniqueID);
		}
		
		var currentClipon = {
			baseUrl: WCParamJS.homePageURL,
			uniqueID: catentryProductBean,
			partnumber: jsonOfClip.partNumber.replaceAll('_','-'),
			thumbnail: jsonOfClip.thumbnail.split('?')[0],
		    modelName: modelNameValueClip,
		    madeIn: madeInValueClip,
		    isNewRelease: isNewReleaseClip,
		    isExclusive: isExclusiveClip,
		    isLimited: isLimitedEditionClip,
		    isPolarized: isPolarizedClip,
		    frontColor_lensColor: frontColorValueClip + " / " +lensColorValueClip,
			skus: skus,
			isPreorderable : isPreorderable
		}
		
		arrayOfClip[catentryProductBean] = currentClipon;
	
	}
	
	
	var urlNew = (isInToolkit ? '' : WCParamJS.homePageURL) + '/search/resources/store/' + WCParamJS.storeId + '/productview/byIds?' + 'id=' + clipCatentry.join('&id=') + "&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&responseFormat=json&langId=" + WCParamJS.langId + "&currency=" + WCParamJS.commandContextCurrency + (isPersol && window.customerSegment != undefined ? '&customerSegment=' + customerSegment : '')  + "&profileName=LUX_findProductByIds_Inventory&isForClip=true&isForInventory=true";
	var carouselOfClip = {};
	var htmlForOtherColors = {};
	
	promiseForClip(urlNew).then(function (data) {
		data.catalogEntryView.forEach(function(catentryIndex){
    		/* In this forEach we take:
    		 * Price for every itemBean 
    		 * Ranking for all products
    		 * Manifest for all Product Bean
    		 */
			try{
				if(catentryIndex.catalogEntryTypeCode === 'ProductBean'){
	    			if(catentryIndex.inventory.ranking != 2){
	    				delete arrayOfClip[catentryIndex.uniqueID];
	    			}else{
	    				var imageForCarouselClipon = [];
	    				var htmlForCarousel = '<div class="container-carousel-and-arrow" catentryClip="' + catentryIndex.uniqueID +'"><div class="clipon-main-carousel carousel-clip_' + catentryIndex.uniqueID +'" catentryClip="' + catentryIndex.uniqueID +'">'
	    				catentryIndex.manifest.payload.images.forEach(function(imageCarouselClipon){
	    					if( imageCarouselClipon.usage == "PDP Carousel"){
	    						imageForCarouselClipon.push(imageCarouselClipon);
	    						htmlForCarousel = htmlForCarousel + '<img class = "lazy" src="'+ lazyLoadImg +'" data-src="'+ imageCarouselClipon.path +'" alt="image of clipon">';
	    					}
	    					
	    				});
	    				htmlForCarousel = htmlForCarousel + '</div><div class="container-clipon-control-and-counter" role="region"><div class="container-control-clipon"><div class="control-clipon slick-controls-clipon_'+catentryIndex.uniqueID+'"></div></div><div class="slick-slider-number slick__'+catentryIndex.uniqueID+'"><span class="currentNumber"></span><span class="divider">/</span><span class="totalNumber"></span></div></div></div>';
	    				
	    				carouselOfClip[catentryIndex.uniqueID] = htmlForCarousel;
	    				arrayOfClip[catentryIndex.uniqueID]['manifest'] = imageForCarouselClipon;
	    				
	    				var templateOtherColorsHtml = $('#otherColorsClipTemplate').html();
	    				htmlForOtherColors[catentryIndex.uniqueID] =  Mustache.to_html(templateOtherColorsHtml, arrayOfClip[catentryIndex.uniqueID]);
	    			}
	    		}else{
	    			if(catentryIndex.inventory.ranking != 2){
	    				delete arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID];
	    			}else{
	    				var listpriceClip;
	    				if(isOliver){
	    					arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['price'] = WCCurrencyJS.format(catentryIndex.price.price, {"truncDecimals":"true"});
	    					catentryIndex.price.price == catentryIndex.price.listprice ? listpriceClip =  '' : listpriceClip = WCCurrencyJS.format( catentryIndex.price.listprice, {"truncDecimals":"true"});
	    				} else {
	    					arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['price'] = WCCurrencyJS.format(catentryIndex.price.price);
	    					catentryIndex.price.price == catentryIndex.price.listprice ? listpriceClip =  '' : listpriceClip = WCCurrencyJS.format( catentryIndex.price.listprice);
	    				}
	    				
	    				arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['priceForKlarna'] = formatCurrency(catentryIndex.price.price.split('.')[0]).replace('.','');
	    				arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['listprice'] = listpriceClip;
	    				arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['partnumber'] = catentryIndex.partNumber;
	    				
	    				catentryIndex.attributes.forEach(function(attribute){
	    					if(attribute.identifier == 'MODEL_SIZE') arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size'] = attribute.values[0].value;
	    					if(attribute.identifier == 'MODEL_SIZE_DISPLAY' ) arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size_display'] = attribute.values[0].value;
	    				});
	    				
	    				var clipSize = arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size_display'] + '|' + arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size']
	    				if(mapSizeFrameClip[clipSize] != undefined){
	    					mapSizeFrameClip[clipSize][catentryIndex.parentCatalogEntryID] = catentryIndex.uniqueID;
	    				}else{
	    					delete arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID];
	    				}
	    			}
	    		}
			}catch(err) {
				console.log(err.message);
			}
    	});   	
    	
    	/* Inizialize the clipon section (Popup and Below section) 
         */
		

    	var templateBarHtml = null;
		if(window.mobilecheck() || window.tabletPortraitCheck()){
			templateBarHtml = $('#cliponSectionTemplateMobile').html();
		}else{
			templateBarHtml = $('#cliponSectionTemplateDesktop').html();
		}
    	//Initialize template with the first clip with the size selected
    	var sizeSelectedOfFrame = $('.size-option.selected').attr('data-option') + '|' + $('.size-option.selected').attr('model-size');
    	var catentryMocoClipSelected = null; // = Object.keys(mapSizeFrameClip[sizeSelectedOfFrame])[0];
    	var catentryUPCClipSelected = null;// = mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(mapSizeFrameClip[sizeSelectedOfFrame])[0]]
    	var existOneClipOn = false;
    	for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
    		if(mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]] != undefined){
    			catentryMocoClipSelected = Object.keys(arrayOfClip)[i];
    			catentryUPCClipSelected = mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]];
    			break;
    		}
    	}
		//Check if almost one size have one clip-on
    	for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
			if(JSON.stringify(mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]]) != undefined && JSON.stringify(mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]])  !=  '{}'){
				existOneClipOn = true;
				break;
			}
		}

    	if(catentryMocoClipSelected == null ){
    		for(var i = 0; i< Object.keys(mapSizeFrameClip).length; i++){
    			if(catentryMocoClipSelected == null ){
    				for(var j = 0; j< Object.keys(arrayOfClip).length; j++){
    					if(mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]][Object.keys(arrayOfClip)[j]] != undefined){
    						catentryMocoClipSelected = Object.keys(arrayOfClip)[j];
    						catentryUPCClipSelected = mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]][Object.keys(arrayOfClip)[j]];
    						break;
    					}
    				}
    			}else{
    				break;
    			}
    		}
    		if(existOneClipOn){
				//BEGIN FIX HB-13132
				$('.clip-not-avaible').show();
				$('#accessory--underlined--link').addClass('cursor-not-allow');
				$('.accessory--underlined--link--name').addClass('cursor-not-allow');
				$('.accessory--underlined--link--icon').addClass('cursor-not-allow');
				$('.accessory--side--button--link').addClass('cursor-not-allow');
				var typeOfText = null;
				if(WCParamJS.langId == '-1'){
					typeOfText = 'small-text';
				}else{
					typeOfText = 'text-two-row';
				}
				$('#accessory--button-container').addClass(typeOfText);
				$('#accessory--side--button').addClass(typeOfText);
				$('#accessory--underlined--link').addClass(typeOfText);
				$('.clip-not-avaible').addClass(typeOfText);
				if(isOliver && !(window.tabletPortraitCheck() || window.mobilecheck())){
					$('#op-pdp__slot8').addClass(typeOfText);
				}else if(isPersol){
					$('#pdp_bottom-section').addClass(typeOfText);
					$('.monogram-value-container').addClass(typeOfText);
				}
				//END FIX HB-13132
			}else{
				$('#accessory--button-container').hide();
				$('#below-clipon-section').hide();
			}
    		
    	}
    	
    	var firstClip = JSON.parse(JSON.stringify(arrayOfClip[catentryMocoClipSelected]));
    	firstClip['price'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].price;
    	firstClip['listPrice'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].listprice;
    	firstClip['priceForKlarna'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].priceForKlarna;
    	firstClip['skuPartnumber'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].partnumber;
    	
		html = Mustache.to_html(templateBarHtml, firstClip);
		$('#below-clipon-section').append(html);
		$('#popup-clipon-section').append(html);
		$('#current-clipon-catentry').attr('value', catentryUPCClipSelected);
		
		$('.size-clipon').text($('.size-option-selected .hinge-distance').text());
		$('#below-clipon-section .container-clipon-badge').find("p:visible:last").addClass('last-showed');
		$('#popup-clipon-section .container-clipon-badge.madein-section p.showed:last-child').addClass('last-showed');
		$('#popup-clipon-section .container-clipon-badge').not('.madein-section').find('p.showed:last').addClass('last-showed');
		/*
		 * Add Function at close image in popup
		 */
		$('.close-image').on('click', function() {
			unfreezeWindowForOverlay($('.fade-clipon').attr('class'));
			$('#popup-clipon-section').hide();
		});
		
		var tileToHide = [];
		
		for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
			
			/*
			 * For each element in arrayOfClip we must create the carousel. this is the scope of this for Loop
			 */
			
			$('.container-image-clipon').append(carouselOfClip[Object.keys(arrayOfClip)[i]]);
			$('.clipon-other-colors').append(htmlForOtherColors[Object.keys(arrayOfClip)[i]]);
			
			/*
			 * Add an event listener in slick clip's main carousel:
			 * when change the the image of carousel the counter of image increase
			 */
			
			$('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('init', function(event, slick) {
			    $('#below-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		        $('#below-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .totalNumber').text(slick.slideCount);
		    });
			
			$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('init', function(event, slick) {
			    $('#popup-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		        $('#popup-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .totalNumber').text(slick.slideCount);
		    });
			
			
			/*
			 * we inizialize for each clip the slick carousel in popup and below section
			 */
			
			$('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').slick({
	    		infinite: true,
	    	    slidesToShow: 1,
	    	    slidesToScroll: 1,
	    	    speed: 200,
	    	    dots: true,
	    	    appendArrows: $('#below-clipon-section .slick-controls-clipon_'+Object.keys(arrayOfClip)[i])
	    	});
			
			$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').slick({
	    		infinite: true,
	    	    slidesToShow: 1,
	    	    slidesToScroll: 1,
	    	    speed: 200,
	    	    dots: true,
	    	    appendArrows: $('#popup-clipon-section .slick-controls-clipon_'+Object.keys(arrayOfClip)[i])
	    	});
			
			if(mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]] == undefined){
				tileToHide.push(Object.keys(arrayOfClip)[i]);
			}
			
			$('.container-carousel-and-arrow:not([catentryClip='+catentryMocoClipSelected+'])').hide();
			$('.container-carousel-and-arrow[catentryClip='+catentryMocoClipSelected+']').show();
			$('.container-carousel-and-arrow[catentryClip='+catentryMocoClipSelected+'] .clipon-main-carousel').slick('refresh');
			if((window.tabletPortraitCheck() || window.mobilecheck()) && isOliver){
				reduceCircleCarouselClip('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryMocoClipSelected+'] .clipon-main-carousel .slick-dots');
			}
			
			/*
			 * Add an event listener in slick clip's main carousel:
			 * when change the the image of carousel the counter of image increase
			 */
			
			$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('afterChange', function(event, slick) {
		    	
		    	if((window.tabletPortraitCheck() || window.mobilecheck()) && isOliver){
		    		reduceCircleCarouselClip(this);
		    	}else{
		    		$('#popup-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		    	}
			});
			
		    $('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('afterChange', function(event, slick) {
		    	if((window.tabletPortraitCheck() || window.mobilecheck()) && isOliver){
		    		reduceCircleCarouselClip(this);
		    	}else{
		    		$('#below-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		    	}
		    });
		    
		    /*if(window.tabletPortraitCheck() || window.mobilecheck()){
		    	$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('beforeChange', function(event, slick) {
			    	$('#current-clipon-catentry').attr('popupLastChangedCarousel',$($(this).find('.slick-dots')).children('.slick-active').index());
				});
				
			    $('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('beforeChange', function(event, slick) {
			    	$('#current-clipon-catentry').attr('belowLastChangedCarousel',$($(this).find('.slick-dots')).children('.slick-active').index());
			    });
		    }*/
		}
		$('.product-clip-on[catentryclip="'+catentryMocoClipSelected+'"]').addClass('selected');
		
    	for(var i = 0; i < tileToHide.length; i++ ){
    		$('.product-clip-on[catentryclip=' +tileToHide[i] + ']').addClass('hidden');	
    	}
    	
    	/*
    	 * Referesh Klarna message for the price
    	 */
    	window.Klarna.OnsiteMessaging.refresh();
    	
    	/*
    	 * Function to switch CliponInformation
    	 */
    	$('.product-clip-on').on('click', function(){
    		var catentryId = $(this).attr('catentryClip');
    		var catentryIdChild  = null, selectedClipPrice  = null, selectedClipPriceList  = null, selectedClipPriceKlarna, selectedPartnumber = null;
    		var frameModelSizeDisplay = $('.size-option.selected').attr('data-option');
    		var frameModelSize = $('.size-option.selected').attr('model-size');
    		for(var i = 0; i< Object.keys(arrayOfClip[catentryId].skus).length; i++){
    			catentryIdChild = Object.keys(arrayOfClip[catentryId].skus)[i];
    			if(arrayOfClip[catentryId].skus[catentryIdChild].model_size_display == frameModelSizeDisplay && arrayOfClip[catentryId].skus[catentryIdChild].model_size == frameModelSize ){
    				selectedClipPrice = arrayOfClip[catentryId].skus[catentryIdChild].price;
    				selectedClipPriceList = arrayOfClip[catentryId].skus[catentryIdChild].listprice;
    				selectedClipPriceKlarna = arrayOfClip[catentryId].skus[catentryIdChild].priceForKlarna;
    				selectedPartnumber = arrayOfClip[catentryId].skus[catentryIdChild].partnumber;
    				break;
    			}else{
    				catentryIdChild = null;
    			}
    		}
    		if($(this).parents().hasClass('popup-class')){
    			$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .slick-dots li').first().children().click();
    			$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .currentNumber').text('1');
    		}else if($(this).parents().hasClass('below-class')){
    			$('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .slick-dots li').first().children().click();
    			$('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .currentNumber').text('1');
    		}
    		
    		//change item selected and Change Main Info of Clip
    		$('.product-clip-on').removeClass('selected');
    		$('.product-clip-on[catentryClip='+catentryId+']').addClass('selected');
    		$('.container-carousel-and-arrow:not([catentryClip='+catentryId+'])').hide();
    		$('.container-carousel-and-arrow[catentryClip='+catentryId+']').show();
    		$('.container-carousel-and-arrow[catentryClip='+catentryId+'] .clipon-main-carousel').slick('refresh');
    		$('.clipon-name').text(arrayOfClip[catentryId].modelName);
			$('.color-clipon-text').text(arrayOfClip[catentryId].frontColor_lensColor);
			
			//change link in viewdetails
			$('.clipon-view-details a').attr('href', WCParamJS.homePageURL + '/' + arrayOfClip[catentryId].partnumber)
			
			//show - hide badge of current clipon
			arrayOfClip[catentryId].isPolarized == true ? $('p.badge-text-polarized').addClass('showed') : $('p.badge-text-polarized').removeClass('showed');
			arrayOfClip[catentryId].isLimited == true ? $('p.limited-edition').addClass('showed') : $('p.limited-edition').removeClass('showed');
			arrayOfClip[catentryId].isNewRelease == true ? $('p.new-badge').addClass('showed'): $('p.new-badge').removeClass('showed');
			arrayOfClip[catentryId].isExclusive == true ? $('p.exclusive').addClass('showed') : $('p.exclusive').removeClass('showed');	
			if(arrayOfClip[catentryId].madeIn != ''){
				$('p.made-in-badge').addClass('showed');
				$('p.made-in-badge .made-in-state').text(arrayOfClip[catentryId].madeIn);
			}else{
				$('p.made-in-badge').removeClass('showed');
				$('p.made-in-badge .made-in-state').text('');
			}
			$('.container-clipon-badge>p.last-showed').removeClass('last-showed');
			$('#below-clipon-section .container-clipon-badge').find("p:visible:last").addClass('last-showed');
			$('#popup-clipon-section .container-clipon-badge.madein-section p.showed:last-child').addClass('last-showed');
			$('#popup-clipon-section .container-clipon-badge').not('.madein-section').find('p.showed:last').addClass('last-showed');
			
			
			//Change info Price
			$('.clipon-offer-price').text(selectedClipPrice);
			$('.clipon-list-price').text(selectedClipPriceList!= '' ? selectedClipPriceList : '' );
			$('.container-clip-on [data-element-id="X_X_Prod_KlarnaInfo"] [data-key="credit-promotion-auto-size"]').attr('data-purchase-amount', selectedClipPriceKlarna);
			window.Klarna.OnsiteMessaging.refresh();
			
			//Change clip to add in cart
			$('#current-clipon-catentry').attr('value', catentryIdChild);
			
			//change data-description for Tealium 
			$('.addCart').attr('data-description',selectedPartnumber);
			
			if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
				reduceCircleCarouselClip('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .clipon-main-carousel .slick-dots');
				reduceCircleCarouselClip('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .clipon-main-carousel .slick-dots');
			}
    	});
	});
	
}

/*
 * this function is called in button of clipon sections add to cart 
 * */
function cliponAddToBag(){
	
	if (isPersol && currentProductIsMonogram) {
        cleanFieldsMonogram();
        $('.shopperActions--monogram--new, #contentWrapper.pageContent .estimated .estimated-monogram').removeClass('show');
        $('.shopperActions--monogram--added, #contentWrapper.pageContent .estimated .estimated-normal').removeClass('show');
        currentProductIsMonogram = false;
    }
	
	if ($('#popup-clipon-section').is(":visible")){
		unfreezeWindowForOverlay($('.fade-clipon').attr('class'));
		$('#popup-clipon-section').hide();
	}
	
	lockShoppingBagIcon();
    setCurrentId("add2CartBtn");
    resetRequest();
    if( $('#page').hasClass('pdp') && (brandCode == 'PO' || brandCode == 'OP')){
    	//close VM if is opened
    	if (!($('#vm_box').hasClass('hide'))){
    		if (typeof vmSwitchOff === 'function') {
    	    	vmSwitchOff(true);
    	    }
    	}
        hideHeaderTimeout.cancel();
        if((window.mobilecheck() || window.tabletPortraitCheck())){
           changeHeaderIndex(true)
        }
    }
	
    $('#current-clipon-catentry').attr('isAdded','true');
	productDisplayJS.AddItem2ShopCartAjax($('#current-clipon-catentry').attr('value'), '1',undefined, $('#current-clipon-catentry').attr('value'));
	productPageAdd2Cart();
}

function promiseForClip(callUrl) {
	return new Promise((resolve, reject) => {
		$.ajax({
	    	url: callUrl,
	    	type: 'GET',
	        async: true,
	    	success: function (data) {
	    		resolve(data)
	    	},
	    	error: function (error) {
	    		reject(error)
	    	},
	    })
	});
}

function changeSizeOfClip(){
	var sizeSelectedOfFrame = $('.size-option.selected').attr('data-option') + '|' + $('.size-option.selected').attr('model-size');
	var currentClipon = $('.product-clip-on.selected').attr('catentryclip');
	
	$('.size-clipon').text($('.size-option-selected .hinge-distance').text());
	if(mapSizeFrameClip[sizeSelectedOfFrame][currentClipon] != undefined){
		$('#current-clipon-catentry').attr('value', mapSizeFrameClip[sizeSelectedOfFrame][currentClipon]);
		$('.addCart').attr('data-description', arrayOfClip[currentClipon]['skus'][mapSizeFrameClip[sizeSelectedOfFrame][currentClipon]]['partnumber']);		
	}else{
		$('.product-clip-on.selected').removeClass('selected');
	}
	
	//BEGIN FIX HB-13132
	if(Object.keys(mapSizeFrameClip[sizeSelectedOfFrame]).length == 0 && $('#accessory--button-container').is(":visible")){
		$('.clip-not-avaible').show(); 
		$('#accessory--underlined--link').addClass('cursor-not-allow');
		$('.accessory--underlined--link--name').addClass('cursor-not-allow');
		$('.accessory--underlined--link--icon').addClass('cursor-not-allow');
		$('.accessory--side--button--link').addClass('cursor-not-allow');  
		$('#below-clipon-section').hide();
		var typeOfText = null;
		if(WCParamJS.langId == '-1'){
			typeOfText = 'small-text';
		}else{
			typeOfText = 'text-two-row';
		}
		$('#accessory--button-container').addClass(typeOfText);
		$('#accessory--side--button').addClass(typeOfText);
		$('#accessory--underlined--link').addClass(typeOfText);
		$('.clip-not-avaible').addClass(typeOfText);
		if(isOliver && !(window.tabletPortraitCheck() || window.mobilecheck())){
			$('#op-pdp__slot8').addClass(typeOfText);
		}else if(isPersol){
			$('#pdp_bottom-section').addClass(typeOfText);
			$('.monogram-value-container').addClass(typeOfText);
		}
	}else if(Object.keys(mapSizeFrameClip[sizeSelectedOfFrame]).length > 0 && $('.clip-not-avaible').is(":visible")){
		$('.clip-not-avaible').hide();
		//BEGIN FIX HB-13132
		$('#accessory--underlined--link').removeClass('cursor-not-allow');
		$('.accessory--underlined--link--name').removeClass('cursor-not-allow');
		$('.accessory--underlined--link--icon').removeClass('cursor-not-allow');
		$('.accessory--side--button--link').removeClass('cursor-not-allow');
		$('#below-clipon-section').show();
	    $('#accessory--button-container').show();
	    var typeOfText = null;
		if(WCParamJS.langId == '-1'){
			typeOfText = 'small-text';
		}else{
			typeOfText = 'text-two-row';
		}
		$('#accessory--button-container').removeClass(typeOfText);
		$('#accessory--side--button').removeClass(typeOfText);
		$('#accessory--underlined--link').removeClass(typeOfText);
		$('.clip-not-avaible').removeClass(typeOfText);
		if(isOliver){
			$('#op-pdp__slot8').removeClass(typeOfText);
		}else if(isPersol){
			$('#pdp_bottom-section').removeClass(typeOfText);
			$('.monogram-value-container').removeClass(typeOfText);
		}
		//END FIX HB-13132
	}
	//END FIX HB-13132
	for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
		if(mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]] != undefined){
			$('.product-clip-on[catentryclip=' + Object.keys(arrayOfClip)[i] + ']').removeClass('hidden');
			if($('.product-clip-on.selected').length == 0){
				$('.product-clip-on[catentryclip="'+ Object.keys(arrayOfClip)[i] +'"]').click();
			}
		}else{
			$('.product-clip-on[catentryclip=' + Object.keys(arrayOfClip)[i] + ']').addClass('hidden');
		}		
	}
	
}

function showCTAloaderClip(){
	$('.container-clip-on .addCart .bag-icon').hide();
    $('.container-clip-on .addCart .loadpanel_loader').css("display","inline-block");

}

function hideCTAloaderClip(){
	$('.container-clip-on .addCart .bag-icon').show();
    $('.container-clip-on .addCart .loadpanel_loader').hide();

}

function reduceCircleCarouselClip(carousel){
	if((window.mobilecheck() || window.tabletPortraitCheck()) && isOliver){
		var dots = $(carousel).find('li');
	    dots.show();
	    
	    dots.removeClass("semi-reduced").removeClass("normal");
	    var indexActive =  $(carousel).find('li.slick-active').index();
	    
	    if(indexActive < 3){
	    	dots.eq(0).addClass("normal");
	        dots.eq(1).addClass("normal");
	        dots.eq(2).addClass("normal");
	        dots.eq(3).addClass("semi-reduced");

	        //when at the beginning of the carousel show only 5 dots
	        for (i = 5; i < dots.length; i++){
	        	dots.eq(i).hide();
	        }
	    } else {
	    	if(indexActive === dots.length - 1){
	            //when at the end of the carousel show only 5 dots
		        for (i = dots.length - 5; i > 0; i--){
		        	dots.eq(i).hide();
		        }
	    	}else if(indexActive === dots.length - 2){
	            //before the end of the carousel show 6 dots
	              for (i = dots.length - 6; i > 0; i--){
	                dots.eq(i).hide();
	              }
	    	}else if (indexActive === 3) {
	            //when at the fourth position show only 5 dots
	    		for (i = 6; i < dots.length; i++){
	              dots.eq(i).hide();
	            }
	    	} else if (indexActive > 3){

	        	for (i = indexActive + 3; i < dots.length; i++){
	            	dots.eq(i).hide();
	        	}

	            for (i = indexActive - 5; i >= 0; i--){
	            	dots.eq(i).hide();
	            }

	    	}

	        dots.eq(indexActive + 1).addClass("semi-reduced");
	        dots.eq(indexActive - 1).addClass("normal");
	        dots.eq(indexActive - 2).addClass("normal");
	        dots.eq(indexActive - 3).addClass("semi-reduced");

	    }

	}
}
//end store-pdp-clipon.js
var badgeVisible = true;

if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(target, firstSource) {
        'use strict';
        if (target === undefined || target === null) {
          throw new TypeError('Cannot convert first argument to object');
        }

        var to = Object(target);
        for (var i = 1; i < arguments.length; i++) {
          var nextSource = arguments[i];
          if (nextSource === undefined || nextSource === null) {
            continue;
          }
          nextSource = Object(nextSource);

          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
        return to;
      }
    });
  }

// Global variables
var defaultSearchProfile = getUrlParameter('searchTerm') ? 'LUX_findProductsBySearchTerm' : 'LUX_findProductsByCategory_group';
var countSelectedFacets = 0, defaultOrderBy, selectedFacetsData = {}, selectedFacets = {}, originalHrefApply = '', previousFilter = {}, originalSelectedSort = "";
var tileIndex = 0;
var indexSearchPanel = 0;

//Filter & OrderBy variables
var queryFilters = [],
    queryOrderBy = [],
    emptyFilters = true,
    emptyOrderBy = true,
    numMaxofPages,
    index,
    isFacetApplied = false;

queryParams = {
    storeId: WCParamJS.storeId,
    catalogId: WCParamJS.catalogId,
    responseFormat: 'json',
    langId: WCParamJS.langId,
    currency: WCParamJS.commandContextCurrency,
    profileName: defaultSearchProfile,
    searchSource: 'E',
    isForPLP: true
};

var featuredProductHtml = "";

/* BEGIN - Workarounds for IE */
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position)
          || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}
(function() {
	  function remove() { this.parentNode && this.parentNode.removeChild(this); }
	  if (!Element.prototype.remove) Element.prototype.remove = remove;
	  if (Text && !Text.prototype.remove) Text.prototype.remove = remove;
	})();
/* END - Workarounds for IE */
columnsToShow = 4
//	Skeleton Loader variables
var $plpSearchObj = {};
$plpSearchObj.itemsPerPage = 0;		// infinite scroll page(group) size
$plpSearchObj.itemsFromServer = 0;	// how many to get from API
$plpSearchObj.viewIndex = 0;		// index of items to show in view
$plpSearchObj.lastIndex = 0;
$plpSearchObj.resultCount = 0;
$plpSearchObj.viewMoreClicked = false;
$plpSearchObj.viewMoreSearchCount = 0;
$plpSearchObj.viewMoreSearchStartIndex = 0;
$plpSearchObj.productsServiceUrl = function(searchedWord) {
	if(storeDirectory === 'PersolGR' && host !== 'localhost'){
        WCParamJS.homePageURL = "https://"+ host + "/greece";
    }
	var baseSearchURL = (isInToolkit ? '' : WCParamJS.homePageURL)+'/search/resources/store/'+WCParamJS.storeId+'/productview/';
	var searchTerm = getUrlParameter('searchTerm');
    /* START Early Access */
    if (isPersol) {
        if (window.customerSegment != undefined && window.customerSegment != ""){
            queryParams.customerSegment = window.customerSegment;
        }
    }
    /* END Early Access */
	if (searchTerm || searchedWord) {
		return baseSearchURL+'bySearchTerm/' + (searchedWord ? searchedWord : searchTerm); // Search Obtimization
	}
	return baseSearchURL+'byCategory/'+ document.querySelector('meta[name="pageId"]').getAttribute('content');
}
$plpSearchObj.lastIndexbkp = 0;

function fn_plpFirstTiles(productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch) {
	// # Load Espot contents (TOP e MIDDLE creati durante il render delle tile)
	if (typeof isWishlist == "undefined"){
        var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
    }

    if (!isWishlist){
        selectedFacetsData = {
            storeId : WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            fromPage: 'catalogEntryList',
            beginIndex: '0',
            responseFormat: 'json',
            orderBy: defaultOrderBy,
            categoryId: ""
        };
    } else {
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObjCount = Object.keys(JSON.parse(sessionStorage.wishlistObj)).length;
            var countString = "(" + wishlistObjCount + ")";
            $(".title-wishlist_count").html(countString);
            if (wishlistObjCount == 0){
                $("#box.wishlist").addClass("emptyWishlist");
                $("#empty-wishlist-container").removeClass("hidden");
                if (isOliver && $("#wishlistAppointmentEspot").length > 0) $("#wishlistAppointmentEspot").remove();
            } else {
                $("#box.wishlist").removeClass("emptyWishlist");
                $("#empty-wishlist-container").addClass("hidden");
            }
        }
    }

 
	$plpSearchObj.itemsPerPage = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 && sessionStorage.backItemsPerPage) ? parseInt(sessionStorage.backItemsPerPage) : columnsToShow*parseInt($("#rowsPerPage").val());			// infinite scroll page(group) size
	$plpSearchObj.itemsFromServer = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 & sessionStorage.itemsToLoad) ? parseInt(sessionStorage.itemsToLoad) : parseInt($("#itemsFromServer").val());					// how many to get from API
	//facet search page e plp credo
    
    if(document.querySelector('.plp') || document.querySelector('.search') || document.querySelector('.searchPanel') ) {
        // Get facets to show in filter by if it's not the Persol search
        /**
        // facets are excluded by search in Persol 
        if (!isWishlist){
            if (isOliver || isPersol) {
                $plpSearchObj.facetsForFilterBy = {};
                if ($('input#facetsForFilterBy').length){
                var facetsForFilterByArr = $('input#facetsForFilterBy').val().split(';');
                    for (var i=0;i<facetsForFilterByArr.length; i++) {
                        var facetArr = facetsForFilterByArr[i].split(':');
                        if (facetArr.length == 2) {
                            $plpSearchObj.facetsForFilterBy[facetArr[0]] = facetArr[1];
                            //queryParams['f.'+facetArr[1].substring(0,facetArr[1].indexOf('%3A'))+'.facet.mincount'] = 0;
                        }
                    }
                // Get facets to be ignored
                $plpSearchObj.facetsToBeIgnored = $('input#facetsToBeIgnored').val().split(';');
                }
            }
        }
        */

        setDefaultSortBy(defaultOrderBy, false, productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch);
        var pageElem = document.getElementById('page');
        var blockFilter = document.querySelector('.block-filter');
        var originalFilterParentElem = "";
        var facetButtonElem = document.querySelector('.plp-filter-button');

        //Different views buttons - By default, on mobile show 2 columns view; on desktop show 3 columns view
        if(!searchedWord){
            if (window.tabletPortraitCheck() || window.mobilecheck()){
                if (!isWishlist) {
                    $('.button-views.two-col-icon').addClass("active");
                    $('.grid_mode').addClass('grid_mode-two-cols');
                }
            }

            // ex --Apply facets when you click the apply button
            

            if(document.querySelector('.search-page')) {
                originalFilterParentElem = document.querySelector('#content > .search-page');
            } else {
                originalFilterParentElem = document.querySelector('#content > .plp');
            }

            if (document.querySelector(".facet__apply")) {
                originalHrefApply = document.querySelector(".facet__apply").getAttribute('data-href');
            }

            //show description before offset calculation: description can born displayed?
            if (isOliver){
                $('.description.descriptionDefault').css('display','flex');
                if (window.tabletPortraitCheck() || window.mobilecheck()) {
                    var espotHeight= $( "#contentRecommendationWidget_X_PLP_HeroBanner_X_PLP_HeroBanner").height();
                    //var textHeight =$(".descriptionDefault").height();
                    //var marginButtons= espotHeight - textHeight
                    //$('.plp-filter-view-button').css("margin-top","-"+$('.grid.product-list').css('margin-top'));
                }
            }

            // Change DOM facet button position to make it FIXED
                if (!isWishlist){
                    var class_startscroll = ".plp-filter-button_wrapper";
                    if (isPersol && document.querySelector('.search')) {
                        class_startscroll = ".searchSummaryWidget";
                    }
                    
                    var offset = $(class_startscroll).offset().top;
                    var totalOffset = offset;
                    if(window.mobilecheck() || window.tabletPortraitCheck()) {
                        totalOffset = offset + $(class_startscroll + ' .espot-plp-beans').outerHeight() + 56;
                    }
                } else {
                    if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex) {                    
                        //clean up the grid
                        $('.plp-grid-skeleton').remove();
                    }

                    //Remove extra empty <li> tags in wishlist page
                    if (isWishlist) {
                        if (typeof sessionStorage.wishlistObj != "undefined"){
                            var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                            var productsLength = Object.keys(wishlistProducts).length;

                            if (productsLength == 0){
                                if ($("#wishlist_grid li").length > 0) {
                                    $("#wishlist_grid li").remove();
                                }
                            } else {
                                for (var i=0 ;i<productsLength; i++){
                                    var wishlistLi = $("#wishlist_grid li")[i];
                                    if ($(wishlistLi).html() == ""){
                                        $(wishlistLi).remove();
                                    }
                                }
                            }
                        }
                    }
                }
                window.addEventListener('scroll', function() {
                    if (!isWishlist){
                    /** Sticky submenu in plp */
                        if (isPersol) {
                            if(window.mobilecheck() || window.tabletPortraitCheck()) {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() + $('#ci_espot__X_Header_GlobalBanner').height();
                                } else {
                                    var checkPersol = $(this).scrollTop() +1;
                                }
                            } else {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height() + $('#ci_espot__X_Header_GlobalBanner').height();
                                }
                                else {
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height();
                                }
                            }

                            var getBannerTopHeight = function () {
                                if($('#bannerTop').length && $('#bannerTop').is(":visible")) {
                                    return $('#bannerTop').height();
                                } else {
                                    return 0;
                                }
                            }

                            var offset2 = 0;
                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                offset2 = $(class_startscroll + " .espot-plp-beans").outerHeight() + 10;
                            }

                            if(checkPersol >= (offset + offset2)){
                                if(window.innerWidth >= 1024 && window.innerWidth < 1300 && window.matchMedia("(orientation: landscape)").matches){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else {
                                    $(class_startscroll).css('top', $('#header').height() + getBannerTopHeight()-1);
                                }

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).addClass('plp-filter-button_wrapper--sticky');
                                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", $(".plp-filter-button_wrapper").outerHeight() );
                                        $('.plp-wrapper-title').show();
                                        $('.plp-filter-button_wrapper--sticky').css("top",$('.ct-promo-banner').height());
                                    }else {
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", "168.8px" );
                                        var stripHeight = $('.ct-promo-banner').height();
                                        var headerHeight = $('#header').outerHeight();
                                        $('.plp-filter-button_wrapper--sticky').css("top",parseInt(stripHeight)+parseInt(headerHeight));
                                    }
                                }
                            }else{
                                $(class_startscroll).css('top', 'auto');

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).removeClass('plp-filter-button_wrapper--sticky');
                                    $('.plp-wrapper-title').hide();
                                    $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", 0 );
                                }
                            }
                        }
                    }
                    
                    var documentBottom = $(window).scrollTop()+$(window).outerHeight();
                    
                    if($(".plp-grid-skeleton").length > 0) {
                        var skeletonTop =  $(".plp-grid-skeleton").offset().top;
                        //retiver info origina plp 
                        
                        
                        if (skeletonTop <= documentBottom
                                && $plpSearchObj.viewIndex < $plpSearchObj.lastIndex
                                && !$plpSearchObj.busy) {
                            $plpSearchObj.viewMoreTiles($plpSearchObj.itemsPerPage);
                        }

                        if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex && $plpSearchObj.viewIndex!=0) {                    
                            //clean up the grid
                            $('.plp-grid-skeleton').remove();

                            //Remove extra empty <li> tags in wishlist page
                            if (isWishlist) {
                                if (typeof sessionStorage.wishlistObj != "undefined"){
                                    var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                                    var productsLength = Object.keys(wishlistProducts).length;

                                    if (productsLength == 0){
                                        if ($("#wishlist_grid li").length > 0) {
                                            $("#wishlist_grid li").remove();
                                        }
                                    } else {
                                        for (var i=0 ;i<productsLength; i++){
                                            var wishlistLi = $("#wishlist_grid li")[i];
                                            if ($(wishlistLi).html() == ""){
                                                $(wishlistLi).remove();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });

                //  Begin Change DOM filter position to make it FIXED
                if (!isWishlist){
                    if (isOliver){
                        document.querySelector('body').appendChild(blockFilter);
                    }
                }

                window.addEventListener('resize', function() {
                    if(!isWishlist){
                        if(window.innerWidth >= 1024 && blockFilter.parentNode !== originalFilterParentElem) {
                            facetButtonElem.classList.remove('scroll');
                        }
                        else if (window.innerWidth < 1024 && blockFilter.parentNode !== pageElem) {
                            document.querySelector('body').appendChild(blockFilter);
                        }
                    }
                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                        if(isOliver) {
                            if (isWishlist){
                                $('#wishlist_grid .grid-item:not(.product-espot)').outerHeight("100%");
                            } else {
                                $('.grid-item:not(.product-espot)').outerHeight("100%");
                            }
                        } else if(isPersol) {
                            if(isWishlist){
                                $('.grid-item:not(.product-espot):not(.grid-item-search)').outerHeight("100%");

                            }else{
                                $('.grid-item:not(.product-espot)').height("100%");
                            }
                            
                        }
                    }
                    if(!isWishlist){
                        if(blockFilter.classList.contains('opend') && window.innerWidth >= 1024) {
                            document.querySelector('html').removeAttribute("style");
                            document.querySelector('body').removeAttribute("style");
                        } else if(blockFilter.classList.contains('opend') && window.innerWidth < 1024) {
                            document.querySelector('html').setAttribute("style", "overflow: hidden;");
                            document.querySelector('body').setAttribute("style", "position: static; overflow: hidden");
                        }
                    }
                }, true);
                //  End Change DOM filter position

                //Add classes to Persol if on mobile
                if (isPersol) {
                    if (window.tabletPortraitCheck() || window.mobilecheck()){
                        $('.sale_badge').addClass('submenu__subheader');
                        $('.sale_badge').addClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
                    } else {
                        $('.sale_badge').removeClass('submenu__subheader');
                        $('.sale_badge').removeClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
                    }
                }

                // deleted function --- see //START FILTER SECTION in non critical js 

        
          
        }
    }

        initButtonViewOnClick();

		



    // # X_PLP_SalesBeans
    if ($('#ci_espot__X_PLP_SalesBeans').length > 0) {

    	// Change event for select
    	$('select.select-bean').change(function(e) {
        	document.location.href = $(e.target).val();
        });

    	// Active/Select current dash button page
		var urlPage= window.location.href;
	    var splitUrl = urlPage.split("/");
	    var salesCategory = splitUrl[splitUrl.length - 1];
	    $('.nav-beans #' + decodeURI(salesCategory.split('?')[0])).addClass("active");
	    $("select option[value='"+salesCategory.split('?')[0]+"']").prop("selected",true);
	}
}

function initButtonViewOnClick(){
    // Change view when clicking on different buttons
    $('.button-views.one-col-icon').click(function() {
        columnsToShow = 1;
        $('.button-views').removeClass("active");
        $('.button-views.one-col-icon').addClass("active");
        $('.grid_mode').addClass('grid_mode-one-col');
        $('.grid_mode').removeClass('grid_mode-two-cols');
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").addClass("-one-col");
    });

    $('.button-views.two-col-icon').click(function() {
        columnsToShow = 2;
        $('.button-views').removeClass("active");
        $('.button-views.two-col-icon').addClass("active");
        $('#plp_grid.grid_mode').addClass('grid_mode-two-cols');
        $('#plp_grid.grid_mode').removeClass('grid_mode-one-col');
        $('#plp_grid.grid-item').removeAttr('style')
        $('.product--wrapper__container').removeAttr('style')
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").removeClass("-one-col");
    });
}

/**
 * @function setDefaultSortBy
 * @desc This function select the default sort by inside facet section
 *
 * @param {*} num
 */
function setDefaultSortBy(num, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    var sortElems = document.querySelectorAll('.facet__sortBy .facet__filter-button');
    for(var sortElem = 0; sortElem < sortElems.length; sortElem++) {
        if(sortElems[sortElem].getAttribute('data-facet') == num){
            sortElems[sortElem].parentElement.classList.add('selected');
            break;
        }
    }
    originalSelectedSort = document.querySelector('#facet__sortBy .facet__filter-noimg.selected');
    ajaxCallFacet(callbackSortBy, null, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch);
}

function ajaxCallFacet(callback, elem, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    
    if(typeof firstSearch != undefined){
        $plpSearchObj.firstSearch = firstSearch;
    }else{
        $plpSearchObj.firstSearch = undefined;
    }
    $plpSearchObj.viewIndex = 0;
    $plpSearchObj.lastIndex = 0;
    $plpSearchObj.resultCount = 0;
    $plpSearchObj.getData(isViewMore, function() {
        $plpSearchObj.attrValIdentifierObject = [];//object use to retrive indetifier value of attribute value
    	$plpSearchObj.busy = false;
    	createNewTileProducts(0,$plpSearchObj.itemsPerPage,searchedWord,isWishlist,false,wishlistToDeleteData);
        $plpSearchObj.itemsPerPage = columnsToShow*parseInt($("#rowsPerPage").val());
        $plpSearchObj.itemsFromServer = parseInt($("#itemsFromServer").val());
    	callback(elem);
    }, productData,searchedWord, isWishlist);
    if (typeof productData === 'undefined') {
        $plpSearchObj.busy = true;
    }
}

//function to load plp data 
$plpSearchObj.getData = function(isViewMore,callback,productData,searchedWord,isWishlist) {
	if (!isViewMore) {
		$plpSearchObj.items = {};
		$plpSearchObj.currentPage = 1;
		$plpSearchObj.viewIndex = 0;
		$plpSearchObj.lastIndex = 0;
        
        /*if (document.querySelector('.search')) {
            $("span[id^=searchTotalCount]").html($("span[id^=searchTotalCount]").html().replace(/\d/g, ''));
        }*/
		window.scrollTo(0,0);
	} else {
        $plpSearchObj.viewMoreClicked = true;
		$plpSearchObj.currentPage = Math.floor(($plpSearchObj.lastIndex||0)/$plpSearchObj.itemsFromServer)+1;
        
        var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
        
        for(var i = 0; i  < $plpSearchObj.itemsFromServer; i++) {
            var createDOMLi = document.createElement('li');
            if(isOliver) createDOMLi.classList.add('product');
            createDOMLi.classList.add('plp-grid-skeleton');
            ulGrid.appendChild(createDOMLi);
        }
        // 	$('.product--wrapper').height($('.product').width());
        // }
    } 
	
    if (isPersol) {
    	$('.skeleton .product--wrapper').height($('.skeleton .product-container').width() * (400/360));
    }

    $plpSearchObj.queryParams = queryParams;
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['categoryId'] = '';
    }else{
        $plpSearchObj.queryParams['categoryId'] = document.querySelector('meta[name="pageId"]').getAttribute('content');
    }
	if (selectedFacetsData["orderBy"]) {
		$plpSearchObj.queryParams['orderBy'] = selectedFacetsData["orderBy"];
	    if (isPriceOrdering()) {
	    	queryParams['profileName'] = 'LUX_findProductsByCategory';
	    } else if (isNewArrivalsOrdering() && getUrlParameter('searchTerm') == null) {
	    	queryParams['profileName'] = defaultSearchProfile+'_new_first';
	    } else {
	    	queryParams['profileName'] = defaultSearchProfile;
	    }
	} else {
		delete $plpSearchObj.queryParams['orderBy'];
    	queryParams['profileName'] = defaultSearchProfile;
	}
	if (!categoryToGroupTile()) {
		queryParams['profileName'] = 'LUX_findProductsByCategory';
	}
	$plpSearchObj.queryParams['pageNumber'] = $plpSearchObj.currentPage;
	$plpSearchObj.queryParams['pageSize'] = $plpSearchObj.itemsFromServer;
    var facetArr = [];
    var queryString = window.location.search.substr(1);
    if (queryString.trim() != "") {
        var parameters = queryString.split('&');
        $.each(parameters, function(i,el){
       	 	var facetKey = el.split('=')[0];
       	 	if (facetKey.startsWith('facet')) {
       	 		var facetValue = el.split('=')[1];
       	 		facetArr.push(facetValue);
       	 	}
        });
    }
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['facet'] = [];
    }else{
        $plpSearchObj.queryParams['facet'] = facetArr;
    }
    

    var ajaxPLPSuccess = function(data) {
    	
    	   if(location.href.includes("facet") && !$plpSearchObj.viewMoreClicked){
           	tileIndex = 0;
           }

        $plpSearchObj.resultCount = !isWishlist ? data.recordSetTotal : Object.keys(data).length;
        var dataRecordCount = !isWishlist ? data.recordSetCount : Object.keys(data).length;
        if (dataRecordCount === 0) {
        	var dataSpellCheck = '';
        	if ($('.suggestions_container .suggestion').length > 0){
        		dataSpellCheck = $('.suggestions_container .suggestion')[0].text;
        	} else if (data.metaData){
        		dataSpellCheck = data.metaData.spellcheck[0];
        	}
        	if (dataSpellCheck){
        		$.ajax({
                    url: $plpSearchObj.productsServiceUrl(dataSpellCheck),
                    type: 'GET',
                    async: true,
                    data: $.param($plpSearchObj.queryParams,true),
                    success: ajaxPLPSuccess,
                    error: function(error) {
                    	return error;
                    }
                });
        	} else {
                if(searchedWord && typeof $plpSearchObj.firstSearch == undefined){//no result in search panel 
                    searchError(true);
                    resetSearchTile(true);//resetFeature
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(searchedWord && $plpSearchObj.firstSearch ){//no result in search panel firstsearch
                    searchError(true);
                    resetSearchTile(true);
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(isWishlist){
                    $("#wishlist_grid li .grid-item").remove(); //wishlist is empty
                }else {
                    //	Hide View More button
                    //populateUtagDataAfterAjax();
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                    if (isOliver && getUrlParameter('searchTerm') === null){
                        $('#noProducts').css('display','block');
                        //add default empty element in plp_grid for wcag
                        var createDOMProduct = document.createElement('li');
                        createDOMProduct.classList.add('grid-item');
                        createDOMProduct.setAttribute('id','dummyElement');
                        ulGrid.appendChild(createDOMProduct);
                    }

                }
                
            }
        }
        
        else if (dataRecordCount > 0) {
        	if(($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm' && $('.suggestions_container .suggestion').length > 0 && $('.suggestions_container .suggestion')[0].text.toLowerCase() != (data.catalogEntryView[0].name).toLowerCase())){
        		for (var i = 0; i < dataRecordCount; i++) {
        			if($('.suggestions_container .suggestion')[0].text.toLowerCase() == (data.catalogEntryView[i].name).toLowerCase()){
        				var shortDescription = (data.catalogEntryView[i].shortDescription);
        				$.ajax({
                            url: $plpSearchObj.productsServiceUrl(shortDescription),
                            type: 'GET',
                            async: true,
                            data: $.param($plpSearchObj.queryParams,true),
                            success: ajaxPLPSuccess,
                            error: function(error) {
                            	return error;
                            }
                        });
        				break;
        			}
        		}
        	}
            var results = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord ? data.catalogEntryView : (isWishlist ? data : data.catalogEntryGroupView); 
             // Display message when no products are shown
            $('#noProducts').css('display','none');
            //delete dummyElement in plp_grid for WCAG
            $('#dummyElement').remove();
            if(searchedWord){
                searchError(false);
                $(".title_result").hide();
                $(".redirect_result_container").css("display","flex");
                $(".redirect_result_container .redirect_result_link").show()
                $(".redirect_result_link #serched_word").html($('input:text[name=searchInput]').val());
                
            }
            /* populate items */
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord) {
                $.each(results, function(key,value) {
                    $plpSearchObj.items[(parseInt(key)+($plpSearchObj.itemsFromServer*($plpSearchObj.currentPage-1)))] = value;
                    
                });
                if(!searchedWord){
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            } else {
                //  START - Email me sorting by inventory
                function fn_sortByInventory(p) {
                    var r = 0;
                    if (p['inventory']
                            && p['inventory']['ranking']
                            && p['inventory']['flComingSoon']) {
                        r = p['inventory']['ranking'] + (p['inventory']['flComingSoon'] == 'true' ? 0.5 : 0);
                    }
                    return r; 
                }
                if (!isWishlist){
                    $.each(results,function(group,products) {
                        products.sort(function(a, b){
                            var sortedResults = fn_sortByInventory(b) - fn_sortByInventory(a);
                            return sortedResults;
                        });
                    });
                }
                //  END - Email me sorting by inventory
                Object.assign($plpSearchObj.items,results);
                if(!searchedWord){
                    //search Optimization save PLP items info 
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            }

            //  LCP
            /*
            let count = 0;
            $.each($plpSearchObj.items,function (key,value) {
                if (count == 0
                        && value[0] != undefined) {
                    var lcp = new Image();
                    if (isOliver){
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else if (isPersol) {
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail,'sclw=0.25&sclh=0.25','small');
                    }
                    return false;
                }
            });
            */

            /*populate tealiumProducts HB-5614*/
            var status = 'undefined';
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) {
                if(typeof tealiumProducts === 'undefined'){
                     tealiumProducts = {};
                }
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        var category = "";
                        if(pageType=='Wishlist'){
                        	category = getAttributeValue(value.attributes,"PRODUCTTYPE");
                        	category = category.toLowerCase();
                        	
                        	if(category.includes("sun")){
                        		category = "SUN";
                        	}
                        	if(category.includes("optical")){
                        		category = "OPTICS";
                        	}
                        	
                        	if(category.includes("accessories")){
                        		category = "ACCESSORIES"; 
                        	}
                        }else{
                        	category = getCategoryName(key ,"_")
                        }
                        
                        tealiumProduct['Category'] = category; 
                        tealiumProduct['Price'] = parseFloat(value['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value.inventory);
                        $(addProductsToTealium(value.partNumber,tealiumProduct)); // fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(e);
                    }
                });
            }
            else {
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        tealiumProduct['Category'] = getCategoryName(key ,"_");
                        tealiumProduct['Price'] = parseFloat(value[0]['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value[0]['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value[0].inventory);
                        $(addProductsToTealium(value[0].partNumber,tealiumProduct));// fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(value[0]);
                    }
                });
            }
            
            
            if(pageType=='Search'){
               var obj = {};
               obj['Search_Keyword'] = getUrlParameter('searchTerm');
               obj['Search_ResultItemsQnt'] = $plpSearchObj.resultCount;
               obj['Search_View'] = 'SERP';
               obj['Event_Source'] = 'SERP'
               pushDataToTealium(obj)
            } 
            
            if (typeof monetateQ !== 'undefined'){
                  monetateTrackPlp();
            }

            /*END 5614*/
    
            if(!searchedWord){
                if($plpSearchObj.lastIndexbkp > 0 && !$plpSearchObj.isFilterPanel){ // search Optimization  if is after search and not use filter
                    $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp
                    $plpSearchObj.lastIndex += Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex;
                }else{
                    //if apply filter 
                    $plpSearchObj.lastIndex = Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex
                    $plpSearchObj.isFilterPanel = false;
                }
 
                
            }
            
            $plpSearchObj.loading = false;
            if (typeof callback == 'function') {
            	if($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm'){
            		resetSearchTile(false,false,false);
            	}
            	callback();
            }

            /* facets are included only in PLP */
            if (!isWishlist){
                if(!searchedWord){
                    closeFilterMenu();
                    isFacetApplied = true;
                    originalSelectedSort = $('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en");
                    if(countSelectedFacets == 0) {
                        $(".facet__apply").removeClass('show');
                        document.querySelector('.facet__widget').classList.remove('active');
                        isFacetApplied = false;
                    }
                }
            }

            //	View More button
            if (!isWishlist){
                if ($plpSearchObj.resultCount-$plpSearchObj.lastIndex <= 0) {
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                } else {
                    $('.plp__view-more.button.secondary').show();
                }
            }

            if (!isViewMore) {
                /* facets are excluded by search in Persol */
                if (!searchedWord) { // SearchOptimiztion ! (isPersol && getUrlParameter('searchTerm'))
                    //	Inner function used to handle filters drawing and toggle
                    if (!isWishlist){

                        var filtersHandling = function(dataPartial,dataAll) {
                        // $plpSearchObj.attrValIdentifierObject =  createAttrValIdentifierObject(dataAll.catalogEntryGroupView);
                            drawFilters(dataAll.facetView,facetArr,parameters,$('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en"));
                            $('.facet__apply-number').text($plpSearchObj.resultCount);
                            $('.numframe').html($plpSearchObj.resultCount + ' ' + $('#frameTranslate').val());
                            $("#productsFacets li.facet__list-item li").each(function(i,e) {
                                toggleFilter(e,dataPartial);
                            });
                        };
                        //	If there are no GET parameters, then use the normal flow
                        if (facetArr.length == 0) {
                            filtersHandling(data,data);
                        } else {
                            new Promise((resolve, reject) => {
                                // else do an AJAX call to get the full facets list
                                var queryParamsAllFilters = $.extend({},$plpSearchObj.queryParams);
                                queryParamsAllFilters['facet'] = [];
                                delete queryParamsAllFilters['isForPLP'];
                                queryParamsAllFilters['isForPLPFilters'] = true;
                                $.ajax({
                                    url: $plpSearchObj.productsServiceUrl(),
                                    type: 'GET',
                                    async: true,
                                    data: $.param(queryParamsAllFilters,true),
                                    success: function(dataAll) {
                                        filtersHandling(data,dataAll);
                                        resolve(dataAll);
                                    },
                                    error: function(error) {
                                        reject(all);
                                        return error;
                                    },
                                    beforeSend: function(jqXHR, settings) {
                                        //  Security check, if true then stop the request and show 0 results
                                        if (settings.url.indexOf('TopCategoriesDisplay') > -1) {
                                            return false;
                                        }
                                    }
                                });
                            });
                        }
                    }
                }

                if (!isWishlist){
                    if(!searchedWord){
                        if(originalSelectedSort != undefined){
                            if(!(isPersol && getUrlParameter('searchTerm')) && facetArr.length == 0 && originalSelectedSort.innerText!==''){
                                setUTagData(parameters,originalSelectedSort);
                            }
                        }
                    }
                }

                if (document.querySelector('.search') ) {
                    $("span[id^=searchTotalCount] #totalCount").html("("+ $plpSearchObj.resultCount + ") " );
                }
            }
        }

        // Remove top and middle espot skeleton
        $('#plp_top_espot_skeleton').remove();
        $('#plp_middle_espot_skeleton').remove();

        //  CLS
        $('.plp-hide').show();
    };
    if (!isWishlist && typeof productData === 'undefined') {

        if(searchedWord || getUrlParameter('searchTerm') ){
            $plpSearchObj.queryParams.profileName = "LUX_findProductsBySearchTerm"
            if(isPersol){
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688668_3074457345616688669_3074457345616718183_3074457345616718182)'"; // catgoria LEnti + categorie servizi
            }else{
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688676_3074457345616714198_3074457345616714199_3074457345616688675)'"; // catgoria LEnti + categorie servizi
            }
             
            
        }else{
            $plpSearchObj.queryParams.profileName = $plpSearchObj.queryParams.profileName;
            delete $plpSearchObj.queryParams.filterQuery 
        }
        if(!isWishlist && !(searchedWord || getUrlParameter('searchTerm'))){}else{
        	$.ajax({
                url: $plpSearchObj.productsServiceUrl(searchedWord),
                type: 'GET',
                async: true,
                data: $.param($plpSearchObj.queryParams,true),
                success: ajaxPLPSuccess,
                error: function(error) {
                    return error;
                },
                beforeSend: function(jqXHR, settings) {
                    //  Security check, if true then stop the request and show 0 results
                    if (settings.url.indexOf('TopCategoriesDisplay') > -1) {

                        $plpSearchObj.resultCount = 0;

                        //	Hide View More button
                        $('.plp__view-more.button.secondary').attr('style','display:none !important');
                        if (isOliver && getUrlParameter('searchTerm') === null){
                            $('#noProducts').css('display','block');
                            //add default empty element in plp_gid for wcag
                            var createDOMProduct = document.createElement('li');
                            createDOMProduct.classList.add('grid-item');
                            createDOMProduct.setAttribute('id','dummyElement');
                            ulGrid.appendChild(createDOMProduct);
                            
                        }

                        return false;
                    }
                }
            });
        }
        
    } else {
        ajaxPLPSuccess(productData);
    }

};

/**
 * @funtion createNewTileProducts
 * @desc This function creates the new tile products with a template html
 */
function createNewTileProducts(startAt,count,searchedWord,isWishlist,isWishlistViewMoreTiles,wishlistToDeleteData,firstSearch) {
	// TEMPORARY FIX FOR HB-9977
	if(pageSection_1 == 'Accessories' && (window.tabletPortraitCheck() || window.mobilecheck())){
		count = 6;
	}
	$plpSearchObj.viewIndex = startAt+count;
    if(!searchedWord){
        //search Optimization -- save viewIndex 
        $plpSearchObj.viewIndexbkp = $plpSearchObj.viewIndex
    }
	//	Remove extra skeleton tiles
	var toShow = $plpSearchObj.lastIndex-$plpSearchObj.viewIndex;
	var toRemove = $plpSearchObj.itemsFromServer-toShow;
	
    var products = {}, i = 0;

    if (getUrlParameter('searchTerm') && $plpSearchObj.viewMoreClicked && !searchedWord) {
        var stopAt = $plpSearchObj.viewMoreSearchStartIndex+count;
        i = $plpSearchObj.viewMoreSearchStartIndex;
        if (toShow < 0) {
            // check for the end on products
            stopAt += toShow;
        }
        for (m in $plpSearchObj.items) {
            if (i>=$plpSearchObj.viewMoreSearchStartIndex && i < stopAt) {
                products[m] = $plpSearchObj.items[parseInt(m)+startAt];
            }
            i++;
        }
        $plpSearchObj.viewMoreSearchCount++;
        $plpSearchObj.viewMoreSearchStartIndex = count * $plpSearchObj.viewMoreSearchCount;
    } else {
        for (m in $plpSearchObj.items) {
            if (startAt<=i && i<startAt+count) {
                if(searchedWord){
                    if(isPersol && i <= 2){
                        products[m] = $plpSearchObj.items[m];
                    }else if(isOliver && i <= 1){
                        products[m] = $plpSearchObj.items[m];
                    }
                }else{
                    products[m] = $plpSearchObj.items[m];
                }
                
            }
            i++;
        }
    }

    // Show number of selected facets in the filter button
    if (countSelectedFacets >= 1) {
        $('.plp-filter-button').addClass('active');
    	$('.filter__button-number').text(countSelectedFacets);
    } else {
        $('.plp-filter-button').removeClass('active'); 
    }

    var tileCount = Object.keys($plpSearchObj.items).length;

    
    renderTileProducts(products, startAt, count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData);
}

/**
 * @funtion manageWishlistGuestEspot
 * @desc This function adds the sign in/register espot in the wishlist page as last tile of first grid row. This only happens when user is guest
 * */
function manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData) {
    var parentElement = ulGridChilds[0].parentNode;
    if (isPersol){
        if (productsLength > 0 && productsLength < 4) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(3).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[3]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    } else {
        if (productsLength > 0 && productsLength < 3) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(2).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[2]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    }
    if (typeof setWishlistEspotCtaClick == "function"){
        setWishlistEspotCtaClick();
    }
}

/**
 * @funtion renderTileProducts
 * @desc This function creates the new tile products with a template html
 * @param {products} products
 * @param {inventory} inventory
 */
function renderTileProducts(products,startAt,count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData) {

    var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
    var productArray = [];

  
    
    const ulGridChilds = searchedWord ? document.querySelectorAll('.search-grid-skeleton') : ((isWishlist && $('.plp-grid-skeleton').length == 0) ? document.querySelectorAll('#wishlist_grid li') : document.querySelectorAll('.plp-grid-skeleton')); //search optimization

    var productIndex = 0;
   
    var productsLength = Object.keys(products).length;

    for(var product in products) {

        if (typeof wishlistToDeleteData == "undefined" || !wishlistToDeleteData.isWishlistProductToDelete){
            var createDOMProduct = document.createElement('div');
            createDOMProduct.classList.add('grid-item');
            if(searchedWord){
                createDOMProduct.classList.add('grid-item-search');
                if(searchedWord == "X_Search_FeaturedProducts"){
                    $(".grid-item-search").parent().addClass("featured-products");
                }
            }

            var isLCPTile = startAt == 0 && productIndex == 0;
           

            if(searchedWord == "X_Search_FeaturedProducts"){
                var html = getSingleTileHtml(product, products[product].productModel, true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }else{
                var html = getSingleTileHtml(product, products[product], true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }
            
            
            $(createDOMProduct).html(html);
            ulGridChilds[productIndex].replaceChildren(createDOMProduct);
        }
        
        if (isWishlist){
            //If there is at least one product and user is guest, display sign in/register espot at last position of first grid row
            if (userType == "G" && productsLength > 0){
                if (!isWishlistViewMoreTiles || typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                    if (productIndex == productsLength - 1) {
                        if (typeof wishlistContentEspotHTML == 'undefined'){
                            returnEspotContent("X_Wishlist_Login");
                            var wishlistContentEspotHTML = $("#guestWishlistEspotContent").val();
                        }
                        if (typeof wishlistContentEspotHTML != "undefined" && wishlistContentEspotHTML != ""){
                            var espotLi = document.createElement('li');
                            espotLi.classList.add("wishlist-li");
                            var createDOMEspot = document.createElement('div');
                            createDOMEspot.classList.add('grid-item', 'wishlist-espot');
                            $(createDOMEspot).html(wishlistContentEspotHTML);
                            espotLi.appendChild(createDOMEspot);
                            if ($(".wishlist-espot").length == 0){
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            } else {
                                $(".wishlist-espot").parent().addClass("wishlist-li");
                                if ($(".wishlist-li").length > 0) {
                                    $(".wishlist-li").remove();
                                }
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            }
                        }
                    }
                }
            }


            if(typeof checkIsInWishlist === 'function'){ 
                if(checkIsInWishlist(product)){ // WISHLIST -- check if current product is in wishist
                    $("[data-id=" + product + "] .wishlist-icon-container").addClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }else{
                    $("[data-id=" + product + "] .wishlist-icon-container").removeClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }
            }
            wishlistAvailabilityCheckCTA(products, product);
        }

        if(searchedWord){
           ulGridChilds[productIndex].classList.remove("search-grid-skeleton");
           //$(".search-grid-skeleton").eq(productIndex).hide()
        }else {
            ulGridChilds[productIndex].classList.remove("plp-grid-skeleton");
            
        }

        ulGridChilds[productIndex].classList.remove("product");
        ulGridChilds[productIndex].querySelector('.square-container').classList.remove("skeleton-element");
        ulGridChilds[productIndex].querySelector('.product__wrapper-info').classList.remove("skeleton-element");
        
        
        productArray.push(createDOMProduct);
       
        removeLoader();


        
        productIndex++;
        tileIndex++;
    }


    if(searchedWord && $("#search_grid .search-grid-skeleton").length > 0){ //hide skeleton if result <3 /2
        $("#search_grid .search-grid-skeleton").hide();
    }

    if (!isWishlist){
        if(searchedWord != 'X_Search_FeaturedProducts' && searchedWord){
            var resultItemsQnt = $("#search_grid li:not(.search-grid-skeleton)").length;
            tealiumPushSearchPageReady(searchedWord,resultItemsQnt);
        }
    } else {
        init_wishlist_tooltip();
    }


  

    // Show images in IE, as Yall does not work properly
    if (!('IntersectionObserver' in window)) {
        if (typeof mokeupLazyLoad === "function") {
            mokeupLazyLoad();
        }
    }
    if(window.location.href.includes("?facet=")){
    	$('#X_PLP_TopBanner').hide();
    	$('#X_PLP_BottomBanner').hide();
    	$('#X_PLP_MiddleBanner').hide();
    	$('#X_PLP_PromoBanner').hide();
        $('#X_PLP_BottomGridBanner').hide();
        $('#X_PLP_GridBannerTop').hide();
        $('#X_PLP_GridBannerBottom').hide();
    }

    if(isEdgeOrIExplorer()){
        $('.grid.product-list').css("width","auto");
    }
    
    /**
     * Handle back button : scroll to the last product clicked by user 
    * */
    if(sessionStorage.plpTitle == pageSection_1 && sessionStorage.pageY) {
            if($plpSearchObj.viewIndex  > 16) { //middle espot non renderizzato
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY - sessionStorage.middleEspotHeight
                },0);
            }
            else {
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY
                },0);
            }
            sessionStorage.removeItem('pageY');
            sessionStorage.removeItem('plpTitle');
            sessionStorage.removeItem('itemsToLoad');
            sessionStorage.removeItem('backItemsPerPage');
            sessionStorage.removeItem('middleEspotHeight');
    }
    if(searchedWord == "X_Search_FeaturedProducts"){ // save Feautured 
        $('#search_grid li').each(function() {
            if(!$(this).hasClass("search-grid-skeleton")){
                featuredProductHtml += this.outerHTML
            }
        })
    }
    
}
/**
 * @funtion getSingleTileHtml
 * @desc This function creates a single product tile with a template html
 * @param {model} model
 * @param {product} product
*/
function getSingleTileHtml(product, model, insideGrid,productIndex=0,isLCPTile, tileIndex,searchedWord,isWishlist,isEspot) {

    var html = '';

    try {

        var listPrice = '';
        var offerPrice = '';
        var percentage = '';

        var polarized = '';
        var isPhotocromic = false;
        var isRox = false;
        var modelNameValue = "";
        var group2BadgeValue = '';
        var wishlistAddedSize = "";
        var wishlistAddedSizeNumber = "";
        var productMoco = "";
        var isPolar = false;
        var catentryIdDefaultSize = [];

        if (typeof isWishlist == "undefined"){
            var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
        }

        //var model = products[product];
        var showedProduct = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0];
        if (showedProduct.thumbnail === undefined) {
            showedProduct.thumbnail = '';
        }
        $(model).each(function (ind) {
            var currProduct = $(this)[0];
            if (isOliver) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
            } else if (isPersol) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }

            try {
                if(WCParamJS.countryCode == 'US' || WCParamJS.countryCode == 'CA'){
                    catentryIdDefaultSize[ind]= currProduct.mostSoldSize['NA'].uniqueID;
                }else if(WCParamJS.countryCode == 'JP'){
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['JP'].uniqueID;
                }else{
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['EMEA'].uniqueID;
                }
            } catch (e) {
                console.error('Error in finding default size for wishlist');
            }
        });

        if(showedProduct != undefined
                && showedProduct.attributes != undefined) {
            for(var i=0; showedProduct.attributes.length>i; i++) {
                if(showedProduct.attributes[i].identifier === 'MODELNAME' && showedProduct.attributes[i].usage === 'Descriptive' ) modelNameValue = showedProduct.attributes[i].values[0].value;
                if(showedProduct.attributes[i].identifier === 'POLARIZED' && showedProduct.attributes[i].usage === 'Descriptive' ){
                    for(var k=0; showedProduct.attributes[i].values.length > k; k++ ){
                        if(showedProduct.attributes[i].values[k].value == true || showedProduct.attributes[i].values[k].value.toLowerCase() === 'yes'){
                            polarized = showedProduct.attributes[i].name;
                        }
                    }
                }
                if(showedProduct.attributes[i].identifier === 'MOCO' && showedProduct.attributes[i].usage === 'Descriptive' ) {
                    productMoco = showedProduct.attributes[i].values[0].value;
                }

            }
            if (isWishlist){
                for(var i=0; showedProduct.attributes.length>i; i++) {
                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE" && showedProduct.attributes[i].usage === "Descriptive" ) {
                        if (typeof wishlistAddedSizeNumber == "undefined" || wishlistAddedSizeNumber == ""){
                            wishlistAddedSizeNumber = showedProduct.attributes[i].values[0].value;
                        }
                    }

                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE_DISPLAY" && showedProduct.attributes[i].usage === "Defining" ) {
                        if (typeof wishlistAddedSize == "undefined" || wishlistAddedSize == ""){
                            wishlistAddedSize = showedProduct.attributes[i].values[0].value;
                        }
                    }
                }
            }
        }

        

        var indexOtherColors = 0;
        var eachLensColor = "";
        var eachFrontColor = "";
        var isClipon = modelNameValue.toLowerCase().includes('clip');
        /*if (isClipon) {
            showedProduct.thumbnail = showedProduct.thumbnail.replace('/is/image/OliverPeoples','/extra/image/OliverPeoples/clipon').replace('_shad_fr','_shad_fr_clipon');
        }*/

        var inventoryStatus = false;
        var cbsCounter = 0;
        var csCounter = 0;
        var soCounter = 0;
        //prova
        var colorProp = "Color"
        var colorsProp = "Colors"
        //prova
        if (!(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile()|| searchedWord || isWishlist)){
            $(model).each(function (ind) {
                if (!(typeof model[ind]['inventory'] === 'undefined')){
                    if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'true'){
                        csCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '0'){
                        soCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'false'){
                        cbsCounter++;
                    }
                } else return false;

                if (csCounter == model.length || cbsCounter == model.length || soCounter == model.length) {
                    inventoryStatus = true;
                    return inventoryStatus;
                }
            });
         }//else{
        //     $(model).each(function (ind) {
        //         if (!(typeof model['inventory'] === 'undefined')){
        //             if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'true'){
        //                 csCounter++;
        //             } else if (model['inventory']['ranking'] == '0'){
        //                 soCounter++;
        //             } else if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'false'){
        //                 cbsCounter++;
        //             }
        //         } else return false;

        //         if (csCounter == 1 || cbsCounter == 1 || soCounter == 1) {
        //             inventoryStatus = true;
        //             return inventoryStatus;
        //         }
        //     });
        // }

        var mustacheObj = {
            modelName: modelNameValue != undefined ? modelNameValue : '',
            inventoryStatus: inventoryStatus,
            //indexPlp:productIndex+1,
            indexPlp:tileIndex+1,
            indexSearchPanel: indexSearchPanel+1,
            isSearchPanel: function () {
                if(searchedWord != undefined) {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchFeturedProduct: function () {
                if(searchedWord == "X_Search_FeaturedProducts") {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchPageResult: function(){
                if(searchedWord == undefined && getUrlParameter('searchTerm')){
                    return true;
                }else{
                    return false;
                }
            },
            isWishlistPage: function(){
                if (isWishlist){
                    return true;
                } else {
                    return false;
                }
            },
            catentryIdDefaultSize : function(){
                return catentryIdDefaultSize[indexOtherColors];
            },
            catentryIsPresentInWishlist: function(){
                if(typeof checkIsInWishlist === 'function'){
                    return checkIsInWishlist(catentryIdDefaultSize[indexOtherColors]);
                }
            },
            image: function () {
            	var stringOfThumbnail = null;
                var backgroundColor = "";
                if (isOliver){
                    backgroundColor = "";
                    // OP: using of OV_OpPlp
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1000');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                	}
                } else  {
                    // PO: scaling of 45% on desktop
                    backgroundColor = "&bgcolor=%23f7f7f7";
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1500');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','small');
                	}
                }
                return stringOfThumbnail + backgroundColor;
            },
            imageScaled: function () {
                var backgroundColor = "";
                if (isOliver){
                    // OP: scaling of 25% on mobile
                    var backgroundColor = "";
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                } else  {
                    // PO: scaling of 25% on mobile
                    var backgroundColor = "&bgcolor=%23f7f7f7";
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                }
            },
            thumbnail: function () {
                if (isOliver){
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                } else {
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
                }
            },
            uniqueID: showedProduct != undefined ? showedProduct.uniqueID : '',
            partNumber: (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[indexOtherColors]).partNumber,
            partNumberAlt: function () {
                if (!isWishlist){
                    return this.partNumber.replaceAll('_','-').replaceAll('/', '-');
                } else {
                    return productMoco.toUpperCase();
                }
            },
            colorProperty: !(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) && model.length > 1 ? colorsProp : colorProp,
            offerPrice: offerPrice ? WCCurrencyJS.format(offerPrice) : '',
            listPrice: listPrice ? WCCurrencyJS.format(listPrice) : '',
            percentage: percentage,
            baseURL: WCParamJS.homePageURL,
            group2BadgeValue: group2BadgeValue,
            otherColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? [ model ] : model,
            replaceImageUrl: function () {
            	var replaceImage = null;
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        backgroundColor = "";
                        // OP: using of OV_OpPlp
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('OV_OpPlp','OV_parameters&WID').replace('WID','wid=1000');
                            }else{
                            	replaceImage = this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID').replace('WID','wid=1000');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                            }else{
                            	replaceImage = replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                            }
                    	}
                    } else {
                        var backgroundColor = "&bgcolor=%23f7f7f7";
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }else{
                            	replaceImage = this.thumbnail2.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                            }else{
    	                        // PO: scaling of 45% on desktop
    	                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
    	                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
    	                        replaceImage = replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                            }
                    	}
                    }
                }else{
                	replaceImage = this.thumbnail;
                }
                return replaceImage ;
            },
            replaceImageUrlScaled: function () {
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        
                        backgroundColor = "";
                        // OP: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                        }
                        return replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') +  backgroundColor;
                    } else {
                        backgroundColor = "&bgcolor=%23f7f7f7";
                        // PO: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                        }
                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
                        return replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                    }
                }
                return this.thumbnail;
            },
            replaceImageUrl1Tile: function () {
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else
                        //return this.thumbnail;
                        return replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','big');
                }
                return this.thumbnail;
            },
            index: function() {
                indexOtherColors++;
            },
            // Show color names under image
            printColorsName: function(){
                $(this.attributes).each(function (){
                    if ((this.identifier) === "FRONT_COLOR"){
                        eachFrontColor = ((this).values[0].identifier);
                    }
                    if ((this.identifier) === "LENS_COLOR"){
                        eachLensColor = ((this).values[0].identifier);
                    }
                })
                if ($("#categoryName").val() === 'OV_Sun') {
                    return (eachFrontColor + '/' + eachLensColor);
                } else {
                    return (eachFrontColor);
                }
            },
            printListPrice: function() {
                var product = this;
                var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
                return listPrice != '' ? WCCurrencyJS.format(listPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            printOfferPrice: function() {
                var product = this;
                offerPrice = getPriceByCustomerSegment(product["price"]);
                return offerPrice != '' ? WCCurrencyJS.format(offerPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            showListPrice: function() {
            	var product = this;
            	var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
            	var offerPrice = getPriceByCustomerSegment(product["price"]);
            	if(offerPrice != '' && listPrice != ''){
	            	if(offerPrice < listPrice) {
	            		return 'showListPrice';
	            	}
            	}
            	return '';
            },
            printStatus: function() {
                return printStatus(this);
            },
            printWishlistSize: function() {
                return wishlistAddedSize;
            },
            printWishlistSizeNumber: function() {
                return wishlistAddedSizeNumber;
            },
            isWishlistSizeEmpty: function() {
                if (wishlistAddedSize == "" || typeof wishlistAddedSize == "undefined"){
                    return true;
                } else {
                    return false;
                }
            },
            printPolarBadge: function() {
                return getPolarized(this.attributes);
            },
            printTransitionBadge : function () {
                return getTransitionBadge(this.attributes);
            },
            printTopBadge: function() {
                /**
                 * Group 1 Badges Hierarchy
                 * PO Transition > Polar
                 * OP Polar
                 */
                var isPolar = getPolarized(this.attributes);
                var isTransition =  getTransitionBadge(this.attributes);
             
                if(isTransition && isPersol){
                    return isTransition;
                }
                else if(isPolar){
                    if(isOliver){
                        return "— "+isPolar+" —";
                    }else{
                        return isPolar;
                    }
                }
            },
            printBottomBadge : function(){
               return  printBadges(this.attributes);
            },
            isPreOrder : function() {
                return getPreOrderBadge(this.attributes) != undefined ;
            },
            isPrescription: function(){
                return isPrescription(this.attributes);
            },
            printSeparator: function(){
                if((printBadges(this.attributes) != "" || getPreOrderBadge(this.attributes) != undefined) && isPrescription(this.attributes,searchedWord) == true){
                    return true;
                }else{
                    return false;
                }
            },
            isFastLoadImg: function() {
                return this.indexPlp < 4
            },
            isLCPTile: isLCPTile
          }

        if(searchedWord) {
            indexSearchPanel++;
        }

        if (insideGrid && !searchedWord) {
            if(typeof tealiumProducts === 'undefined'){
                var tealiumProducts = {};
            }

            //	Tealium
            var tealiumProduct = {};
            var myPartNumber = (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0]).partNumber;
            if (isPersol){
                tealiumProduct['Sku'] = myPartNumber.replaceAll('RX_','');
            } else {
                tealiumProduct['Sku'] = myPartNumber;
            }
            tealiumProduct['ModelName'] = (modelNameValue != undefined ? modelNameValue : '').toUpperCase();
            tealiumProduct['Category'] = !isWishlist ? getSunOpticalCategoryName($("#categoryName").val()) : '';
            tealiumProduct['Price'] = offerPrice;
            tealiumProduct['PriceFull'] = listPrice;
            tealiumProduct['Brand'] = currentBrand;
            tealiumProducts[myPartNumber] = tealiumProduct;
            if(typeof pushWkndSkuInPLP == 'function' && window.wunderkind && window.wunderkind.category !== undefined)
                pushWkndSkuInPLP(tealiumProduct['Sku']);
        }

        var templateHtml = $('#plpTemplate2024').html();
        html = Mustache.to_html(templateHtml, mustacheObj);
        

    } catch (error) {
        console.error('Error in tile creation',error);
    }

    return html;
}



/**
* Opens the search bar when the search icon is clicked.
* Change the tabindex value to every focusable element into the search.
*/
function openSearchBar(element){
    //hideHeaderTimeout.cancel();
    var searchPanel = $('.header__search-wrapper');
    changeTabIndex($('.header__search-wrapper'));
    searchPanel.hasClass("opend") ? searchPanel.removeClass('opend') : searchPanel.addClass('opend');
    searchPanel.removeClass("hidden-panel");
    $('.search--fade').show();
    history.pushState({}, '') // added state in chronology To close the panel when the back button is clicked
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","hidden");
    }
    
    $("body").css("overflow","hidden");
    $("#page").css("overflow","hidden");
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        loadHeaderEspot("X_Search_FeaturedProducts"); // load Feature Products
    }

    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").addClass("searchPanelIsOpen");

    if(isOliver){
        tealium_data2track.push({
            'id':'Click', 
            'data_element_id': 'MainNav_Search_Open',
            'Click_FocusElement' : element
        });
    }
 
    
};

function closeSearchBar() {
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        if($(".searchPanel .search_panel_container").hasClass("active")){
            $(".searchPanel .search_panel_container").removeClass("active");
            $(".searchPanel .search_panel_container").focusout();
            window.history.go(-1);
            if(isPersol){
            	$('.header_wishlist').show(); 
                $("#logo").hide();
            }
        }

    }else{
        $('.header__search-wrapper').removeClass('opend');
        $('.search--fade').hide();
        window.history.go(-1);// delete the state added at opening
        if($plpSearchObj.itemsbkp != undefined){
            //search Optimization --retrieve info on the plp that was being navigated
            $plpSearchObj.items =  $plpSearchObj.itemsbkp;
            $plpSearchObj.busy = false;
            $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp;
            $plpSearchObj.viewIndex = $plpSearchObj.viewIndexbkp ;
        }
    }
    
   
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","auto");
    }
    $("body").css("overflow","auto");
    $("#page").css("overflow","auto");

    resetSearchTile(true,true,false);
    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").removeClass("searchPanelIsOpen");

    if(isOliver){
        setTimeout(function() {
            $('.header__search-wrapper').addClass("hidden-panel"); //HB-12925 Overlay fade effect when close panel
        }, 600);
    }
};


window.onpopstate = function() { //interface is fired when the active history entry changes while the user navigates the session history.
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        var searchPanel = $(".searchPanel .search_panel_container");
        if(searchPanel.hasClass("active")){
            closeSearchBar();
        }
    }else{
        var searchPanel = $('.header__search-wrapper');
        if(searchPanel.hasClass("opend")){
            closeSearchBar();
        }
    }     
  };






function getUrlParameter(paramName) {
    var results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    } else {
       return decodeURI(results[1]) || 0;
    }
}

/**
 * @function callbackSortBy
 * @desc callback function for default sort by
 */
function callbackSortBy(elem){
    if(elem) {
        checkFacetsAndSearch($(elem));
    }
    $('.facet__apply-number').text($plpSearchObj.resultCount);

}

function isNewArrivalsOrdering() {
	return selectedFacetsData["orderBy"] === '8';
}

function isPriceOrdering() {
	return selectedFacetsData["orderBy"] === '3' || selectedFacetsData["orderBy"] === '4';
}

function categoryToGroupTile() {
	if ($('input#notGroupTile').val() == 1)
		return false;

	return true;
}





function resetSearchTile(reloadFeaturedProducts,resetInputButton,resetSuggestion){
    if(reloadFeaturedProducts){
        if( !(window.tabletPortraitCheck() || window.mobilecheck()) && $(".searchPanel .featured-products").length == 0 ){
            $("#search_grid").html(featuredProductHtml);
        } 
        $(".title_result").show();
        $(".redirect_result_container").css("display","none");
    }else{
        $("#search_grid .search-grid-skeleton").show();
        $('#search_grid li').each(function() {
            $(".redirect_result_container .redirect_result_link").css("display","none");
            if(!$(this).hasClass("search-grid-skeleton")){
                 $(this).empty(); // elimina il contenuto 
                 $(this).append('<div class="grid-item">' +
                                    '<div class="product">' +
                                        '<div class="product--wrapper">' +
                                            '<div class="product--wrapper__container">' +
                                                '<div class="plp__other-product-carousel new-plp">' +
                                                    '<div class="square-container skeleton-element">' +
                                                        '<div class="square-content">' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="product__wrapper-info skeleton-element">' +
                                                        '<a class="lower-tile-container ">' +
                                                        '</a>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
                 $(this).addClass("search-grid-skeleton");
                 $(this).removeClass("featured-products");
                
                 
            }
         });
    }
    if(resetInputButton){
        $('input:text[name=searchInput]').val("");
        $(".searchPanel .delete-input-icon").hide();
    }
    if(resetSuggestion){
        $("#search_UsefulLinks").show();
        $("#search_popular").show();
        $(".searchPanel .suggestions_container").empty();
        $(".searchPanel .suggestions_container").hide();
        searchError(false);
    }

    removeLoader();
    
}

function updateSearchTermHistoryCookieAndRedirect(updatedSearchTerm, redirectURL){
	
	this.updateSearchTermHistoryCookie(updatedSearchTerm);
    if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {document.location.href = appendWcCommonRequestParameters(redirectURL);}
    
}

function fn_startSearch() {
    var searchTimeout;
    indexSearchPanel = 0;
    var dInput = $('input:text[name=searchInput]').val().toLowerCase();
    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
        if(dInput.length >= 2){
        	$plpSearchObj.search = true;
            resetSearchTile();
            const promise2 = Promise.resolve(printAutoSuggestions(dInput));
            const promise3 = new Promise((resolve, reject) => {
                setTimeout(resolve, 500, 'Success');
            });
            const promise1 = Promise.resolve(fn_plpFirstTiles(undefined,dInput,undefined,undefined,true));
            Promise.all([promise1,promise2, promise3]).then((values) => {
                if(values[1].suggestionView[0].entry.length > 0 && ($(".error_search_message").is(":visible") || $('.title_result').is(":visible") || $('#search_grid .square-container.skeleton-element').is(":visible")) ){
                    searchError(false);
                    resetSearchTile(false,false,false);
                    fn_plpFirstTiles(undefined,values[1].suggestionView[0].entry[0].name);
                }else if( (!$(".error_search_message").is(":visible") || !$('.title_result').is(":visible")) ){
                    searchError(false);
                }else{
                    searchError(true);
                    resetSearchTile(true,false,false); 
                }
            });
        }
    }else{
        if(dInput.length >= 2){
            printAutoSuggestions(dInput);
        } 
    }
    if(dInput.length > 0){
        if(dInput.length < 2){
            resetSearchTile(true,false,true);
        }
       // $(".searchPanel .delete-input-icon").show();
    }else if(dInput == 0){
        resetSearchTile(true,true,true);
    }
}

function tealiumPushSearchPageReady(dInput,resultItemsQnt) {
    console.log("TEALIUM::tealiumPushSearchPageReady function invoked");
    if(typeof tealium_data2track !== 'undefined' && !mobilecheck()) {
        var trackData = {};
        trackData['id'] = 'SearchPageReady';
        trackData['Search_Keyword'] = dInput.toLowerCase();
        trackData['Search_KeywordActual'] = '';
        trackData['Search_Type'] = 'text';
        trackData['Search_ResultItemsQnt'] = resultItemsQnt; 
        trackData['Search_FacetValues_String'] = "";
        trackData['Search_View'] = "SERB"
        tealium_data2track.push(trackData);
    }
}


function goToSearchPage(input){
    var searchType = ""
    if(input != undefined){
        var dInput = input  
        searchType = "suggested"
       
    }else {
        var dInput = $('input:text[name=searchInput]').val();
        searchType = "text"
        
    }
    var typeResult = checkTileEditorialProduct(numItems,numEditorials);
    if(dInput.length > 0){
        updateSearchTermHistoryCookie(dInput);
        var baseSearchPage = (isInToolkit ? '' : WCParamJS.homePageURL +"/")+'SearchDisplay?storeId='+WCParamJS.storeId+'&catalogId='+ WCParamJS.catalogId + '&langId='+ WCParamJS.langId + '&design=' + typeResult + '&searchTerm=' + dInput +'&Search_Type='+ searchType;   
        location.href = baseSearchPage;
    }
   
}

/**
function printAutoSuggestions(dInput){
    dInput = dInput.replaceAll("’","'");
    $(".searchPanel .suggestions_container").empty();//clean suggestion div 
    var searchHistory = getSearchTermsCookie();
    var limit = 10 - searchHistory.length; //total suggestions + history search = 10

    if(searchHistory.length > 0){ //check for research already done
        searchHistory.forEach(function (term) { 
            historySearchDiv = '<div><a class="search-history" onclick=" goToSearchPage(\''+ term.replace("-","").replace(" ","") +'\')" data-element-id="SearchPanel_Results_query">' + term.replace("%27","'")+ '</a></div>';
            $(".searchPanel .suggestions_container").append(historySearchDiv);//print the latest research
        }) 
    }
    queryAutoSuggestions = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        responseFormat: 'json',
        langId: WCParamJS.langId,
        categoryId: WCParamJS.categoryId,
        limit: limit
    };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: (isInToolkit ? '' : WCParamJS.homePageURL) +"/search/resources/store/" + WCParamJS.storeId  + "/sitecontent/productSuggestionsBySearchTerm/"+ dInput ,
            type: 'GET',
            async: true,
            data: queryAutoSuggestions,
            success: function(data){
                var suggestionDiv = "";
                if(data.suggestionView && data.suggestionView[0].entry.length > 0){
                    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#search_UsefulLinks").hide();
                        $("#search_popular").hide();
                        
                    }else{
                        tealiumPushSearchPageReady(dInput,limit);
                    }
                    searchError(false);
                    $(".searchPanel .suggestions_container").show();
                    var searchTerms = [];
                    for (var i = 0; i < data.suggestionView[0].entry.length; i++) {
                    	var isPresent = false;
                    	var temporaryTerm = data.suggestionView[0].entry[i].name;
                		for (var j = 0; j < searchTerms.length; j++) {
                		//check if the result name has been already shown
                    		if (temporaryTerm === searchTerms[j]){
                    			isPresent = true;
                    		}
                    	}
                    	if(!isPresent){
                    		var spanTerm = data.suggestionView[0].entry[i].name.replace(dInput.toLowerCase(),"<span class='serched-word'>" + dInput.toLowerCase() +"</span>" );
                            suggestionDiv = '<div><a class="suggestion" onclick="goToSearchPage(\'' + data.suggestionView[0].entry[i].name.replace("'","%27") + '\')">' + spanTerm.toLowerCase() + '</a></div>';
                            $(".searchPanel .suggestions_container").append(suggestionDiv);//print suggestions
                    	}
                    	searchTerms.push(data.suggestionView[0].entry[i].name);
                    }
                }
                else if (data.metaData){
                	dInput = data.metaData.spellcheck[0];
                	printAutoSuggestions(dInput);
                }
                else if(!(searchHistory.length > 0 && data.suggestionView && data.suggestionView[0].entry.length > 0)){
                    if((window.tabletPortraitCheck() || window.mobilecheck())){
                        searchError(true);
                        tealiumPushSearchPageReady(dInput,'0');
                    }
                    $(".suggestions_container").hide();
                    $("#search_UsefulLinks").show();
                    $("#search_popular").show();
                    
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);  
                reject(error);
            }
        });
    });

    

}
*/ 

var inputTimer = null;

function loadHeaderEspot(espotName) {

    // If espot div is not present, skip the loading
    if ($("#" + espotName).length == 0) return;
  
    // Get product, if present
    let products = {};
    let contents = [];
  
    // Compose service url
    var espotServiceUrl =
      WCParamJS.urlPrefixForHTTPS +
      "/wcs/resources/store/" +
      WCParamJS.storeId +
      "/espot/" +
      espotName +
      "?langId=" +
      WCParamJS.langId;
  
    return new Promise((resolve, reject) => {
  
      $.getJSON(espotServiceUrl, function (data) {
        products = {};
        contents = [];
        //con la risposta del servizio mi creo due array di oggetti di prodotti e contenuti
        data["MarketingSpotData"].forEach(function (msd, index) {
          if (msd["baseMarketingSpotActivityData"]) {
            var savedActivityPriority;
            msd["baseMarketingSpotActivityData"].every(function (bmspd, index) {
              if (
                typeof savedActivityPriority != "undefined" &&
                savedActivityPriority != bmspd["activityPriority"]
              ) {
                return false;
              }
              savedActivityPriority = bmspd["activityPriority"];
              if (bmspd["baseMarketingSpotDataType"] === "CatalogEntry") {
                // controllo che sia un prodotto
                var productsobj = {
                  product: bmspd["baseMarketingSpotActivityName"],
                  productId: bmspd["productId"]
                };
                //prendo le info sul modello
                var isProductPresent =
                  productsobj["product"].length > 0 &&
                  productsobj["productId"].length > 0;
                  if (isProductPresent) {
                    products[productsobj["productId"]] = productsobj;
                }
              } else if (
                bmspd["baseMarketingSpotDataType"] === "MarketingContent"
              ) {
                // controllo che sia un contenuto
                bmspd["marketingContentDescription"].forEach(function (mkd, index) {
                  if(typeof mkd["marketingText"] != 'undefined'){
                    contents.push(
                        mkd["marketingText"].replaceAll(
                          "[fullPathHomeURL]",
                          WCParamJS.homePageURL
                        )
                      ); //metto nell array di contenuto tutti i contenuti
                  }  
                });
              }
              return true;
            });
          }
        });
  
      }).done(function(data) {
  
        if (Object.keys(products).length > 0) {
  
          getProductsModelHeader(products,function() {
            if(espotName=="X_Search_FeaturedProducts"){
              renderTileProducts(products,0,0,0,espotName);
            }else{
                if( typeof espotCallback == 'function'){
                    espotCallback(products, contents, espotName);
                }
            }
            
          })
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error(error)
          });
  
        } else {
            if( typeof espotCallback == 'function'){
                espotCallback(products, contents, espotName)
            }
        }
  
        resolve(data);
    }).fail(function(error) {
      reject(error);
    });
  
    });
  
  }

  function getProductsModelHeader(products,callback) {

    var productIds = [];
    $.each(products,function(k,v) {
      productIds.push(k);
    });
  
    // Compose service url
    var productServiceUrl =
      (isInToolkit ? "" : WCParamJS.homePageURL) +
      "/search/resources/store/" +
      WCParamJS.storeId +
      "/productview/byIds?id=" +
      productIds.join("&id=") +
      "&storeId=" +
      WCParamJS.storeId +
      "&catalogId=" +
      WCParamJS.catalogId +
      "&responseFormat=json&langId=" +
      WCParamJS.langId +
      "&currency=" +
      WCParamJS.commandContextCurrency +
      "&profileName=LUX_findProductByIds_Details" +
      "&isForDDM=true"
      ;
  
    return new Promise((resolve, reject) => {
      $.getJSON(productServiceUrl, function (data) {
        var productModel = data["catalogEntryView"];
  
        // To align objects with those expected by Mustache
        productModel.forEach(function (m, index) {
          m["modelCode"] = m.partNumber.split('__')[0];
          products[m["uniqueID"]]["productModel"] = m;
        });
  
        if (typeof callback === 'function') {
          callback();
        }
  
      }).done(function(data) {
        resolve(data);
      }).fail(function(error) {
        reject(error);
      });
    });
    
  }
  /** 
  function updateSearchTermHistoryCookie(updatedSearchTerm){
    // Set the expiration date to one month from the current date
    var expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 1);
    var cookieKey = "searchTermHistory";
    var cookieValue = "|" + updatedSearchTerm;
    var searchTermHistoryCookie = getCookie(cookieKey);
    if( searchTermHistoryCookie != undefined && searchTermHistoryCookie != 'undefined') {
        var termsArray = searchTermHistoryCookie.split("|");
        if(!termsArray.includes(cookieValue.replace("|",""))){
            cookieValue = getCookie(cookieKey) + cookieValue;
        }
        
    }
    setCookie(cookieKey, cookieValue,{path:'/', domain:cookieDomain, expires: expirationDate});
}


function getSearchTermsCookie(){
    var searchHistoryCookie = getCookie("searchTermHistory");
    var theLastTerms=[];
    if( searchHistoryCookie != undefined && searchHistoryCookie != 'undefined') {
        var termsArray = searchHistoryCookie.split("|");
        var count = 0; 
        for(var i = termsArray.length - 3; i < termsArray.length; i++) {
            if(termsArray[i] != undefined && termsArray[i] != "" && termsArray[i] != 'undefined'){
                theLastTerms[count]= termsArray[i];
                count++;
            }
        }
    }
    return theLastTerms.reverse();
}
**/

function searchError(show){
    if(show){
        var searchedWord = $('input:text[name=searchInput]').val();
        $(".error_search_message #error_word").html(searchedWord);
        $(".error_search_message").show();
        $(".error-search-icon").show();
        $(".input-icon").hide();
    }else{
        $(".error_search_message").hide();
        $(".error-search-icon").hide();
        $(".input-icon").show();
    }
    
}



/**
 * @funtion getStatus 
 * @desc get Product Status (Available, SoldOut, Out-of-stock, etc.) based on inventory informations
 */
function getStatus(inventoryStatus) {
    //var flComingSoon = inventoryStatus.flComingSoon;
    var ranking = inventoryStatus.ranking;
    var status = "";

    switch(ranking) {
        case "0" : {
            status =  "SoldOut";
            break;
        }
        case "1" : {//Coming Soon & Coming Back Soon
            status = "Out-of-stock";  
            break;
        }
        case "2" : {
            status = "Available";
            break;
        } 
        default : {
            status= "/";
        }
    }
    return status;
}

//remove loader as soon as image is displayed
function removeLoader(){
    var articleImages = document.querySelectorAll(".image-container.main > picture >  img");
    var imageSkeleton = '';
    articleImages.forEach(function(img) {
        img.addEventListener('load', function() {
            imageSkeleton = $(img).closest(".image-container");
            $(imageSkeleton).removeClass("skeleton-element");
        });       
    });
}

function clearSearchPanelEditorial(){
	while ($('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length != 0){
		$('#search_hits .ais-Hits .ais-Hits-item.is-editorial')[$('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length-1].remove()
	}
}


